var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
/*!
 * jsoneditor.js
 *
 * @brief
 * JSONEditor is a web-based tool to view, edit, format, and validate JSON.
 * It has various modes such as a tree editor, a code editor, and a plain text
 * editor.
 *
 * Supported browsers: Chrome, Firefox, Safari, Opera, Internet Explorer 8+
 *
 * @license
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy
 * of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 *
 * Copyright (c) 2011-2023 Jos de Jong, http://jsoneditoronline.org
 *
 * @author  Jos de Jong, <wjosdejong@gmail.com>
 * @version 9.10.2
 * @date    2023-05-15
 */
!function (e, t) {
  exports = t();
}(self, function () {
  return n = {
    897: function (e, t, n) {
      "use strict";

      n.d(t, {
        x: function () {
          return r;
        }
      });
      var c = n(2602),
        h = n(9791),
        d = n(7907);
      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function i(e, t) {
        for (var n = 0; n < t.length; n++) {
          i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== o(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== o(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === o(e) ? e : String(e);
          }(i.key), i);
        }
      }
      var r = function () {
        function l(t, e) {
          if (!((this || _global) instanceof l)) throw new TypeError("Cannot call a class as a function");
          (this || _global).dom = {};
          var h = this || _global,
            n = (this || _global).dom,
            e = ((this || _global).anchor = void 0, (this || _global).items = t, (this || _global).eventListeners = {}, (this || _global).selection = void 0, (this || _global).onClose = e ? e.close : void 0, (this || _global).limitHeight = !!e && e.limitHeight, document.createElement("div")),
            i = (e.className = "jsoneditor-contextmenu-root", n.root = e, document.createElement("div")),
            e = (i.className = "jsoneditor-contextmenu", n.menu = i, e.appendChild(i), document.createElement("ul")),
            i = (e.className = "jsoneditor-menu", i.appendChild(e), n.list = e, n.items = [], document.createElement("button")),
            n = (i.type = "button", n.focusButton = i, document.createElement("li"));
          n.style.overflow = "hidden", n.style.height = "0", n.appendChild(i), e.appendChild(n), function a(l, c, e) {
            e.forEach(function (t) {
              var n, e, i, o, r, s;
              "separator" === t.type ? ((r = document.createElement("div")).className = "jsoneditor-separator", (e = document.createElement("li")).appendChild(r), l.appendChild(e)) : (n = {}, r = document.createElement("li"), l.appendChild(r), (e = document.createElement("button")).type = "button", e.className = t.className, n.button = e, t.title && (e.title = t.title), t.click && (e.onclick = function (e) {
                e.preventDefault(), h.hide(), t.click();
              }), r.appendChild(e), t.submenu ? ((o = document.createElement("div")).className = "jsoneditor-icon", e.appendChild(o), (o = document.createElement("div")).className = "jsoneditor-text" + (t.click ? "" : " jsoneditor-right-margin"), o.appendChild(document.createTextNode(t.text)), e.appendChild(o), (i = t.click ? (e.className += " jsoneditor-default", (o = document.createElement("button")).type = "button", (n.buttonExpand = o).className = "jsoneditor-expand", (s = document.createElement("div")).className = "jsoneditor-expand", o.appendChild(s), r.appendChild(o), t.submenuTitle && (o.title = t.submenuTitle), o) : ((s = document.createElement("div")).className = "jsoneditor-expand", e.appendChild(s), e)).onclick = function (e) {
                e.preventDefault(), h._onExpandItem(n), i.focus();
              }, n.subItems = o = [], s = document.createElement("ul"), (n.ul = s).className = "jsoneditor-menu", s.style.height = "0", r.appendChild(s), a(s, o, t.submenu)) : ((r = document.createElement("div")).className = "jsoneditor-icon", e.appendChild(r), (s = document.createElement("div")).className = "jsoneditor-text", s.appendChild(document.createTextNode((0, d.Iu)(t.text))), e.appendChild(s)), c.push(n));
            });
          }(e, (this || _global).dom.items, t), (this || _global).maxHeight = 0, t.forEach(function (e) {
            e = 24 * (t.length + (e.submenu ? e.submenu.length : 0));
            h.maxHeight = Math.max(h.maxHeight, e);
          });
        }
        var e, t, n;
        return e = l, (t = [{
          key: "_getVisibleButtons",
          value: function () {
            var t = [],
              n = this || _global;
            return (this || _global).dom.items.forEach(function (e) {
              t.push(e.button), e.buttonExpand && t.push(e.buttonExpand), e.subItems && e === n.expandedItem && e.subItems.forEach(function (e) {
                t.push(e.button), e.buttonExpand && t.push(e.buttonExpand);
              });
            }), t;
          }
        }, {
          key: "show",
          value: function (e, t, n) {
            this.hide();
            var i = !0,
              o = e.parentNode,
              r = e.getBoundingClientRect(),
              o = o.getBoundingClientRect(),
              s = t.getBoundingClientRect(),
              a = this || _global,
              t = ((this || _global).dom.absoluteAnchor = (0, c.w)(e, t, function () {
                a.hide();
              }), r.bottom + (this || _global).maxHeight < s.bottom || r.top - (this || _global).maxHeight > s.top && (i = !1), n ? 0 : r.top - o.top);
            i ? (n = e.offsetHeight, (this || _global).dom.menu.style.left = "0", (this || _global).dom.menu.style.top = t + n + "px", (this || _global).dom.menu.style.bottom = "") : ((this || _global).dom.menu.style.left = "0", (this || _global).dom.menu.style.top = "", (this || _global).dom.menu.style.bottom = "0px"), (this || _global).limitHeight && (o = i ? s.bottom - r.bottom - 10 : r.top - s.top - 10, (this || _global).dom.list.style.maxHeight = o + "px", (this || _global).dom.list.style.overflowY = "auto"), (this || _global).dom.absoluteAnchor.appendChild((this || _global).dom.root), (this || _global).selection = (0, h.getSelection)(), (this || _global).anchor = e, setTimeout(function () {
              a.dom.focusButton.focus();
            }, 0), l.visibleMenu && l.visibleMenu.hide(), l.visibleMenu = this || _global;
          }
        }, {
          key: "hide",
          value: function () {
            (this || _global).dom.absoluteAnchor && ((this || _global).dom.absoluteAnchor.destroy(), delete (this || _global).dom.absoluteAnchor), (this || _global).dom.root.parentNode && ((this || _global).dom.root.parentNode.removeChild((this || _global).dom.root), (this || _global).onClose) && this.onClose(), l.visibleMenu === (this || _global) && (l.visibleMenu = void 0);
          }
        }, {
          key: "_onExpandItem",
          value: function (n) {
            var i,
              o = this || _global,
              e = n === (this || _global).expandedItem,
              t = (this || _global).expandedItem;
            t && (t.ul.style.height = "0", t.ul.style.padding = "", setTimeout(function () {
              o.expandedItem !== t && (t.ul.style.display = "", h.removeClassName)(t.ul.parentNode, "jsoneditor-selected");
            }, 300), (this || _global).expandedItem = void 0), e || ((i = n.ul).style.display = "block", i.clientHeight, setTimeout(function () {
              if (o.expandedItem === n) {
                for (var e = 0, t = 0; t < i.childNodes.length; t++) e += i.childNodes[t].clientHeight;
                i.style.height = e + "px", i.style.padding = "5px 10px";
              }
            }, 0), (0, h.addClassName)(i.parentNode, "jsoneditor-selected"), (this || _global).expandedItem = n);
          }
        }, {
          key: "_onKeyDown",
          value: function (e) {
            var t,
              n,
              i,
              o,
              r = e.target,
              s = e.which,
              a = !1;
            27 === s ? ((this || _global).selection && (0, h.setSelection)((this || _global).selection), (this || _global).anchor && (this || _global).anchor.focus(), this.hide(), a = !0) : 9 === s ? e.shiftKey ? 0 === (n = (t = this._getVisibleButtons()).indexOf(r)) && (t[t.length - 1].focus(), a = !0) : (n = (t = this._getVisibleButtons()).indexOf(r)) === t.length - 1 && (t[0].focus(), a = !0) : 37 === s ? ("jsoneditor-expand" === r.className && (n = (t = this._getVisibleButtons()).indexOf(r), i = t[n - 1]) && i.focus(), a = !0) : 38 === s ? (n = (t = this._getVisibleButtons()).indexOf(r), (i = (i = (i = t[n - 1]) && "jsoneditor-expand" === i.className ? t[n - 2] : i) || t[t.length - 1]) && i.focus(), a = !0) : 39 === s ? (n = (t = this._getVisibleButtons()).indexOf(r), (o = t[n + 1]) && "jsoneditor-expand" === o.className && o.focus(), a = !0) : 40 === s && (n = (t = this._getVisibleButtons()).indexOf(r), (o = (o = (o = t[n + 1]) && "jsoneditor-expand" === o.className ? t[n + 2] : o) || t[0]) && (o.focus(), a = !0), a = !0), a && (e.stopPropagation(), e.preventDefault());
          }
        }]) && i(e.prototype, t), n && i(e, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), l;
      }();
      r.visibleMenu = void 0;
    },
    6436: function (e, t, n) {
      "use strict";

      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function r(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== o(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== o(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === o(e) ? e : String(e);
          }(i.key), i);
        }
      }
      n.d(t, {
        Q: function () {
          return i;
        }
      });
      var i = function () {
        function n(e) {
          if (!((this || _global) instanceof n)) throw new TypeError("Cannot call a class as a function");
          (this || _global).errorTableVisible = e.errorTableVisible, (this || _global).onToggleVisibility = e.onToggleVisibility, (this || _global).onFocusLine = e.onFocusLine || function () {}, (this || _global).onChangeHeight = e.onChangeHeight, (this || _global).dom = {};
          var e = document.createElement("div"),
            t = (e.className = "jsoneditor-validation-errors-container", (this || _global).dom.validationErrorsContainer = e, document.createElement("div")),
            e = (t.style.display = "none", t.className = "jsoneditor-additional-errors fadein", t.textContent = "Scroll for more \u25BF", (this || _global).dom.additionalErrorsIndication = t, e.appendChild(t), document.createElement("span")),
            t = (e.className = "jsoneditor-validation-error-icon", e.style.display = "none", (this || _global).dom.validationErrorIcon = e, document.createElement("span"));
          t.className = "jsoneditor-validation-error-count", t.style.display = "none", (this || _global).dom.validationErrorCount = t, (this || _global).dom.parseErrorIndication = document.createElement("span"), (this || _global).dom.parseErrorIndication.className = "jsoneditor-parse-error-icon", (this || _global).dom.parseErrorIndication.style.display = "none";
        }
        var e, t, i;
        return e = n, (t = [{
          key: "getErrorTable",
          value: function () {
            return (this || _global).dom.validationErrorsContainer;
          }
        }, {
          key: "getErrorCounter",
          value: function () {
            return (this || _global).dom.validationErrorCount;
          }
        }, {
          key: "getWarningIcon",
          value: function () {
            return (this || _global).dom.validationErrorIcon;
          }
        }, {
          key: "getErrorIcon",
          value: function () {
            return (this || _global).dom.parseErrorIndication;
          }
        }, {
          key: "toggleTableVisibility",
          value: function () {
            (this || _global).errorTableVisible = !(this || _global).errorTableVisible, this.onToggleVisibility((this || _global).errorTableVisible);
          }
        }, {
          key: "setErrors",
          value: function (e, r) {
            var s,
              t,
              a = this || _global,
              n = ((this || _global).dom.validationErrors && ((this || _global).dom.validationErrors.parentNode.removeChild((this || _global).dom.validationErrors), (this || _global).dom.validationErrors = null, (this || _global).dom.additionalErrorsIndication.style.display = "none"), (this || _global).errorTableVisible && 0 < e.length ? ((n = document.createElement("div")).className = "jsoneditor-validation-errors", (t = document.createElement("table")).className = "jsoneditor-text-errors", n.appendChild(t), s = document.createElement("tbody"), t.appendChild(s), e.forEach(function (t) {
                isNaN(t.line) ? t.dataPath && (n = r.find(function (e) {
                  return e.path === t.dataPath;
                })) && (e = n.line + 1) : e = t.line;
                var e,
                  n = document.createElement("tr"),
                  i = (n.className = isNaN(e) ? "" : "jump-to-line", "error" === t.type ? n.className += " parse-error" : n.className += " validation-error", document.createElement("td")),
                  o = document.createElement("button"),
                  o = (o.className = "jsoneditor-schema-error", i.appendChild(o), n.appendChild(i), document.createElement("td"));
                o.style = "white-space: nowrap;", o.textContent = isNaN(e) ? "" : "Ln " + e, n.appendChild(o), "string" == typeof t ? ((i = document.createElement("td")).colSpan = 2, (o = document.createElement("pre")).appendChild(document.createTextNode(t)), i.appendChild(o), n.appendChild(i)) : ((o = document.createElement("td")).appendChild(document.createTextNode(t.dataPath || "")), n.appendChild(o), i = document.createElement("td"), (o = document.createElement("pre")).appendChild(document.createTextNode(t.message.replace(/<br>/gi, "\n"))), i.appendChild(o), n.appendChild(i)), n.onclick = function () {
                  a.onFocusLine(e);
                }, s.appendChild(n);
              }), (this || _global).dom.validationErrors = n, (this || _global).dom.validationErrorsContainer.appendChild(n), (this || _global).dom.additionalErrorsIndication.title = e.length + " errors total", (this || _global).dom.validationErrorsContainer.clientHeight < (this || _global).dom.validationErrorsContainer.scrollHeight ? ((this || _global).dom.additionalErrorsIndication.style.display = "block", (this || _global).dom.validationErrorsContainer.onscroll = function () {
                a.dom.additionalErrorsIndication.style.display = 0 < a.dom.validationErrorsContainer.clientHeight && 0 === a.dom.validationErrorsContainer.scrollTop ? "block" : "none";
              }) : (this || _global).dom.validationErrorsContainer.onscroll = void 0, t = (this || _global).dom.validationErrorsContainer.clientHeight + ((this || _global).dom.statusBar ? (this || _global).dom.statusBar.clientHeight : 0), this.onChangeHeight(t)) : this.onChangeHeight(0), e.filter(function (e) {
                return "error" !== e.type;
              }).length);
            0 < n ? ((this || _global).dom.validationErrorCount.style.display = "inline", (this || _global).dom.validationErrorCount.innerText = n, (this || _global).dom.validationErrorCount.onclick = (this || _global).toggleTableVisibility.bind(this || _global), (this || _global).dom.validationErrorIcon.style.display = "inline", (this || _global).dom.validationErrorIcon.title = n + " schema validation error(s) found", (this || _global).dom.validationErrorIcon.onclick = (this || _global).toggleTableVisibility.bind(this || _global)) : ((this || _global).dom.validationErrorCount.style.display = "none", (this || _global).dom.validationErrorIcon.style.display = "none"), e.some(function (e) {
              return "error" === e.type;
            }) ? (t = e[0].line, (this || _global).dom.parseErrorIndication.style.display = "block", (this || _global).dom.parseErrorIndication.title = isNaN(t) ? "parse error - check that the json is valid" : "parse error on line " + t, (this || _global).dom.parseErrorIndication.onclick = (this || _global).toggleTableVisibility.bind(this || _global)) : (this || _global).dom.parseErrorIndication.style.display = "none";
          }
        }]) && r(e.prototype, t), i && r(e, i), Object.defineProperty(e, "prototype", {
          writable: !1
        }), n;
      }();
    },
    2474: function (e, t, n) {
      "use strict";

      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function r(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== o(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== o(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === o(e) ? e : String(e);
          }(i.key), i);
        }
      }
      n.d(t, {
        R: function () {
          return i;
        }
      });
      var i = function () {
        function t(e) {
          if (!((this || _global) instanceof t)) throw new TypeError("Cannot call a class as a function");
          if ((this || _global).target = e.target || null, !(this || _global).target) throw new Error("FocusTracker constructor called without a \"target\" to track.");
          (this || _global).onFocus = "function" == typeof e.onFocus ? e.onFocus : null, (this || _global).onBlur = "function" == typeof e.onBlur ? e.onBlur : null, (this || _global)._onClick = (this || _global)._onEvent.bind(this || _global), (this || _global)._onKeyUp = function (e) {
            9 !== e.which && 9 !== e.keyCode || this._onEvent(e);
          }.bind(this || _global), (this || _global)._onBlur = (this || _global)._onEvent.bind(this || _global), (this || _global).focusFlag = !1, (this || _global).firstEventFlag = !0, ((this || _global).onFocus || (this || _global).onBlur) && (document.addEventListener("click", (this || _global)._onClick), document.addEventListener("keyup", (this || _global)._onKeyUp), document.addEventListener("blur", (this || _global)._onBlur));
        }
        var e, n, i;
        return e = t, (n = [{
          key: "destroy",
          value: function () {
            document.removeEventListener("click", (this || _global)._onClick), document.removeEventListener("keyup", (this || _global)._onKeyUp), document.removeEventListener("blur", (this || _global)._onBlur), this._onEvent({
              target: document.body
            });
          }
        }, {
          key: "_onEvent",
          value: function (e) {
            e = e.target, e = e === (this || _global).target || !(!(this || _global).target.contains(e) && !(this || _global).target.contains(document.activeElement));
            e ? (this || _global).focusFlag || ((this || _global).onFocus && this.onFocus({
              type: "focus",
              target: (this || _global).target
            }), (this || _global).focusFlag = !0) : ((this || _global).focusFlag || (this || _global).firstEventFlag) && ((this || _global).onBlur && this.onBlur({
              type: "blur",
              target: (this || _global).target
            }), (this || _global).focusFlag = !1, (this || _global).firstEventFlag) && ((this || _global).firstEventFlag = !1);
          }
        }]) && r(e.prototype, n), i && r(e, i), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();
    },
    3161: function (e, t, o) {
      "use strict";

      var n = o(8170),
        i = o(8037),
        r = o(8038).treeModeMixins,
        s = o(8458).textModeMixins,
        a = o(341).previewModeMixins,
        l = o(9791),
        c = l.clear,
        h = l.extend,
        d = l.getInnerText,
        u = l.getInternetExplorerVersion,
        g = l.parse,
        l = o(2744).tryRequireAjv,
        p = o(2558).showTransformModal,
        m = o(6210).showSortModal,
        f = l();
      function C(e, t, n) {
        if (!((this || _global) instanceof C)) throw new Error("JSONEditor constructor called without \"new\".");
        var i = u();
        if (-1 !== i && i < 9) throw new Error("Unsupported browser, IE9 or newer required. Please install the newest version of your browser.");
        t && (t.error && (console.warn("Option \"error\" has been renamed to \"onError\""), t.onError = t.error, delete t.error), t.change && (console.warn("Option \"change\" has been renamed to \"onChange\""), t.onChange = t.change, delete t.change), t.editable && (console.warn("Option \"editable\" has been renamed to \"onEditable\""), t.onEditable = t.editable, delete t.editable), t.onChangeJSON && ("text" === t.mode || "code" === t.mode || t.modes && (-1 !== t.modes.indexOf("text") || -1 !== t.modes.indexOf("code"))) && console.warn("Option \"onChangeJSON\" is not applicable to modes \"text\" and \"code\". Use \"onChangeText\" or \"onChange\" instead."), t) && Object.keys(t).forEach(function (e) {
          -1 === C.VALID_OPTIONS.indexOf(e) && console.warn("Unknown option \"" + e + "\". This option will be ignored");
        }), arguments.length && this._create(e, t, n);
      }
      "undefined" == typeof Promise && console.error("Promise undefined. Please load a Promise polyfill in the browser in order to use JSONEditor"), C.modes = {}, C.prototype.DEBOUNCE_INTERVAL = 150, C.VALID_OPTIONS = ["ajv", "schema", "schemaRefs", "templates", "ace", "theme", "autocomplete", "onChange", "onChangeJSON", "onChangeText", "onExpand", "onEditable", "onError", "onEvent", "onModeChange", "onNodeName", "onValidate", "onCreateMenu", "onSelectionChange", "onTextSelectionChange", "onClassName", "onFocus", "onBlur", "colorPicker", "onColorPicker", "timestampTag", "timestampFormat", "escapeUnicode", "history", "search", "mode", "modes", "name", "indentation", "sortObjectKeys", "navigationBar", "statusBar", "mainMenuBar", "languages", "language", "enableSort", "enableTransform", "limitDragging", "maxVisibleChilds", "onValidationError", "modalAnchor", "popupAnchor", "createQuery", "executeQuery", "queryDescription", "allowSchemaSuggestions", "showErrorTable"], C.prototype._create = function (e, t, n) {
        (this || _global).container = e, (this || _global).options = t || {}, (this || _global).json = n || {};
        e = (this || _global).options.mode || (this || _global).options.modes && (this || _global).options.modes[0] || "tree";
        this.setMode(e);
      }, C.prototype.destroy = function () {}, C.prototype.set = function (e) {
        (this || _global).json = e;
      }, C.prototype.get = function () {
        return (this || _global).json;
      }, C.prototype.setText = function (e) {
        (this || _global).json = g(e);
      }, C.prototype.getText = function () {
        return JSON.stringify((this || _global).json);
      }, C.prototype.setName = function (e) {
        (this || _global).options || ((this || _global).options = {}), (this || _global).options.name = e;
      }, C.prototype.getName = function () {
        return (this || _global).options && (this || _global).options.name;
      }, C.prototype.setMode = function (e) {
        if (e !== (this || _global).options.mode || !(this || _global).create) {
          var t = (this || _global).container,
            n = h({}, (this || _global).options),
            i = n.mode,
            o = (n.mode = e, C.modes[e]);
          if (!o) throw new Error("Unknown mode \"" + n.mode + "\"");
          var r = "text" === o.data,
            s = this.getName(),
            a = this[r ? "getText" : "get"]();
          if (this.destroy(), c(this || _global), h(this || _global, o.mixin), this.create(t, n), this.setName(s), this[r ? "setText" : "set"](a), "function" == typeof o.load) try {
            o.load.call(this || _global);
          } catch (e) {
            console.error(e);
          }
          if ("function" == typeof n.onModeChange && e !== i) try {
            n.onModeChange(e, i);
          } catch (e) {
            console.error(e);
          }
        }
      }, C.prototype.getMode = function () {
        return (this || _global).options.mode;
      }, C.prototype._onError = function (e) {
        (this || _global).options && "function" == typeof (this || _global).options.onError ? (this || _global).options.onError(e) : window.alert(e.toString());
      }, C.prototype.setSchema = function (e, t) {
        if (e) {
          var n;
          try {
            (this || _global).options.ajv ? n = (this || _global).options.ajv : ((n = f({
              allErrors: !0,
              verbose: !0,
              schemaId: "auto",
              $data: !0
            })).addMetaSchema(o(7171)), n.addMetaSchema(o(6273)));
          } catch (e) {
            console.warn("Failed to create an instance of Ajv, JSON Schema validation is not available. Please use a JSONEditor bundle including Ajv, or pass an instance of Ajv as via the configuration option `ajv`.");
          }
          if (n) {
            if (t) {
              for (var i in t) n.removeSchema(i), t[i] && n.addSchema(t[i], i);
              (this || _global).options.schemaRefs = t;
            }
            (this || _global).validateSchema = n.compile(e), (this || _global).options.schema = e, (this || _global).options.schemaRefs = t, this.validate();
          }
        } else (this || _global).validateSchema = null, (this || _global).options.schema = null, (this || _global).options.schemaRefs = null, this.validate();
        this.refresh(), "function" == typeof (this || _global)._onSchemaChange && this._onSchemaChange(e, t);
      }, C.prototype.validate = function () {}, C.prototype.refresh = function () {}, (C.registerMode = function (e) {
        var t;
        if (Array.isArray(e)) for (o = 0; o < e.length; o++) C.registerMode(e[o]);else {
          if (!("mode" in e)) throw new Error("Property \"mode\" missing");
          if (!("mixin" in e)) throw new Error("Property \"mixin\" missing");
          if (!("data" in e)) throw new Error("Property \"data\" missing");
          var n = e.mode;
          if (n in C.modes) throw new Error("Mode \"" + n + "\" already registered");
          if ("function" != typeof e.mixin.create) throw new Error("Required function \"create\" missing on mixin");
          for (var i = ["setMode", "registerMode", "modes"], o = 0; o < i.length; o++) if ((t = i[o]) in e.mixin) throw new Error("Reserved property \"" + t + "\" not allowed in mixin");
          C.modes[n] = e;
        }
      })(r), C.registerMode(s), C.registerMode(a), C.ace = n, C.Ajv = f, C.VanillaPicker = i, C.showTransformModal = p, C.showSortModal = m, C.getInnerText = d, e.exports = C.default = C;
    },
    6617: function (e, t, n) {
      "use strict";

      n.d(t, {
        x: function () {
          return r;
        }
      });
      var u = n(897),
        g = n(7907);
      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function i(e, t) {
        for (var n = 0; n < t.length; n++) {
          i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== o(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== o(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === o(e) ? e : String(e);
          }(i.key), i);
        }
      }
      var r = function () {
        function d(e, t, n, i) {
          if (!((this || _global) instanceof d)) throw new TypeError("Cannot call a class as a function");
          for (var o = {
              code: {
                text: (0, g.Iu)("modeCodeText"),
                title: (0, g.Iu)("modeCodeTitle"),
                click: function () {
                  i("code");
                }
              },
              form: {
                text: (0, g.Iu)("modeFormText"),
                title: (0, g.Iu)("modeFormTitle"),
                click: function () {
                  i("form");
                }
              },
              text: {
                text: (0, g.Iu)("modeTextText"),
                title: (0, g.Iu)("modeTextTitle"),
                click: function () {
                  i("text");
                }
              },
              tree: {
                text: (0, g.Iu)("modeTreeText"),
                title: (0, g.Iu)("modeTreeTitle"),
                click: function () {
                  i("tree");
                }
              },
              view: {
                text: (0, g.Iu)("modeViewText"),
                title: (0, g.Iu)("modeViewTitle"),
                click: function () {
                  i("view");
                }
              },
              preview: {
                text: (0, g.Iu)("modePreviewText"),
                title: (0, g.Iu)("modePreviewTitle"),
                click: function () {
                  i("preview");
                }
              }
            }, r = [], s = 0; s < t.length; s++) {
            var a = t[s],
              l = o[a];
            if (!l) throw new Error("Unknown mode \"" + a + "\"");
            l.className = "jsoneditor-type-modes" + (n === a ? " jsoneditor-selected" : ""), r.push(l);
          }
          var c = o[n];
          if (!c) throw new Error("Unknown mode \"" + n + "\"");
          var c = c.text,
            h = document.createElement("button"),
            c = (h.type = "button", h.className = "jsoneditor-modes jsoneditor-separator", h.textContent = c + " \u25BE", h.title = (0, g.Iu)("modeEditorTitle"), h.onclick = function () {
              new u.x(r).show(h, e);
            }, document.createElement("div"));
          c.className = "jsoneditor-modes", c.style.position = "relative", c.appendChild(h), e.appendChild(c), (this || _global).dom = {
            container: e,
            box: h,
            frame: c
          };
        }
        var e, t, n;
        return e = d, (t = [{
          key: "focus",
          value: function () {
            (this || _global).dom.box.focus();
          }
        }, {
          key: "destroy",
          value: function () {
            (this || _global).dom && (this || _global).dom.frame && (this || _global).dom.frame.parentNode && (this || _global).dom.frame.parentNode.removeChild((this || _global).dom.frame), (this || _global).dom = null;
          }
        }]) && i(e.prototype, t), n && i(e, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), d;
      }();
    },
    8170: function (e, t, n) {
      var i;
      if (window.ace) i = window.ace;else try {
        i = n(6225), n(4091), n(3330), n(4317);
        var o = n(7923);
        i.config.setModuleUrl("ace/mode/json_worker", o);
      } catch (e) {}
      e.exports = i;
    },
    4864: function () {
      window.ace.define("ace/theme/jsoneditor", ["require", "exports", "module", "ace/lib/dom"], function (e, t, n) {
        t.isDark = !1, t.cssClass = "ace-jsoneditor", t.cssText = ".ace-jsoneditor .ace_gutter {\nbackground: #ebebeb;\ncolor: #333\n}\n\n.ace-jsoneditor.ace_editor {\nline-height: 1.3;\nbackground-color: #fff;\n}\n.ace-jsoneditor .ace_print-margin {\nwidth: 1px;\nbackground: #e8e8e8\n}\n.ace-jsoneditor .ace_scroller {\nbackground-color: #FFFFFF\n}\n.ace-jsoneditor .ace_text-layer {\ncolor: gray\n}\n.ace-jsoneditor .ace_variable {\ncolor: #1a1a1a\n}\n.ace-jsoneditor .ace_cursor {\nborder-left: 2px solid #000000\n}\n.ace-jsoneditor .ace_overwrite-cursors .ace_cursor {\nborder-left: 0px;\nborder-bottom: 1px solid #000000\n}\n.ace-jsoneditor .ace_marker-layer .ace_selection {\nbackground: lightgray\n}\n.ace-jsoneditor.ace_multiselect .ace_selection.ace_start {\nbox-shadow: 0 0 3px 0px #FFFFFF;\nborder-radius: 2px\n}\n.ace-jsoneditor .ace_marker-layer .ace_step {\nbackground: rgb(255, 255, 0)\n}\n.ace-jsoneditor .ace_marker-layer .ace_bracket {\nmargin: -1px 0 0 -1px;\nborder: 1px solid #BFBFBF\n}\n.ace-jsoneditor .ace_marker-layer .ace_active-line {\nbackground: #FFFBD1\n}\n.ace-jsoneditor .ace_gutter-active-line {\nbackground-color : #dcdcdc\n}\n.ace-jsoneditor .ace_marker-layer .ace_selected-word {\nborder: 1px solid lightgray\n}\n.ace-jsoneditor .ace_invisible {\ncolor: #BFBFBF\n}\n.ace-jsoneditor .ace_keyword,\n.ace-jsoneditor .ace_meta,\n.ace-jsoneditor .ace_support.ace_constant.ace_property-value {\ncolor: #AF956F\n}\n.ace-jsoneditor .ace_keyword.ace_operator {\ncolor: #484848\n}\n.ace-jsoneditor .ace_keyword.ace_other.ace_unit {\ncolor: #96DC5F\n}\n.ace-jsoneditor .ace_constant.ace_language {\ncolor: darkorange\n}\n.ace-jsoneditor .ace_constant.ace_numeric {\ncolor: red\n}\n.ace-jsoneditor .ace_constant.ace_character.ace_entity {\ncolor: #BF78CC\n}\n.ace-jsoneditor .ace_invalid {\ncolor: #FFFFFF;\nbackground-color: #FF002A;\n}\n.ace-jsoneditor .ace_fold {\nbackground-color: #AF956F;\nborder-color: #000000\n}\n.ace-jsoneditor .ace_storage,\n.ace-jsoneditor .ace_support.ace_class,\n.ace-jsoneditor .ace_support.ace_function,\n.ace-jsoneditor .ace_support.ace_other,\n.ace-jsoneditor .ace_support.ace_type {\ncolor: #C52727\n}\n.ace-jsoneditor .ace_string {\ncolor: green\n}\n.ace-jsoneditor .ace_comment {\ncolor: #BCC8BA\n}\n.ace-jsoneditor .ace_entity.ace_name.ace_tag,\n.ace-jsoneditor .ace_entity.ace_other.ace_attribute-name {\ncolor: #606060\n}\n.ace-jsoneditor .ace_markup.ace_underline {\ntext-decoration: underline\n}\n.ace-jsoneditor .ace_indent-guide {\nbackground: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y\n}", e("../lib/dom").importCssString(t.cssText, t.cssClass);
      });
    },
    6589: function (e, t) {
      (n = {
        trace: function () {},
        yy: {},
        symbols_: {
          error: 2,
          JSONString: 3,
          STRING: 4,
          JSONNumber: 5,
          NUMBER: 6,
          JSONNullLiteral: 7,
          NULL: 8,
          JSONBooleanLiteral: 9,
          TRUE: 10,
          FALSE: 11,
          JSONText: 12,
          JSONValue: 13,
          EOF: 14,
          JSONObject: 15,
          JSONArray: 16,
          "{": 17,
          "}": 18,
          JSONMemberList: 19,
          JSONMember: 20,
          ":": 21,
          ",": 22,
          "[": 23,
          "]": 24,
          JSONElementList: 25,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          4: "STRING",
          6: "NUMBER",
          8: "NULL",
          10: "TRUE",
          11: "FALSE",
          14: "EOF",
          17: "{",
          18: "}",
          21: ":",
          22: ",",
          23: "[",
          24: "]"
        },
        productions_: [0, [3, 1], [5, 1], [7, 1], [9, 1], [9, 1], [12, 2], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [15, 2], [15, 3], [20, 3], [19, 1], [19, 3], [16, 2], [16, 3], [25, 1], [25, 3]],
        performAction: function (e, t, n, i, o, r, s) {
          var a = r.length - 1;
          switch (o) {
            case 1:
              (this || _global).$ = e.replace(/\\(\\|")/g, "$1").replace(/\\n/g, "\n").replace(/\\r/g, "\r").replace(/\\t/g, "\t").replace(/\\v/g, "\x0B").replace(/\\f/g, "\f").replace(/\\b/g, "\b");
              break;
            case 2:
              (this || _global).$ = Number(e);
              break;
            case 3:
              (this || _global).$ = null;
              break;
            case 4:
              (this || _global).$ = !0;
              break;
            case 5:
              (this || _global).$ = !1;
              break;
            case 6:
              return (this || _global).$ = r[a - 1];
            case 13:
              (this || _global).$ = {};
              break;
            case 14:
              (this || _global).$ = r[a - 1];
              break;
            case 15:
              (this || _global).$ = [r[a - 2], r[a]];
              break;
            case 16:
              (this || _global).$ = {}, (this || _global).$[r[a][0]] = r[a][1];
              break;
            case 17:
              (this || _global).$ = r[a - 2], r[a - 2][r[a][0]] = r[a][1];
              break;
            case 18:
              (this || _global).$ = [];
              break;
            case 19:
              (this || _global).$ = r[a - 1];
              break;
            case 20:
              (this || _global).$ = [r[a]];
              break;
            case 21:
              (this || _global).$ = r[a - 2], r[a - 2].push(r[a]);
          }
        },
        table: [{
          3: 5,
          4: [1, 12],
          5: 6,
          6: [1, 13],
          7: 3,
          8: [1, 9],
          9: 4,
          10: [1, 10],
          11: [1, 11],
          12: 1,
          13: 2,
          15: 7,
          16: 8,
          17: [1, 14],
          23: [1, 15]
        }, {
          1: [3]
        }, {
          14: [1, 16]
        }, {
          14: [2, 7],
          18: [2, 7],
          22: [2, 7],
          24: [2, 7]
        }, {
          14: [2, 8],
          18: [2, 8],
          22: [2, 8],
          24: [2, 8]
        }, {
          14: [2, 9],
          18: [2, 9],
          22: [2, 9],
          24: [2, 9]
        }, {
          14: [2, 10],
          18: [2, 10],
          22: [2, 10],
          24: [2, 10]
        }, {
          14: [2, 11],
          18: [2, 11],
          22: [2, 11],
          24: [2, 11]
        }, {
          14: [2, 12],
          18: [2, 12],
          22: [2, 12],
          24: [2, 12]
        }, {
          14: [2, 3],
          18: [2, 3],
          22: [2, 3],
          24: [2, 3]
        }, {
          14: [2, 4],
          18: [2, 4],
          22: [2, 4],
          24: [2, 4]
        }, {
          14: [2, 5],
          18: [2, 5],
          22: [2, 5],
          24: [2, 5]
        }, {
          14: [2, 1],
          18: [2, 1],
          21: [2, 1],
          22: [2, 1],
          24: [2, 1]
        }, {
          14: [2, 2],
          18: [2, 2],
          22: [2, 2],
          24: [2, 2]
        }, {
          3: 20,
          4: [1, 12],
          18: [1, 17],
          19: 18,
          20: 19
        }, {
          3: 5,
          4: [1, 12],
          5: 6,
          6: [1, 13],
          7: 3,
          8: [1, 9],
          9: 4,
          10: [1, 10],
          11: [1, 11],
          13: 23,
          15: 7,
          16: 8,
          17: [1, 14],
          23: [1, 15],
          24: [1, 21],
          25: 22
        }, {
          1: [2, 6]
        }, {
          14: [2, 13],
          18: [2, 13],
          22: [2, 13],
          24: [2, 13]
        }, {
          18: [1, 24],
          22: [1, 25]
        }, {
          18: [2, 16],
          22: [2, 16]
        }, {
          21: [1, 26]
        }, {
          14: [2, 18],
          18: [2, 18],
          22: [2, 18],
          24: [2, 18]
        }, {
          22: [1, 28],
          24: [1, 27]
        }, {
          22: [2, 20],
          24: [2, 20]
        }, {
          14: [2, 14],
          18: [2, 14],
          22: [2, 14],
          24: [2, 14]
        }, {
          3: 20,
          4: [1, 12],
          20: 29
        }, {
          3: 5,
          4: [1, 12],
          5: 6,
          6: [1, 13],
          7: 3,
          8: [1, 9],
          9: 4,
          10: [1, 10],
          11: [1, 11],
          13: 30,
          15: 7,
          16: 8,
          17: [1, 14],
          23: [1, 15]
        }, {
          14: [2, 19],
          18: [2, 19],
          22: [2, 19],
          24: [2, 19]
        }, {
          3: 5,
          4: [1, 12],
          5: 6,
          6: [1, 13],
          7: 3,
          8: [1, 9],
          9: 4,
          10: [1, 10],
          11: [1, 11],
          13: 31,
          15: 7,
          16: 8,
          17: [1, 14],
          23: [1, 15]
        }, {
          18: [2, 17],
          22: [2, 17]
        }, {
          18: [2, 15],
          22: [2, 15]
        }, {
          22: [2, 21],
          24: [2, 21]
        }],
        defaultActions: {
          16: [2, 6]
        },
        parseError: function (e, t) {
          throw new Error(e);
        },
        parse: function (e) {
          var t = this || _global,
            n = [0],
            i = [null],
            o = [],
            r = (this || _global).table,
            s = "",
            a = 0,
            l = 0,
            c = 0,
            h = ((this || _global).lexer.setInput(e), (this || _global).lexer.yy = (this || _global).yy, (this || _global).yy.lexer = (this || _global).lexer, void 0 === (this || _global).lexer.yylloc && ((this || _global).lexer.yylloc = {}), (this || _global).lexer.yylloc);
          function d() {
            var e = t.lexer.lex() || 1;
            return e = "number" != typeof e ? t.symbols_[e] || e : e;
          }
          o.push(h), "function" == typeof (this || _global).yy.parseError && ((this || _global).parseError = (this || _global).yy.parseError);
          for (var u, g, p, m, f, C, y, v, I, b = {};;) {
            if (p = n[n.length - 1], void 0 === (m = (this || _global).defaultActions[p] || (null == u && (u = d()), r[p] && r[p][u])) || !m.length || !m[0]) {
              if (!c) {
                for (f in v = [], r[p]) (this || _global).terminals_[f] && 2 < f && v.push("'" + (this || _global).terminals_[f] + "'");
                var A = "",
                  A = (this || _global).lexer.showPosition ? "Parse error on line " + (a + 1) + ":\n" + (this || _global).lexer.showPosition() + "\nExpecting " + v.join(", ") + ", got '" + (this || _global).terminals_[u] + "'" : "Parse error on line " + (a + 1) + ": Unexpected " + (1 == u ? "end of input" : "'" + ((this || _global).terminals_[u] || u) + "'");
                this.parseError(A, {
                  text: (this || _global).lexer.match,
                  token: (this || _global).terminals_[u] || u,
                  line: (this || _global).lexer.yylineno,
                  loc: h,
                  expected: v
                });
              }
              if (3 == c) {
                if (1 == u) throw new Error(A || "Parsing halted.");
                l = (this || _global).lexer.yyleng, s = (this || _global).lexer.yytext, a = (this || _global).lexer.yylineno, h = (this || _global).lexer.yylloc, u = d();
              }
              for (;;) {
                if (2 .toString() in r[p]) break;
                if (0 == p) throw new Error(A || "Parsing halted.");
                I = 1, n.length = n.length - 2 * I, i.length = i.length - I, o.length = o.length - I, p = n[n.length - 1];
              }
              g = u, u = 2, m = r[p = n[n.length - 1]] && r[p][2], c = 3;
            }
            if (m[0] instanceof Array && 1 < m.length) throw new Error("Parse Error: multiple actions possible at state: " + p + ", token: " + u);
            switch (m[0]) {
              case 1:
                n.push(u), i.push((this || _global).lexer.yytext), o.push((this || _global).lexer.yylloc), n.push(m[1]), u = null, g ? (u = g, g = null) : (l = (this || _global).lexer.yyleng, s = (this || _global).lexer.yytext, a = (this || _global).lexer.yylineno, h = (this || _global).lexer.yylloc, 0 < c && c--);
                break;
              case 2:
                if (C = (this || _global).productions_[m[1]][1], b.$ = i[i.length - C], b._$ = {
                  first_line: o[o.length - (C || 1)].first_line,
                  last_line: o[o.length - 1].last_line,
                  first_column: o[o.length - (C || 1)].first_column,
                  last_column: o[o.length - 1].last_column
                }, void 0 !== (y = (this || _global).performAction.call(b, s, l, a, (this || _global).yy, m[1], i, o))) return y;
                C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), o = o.slice(0, -1 * C)), n.push((this || _global).productions_[m[1]][0]), i.push(b.$), o.push(b._$), y = r[n[n.length - 2]][n[n.length - 1]], n.push(y);
                break;
              case 3:
                return !0;
            }
          }
          return !0;
        }
      }).lexer = {
        EOF: 1,
        parseError: function (e, t) {
          if (!(this || _global).yy.parseError) throw new Error(e);
          (this || _global).yy.parseError(e, t);
        },
        setInput: function (e) {
          return (this || _global)._input = e, (this || _global)._more = (this || _global)._less = (this || _global).done = !1, (this || _global).yylineno = (this || _global).yyleng = 0, (this || _global).yytext = (this || _global).matched = (this || _global).match = "", (this || _global).conditionStack = ["INITIAL"], (this || _global).yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this || _global;
        },
        input: function () {
          var e = (this || _global)._input[0];
          return (this || _global).yytext += e, (this || _global).yyleng++, (this || _global).match += e, (this || _global).matched += e, e.match(/\n/) && (this || _global).yylineno++, (this || _global)._input = (this || _global)._input.slice(1), e;
        },
        unput: function (e) {
          return (this || _global)._input = e + (this || _global)._input, this || _global;
        },
        more: function () {
          return (this || _global)._more = !0, this || _global;
        },
        less: function (e) {
          (this || _global)._input = (this || _global).match.slice(e) + (this || _global)._input;
        },
        pastInput: function () {
          var e = (this || _global).matched.substr(0, (this || _global).matched.length - (this || _global).match.length);
          return (20 < e.length ? "..." : "") + e.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function () {
          var e = (this || _global).match;
          return e.length < 20 && (e += (this || _global)._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (20 < e.length ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function () {
          var e = this.pastInput(),
            t = new Array(e.length + 1).join("-");
          return e + this.upcomingInput() + "\n" + t + "^";
        },
        next: function () {
          if ((this || _global).done) return (this || _global).EOF;
          (this || _global)._input || ((this || _global).done = !0), (this || _global)._more || ((this || _global).yytext = "", (this || _global).match = "");
          for (var e, t, n, i, o = this._currentRules(), r = 0; r < o.length && (!(t = (this || _global)._input.match((this || _global).rules[o[r]])) || e && !(t[0].length > e[0].length) || (e = t, n = r, (this || _global).options.flex)); r++);
          return e ? ((i = e[0].match(/\n.*/g)) && ((this || _global).yylineno += i.length), (this || _global).yylloc = {
            first_line: (this || _global).yylloc.last_line,
            last_line: (this || _global).yylineno + 1,
            first_column: (this || _global).yylloc.last_column,
            last_column: i ? i[i.length - 1].length - 1 : (this || _global).yylloc.last_column + e[0].length
          }, (this || _global).yytext += e[0], (this || _global).match += e[0], (this || _global).yyleng = (this || _global).yytext.length, (this || _global)._more = !1, (this || _global)._input = (this || _global)._input.slice(e[0].length), (this || _global).matched += e[0], i = (this || _global).performAction.call(this || _global, (this || _global).yy, this || _global, o[n], (this || _global).conditionStack[(this || _global).conditionStack.length - 1]), (this || _global).done && (this || _global)._input && ((this || _global).done = !1), i || void 0) : "" === (this || _global)._input ? (this || _global).EOF : void this.parseError("Lexical error on line " + ((this || _global).yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: (this || _global).yylineno
          });
        },
        lex: function () {
          var e = this.next();
          return void 0 !== e ? e : this.lex();
        },
        begin: function (e) {
          (this || _global).conditionStack.push(e);
        },
        popState: function () {
          return (this || _global).conditionStack.pop();
        },
        _currentRules: function () {
          return (this || _global).conditions[(this || _global).conditionStack[(this || _global).conditionStack.length - 1]].rules;
        },
        topState: function () {
          return (this || _global).conditionStack[(this || _global).conditionStack.length - 2];
        },
        pushState: function (e) {
          this.begin(e);
        },
        options: {},
        performAction: function (e, t, n, i) {
          switch (n) {
            case 0:
              break;
            case 1:
              return 6;
            case 2:
              return t.yytext = t.yytext.substr(1, t.yyleng - 2), 4;
            case 3:
              return 17;
            case 4:
              return 18;
            case 5:
              return 23;
            case 6:
              return 24;
            case 7:
              return 22;
            case 8:
              return 21;
            case 9:
              return 10;
            case 10:
              return 11;
            case 11:
              return 8;
            case 12:
              return 14;
            case 13:
              return "INVALID";
          }
        },
        rules: [/^(?:\s+)/, /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/, /^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/, /^(?:\{)/, /^(?:\})/, /^(?:\[)/, /^(?:\])/, /^(?:,)/, /^(?::)/, /^(?:true\b)/, /^(?:false\b)/, /^(?:null\b)/, /^(?:$)/, /^(?:.)/],
        conditions: {
          INITIAL: {
            rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            inclusive: !0
          }
        }
      };
      var n;
      t.parser = n, t.parse = n.parse.bind(n);
    },
    3879: function (e) {
      "use strict";

      function i() {}
      i.prototype = {
        on: function (e, t) {
          (this || _global)._events = (this || _global)._events || {}, (this || _global)._events[e] = (this || _global)._events[e] || [], (this || _global)._events[e].push(t);
        },
        off: function (e, t) {
          (this || _global)._events = (this || _global)._events || {}, e in (this || _global)._events != !1 && (this || _global)._events[e].splice((this || _global)._events[e].indexOf(t), 1);
        },
        emit: function (e) {
          if ((this || _global)._events = (this || _global)._events || {}, e in (this || _global)._events != !1) for (var t = 0; t < (this || _global)._events[e].length; t++) (this || _global)._events[e][t].apply(this || _global, Array.prototype.slice.call(arguments, 1));
        }
      }, i.mixin = function (e) {
        for (var t = ["on", "off", "emit"], n = 0; n < t.length; n++) "function" == typeof e ? e.prototype[t[n]] = i.prototype[t[n]] : e[t[n]] = i.prototype[t[n]];
        return e;
      };
      var u = {
        escapeRegExp: function (e) {
          var t = /[\\^$.*+?()[\]{}|]/g,
            n = new RegExp(t.source);
          return e && n.test(e) ? e.replace(t, "\\$&") : e;
        },
        extend: function (e, t) {
          for (var n in t) {
            var i;
            t.hasOwnProperty(n) && ((i = t[n]) && "[object Object]" === Object.prototype.toString.call(i) ? (e[n] = e[n] || {}, u.extend(e[n], i)) : e[n] = i);
          }
          return e;
        },
        each: function (e, t, n) {
          if ("[object Object]" === Object.prototype.toString.call(e)) for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.call(n, i, e[i], e);else for (var o = 0, r = e.length; o < r; o++) t.call(n, o, e[o], e);
        },
        createElement: function (e, t) {
          var n,
            i = document.createElement(e);
          if (t && "[object Object]" === Object.prototype.toString.call(t)) for (n in t) n in i ? i[n] = t[n] : "html" === n ? i.innerHTML = t[n] : i.setAttribute(n, t[n]);
          return i;
        },
        hasClass: function (e, t) {
          if (e) return e.classList ? e.classList.contains(t) : !!e.className && !!e.className.match(new RegExp("(\\s|^)" + t + "(\\s|$)"));
        },
        addClass: function (e, t) {
          u.hasClass(e, t) || (e.classList ? e.classList.add(t) : e.className = e.className.trim() + " " + t);
        },
        removeClass: function (e, t) {
          u.hasClass(e, t) && (e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(^|\\s)" + t.split(" ").join("|") + "(\\s|$)", "gi"), " "));
        },
        closest: function (e, t) {
          return e && e !== document.body && (t(e) ? e : u.closest(e.parentNode, t));
        },
        isInt: function (e) {
          return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
        },
        debounce: function (i, o, r) {
          var s;
          return function () {
            var e = this || _global,
              t = arguments,
              n = r && !s;
            clearTimeout(s), s = setTimeout(function () {
              s = null, r || i.apply(e, t);
            }, o), n && i.apply(e, t);
          };
        },
        rect: function (e, t) {
          var n = window,
            e = e.getBoundingClientRect(),
            i = t ? n.pageXOffset : 0,
            t = t ? n.pageYOffset : 0;
          return {
            bottom: e.bottom + t,
            height: e.height,
            left: e.left + i,
            right: e.right + i,
            top: e.top + t,
            width: e.width
          };
        },
        includes: function (e, t) {
          return -1 < e.indexOf(t);
        },
        startsWith: function (e, t) {
          return e.substr(0, t.length) === t;
        },
        truncate: function (e) {
          for (; e.firstChild;) e.removeChild(e.firstChild);
        }
      };
      function h(e, t) {
        return e.hasOwnProperty(t) && (!0 === e[t] || e[t].length);
      }
      function g(e, t, n) {
        e.parentNode ? e.parentNode.parentNode || t.appendChild(e.parentNode) : t.appendChild(e), u.removeClass(e, "excluded"), n || (e.textContent = e.textContent);
      }
      function o() {
        var n, e;
        (this || _global).items.length && (n = document.createDocumentFragment(), (this || _global).config.pagination ? (e = (this || _global).pages.slice(0, (this || _global).pageIndex), u.each(e, function (e, t) {
          u.each(t, function (e, t) {
            g(t, n, (this || _global).customOption);
          }, this || _global);
        }, this || _global)) : u.each((this || _global).items, function (e, t) {
          g(t, n, (this || _global).customOption);
        }, this || _global), n.childElementCount && (u.removeClass((this || _global).items[(this || _global).navIndex], "active"), (this || _global).navIndex = (n.querySelector(".selectr-option.selected") || n.querySelector(".selectr-option")).idx, u.addClass((this || _global).items[(this || _global).navIndex], "active")), (this || _global).tree.appendChild(n));
      }
      function d(e, t) {
        t = t || e;
        var n = {
          class: "selectr-option",
          role: "treeitem",
          "aria-selected": !1
        };
        return (this || _global).customOption ? n.html = (this || _global).config.renderOption(t) : n.textContent = e.textContent, (t = u.createElement("li", n)).idx = e.idx, (this || _global).items.push(t), e.defaultSelected && (this || _global).defaultSelected.push(e.idx), e.disabled && (t.disabled = !0, u.addClass(t, "disabled")), t;
      }
      function r() {
        var n,
          e = (this || _global).tree,
          t = e.scrollTop;
        e.scrollHeight - e.offsetHeight <= t && (this || _global).pageIndex < (this || _global).pages.length && (n = document.createDocumentFragment(), u.each((this || _global).pages[(this || _global).pageIndex], function (e, t) {
          g(t, n, (this || _global).customOption);
        }, this || _global), e.appendChild(n), (this || _global).pageIndex++, this.emit("selectr.paginate", {
          items: (this || _global).items.length,
          total: (this || _global).data.length,
          page: (this || _global).pageIndex,
          pages: (this || _global).pages.length
        }));
      }
      function s() {
        ((this || _global).config.searchable || (this || _global).config.taggable) && ((this || _global).input.value = null, (this || _global).searching = !1, (this || _global).config.searchable && u.removeClass((this || _global).inputContainer, "active"), u.hasClass((this || _global).container, "notice") && (u.removeClass((this || _global).container, "notice"), u.addClass((this || _global).container, "open"), (this || _global).input.focus()), u.each((this || _global).items, function (e, t) {
          u.removeClass(t, "excluded"), (this || _global).customOption || (t.textContent = t.textContent);
        }, this || _global));
      }
      function t(e, t) {
        if (!e) throw new Error("You must supply either a HTMLSelectElement or a CSS3 selector string.");
        if ("string" == typeof ((this || _global).el = e) && ((this || _global).el = document.querySelector(e)), null === (this || _global).el) throw new Error("The element you passed to Selectr can not be found.");
        if ("select" !== (this || _global).el.nodeName.toLowerCase()) throw new Error("The element you passed to Selectr is not a HTMLSelectElement.");
        this.render(t);
      }
      t.prototype.render = function (e) {
        var t;
        (this || _global).rendered || (((this || _global).el.selectr = this || _global).config = u.extend({
          defaultSelected: !0,
          width: "auto",
          disabled: !1,
          disabledMobile: !1,
          searchable: !0,
          clearable: !1,
          sortSelected: !1,
          allowDeselect: !1,
          closeOnScroll: !1,
          nativeDropdown: !1,
          nativeKeyboard: !1,
          placeholder: "Select an option...",
          taggable: !1,
          tagPlaceholder: "Enter a tag...",
          messages: {
            noResults: "No results.",
            noOptions: "No options available.",
            maxSelections: "A maximum of {max} items can be selected.",
            tagDuplicate: "That tag is already in use.",
            searchPlaceholder: "Search options..."
          }
        }, e), (this || _global).originalType = (this || _global).el.type, (this || _global).originalIndex = (this || _global).el.tabIndex, (this || _global).defaultSelected = [], (this || _global).originalOptionCount = (this || _global).el.options.length, ((this || _global).config.multiple || (this || _global).config.taggable) && ((this || _global).el.multiple = !0), (this || _global).disabled = h((this || _global).config, "disabled"), (this || _global).opened = !1, (this || _global).config.taggable && ((this || _global).config.searchable = !1), (this || _global).navigating = !1, (this || _global).mobileDevice = !1, !(this || _global).config.disabledMobile && /Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent) && ((this || _global).mobileDevice = !0), (this || _global).customOption = (this || _global).config.hasOwnProperty("renderOption") && "function" == typeof (this || _global).config.renderOption, (this || _global).customSelected = (this || _global).config.hasOwnProperty("renderSelection") && "function" == typeof (this || _global).config.renderSelection, (this || _global).supportsEventPassiveOption = this.detectEventPassiveOption(), i.mixin(this || _global), function () {
          (this || _global).requiresPagination = (this || _global).config.pagination && 0 < (this || _global).config.pagination, h((this || _global).config, "width") && (u.isInt((this || _global).config.width) ? (this || _global).width = (this || _global).config.width + "px" : "auto" === (this || _global).config.width ? (this || _global).width = "100%" : u.includes((this || _global).config.width, "%") && ((this || _global).width = (this || _global).config.width)), (this || _global).container = u.createElement("div", {
            class: "selectr-container"
          }), (this || _global).config.customClass && u.addClass((this || _global).container, (this || _global).config.customClass), (this || _global).mobileDevice ? u.addClass((this || _global).container, "selectr-mobile") : u.addClass((this || _global).container, "selectr-desktop"), (this || _global).el.tabIndex = -1, (this || _global).config.nativeDropdown || (this || _global).mobileDevice ? u.addClass((this || _global).el, "selectr-visible") : u.addClass((this || _global).el, "selectr-hidden"), (this || _global).selected = u.createElement("div", {
            class: "selectr-selected",
            disabled: (this || _global).disabled,
            tabIndex: 0,
            "aria-expanded": !1
          }), (this || _global).label = u.createElement((this || _global).el.multiple ? "ul" : "span", {
            class: "selectr-label"
          });
          var e = u.createElement("div", {
            class: "selectr-options-container"
          });
          if ((this || _global).tree = u.createElement("ul", {
            class: "selectr-options",
            role: "tree",
            "aria-hidden": !0,
            "aria-expanded": !1
          }), (this || _global).notice = u.createElement("div", {
            class: "selectr-notice"
          }), (this || _global).el.setAttribute("aria-hidden", !0), (this || _global).disabled && ((this || _global).el.disabled = !0), (this || _global).el.multiple ? (u.addClass((this || _global).label, "selectr-tags"), u.addClass((this || _global).container, "multiple"), (this || _global).tags = [], (this || _global).selectedValues = (this || _global).config.defaultSelected ? this.getSelectedProperties("value") : [], (this || _global).selectedIndexes = this.getSelectedProperties("idx")) : ((this || _global).selectedValue = null, (this || _global).selectedIndex = -1), (this || _global).selected.appendChild((this || _global).label), (this || _global).config.clearable && ((this || _global).selectClear = u.createElement("button", {
            class: "selectr-clear",
            type: "button"
          }), (this || _global).container.appendChild((this || _global).selectClear), u.addClass((this || _global).container, "clearable")), (this || _global).config.taggable) {
            var t = u.createElement("li", {
              class: "input-tag"
            });
            if ((this || _global).input = u.createElement("input", {
              class: "selectr-tag-input",
              placeholder: (this || _global).config.tagPlaceholder,
              tagIndex: 0,
              autocomplete: "off",
              autocorrect: "off",
              autocapitalize: "off",
              spellcheck: "false",
              role: "textbox",
              type: "search"
            }), t.appendChild((this || _global).input), (this || _global).label.appendChild(t), u.addClass((this || _global).container, "taggable"), (this || _global).tagSeperators = [","], (this || _global).config.tagSeperators) {
              (this || _global).tagSeperators = (this || _global).tagSeperators.concat((this || _global).config.tagSeperators);
              for (var n = [], i = 0; i < (this || _global).tagSeperators.length; i++) n.push(u.escapeRegExp((this || _global).tagSeperators[i]));
              (this || _global).tagSeperatorsRegex = new RegExp(n.join("|"), "i");
            } else (this || _global).tagSeperatorsRegex = new RegExp(",", "i");
          }
          (this || _global).config.searchable && ((this || _global).input = u.createElement("input", {
            class: "selectr-input",
            tagIndex: -1,
            autocomplete: "off",
            autocorrect: "off",
            autocapitalize: "off",
            spellcheck: "false",
            role: "textbox",
            type: "search",
            placeholder: (this || _global).config.messages.searchPlaceholder
          }), (this || _global).inputClear = u.createElement("button", {
            class: "selectr-input-clear",
            type: "button"
          }), (this || _global).inputContainer = u.createElement("div", {
            class: "selectr-input-container"
          }), (this || _global).inputContainer.appendChild((this || _global).input), (this || _global).inputContainer.appendChild((this || _global).inputClear), e.appendChild((this || _global).inputContainer)), e.appendChild((this || _global).notice), e.appendChild((this || _global).tree), (this || _global).items = [], (this || _global).options = [], (this || _global).el.options.length && ((this || _global).options = [].slice.call((this || _global).el.options));
          var o,
            r,
            s,
            a = !1,
            l = 0;
          (this || _global).el.children.length && u.each((this || _global).el.children, function (e, t) {
            "OPTGROUP" === t.nodeName ? (a = u.createElement("ul", {
              class: "selectr-optgroup",
              role: "group",
              html: "<li class='selectr-optgroup--label'>" + t.label + "</li>"
            }), u.each(t.children, function (e, t) {
              t.idx = l, a.appendChild(d.call(this || _global, t, a)), l++;
            }, this || _global)) : (t.idx = l, d.call(this || _global, t), l++);
          }, this || _global), (this || _global).config.data && Array.isArray((this || _global).config.data) && (o = !((this || _global).data = []), a = !1, l = 0, u.each((this || _global).config.data, function (e, t) {
            h(t, "children") ? (o = u.createElement("optgroup", {
              label: t.text
            }), a = u.createElement("ul", {
              class: "selectr-optgroup",
              role: "group",
              html: "<li class='selectr-optgroup--label'>" + t.text + "</li>"
            }), u.each(t.children, function (e, t) {
              (r = new Option(t.text, t.value, !1, t.hasOwnProperty("selected") && !0 === t.selected)).disabled = h(t, "disabled"), (this || _global).options.push(r), o.appendChild(r), r.idx = l, a.appendChild(d.call(this || _global, r, t)), (this || _global).data[l] = t, l++;
            }, this || _global), (this || _global).el.appendChild(o)) : ((r = new Option(t.text, t.value, !1, t.hasOwnProperty("selected") && !0 === t.selected)).disabled = h(t, "disabled"), (this || _global).options.push(r), r.idx = l, d.call(this || _global, r, t), (this || _global).data[l] = t, l++);
          }, this || _global)), this.setSelected(!0);
          for (var c = (this || _global).navIndex = 0; c < (this || _global).items.length; c++) if (s = (this || _global).items[c], !u.hasClass(s, "disabled")) {
            u.addClass(s, "active"), (this || _global).navIndex = c;
            break;
          }
          (this || _global).requiresPagination && ((this || _global).pageIndex = 1, this.paginate()), (this || _global).container.appendChild((this || _global).selected), (this || _global).container.appendChild(e), (this || _global).placeEl = u.createElement("div", {
            class: "selectr-placeholder"
          }), this.setPlaceholder(), (this || _global).selected.appendChild((this || _global).placeEl), (this || _global).disabled && this.disable(), (this || _global).el.parentNode.insertBefore((this || _global).container, (this || _global).el), (this || _global).container.appendChild((this || _global).el);
        }.call(this || _global), this.bindEvents(), this.update(), (this || _global).optsRect = u.rect((this || _global).tree), (this || _global).rendered = !0, (this || _global).el.multiple || ((this || _global).el.selectedIndex = (this || _global).selectedIndex), t = this || _global, setTimeout(function () {
          t.emit("selectr.init");
        }, 20));
      }, t.prototype.getSelected = function () {
        return (this || _global).el.querySelectorAll("option:checked");
      }, t.prototype.getSelectedProperties = function (t) {
        var e = this.getSelected();
        return [].slice.call(e).map(function (e) {
          return e[t];
        }).filter(function (e) {
          return null != e;
        });
      }, t.prototype.detectEventPassiveOption = function () {
        var e = !1;
        try {
          var t = Object.defineProperty({}, "passive", {
            get: function () {
              e = !0;
            }
          });
          window.addEventListener("test", null, t);
        } catch (e) {}
        return e;
      }, t.prototype.bindEvents = function () {
        var n,
          i = this || _global;
        (this || _global).events = {}, (this || _global).events.dismiss = function (e) {
          e = e.target;
          (this || _global).container.contains(e) || !(this || _global).opened && !u.hasClass((this || _global).container, "notice") || this.close();
        }.bind(this || _global), (this || _global).events.navigate = function (e) {
          if (e = e || window.event, (this || _global).items.length && (this || _global).opened && u.includes([13, 38, 40], e.which)) {
            if (e.preventDefault(), 13 === e.which) return !((this || _global).noResults || (this || _global).config.taggable && 0 < (this || _global).input.value.length) && this.change((this || _global).navIndex);
            var t,
              n = (this || _global).items[(this || _global).navIndex],
              i = (this || _global).navIndex;
            switch (e.which) {
              case 38:
                (t = 0) < (this || _global).navIndex && (this || _global).navIndex--;
                break;
              case 40:
                (this || _global).navIndex < (this || _global).items.length - (t = 1) && (this || _global).navIndex++;
            }
            for ((this || _global).navigating = !0; u.hasClass((this || _global).items[(this || _global).navIndex], "disabled") || u.hasClass((this || _global).items[(this || _global).navIndex], "excluded");) {
              if (!(0 < (this || _global).navIndex && (this || _global).navIndex < (this || _global).items.length - 1)) {
                (this || _global).navIndex = i;
                break;
              }
              if (t ? (this || _global).navIndex++ : (this || _global).navIndex--, (this || _global).searching) {
                if ((this || _global).navIndex > (this || _global).tree.lastElementChild.idx) {
                  (this || _global).navIndex = (this || _global).tree.lastElementChild.idx;
                  break;
                }
                if ((this || _global).navIndex < (this || _global).tree.firstElementChild.idx) {
                  (this || _global).navIndex = (this || _global).tree.firstElementChild.idx;
                  break;
                }
              }
            }
            e = u.rect((this || _global).items[(this || _global).navIndex]);
            t ? (0 === (this || _global).navIndex ? (this || _global).tree.scrollTop = 0 : e.top + e.height > (this || _global).optsRect.top + (this || _global).optsRect.height && ((this || _global).tree.scrollTop = (this || _global).tree.scrollTop + (e.top + e.height - ((this || _global).optsRect.top + (this || _global).optsRect.height))), (this || _global).navIndex === (this || _global).tree.childElementCount - 1 && (this || _global).requiresPagination && r.call(this || _global)) : 0 === (this || _global).navIndex ? (this || _global).tree.scrollTop = 0 : e.top - (this || _global).optsRect.top < 0 && ((this || _global).tree.scrollTop = (this || _global).tree.scrollTop + (e.top - (this || _global).optsRect.top)), n && u.removeClass(n, "active"), u.addClass((this || _global).items[(this || _global).navIndex], "active");
          } else (this || _global).navigating = !1;
        }.bind(this || _global), (this || _global).events.reset = (this || _global).reset.bind(this || _global), ((this || _global).config.nativeDropdown || (this || _global).mobileDevice) && ((this || _global).container.addEventListener("touchstart", function (e) {
          e.changedTouches[0].target === i.el && i.toggle();
        }, !!(this || _global).supportsEventPassiveOption && {
          passive: !0
        }), (this || _global).container.addEventListener("click", function (e) {
          e.target === i.el && i.toggle();
        }), (this || _global).el.addEventListener("change", function (e) {
          e.__selfTriggered || (i.el.multiple ? (e = i.getSelectedProperties("idx"), e = function (e, t) {
            for (var n, i = [], o = e.slice(0), r = 0; r < t.length; r++) -1 < (n = o.indexOf(t[r])) ? o.splice(n, 1) : i.push(t[r]);
            return [i, o];
          }(i.selectedIndexes, e), u.each(e[0], function (e, t) {
            i.select(t);
          }, i), u.each(e[1], function (e, t) {
            i.deselect(t);
          }, i)) : -1 < i.el.selectedIndex && i.select(i.el.selectedIndex));
        })), (this || _global).config.nativeDropdown && (this || _global).container.addEventListener("keydown", function (e) {
          "Enter" === e.key && i.selected === document.activeElement && (i.toggle(), setTimeout(function () {
            i.el.focus();
          }, 200));
        }), (this || _global).selected.addEventListener("click", function (e) {
          i.disabled || i.toggle(), e.preventDefault();
        }), (this || _global).config.nativeKeyboard && (n = "", (this || _global).selected.addEventListener("keydown", function (e) {
          var t;
          i.disabled || i.selected !== document.activeElement || e.altKey || e.ctrlKey || e.metaKey || (" " === e.key || !i.opened && -1 < ["Enter", "ArrowUp", "ArrowDown"].indexOf(e.key) ? (i.toggle(), e.preventDefault(), e.stopPropagation()) : e.key.length <= 2 && String[String.fromCodePoint ? "fromCodePoint" : "fromCharCode"](e.key[String.codePointAt ? "codePointAt" : "charCodeAt"](0)) === e.key && (i.config.multiple ? (i.open(), i.config.searchable && (i.input.value = e.key, i.input.focus(), i.search(null, !0))) : (n += e.key, (t = i.search(n, !0)) && t.length && (i.clear(), i.setValue(t[0].value)), setTimeout(function () {
            n = "";
          }, 1000)), e.preventDefault(), e.stopPropagation()));
        }), (this || _global).container.addEventListener("keyup", function (e) {
          i.opened && "Escape" === e.key && (i.close(), e.stopPropagation(), i.selected.focus());
        })), (this || _global).label.addEventListener("click", function (e) {
          u.hasClass(e.target, "selectr-tag-remove") && i.deselect(e.target.parentNode.idx);
        }), (this || _global).selectClear && (this || _global).selectClear.addEventListener("click", (this || _global).clear.bind(this || _global)), (this || _global).tree.addEventListener("mousedown", function (e) {
          e.preventDefault();
        }), (this || _global).tree.addEventListener("click", function (e) {
          var t = u.closest(e.target, function (e) {
            return e && u.hasClass(e, "selectr-option");
          });
          t && !u.hasClass(t, "disabled") && (u.hasClass(t, "selected") ? (i.el.multiple || !i.el.multiple && i.config.allowDeselect) && i.deselect(t.idx) : i.select(t.idx), i.opened && !i.el.multiple) && i.close(), e.preventDefault(), e.stopPropagation();
        }), (this || _global).tree.addEventListener("mouseover", function (e) {
          !u.hasClass(e.target, "selectr-option") || u.hasClass(e.target, "disabled") || (u.removeClass(i.items[i.navIndex], "active"), u.addClass(e.target, "active"), i.navIndex = [].slice.call(i.items).indexOf(e.target));
        }), (this || _global).config.searchable && ((this || _global).input.addEventListener("focus", function (e) {
          i.searching = !0;
        }), (this || _global).input.addEventListener("blur", function (e) {
          i.searching = !1;
        }), (this || _global).input.addEventListener("keyup", function (e) {
          i.search(), i.config.taggable || ((this || _global).value.length ? u.addClass((this || _global).parentNode, "active") : u.removeClass((this || _global).parentNode, "active"));
        }), (this || _global).inputClear.addEventListener("click", function (e) {
          i.input.value = null, s.call(i), i.tree.childElementCount || o.call(i);
        })), (this || _global).config.taggable && (this || _global).input.addEventListener("keyup", function (e) {
          var t, n;
          i.search(), i.config.taggable && (this || _global).value.length && (t = (this || _global).value.trim()).length && (13 === e.which || i.tagSeperatorsRegex.test(t)) && (e = t.replace(i.tagSeperatorsRegex, ""), (n = (e = (e = u.escapeRegExp(e)).trim()).length ? i.add({
            value: e,
            textContent: e,
            selected: !0
          }, !0) : n) ? (i.close(), s.call(i)) : ((this || _global).value = "", i.setMessage(i.config.messages.tagDuplicate)));
        }), (this || _global).update = u.debounce(function () {
          i.opened && i.config.closeOnScroll && i.close(), i.width && (i.container.style.width = i.width), i.invert();
        }, 50), (this || _global).requiresPagination && ((this || _global).paginateItems = u.debounce(function () {
          r.call(this || _global);
        }, 50), (this || _global).tree.addEventListener("scroll", (this || _global).paginateItems.bind(this || _global))), document.addEventListener("click", (this || _global).events.dismiss), window.addEventListener("keydown", (this || _global).events.navigate), window.addEventListener("resize", (this || _global).update), window.addEventListener("scroll", (this || _global).update), this.on("selectr.destroy", function () {
          document.removeEventListener("click", (this || _global).events.dismiss), window.removeEventListener("keydown", (this || _global).events.navigate), window.removeEventListener("resize", (this || _global).update), window.removeEventListener("scroll", (this || _global).update);
        }), (this || _global).el.form && ((this || _global).el.form.addEventListener("reset", (this || _global).events.reset), this.on("selectr.destroy", function () {
          (this || _global).el.form.removeEventListener("reset", (this || _global).events.reset);
        }));
      }, t.prototype.setSelected = function (e) {
        var n;
        (this || _global).config.data || (this || _global).el.multiple || !(this || _global).el.options.length || (0 !== (this || _global).el.selectedIndex || (this || _global).el.options[0].defaultSelected || (this || _global).config.defaultSelected || ((this || _global).el.selectedIndex = -1), (this || _global).selectedIndex = (this || _global).el.selectedIndex, -1 < (this || _global).selectedIndex && this.select((this || _global).selectedIndex)), (this || _global).config.multiple && "select-one" === (this || _global).originalType && !(this || _global).config.data && (this || _global).el.options[0].selected && !(this || _global).el.options[0].defaultSelected && ((this || _global).el.options[0].selected = !1), u.each((this || _global).options, function (e, t) {
          t.selected && t.defaultSelected && this.select(t.idx);
        }, this || _global), (this || _global).config.selectedValue && this.setValue((this || _global).config.selectedValue), (this || _global).config.data && (!(this || _global).el.multiple && (this || _global).config.defaultSelected && (this || _global).el.selectedIndex < 0 && 0 < (this || _global).config.data.length && this.select(0), n = 0, u.each((this || _global).config.data, function (e, t) {
          h(t, "children") ? u.each(t.children, function (e, t) {
            t.hasOwnProperty("selected") && !0 === t.selected && this.select(n), n++;
          }, this || _global) : (t.hasOwnProperty("selected") && !0 === t.selected && this.select(n), n++);
        }, this || _global));
      }, t.prototype.destroy = function () {
        (this || _global).rendered && (this.emit("selectr.destroy"), "select-one" === (this || _global).originalType && ((this || _global).el.multiple = !1), (this || _global).config.data && ((this || _global).el.innerHTML = ""), u.removeClass((this || _global).el, "selectr-hidden"), (this || _global).container.parentNode.replaceChild((this || _global).el, (this || _global).container), (this || _global).rendered = !1, delete (this || _global).el.selectr);
      }, t.prototype.change = function (e) {
        var t = (this || _global).items[e],
          n = (this || _global).options[e];
        n.disabled || (n.selected && u.hasClass(t, "selected") ? this.deselect(e) : this.select(e), (this || _global).opened && !(this || _global).el.multiple && this.close());
      }, t.prototype.select = function (i) {
        var e = (this || _global).items[i],
          t = [].slice.call((this || _global).el.options),
          n = (this || _global).options[i];
        if ((this || _global).el.multiple) {
          if (u.includes((this || _global).selectedIndexes, i)) return !1;
          if ((this || _global).config.maxSelections && (this || _global).tags.length === (this || _global).config.maxSelections) return this.setMessage((this || _global).config.messages.maxSelections.replace("{max}", (this || _global).config.maxSelections), !0), !1;
          (this || _global).selectedValues.push(n.value), (this || _global).selectedIndexes.push(i), !function (e) {
            var l,
              c = this || _global,
              n = document.createDocumentFragment(),
              t = (this || _global).options[e.idx],
              i = (this || _global).data ? (this || _global).data[e.idx] : t,
              o = {
                class: "selectr-tag"
              },
              i = ((this || _global).customSelected ? o.html = (this || _global).config.renderSelection(i) : o.textContent = t.textContent, u.createElement("li", o)),
              o = u.createElement("button", {
                class: "selectr-tag-remove",
                type: "button"
              });
            i.appendChild(o), i.idx = e.idx, i.tag = t.value, (this || _global).tags.push(i), (this || _global).config.sortSelected ? (o = (this || _global).tags.slice(), l = function (e, i) {
              e.replace(/(\d+)|(\D+)/g, function (e, t, n) {
                i.push([t || 1 / 0, n || ""]);
              });
            }, o.sort(function (e, t) {
              var n,
                i,
                o = [],
                r = [];
              for (!0 === c.config.sortSelected ? (n = e.tag, i = t.tag) : "text" === c.config.sortSelected && (n = e.textContent, i = t.textContent), l(n, o), l(i, r); o.length && r.length;) {
                var s = o.shift(),
                  a = r.shift(),
                  s = s[0] - a[0] || s[1].localeCompare(a[1]);
                if (s) return s;
              }
              return o.length - r.length;
            }), u.each(o, function (e, t) {
              n.appendChild(t);
            }), (this || _global).label.innerHTML = "") : n.appendChild(i), (this || _global).config.taggable ? (this || _global).label.insertBefore(n, (this || _global).input.parentNode) : (this || _global).label.appendChild(n);
          }.call(this || _global, e);
        } else {
          var o = (this || _global).data ? (this || _global).data[i] : n;
          (this || _global).customSelected ? (this || _global).label.innerHTML = (this || _global).config.renderSelection(o) : (this || _global).label.textContent = n.textContent, (this || _global).selectedValue = n.value, (this || _global).selectedIndex = i, u.each((this || _global).options, function (e, t) {
            var n = (this || _global).items[e];
            e !== i && (n && u.removeClass(n, "selected"), t.selected = !1, t.removeAttribute("selected"));
          }, this || _global);
        }
        u.includes(t, n) || (this || _global).el.add(n), e.setAttribute("aria-selected", !0), u.addClass(e, "selected"), u.addClass((this || _global).container, "has-selected"), n.selected = !0, n.setAttribute("selected", ""), this.emit("selectr.change", n), this.emit("selectr.select", n), "createEvent" in document ? ((o = document.createEvent("HTMLEvents")).initEvent("change", !0, !0), o.__selfTriggered = !0, (this || _global).el.dispatchEvent(o)) : (this || _global).el.fireEvent("onchange");
      }, t.prototype.deselect = function (e, t) {
        var n = (this || _global).items[e],
          i = (this || _global).options[e];
        if ((this || _global).el.multiple) {
          var o = (this || _global).selectedIndexes.indexOf(e),
            o = ((this || _global).selectedIndexes.splice(o, 1), (this || _global).selectedValues.indexOf(i.value));
          (this || _global).selectedValues.splice(o, 1), !function (n) {
            var i = !1;
            u.each((this || _global).tags, function (e, t) {
              t.idx === n.idx && (i = t);
            }, this || _global), i && ((this || _global).label.removeChild(i), (this || _global).tags.splice((this || _global).tags.indexOf(i), 1));
          }.call(this || _global, n), (this || _global).tags.length || u.removeClass((this || _global).container, "has-selected");
        } else {
          if (!t && !(this || _global).config.clearable && !(this || _global).config.allowDeselect) return !1;
          (this || _global).label.innerHTML = "", (this || _global).selectedValue = null, (this || _global).el.selectedIndex = (this || _global).selectedIndex = -1, u.removeClass((this || _global).container, "has-selected");
        }
        (this || _global).items[e].setAttribute("aria-selected", !1), u.removeClass((this || _global).items[e], "selected"), i.selected = !1, i.removeAttribute("selected"), this.emit("selectr.change", null), this.emit("selectr.deselect", i), "createEvent" in document ? ((o = document.createEvent("HTMLEvents")).initEvent("change", !0, !0), o.__selfTriggered = !0, (this || _global).el.dispatchEvent(o)) : (this || _global).el.fireEvent("onchange");
      }, t.prototype.setValue = function (n) {
        var i = Array.isArray(n);
        if (i || (n = n.toString().trim()), !(this || _global).el.multiple && i) return !1;
        u.each((this || _global).options, function (e, t) {
          (i && -1 < n.indexOf(t.value) || t.value === n) && this.change(t.idx);
        }, this || _global);
      }, t.prototype.getValue = function (e, t) {
        var n, i;
        return (this || _global).el.multiple ? e ? (this || _global).selectedIndexes.length && (i = {
          values: []
        }, u.each((this || _global).selectedIndexes, function (e, t) {
          t = (this || _global).options[t];
          i.values[e] = {
            value: t.value,
            text: t.textContent
          };
        }, this || _global)) : i = (this || _global).selectedValues.slice() : i = e ? {
          value: (n = (this || _global).options[(this || _global).selectedIndex]).value,
          text: n.textContent
        } : (this || _global).selectedValue, i = e && t ? JSON.stringify(i) : i;
      }, t.prototype.add = function (n, i) {
        if (n) {
          if ((this || _global).data = (this || _global).data || [], (this || _global).items = (this || _global).items || [], (this || _global).options = (this || _global).options || [], Array.isArray(n)) u.each(n, function (e, t) {
            this.add(t, i);
          }, this || _global);else if ("[object Object]" === Object.prototype.toString.call(n)) {
            if (i) {
              var o = !1;
              if (u.each((this || _global).options, function (e, t) {
                t.value.toLowerCase() === n.value.toLowerCase() && (o = !0);
              }), o) return !1;
            }
            var e = u.createElement("option", n);
            return (this || _global).data.push(n), (this || _global).mobileDevice && (this || _global).el.add(e), (this || _global).options.push(e), e.idx = 0 < (this || _global).options.length ? (this || _global).options.length - 1 : 0, d.call(this || _global, e), n.selected && this.select(e.idx), this.setPlaceholder(), e;
          }
          return (this || _global).config.pagination && this.paginate(), !0;
        }
      }, t.prototype.remove = function (e) {
        var n,
          i = [];
        Array.isArray(e) ? u.each(e, function (e, t) {
          u.isInt(t) ? i.push(this.getOptionByIndex(t)) : "string" == typeof t && i.push(this.getOptionByValue(t));
        }, this || _global) : u.isInt(e) ? i.push(this.getOptionByIndex(e)) : "string" == typeof e && i.push(this.getOptionByValue(e)), i.length && (u.each(i, function (e, t) {
          n = t.idx, (this || _global).el.remove(t), (this || _global).options.splice(n, 1);
          t = (this || _global).items[n].parentNode;
          t && t.removeChild((this || _global).items[n]), (this || _global).items.splice(n, 1), u.each((this || _global).options, function (e, t) {
            t.idx = e, (this || _global).items[e].idx = e;
          }, this || _global);
        }, this || _global), this.setPlaceholder(), (this || _global).config.pagination) && this.paginate();
      }, t.prototype.removeAll = function () {
        this.clear(!0), u.each((this || _global).el.options, function (e, t) {
          (this || _global).el.remove(t);
        }, this || _global), u.truncate((this || _global).tree), (this || _global).items = [], (this || _global).options = [], (this || _global).data = [], (this || _global).navIndex = 0, (this || _global).requiresPagination && ((this || _global).requiresPagination = !1, (this || _global).pageIndex = 1, (this || _global).pages = []), this.setPlaceholder();
      }, t.prototype.search = function (a, e) {
        var l, c, h, d, t;
        if (!(this || _global).navigating) return l = !1, a || (a = (this || _global).input.value, l = !0, this.removeMessage(), u.truncate((this || _global).tree)), c = [], h = document.createDocumentFragment(), 0 < (a = a.trim().toLowerCase()).length ? (d = e ? u.startsWith : u.includes, u.each((this || _global).options, function (e, t) {
          var n,
            i,
            o,
            r,
            s = (this || _global).items[t.idx];
          d(t.textContent.trim().toLowerCase(), a) && !t.disabled ? (c.push({
            text: t.textContent,
            value: t.value
          }), l && (g(s, h, (this || _global).customOption), u.removeClass(s, "excluded"), !(this || _global).customOption) && (n = a, o = (t = t).textContent, n = new RegExp(n, "ig"), r = n.exec(o)) && (t.innerHTML = "", (i = document.createElement("span")).classList.add("selectr-match"), i.textContent = r[0], t.appendChild(document.createTextNode(o.substring(0, r.index))), t.appendChild(i), t.appendChild(document.createTextNode(o.substring(n.lastIndex))))) : l && u.addClass(s, "excluded");
        }, this || _global), l && (h.childElementCount ? (e = (this || _global).items[(this || _global).navIndex], t = h.querySelector(".selectr-option:not(.excluded)"), (this || _global).noResults = !1, u.removeClass(e, "active"), (this || _global).navIndex = t.idx, u.addClass(t, "active")) : (this || _global).config.taggable || ((this || _global).noResults = !0, this.setMessage((this || _global).config.messages.noResults)), (this || _global).tree.appendChild(h))) : o.call(this || _global), c;
      }, t.prototype.toggle = function () {
        (this || _global).disabled || ((this || _global).opened ? this.close() : this.open());
      }, t.prototype.open = function () {
        var e = this || _global;
        if (!(this || _global).options.length) return !1;
        (this || _global).opened || this.emit("selectr.open"), (this || _global).opened = !0, (this || _global).mobileDevice || (this || _global).config.nativeDropdown ? (u.addClass((this || _global).container, "native-open"), (this || _global).config.data && u.each((this || _global).options, function (e, t) {
          (this || _global).el.add(t);
        }, this || _global)) : (u.addClass((this || _global).container, "open"), o.call(this || _global), this.invert(), (this || _global).tree.scrollTop = 0, u.removeClass((this || _global).container, "notice"), (this || _global).selected.setAttribute("aria-expanded", !0), (this || _global).tree.setAttribute("aria-hidden", !1), (this || _global).tree.setAttribute("aria-expanded", !0), (this || _global).config.searchable && !(this || _global).config.taggable && setTimeout(function () {
          e.input.focus(), e.input.tabIndex = 0;
        }, 10));
      }, t.prototype.close = function () {
        var e;
        (this || _global).opened && this.emit("selectr.close"), (this || _global).opened = !1, (this || _global).navigating = !1, (this || _global).mobileDevice || (this || _global).config.nativeDropdown ? u.removeClass((this || _global).container, "native-open") : (e = u.hasClass((this || _global).container, "notice"), (this || _global).config.searchable && !e && ((this || _global).input.blur(), (this || _global).input.tabIndex = -1, (this || _global).searching = !1), e && (u.removeClass((this || _global).container, "notice"), (this || _global).notice.textContent = ""), u.removeClass((this || _global).container, "open"), u.removeClass((this || _global).container, "native-open"), (this || _global).selected.setAttribute("aria-expanded", !1), (this || _global).tree.setAttribute("aria-hidden", !0), (this || _global).tree.setAttribute("aria-expanded", !1), u.truncate((this || _global).tree), s.call(this || _global));
      }, t.prototype.enable = function () {
        (this || _global).disabled = !1, (this || _global).el.disabled = !1, (this || _global).selected.tabIndex = (this || _global).originalIndex, (this || _global).el.multiple && u.each((this || _global).tags, function (e, t) {
          t.lastElementChild.tabIndex = 0;
        }), u.removeClass((this || _global).container, "selectr-disabled");
      }, t.prototype.disable = function (e) {
        e || ((this || _global).el.disabled = !0), (this || _global).selected.tabIndex = -1, (this || _global).el.multiple && u.each((this || _global).tags, function (e, t) {
          t.lastElementChild.tabIndex = -1;
        }), (this || _global).disabled = !0, u.addClass((this || _global).container, "selectr-disabled");
      }, t.prototype.reset = function () {
        (this || _global).disabled || (this.clear(), this.setSelected(!0), u.each((this || _global).defaultSelected, function (e, t) {
          this.select(t);
        }, this || _global), this.emit("selectr.reset"));
      }, t.prototype.clear = function (e, t) {
        var n;
        (this || _global).el.multiple ? (this || _global).selectedIndexes.length && (n = (this || _global).selectedIndexes.slice(), t ? this.deselect(n.slice(-1)[0]) : u.each(n, function (e, t) {
          this.deselect(t);
        }, this || _global)) : -1 < (this || _global).selectedIndex && this.deselect((this || _global).selectedIndex, e), this.emit("selectr.clear");
      }, t.prototype.serialise = function (e) {
        var i = [];
        return u.each((this || _global).options, function (e, t) {
          var n = {
            value: t.value,
            text: t.textContent
          };
          t.selected && (n.selected = !0), t.disabled && (n.disabled = !0), i[e] = n;
        }), e ? JSON.stringify(i) : i;
      }, t.prototype.serialize = function (e) {
        return this.serialise(e);
      }, t.prototype.setPlaceholder = function (e) {
        e = e || (this || _global).config.placeholder || (this || _global).el.getAttribute("placeholder"), (this || _global).options.length || (e = (this || _global).config.messages.noOptions), (this || _global).placeEl.innerHTML = e;
      }, t.prototype.paginate = function () {
        var n;
        if ((this || _global).items.length) return (n = this || _global).pages = (this || _global).items.map(function (e, t) {
          return t % n.config.pagination == 0 ? n.items.slice(t, t + n.config.pagination) : null;
        }).filter(function (e) {
          return e;
        }), (this || _global).pages;
      }, t.prototype.setMessage = function (e, t) {
        t && this.close(), u.addClass((this || _global).container, "notice"), (this || _global).notice.textContent = e;
      }, t.prototype.removeMessage = function () {
        u.removeClass((this || _global).container, "notice"), (this || _global).notice.innerHTML = "";
      }, t.prototype.invert = function () {
        var e = u.rect((this || _global).selected),
          t = (this || _global).tree.parentNode.offsetHeight,
          n = window.innerHeight;
        e.top + e.height + t > n ? (u.addClass((this || _global).container, "inverted"), (this || _global).isInverted = !0) : (u.removeClass((this || _global).container, "inverted"), (this || _global).isInverted = !1), (this || _global).optsRect = u.rect((this || _global).tree);
      }, t.prototype.getOptionByIndex = function (e) {
        return (this || _global).options[e];
      }, t.prototype.getOptionByValue = function (e) {
        for (var t = !1, n = 0, i = (this || _global).options.length; n < i; n++) if ((this || _global).options[n].value.trim() === e.toString().trim()) {
          t = (this || _global).options[n];
          break;
        }
        return t;
      }, e.exports = t;
    },
    4188: function (e, t, n) {
      "use strict";

      n.d(t, {
        EX: function () {
          return o;
        },
        WF: function () {
          return r;
        },
        oW: function () {
          return s;
        },
        qD: function () {
          return i;
        }
      });
      var i = document.body,
        o = 10485760,
        r = 20000,
        s = 2147483648;
    },
    2602: function (e, t, n) {
      "use strict";

      n.d(t, {
        w: function () {
          return i;
        }
      });
      var u = n(9791);
      function i(n, e, i) {
        var t,
          o = 3 < arguments.length && void 0 !== arguments[3] && arguments[3],
          r = "function" == typeof (a = n).getRootNode ? a.getRootNode() : window,
          s = {},
          a = n.getBoundingClientRect(),
          l = e.getBoundingClientRect(),
          c = document.createElement("div");
        function h() {
          if (c && c.parentNode) {
            for (var e in c.parentNode.removeChild(c), s) t = e, Object.prototype.hasOwnProperty.call(s, t) && ((t = s[e]) && (0, u.removeEventListener)(r, e, t), delete s[e]);
            "function" == typeof i && i(n);
          }
          var t;
        }
        function d(e) {
          (e = e.target) === c || (0, u.isChildOf)(e, c) || h();
        }
        return c.className = "jsoneditor-anchor", c.style.position = "absolute", c.style.left = a.left - l.left + "px", c.style.top = a.top - l.top + "px", c.style.width = a.width - 2 + "px", c.style.height = a.height - 2 + "px", c.style.boxSizing = "border-box", e.appendChild(c), s.mousedown = (0, u.addEventListener)(r, "mousedown", d), s.mousewheel = (0, u.addEventListener)(r, "mousewheel", d), o && (t = null, c.onmouseover = function () {
          clearTimeout(t), t = null;
        }, c.onmouseout = function () {
          t = t || setTimeout(h, 200);
        }), c.destroy = h, c;
      }
    },
    7923: function (e) {
      e.exports = "data:application/javascript;base64,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";
    },
    7907: function (e, t, n) {
      "use strict";

      n.d(t, {
        Iu: function () {
          return h;
        },
        cC: function () {
          return c;
        },
        m0: function () {
          return l;
        }
      });
      n(4987);
      var r = {
          en: {
            array: "Array",
            auto: "Auto",
            appendText: "Append",
            appendTitle: "Append a new field with type 'auto' after this field (Ctrl+Shift+Ins)",
            appendSubmenuTitle: "Select the type of the field to be appended",
            appendTitleAuto: "Append a new field with type 'auto' (Ctrl+Shift+Ins)",
            ascending: "Ascending",
            ascendingTitle: "Sort the childs of this ${type} in ascending order",
            actionsMenu: "Click to open the actions menu (Ctrl+M)",
            cannotParseFieldError: "Cannot parse field into JSON",
            cannotParseValueError: "Cannot parse value into JSON",
            collapseAll: "Collapse all fields",
            compactTitle: "Compact JSON data, remove all whitespaces (Ctrl+Shift+I)",
            descending: "Descending",
            descendingTitle: "Sort the childs of this ${type} in descending order",
            drag: "Drag to move this field (Alt+Shift+Arrows)",
            duplicateKey: "duplicate key",
            duplicateText: "Duplicate",
            duplicateTitle: "Duplicate selected fields (Ctrl+D)",
            duplicateField: "Duplicate this field (Ctrl+D)",
            duplicateFieldError: "Duplicate field name",
            empty: "empty",
            expandAll: "Expand all fields",
            expandTitle: "Click to expand/collapse this field (Ctrl+E). \nCtrl+Click to expand/collapse including all childs.",
            formatTitle: "Format JSON data, with proper indentation and line feeds (Ctrl+I)",
            insert: "Insert",
            insertTitle: "Insert a new field with type 'auto' before this field (Ctrl+Ins)",
            insertSub: "Select the type of the field to be inserted",
            object: "Object",
            ok: "Ok",
            redo: "Redo (Ctrl+Shift+Z)",
            removeText: "Remove",
            removeTitle: "Remove selected fields (Ctrl+Del)",
            removeField: "Remove this field (Ctrl+Del)",
            repairTitle: "Repair JSON: fix quotes and escape characters, remove comments and JSONP notation, turn JavaScript objects into JSON.",
            searchTitle: "Search fields and values",
            searchNextResultTitle: "Next result (Enter)",
            searchPreviousResultTitle: "Previous result (Shift + Enter)",
            selectNode: "Select a node...",
            showAll: "show all",
            showMore: "show more",
            showMoreStatus: "displaying ${visibleChilds} of ${totalChilds} items.",
            sort: "Sort",
            sortTitle: "Sort the childs of this ${type}",
            sortTitleShort: "Sort contents",
            sortFieldLabel: "Field:",
            sortDirectionLabel: "Direction:",
            sortFieldTitle: "Select the nested field by which to sort the array or object",
            sortAscending: "Ascending",
            sortAscendingTitle: "Sort the selected field in ascending order",
            sortDescending: "Descending",
            sortDescendingTitle: "Sort the selected field in descending order",
            string: "String",
            transform: "Transform",
            transformTitle: "Filter, sort, or transform the childs of this ${type}",
            transformTitleShort: "Filter, sort, or transform contents",
            extract: "Extract",
            extractTitle: "Extract this ${type}",
            transformQueryTitle: "Enter a JMESPath query",
            transformWizardLabel: "Wizard",
            transformWizardFilter: "Filter",
            transformWizardSortBy: "Sort by",
            transformWizardSelectFields: "Select fields",
            transformQueryLabel: "Query",
            transformPreviewLabel: "Preview",
            type: "Type",
            typeTitle: "Change the type of this field",
            openUrl: "Ctrl+Click or Ctrl+Enter to open url in new window",
            undo: "Undo last action (Ctrl+Z)",
            validationCannotMove: "Cannot move a field into a child of itself",
            autoType: "Field type \"auto\". The field type is automatically determined from the value and can be a string, number, boolean, or null.",
            objectType: "Field type \"object\". An object contains an unordered set of key/value pairs.",
            arrayType: "Field type \"array\". An array contains an ordered collection of values.",
            stringType: "Field type \"string\". Field type is not determined from the value, but always returned as string.",
            modeEditorTitle: "Switch Editor Mode",
            modeCodeText: "Code",
            modeCodeTitle: "Switch to code highlighter",
            modeFormText: "Form",
            modeFormTitle: "Switch to form editor",
            modeTextText: "Text",
            modeTextTitle: "Switch to plain text editor",
            modeTreeText: "Tree",
            modeTreeTitle: "Switch to tree editor",
            modeViewText: "View",
            modeViewTitle: "Switch to tree view",
            modePreviewText: "Preview",
            modePreviewTitle: "Switch to preview mode",
            examples: "Examples",
            default: "Default",
            containsInvalidProperties: "Contains invalid properties",
            containsInvalidItems: "Contains invalid items"
          },
          es: {
            array: "Matriz",
            auto: "Auto",
            appendText: "Agregar",
            appendTitle: "Agregue un nuevo campo con el tipo 'auto' despu\xE9s de este campo (Ctrl + Shift + Ins)",
            appendSubmenuTitle: "Seleccione el tipo de campo que se agregar\xE1",
            appendTitleAuto: "Agregue un nuevo campo con el tipo 'auto' (Ctrl + Shift + Ins)",
            ascending: "Ascendente",
            ascendingTitle: "Ordene los elementos secundarios de este ${type} en orden ascendente",
            actionsMenu: "Haga clic para abrir el men\xFA de acciones (Ctrl + M)",
            cannotParseFieldError: "No se puede parsear el campo en JSON",
            cannotParseValueError: "No se puede parsear el valor en JSON",
            collapseAll: "Contraer todos los campos",
            compactTitle: "Compactar datos JSON, eliminar todos los espacios en blanco (Ctrl + Shift + I)",
            descending: "Descendente",
            descendingTitle: "Ordene los hijos de este ${type} en orden descendente",
            drag: "Arrastre para mover este campo (Alt + May\xFAs + Flechas)",
            duplicateKey: "llave duplicada",
            duplicateText: "Duplicar",
            duplicateTitle: "Duplicar campos seleccionados (Ctrl + D)",
            duplicateField: "Duplicar este campo (Ctrl + D)",
            duplicateFieldError: "Nombre de campo duplicado",
            empty: "vacio",
            expandAll: "Expandir todos los campos",
            expandTitle: "Haga clic para expandir/contraer este campo (Ctrl + E). \n  Ctrl+Clic para expandir/contraer incluyendo todos los ni\xF1os.",
            formatTitle: "Formatee los datos JSON, con la sangr\xEDa y los avances de l\xEDnea adecuados (Ctrl + I)",
            insert: "Insertar",
            insertTitle: "Inserte un nuevo campo con el tipo 'auto' antes de este campo (Ctrl + Ins)",
            insertSub: "Seleccione el tipo de campo a insertar",
            object: "Objeto",
            ok: "Ok",
            redo: "Rehacer (Ctrl+May\xFAs+Z)",
            removeText: "Eliminar",
            removeTitle: "Eliminar campos seleccionados (Ctrl+Supr)",
            removeField: "Eliminar este campo (Ctrl+Supr)",
            repairTitle: "Reparar JSON: corrija comillas y caracteres de escape, elimine comentarios y notaci\xF3n JSONP, convierta objetos JavaScript en JSON.",
            searchTitle: "Campos de b\xFAsqueda y valores",
            searchNextResultTitle: "Siguiente resultado (Entrar)",
            searchPreviousResultTitle: "Resultado anterior (Shift + Enter)",
            selectNode: "Seleccione un nodo...",
            showAll: "mostrar todo",
            showMore: "mostrar m\xE1s",
            showMoreStatus: "mostrando ${visibleChilds} de ${totalChilds} elementos.",
            sort: "Ordenar",
            sortTitle: "Ordene los hijos de este ${type}",
            sortTitleShort: "Ordenar contenidos",
            sortFieldLabel: "Campo:",
            sortDirectionLabel: "Direcci\xF3n:",
            sortFieldTitle: "Seleccione el campo anidado por el cual ordenar la matriz u objeto",
            sortAscending: "Ascendente",
            sortAscendingTitle: "Ordenar el campo seleccionado en orden ascendente",
            sortDescending: "Descendente",
            sortDescendingTitle: "Ordenar por el campo seleccionado, en orden descendente",
            string: "Texto",
            transform: "Transformar",
            transformTitle: "Filtrar, ordenar o transformar los hijos de este ${type}",
            transformTitleShort: "Filtrar, ordenar o transformar contenidos",
            extract: "Extraer",
            extractTitle: "Extrae este ${type}",
            transformQueryTitle: "Ingrese una consulta JMESPath",
            transformWizardLabel: "Wizard",
            transformWizardFilter: "Filtro",
            transformWizardSortBy: "Ordenar por",
            transformWizardSelectFields: "Seleccione un campo",
            transformQueryLabel: "Consulta",
            transformPreviewLabel: "Vista Previa",
            type: "Tipo",
            typeTitle: "Cambiar el tipo de campo",
            openUrl: "Ctrl+Click o Ctrl+Enter para abrir la URL en una nueva ventana",
            undo: "Deshacer la \xFAltima acci\xF3n (Ctrl+Z)",
            validationCannotMove: "No se puede mover un campo a un hijo de s\xED mismo.",
            autoType: "Field type \"auto\". The field type is automatically determined from the value and can be a string, number, boolean, or null.",
            objectType: "Tipo de campo \"objeto\".  Un objeto contiene un conjunto desordenado de pares clave/valor.",
            arrayType: "Tipo de campo \"matriz\".  Una matriz contiene una colecci\xF3n ordenada de valores.",
            stringType: "Tipo de campo \"cadena\".  El tipo de campo no se determina a partir del valor,  pero siempre se devuelve como una cadena.",
            modeEditorTitle: "Cambiar modo de editor",
            modeCodeText: "Codigo",
            modeCodeTitle: "Cambiar al resaltador de c\xF3digo",
            modeFormText: "Formulario",
            modeFormTitle: "Cambiar al editor de formularios",
            modeTextText: "Texto",
            modeTextTitle: "Cambiar al editor de texto sin formato",
            modeTreeText: "Arbol",
            modeTreeTitle: "Cambiar al editor de \xE1rbol",
            modeViewText: "Vista",
            modeViewTitle: "Cambiar a la vista de \xE1rbol",
            modePreviewText: "Vista Previa",
            modePreviewTitle: "Cambiar al modo de vista previa",
            examples: "Ejemplos",
            default: "Predeterminado",
            containsInvalidProperties: "Contiene propiedades no validas",
            containsInvalidItems: "Contiene items no validos"
          },
          "zh-CN": {
            array: "\u6570\u7EC4",
            auto: "\u81EA\u52A8",
            appendText: "\u8FFD\u52A0",
            appendTitle: "\u5728\u6B64\u5B57\u6BB5\u540E\u8FFD\u52A0\u4E00\u4E2A\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
            appendSubmenuTitle: "\u9009\u62E9\u8981\u8FFD\u52A0\u7684\u5B57\u6BB5\u7C7B\u578B",
            appendTitleAuto: "\u8FFD\u52A0\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
            ascending: "\u5347\u5E8F",
            ascendingTitle: "\u5347\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
            actionsMenu: "\u70B9\u51FB\u6253\u5F00\u52A8\u4F5C\u83DC\u5355(Ctrl+M)",
            cannotParseFieldError: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u89E3\u6790\u4E3AJSON",
            cannotParseValueError: "\u65E0\u6CD5\u5C06\u503C\u89E3\u6790\u4E3AJSON",
            collapseAll: "\u7F29\u8FDB\u6240\u6709\u5B57\u6BB5",
            compactTitle: "\u538B\u7F29JSON\u6570\u636E\uFF0C\u5220\u9664\u6240\u6709\u7A7A\u683C (Ctrl+Shift+I)",
            descending: "\u964D\u5E8F",
            descendingTitle: "\u964D\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
            drag: "\u62D6\u62FD\u79FB\u52A8\u8BE5\u8282\u70B9(Alt+Shift+Arrows)",
            duplicateKey: "\u91CD\u590D\u952E",
            duplicateText: "\u590D\u5236",
            duplicateTitle: "\u590D\u5236\u9009\u4E2D\u5B57\u6BB5(Ctrl+D)",
            duplicateField: "\u590D\u5236\u8BE5\u5B57\u6BB5(Ctrl+D)",
            duplicateFieldError: "\u91CD\u590D\u7684\u5B57\u6BB5\u540D\u79F0",
            empty: "\u6E05\u7A7A",
            expandAll: "\u5C55\u5F00\u6240\u6709\u5B57\u6BB5",
            expandTitle: "\u70B9\u51FB \u5C55\u5F00/\u6536\u7F29 \u8BE5\u5B57\u6BB5(Ctrl+E). \nCtrl+Click \u5C55\u5F00/\u6536\u7F29 \u5305\u542B\u6240\u6709\u5B50\u8282\u70B9.",
            formatTitle: "\u4F7F\u7528\u9002\u5F53\u7684\u7F29\u8FDB\u548C\u6362\u884C\u7B26\u683C\u5F0F\u5316JSON\u6570\u636E (Ctrl+I)",
            insert: "\u63D2\u5165",
            insertTitle: "\u5728\u6B64\u5B57\u6BB5\u524D\u63D2\u5165\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Ins)",
            insertSub: "\u9009\u62E9\u8981\u63D2\u5165\u7684\u5B57\u6BB5\u7C7B\u578B",
            object: "\u5BF9\u8C61",
            ok: "Ok",
            redo: "\u91CD\u505A (Ctrl+Shift+Z)",
            removeText: "\u79FB\u9664",
            removeTitle: "\u79FB\u9664\u9009\u4E2D\u5B57\u6BB5 (Ctrl+Del)",
            removeField: "\u79FB\u9664\u8BE5\u5B57\u6BB5 (Ctrl+Del)",
            repairTitle: "\u4FEE\u590DJSON\uFF1A\u4FEE\u590D\u5F15\u53F7\u548C\u8F6C\u4E49\u7B26\uFF0C\u5220\u9664\u6CE8\u91CA\u548CJSONP\u8868\u793A\u6CD5\uFF0C\u5C06JavaScript\u5BF9\u8C61\u8F6C\u6362\u4E3AJSON\u3002",
            selectNode: "\u9009\u62E9\u4E00\u4E2A\u8282\u70B9...",
            showAll: "\u5C55\u793A\u5168\u90E8",
            showMore: "\u5C55\u793A\u66F4\u591A",
            showMoreStatus: "\u663E\u793A${totalChilds}\u7684${visibleChilds}\u9879\u76EE.",
            sort: "\u6392\u5E8F",
            sortTitle: "\u6392\u5E8F${type}\u7684\u5B50\u8282\u70B9",
            sortTitleShort: "\u5185\u5BB9\u6392\u5E8F",
            sortFieldLabel: "\u5B57\u6BB5\uFF1A",
            sortDirectionLabel: "\u65B9\u5411\uFF1A",
            sortFieldTitle: "\u9009\u62E9\u7528\u4E8E\u5BF9\u6570\u7EC4\u6216\u5BF9\u8C61\u6392\u5E8F\u7684\u5D4C\u5957\u5B57\u6BB5",
            sortAscending: "\u5347\u5E8F\u6392\u5E8F",
            sortAscendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u5347\u5E8F\u6392\u5E8F",
            sortDescending: "\u964D\u5E8F\u6392\u5E8F",
            sortDescendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u964D\u5E8F\u6392\u5E8F",
            string: "\u5B57\u7B26\u4E32",
            transform: "\u53D8\u6362",
            transformTitle: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362${type}\u7684\u5B50\u8282\u70B9",
            transformTitleShort: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362\u5185\u5BB9",
            extract: "\u63D0\u53D6",
            extractTitle: "\u63D0\u53D6\u8FD9\u4E2A ${type}",
            transformQueryTitle: "\u8F93\u5165JMESPath\u67E5\u8BE2",
            transformWizardLabel: "\u5411\u5BFC",
            transformWizardFilter: "\u7B5B\u9009",
            transformWizardSortBy: "\u6392\u5E8F",
            transformWizardSelectFields: "\u9009\u62E9\u5B57\u6BB5",
            transformQueryLabel: "\u67E5\u8BE2",
            transformPreviewLabel: "\u9884\u89C8",
            type: "\u7C7B\u578B",
            typeTitle: "\u66F4\u6539\u5B57\u6BB5\u7C7B\u578B",
            openUrl: "Ctrl+Click \u6216\u8005 Ctrl+Enter \u5728\u65B0\u7A97\u53E3\u6253\u5F00\u94FE\u63A5",
            undo: "\u64A4\u9500\u4E0A\u6B21\u52A8\u4F5C (Ctrl+Z)",
            validationCannotMove: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u79FB\u5165\u5176\u5B50\u8282\u70B9",
            autoType: "\u5B57\u6BB5\u7C7B\u578B \"auto\". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A \u53EF\u4EE5\u4E3A string\uFF0Cnumber\uFF0Cboolean\uFF0C\u6216\u8005 null.",
            objectType: "\u5B57\u6BB5\u7C7B\u578B \"object\". \u5BF9\u8C61\u5305\u542B\u4E00\u7EC4\u65E0\u5E8F\u7684\u952E/\u503C\u5BF9.",
            arrayType: "\u5B57\u6BB5\u7C7B\u578B \"array\". \u6570\u7EC4\u5305\u542B\u503C\u7684\u6709\u5E8F\u96C6\u5408.",
            stringType: "\u5B57\u6BB5\u7C7B\u578B \"string\". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A\uFF0C\u4F46\u59CB\u7EC8\u4F5C\u4E3A\u5B57\u7B26\u4E32\u8FD4\u56DE.",
            modeCodeText: "\u4EE3\u7801",
            modeCodeTitle: "\u5207\u6362\u81F3\u4EE3\u7801\u9AD8\u4EAE",
            modeFormText: "\u8868\u5355",
            modeFormTitle: "\u5207\u6362\u81F3\u8868\u5355\u7F16\u8F91",
            modeTextText: "\u6587\u672C",
            modeTextTitle: "\u5207\u6362\u81F3\u6587\u672C\u7F16\u8F91",
            modeTreeText: "\u6811",
            modeTreeTitle: "\u5207\u6362\u81F3\u6811\u7F16\u8F91",
            modeViewText: "\u89C6\u56FE",
            modeViewTitle: "\u5207\u6362\u81F3\u6811\u89C6\u56FE",
            modePreviewText: "\u9884\u89C8",
            modePreviewTitle: "\u5207\u6362\u81F3\u9884\u89C8\u6A21\u5F0F",
            examples: "\u4F8B\u5B50",
            default: "\u7F3A\u7701",
            containsInvalidProperties: "\u5305\u542B\u65E0\u6548\u7684\u5C5E\u6027",
            containsInvalidItems: "\u5305\u542B\u65E0\u6548\u9879\u76EE"
          },
          "pt-BR": {
            array: "Lista",
            auto: "Automatico",
            appendText: "Adicionar",
            appendTitle: "Adicionar novo campo com tipo 'auto' depois deste campo (Ctrl+Shift+Ins)",
            appendSubmenuTitle: "Selecione o tipo do campo a ser adicionado",
            appendTitleAuto: "Adicionar novo campo com tipo 'auto' (Ctrl+Shift+Ins)",
            ascending: "Ascendente",
            ascendingTitle: "Organizar filhor do tipo ${type} em crescente",
            actionsMenu: "Clique para abrir o menu de a\xE7\xF5es (Ctrl+M)",
            cannotParseFieldError: "N\xE3o \xE9 poss\xEDvel analisar o campo no JSON",
            cannotParseValueError: "N\xE3o \xE9 poss\xEDvel analisar o valor em JSON",
            collapseAll: "Fechar todos campos",
            compactTitle: "Dados JSON compactos, remova todos os espa\xE7os em branco (Ctrl+Shift+I)",
            descending: "Descendente",
            descendingTitle: "Organizar o filhos do tipo ${type} em decrescente",
            duplicateKey: "chave duplicada",
            drag: "Arraste para mover este campo (Alt+Shift+Arrows)",
            duplicateText: "Duplicar",
            duplicateTitle: "Duplicar campos selecionados (Ctrl+D)",
            duplicateField: "Duplicar este campo (Ctrl+D)",
            duplicateFieldError: "Nome do campo duplicado",
            empty: "vazio",
            expandAll: "Expandir todos campos",
            expandTitle: "Clique para expandir/encolher este campo (Ctrl+E). \nCtrl+Click para expandir/encolher incluindo todos os filhos.",
            formatTitle: "Formate dados JSON, com recuo e feeds de linha adequados (Ctrl+I)",
            insert: "Inserir",
            insertTitle: "Inserir um novo campo do tipo 'auto' antes deste campo (Ctrl+Ins)",
            insertSub: "Selecionar o tipo de campo a ser inserido",
            object: "Objeto",
            ok: "Ok",
            redo: "Refazer (Ctrl+Shift+Z)",
            removeText: "Remover",
            removeTitle: "Remover campos selecionados (Ctrl+Del)",
            removeField: "Remover este campo (Ctrl+Del)",
            repairTitle: "Repare JSON: corrija aspas e caracteres de escape, remova coment\xE1rios e nota\xE7\xE3o JSONP, transforme objetos JavaScript em JSON.",
            selectNode: "Selecione um n\xF3dulo...",
            showAll: "mostrar todos",
            showMore: "mostrar mais",
            showMoreStatus: "exibindo ${visibleChilds} de ${totalChilds} itens.",
            sort: "Organizar",
            sortTitle: "Organizar os filhos deste ${type}",
            sortTitleShort: "Organizar os filhos",
            sortFieldLabel: "Campo:",
            sortDirectionLabel: "Dire\xE7\xE3o:",
            sortFieldTitle: "Selecione um campo filho pelo qual ordenar o array ou objeto",
            sortAscending: "Ascendente",
            sortAscendingTitle: "Ordenar o campo selecionado por ordem ascendente",
            sortDescending: "Descendente",
            sortDescendingTitle: "Ordenar o campo selecionado por ordem descendente",
            string: "Texto",
            transform: "Transformar",
            transformTitle: "Filtrar, ordenar ou transformar os filhos deste ${type}",
            transformTitleShort: "Filtrar, ordenar ou transformar conte\xFAdos",
            transformQueryTitle: "Insira uma express\xE3o JMESPath",
            transformWizardLabel: "Assistente",
            transformWizardFilter: "Filtro",
            transformWizardSortBy: "Ordenar por",
            transformWizardSelectFields: "Selecionar campos",
            transformQueryLabel: "Express\xE3o",
            transformPreviewLabel: "Visualizar",
            type: "Tipo",
            typeTitle: "Mudar o tipo deste campo",
            openUrl: "Ctrl+Click ou Ctrl+Enter para abrir link em nova janela",
            undo: "Desfazer \xFAltimo a\xE7\xE3o (Ctrl+Z)",
            validationCannotMove: "N\xE3o pode mover um campo como filho dele mesmo",
            autoType: "Campo do tipo \"auto\". O tipo do campo \xE9 determinao automaticamente a partir do seu valor e pode ser texto, n\xFAmero, verdade/falso ou nulo.",
            objectType: "Campo do tipo \"objeto\". Um objeto cont\xE9m uma lista de pares com chave e valor.",
            arrayType: "Campo do tipo \"lista\". Uma lista contem uma cole\xE7\xE3o de valores ordenados.",
            stringType: "Campo do tipo \"string\". Campo do tipo nao \xE9 determinado atrav\xE9s do seu valor, mas sempre retornara um texto.",
            examples: "Exemplos",
            default: "Revelia",
            containsInvalidProperties: "Cont\xE9m propriedades inv\xE1lidas",
            containsInvalidItems: "Cont\xE9m itens inv\xE1lidos"
          },
          tr: {
            array: "Dizin",
            auto: "Otomatik",
            appendText: "Ekle",
            appendTitle: "Bu alan\u0131n alt\u0131na 'otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
            appendSubmenuTitle: "Eklenecek alan\u0131n tipini se\xE7",
            appendTitleAuto: "'Otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
            ascending: "Artan",
            ascendingTitle: "${type}'\u0131n alt tiplerini artan d\xFCzende s\u0131rala",
            actionsMenu: "Aksiyon men\xFCs\xFCn\xFC a\xE7mak i\xE7in t\u0131klay\u0131n (Ctrl+M)",
            collapseAll: "T\xFCm alanlar\u0131 kapat",
            descending: "Azalan",
            descendingTitle: "${type}'\u0131n alt tiplerini azalan d\xFCzende s\u0131rala",
            drag: "Bu alan\u0131 ta\u015F\u0131mak i\xE7in s\xFCr\xFCkleyin (Alt+Shift+Arrows)",
            duplicateKey: "Var olan anahtar",
            duplicateText: "A\u015Fa\u011F\u0131ya kopyala",
            duplicateTitle: "Se\xE7ili alanlardan bir daha olu\u015Ftur (Ctrl+D)",
            duplicateField: "Bu alandan bir daha olu\u015Ftur (Ctrl+D)",
            duplicateFieldError: "Duplicate field name",
            cannotParseFieldError: "Alan JSON'a ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
            cannotParseValueError: "JSON'a de\u011Fer ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
            empty: "bo\u015F",
            expandAll: "T\xFCm alanlar\u0131 a\xE7",
            expandTitle: "Bu alan\u0131 a\xE7mak/kapatmak i\xE7in t\u0131kla (Ctrl+E). \nAlt alanlarda dahil t\xFCm alanlar\u0131 a\xE7mak i\xE7in Ctrl+Click ",
            insert: "Ekle",
            insertTitle: "Bu alan\u0131n \xFCst\xFCne 'otomatik' tipinde yeni bir alan ekle (Ctrl+Ins)",
            insertSub: "Araya eklenecek alan\u0131n tipini se\xE7",
            object: "Nesne",
            ok: "Tamam",
            redo: "Yeniden yap (Ctrl+Shift+Z)",
            removeText: "Kald\u0131r",
            removeTitle: "Se\xE7ilen alanlar\u0131 kald\u0131r (Ctrl+Del)",
            removeField: "Bu alan\u0131 kald\u0131r (Ctrl+Del)",
            selectNode: "Bir nesne se\xE7...",
            showAll: "t\xFCm\xFCn\xFC g\xF6ster",
            showMore: "daha fazla g\xF6ster",
            showMoreStatus: "${totalChilds} alan\u0131n ${visibleChilds} alt alanlar\u0131 g\xF6steriliyor",
            sort: "S\u0131rala",
            sortTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 s\u0131rala",
            sortTitleShort: "\u0130\xE7erikleri s\u0131rala",
            sortFieldLabel: "Alan:",
            sortDirectionLabel: "Y\xF6n:",
            sortFieldTitle: "Diziyi veya nesneyi s\u0131ralamak i\xE7in i\xE7 i\xE7e ge\xE7mi\u015F alan\u0131 se\xE7in",
            sortAscending: "Artan",
            sortAscendingTitle: "Se\xE7ili alan\u0131 artan d\xFCzende s\u0131rala",
            sortDescending: "Azalan",
            sortDescendingTitle: "Se\xE7ili alan\u0131 azalan d\xFCzende s\u0131rala",
            string: "Karakter Dizisi",
            transform: "D\xF6n\xFC\u015Ft\xFCr",
            transformTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 filtrele, s\u0131rala veya d\xF6n\xFC\u015Ft\xFCr",
            transformTitleShort: "\u0130\xE7erikleri filterele, s\u0131rala veya d\xF6n\xFC\u015Ft\xFCr",
            transformQueryTitle: "JMESPath sorgusu gir",
            transformWizardLabel: "Sihirbaz",
            transformWizardFilter: "Filtre",
            transformWizardSortBy: "S\u0131rala",
            transformWizardSelectFields: "Alanlar\u0131 se\xE7",
            transformQueryLabel: "Sorgu",
            transformPreviewLabel: "\xD6nizleme",
            type: "Tip",
            typeTitle: "Bu alan\u0131n tipini de\u011Fi\u015Ftir",
            openUrl: "URL'i yeni bir pencerede a\xE7mak i\xE7in Ctrl+Click veya Ctrl+Enter",
            undo: "Son de\u011Fi\u015Fikli\u011Fi geri al (Ctrl+Z)",
            validationCannotMove: "Alt alan olarak ta\u015F\u0131nam\u0131yor",
            autoType: "Alan tipi \"otomatik\". Alan t\xFCr\xFC otomatik olarak de\u011Ferden belirlenirve bir dize, say\u0131, boolean veya null olabilir.",
            objectType: "Alan tipi \"nesne\". Bir nesne, s\u0131ralanmam\u0131\u015F bir anahtar / de\u011Fer \xE7ifti k\xFCmesi i\xE7erir.",
            arrayType: "Alan tipi \"dizi\". Bir dizi, d\xFCzenli de\u011Ferler koleksiyonu i\xE7erir.",
            stringType: "Alan tipi \"karakter dizisi\". Alan t\xFCr\xFC de\u011Ferden belirlenmez,ancak her zaman karakter dizisi olarak d\xF6nd\xFCr\xFCl\xFCr.",
            modeCodeText: "Kod",
            modeCodeTitle: "Kod vurgulay\u0131c\u0131ya ge\xE7",
            modeFormText: "Form",
            modeFormTitle: "Form d\xFCzenleyiciye ge\xE7",
            modeTextText: "Metin",
            modeTextTitle: "D\xFCz metin d\xFCzenleyiciye ge\xE7",
            modeTreeText: "A\u011Fa\xE7",
            modeTreeTitle: "A\u011Fa\xE7 d\xFCzenleyiciye ge\xE7",
            modeViewText: "G\xF6r\xFCn\xFCm",
            modeViewTitle: "A\u011Fa\xE7 g\xF6r\xFCn\xFCm\xFCne ge\xE7",
            examples: "\xD6rnekler",
            default: "Varsay\u0131lan",
            containsInvalidProperties: "Ge\xE7ersiz \xF6zellikler i\xE7eriyor",
            containsInvalidItems: "Ge\xE7ersiz \xF6\u011Feler i\xE7eriyor"
          },
          ja: {
            array: "\u914D\u5217",
            auto: "\u30AA\u30FC\u30C8",
            appendText: "\u8FFD\u52A0",
            appendTitle: "\u6B21\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\"\u30AA\u30FC\u30C8\"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)",
            appendSubmenuTitle: "\u8FFD\u52A0\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            appendTitleAuto: "\"\u30AA\u30FC\u30C8\"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)",
            ascending: "\u6607\u9806",
            ascendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u6607\u9806\u306B\u4E26\u3079\u66FF\u3048",
            actionsMenu: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30A2\u30AF\u30B7\u30E7\u30F3\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F (Ctrl+M)",
            collapseAll: "\u3059\u3079\u3066\u3092\u6298\u308A\u305F\u305F\u3080",
            descending: "\u964D\u9806",
            descendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u964D\u9806\u306B\u4E26\u3079\u66FF\u3048",
            drag: "\u30C9\u30E9\u30C3\u30B0\u3057\u3066\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u79FB\u52D5 (Alt+Shift+Arrows)",
            duplicateKey: "\u8907\u88FD\u30AD\u30FC",
            duplicateText: "\u8907\u88FD",
            duplicateTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
            duplicateField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
            duplicateFieldError: "\u30D5\u30A3\u30FC\u30EB\u30C9\u540D\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059",
            cannotParseFieldError: "JSON\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
            cannotParseValueError: "JSON\u306E\u5024\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
            empty: "\u7A7A",
            expandAll: "\u3059\u3079\u3066\u3092\u5C55\u958B",
            expandTitle: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080 (Ctrl+E). \nCtrl+Click \u3067\u3059\u3079\u3066\u306E\u5B50\u8981\u7D20\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080",
            insert: "\u633F\u5165",
            insertTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u524D\u306B\u65B0\u3057\u3044\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u633F\u5165 (Ctrl+Ins)",
            insertSub: "\u633F\u5165\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E",
            object: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8",
            ok: "\u5B9F\u884C",
            redo: "\u3084\u308A\u76F4\u3059 (Ctrl+Shift+Z)",
            removeText: "\u524A\u9664",
            removeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
            removeField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
            selectNode: "\u30CE\u30FC\u30C9\u3092\u9078\u629E...",
            showAll: "\u3059\u3079\u3066\u3092\u8868\u793A",
            showMore: "\u3082\u3063\u3068\u898B\u308B",
            showMoreStatus: "${totalChilds}\u500B\u306E\u30A2\u30A4\u30C6\u30E0\u306E\u3046\u3061 ${visibleChilds}\u500B\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059\u3002",
            sort: "\u4E26\u3079\u66FF\u3048",
            sortTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u4E26\u3079\u66FF\u3048",
            sortTitleShort: "\u4E26\u3079\u66FF\u3048",
            sortFieldLabel: "\u30D5\u30A3\u30FC\u30EB\u30C9:",
            sortDirectionLabel: "\u9806\u5E8F:",
            sortFieldTitle: "\u914D\u5217\u307E\u305F\u306F\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3092\u4E26\u3073\u66FF\u3048\u308B\u305F\u3081\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
            sortAscending: "\u6607\u9806",
            sortAscendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u6607\u9806\u306B\u4E26\u3073\u66FF\u3048",
            sortDescending: "\u964D\u9806",
            sortDescendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u964D\u9806\u306B\u4E26\u3073\u66FF\u3048",
            string: "\u6587\u5B57\u5217",
            transform: "\u5909\u63DB",
            transformTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
            transformTitleShort: "\u5185\u5BB9\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
            extract: "\u62BD\u51FA",
            extractTitle: "${type}\u3092\u62BD\u51FA",
            transformQueryTitle: "JMESPath\u30AF\u30A8\u30EA\u3092\u5165\u529B",
            transformWizardLabel: "\u30A6\u30A3\u30B6\u30FC\u30C9",
            transformWizardFilter: "\u30D5\u30A3\u30EB\u30BF\u30FC",
            transformWizardSortBy: "\u4E26\u3073\u66FF\u3048",
            transformWizardSelectFields: "\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
            transformQueryLabel: "\u30AF\u30A8\u30EA",
            transformPreviewLabel: "\u30D7\u30EC\u30D3\u30E5\u30FC",
            type: "\u578B",
            typeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u5909\u66F4",
            openUrl: "Ctrl+Click \u307E\u305F\u306F Ctrl+Enter \u3067 \u65B0\u898F\u30A6\u30A3\u30F3\u30C9\u30A6\u3067URL\u3092\u958B\u304F",
            undo: "\u5143\u306B\u623B\u3059 (Ctrl+Z)",
            validationCannotMove: "\u5B50\u8981\u7D20\u306B\u79FB\u52D5\u3067\u304D\u307E\u305B\u3093 ",
            autoType: "\u30AA\u30FC\u30C8\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u306F\u5024\u304B\u3089\u81EA\u52D5\u7684\u306B\u6C7A\u5B9A\u3055\u308C\u307E\u3059\u3002 (\u6587\u5B57\u5217\u30FB\u6570\u5024\u30FB\u30D6\u30FC\u30EB\u30FBnull)",
            objectType: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\uFF1A \u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u306A\u3044\u30AD\u30FC\u3068\u5024\u306E\u30DA\u30A2\u7D44\u307F\u5408\u308F\u305B\u3067\u3059\u3002",
            arrayType: "\u914D\u5217\uFF1A \u914D\u5217\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u308B\u5024\u306E\u96C6\u5408\u4F53\u3067\u3059\u3002",
            stringType: "\u6587\u5B57\u5217\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u578B\u306F\u5024\u304B\u3089\u6C7A\u5B9A\u3055\u308C\u307E\u305B\u3093\u304C\u3001\u5E38\u306B\u6587\u5B57\u5217\u3068\u3057\u3066\u8FD4\u3055\u308C\u307E\u3059\u3002",
            modeCodeText: "\u30B3\u30FC\u30C9\u30E2\u30FC\u30C9",
            modeCodeTitle: "\u30CF\u30A4\u30E9\u30A4\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
            modeFormText: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9",
            modeFormTitle: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
            modeTextText: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9",
            modeTextTitle: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
            modeTreeText: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9",
            modeTreeTitle: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
            modeViewText: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9",
            modeViewTitle: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
            modePreviewText: "\u30D7\u30EC\u30D3\u30E5\u30FC",
            modePreviewTitle: "\u30D7\u30EC\u30D3\u30E5\u30FC\u306B\u5207\u308A\u66FF\u3048",
            examples: "\u4F8B",
            default: "\u30C7\u30D5\u30A9\u30EB\u30C8",
            containsInvalidProperties: "\u7121\u52B9\u306A\u30D7\u30ED\u30D1\u30C6\u30A3\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059",
            containsInvalidItems: "\u7121\u52B9\u306A\u30A2\u30A4\u30C6\u30E0\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059"
          },
          "fr-FR": {
            array: "Liste",
            auto: "Auto",
            appendText: "Ajouter",
            appendTitle: "Ajouter un champ de type 'auto' apr\xE8s ce champ (Ctrl+Shift+Ins)",
            appendSubmenuTitle: "S\xE9lectionner le type du champ \xE0 ajouter",
            appendTitleAuto: "Ajouter un champ de type 'auto' (Ctrl+Shift+Ins)",
            ascending: "Ascendant",
            ascendingTitle: "Trier les enfants de ce ${type} par ordre ascendant",
            actionsMenu: "Ouvrir le menu des actions (Ctrl+M)",
            collapseAll: "Regrouper",
            descending: "Descendant",
            descendingTitle: "Trier les enfants de ce ${type} par ordre descendant",
            drag: "D\xE9placer (Alt+Shift+Arrows)",
            duplicateKey: "Dupliquer la cl\xE9",
            duplicateText: "Dupliquer",
            duplicateTitle: "Dupliquer les champs s\xE9lectionn\xE9s (Ctrl+D)",
            duplicateField: "Dupliquer ce champ (Ctrl+D)",
            duplicateFieldError: "Dupliquer le nom de champ",
            cannotParseFieldError: "Champ impossible \xE0 parser en JSON",
            cannotParseValueError: "Valeur impossible \xE0 parser en JSON",
            empty: "vide",
            expandAll: "\xC9tendre",
            expandTitle: "\xC9tendre/regrouper ce champ (Ctrl+E). \nCtrl+Click pour \xE9tendre/regrouper avec tous les champs.",
            insert: "Ins\xE9rer",
            insertTitle: "Ins\xE9rer un champ de type 'auto' avant ce champ (Ctrl+Ins)",
            insertSub: "S\xE9lectionner le type de champ \xE0 ins\xE9rer",
            object: "Objet",
            ok: "Ok",
            redo: "Rejouer (Ctrl+Shift+Z)",
            removeText: "Supprimer",
            removeTitle: "Supprimer les champs s\xE9lectionn\xE9s (Ctrl+Del)",
            removeField: "Supprimer ce champ (Ctrl+Del)",
            searchTitle: "Rechercher champs et valeurs",
            searchNextResultTitle: "R\xE9sultat suivant (Enter)",
            searchPreviousResultTitle: "R\xE9sultat pr\xE9c\xE9dent (Shift + Enter)",
            selectNode: "S\xE9lectionner un n\u0153ud...",
            showAll: "voir tout",
            showMore: "voir plus",
            showMoreStatus: "${visibleChilds} \xE9l\xE9ments affich\xE9s de ${totalChilds}.",
            sort: "Trier",
            sortTitle: "Trier les champs de ce ${type}",
            sortTitleShort: "Trier",
            sortFieldLabel: "Champ:",
            sortDirectionLabel: "Direction:",
            sortFieldTitle: "S\xE9lectionner les champs permettant de trier les listes et objet",
            sortAscending: "Ascendant",
            sortAscendingTitle: "Trier les champs s\xE9lectionn\xE9s par ordre ascendant",
            sortDescending: "Descendant",
            sortDescendingTitle: "Trier les champs s\xE9lectionn\xE9s par ordre descendant",
            string: "Cha\xEEne",
            transform: "Transformer",
            transformTitle: "Filtrer, trier, or transformer les enfants de ce ${type}",
            transformTitleShort: "Filtrer, trier ou transformer le contenu",
            extract: "Extraire",
            extractTitle: "Extraire ce ${type}",
            transformQueryTitle: "Saisir une requ\xEAte JMESPath",
            transformWizardLabel: "Assistant",
            transformWizardFilter: "Filtrer",
            transformWizardSortBy: "Trier par",
            transformWizardSelectFields: "S\xE9lectionner les champs",
            transformQueryLabel: "Requ\xEAte",
            transformPreviewLabel: "Pr\xE9visualisation",
            type: "Type",
            typeTitle: "Changer le type de ce champ",
            openUrl: "Ctrl+Click ou Ctrl+Enter pour ouvrir l'url dans une autre fen\xEAtre",
            undo: "Annuler la derni\xE8re action (Ctrl+Z)",
            validationCannotMove: "Cannot move a field into a child of itself",
            autoType: "Champe de type \"auto\". Ce type de champ est automatiquement d\xE9termin\xE9 en fonction de la valeur et peut \xEAtre de type \"cha\xEEne\", \"nombre\", \"bool\xE9en\" ou null.",
            objectType: "Champ de type \"objet\". Un objet contient un ensemble non ordonn\xE9 de paires cl\xE9/valeur.",
            arrayType: "Champ de type \"liste\". Une liste contient une collection ordonn\xE9e de valeurs.",
            stringType: "Champ de type \"cha\xEEne\". Ce type de champ n'est pas d\xE9termin\xE9 en fonction de la valeur, mais retourne syst\xE9matiquement une cha\xEEne de caract\xE8res.",
            modeEditorTitle: "Changer mode d'\xE9dition",
            modeCodeText: "Code",
            modeCodeTitle: "Activer surlignage code",
            modeFormText: "Formulaire",
            modeFormTitle: "Activer formulaire",
            modeTextText: "Texte",
            modeTextTitle: "Activer \xE9diteur texte",
            modeTreeText: "Arbre",
            modeTreeTitle: "Activer \xE9diteur arbre",
            modeViewText: "Lecture seule",
            modeViewTitle: "Activer vue arbre",
            modePreviewText: "Pr\xE9visualisation",
            modePreviewTitle: "Activer mode pr\xE9visualiser",
            examples: "Exemples",
            default: "D\xE9faut",
            containsInvalidProperties: "Contient des propri\xE9t\xE9s non valides",
            containsInvalidItems: "Contient des \xE9l\xE9ments invalides"
          },
          de: {
            array: "Auflistung",
            auto: "Auto",
            appendText: "anh\xE4ngen",
            appendTitle: "F\xFCgen Sie nach diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Umschalt+Ein)",
            appendSubmenuTitle: "W\xE4hlen Sie den Typ des neuen Feldes",
            appendTitleAuto: "Ein neues Feld vom Typ 'auto' hinzuf\xFCgen (Strg+Umschalt+Ein)",
            ascending: "Aufsteigend",
            ascendingTitle: "Sortieren Sie die Elemente dieses ${type} in aufsteigender Reihenfolge",
            actionsMenu: "Klicken Sie zum \xD6ffnen des Aktionsmen\xFCs (Strg+M)",
            cannotParseFieldError: "Feld kann nicht in JSON geparst werden",
            cannotParseValueError: "Wert kann nicht in JSON geparst werden",
            collapseAll: "Alle Felder zuklappen",
            compactTitle: "JSON-Daten verdichten, alle Leerzeichen entfernen (Strg+Umschalt+\\)",
            descending: "Absteigend",
            descendingTitle: "Sortieren Sie die Elemente dieses ${type} in absteigender Reihenfolge",
            drag: "Ziehen, um dieses Feld zu verschieben (Alt+Umschalt+Pfeile)",
            duplicateKey: "Doppelter Schl\xFCssel",
            duplicateText: "Duplikat",
            duplicateTitle: "Ausgew\xE4hlte Felder duplizieren (Strg+D)",
            duplicateField: "Dieses Feld duplizieren (Strg+D)",
            duplicateFieldError: "Doppelter Feldname",
            empty: "leer",
            expandAll: "Alle Felder anzeigen",
            expandTitle: "Klicken Sie, um dieses Feld zu erweitern/zu kollabieren (Strg+E). \nStrg+Klicken Sie, um dieses Feld einschlie\xDFlich aller Elemente zu erweitern/zu kollabieren.",
            formatTitle: "JSON-Daten mit korrekter Einr\xFCckung und Zeilenvorsch\xFCben formatieren (Strg+\\)",
            insert: "einf\xFCgen",
            insertTitle: "F\xFCgen Sie vor diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Einfg)",
            insertSub: "W\xE4hlen Sie den Typ des neuen Feldes",
            object: "Objekt",
            ok: "Ok",
            redo: "Wiederholen (Strg+Umschalt+Z)",
            removeText: "entfernen",
            removeTitle: "Ausgew\xE4hlte Felder entfernen (Strg+Entf)",
            removeField: "Dieses Feld entfernen (Strg+Entf)",
            repairTitle: "JSON reparieren: Anf\xFChrungszeichen und Escape-Zeichen korrigieren, Kommentare und JSONP-Notation entfernen, JavaScript-Objekte in JSON umwandeln.",
            searchTitle: "Suchfelder und Werte",
            searchNextResultTitle: "N\xE4chstes Ergebnis (Enter)",
            searchPreviousResultTitle: "Vorheriges Ergebnis (Umschalt + Eingabe)",
            selectNode: "W\xE4hlen Sie einen Knoten aus...",
            showAll: "alle anzeigen",
            showMore: "mehr anzeigen",
            showMoreStatus: "Anzeige von ${visibleChilds} von ${totalChilds}-Elementen.",
            sort: "Sortieren",
            sortTitle: "Sortieren Sie die Elemente dieses ${type}",
            sortTitleShort: "Inhalt sortieren",
            sortFieldLabel: "Feld:",
            sortDirectionLabel: "Richtung:",
            sortFieldTitle: "W\xE4hlen Sie das verschachtelte Feld, nach dem das Array oder Objekt sortiert werden soll.",
            sortAscending: "Aufsteigend",
            sortAscendingTitle: "Sortieren Sie das ausgew\xE4hlte Feld in aufsteigender Reihenfolge",
            sortDescending: "Absteigend",
            sortDescendingTitle: "Sortieren Sie das ausgew\xE4hlte Feld in absteigender Reihenfolge",
            string: "Zeichenfolge",
            transform: "Verwandeln",
            transformTitle: "Die Elemente dieses ${type} filtern, sortieren oder transformieren",
            transformTitleShort: "Inhalte filtern, sortieren oder transformieren",
            extract: "Auszug",
            extractTitle: "Extrahieren Sie diesen ${type}",
            transformQueryTitle: "Eine JMESPath-Abfrage eingeben",
            transformWizardLabel: "Zauberer",
            transformWizardFilter: "Filter",
            transformWizardSortBy: "Sortieren nach",
            transformWizardSelectFields: "Felder ausw\xE4hlen",
            transformQueryLabel: "Anfrage",
            transformPreviewLabel: "Vorschau",
            type: "Geben Sie  ein.",
            typeTitle: "\xC4ndern Sie den Typ dieses Feldes",
            openUrl: "Strg+Klicken oder Strg+Eingabe, um die URL in einem neuen Fenster zu \xF6ffnen",
            undo: "Letzte Aktion r\xFCckg\xE4ngig machen (Strg+Z)",
            validationCannotMove: "Kann ein Feld nicht in ein Kind seiner selbst verschieben",
            autoType: "Feldtyp \"auto\". Der Feldtyp wird automatisch aus dem Wert bestimmt und kann ein String, eine Zahl, boolesch oder null sein.",
            objectType: "Feldtyp \"Objekt\". Ein Objekt enth\xE4lt eine ungeordnete Menge von Schl\xFCssel/Wert-Paaren.",
            arrayType: "Feldtyp \"Array\". Ein Array enth\xE4lt eine geordnete Sammlung von Werten.",
            stringType: "Feldtyp \"Zeichenfolge\". Der Feldtyp wird nicht aus dem Wert bestimmt, sondern immer als Zeichenfolge zur\xFCckgegeben.",
            modeEditorTitle: "Editor-Modus umschalten",
            modeCodeText: "Code",
            modeCodeTitle: "Umschalten auf Code-Highlighter",
            modeFormText: "Formular",
            modeFormTitle: "Zum Formular-Editor wechseln",
            modeTextText: "Text",
            modeTextTitle: "Zum Editor f\xFCr einfachen Text wechseln",
            modeTreeText: "Baum",
            modeTreeTitle: "Zum Baum-Editor wechseln",
            modeViewText: "Siehe",
            modeViewTitle: "Zur Baumansicht wechseln",
            modePreviewText: "Vorschau",
            modePreviewTitle: "In den Vorschau-Modus wechseln",
            examples: "Beispiele",
            default: "Standardm\xE4\xDFig",
            containsInvalidProperties: "Enth\xE4lt ung\xFCltige Eigenschaften",
            containsInvalidItems: "Enth\xE4lt ung\xFCltige Elemente"
          },
          ru: {
            array: "\u041C\u0430\u0441\u0441\u0438\u0432",
            auto: "\u0410\u0432\u0442\u043E",
            appendText: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
            appendTitle: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u043E\u0441\u043B\u0435 \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Ctrl+Shift+Ins)",
            appendSubmenuTitle: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
            appendTitleAuto: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' (Ctrl+Shift+Ins)",
            ascending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
            ascendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
            actionsMenu: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F \u043C\u0435\u043D\u044E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 (Ctrl+M)",
            cannotParseFieldError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 \u0432 JSON",
            cannotParseValueError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 JSON",
            collapseAll: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
            compactTitle: "\u041C\u0438\u043D\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F JSON (Ctrl+Shift+I)",
            descending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
            descendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
            drag: "\u041F\u043E\u0442\u044F\u043D\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Alt+Shift+Arrows)",
            duplicateKey: "\u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0438\u0439\u0441\u044F \u043A\u043B\u044E\u0447",
            duplicateText: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
            duplicateTitle: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 (Ctrl+D)",
            duplicateField: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+D)",
            duplicateFieldError: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u044F",
            empty: "\u043F\u0443\u0441\u0442\u043E\u0439",
            expandAll: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
            expandTitle: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u043F\u043E\u043B\u044F (Ctrl+E)\n\u0438\u043B\u0438 Ctrl+Click \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u0432\u0441\u0435\u0445 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432.",
            formatTitle: "\u0424\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 JSON (Ctrl+I)",
            insert: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
            insertTitle: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u0435\u0440\u0435\u0434 \u044D\u0442\u0438\u043C \u043F\u043E\u043B\u0435\u043C (Ctrl+Ins)",
            insertSub: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438",
            object: "\u041E\u0431\u044A\u0435\u043A\u0442",
            ok: "\u041E\u041A",
            redo: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C (Ctrl+Shift+Z)",
            removeText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
            removeTitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044F (Ctrl+Del)",
            removeField: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+Del)",
            repairTitle: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 JSON: \u0438\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u043A\u0430\u0432\u044B\u0447\u043A\u0438 \u0438 escape-\u0441\u0438\u043C\u0432\u043E\u043B\u044B, \u0443\u0434\u0430\u043B\u0438\u0442\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u0438 \u043D\u043E\u0442\u0430\u0446\u0438\u044E JSONP, \u043C\u043E\u0434\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B JavaScript \u0432 JSON.",
            searchTitle: "\u041F\u043E\u0438\u0441\u043A",
            searchNextResultTitle: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Enter)",
            searchPreviousResultTitle: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Shift + Enter)",
            selectNode: "\u0412\u044B\u0431\u043E\u0440 \u0443\u0437\u043B\u0430...",
            showAll: "\u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435",
            showMore: "\u0431\u043E\u043B\u044C\u0448\u0435",
            showMoreStatus: "${visibleChilds} \u0438\u0437 ${totalChilds}",
            sort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
            sortTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432 \u0442\u0438\u043F\u0430 ${type}",
            sortTitleShort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E",
            sortFieldLabel: "\u041F\u043E\u043B\u0435:",
            sortDirectionLabel: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435:",
            sortFieldTitle: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \u0434\u043B\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",
            sortAscending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
            sortAscendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
            sortDescending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
            sortDescendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
            string: "\u0421\u0442\u0440\u043E\u043A\u0430",
            transform: "\u041C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
            transformTitle: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0430 ${type}",
            transformTitleShort: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445",
            extract: "\u0418\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435",
            extractTitle: "\u0418\u0437\u0432\u043B\u0435\u0447\u044C \u0442\u0438\u043F ${type}",
            transformQueryTitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 JMESpath \u0437\u0430\u043F\u0440\u043E\u0441",
            transformWizardLabel: "\u041C\u0430\u0441\u0442\u0435\u0440",
            transformWizardFilter: "\u0424\u0438\u043B\u044C\u0442\u0440",
            transformWizardSortBy: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
            transformWizardSelectFields: "\u041F\u043E\u043B\u044F",
            transformQueryLabel: "\u0417\u0430\u043F\u0440\u043E\u0441",
            transformPreviewLabel: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
            type: "\u0422\u0438\u043F",
            typeTitle: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0438\u043F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F",
            openUrl: "Ctrl+Click \u0438\u043B\u0438 Ctrl+Enter \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F url \u0432 \u043D\u043E\u0432\u043E\u043C \u043E\u043A\u043D\u0435",
            undo: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C (Ctrl+Z)",
            validationCannotMove: "\u041F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u043E \u0432 \u043F\u043E\u0442\u043E\u043C\u043A\u0430",
            autoType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u043E\u0439, \u0447\u0438\u0441\u043B\u043E\u043C, \u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 null.",
            objectType: "\u041E\u0431\u044A\u0435\u043A\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u043F\u0430\u0440 \u043A\u043B\u044E\u0447/\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435.",
            arrayType: "\u041C\u0430\u0441\u0441\u0438\u0432 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439.",
            stringType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0438\u0437 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F, \u043D\u043E \u0432\u0441\u0435\u0433\u0434\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442\u0441\u044F \u043A\u0430\u043A \u0441\u0442\u0440\u043E\u043A\u0430.",
            modeEditorTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0440\u0435\u0436\u0438\u043C\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430",
            modeCodeText: "\u041A\u043E\u0434",
            modeCodeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u043A\u043E\u0434\u0430",
            modeFormText: "\u0424\u043E\u0440\u043C\u0430",
            modeFormTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0444\u043E\u0440\u043C\u044B",
            modeTextText: "\u0422\u0435\u043A\u0441\u0442",
            modeTextTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0442\u0435\u043A\u0441\u0442\u0430",
            modeTreeText: "\u0414\u0435\u0440\u0435\u0432\u043E",
            modeTreeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
            modeViewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0434\u0435\u0440\u0435\u0432\u0430",
            modeViewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
            modePreviewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
            modePreviewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430",
            examples: "\u041F\u0440\u0438\u043C\u0435\u0440\u044B",
            default: "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
            containsInvalidProperties: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430",
            containsInvalidItems: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B"
          },
          ko: {
            array: "\uBC30\uC5F4",
            auto: "\uC790\uB3D9",
            appendText: "\uCD94\uAC00",
            appendTitle: "\uC120\uD0DD\uD55C \uC694\uC18C \uC544\uB798\uC5D0 \"\uC790\uB3D9\" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)",
            appendSubmenuTitle: "\uCD94\uAC00\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
            appendTitleAuto: "\"\uC790\uB3D9\" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)",
            ascending: "\uC624\uB984\uCC28\uC21C",
            ascendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C \uC815\uB82C\uD569\uB2C8\uB2E4.",
            actionsMenu: "\uBA54\uB274 \uC5F4\uAE30 (Ctrl + M)",
            cannotParseFieldError: "JSON\uC758 \uC694\uC18C\uB97C \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
            cannotParseValueError: "JSON\uC758 \uAC12\uC744 \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
            collapseAll: "\uBAA8\uB450 \uC811\uAE30",
            compactTitle: "\uBAA8\uB4E0 \uACF5\uBC31\uC744 \uC81C\uAC70\uD558\uC5EC JSON \uB370\uC774\uD130\uB97C \uC791\uAC8C \uB9CC\uB4ED\uB2C8\uB2E4. (Ctrl + Shift + I)",
            descending: "\uB0B4\uB9BC\uCC28\uC21C",
            descendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C",
            drag: "\uB4DC\uB798\uADF8\uD558\uC5EC \uC694\uC18C\uB97C \uC774\uB3D9\uD569\uB2C8\uB2E4. (Alt + Shift + Arrows)",
            duplicateKey: "\uBCF5\uC81C\uD0A4",
            duplicateText: "\uBCF5\uC81C",
            duplicateTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
            duplicateField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
            duplicateFieldError: "\uC694\uC18C \uC774\uB984\uC774 \uC911\uBCF5\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
            empty: "\uBE44\uC5B4\uC788\uC74C",
            expandAll: "\uBAA8\uB450 \uC5F4\uAE30",
            expandTitle: "\uD074\uB9AD\uD558\uC5EC \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4. (Ctrl + E) \nCtrl + Click\uC73C\uB85C \uBAA8\uB4E0 \uD558\uC704 \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4.",
            formatTitle: "\uC801\uC808\uD55C \uB4E4\uC5EC\uC4F0\uAE30 \uBC0F \uC904\uBC14\uAFC8\uC73C\uB85C JSON \uB370\uC774\uD130\uB97C \uC815\uD615\uD654\uD569\uB2C8\uB2E4. (Ctrl + I)",
            insert: "\uC0BD\uC785",
            insertTitle: "\uC120\uD0DD\uD55C \uC694\uC18C \uC704\uC5D0 \uC0C8\uC694\uC18C\uB97C \uC0BD\uC785\uD569\uB2C8\uB2E4. (Ctrl + Ins)",
            insertSub: "\uC0BD\uC785\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
            object: "\uAC1D\uCCB4",
            ok: "\uD655\uC778",
            redo: "\uB2E4\uC2DC \uC2E4\uD589 (Ctrl + Shift + Z)",
            removeText: "\uC0AD\uC81C",
            removeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
            removeField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
            repairTitle: "JSON \uAD50\uC815: JSON \uB0B4\uC758 \uC8FC\uC11D\uACFC JSONP \uD45C\uAE30\uBC95\uC744 \uC9C0\uC6B0\uACE0 \uB530\uC634\uD45C\uC640 \uC774\uC2A4\uCF00\uC774\uD504 \uBB38\uC790\uB97C \uC218\uC815\uD569\uB2C8\uB2E4.",
            searchTitle: "\uC694\uC18C \uB610\uB294 \uAC12 \uCC3E\uAE30",
            searchNextResultTitle: "\uB2E4\uC74C\uC73C\uB85C \uCC3E\uAE30 (Enter)",
            searchPreviousResultTitle: "\uC774\uC804\uC73C\uB85C \uCC3E\uAE30 (Shift + Enter)",
            selectNode: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694...",
            showAll: "\uBAA8\uB450\uBCF4\uAE30",
            showMore: "\uB354\uBCF4\uAE30",
            showMoreStatus: "${totalChilds} \uAC1C\uC758 \uD56D\uBAA9 \uC911 ${visibleChilds} \uAC1C\uB97C \uD45C\uC2DC\uD569\uB2C8\uB2E4.",
            sort: "\uC815\uB82C",
            sortTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC815\uB82C\uD569\uB2C8\uB2E4.",
            sortTitleShort: "\uC815\uB82C",
            sortFieldLabel: "\uC694\uC18C:",
            sortDirectionLabel: "\uC21C\uC11C:",
            sortFieldTitle: "\uBC30\uC5F4\uC774\uB098 \uAC1D\uCCB4\uB97C \uC815\uB82C\uD558\uB294 \uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
            sortAscending: "\uC624\uB984\uCC28\uC21C",
            sortAscendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
            sortDescending: "\uB0B4\uB9BC\uCC28\uC21C",
            sortDescendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
            string: "\uBB38\uC790",
            transform: "\uBCC0\uD658",
            transformTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
            transformTitleShort: "\uB0B4\uC6A9\uC744 \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
            extract: "\uCD94\uCD9C",
            extractTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uAC12\uC744 \uCD5C\uC0C1\uC704\uC5D0 \uC704\uCE58\uC2DC\uD0B5\uB2C8\uB2E4.",
            transformQueryTitle: "JMESPath \uCFFC\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
            transformWizardLabel: "\uB9C8\uBC95\uC0AC",
            transformWizardFilter: "\uD544\uD130",
            transformWizardSortBy: "\uC815\uB82C",
            transformWizardSelectFields: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
            transformQueryLabel: "\uCFFC\uB9AC",
            transformPreviewLabel: "\uBBF8\uB9AC\uBCF4\uAE30",
            type: "\uC720\uD615",
            typeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uC758 \uC720\uD615\uC744 \uBCC0\uACBD\uD569\uB2C8\uB2E4.",
            openUrl: "Ctrl + Click \uB610\uB294 Ctrl + Enter\uB85C \uC0C8 \uCC3D\uC5D0\uC11C URL \uC5F4\uAE30",
            undo: "\uC2E4\uD589 \uCDE8\uC18C (Ctrl + Z)",
            validationCannotMove: "\uD558\uC704 \uC694\uC18C\uB85C \uC774\uB3D9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
            autoType: "\uC790\uB3D9: \uC694\uC18C\uC758 \uD615\uC2DD\uC774 \uAC12\uC758 \uC720\uD615\uC73C\uB85C \uACB0\uC815\uB429\uB2C8\uB2E4. \uBB38\uC790, \uC22B\uC790, \uBD80\uC6B8, \uB610\uB294 null\uB9CC \uD5C8\uC6A9\uB429\uB2C8\uB2E4.",
            objectType: "\uAC1D\uCCB4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB418\uC9C0 \uC54A\uC740 \uC774\uB984/\uAC12 \uC30D\uC73C\uB85C \uC774\uB8E8\uC5B4\uC9C4 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
            arrayType: "\uBC30\uC5F4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB41C \uAC12\uC758 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
            stringType: "\uBB38\uC790: \uC694\uC18C\uC758 \uC720\uD615\uC774 \uAC12\uC5D0\uC11C \uACB0\uC815\uB418\uC9C0 \uC54A\uC9C0\uB9CC \uD56D\uC0C1 \uBB38\uC790\uB85C \uBC18\uD658\uB429\uB2C8\uB2E4.",
            modeEditorTitle: "\uD3B8\uC9D1\uAE30 \uC720\uD615 \uBCC0\uACBD",
            modeCodeText: "\uCF54\uB4DC",
            modeCodeTitle: "\uD615\uC2DD \uAD50\uC815\uC744 \uB3C4\uC640\uC8FC\uB294 \uAE30\uB2A5\uC774 \uD3EC\uD568\uB41C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
            modeFormText: "\uC785\uB825 \uC591\uC2DD",
            modeFormTitle: "\uC815\uD574\uC9C4 \uC694\uC18C\uC5D0 \uAC12\uC744 \uC785\uB825\uD558\uB294 \uD3B8\uC9D1\uAE30",
            modeTextText: "\uBB38\uC790",
            modeTextTitle: "\uB2E8\uC21C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
            modeTreeText: "\uD2B8\uB9AC",
            modeTreeTitle: "\uD2B8\uB9AC \uAD6C\uC870\uB85C \uD45C\uC2DC\uB418\uB294 \uD3B8\uC9D1\uAE30",
            modeViewText: "\uBCF4\uAE30",
            modeViewTitle: "\uC77D\uAE30\uC804\uC6A9 \uD2B8\uB9AC \uAD6C\uC870\uB85C JSON\uC744 \uD45C\uC2DC",
            modePreviewText: "\uBBF8\uB9AC\uBCF4\uAE30",
            modePreviewTitle: "\uC77D\uAE30\uC804\uC6A9 \uBB38\uC790\uB85C JSON\uC744 \uD45C\uC2DC",
            examples: "\uC608\uC81C",
            default: "\uAE30\uBCF8\uAC12",
            containsInvalidProperties: "\uC798\uBABB\uB41C \uC18D\uC131\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4.",
            containsInvalidItems: "\uC798\uBABB\uB41C \uD56D\uBAA9\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4"
          }
        },
        i = Object.keys(r),
        s = "en",
        o = "undefined" != typeof navigator ? navigator.language || navigator.userLanguage : void 0,
        a = i.find(function (e) {
          return e === o;
        }) || s;
      function l(t) {
        var e;
        t && ((e = i.find(function (e) {
          return e === t;
        })) ? a = e : console.error("Language not found"));
      }
      function c(e) {
        if (e) for (var t in e) !function (t) {
          i.find(function (e) {
            return e === t;
          }) || i.push(t), r[t] = Object.assign({}, r[s], r[t], e[t]);
        }(t);
      }
      function h(e, t, n) {
        var i = r[n = n || a][e] || r[s][e] || e;
        if (t) for (var o in t) i = i.replace("${" + o + "}", t[o]);
        return i;
      }
    },
    6056: function (e, t, n) {
      "use strict";

      n.d(t, {
        J: function () {
          return r;
        },
        r: function () {
          return o;
        }
      });
      var t = n(5156),
        i = n.n(t),
        s = n(9791);
      function o(e, t) {
        var n,
          i = t.sort,
          o = t.filter,
          t = t.projection,
          r = "";
        return o ? (n = "@" !== o.field ? ["0"].concat((0, s.parsePath)("." + o.field)) : ["0"], n = "string" == typeof (0, s.get)(e, n) ? o.value : (0, s.parseString)(o.value), r += "[? " + o.field + " " + o.relation + " `" + JSON.stringify(n) + "`]") : r += Array.isArray(e) ? "[*]" : "@", i && ("desc" === i.direction ? r += " | reverse(sort_by(@, &" + i.field + "))" : r += " | sort_by(@, &" + i.field + ")"), t && ("]" !== r[r.length - 1] && (r += " | [*]"), 1 === t.fields.length ? r += "." + t.fields[0] : 1 < t.fields.length && (r += ".{" + t.fields.map(function (e) {
          var t = e.split(".");
          return t[t.length - 1] + ": " + e;
        }).join(", ") + "}")), r;
      }
      function r(e, t) {
        return i().search(e, t);
      }
    },
    4987: function () {
      function e(e) {
        void 0 === e || "remove" in e || Object.defineProperty(e, "remove", {
          configurable: !0,
          enumerable: !0,
          writable: !0,
          value: function () {
            void 0 !== (this || _global).parentNode && (this || _global).parentNode.removeChild(this || _global);
          }
        });
      }
      "undefined" != typeof Element && (void 0 !== window.Element && e(window.Element.prototype), void 0 !== window.CharacterData && e(window.CharacterData.prototype), void 0 !== window.DocumentType) && e(window.DocumentType.prototype), Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
        value: function (e) {
          for (var t = 0; t < (this || _global).length; t++) {
            var n = (this || _global)[t];
            if (e.call(this || _global, n, t, this || _global)) return t;
          }
          return -1;
        },
        configurable: !0,
        writable: !0
      }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
        value: function (e) {
          e = this.findIndex(e);
          return (this || _global)[e];
        },
        configurable: !0,
        writable: !0
      }), String.prototype.trim || (String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      });
    },
    341: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, {
        previewModeMixins: function () {
          return f;
        }
      });
      var i = n(1262),
        s = n(4188),
        o = n(6436),
        r = n(2474);
      function a(e) {
        return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function l(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== a(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== a(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === a(e) ? e : String(e);
          }(i.key), i);
        }
      }
      var c = function () {
          function i(e, t, n) {
            if (!((this || _global) instanceof i)) throw new TypeError("Cannot call a class as a function");
            (this || _global).onChange = e, (this || _global).calculateItemSize = t || function () {
              return 1;
            }, (this || _global).limit = n, (this || _global).items = [], (this || _global).index = -1;
          }
          var e, t, n;
          return e = i, (t = [{
            key: "add",
            value: function (e) {
              for (; this._calculateHistorySize() > (this || _global).limit && 1 < (this || _global).items.length;) (this || _global).items.shift(), (this || _global).index--;
              (this || _global).items = (this || _global).items.slice(0, (this || _global).index + 1), (this || _global).items.push(e), (this || _global).index++, this.onChange();
            }
          }, {
            key: "_calculateHistorySize",
            value: function () {
              var t = (this || _global).calculateItemSize,
                n = 0;
              return (this || _global).items.forEach(function (e) {
                n += t(e);
              }), n;
            }
          }, {
            key: "undo",
            value: function () {
              if (this.canUndo()) return (this || _global).index--, this.onChange(), (this || _global).items[(this || _global).index];
            }
          }, {
            key: "redo",
            value: function () {
              if (this.canRedo()) return (this || _global).index++, this.onChange(), (this || _global).items[(this || _global).index];
            }
          }, {
            key: "canUndo",
            value: function () {
              return 0 < (this || _global).index;
            }
          }, {
            key: "canRedo",
            value: function () {
              return (this || _global).index < (this || _global).items.length - 1;
            }
          }, {
            key: "clear",
            value: function () {
              (this || _global).items = [], (this || _global).index = -1, this.onChange();
            }
          }]) && l(e.prototype, t), n && l(e, n), Object.defineProperty(e, "prototype", {
            writable: !1
          }), i;
        }(),
        h = n(7907),
        d = n(6056),
        u = n(6617),
        g = n(6210),
        p = n(2558),
        t = n(8458),
        m = n(9791),
        n = t.textModeMixins[0].mixin,
        t = {
          create: function (e) {
            var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
              n = (void 0 === t.statusBar && (t.statusBar = !0), t.mainMenuBar = !1 !== t.mainMenuBar, t.enableSort = !1 !== t.enableSort, t.enableTransform = !1 !== t.enableTransform, t.createQuery = t.createQuery || d.r, t.executeQuery = t.executeQuery || d.J, "number" == typeof ((this || _global).options = t).indentation ? (this || _global).indentation = Number(t.indentation) : (this || _global).indentation = 2, (0, h.cC)((this || _global).options.languages), (0, h.m0)((this || _global).options.language), (this || _global).mode = "preview", this || _global),
              e = ((this || _global).container = e, (this || _global).dom = {}, (this || _global).json = void 0, (this || _global).text = "", (this || _global)._debouncedValidate = (0, m.debounce)((this || _global).validate.bind(this || _global), (this || _global).DEBOUNCE_INTERVAL), (this || _global).width = e.clientWidth, (this || _global).height = e.clientHeight, (this || _global).frame = document.createElement("div"), (this || _global).frame.className = "jsoneditor jsoneditor-mode-preview", (this || _global).frame.onclick = function (e) {
                e.preventDefault();
              }, {
                target: (this || _global).frame,
                onFocus: (this || _global).options.onFocus || null,
                onBlur: (this || _global).options.onBlur || null
              }),
              e = ((this || _global).frameFocusTracker = new r.R(e), (this || _global).content = document.createElement("div"), (this || _global).content.className = "jsoneditor-outer", (this || _global).dom.busy = document.createElement("div"), (this || _global).dom.busy.className = "jsoneditor-busy", (this || _global).dom.busyContent = document.createElement("span"), (this || _global).dom.busyContent.textContent = "busy...", (this || _global).dom.busy.appendChild((this || _global).dom.busyContent), (this || _global).content.appendChild((this || _global).dom.busy), (this || _global).dom.previewContent = document.createElement("pre"), (this || _global).dom.previewContent.className = "jsoneditor-preview", (this || _global).dom.previewText = document.createTextNode(""), (this || _global).dom.previewContent.appendChild((this || _global).dom.previewText), (this || _global).content.appendChild((this || _global).dom.previewContent), (this || _global).options.mainMenuBar && ((0, m.addClassName)((this || _global).content, "has-main-menu-bar"), (this || _global).menu = document.createElement("div"), (this || _global).menu.className = "jsoneditor-menu", (this || _global).frame.appendChild((this || _global).menu), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-format", e.title = (0, h.Iu)("formatTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
                n.executeWithBusyMessage(function () {
                  try {
                    n.format();
                  } catch (e) {
                    n._onError(e);
                  }
                }, "formatting...");
              }, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-compact", e.title = (0, h.Iu)("compactTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
                n.executeWithBusyMessage(function () {
                  try {
                    n.compact();
                  } catch (e) {
                    n._onError(e);
                  }
                }, "compacting...");
              }, (this || _global).options.enableSort && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-sort", e.title = (0, h.Iu)("sortTitleShort"), e.onclick = function () {
                n._showSortModal();
              }, (this || _global).menu.appendChild(e)), (this || _global).options.enableTransform && ((e = document.createElement("button")).type = "button", e.title = (0, h.Iu)("transformTitleShort"), e.className = "jsoneditor-transform", e.onclick = function () {
                n._showTransformModal();
              }, (this || _global).dom.transform = e, (this || _global).menu.appendChild(e)), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-repair", e.title = (0, h.Iu)("repairTitle"), (this || _global).menu.appendChild(e), !(e.onclick = function () {
                void 0 === n.json && n.executeWithBusyMessage(function () {
                  try {
                    n.repair();
                  } catch (e) {
                    n._onError(e);
                  }
                }, "repairing...");
              }) !== (this || _global).options.history && ((this || _global).history = new c(function () {
                n.dom.undo.disabled = !n.history.canUndo(), n.dom.redo.disabled = !n.history.canRedo();
              }, function (e) {
                return 2 * e.text.length;
              }, s.oW), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-undo jsoneditor-separator", e.title = (0, h.Iu)("undo"), e.onclick = function () {
                var e = n.history.undo();
                e && n._applyHistory(e);
              }, (this || _global).menu.appendChild(e), (this || _global).dom.undo = e, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-redo", e.title = (0, h.Iu)("redo"), e.onclick = function () {
                var e = n.history.redo();
                e && n._applyHistory(e);
              }, (this || _global).menu.appendChild(e), (this || _global).dom.redo = e, (this || _global).history.onChange()), (this || _global).options) && (this || _global).options.modes && (this || _global).options.modes.length && ((this || _global).modeSwitcher = new u.x((this || _global).menu, (this || _global).options.modes, (this || _global).options.mode, function (e) {
                try {
                  n.setMode(e), n.modeSwitcher.focus();
                } catch (e) {
                  n._onError(e);
                }
              })), Array.isArray((this || _global).options.showErrorTable) ? (this || _global).options.showErrorTable.includes((this || _global).mode) : !0 === (this || _global).options.showErrorTable);
            (this || _global).errorTable = new o.Q({
              errorTableVisible: e,
              onToggleVisibility: function () {
                n.validate();
              },
              onFocusLine: null,
              onChangeHeight: function (e) {
                e = e + (n.dom.statusBar ? n.dom.statusBar.clientHeight : 0) + 1;
                n.content.style.marginBottom = -e + "px", n.content.style.paddingBottom = e + "px";
              }
            }), (this || _global).frame.appendChild((this || _global).content), (this || _global).frame.appendChild((this || _global).errorTable.getErrorTable()), (this || _global).container.appendChild((this || _global).frame), t.statusBar && ((0, m.addClassName)((this || _global).content, "has-status-bar"), e = document.createElement("div"), ((this || _global).dom.statusBar = e).className = "jsoneditor-statusbar", (this || _global).frame.appendChild(e), (this || _global).dom.fileSizeInfo = document.createElement("span"), (this || _global).dom.fileSizeInfo.className = "jsoneditor-size-info", (this || _global).dom.fileSizeInfo.innerText = "", e.appendChild((this || _global).dom.fileSizeInfo), (this || _global).dom.arrayInfo = document.createElement("span"), (this || _global).dom.arrayInfo.className = "jsoneditor-size-info", (this || _global).dom.arrayInfo.innerText = "", e.appendChild((this || _global).dom.arrayInfo), e.appendChild((this || _global).errorTable.getErrorCounter()), e.appendChild((this || _global).errorTable.getWarningIcon()), e.appendChild((this || _global).errorTable.getErrorIcon())), this._renderPreview(), this.setSchema((this || _global).options.schema, (this || _global).options.schemaRefs);
          },
          _renderPreview: function () {
            var e = this.getText();
            (this || _global).dom.previewText.nodeValue = (0, m.limitCharacters)(e, s.WF), (this || _global).dom.fileSizeInfo && ((this || _global).dom.fileSizeInfo.innerText = "Size: " + (0, m.formatSize)(e.length)), (this || _global).dom.arrayInfo && (Array.isArray((this || _global).json) ? (this || _global).dom.arrayInfo.innerText = "Array: " + (this || _global).json.length + " items" : (this || _global).dom.arrayInfo.innerText = "");
          },
          _onChange: function () {
            if (this._debouncedValidate(), (this || _global).options.onChange) try {
              (this || _global).options.onChange();
            } catch (e) {
              console.error("Error in onChange callback: ", e);
            }
            if ((this || _global).options.onChangeJSON) try {
              (this || _global).options.onChangeJSON(this.get());
            } catch (e) {
              console.error("Error in onChangeJSON callback: ", e);
            }
            if ((this || _global).options.onChangeText) try {
              (this || _global).options.onChangeText(this.getText());
            } catch (e) {
              console.error("Error in onChangeText callback: ", e);
            }
          }
        },
        f = (t._showSortModal = function () {
          var r = this || _global;
          this.executeWithBusyMessage(function () {
            var e = r.options.modalAnchor || s.qD,
              o = r.get();
            r._renderPreview(), (0, g.showSortModal)(e, o, function (i) {
              r.executeWithBusyMessage(function () {
                var e, t, n;
                e = o, t = i, Array.isArray(e) && (n = (0, m.sort)(e, t.path, t.direction), r.sortedBy = t, r._setAndFireOnChange(n)), (0, m.isObject)(e) && (n = (0, m.sortObjectKeys)(e, t.direction), r.sortedBy = t, r._setAndFireOnChange(n));
              }, "sorting...");
            }, r.sortedBy);
          }, "parsing...");
        }, t._showTransformModal = function () {
          var r = this || _global;
          this.executeWithBusyMessage(function () {
            var e = r.options,
              t = e.createQuery,
              n = e.executeQuery,
              i = e.modalAnchor,
              e = e.queryDescription,
              o = r.get();
            r._renderPreview(), (0, p.showTransformModal)({
              container: i || s.qD,
              json: o,
              queryDescription: e,
              createQuery: t,
              executeQuery: n,
              onTransform: function (t) {
                r.executeWithBusyMessage(function () {
                  var e = n(o, t);
                  r._setAndFireOnChange(e);
                }, "transforming...");
              }
            });
          }, "parsing...");
        }, t.destroy = function () {
          (this || _global).frame && (this || _global).container && (this || _global).frame.parentNode === (this || _global).container && (this || _global).container.removeChild((this || _global).frame), (this || _global).modeSwitcher && ((this || _global).modeSwitcher.destroy(), (this || _global).modeSwitcher = null), (this || _global)._debouncedValidate = null, (this || _global).history && ((this || _global).history.clear(), (this || _global).history = null), (this || _global).frameFocusTracker.destroy();
        }, t.compact = function () {
          var e = this.get(),
            t = JSON.stringify(e);
          this._setTextAndFireOnChange(t, e);
        }, t.format = function () {
          var e = this.get(),
            t = JSON.stringify(e, null, (this || _global).indentation);
          this._setTextAndFireOnChange(t, e);
        }, t.repair = function () {
          var e = this.getText();
          try {
            var t = (0, i.K)(e);
            this._setTextAndFireOnChange(t);
          } catch (e) {}
        }, t.focus = function () {
          (this || _global).dom.transform.focus();
        }, t.set = function (e) {
          (this || _global).history && (this || _global).history.clear(), this._set(e);
        }, t.update = function (e) {
          this._set(e);
        }, t._set = function (e) {
          (this || _global).text = void 0, (this || _global).json = e, this._renderPreview(), this._pushHistory(), this._debouncedValidate();
        }, t._setAndFireOnChange = function (e) {
          this._set(e), this._onChange();
        }, t.get = function () {
          var e;
          return void 0 === (this || _global).json && (e = this.getText(), (this || _global).json = (0, m.parse)(e)), (this || _global).json;
        }, t.getText = function () {
          return void 0 === (this || _global).text && ((this || _global).text = JSON.stringify((this || _global).json, null, (this || _global).indentation), !0 === (this || _global).options.escapeUnicode) && ((this || _global).text = (0, m.escapeUnicodeChars)((this || _global).text)), (this || _global).text;
        }, t.setText = function (e) {
          (this || _global).history && (this || _global).history.clear(), this._setText(e);
        }, t.updateText = function (e) {
          this.getText() !== e && this._setText(e);
        }, t._setText = function (e, t) {
          var n;
          !0 === (this || _global).options.escapeUnicode ? (this || _global).text = (0, m.escapeUnicodeChars)(e) : (this || _global).text = e, (this || _global).json = t, this._renderPreview(), void 0 === (this || _global).json ? (n = this || _global).executeWithBusyMessage(function () {
            try {
              n.json = n.get(), n._renderPreview(), n._pushHistory();
            } catch (e) {}
          }, "parsing...") : this._pushHistory(), this._debouncedValidate();
        }, t._setTextAndFireOnChange = function (e, t) {
          this._setText(e, t), this._onChange();
        }, t._applyHistory = function (e) {
          (this || _global).json = e.json, (this || _global).text = e.text, this._renderPreview(), this._debouncedValidate();
        }, t._pushHistory = function () {
          var e;
          (this || _global).history && (e = {
            text: (this || _global).text,
            json: (this || _global).json
          }, (this || _global).history.add(e));
        }, t.executeWithBusyMessage = function (e, t) {
          var n;
          this.getText().length > s.EX ? ((0, m.addClassName)((n = this || _global).frame, "busy"), n.dom.busyContent.innerText = t, setTimeout(function () {
            e(), (0, m.removeClassName)(n.frame, "busy"), n.dom.busyContent.innerText = "";
          }, 100)) : e();
        }, t.validate = n.validate, t._renderErrors = n._renderErrors, [{
          mode: "preview",
          mixin: t,
          data: "json"
        }]);
    },
    6210: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, {
        showSortModal: function () {
          return s;
        }
      });
      var t = n(483),
        i = n.n(t),
        o = n(7907),
        r = n(9791);
      function s(e, t, s, n) {
        var a = Array.isArray(t) ? (0, r.getChildPaths)(t) : [""],
          l = n && n.path && (0, r.contains)(a, n.path) ? n.path : a[0],
          c = n && n.direction || "asc",
          t = "<div class=\"pico-modal-contents\"><div class=\"pico-modal-header\">" + (0, o.Iu)("sort") + "</div><form><table><tbody><tr>  <td>" + (0, o.Iu)("sortFieldLabel") + " </td>  <td class=\"jsoneditor-modal-input\">  <div class=\"jsoneditor-select-wrapper\">    <select id=\"field\" title=\"" + (0, o.Iu)("sortFieldTitle") + "\">    </select>  </div>  </td></tr><tr>  <td>" + (0, o.Iu)("sortDirectionLabel") + " </td>  <td class=\"jsoneditor-modal-input\">  <div id=\"direction\" class=\"jsoneditor-button-group\"><input type=\"button\" value=\"" + (0, o.Iu)("sortAscending") + "\" title=\"" + (0, o.Iu)("sortAscendingTitle") + "\" data-value=\"asc\" class=\"jsoneditor-button-first jsoneditor-button-asc\"/><input type=\"button\" value=\"" + (0, o.Iu)("sortDescending") + "\" title=\"" + (0, o.Iu)("sortDescendingTitle") + "\" data-value=\"desc\" class=\"jsoneditor-button-last jsoneditor-button-desc\"/>  </div>  </td></tr><tr><td colspan=\"2\" class=\"jsoneditor-modal-input jsoneditor-modal-actions\">  <input type=\"submit\" id=\"ok\" value=\"" + (0, o.Iu)("ok") + "\" /></td></tr></tbody></table></form></div>";
        i()({
          parent: e,
          content: t,
          overlayClass: "jsoneditor-modal-overlay",
          overlayStyles: {
            backgroundColor: "rgb(1,1,1)",
            opacity: 0.3
          },
          modalClass: "jsoneditor-modal jsoneditor-modal-sort"
        }).afterCreate(function (t) {
          var e = t.modalElem().querySelector("form"),
            n = t.modalElem().querySelector("#ok"),
            i = t.modalElem().querySelector("#field"),
            o = t.modalElem().querySelector("#direction");
          function r(e) {
            o.value = e, o.className = "jsoneditor-button-group jsoneditor-button-group-value-" + o.value;
          }
          a.forEach(function (e) {
            var t,
              n = document.createElement("option");
            n.text = "" === (t = e) ? "@" : "." === t[0] ? t.slice(1) : t, n.value = e, i.appendChild(n);
          }), i.value = l || a[0], r(c || "asc"), o.onclick = function (e) {
            r(e.target.getAttribute("data-value"));
          }, n.onclick = function (e) {
            e.preventDefault(), e.stopPropagation(), t.close(), s({
              path: i.value,
              direction: o.value
            });
          }, e && (e.onsubmit = n.onclick);
        }).afterClose(function (e) {
          e.destroy();
        }).show();
      }
    },
    2558: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, {
        showTransformModal: function () {
          return s;
        }
      });
      var t = n(483),
        i = n.n(t),
        t = n(3879),
        x = n.n(t),
        o = n(7907);
      function I(e) {
        return (I = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function k(e, t, n, i) {
        if ("boolean" == typeof e || e instanceof Boolean || null === e || "number" == typeof e || e instanceof Number || "string" == typeof e || e instanceof String || e instanceof Date) return JSON.stringify(e);
        if (Array.isArray(e)) {
          for (var o = e, r = t, s = n, a = i, l = r ? s + r : void 0, c = r ? "[\n" : "[", h = 0; h < o.length; h++) {
            var d = o[h];
            if (r && (c += l), c += void 0 !== d && "function" != typeof d ? k(d, r, l, a) : "null", h < o.length - 1 && (c += r ? ",\n" : ","), c.length > a) return c + "...";
          }
          return c += r ? "\n" + s + "]" : "]";
        }
        if (e && "object" === I(e)) {
          var u,
            g = e,
            p = t,
            s = n,
            m = i,
            f = p ? s + p : void 0,
            C = !0,
            y = p ? "{\n" : "{";
          if ("function" == typeof g.toJSON) return k(g.toJSON(), p, s, m);
          for (u in g) if (function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }(g, u)) {
            var v = g[u];
            if (C ? C = !1 : y += p ? ",\n" : ",", (y = (y += p ? f + "\"" + u + "\": " : "\"" + u + "\":") + k(v, p, f, m)).length > m) return y + "...";
          }
          return y += p ? "\n" + s + "}" : "}";
        }
      }
      function E(e, t) {
        for (var n = ""; 0 < t--;) n += e;
        return n;
      }
      var T = n(9791),
        R = n(4188),
        r = "Enter a <a href=\"http://jmespath.org\" target=\"_blank\">JMESPath</a> query to filter, sort, or transform the JSON data.<br/>To learn JMESPath, go to <a href=\"http://jmespath.org/tutorial.html\" target=\"_blank\">the interactive tutorial</a>.";
      function s(e) {
        var t = e.container,
          I = e.json,
          n = e.queryDescription,
          n = void 0 === n ? r : n,
          b = e.createQuery,
          A = e.executeQuery,
          w = e.onTransform,
          S = I,
          e = "<label class=\"pico-modal-contents\"><div class=\"pico-modal-header\">" + (0, o.Iu)("transform") + "</div><p>" + n + "</p><div class=\"jsoneditor-jmespath-label\">" + (0, o.Iu)("transformWizardLabel") + " </div><div id=\"wizard\" class=\"jsoneditor-jmespath-block jsoneditor-jmespath-wizard\">  <table class=\"jsoneditor-jmespath-wizard-table\">    <tbody>      <tr>        <th>" + (0, o.Iu)("transformWizardFilter") + "</th>        <td class=\"jsoneditor-jmespath-filter\">          <div class=\"jsoneditor-inline jsoneditor-jmespath-filter-field\" >            <select id=\"filterField\">            </select>          </div>          <div class=\"jsoneditor-inline jsoneditor-jmespath-filter-relation\" >            <select id=\"filterRelation\">              <option value=\"==\">==</option>              <option value=\"!=\">!=</option>              <option value=\"<\">&lt;</option>              <option value=\"<=\">&lt;=</option>              <option value=\">\">&gt;</option>              <option value=\">=\">&gt;=</option>            </select>          </div>          <div class=\"jsoneditor-inline jsoneditor-jmespath-filter-value\" >            <input type=\"text\" class=\"value\" placeholder=\"value...\" id=\"filterValue\" />          </div>        </td>      </tr>      <tr>        <th>" + (0, o.Iu)("transformWizardSortBy") + "</th>        <td class=\"jsoneditor-jmespath-filter\">          <div class=\"jsoneditor-inline jsoneditor-jmespath-sort-field\">            <select id=\"sortField\">            </select>          </div>          <div class=\"jsoneditor-inline jsoneditor-jmespath-sort-order\" >            <select id=\"sortOrder\">              <option value=\"asc\">Ascending</option>              <option value=\"desc\">Descending</option>            </select>          </div>        </td>      </tr>      <tr id=\"selectFieldsPart\">        <th>" + (0, o.Iu)("transformWizardSelectFields") + "</th>        <td class=\"jsoneditor-jmespath-filter\">          <select class=\"jsoneditor-jmespath-select-fields\" id=\"selectFields\" multiple></select>        </td>      </tr>    </tbody>  </table></div><div class=\"jsoneditor-jmespath-label\">" + (0, o.Iu)("transformQueryLabel") + " </div><div class=\"jsoneditor-jmespath-block\">  <textarea id=\"query\"             rows=\"4\"             autocomplete=\"off\"             autocorrect=\"off\"             autocapitalize=\"off\"             spellcheck=\"false\"            title=\"" + (0, o.Iu)("transformQueryTitle") + "\">[*]</textarea></div><div class=\"jsoneditor-jmespath-label\">" + (0, o.Iu)("transformPreviewLabel") + " </div><div class=\"jsoneditor-jmespath-block\">  <textarea id=\"preview\"       class=\"jsoneditor-transform-preview\"      readonly> </textarea></div><div class=\"jsoneditor-jmespath-block jsoneditor-modal-actions\">  <input type=\"submit\" id=\"ok\" value=\"" + (0, o.Iu)("ok") + "\" autofocus /></div></div>";
        i()({
          parent: t,
          content: e,
          overlayClass: "jsoneditor-modal-overlay",
          overlayStyles: {
            backgroundColor: "rgb(1,1,1)",
            opacity: 0.3
          },
          modalClass: "jsoneditor-modal jsoneditor-modal-transform",
          focus: !1
        }).afterCreate(function (t) {
          var e = t.modalElem(),
            n = e.querySelector("#wizard"),
            r = e.querySelector("#ok"),
            o = e.querySelector("#filterField"),
            s = e.querySelector("#filterRelation"),
            a = e.querySelector("#filterValue"),
            l = e.querySelector("#sortField"),
            c = e.querySelector("#sortOrder"),
            h = e.querySelector("#selectFields"),
            d = e.querySelector("#query"),
            u = e.querySelector("#preview");
          Array.isArray(S) || (n.style.fontStyle = "italic", n.textContent = "(wizard not available for objects, only for arrays)");
          (0, T.getChildPaths)(I).forEach(function (e) {
            var e = f(e),
              t = document.createElement("option"),
              t = (t.text = e, t.value = e, o.appendChild(t), document.createElement("option"));
            t.text = e, t.value = e, l.appendChild(t);
          });
          var n = (0, T.getChildPaths)(I, !0).filter(function (e) {
              return "" !== e;
            }),
            n = (0 < n.length ? n.forEach(function (e) {
              var e = f(e),
                t = document.createElement("option");
              t.text = e, t.value = e, h.appendChild(t);
            }) : (n = e.querySelector("#selectFieldsPart")) && (n.style.display = "none"), new (x())(o, {
              defaultSelected: !1,
              clearable: !0,
              allowDeselect: !0,
              placeholder: "field..."
            })),
            i = new (x())(s, {
              defaultSelected: !1,
              clearable: !0,
              allowDeselect: !0,
              placeholder: "compare..."
            }),
            g = new (x())(l, {
              defaultSelected: !1,
              clearable: !0,
              allowDeselect: !0,
              placeholder: "field..."
            }),
            p = new (x())(c, {
              defaultSelected: !1,
              clearable: !0,
              allowDeselect: !0,
              placeholder: "order..."
            }),
            m = new (x())(h, {
              multiple: !0,
              clearable: !0,
              defaultSelected: !1,
              placeholder: "select fields..."
            });
          function f(e) {
            return "" === e ? "@" : "." === e[0] ? e.slice(1) : e;
          }
          n.on("selectr.change", v), i.on("selectr.change", v), a.oninput = v, g.on("selectr.change", v), p.on("selectr.change", v), m.on("selectr.change", v), e.querySelector(".pico-modal-contents").onclick = function (e) {
            "A" !== e.target.nodeName && e.preventDefault();
          };
          var C = (0, T.debounce)(function () {
            try {
              var e = A(S, d.value);
              u.className = "jsoneditor-transform-preview", u.value = (t = e, n = 2, i = R.WF, "number" == typeof n ? 10 < n ? o = E(" ", 10) : 1 <= n && (o = E(" ", n)) : "string" == typeof n && "" !== n && (o = n), (n = k(t, o, "", i)).length > i ? (t = n, ("number" == typeof (o = i) ? t.slice(0, o) : t) + "...") : n), r.disabled = !1;
            } catch (e) {
              u.className = "jsoneditor-transform-preview jsoneditor-error", u.value = e.toString(), r.disabled = !0;
            }
            var t, n, i, o;
          }, 300);
          function y(t, e) {
            try {
              d.value = b(t, e), r.disabled = !1, C();
            } catch (e) {
              t = "Error: an error happened when executing \"createQuery\": " + (e.message || e.toString());
              d.value = "", r.disabled = !0, u.className = "jsoneditor-transform-preview jsoneditor-error", u.value = t;
            }
          }
          function v() {
            var e = {};
            if (o.value && s.value && a.value && (e.filter = {
              field: o.value,
              relation: s.value,
              value: a.value
            }), l.value && c.value && (e.sort = {
              field: l.value,
              direction: c.value
            }), h.value) {
              for (var t, n = [], i = 0; i < h.options.length; i++) h.options[i].selected && (t = h.options[i].value, n.push(t));
              e.projection = {
                fields: n
              };
            }
            y(I, e);
          }
          d.oninput = C, r.onclick = function (e) {
            e.preventDefault(), e.stopPropagation(), t.close(), w(d.value);
          }, y(I, {}), setTimeout(function () {
            d.select(), d.focus(), d.selectionStart = 3, d.selectionEnd = 3;
          });
        }).afterClose(function (e) {
          e.destroy();
        }).show();
      }
    },
    8458: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, {
        textModeMixins: function () {
          return A;
        }
      });
      var i = n(1262),
        t = n(8170),
        l = n.n(t),
        a = n(4188),
        c = n(6436),
        h = n(2474),
        d = n(7907),
        u = n(6056),
        g = n(6617),
        o = n(6210),
        p = n(2558),
        m = n(9125),
        f = n(7026),
        C = n(9791);
      function r(e) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function s(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== r(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== r(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === r(e) ? e : String(e);
          }(i.key), i);
        }
      }
      var y = function () {
        function n(e, t) {
          if (!((this || _global) instanceof n)) throw new TypeError("Cannot call a class as a function");
          (this || _global).schema = e, (this || _global).schemaRefs = t || {}, (this || _global).suggestions = {}, (this || _global).suggestionsRefs = {}, this._buildSuggestions();
        }
        var e, t, i;
        return e = n, (t = [{
          key: "_buildSuggestions",
          value: function () {
            for (var e in this._handleSchemaEntry("", (this || _global).schema, (this || _global).suggestions), (this || _global).schemaRefs) (this || _global).suggestionsRefs[e] = {}, this._handleSchemaEntry("", (this || _global).schemaRefs[e], (this || _global).suggestionsRefs[e]);
          }
        }, {
          key: "_handleRef",
          value: function (e, t, n) {
            n[e] = n[e] || {}, n[e].refs = n[e].refs || [], n[e].refs = (0, C.uniqueMergeArrays)(n[e].refs, [t]);
          }
        }, {
          key: "_handleSchemaEntry",
          value: function (e, t, n) {
            if (t) {
              if (t.$ref) this._handleRef(e, t.$ref, n);else {
                var i = this._checkOfConditon(t);
                if (i) this._handleOfCondition(e, t[i], n);else switch (t.type) {
                  case "object":
                    this._handleObject(e, t, n);
                    break;
                  case "string":
                  case "number":
                  case "integer":
                    this._handlePrimitive(e, t, n);
                    break;
                  case "boolean":
                    this._handleBoolean(e, t, n);
                    break;
                  case "array":
                    this._handleArray(e, t, n);
                }
              }
            } else console.error("SchemaTextCompleter: schema node is missing for path", e);
          }
        }, {
          key: "_handleObject",
          value: function (t, n, i) {
            var e,
              o = this || _global;
            (0, C.isObject)(n.properties) && (e = Object.keys(n.properties), i[t] = i[t] || {}, i[t].props = i[t].props || [], i[t].props = (0, C.uniqueMergeArrays)(i[t].props, e), e.forEach(function (e) {
              (0, C.asyncExec)(function () {
                o._handleSchemaEntry("".concat(t, "/").concat(e), n.properties[e], i);
              });
            }));
          }
        }, {
          key: "_handlePrimitive",
          value: function (e, t, n) {
            n[e] = n[e] || {}, (0, C.isArray)(t.examples) && (n[e].examples = n[e].examples || [], n[e].examples = (0, C.uniqueMergeArrays)(n[e].examples, t.examples)), (0, C.isArray)(t.enum) && (n[e].enum = n[e].enum || [], n[e].enum = (0, C.uniqueMergeArrays)(n[e].enum, t.enum));
          }
        }, {
          key: "_handleBoolean",
          value: function (e, t, n) {
            n[e] || (n[e] = {
              bool: [!0, !1]
            });
          }
        }, {
          key: "_handleArray",
          value: function (e, t, n) {
            var i = this || _global;
            t.items && (0, C.asyncExec)(function () {
              i._handleSchemaEntry("".concat(e, "/\\d+"), t.items, n);
            });
          }
        }, {
          key: "_handleOfCondition",
          value: function (t, e, n) {
            var i = this || _global;
            e && e.length && e.forEach(function (e) {
              (0, C.asyncExec)(function () {
                i._handleSchemaEntry(t, e, n);
              });
            });
          }
        }, {
          key: "_checkOfConditon",
          value: function (e) {
            if (e) return e.oneOf ? "oneOf" : e.anyOf ? "anyOf" : e.allOf ? "allOf" : void 0;
          }
        }, {
          key: "getCompletions",
          value: function (e, t, i, n, s) {
            var c = this || _global;
            try {
              var o = f.parse(t.getValue()).pointers || {},
                r = function (i) {
                  function e(t) {
                    var e,
                      n = {
                        props: "property",
                        enum: "enum",
                        bool: "boolean",
                        examples: "examples"
                      };
                    i && null != (e = i[t]) && e.length && (o = o.concat(i[t].map(function (e) {
                      return {
                        caption: e + "",
                        meta: "schema [".concat(n[t], "]"),
                        score: r++,
                        value: e + ""
                      };
                    })));
                  }
                  var o = [],
                    r = 0;
                  e("props"), e("enum"), e("bool"), e("examples"), o.length && s(null, o);
                };
              Object.keys(o).forEach(function (n) {
                (0, C.asyncExec)(function () {
                  function l(n, e, i) {
                    var t,
                      o = Object.keys(e).reduce(function (e, t) {
                        return new RegExp("^".concat(i).concat(t)).test(n) && (!e || e.length < t.length) ? t : e;
                      });
                    if ("string" == typeof o) {
                      if (null != (t = e[o]) && null != (t = t.refs) && t.length) {
                        var r,
                          s = {};
                        for (r in e[o].refs) {
                          var a = e[o].refs[r];
                          c.suggestionsRefs[a] && (null != (a = l(n, c.suggestionsRefs[a], "".concat(i).concat(o))) && a.enum && (s.enum = (0, C.uniqueMergeArrays)(s.enum, a.enum)), null != a && a.examples && (s.examples = (0, C.uniqueMergeArrays)(s.examples, a.examples)), null != a && a.bool && (s.bool = (0, C.uniqueMergeArrays)(s.bool, a.bool)), null != a) && a.props && (s.props = (0, C.uniqueMergeArrays)(s.props, a.props));
                        }
                        return s;
                      }
                      if (new RegExp("^".concat(i).concat(o, "$")).test(n)) return e[o];
                    }
                  }
                  var e, t;
                  (null == (t = o[n].key) ? void 0 : t.line) === i.row && i.column >= o[n].key.column && i.column <= o[n].keyEnd.column && (e = n.slice(0, n.lastIndexOf("/"))), (e = (null == (t = o[n].value) ? void 0 : t.line) === i.row && (null == (t = o[n].value) ? void 0 : t.line) === (null == (t = o[n].valueEnd) ? void 0 : t.line) && i.column >= o[n].value.column && i.column <= o[n].valueEnd.column ? n : e) && (t = l(e, c.suggestions, ""), r(t));
                });
              });
            } catch (e) {}
          }
        }]) && s(e.prototype, t), i && s(e, i), Object.defineProperty(e, "prototype", {
          writable: !1
        }), n;
      }();
      function v(e) {
        return (v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      var t = {},
        I = "ace/theme/jsoneditor";
      function b() {
        try {
          this.format();
        } catch (e) {}
      }
      t.create = function (e) {
        var t,
          n,
          i,
          o = this || _global,
          r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          s = (void 0 === r.statusBar && (r.statusBar = !0), r.mainMenuBar = !1 !== r.mainMenuBar, r.enableSort = !1 !== r.enableSort, r.enableTransform = !1 !== r.enableTransform, r.createQuery = r.createQuery || u.r, r.executeQuery = r.executeQuery || u.J, r.showErrorTable = void 0 !== r.showErrorTable ? r.showErrorTable : ["text", "preview"], "number" == typeof ((this || _global).options = r).indentation ? (this || _global).indentation = Number(r.indentation) : (this || _global).indentation = 2, (0, d.cC)((this || _global).options.languages), (0, d.m0)((this || _global).options.language), r.ace || l()),
          a = ((this || _global).mode = "code" === r.mode ? "code" : "text", "code" === (this || _global).mode && void 0 === s && ((this || _global).mode = "text", console.warn("Failed to load Ace editor, falling back to plain text mode. Please use a JSONEditor bundle including Ace, or pass Ace as via the configuration option `ace`.")), (this || _global).theme = r.theme || I, (this || _global).theme === I && s && (0, m.O)(), r.onTextSelectionChange && this.onTextSelectionChange(r.onTextSelectionChange), this || _global),
          e = ((this || _global).container = e, (this || _global).dom = {}, (this || _global).aceEditor = void 0, (this || _global).textarea = void 0, (this || _global).validateSchema = null, (this || _global).annotations = [], (this || _global).lastSchemaErrors = void 0, (this || _global)._debouncedValidate = (0, C.debounce)((this || _global)._validateAndCatch.bind(this || _global), (this || _global).DEBOUNCE_INTERVAL), (this || _global).width = e.clientWidth, (this || _global).height = e.clientHeight, (this || _global).frame = document.createElement("div"), (this || _global).frame.className = "jsoneditor jsoneditor-mode-" + (this || _global).options.mode, (this || _global).frame.onclick = function (e) {
            e.preventDefault();
          }, (this || _global).frame.onkeydown = function (e) {
            a._onKeyDown(e);
          }, {
            target: (this || _global).frame,
            onFocus: (this || _global).options.onFocus || null,
            onBlur: (this || _global).options.onBlur || null
          }),
          e = ((this || _global).frameFocusTracker = new h.R(e), (this || _global).content = document.createElement("div"), (this || _global).content.className = "jsoneditor-outer", (this || _global).options.mainMenuBar && ((0, C.addClassName)((this || _global).content, "has-main-menu-bar"), (this || _global).menu = document.createElement("div"), (this || _global).menu.className = "jsoneditor-menu", (this || _global).frame.appendChild((this || _global).menu), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-format", e.title = (0, d.Iu)("formatTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
            try {
              a.format(), a._onChange();
            } catch (e) {
              a._onError(e);
            }
          }, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-compact", e.title = (0, d.Iu)("compactTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
            try {
              a.compact(), a._onChange();
            } catch (e) {
              a._onError(e);
            }
          }, (this || _global).options.enableSort && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-sort", e.title = (0, d.Iu)("sortTitleShort"), e.onclick = function () {
            a._showSortModal();
          }, (this || _global).menu.appendChild(e)), (this || _global).options.enableTransform && ((e = document.createElement("button")).type = "button", e.title = (0, d.Iu)("transformTitleShort"), e.className = "jsoneditor-transform", e.onclick = function () {
            a._showTransformModal();
          }, (this || _global).menu.appendChild(e)), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-repair", e.title = (0, d.Iu)("repairTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
            try {
              a.repair(), a._onChange();
            } catch (e) {
              a._onError(e);
            }
          }, "code" === (this || _global).mode && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-undo jsoneditor-separator", e.title = (0, d.Iu)("undo"), e.onclick = function () {
            o.aceEditor.getSession().getUndoManager().undo();
          }, (this || _global).menu.appendChild(e), (this || _global).dom.undo = e, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-redo", e.title = (0, d.Iu)("redo"), e.onclick = function () {
            o.aceEditor.getSession().getUndoManager().redo();
          }, (this || _global).menu.appendChild(e), (this || _global).dom.redo = e), (this || _global).options && (this || _global).options.modes && (this || _global).options.modes.length && ((this || _global).modeSwitcher = new g.x((this || _global).menu, (this || _global).options.modes, (this || _global).options.mode, function (e) {
            try {
              a.setMode(e), a.modeSwitcher.focus();
            } catch (e) {
              a._onError(e);
            }
          })), "code" === (this || _global).mode) && ((t = document.createElement("a")).appendChild(document.createTextNode("powered by ace")), t.href = "https://ace.c9.io/", t.target = "_blank", t.className = "jsoneditor-poweredBy", t.onclick = function () {
            window.open(t.href, t.target, "noreferrer");
          }, (this || _global).menu.appendChild(t)), (this || _global).options.onEditable && v("function" === (this || _global).options.onEditable) && !(this || _global).options.onEditable({})),
          s = ((this || _global).frame.appendChild((this || _global).content), (this || _global).container.appendChild((this || _global).frame), "code" === (this || _global).mode ? ((this || _global).editorDom = document.createElement("div"), (this || _global).editorDom.style.height = "100%", (this || _global).editorDom.style.width = "100%", (this || _global).content.appendChild((this || _global).editorDom), i = (s = s.edit((this || _global).editorDom)).getSession(), s.$blockScrolling = 1 / 0, s.setTheme((this || _global).theme), s.setOptions({
            readOnly: e
          }), s.setShowPrintMargin(!1), s.setFontSize("14px"), i.setMode("ace/mode/json"), i.setTabSize((this || _global).indentation), i.setUseSoftTabs(!0), i.setUseWrapMode(!0), n = i.setAnnotations, i.setAnnotations = function (e) {
            n.call(this || _global, e && e.length ? e : a.annotations);
          }, s.commands.bindKey("Ctrl-L", null), s.commands.bindKey("Command-L", null), s.commands.bindKey("Ctrl-\\", null), s.commands.bindKey("Command-\\", null), s.commands.bindKey("Ctrl-Shift-\\", null), s.commands.bindKey("Command-Shift-\\", null), ((this || _global).aceEditor = s).on("change", (this || _global)._onChange.bind(this || _global)), s.on("changeSelection", (this || _global)._onSelect.bind(this || _global))) : ((i = document.createElement("textarea")).className = "jsoneditor-text", i.spellcheck = !1, (this || _global).content.appendChild(i), (this || _global).textarea = i, (this || _global).textarea.readOnly = e, null === (this || _global).textarea.oninput ? (this || _global).textarea.oninput = (this || _global)._onChange.bind(this || _global) : (this || _global).textarea.onchange = (this || _global)._onChange.bind(this || _global), i.onselect = (this || _global)._onSelect.bind(this || _global), i.onmousedown = (this || _global)._onMouseDown.bind(this || _global), i.onblur = (this || _global)._onBlur.bind(this || _global)), this._updateHistoryButtons(), Array.isArray((this || _global).options.showErrorTable) ? (this || _global).options.showErrorTable.includes((this || _global).mode) : !0 === (this || _global).options.showErrorTable);
        (this || _global).errorTable = new c.Q({
          errorTableVisible: s,
          onToggleVisibility: function () {
            a._validateAndCatch();
          },
          onFocusLine: function (e) {
            a.isFocused = !0, isNaN(e) || a.setTextSelection({
              row: e,
              column: 1
            }, {
              row: e,
              column: 1000
            });
          },
          onChangeHeight: function (e) {
            e = e + (a.dom.statusBar ? a.dom.statusBar.clientHeight : 0) + 1;
            a.content.style.marginBottom = -e + "px", a.content.style.paddingBottom = e + "px";
          }
        }), (this || _global).frame.appendChild((this || _global).errorTable.getErrorTable()), r.statusBar && ((0, C.addClassName)((this || _global).content, "has-status-bar"), (this || _global).curserInfoElements = {}, e = document.createElement("div"), ((this || _global).dom.statusBar = e).className = "jsoneditor-statusbar", (this || _global).frame.appendChild(e), (i = document.createElement("span")).className = "jsoneditor-curserinfo-label", i.innerText = "Ln:", (s = document.createElement("span")).className = "jsoneditor-curserinfo-val", s.innerText = "1", e.appendChild(i), e.appendChild(s), (r = document.createElement("span")).className = "jsoneditor-curserinfo-label", r.innerText = "Col:", (i = document.createElement("span")).className = "jsoneditor-curserinfo-val", i.innerText = "1", e.appendChild(r), e.appendChild(i), (this || _global).curserInfoElements.colVal = i, (this || _global).curserInfoElements.lnVal = s, (r = document.createElement("span")).className = "jsoneditor-curserinfo-label", r.innerText = "characters selected", r.style.display = "none", (i = document.createElement("span")).className = "jsoneditor-curserinfo-count", i.innerText = "0", i.style.display = "none", (this || _global).curserInfoElements.countLabel = r, (this || _global).curserInfoElements.countVal = i, e.appendChild(i), e.appendChild(r), e.appendChild((this || _global).errorTable.getErrorCounter()), e.appendChild((this || _global).errorTable.getWarningIcon()), e.appendChild((this || _global).errorTable.getErrorIcon())), this.setSchema((this || _global).options.schema, (this || _global).options.schemaRefs);
      }, t._onSchemaChange = function (e, t) {
        (this || _global).aceEditor && ((this || _global).options.allowSchemaSuggestions && e ? ((this || _global).aceEditor.setOption("enableBasicAutocompletion", [new y(e, t)]), (this || _global).aceEditor.setOption("enableLiveAutocompletion", !0)) : ((this || _global).aceEditor.setOption("enableBasicAutocompletion", void 0), (this || _global).aceEditor.setOption("enableLiveAutocompletion", !1)));
      }, t._onChange = function () {
        var e = this || _global;
        if (!(this || _global).onChangeDisabled) {
          if (setTimeout(function () {
            e._updateHistoryButtons && e._updateHistoryButtons();
          }), this._debouncedValidate(), (this || _global).options.onChange) try {
            (this || _global).options.onChange();
          } catch (e) {
            console.error("Error in onChange callback: ", e);
          }
          if ((this || _global).options.onChangeText) try {
            (this || _global).options.onChangeText(this.getText());
          } catch (e) {
            console.error("Error in onChangeText callback: ", e);
          }
        }
      }, t._updateHistoryButtons = function () {
        var e;
        (this || _global).aceEditor && (this || _global).dom.undo && (this || _global).dom.redo && (e = (this || _global).aceEditor.getSession().getUndoManager()) && e.hasUndo && e.hasRedo && ((this || _global).dom.undo.disabled = !e.hasUndo(), (this || _global).dom.redo.disabled = !e.hasRedo());
      }, t._showSortModal = function () {
        try {
          var n = this || _global,
            e = (this || _global).options.modalAnchor || a.qD,
            i = this.get();
          (0, o.showSortModal)(e, i, function (e) {
            var t;
            Array.isArray(i) && (t = (0, C.sort)(i, e.path, e.direction), n.sortedBy = e, n.update(t)), (0, C.isObject)(i) && (t = (0, C.sortObjectKeys)(i, e.direction), n.sortedBy = e, n.update(t));
          }, n.sortedBy);
        } catch (e) {
          this._onError(e);
        }
      }, t._showTransformModal = function () {
        var t = this || _global;
        try {
          var e = (this || _global).options,
            n = e.modalAnchor,
            i = e.createQuery,
            o = e.executeQuery,
            r = e.queryDescription,
            s = this.get();
          (0, p.showTransformModal)({
            container: n || a.qD,
            json: s,
            queryDescription: r,
            createQuery: i,
            executeQuery: o,
            onTransform: function (e) {
              e = o(s, e);
              t.update(e);
            }
          });
        } catch (e) {
          this._onError(e);
        }
      }, t._onSelect = function () {
        this._updateCursorInfo(), this._emitSelectionChange();
      }, t._onKeyDown = function (e) {
        var t = !1;
        73 === (e.which || e.keyCode) && e.ctrlKey && (e.shiftKey ? this.compact() : this.format(), this._onChange(), t = !0), t && (e.preventDefault(), e.stopPropagation()), this._updateCursorInfo(), this._emitSelectionChange();
      }, t._onMouseDown = function () {
        this._updateCursorInfo(), this._emitSelectionChange();
      }, t._onBlur = function () {
        var e = this || _global;
        setTimeout(function () {
          e.isFocused || (e._updateCursorInfo(), e._emitSelectionChange()), e.isFocused = !1;
        });
      }, t._updateCursorInfo = function () {
        var e,
          t,
          n,
          i,
          o,
          r = this || _global;
        function s() {
          r.curserInfoElements.countVal.innerText !== o && (r.curserInfoElements.countVal.innerText = o, r.curserInfoElements.countVal.style.display = o ? "inline" : "none", r.curserInfoElements.countLabel.style.display = o ? "inline" : "none"), r.curserInfoElements.lnVal.innerText = n, r.curserInfoElements.colVal.innerText = i;
        }
        (this || _global).textarea ? setTimeout(function () {
          var e = (0, C.getInputSelection)(r.textarea);
          e.startIndex !== e.endIndex && (o = e.endIndex - e.startIndex), i = (o && r.cursorInfo && r.cursorInfo.line === e.end.row && r.cursorInfo.column === e.end.column ? (n = e.start.row, e.start) : (n = e.end.row, e.end)).column, r.cursorInfo = {
            line: n,
            column: i,
            count: o
          }, r.options.statusBar && s();
        }, 0) : (this || _global).aceEditor && (this || _global).curserInfoElements && (e = (this || _global).aceEditor.getCursorPosition(), t = (this || _global).aceEditor.getSelectedText(), n = e.row + 1, i = e.column + 1, o = t.length, r.cursorInfo = {
          line: n,
          column: i,
          count: o
        }, (this || _global).options.statusBar) && s();
      }, t._emitSelectionChange = function () {
        var e;
        (this || _global)._selectionChangedHandler && (e = this.getTextSelection(), this._selectionChangedHandler(e.start, e.end, e.text));
      }, t._refreshAnnotations = function () {
        var e,
          t = (this || _global).aceEditor && (this || _global).aceEditor.getSession();
        t && (e = t.getAnnotations().filter(function (e) {
          return "error" === e.type;
        }), t.setAnnotations(e));
      }, t.destroy = function () {
        (this || _global).aceEditor && ((this || _global).aceEditor.destroy(), (this || _global).aceEditor = null), (this || _global).frame && (this || _global).container && (this || _global).frame.parentNode === (this || _global).container && (this || _global).container.removeChild((this || _global).frame), (this || _global).modeSwitcher && ((this || _global).modeSwitcher.destroy(), (this || _global).modeSwitcher = null), (this || _global).textarea = null, (this || _global)._debouncedValidate = null, (this || _global).frameFocusTracker.destroy();
      }, t.compact = function () {
        var e = this.get(),
          e = JSON.stringify(e);
        this.updateText(e);
      }, t.format = function () {
        var e = this.get(),
          e = JSON.stringify(e, null, (this || _global).indentation);
        this.updateText(e);
      }, t.repair = function () {
        var e = this.getText();
        try {
          var t = (0, i.K)(e);
          this.updateText(t);
        } catch (e) {}
      }, t.focus = function () {
        (this || _global).textarea && (this || _global).textarea.focus(), (this || _global).aceEditor && (this || _global).aceEditor.focus();
      }, t.resize = function () {
        (this || _global).aceEditor && (this || _global).aceEditor.resize(!1);
      }, t.set = function (e) {
        this.setText(JSON.stringify(e, null, (this || _global).indentation));
      }, t.update = function (e) {
        this.updateText(JSON.stringify(e, null, (this || _global).indentation));
      }, t.get = function () {
        var e = this.getText();
        return (0, C.parse)(e);
      }, t.getText = function () {
        return (this || _global).textarea ? (this || _global).textarea.value : (this || _global).aceEditor ? (this || _global).aceEditor.getValue() : "";
      }, t._setText = function (e, t) {
        var n,
          i = this || _global,
          e = !0 === (this || _global).options.escapeUnicode ? (0, C.escapeUnicodeChars)(e) : e;
        (this || _global).textarea && ((this || _global).textarea.value = e), (this || _global).aceEditor && ((this || _global).onChangeDisabled = !0, (this || _global).aceEditor.setValue(e, -1), (this || _global).onChangeDisabled = !1, t && (n = this || _global, setTimeout(function () {
          n.aceEditor && n.aceEditor.session.getUndoManager().reset();
        })), setTimeout(function () {
          i._updateHistoryButtons && i._updateHistoryButtons();
        })), this._debouncedValidate();
      }, t.setText = function (e) {
        this._setText(e, !0);
      }, t.updateText = function (e) {
        this.getText() !== e && this._setText(e, !1);
      }, t.validate = function () {
        var t,
          n = this || _global,
          i = [],
          o = [];
        try {
          var r = this.get(),
            s = ((this || _global).validateSchema && !this.validateSchema(r) && (i = (this || _global).validateSchema.errors.map(function (e) {
              return e.type = "validation", (0, C.improveSchemaError)(e);
            })), (this || _global).validationSequence = ((this || _global).validationSequence || 0) + 1, this || _global),
            a = (this || _global).validationSequence;
          return function (e, t) {
            if (!t) return Promise.resolve([]);
            try {
              var n = t(e);
              return ((0, C.isPromise)(n) ? n : Promise.resolve(n)).then(function (e) {
                return Array.isArray(e) ? e.filter(function (e) {
                  var t = (0, C.isValidValidationError)(e);
                  return t || console.warn("Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: \"...\"}. Actual error:", e), t;
                }).map(function (e) {
                  return {
                    dataPath: (0, C.stringifyPath)(e.path),
                    message: e.message,
                    type: "customValidation"
                  };
                }) : [];
              });
            } catch (e) {
              return Promise.reject(e);
            }
          }(r, (this || _global).options.onValidate).then(function (e) {
            return a === s.validationSequence && (e = i.concat(o).concat(e), s._renderErrors(e), "function" == typeof n.options.onValidationError && (0, C.isValidationErrorChanged)(e, n.lastSchemaErrors) && n.options.onValidationError.call(n, e), n.lastSchemaErrors = e), n.lastSchemaErrors;
          });
        } catch (e) {
          return this.getText() && ((r = /\w*line\s*(\d+)\w*/g.exec(e.message)) && (t = +r[1]), o = [{
            type: "error",
            message: e.message.replace(/\n/g, "<br>"),
            line: t
          }]), this._renderErrors(o), "function" == typeof (this || _global).options.onValidationError && (0, C.isValidationErrorChanged)(o, (this || _global).lastSchemaErrors) && (this || _global).options.onValidationError.call(this || _global, o), (this || _global).lastSchemaErrors = o, Promise.resolve((this || _global).lastSchemaErrors);
        }
      }, t._validateAndCatch = function () {
        this.validate().catch(function (e) {
          console.error("Error running validation:", e);
        });
      }, t._renderErrors = function (i) {
        var e = this.getText(),
          t = [],
          e = (i.reduce(function (e, t) {
            return "string" == typeof t.dataPath && -1 === e.indexOf(t.dataPath) && e.push(t.dataPath), e;
          }, t), (0, C.getPositionForPath)(e, t));
        (this || _global).aceEditor && ((this || _global).annotations = e.map(function (t) {
          var e = i.filter(function (e) {
              return e.dataPath === t.path;
            }),
            n = e.map(function (e) {
              return e.message;
            }).join("\n");
          return n ? {
            row: t.line,
            column: t.column,
            text: "Schema validation error" + (1 !== e.length ? "s" : "") + ": \n" + n,
            type: "warning",
            source: "jsoneditor"
          } : {};
        }), this._refreshAnnotations()), (this || _global).errorTable.setErrors(i, e), (this || _global).aceEditor && (this || _global).aceEditor.resize(!1);
      }, t.getTextSelection = function () {
        var e,
          t,
          n,
          i = {};
        return (this || _global).textarea ? (n = (0, C.getInputSelection)((this || _global).textarea), (this || _global).cursorInfo && (this || _global).cursorInfo.line === n.end.row && (this || _global).cursorInfo.column === n.end.column ? (i.start = n.end, i.end = n.start) : i = n, {
          start: i.start,
          end: i.end,
          text: (this || _global).textarea.value.substring(n.startIndex, n.endIndex)
        }) : (this || _global).aceEditor ? (n = (this || _global).aceEditor.getSelection(), e = (this || _global).aceEditor.getSelectedText(), t = n.getRange(), (n = n.getSelectionLead()).row === t.end.row && n.column === t.end.column ? i = t : (i.start = t.end, i.end = t.start), {
          start: {
            row: i.start.row + 1,
            column: i.start.column + 1
          },
          end: {
            row: i.end.row + 1,
            column: i.end.column + 1
          },
          text: e
        }) : void 0;
      }, t.onTextSelectionChange = function (e) {
        "function" == typeof e && ((this || _global)._selectionChangedHandler = (0, C.debounce)(e, (this || _global).DEBOUNCE_INTERVAL));
      }, t.setTextSelection = function (e, t) {
        var n, i, o;
        e && t && ((this || _global).textarea ? (n = (0, C.getIndexForPosition)((this || _global).textarea, e.row, e.column), o = (0, C.getIndexForPosition)((this || _global).textarea, t.row, t.column), -1 < n && -1 < o && ((this || _global).textarea.setSelectionRange ? ((this || _global).textarea.focus(), (this || _global).textarea.setSelectionRange(n, o)) : (this || _global).textarea.createTextRange && ((i = (this || _global).textarea.createTextRange()).collapse(!0), i.moveEnd("character", o), i.moveStart("character", n), i.select()), o = ((this || _global).textarea.value.match(/\n/g) || []).length + 1, n = (this || _global).textarea.scrollHeight / o, i = e.row * n, (this || _global).textarea.scrollTop = i > (this || _global).textarea.clientHeight ? i - (this || _global).textarea.clientHeight / 2 : 0)) : (this || _global).aceEditor && (o = {
          start: {
            row: e.row - 1,
            column: e.column - 1
          },
          end: {
            row: t.row - 1,
            column: t.column - 1
          }
        }, (this || _global).aceEditor.selection.setRange(o), (this || _global).aceEditor.scrollToLine(e.row - 1, !0)));
      };
      var A = [{
        mode: "text",
        mixin: t,
        data: "text",
        load: b
      }, {
        mode: "code",
        mixin: t,
        data: "text",
        load: b
      }];
    },
    8038: function (W, e, t) {
      "use strict";

      t.r(e), t.d(e, {
        treeModeMixins: function () {
          return D;
        }
      });
      var w = {
        start: function (e, t, n) {
          return 0 === t.indexOf(e);
        },
        contain: function (e, t, n) {
          return -1 < t.indexOf(e);
        }
      };
      var s = t(897),
        a = t(2474);
      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function r(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== o(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== o(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === o(e) ? e : String(e);
          }(i.key), i);
        }
      }
      var S = function () {
          function e() {
            if (!((this || _global) instanceof e)) throw new TypeError("Cannot call a class as a function");
            (this || _global).locked = !1;
          }
          var t, n, i;
          return t = e, (n = [{
            key: "highlight",
            value: function (e) {
              (this || _global).locked || ((this || _global).node !== e && ((this || _global).node && (this || _global).node.setHighlight(!1), (this || _global).node = e, (this || _global).node.setHighlight(!0)), this._cancelUnhighlight());
            }
          }, {
            key: "unhighlight",
            value: function () {
              var e;
              (this || _global).locked || (e = this || _global).node && (this._cancelUnhighlight(), (this || _global).unhighlightTimer = setTimeout(function () {
                e.node.setHighlight(!1), e.node = void 0, e.unhighlightTimer = void 0;
              }, 0));
            }
          }, {
            key: "_cancelUnhighlight",
            value: function () {
              (this || _global).unhighlightTimer && (clearTimeout((this || _global).unhighlightTimer), (this || _global).unhighlightTimer = void 0);
            }
          }, {
            key: "lock",
            value: function () {
              (this || _global).locked = !0;
            }
          }, {
            key: "unlock",
            value: function () {
              (this || _global).locked = !1;
            }
          }]) && r(t.prototype, n), i && r(t, i), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e;
        }(),
        l = t(7907),
        i = t(6056),
        c = t(6617),
        e = t(233),
        h = t.n(e),
        d = t(2602),
        k = t(9791);
      var u = t(6210),
        g = t(2558),
        p = t(4188);
      function H(e) {
        return function (e) {
          if (Array.isArray(e)) return f(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || m(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function G(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
          if (null != n) {
            var i,
              o,
              r,
              s,
              a = [],
              l = !0,
              c = !1;
            try {
              if (r = (n = n.call(e)).next, 0 === t) {
                if (Object(n) !== n) return;
                l = !1;
              } else for (; !(l = (i = r.call(n)).done) && (a.push(i.value), a.length !== t); l = !0);
            } catch (e) {
              c = !0, o = e;
            } finally {
              try {
                if (!l && null != n.return && (s = n.return(), Object(s) !== s)) return;
              } finally {
                if (c) throw o;
              }
            }
            return a;
          }
        }(e, t) || m(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function x(e, t) {
        var n,
          i,
          o,
          r,
          s = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (s) return i = !(n = !0), {
          s: function () {
            s = s.call(e);
          },
          n: function () {
            var e = s.next();
            return n = e.done, e;
          },
          e: function (e) {
            i = !0, o = e;
          },
          f: function () {
            try {
              n || null == s.return || s.return();
            } finally {
              if (i) throw o;
            }
          }
        };
        if (Array.isArray(e) || (s = m(e)) || t && e && "number" == typeof e.length) return s && (e = s), r = 0, {
          s: t = function () {},
          n: function () {
            return r >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[r++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: t
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      function m(e, t) {
        var n;
        if (e) return "string" == typeof e ? f(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f(e, t) : void 0;
      }
      function f(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
        return i;
      }
      function E(e) {
        return (E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function C(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== E(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== E(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === E(e) ? e : String(e);
          }(i.key), i);
        }
      }
      var T = function () {
          function x(e, t) {
            if (!((this || _global) instanceof x)) throw new TypeError("Cannot call a class as a function");
            (this || _global).editor = e, (this || _global).dom = {}, (this || _global).expanded = !1, t && t instanceof Object ? (this.setField(t.field, t.fieldEditable), "value" in t && this.setValue(t.value, t.type), "internalValue" in t && this.setInternalValue(t.internalValue)) : (this.setField(""), this.setValue(null)), (this || _global)._debouncedOnChangeValue = (0, k.debounce)((this || _global)._onChangeValue.bind(this || _global), x.prototype.DEBOUNCE_INTERVAL), (this || _global)._debouncedOnChangeField = (0, k.debounce)((this || _global)._onChangeField.bind(this || _global), x.prototype.DEBOUNCE_INTERVAL), (this || _global).visibleChilds = this.getMaxVisibleChilds();
          }
          var e, t, n;
          return e = x, (t = [{
            key: "getMaxVisibleChilds",
            value: function () {
              return (this || _global).editor && (this || _global).editor.options && (this || _global).editor.options.maxVisibleChilds ? (this || _global).editor.options.maxVisibleChilds : P;
            }
          }, {
            key: "_updateEditability",
            value: function () {
              var e, t;
              (this || _global).editable = {
                field: !0,
                value: !0
              }, (this || _global).editor && ((this || _global).editable.field = "tree" === (this || _global).editor.options.mode, (this || _global).editable.value = "view" !== (this || _global).editor.options.mode, "tree" !== (this || _global).editor.options.mode && "form" !== (this || _global).editor.options.mode || "function" != typeof (this || _global).editor.options.onEditable || (e = (this || _global).getValue.bind(this || _global), "boolean" == typeof (t = (this || _global).editor.options.onEditable({
                field: (this || _global).field,
                get value() {
                  return e();
                },
                path: this.getPath()
              })) ? ((this || _global).editable.field = t, (this || _global).editable.value = t) : "object" === E(t) && null !== t ? ("boolean" == typeof t.field && ((this || _global).editable.field = t.field), "boolean" == typeof t.value && ((this || _global).editable.value = t.value)) : (console.error("Invalid return value for function onEditable.", "Actual value:", t, ".", "Either a boolean or object { field: boolean, value: boolean } expected."), (this || _global).editable.field = !1, (this || _global).editable.value = !1)));
            }
          }, {
            key: "getPath",
            value: function () {
              for (var e = this || _global, t = []; e;) {
                var n = e.getName();
                void 0 !== n && t.unshift(n), e = e.parent;
              }
              return t;
            }
          }, {
            key: "getInternalPath",
            value: function () {
              for (var e = this || _global, t = []; e;) e.parent && t.unshift(e.getIndex()), e = e.parent;
              return t;
            }
          }, {
            key: "getName",
            value: function () {
              return (this || _global).parent ? "array" !== (this || _global).parent.type ? (this || _global).field : (this || _global).index : void 0;
            }
          }, {
            key: "findNodeByPath",
            value: function (e) {
              if (e) {
                if (0 === e.length) return this || _global;
                if (e.length && (this || _global).childs && (this || _global).childs.length) for (var t = 0; t < (this || _global).childs.length; ++t) if ("" + e[0] == "" + (this || _global).childs[t].getName()) return (this || _global).childs[t].findNodeByPath(e.slice(1));
              }
            }
          }, {
            key: "findNodeByInternalPath",
            value: function (e) {
              if (e) {
                for (var t = this || _global, n = 0; n < e.length && t; n++) var i = e[n], t = t.childs[i];
                return t;
              }
            }
          }, {
            key: "serialize",
            value: function () {
              return {
                value: this.getValue(),
                path: this.getPath()
              };
            }
          }, {
            key: "findNode",
            value: function (e) {
              for (var n = (0, k.parsePath)(e), i = this || _global; i && 0 < n.length;) !function () {
                var t = n.shift();
                if ("number" == typeof t) {
                  if ("array" !== i.type) throw new Error("Cannot get child node at index " + t + ": node is no array");
                  i = i.childs[t];
                } else {
                  if ("object" !== i.type) throw new Error("Cannot get child node " + t + ": node is no object");
                  i = i.childs.filter(function (e) {
                    return e.field === t;
                  })[0];
                }
              }();
              return i;
            }
          }, {
            key: "findParents",
            value: function () {
              for (var e = [], t = (this || _global).parent; t;) e.unshift(t), t = t.parent;
              return e;
            }
          }, {
            key: "setError",
            value: function (e, t) {
              (this || _global).error = e, (this || _global).errorChild = t, (this || _global).dom && (this || _global).dom.tr && this.updateError();
            }
          }, {
            key: "updateError",
            value: function () {
              var n = this || _global,
                i = (this || _global).fieldError || (this || _global).valueError || (this || _global).error,
                e = (this || _global).dom.tdError;
              if (i && (this || _global).dom && (this || _global).dom.tr) {
                (0, k.addClassName)((this || _global).dom.tr, "jsoneditor-validation-error"), e || (e = document.createElement("td"), (this || _global).dom.tdError = e, (this || _global).dom.tdValue.parentNode.appendChild(e));
                var o = document.createElement("button"),
                  t = (o.type = "button", o.className = "jsoneditor-button jsoneditor-schema-error", function () {
                    n.dom.popupAnchor && n.dom.popupAnchor.destroy();
                  }),
                  r = function () {
                    delete n.dom.popupAnchor;
                  },
                  s = function (e) {
                    var t = n.editor.frame,
                      e = (n.dom.popupAnchor = (0, d.w)(o, n.editor.getPopupAnchor(), r, e), o.getBoundingClientRect()),
                      t = 120 < t.getBoundingClientRect().width - e.x ? "jsoneditor-above" : "jsoneditor-left",
                      e = document.createElement("div");
                    e.className = "jsoneditor-popover " + t, e.appendChild(document.createTextNode(i.message)), n.dom.popupAnchor.appendChild(e);
                  },
                  a = (o.onmouseover = function () {
                    n.dom.popupAnchor || s(!0);
                  }, o.onfocus = function () {
                    t(), s(!1);
                  }, o.onblur = function () {
                    t();
                  }, (this || _global).errorChild);
                for (a && (o.onclick = function () {
                  a.findParents().forEach(function (e) {
                    e.expand(!1);
                  }), a.scrollTo(function () {
                    a.focus();
                  });
                }); e.firstChild;) e.removeChild(e.firstChild);
                e.appendChild(o);
              } else (this || _global).dom.tr && (0, k.removeClassName)((this || _global).dom.tr, "jsoneditor-validation-error"), e && ((this || _global).dom.tdError.parentNode.removeChild((this || _global).dom.tdError), delete (this || _global).dom.tdError);
            }
          }, {
            key: "getIndex",
            value: function () {
              var e;
              return (this || _global).parent ? -1 !== (e = (this || _global).parent.childs.indexOf(this || _global)) ? e : null : -1;
            }
          }, {
            key: "setParent",
            value: function (e) {
              (this || _global).parent = e;
            }
          }, {
            key: "setField",
            value: function (e, t) {
              (this || _global).field = e, (this || _global).previousField = e, (this || _global).fieldEditable = !0 === t;
            }
          }, {
            key: "getField",
            value: function () {
              return void 0 === (this || _global).field && this._getDomField(), (this || _global).field;
            }
          }, {
            key: "setValue",
            value: function (e, t) {
              var n,
                i,
                o,
                r,
                s,
                a,
                l = (this || _global).childs;
              if ((this || _global).type = this._getType(e), t && t !== (this || _global).type) {
                if ("string" !== t || "auto" !== (this || _global).type) throw new Error("Type mismatch: cannot cast value of type \"" + (this || _global).type + " to the specified type \"" + t + "\"");
                (this || _global).type = t;
              }
              if ("array" === (this || _global).type) {
                for ((this || _global).childs || ((this || _global).childs = []), n = 0; n < e.length; n++) void 0 === (s = e[n]) || s instanceof Function || (n < (this || _global).childs.length ? ((o = (this || _global).childs[n]).fieldEditable = !1, o.index = n, o.setValue(s)) : (o = new x((this || _global).editor, {
                  value: s
                }), r = n < this.getMaxVisibleChilds(), this.appendChild(o, r, !1)));
                for (i = (this || _global).childs.length; i >= e.length; i--) this.removeChild((this || _global).childs[i], !1);
              } else if ("object" === (this || _global).type) {
                for ((this || _global).childs || ((this || _global).childs = []), i = (this || _global).childs.length - 1; 0 <= i; i--) v(e, (this || _global).childs[i].field) || this.removeChild((this || _global).childs[i], !1);
                for (var c in n = 0, e) v(e, c) && (void 0 === (s = e[c]) || s instanceof Function || ((a = this.findChildByProperty(c)) ? (a.setField(c, !0), a.setValue(s)) : (a = new x((this || _global).editor, {
                  field: c,
                  value: s
                }), c = n < this.getMaxVisibleChilds(), this.appendChild(a, c, !1))), n++);
                !((this || _global).value = "") === (this || _global).editor.options.sortObjectKeys && this.sort([], "asc", !1);
              } else this.hideChilds(), delete (this || _global).append, delete (this || _global).showMore, delete (this || _global).expanded, delete (this || _global).childs, (this || _global).value = e;
              Array.isArray(l) !== Array.isArray((this || _global).childs) && this.recreateDom(), this.updateDom({
                updateIndexes: !0
              }), (this || _global).previousValue = (this || _global).value;
            }
          }, {
            key: "setInternalValue",
            value: function (e) {
              var t,
                n,
                i,
                o,
                r,
                s = (this || _global).childs;
              if ((this || _global).type = e.type, "array" === e.type) {
                for ((this || _global).childs || ((this || _global).childs = []), o = 0; o < e.childs.length; o++) void 0 === (t = e.childs[o]) || t instanceof Function || (o < (this || _global).childs.length ? ((n = (this || _global).childs[o]).fieldEditable = !1, n.index = o, n.setInternalValue(t)) : (n = new x((this || _global).editor, {
                  internalValue: t
                }), i = o < this.getMaxVisibleChilds(), this.appendChild(n, i, !1)));
                for (r = (this || _global).childs.length; r >= e.childs.length; r--) this.removeChild((this || _global).childs[r], !1);
              } else if ("object" === e.type) {
                for ((this || _global).childs || ((this || _global).childs = []), o = 0; o < e.childs.length; o++) void 0 === (t = e.childs[o]) || t instanceof Function || (o < (this || _global).childs.length ? (delete (n = (this || _global).childs[o]).index, n.setField(t.field, !0), n.setInternalValue(t.value)) : (n = new x((this || _global).editor, {
                  field: t.field,
                  internalValue: t.value
                }), i = o < this.getMaxVisibleChilds(), this.appendChild(n, i, !1)));
                for (r = (this || _global).childs.length; r >= e.childs.length; r--) this.removeChild((this || _global).childs[r], !1);
              } else this.hideChilds(), delete (this || _global).append, delete (this || _global).showMore, delete (this || _global).expanded, delete (this || _global).childs, (this || _global).value = e.value;
              Array.isArray(s) !== Array.isArray((this || _global).childs) && this.recreateDom(), this.updateDom({
                updateIndexes: !0
              }), (this || _global).previousValue = (this || _global).value;
            }
          }, {
            key: "recreateDom",
            value: function () {
              var e;
              (this || _global).dom && (this || _global).dom.tr && (this || _global).dom.tr.parentNode ? (e = this._detachFromDom(), this.clearDom(), this._attachToDom(e)) : this.clearDom();
            }
          }, {
            key: "getValue",
            value: function () {
              var t, n;
              return "array" === (this || _global).type ? (t = [], (this || _global).childs.forEach(function (e) {
                t.push(e.getValue());
              }), t) : "object" === (this || _global).type ? (n = {}, (this || _global).childs.forEach(function (e) {
                n[e.getField()] = e.getValue();
              }), n) : (void 0 === (this || _global).value && this._getDomValue(), (this || _global).value);
            }
          }, {
            key: "getInternalValue",
            value: function () {
              return "array" === (this || _global).type ? {
                type: (this || _global).type,
                childs: (this || _global).childs.map(function (e) {
                  return e.getInternalValue();
                })
              } : "object" === (this || _global).type ? {
                type: (this || _global).type,
                childs: (this || _global).childs.map(function (e) {
                  return {
                    field: e.getField(),
                    value: e.getInternalValue()
                  };
                })
              } : (void 0 === (this || _global).value && this._getDomValue(), {
                type: (this || _global).type,
                value: (this || _global).value
              });
            }
          }, {
            key: "getLevel",
            value: function () {
              return (this || _global).parent ? (this || _global).parent.getLevel() + 1 : 0;
            }
          }, {
            key: "getNodePath",
            value: function () {
              var e = (this || _global).parent ? (this || _global).parent.getNodePath() : [];
              return e.push(this || _global), e;
            }
          }, {
            key: "clone",
            value: function () {
              var t, n;
              return (t = new x((this || _global).editor)).type = (this || _global).type, t.field = (this || _global).field, t.fieldInnerText = (this || _global).fieldInnerText, t.fieldEditable = (this || _global).fieldEditable, t.previousField = (this || _global).previousField, t.value = (this || _global).value, t.valueInnerText = (this || _global).valueInnerText, t.previousValue = (this || _global).previousValue, t.expanded = (this || _global).expanded, t.visibleChilds = (this || _global).visibleChilds, (this || _global).childs ? (n = [], (this || _global).childs.forEach(function (e) {
                e = e.clone();
                e.setParent(t), n.push(e);
              }), t.childs = n) : t.childs = void 0, t;
            }
          }, {
            key: "expand",
            value: function (t) {
              (this || _global).childs && ((this || _global).expanded = !0, (this || _global).dom.expand && ((this || _global).dom.expand.className = "jsoneditor-button jsoneditor-expanded"), this.showChilds(), !1 !== t && (this || _global).childs.forEach(function (e) {
                e.expand(t);
              }), this.updateDom({
                recurse: !1
              }));
            }
          }, {
            key: "collapse",
            value: function (t) {
              (this || _global).childs && (this.hideChilds(), !1 !== t && (this || _global).childs.forEach(function (e) {
                e.collapse(t);
              }), (this || _global).dom.expand && ((this || _global).dom.expand.className = "jsoneditor-button jsoneditor-collapsed"), (this || _global).expanded = !1, this.updateDom({
                recurse: !1
              }));
            }
          }, {
            key: "showChilds",
            value: function () {
              var e = (this || _global).childs;
              if (e && (this || _global).expanded) {
                var e = (this || _global).dom.tr,
                  t = e ? e.parentNode : void 0;
                if (t) {
                  for (var n = this.getAppendDom(), i = (n.parentNode || ((o = e.nextSibling) ? t.insertBefore(n, o) : t.appendChild(n)), Math.min((this || _global).childs.length, (this || _global).visibleChilds)), o = this._getNextTr(), r = 0; r < i; r++) {
                    var s = (this || _global).childs[r];
                    s.getDom().parentNode || t.insertBefore(s.getDom(), o), s.showChilds();
                  }
                  e = this.getShowMoreDom();
                  o = this._getNextTr(), e.parentNode || t.insertBefore(e, o), (this || _global).showMore.updateDom();
                }
              }
            }
          }, {
            key: "_getNextTr",
            value: function () {
              return (this || _global).showMore && (this || _global).showMore.getDom().parentNode ? (this || _global).showMore.getDom() : (this || _global).append && (this || _global).append.getDom().parentNode ? (this || _global).append.getDom() : void 0;
            }
          }, {
            key: "hide",
            value: function (e) {
              var t = (this || _global).dom.tr,
                n = t ? t.parentNode : void 0;
              n && n.removeChild(t), (this || _global).dom.popupAnchor && (this || _global).dom.popupAnchor.destroy(), this.hideChilds(e);
            }
          }, {
            key: "hideChilds",
            value: function (e) {
              var t;
              (this || _global).childs && (this || _global).expanded && ((t = this.getAppendDom()).parentNode && t.parentNode.removeChild(t), (this || _global).childs.forEach(function (e) {
                e.hide();
              }), (t = this.getShowMoreDom()).parentNode && t.parentNode.removeChild(t), e && !e.resetVisibleChilds || ((this || _global).visibleChilds = this.getMaxVisibleChilds()));
            }
          }, {
            key: "_updateCssClassName",
            value: function () {
              var e, t;
              (this || _global).dom.field && (this || _global).editor && (this || _global).editor.options && "function" == typeof (this || _global).editor.options.onClassName && (this || _global).dom.tree && ((0, k.removeAllClassNames)((this || _global).dom.tree), e = (this || _global).getValue.bind(this || _global), t = (this || _global).editor.options.onClassName({
                path: this.getPath(),
                field: (this || _global).field,
                get value() {
                  return e();
                }
              }) || "", (0, k.addClassName)((this || _global).dom.tree, "jsoneditor-values " + t));
            }
          }, {
            key: "recursivelyUpdateCssClassesOnNodes",
            value: function () {
              if (this._updateCssClassName(), Array.isArray((this || _global).childs)) for (var e = 0; e < (this || _global).childs.length; e++) (this || _global).childs[e].recursivelyUpdateCssClassesOnNodes();
            }
          }, {
            key: "expandTo",
            value: function () {
              for (var e = (this || _global).parent; e;) e.expanded || e.expand(), e = e.parent;
            }
          }, {
            key: "appendChild",
            value: function (e, t, n) {
              var i, o;
              this._hasChilds() && (e.setParent(this || _global), e.fieldEditable = "object" === (this || _global).type, "array" === (this || _global).type && (e.index = (this || _global).childs.length), "object" === (this || _global).type && void 0 === e.field && e.setField(""), (this || _global).childs.push(e), (this || _global).expanded && !1 !== t && (t = e.getDom(), o = (i = this._getNextTr()) ? i.parentNode : void 0, i && o && o.insertBefore(t, i), e.showChilds(), (this || _global).visibleChilds++), !1 !== n) && (this.updateDom({
                updateIndexes: !0
              }), e.updateDom({
                recurse: !0
              }));
            }
          }, {
            key: "moveBefore",
            value: function (e, t, n) {
              var i, o, r;
              this._hasChilds() && ((i = (this || _global).dom.tr ? (this || _global).dom.tr.parentNode : void 0) && ((o = document.createElement("tr")).style.height = i.clientHeight + "px", i.appendChild(o)), e.parent && e.parent.removeChild(e), t instanceof _ || !t ? (this || _global).childs.length + 1 > (this || _global).visibleChilds ? (r = (this || _global).childs[(this || _global).visibleChilds - 1], this.insertBefore(e, r, n)) : this.appendChild(e, !0, n) : this.insertBefore(e, t, n), i) && o && i.removeChild(o);
            }
          }, {
            key: "insertBefore",
            value: function (e, t, n) {
              if (this._hasChilds()) {
                if ((this || _global).visibleChilds++, "object" === (this || _global).type && void 0 === e.field && e.setField(""), t === (this || _global).append) e.setParent(this || _global), e.fieldEditable = "object" === (this || _global).type, (this || _global).childs.push(e);else {
                  var i = (this || _global).childs.indexOf(t);
                  if (-1 === i) throw new Error("Node not found");
                  e.setParent(this || _global), e.fieldEditable = "object" === (this || _global).type, (this || _global).childs.splice(i, 0, e);
                }
                var o;
                (this || _global).expanded && (i = e.getDom(), o = (t = t.getDom()) ? t.parentNode : void 0, t && o && o.insertBefore(i, t), e.showChilds(), this.showChilds()), !1 !== n && (this.updateDom({
                  updateIndexes: !0
                }), e.updateDom({
                  recurse: !0
                }));
              }
            }
          }, {
            key: "insertAfter",
            value: function (e, t) {
              this._hasChilds() && (t = (this || _global).childs.indexOf(t), (t = (this || _global).childs[t + 1]) ? this.insertBefore(e, t) : this.appendChild(e));
            }
          }, {
            key: "search",
            value: function (t, n) {
              Array.isArray(n) || (n = []);
              var e = t ? t.toLowerCase() : void 0;
              return delete (this || _global).searchField, delete (this || _global).searchValue, void 0 !== (this || _global).field && n.length <= (this || _global).MAX_SEARCH_RESULTS && (-1 !== String((this || _global).field).toLowerCase().indexOf(e) && ((this || _global).searchField = !0, n.push({
                node: this || _global,
                elem: "field"
              })), this._updateDomField()), this._hasChilds() ? (this || _global).childs && (this || _global).childs.forEach(function (e) {
                e.search(t, n);
              }) : void 0 !== (this || _global).value && n.length <= (this || _global).MAX_SEARCH_RESULTS && (-1 !== String((this || _global).value).toLowerCase().indexOf(e) && ((this || _global).searchValue = !0, n.push({
                node: this || _global,
                elem: "value"
              })), this._updateDomValue()), n;
            }
          }, {
            key: "scrollTo",
            value: function (e) {
              this.expandPathToNode(), (this || _global).dom.tr && (this || _global).dom.tr.parentNode && (this || _global).editor.scrollTo((this || _global).dom.tr.offsetTop, e);
            }
          }, {
            key: "expandPathToNode",
            value: function () {
              for (var e = this || _global; e && e.parent;) {
                for (var t = "array" === e.parent.type ? e.index : e.parent.childs.indexOf(e); e.parent.visibleChilds < t + 1;) e.parent.visibleChilds += this.getMaxVisibleChilds();
                e.parent.expand(!1), e = e.parent;
              }
            }
          }, {
            key: "focus",
            value: function (e) {
              if (x.focusElement = e, (this || _global).dom.tr && (this || _global).dom.tr.parentNode) {
                var t = (this || _global).dom;
                switch (e) {
                  case "drag":
                    (t.drag || t.menu).focus();
                    break;
                  case "menu":
                    t.menu.focus();
                    break;
                  case "expand":
                    this._hasChilds() ? t.expand.focus() : t.field && (this || _global).fieldEditable ? (t.field.focus(), (0, k.selectContentEditable)(t.field)) : t.value && !this._hasChilds() ? (t.value.focus(), (0, k.selectContentEditable)(t.value)) : t.menu.focus();
                    break;
                  case "field":
                    t.field && (this || _global).fieldEditable ? (t.field.focus(), (0, k.selectContentEditable)(t.field)) : t.value && !this._hasChilds() ? (t.value.focus(), (0, k.selectContentEditable)(t.value)) : (this._hasChilds() ? t.expand : t.menu).focus();
                    break;
                  default:
                    t.select ? t.select.focus() : t.value && !this._hasChilds() ? (t.value.focus(), (0, k.selectContentEditable)(t.value)) : t.field && (this || _global).fieldEditable ? (t.field.focus(), (0, k.selectContentEditable)(t.field)) : (this._hasChilds() ? t.expand : t.menu).focus();
                }
              }
            }
          }, {
            key: "containsNode",
            value: function (e) {
              if ((this || _global) === e) return !0;
              var t = (this || _global).childs;
              if (t) for (var n = 0, i = t.length; n < i; n++) if (t[n].containsNode(e)) return !0;
              return !1;
            }
          }, {
            key: "removeChild",
            value: function (e, t) {
              if ((this || _global).childs) {
                var n = (this || _global).childs.indexOf(e);
                if (-1 !== n) return n < (this || _global).visibleChilds && (this || _global).expanded && (this || _global).visibleChilds--, e.hide(), delete e.searchField, delete e.searchValue, (e = (this || _global).childs.splice(n, 1)[0]).parent = null, !1 !== t && this.updateDom({
                  updateIndexes: !0
                }), e;
              }
            }
          }, {
            key: "_remove",
            value: function (e) {
              this.removeChild(e);
            }
          }, {
            key: "changeType",
            value: function (e) {
              var t,
                n = (this || _global).type;
              n !== e && ("string" !== e && "auto" !== e || "string" !== n && "auto" !== n ? (t = this._detachFromDom(), this.clearDom(), "object" === ((this || _global).type = e) ? ((this || _global).childs || ((this || _global).childs = []), (this || _global).childs.forEach(function (e) {
                e.clearDom(), delete e.index, e.fieldEditable = !0, void 0 === e.field && (e.field = "");
              }), "string" !== n && "auto" !== n || ((this || _global).expanded = !0)) : "array" === e ? ((this || _global).childs || ((this || _global).childs = []), (this || _global).childs.forEach(function (e, t) {
                e.clearDom(), e.fieldEditable = !1, e.index = t;
              }), "string" !== n && "auto" !== n || ((this || _global).expanded = !0)) : (this || _global).expanded = !1, this._attachToDom(t)) : (this || _global).type = e, "auto" !== e && "string" !== e || ((this || _global).value = "string" === e ? String((this || _global).value) : (0, k.parseString)(String((this || _global).value)), this.focus()), this.updateDom({
                updateIndexes: !0
              }));
            }
          }, {
            key: "deepEqual",
            value: function (e) {
              var t;
              if ("array" === (this || _global).type) {
                if (!Array.isArray(e)) return !1;
                if ((this || _global).childs.length !== e.length) return !1;
                for (t = 0; t < (this || _global).childs.length; t++) if (!(this || _global).childs[t].deepEqual(e[t])) return !1;
              } else if ("object" === (this || _global).type) {
                if ("object" !== E(e) || !e) return !1;
                var n = Object.keys(e);
                if ((this || _global).childs.length !== n.length) return !1;
                for (t = 0; t < n.length; t++) {
                  var i = (this || _global).childs[t];
                  if (i.field !== n[t] || !i.deepEqual(e[i.field])) return !1;
                }
              } else if ((this || _global).value !== e) return !1;
              return !0;
            }
          }, {
            key: "_getDomValue",
            value: function () {
              if (this._clearValueError(), (this || _global).dom.value && "array" !== (this || _global).type && "object" !== (this || _global).type && ((this || _global).valueInnerText = (0, k.getInnerText)((this || _global).dom.value), "" === (this || _global).valueInnerText) && "" !== (this || _global).dom.value.innerHTML && ((this || _global).dom.value.textContent = ""), void 0 !== (this || _global).valueInnerText) try {
                var e, t;
                (t = "string" === (this || _global).type ? this._unescapeHTML((this || _global).valueInnerText) : (e = this._unescapeHTML((this || _global).valueInnerText), (0, k.parseString)(e))) !== (this || _global).value && ((this || _global).value = t, this._debouncedOnChangeValue());
              } catch (e) {
                this._setValueError((0, l.Iu)("cannotParseValueError"));
              }
            }
          }, {
            key: "_setValueError",
            value: function (e) {
              (this || _global).valueError = {
                message: e
              }, this.updateError();
            }
          }, {
            key: "_clearValueError",
            value: function () {
              (this || _global).valueError && ((this || _global).valueError = null, this.updateError());
            }
          }, {
            key: "_setFieldError",
            value: function (e) {
              (this || _global).fieldError = {
                message: e
              }, this.updateError();
            }
          }, {
            key: "_clearFieldError",
            value: function () {
              (this || _global).fieldError && ((this || _global).fieldError = null, this.updateError());
            }
          }, {
            key: "_onChangeValue",
            value: function () {
              var e,
                t = (this || _global).editor.getDomSelection(),
                n = (t.range && (n = (0, k.textDiff)(String((this || _global).value), String((this || _global).previousValue)), t.range.startOffset = n.start, t.range.endOffset = n.end), (this || _global).editor.getDomSelection());
              n.range && (e = (0, k.textDiff)(String((this || _global).previousValue), String((this || _global).value)), n.range.startOffset = e.start, n.range.endOffset = e.end), (this || _global).editor._onAction("editValue", {
                path: this.getInternalPath(),
                oldValue: (this || _global).previousValue,
                newValue: (this || _global).value,
                oldSelection: t,
                newSelection: n
              }), (this || _global).previousValue = (this || _global).value;
            }
          }, {
            key: "_onChangeField",
            value: function () {
              var e = (this || _global).editor.getDomSelection(),
                t = (this || _global).previousField || "",
                n = (e.range && (n = (0, k.textDiff)((this || _global).field, t), e.range.startOffset = n.start, e.range.endOffset = n.end), (this || _global).editor.getDomSelection());
              n.range && (t = (0, k.textDiff)(t, (this || _global).field), n.range.startOffset = t.start, n.range.endOffset = t.end), (this || _global).editor._onAction("editField", {
                parentPath: (this || _global).parent.getInternalPath(),
                index: this.getIndex(),
                oldValue: (this || _global).previousField,
                newValue: (this || _global).field,
                oldSelection: e,
                newSelection: n
              }), (this || _global).previousField = (this || _global).field;
            }
          }, {
            key: "_updateDomValue",
            value: function () {
              var e = (this || _global).dom.value;
              if (e) {
                var t = ["jsoneditor-value"],
                  n = (this || _global).value,
                  i = "auto" === (this || _global).type ? (0, k.getType)(n) : (this || _global).type,
                  o = "string" === i && (0, k.isUrl)(n);
                if (t.push("jsoneditor-" + i), o && t.push("jsoneditor-url"), "" === String((this || _global).value) && "array" !== (this || _global).type && "object" !== (this || _global).type && t.push("jsoneditor-empty"), (this || _global).searchValueActive && t.push("jsoneditor-highlight-active"), (this || _global).searchValue && t.push("jsoneditor-highlight"), e.className = t.join(" "), "array" === i || "object" === i ? (t = (this || _global).childs ? (this || _global).childs.length : 0, e.title = (this || _global).type + " containing " + t + " items") : o && (this || _global).editable.value ? e.title = (0, l.Iu)("openUrl") : e.title = "", "boolean" === i && (this || _global).editable.value ? ((this || _global).dom.checkbox || ((this || _global).dom.checkbox = document.createElement("input"), (this || _global).dom.checkbox.type = "checkbox", (this || _global).dom.tdCheckbox = document.createElement("td"), (this || _global).dom.tdCheckbox.className = "jsoneditor-tree", (this || _global).dom.tdCheckbox.appendChild((this || _global).dom.checkbox), (this || _global).dom.tdValue.parentNode.insertBefore((this || _global).dom.tdCheckbox, (this || _global).dom.tdValue)), (this || _global).dom.checkbox.checked = (this || _global).value) : (this || _global).dom.tdCheckbox && ((this || _global).dom.tdCheckbox.parentNode.removeChild((this || _global).dom.tdCheckbox), delete (this || _global).dom.tdCheckbox, delete (this || _global).dom.checkbox), (this || _global).enum && (this || _global).editable.value ? ((this || _global).dom.select || ((this || _global).dom.select = document.createElement("select"), (this || _global).id = (this || _global).field + "_" + new Date().getUTCMilliseconds(), (this || _global).dom.select.id = (this || _global).id, (this || _global).dom.select.name = (this || _global).dom.select.id, (t = document.createElement("option")).value = "", t.textContent = "--", (this || _global).dom.select.appendChild(t), this._updateEnumOptions(), (this || _global).dom.tdSelect = document.createElement("td"), (this || _global).dom.tdSelect.className = "jsoneditor-tree", (this || _global).dom.tdSelect.appendChild((this || _global).dom.select), (this || _global).dom.tdValue.parentNode.insertBefore((this || _global).dom.tdSelect, (this || _global).dom.tdValue)), (this || _global).dom.select.value = -1 !== (this || _global).enum.indexOf((this || _global).value) ? (this || _global).value : "", !(this || _global).schema || v((this || _global).schema, "oneOf") || v((this || _global).schema, "anyOf") || v((this || _global).schema, "allOf") ? delete (this || _global).valueFieldHTML : ((this || _global).valueFieldHTML = (this || _global).dom.tdValue.innerHTML, (this || _global).dom.tdValue.style.visibility = "hidden", (this || _global).dom.tdValue.textContent = "")) : (this || _global).dom.tdSelect && ((this || _global).dom.tdSelect.parentNode.removeChild((this || _global).dom.tdSelect), delete (this || _global).dom.tdSelect, delete (this || _global).dom.select, (this || _global).dom.tdValue.innerHTML = (this || _global).valueFieldHTML, (this || _global).dom.tdValue.style.visibility = "", delete (this || _global).valueFieldHTML, (this || _global).dom.tdValue.appendChild((this || _global).dom.value)), (this || _global).editor.options.colorPicker && "string" == typeof n && (0, k.isValidColor)(n) ? ((this || _global).dom.color || ((this || _global).dom.color = document.createElement("div"), (this || _global).dom.color.className = "jsoneditor-color", (this || _global).dom.tdColor = document.createElement("td"), (this || _global).dom.tdColor.className = "jsoneditor-tree", (this || _global).dom.tdColor.appendChild((this || _global).dom.color), (this || _global).dom.tdValue.parentNode.insertBefore((this || _global).dom.tdColor, (this || _global).dom.tdValue)), (0, k.addClassName)((this || _global).dom.value, "jsoneditor-color-value"), ((this || _global).editable.value ? (0, k.removeClassName) : (0, k.addClassName))((this || _global).dom.color, "jsoneditor-color-readonly"), (this || _global).dom.color.style.backgroundColor = n) : this._deleteDomColor(), this._showTimestampTag()) {
                  (this || _global).dom.date || ((this || _global).dom.date = document.createElement("div"), (this || _global).dom.date.className = "jsoneditor-date", (this || _global).dom.value.parentNode.appendChild((this || _global).dom.date));
                  o = null;
                  if (o = "function" == typeof (this || _global).editor.options.timestampFormat ? (this || _global).editor.options.timestampFormat({
                    field: (this || _global).field,
                    value: (this || _global).value,
                    path: this.getPath()
                  }) : o) {
                    for (; (this || _global).dom.date.firstChild;) (this || _global).dom.date.removeChild((this || _global).dom.date.firstChild);
                    (this || _global).dom.date.appendChild(document.createTextNode(o));
                  } else (this || _global).dom.date.textContent = new Date(n).toISOString();
                  (this || _global).dom.date.title = new Date(n).toString();
                } else (this || _global).dom.date && ((this || _global).dom.date.parentNode.removeChild((this || _global).dom.date), delete (this || _global).dom.date);
                (0, k.stripFormatting)(e), this._updateDomDefault();
              }
            }
          }, {
            key: "_updateEnumOptions",
            value: function () {
              if ((this || _global).enum && (this || _global).dom.select) {
                (this || _global).dom.select.innerHTML = "";
                for (var e = 0; e < (this || _global).enum.length; e++) {
                  var t = document.createElement("option");
                  t.value = (this || _global).enum[e], t.textContent = (this || _global).enum[e], (this || _global).dom.select.appendChild(t);
                }
              }
            }
          }, {
            key: "_deleteDomColor",
            value: function () {
              (this || _global).dom.color && ((this || _global).dom.tdColor.parentNode.removeChild((this || _global).dom.tdColor), delete (this || _global).dom.tdColor, delete (this || _global).dom.color, (0, k.removeClassName)((this || _global).dom.value, "jsoneditor-color-value"));
            }
          }, {
            key: "_updateDomField",
            value: function () {
              var e,
                t = (this || _global).dom.field;
              t && ((e = (0, k.makeFieldTooltip)((this || _global).schema, (this || _global).editor.options.language)) && (t.title = e), ("" === String((this || _global).field) && (this || _global).parent && "array" !== (this || _global).parent.type ? (0, k.addClassName) : (0, k.removeClassName))(t, "jsoneditor-empty"), ((this || _global).searchFieldActive ? (0, k.addClassName) : (0, k.removeClassName))(t, "jsoneditor-highlight-active"), ((this || _global).searchField ? (0, k.addClassName) : (0, k.removeClassName))(t, "jsoneditor-highlight"), (0, k.stripFormatting)(t));
            }
          }, {
            key: "_getDomField",
            value: function (e) {
              if (this._clearFieldError(), (this || _global).dom.field && (this || _global).fieldEditable && ((this || _global).fieldInnerText = (0, k.getInnerText)((this || _global).dom.field), "" === (this || _global).fieldInnerText) && "" !== (this || _global).dom.field.innerHTML && ((this || _global).dom.field.textContent = ""), void 0 !== (this || _global).fieldInnerText) try {
                var t = this._unescapeHTML((this || _global).fieldInnerText),
                  n = (this || _global).parent.getFieldNames(this || _global);
                -1 !== n.indexOf(t) ? e ? (t = (0, k.findUniqueName)(t, n)) !== (this || _global).field && ((this || _global).field = t, this._debouncedOnChangeField()) : this._setFieldError((0, l.Iu)("duplicateFieldError")) : t !== (this || _global).field && ((this || _global).field = t, this._debouncedOnChangeField());
              } catch (e) {
                this._setFieldError((0, l.Iu)("cannotParseFieldError"));
              }
            }
          }, {
            key: "_updateDomDefault",
            value: function () {
              var e;
              (this || _global).schema && void 0 !== (this || _global).schema.default && !this._hasChilds() && (e = (this || _global).dom.select || (this || _global).dom.value) && ((this || _global).value === (this || _global).schema.default ? (e.title = (0, l.Iu)("default"), (0, k.addClassName)(e, "jsoneditor-is-default"), k.removeClassName) : (e.removeAttribute("title"), (0, k.removeClassName)(e, "jsoneditor-is-default"), k.addClassName))(e, "jsoneditor-is-not-default");
            }
          }, {
            key: "_showTimestampTag",
            value: function () {
              var e, t;
              return "number" == typeof (this || _global).value && ("function" == typeof (e = (this || _global).editor.options.timestampTag) ? "boolean" == typeof (t = e({
                field: (this || _global).field,
                value: (this || _global).value,
                path: this.getPath()
              })) ? t : (0, k.isTimestamp)((this || _global).field, (this || _global).value) : !0 === e && (0, k.isTimestamp)((this || _global).field, (this || _global).value));
            }
          }, {
            key: "clearDom",
            value: function () {
              (this || _global).dom = {};
            }
          }, {
            key: "getDom",
            value: function () {
              var e,
                t,
                n = (this || _global).dom;
              return n.tr || (this._updateEditability(), n.tr = document.createElement("tr"), "tree" === (n.tr.node = this || _global).editor.options.mode && (t = document.createElement("td"), (this || _global).editable.field && (this || _global).parent && ((e = document.createElement("button")).type = "button", (n.drag = e).className = "jsoneditor-button jsoneditor-dragarea", e.title = (0, l.Iu)("drag"), t.appendChild(e)), n.tr.appendChild(t), e = document.createElement("td"), (t = document.createElement("button")).type = "button", (n.menu = t).className = "jsoneditor-button jsoneditor-contextmenu-button", t.title = (0, l.Iu)("actionsMenu"), e.appendChild(n.menu), n.tr.appendChild(e)), t = document.createElement("td"), n.tr.appendChild(t), n.tree = this._createDomTree(), t.appendChild(n.tree), this.updateDom({
                updateIndexes: !0
              })), n.tr;
            }
          }, {
            key: "isVisible",
            value: function () {
              return (this || _global).dom && (this || _global).dom.tr && (this || _global).dom.tr.parentNode || !1;
            }
          }, {
            key: "isDescendantOf",
            value: function (e) {
              for (var t = (this || _global).parent; t;) {
                if (t === e) return !0;
                t = t.parent;
              }
              return !1;
            }
          }, {
            key: "_createDomField",
            value: function () {
              return document.createElement("div");
            }
          }, {
            key: "setHighlight",
            value: function (t) {
              (this || _global).dom.tr && ((t ? (0, k.addClassName) : (0, k.removeClassName))((this || _global).dom.tr, "jsoneditor-highlight"), (this || _global).append && (this || _global).append.setHighlight(t), (this || _global).childs) && (this || _global).childs.forEach(function (e) {
                e.setHighlight(t);
              });
            }
          }, {
            key: "setSelected",
            value: function (t, e) {
              (this || _global).selected = t, (this || _global).dom.tr && ((t ? (0, k.addClassName) : (0, k.removeClassName))((this || _global).dom.tr, "jsoneditor-selected"), (e ? (0, k.addClassName) : (0, k.removeClassName))((this || _global).dom.tr, "jsoneditor-first"), (this || _global).append && (this || _global).append.setSelected(t), (this || _global).showMore && (this || _global).showMore.setSelected(t), (this || _global).childs) && (this || _global).childs.forEach(function (e) {
                e.setSelected(t);
              });
            }
          }, {
            key: "updateValue",
            value: function (e) {
              (this || _global).value = e, (this || _global).previousValue = e, (this || _global).valueError = void 0, this.updateDom();
            }
          }, {
            key: "updateField",
            value: function (e) {
              (this || _global).field = e, (this || _global).previousField = e, (this || _global).fieldError = void 0, this.updateDom();
            }
          }, {
            key: "updateDom",
            value: function (t) {
              var e,
                n = (this || _global).dom.tree,
                n = (n && (n.style.marginLeft = 24 * this.getLevel() + "px"), (this || _global).dom.field),
                n = (n && ((this || _global).fieldEditable ? (n.contentEditable = (this || _global).editable.field, n.spellcheck = !1, n.className = "jsoneditor-field") : (n.contentEditable = !1, n.className = "jsoneditor-readonly"), e = void 0 !== (this || _global).index ? (this || _global).index : void 0 !== (this || _global).field ? (this || _global).field : (e = (this || _global).editor.options.schema ? x._findSchema((this || _global).editor.options.schema, (this || _global).editor.options.schemaRefs || {}, this.getPath()) : void 0) && e.title ? e.title : this._hasChilds() ? (this || _global).type : "", e = this._escapeHTML(e), document.activeElement !== n && e !== this._unescapeHTML((0, k.getInnerText)(n)) && (n.innerHTML = e), this._updateSchema(), this._updateEnumOptions()), (this || _global).dom.value),
                n = (n && ("array" === (this || _global).type || "object" === (this || _global).type ? this.updateNodeName() : (e = this._escapeHTML((this || _global).value), document.activeElement !== n && e !== this._unescapeHTML((0, k.getInnerText)(n)) && (n.innerHTML = e))), (this || _global).dom.tr);
              n && ("array" === (this || _global).type || "object" === (this || _global).type ? ((0, k.addClassName)(n, "jsoneditor-expandable"), (this || _global).expanded ? ((0, k.addClassName)(n, "jsoneditor-expanded"), (0, k.removeClassName)(n, "jsoneditor-collapsed")) : ((0, k.addClassName)(n, "jsoneditor-collapsed"), (0, k.removeClassName)(n, "jsoneditor-expanded"))) : ((0, k.removeClassName)(n, "jsoneditor-expandable"), (0, k.removeClassName)(n, "jsoneditor-expanded"), (0, k.removeClassName)(n, "jsoneditor-collapsed"))), this._updateDomField(), this._updateDomValue(), t && !0 === t.updateIndexes && this._updateDomIndexes(), t && !0 === t.recurse && (this || _global).childs && (this || _global).childs.forEach(function (e) {
                e.updateDom(t);
              }), (this || _global).error && this.updateError(), (this || _global).append && (this || _global).append.updateDom(), (this || _global).showMore && (this || _global).showMore.updateDom(), this._updateCssClassName();
            }
          }, {
            key: "_updateSchema",
            value: function () {
              (this || _global).editor && (this || _global).editor.options && ((this || _global).schema = (this || _global).editor.options.schema ? x._findSchema((this || _global).editor.options.schema, (this || _global).editor.options.schemaRefs || {}, this.getPath()) : null, (this || _global).schema ? (this || _global).enum = x._findEnum((this || _global).schema) : delete (this || _global).enum);
            }
          }, {
            key: "_updateDomIndexes",
            value: function () {
              var e = (this || _global).dom.value,
                t = (this || _global).childs;
              e && t && ("array" === (this || _global).type ? t.forEach(function (e, t) {
                e.index = t;
                e = e.dom.field;
                e && (e.textContent = t);
              }) : "object" === (this || _global).type && t.forEach(function (e) {
                void 0 !== e.index && (delete e.index, void 0 === e.field) && (e.field = "");
              }));
            }
          }, {
            key: "_createDomValue",
            value: function () {
              var e;
              return "array" === (this || _global).type ? (e = document.createElement("div")).textContent = "[...]" : "object" === (this || _global).type ? (e = document.createElement("div")).textContent = "{...}" : (!(this || _global).editable.value && (0, k.isUrl)((this || _global).value) ? (e = document.createElement("a")).href = (this || _global).value : ((e = document.createElement("div")).contentEditable = (this || _global).editable.value, e.spellcheck = !1), e.innerHTML = this._escapeHTML((this || _global).value)), e;
            }
          }, {
            key: "_createDomExpandButton",
            value: function () {
              var e = document.createElement("button");
              return e.type = "button", this._hasChilds() ? (e.className = (this || _global).expanded ? "jsoneditor-button jsoneditor-expanded" : "jsoneditor-button jsoneditor-collapsed", e.title = (0, l.Iu)("expandTitle")) : (e.className = "jsoneditor-button jsoneditor-invisible", e.title = ""), e;
            }
          }, {
            key: "_createDomTree",
            value: function () {
              var e = (this || _global).dom,
                t = document.createElement("table"),
                n = document.createElement("tbody"),
                i = (t.style.borderCollapse = "collapse", t.className = "jsoneditor-values", t.appendChild(n), document.createElement("tr")),
                n = (n.appendChild(i), document.createElement("td")),
                n = (n.className = "jsoneditor-tree", i.appendChild(n), e.expand = this._createDomExpandButton(), n.appendChild(e.expand), e.tdExpand = n, document.createElement("td")),
                n = (n.className = "jsoneditor-tree", i.appendChild(n), e.field = this._createDomField(), n.appendChild(e.field), e.tdField = n, document.createElement("td")),
                n = (n.className = "jsoneditor-tree", i.appendChild(n), "object" !== (this || _global).type && "array" !== (this || _global).type && (n.appendChild(document.createTextNode(":")), n.className = "jsoneditor-separator"), e.tdSeparator = n, document.createElement("td"));
              return n.className = "jsoneditor-tree", i.appendChild(n), e.value = this._createDomValue(), n.appendChild(e.value), e.tdValue = n, t;
            }
          }, {
            key: "onEvent",
            value: function (e) {
              var t,
                n = e.type,
                i = e.target || e.srcElement,
                o = (this || _global).dom,
                r = this || _global,
                s = this._hasChilds(),
                a = (i !== o.drag && i !== o.menu || ("mouseover" === n ? (this || _global).editor.highlighter.highlight(this || _global) : "mouseout" === n && (this || _global).editor.highlighter.unhighlight()), "click" === n && i === o.menu && ((t = r.editor.highlighter).highlight(r), t.lock(), (0, k.addClassName)(o.menu, "jsoneditor-selected"), this.showContextMenu(o.menu, function () {
                  (0, k.removeClassName)(o.menu, "jsoneditor-selected"), t.unlock(), t.unhighlight();
                })), "click" === n && i === o.expand && s && (d = e.ctrlKey, this._onExpand(d)), "click" !== n || e.target !== r.dom.tdColor && e.target !== r.dom.color || !(this || _global).editable.value || this._showColorPicker(), "change" === n && i === o.checkbox && ((this || _global).dom.value.textContent = String(!(this || _global).value), this._getDomValue(), this._updateDomDefault()), "change" === n && i === o.select && ((this || _global).dom.value.innerHTML = this._escapeHTML(o.select.value), this._getDomValue(), this._updateDomValue()), o.value);
              if (i === a) switch (n) {
                case "blur":
                case "change":
                  this._getDomValue(), this._clearValueError(), this._updateDomValue();
                  var l = this._escapeHTML((this || _global).value);
                  l !== this._unescapeHTML((0, k.getInnerText)(a)) && (a.innerHTML = l);
                  break;
                case "input":
                  this._getDomValue(), this._updateDomValue();
                  break;
                case "keydown":
                case "mousedown":
                  (this || _global).editor.selection = (this || _global).editor.getDomSelection();
                  break;
                case "click":
                  e.ctrlKey && (this || _global).editable.value && (0, k.isUrl)((this || _global).value) && (e.preventDefault(), window.open((this || _global).value, "_blank", "noreferrer"));
                  break;
                case "keyup":
                  this._getDomValue(), this._updateDomValue();
                  break;
                case "cut":
                case "paste":
                  setTimeout(function () {
                    r._getDomValue(), r._updateDomValue();
                  }, 1);
              }
              var c = o.field;
              if (i === c) switch (n) {
                case "blur":
                  this._getDomField(!0), this._updateDomField();
                  var h = this._escapeHTML((this || _global).field);
                  h !== this._unescapeHTML((0, k.getInnerText)(c)) && (c.innerHTML = h);
                  break;
                case "input":
                  this._getDomField(), this._updateSchema(), this._updateDomField(), this._updateDomValue();
                  break;
                case "keydown":
                case "mousedown":
                  (this || _global).editor.selection = (this || _global).editor.getDomSelection();
                  break;
                case "keyup":
                  this._getDomField(), this._updateDomField();
                  break;
                case "cut":
                case "paste":
                  setTimeout(function () {
                    r._getDomField(), r._updateDomField();
                  }, 1);
              }
              var d = o.tree;
              d && i === d.parentNode && "click" === n && !e.hasMoved && ((void 0 !== e.offsetX ? e.offsetX < 24 * (this.getLevel() + 1) : e.pageX < (0, k.getAbsoluteLeft)(o.tdSeparator)) || s ? c && ((0, k.setEndOfContentEditable)(c), c.focus()) : a && !(this || _global).enum && ((0, k.setEndOfContentEditable)(a), a.focus())), (i !== o.tdExpand || s) && i !== o.tdField && i !== o.tdSeparator || "click" !== n || e.hasMoved || c && ((0, k.setEndOfContentEditable)(c), c.focus()), "keydown" === n && this.onKeyDown(e), "function" == typeof (this || _global).editor.options.onEvent && this._onEvent(e);
            }
          }, {
            key: "_onEvent",
            value: function (e) {
              var t = e.target,
                n = t === (this || _global).dom.field,
                t = t === (this || _global).dom.value || t === (this || _global).dom.checkbox || t === (this || _global).dom.select;
              (n || t) && (n = {
                field: this.getField(),
                path: this.getPath()
              }, t && !this._hasChilds() && (n.value = this.getValue()), (this || _global).editor.options.onEvent(n, e));
            }
          }, {
            key: "onKeyDown",
            value: function (e) {
              var t,
                n,
                i,
                o,
                r,
                s,
                a,
                l,
                c,
                h,
                d,
                u,
                g,
                p,
                m = e.which || e.keyCode,
                f = e.target || e.srcElement,
                C = e.ctrlKey,
                y = e.shiftKey,
                v = e.altKey,
                I = !1,
                b = "tree" === (this || _global).editor.options.mode,
                A = 0 < (this || _global).editor.multiselection.nodes.length ? (this || _global).editor.multiselection.nodes : [this || _global],
                w = A[0],
                S = A[A.length - 1];
              13 === m ? f === (this || _global).dom.value ? (this || _global).editable.value && !e.ctrlKey || (0, k.isUrl)((this || _global).value) && (window.open((this || _global).value, "_blank", "noreferrer"), I = !0) : f === (this || _global).dom.expand && this._hasChilds() && (g = e.ctrlKey, this._onExpand(g), f.focus(), I = !0) : 68 === m ? C && b && (x.onDuplicate(A), I = !0) : 69 === m ? C && (this._onExpand(y), f.focus(), I = !0) : 77 === m && b ? C && (this.showContextMenu(f), I = !0) : 46 === m && b ? C && (x.onRemove(A), I = !0) : 45 === m && b ? C && !y ? (this._onInsertBefore(), I = !0) : C && y && (this._onInsertAfter(), I = !0) : 35 === m ? v && ((g = this._lastNode()) && g.focus(x.focusElement || this._getElementName(f)), I = !0) : 36 === m ? v && ((g = this._firstNode()) && g.focus(x.focusElement || this._getElementName(f)), I = !0) : 37 === m ? v && !y ? ((g = this._previousElement(f)) && this.focus(this._getElementName(g)), I = !0) : v && y && b && (g = S.expanded ? (g = S.getAppendDom()) ? g.nextSibling : void 0 : S.getDom().nextSibling) && (d = x.getNodeFromTarget(g), g = g.nextSibling, u = x.getNodeFromTarget(g), d) && d instanceof _ && 1 !== S.parent.childs.length && u && u.parent && (n = (this || _global).editor.getDomSelection(), i = (o = w.parent).childs[S.getIndex() + 1] || o.append, r = w.getIndex(), s = u.getIndex(), a = o.getInternalPath(), l = u.parent.getInternalPath(), A.forEach(function (e) {
                u.parent.moveBefore(e, u);
              }), this.focus(x.focusElement || this._getElementName(f)), (this || _global).editor._onAction("moveNodes", {
                count: A.length,
                fieldNames: A.map(R),
                oldParentPath: o.getInternalPath(),
                newParentPath: w.parent.getInternalPath(),
                oldIndex: i.getIndex(),
                newIndex: w.getIndex(),
                oldIndexRedo: r,
                newIndexRedo: s,
                oldParentPathRedo: a,
                newParentPathRedo: l,
                oldSelection: n,
                newSelection: (this || _global).editor.getDomSelection()
              })) : 38 === m ? v && !y ? ((t = this._previousNode()) && ((this || _global).editor.deselect(!0), t.focus(x.focusElement || this._getElementName(f))), I = !0) : !v && C && y && b ? ((t = this._previousNode()) && ((h = (this || _global).editor.multiselection).start = h.start || this || _global, h.end = t, c = (this || _global).editor._findTopLevelNodes(h.start, h.end), (this || _global).editor.select(c), t.focus("field")), I = !0) : v && y && b && ((t = w._previousNode()) && t.parent && (n = (this || _global).editor.getDomSelection(), i = (o = w.parent).childs[S.getIndex() + 1] || o.append, r = w.getIndex(), s = t.getIndex(), a = o.getInternalPath(), l = t.parent.getInternalPath(), A.forEach(function (e) {
                t.parent.moveBefore(e, t);
              }), this.focus(x.focusElement || this._getElementName(f)), (this || _global).editor._onAction("moveNodes", {
                count: A.length,
                fieldNames: A.map(R),
                oldParentPath: o.getInternalPath(),
                newParentPath: w.parent.getInternalPath(),
                oldIndex: i.getIndex(),
                newIndex: w.getIndex(),
                oldIndexRedo: r,
                newIndexRedo: s,
                oldParentPathRedo: a,
                newParentPathRedo: l,
                oldSelection: n,
                newSelection: (this || _global).editor.getDomSelection()
              })), I = !0) : 39 === m ? v && !y ? ((g = this._nextElement(f)) && this.focus(this._getElementName(g)), I = !0) : v && y && b && (g = w.getDom().previousSibling) && (t = x.getNodeFromTarget(g)) && t.parent && !t.isVisible() && (n = (this || _global).editor.getDomSelection(), i = (o = w.parent).childs[S.getIndex() + 1] || o.append, r = w.getIndex(), s = t.getIndex(), a = o.getInternalPath(), l = t.parent.getInternalPath(), A.forEach(function (e) {
                t.parent.moveBefore(e, t);
              }), this.focus(x.focusElement || this._getElementName(f)), (this || _global).editor._onAction("moveNodes", {
                count: A.length,
                fieldNames: A.map(R),
                oldParentPath: o.getInternalPath(),
                newParentPath: w.parent.getInternalPath(),
                oldIndex: i.getIndex(),
                newIndex: w.getIndex(),
                oldIndexRedo: r,
                newIndexRedo: s,
                oldParentPathRedo: a,
                newParentPathRedo: l,
                oldSelection: n,
                newSelection: (this || _global).editor.getDomSelection()
              })) : 40 === m && (v && !y ? ((d = this._nextNode()) && ((this || _global).editor.deselect(!0), d.focus(x.focusElement || this._getElementName(f))), I = !0) : !v && C && y && b ? ((d = this._nextNode()) && ((h = (this || _global).editor.multiselection).start = h.start || this || _global, h.end = d, c = (this || _global).editor._findTopLevelNodes(h.start, h.end), (this || _global).editor.select(c), d.focus("field")), I = !0) : v && y && b && ((p = (d = (d = (d = S.expanded ? S.append ? S.append._nextNode() : void 0 : S._nextNode()) && !d.isVisible() ? d.parent.showMore : d) && d instanceof _ ? S : d) && (d._nextNode() || d.parent.append)) && p.parent && (n = (this || _global).editor.getDomSelection(), i = (o = w.parent).childs[S.getIndex() + 1] || o.append, r = w.getIndex(), s = p.getIndex(), a = o.getInternalPath(), l = p.parent.getInternalPath(), A.forEach(function (e) {
                p.parent.moveBefore(e, p);
              }), this.focus(x.focusElement || this._getElementName(f)), (this || _global).editor._onAction("moveNodes", {
                count: A.length,
                fieldNames: A.map(R),
                oldParentPath: o.getInternalPath(),
                newParentPath: w.parent.getInternalPath(),
                oldParentPathRedo: a,
                newParentPathRedo: l,
                oldIndexRedo: r,
                newIndexRedo: s,
                oldIndex: i.getIndex(),
                newIndex: w.getIndex(),
                oldSelection: n,
                newSelection: (this || _global).editor.getDomSelection()
              })), I = !0)), I && (e.preventDefault(), e.stopPropagation());
            }
          }, {
            key: "_onExpand",
            value: function (e) {
              var t, n, i;
              e && (i = (n = (t = (this || _global).dom.tr.parentNode).parentNode).scrollTop, n.removeChild(t)), (this || _global).expanded ? this.collapse(e) : this.expand(e), e && (n.appendChild(t), n.scrollTop = i), "function" == typeof (this || _global).editor.options.onExpand && (this || _global).editor.options.onExpand({
                path: this.getPath(),
                isExpand: (this || _global).expanded,
                recursive: e
              });
            }
          }, {
            key: "_showColorPicker",
            value: function () {
              var t, e;
              "function" == typeof (this || _global).editor.options.onColorPicker && (this || _global).dom.color && ((t = this || _global)._deleteDomColor(), t.updateDom(), e = (0, d.w)((this || _global).dom.color, (this || _global).editor.getPopupAnchor()), (this || _global).editor.options.onColorPicker(e, (this || _global).value, function (e) {
                "string" == typeof e && e !== t.value && (t._deleteDomColor(), t.value = e, t.updateDom(), t._debouncedOnChangeValue());
              }));
            }
          }, {
            key: "getFieldNames",
            value: function (t) {
              return "object" === (this || _global).type ? (this || _global).childs.filter(function (e) {
                return e !== t;
              }).map(function (e) {
                return e.field;
              }) : [];
            }
          }, {
            key: "_onInsertBefore",
            value: function (e, t, n) {
              var i = (this || _global).editor.getDomSelection(),
                e = new x((this || _global).editor, {
                  field: void 0 !== e ? e : "",
                  value: void 0 !== t ? t : "",
                  type: n
                }),
                t = (e.expand(!0), this.getInternalPath()),
                n = ((this || _global).parent.insertBefore(e, this || _global), (this || _global).editor.highlighter.unhighlight(), e.focus("field"), (this || _global).editor.getDomSelection());
              (this || _global).editor._onAction("insertBeforeNodes", {
                nodes: [e],
                paths: [e.getInternalPath()],
                beforePath: t,
                parentPath: (this || _global).parent.getInternalPath(),
                oldSelection: i,
                newSelection: n
              });
            }
          }, {
            key: "_onInsertAfter",
            value: function (e, t, n) {
              var i = (this || _global).editor.getDomSelection(),
                e = new x((this || _global).editor, {
                  field: void 0 !== e ? e : "",
                  value: void 0 !== t ? t : "",
                  type: n
                }),
                t = (e.expand(!0), (this || _global).parent.insertAfter(e, this || _global), (this || _global).editor.highlighter.unhighlight(), e.focus("field"), (this || _global).editor.getDomSelection());
              (this || _global).editor._onAction("insertAfterNodes", {
                nodes: [e],
                paths: [e.getInternalPath()],
                afterPath: this.getInternalPath(),
                parentPath: (this || _global).parent.getInternalPath(),
                oldSelection: i,
                newSelection: t
              });
            }
          }, {
            key: "_onAppend",
            value: function (e, t, n) {
              var i = (this || _global).editor.getDomSelection(),
                e = new x((this || _global).editor, {
                  field: void 0 !== e ? e : "",
                  value: void 0 !== t ? t : "",
                  type: n
                }),
                t = (e.expand(!0), (this || _global).parent.appendChild(e), (this || _global).editor.highlighter.unhighlight(), e.focus("field"), (this || _global).editor.getDomSelection());
              (this || _global).editor._onAction("appendNodes", {
                nodes: [e],
                paths: [e.getInternalPath()],
                parentPath: (this || _global).parent.getInternalPath(),
                oldSelection: i,
                newSelection: t
              });
            }
          }, {
            key: "_onChangeType",
            value: function (e) {
              var t,
                n,
                i = (this || _global).type;
              e !== i && (t = (this || _global).editor.getDomSelection(), this.changeType(e), n = (this || _global).editor.getDomSelection(), (this || _global).editor._onAction("changeType", {
                path: this.getInternalPath(),
                oldType: i,
                newType: e,
                oldSelection: t,
                newSelection: n
              }));
            }
          }, {
            key: "sort",
            value: function (n, e) {
              var t,
                i,
                o = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
              "string" == typeof n && (n = (0, k.parsePath)(n)), this._hasChilds() && (this.hideChilds(), t = (this || _global).childs, (this || _global).childs = (this || _global).childs.concat(), i = "desc" === e ? -1 : 1, "object" === (this || _global).type ? (this || _global).childs.sort(function (e, t) {
                return i * h()(e.field, t.field);
              }) : (this || _global).childs.sort(function (e, t) {
                var e = e.getNestedChild(n),
                  t = t.getNestedChild(n);
                return e ? t ? (e = e.value, t = t.value, "string" != typeof e && "string" != typeof t ? t < e ? i : e < t ? -i : 0 : i * h()(e, t)) : -i : i;
              }), this._updateDomIndexes(), this.showChilds(), !0 === o) && (this || _global).editor._onAction("sort", {
                path: this.getInternalPath(),
                oldChilds: t,
                newChilds: (this || _global).childs
              });
            }
          }, {
            key: "update",
            value: function (e) {
              var t = this.getInternalValue();
              this.setValue(e), (this || _global).editor._onAction("transform", {
                path: this.getInternalPath(),
                oldValue: t,
                newValue: this.getInternalValue()
              });
            }
          }, {
            key: "_detachFromDom",
            value: function () {
              var e = (this || _global).dom.tr ? (this || _global).dom.tr.parentNode : void 0,
                t = (this || _global).expanded ? this.getAppendDom() : this.getDom(),
                t = t && t.parentNode ? t.nextSibling : void 0;
              return this.hide({
                resetVisibleChilds: !1
              }), {
                table: e,
                nextTr: t
              };
            }
          }, {
            key: "_attachToDom",
            value: function (e) {
              e.table && (e.nextTr ? e.table.insertBefore(this.getDom(), e.nextTr) : e.table.appendChild(this.getDom())), (this || _global).expanded && this.showChilds();
            }
          }, {
            key: "transform",
            value: function (e) {
              if (this._hasChilds()) {
                this.hideChilds();
                try {
                  var t = this.getInternalValue(),
                    n = this.getValue(),
                    i = (this || _global).editor.options.executeQuery(n, e),
                    o = (this.setValue(i), this.getInternalValue());
                  (this || _global).editor._onAction("transform", {
                    path: this.getInternalPath(),
                    oldValue: t,
                    newValue: o
                  }), this.showChilds();
                } catch (e) {
                  this.showChilds(), (this || _global).editor._onError(e);
                }
              }
            }
          }, {
            key: "extract",
            value: function () {
              (this || _global).editor.node.hideChilds(), this.hideChilds();
              try {
                var e = (this || _global).editor.node.getInternalValue(),
                  t = ((this || _global).editor._setRoot(this || _global), (this || _global).editor.node.getInternalValue());
                (this || _global).editor._onAction("transform", {
                  path: (this || _global).editor.node.getInternalPath(),
                  oldValue: e,
                  newValue: t
                });
              } catch (e) {
                (this || _global).editor._onError(e);
              } finally {
                this.updateDom({
                  recurse: !0
                }), this.showChilds();
              }
            }
          }, {
            key: "getNestedChild",
            value: function (e) {
              for (var t = 0, n = this || _global; n && t < e.length;) n = n.findChildByProperty(e[t]), t++;
              return n;
            }
          }, {
            key: "findChildByProperty",
            value: function (t) {
              if ("object" === (this || _global).type) return (this || _global).childs.find(function (e) {
                return e.field === t;
              });
            }
          }, {
            key: "getAppendDom",
            value: function () {
              return (this || _global).append || ((this || _global).append = new _((this || _global).editor), (this || _global).append.setParent(this || _global)), (this || _global).append.getDom();
            }
          }, {
            key: "getShowMoreDom",
            value: function () {
              return (this || _global).showMore || ((this || _global).showMore = new F((this || _global).editor, this || _global)), (this || _global).showMore.getDom();
            }
          }, {
            key: "nextSibling",
            value: function () {
              var e = (this || _global).parent.childs.indexOf(this || _global);
              return (this || _global).parent.childs[e + 1] || (this || _global).parent.append;
            }
          }, {
            key: "_previousNode",
            value: function () {
              var e = null,
                t = this.getDom();
              if (t && t.parentNode) for (var n = t; n = n.previousSibling, e = x.getNodeFromTarget(n), n && e && e instanceof _ && !e.isVisible(););
              return e;
            }
          }, {
            key: "_nextNode",
            value: function () {
              var e = null,
                t = this.getDom();
              if (t && t.parentNode) for (var n = t; n = n.nextSibling, e = x.getNodeFromTarget(n), n && e && e instanceof _ && !e.isVisible(););
              return e;
            }
          }, {
            key: "_firstNode",
            value: function () {
              var e = null,
                t = this.getDom();
              return t && t.parentNode && (t = t.parentNode.firstChild, e = x.getNodeFromTarget(t)), e;
            }
          }, {
            key: "_lastNode",
            value: function () {
              var e = null,
                t = this.getDom();
              if (t && t.parentNode) for (var n = t.parentNode.lastChild, e = x.getNodeFromTarget(n); n && e && !e.isVisible();) n = n.previousSibling, e = x.getNodeFromTarget(n);
              return e;
            }
          }, {
            key: "_previousElement",
            value: function (e) {
              var t = (this || _global).dom;
              switch (e) {
                case t.value:
                  if ((this || _global).fieldEditable) return t.field;
                case t.field:
                  if (this._hasChilds()) return t.expand;
                case t.expand:
                  return t.menu;
                case t.menu:
                  if (t.drag) return t.drag;
                default:
                  return null;
              }
            }
          }, {
            key: "_nextElement",
            value: function (e) {
              var t = (this || _global).dom;
              switch (e) {
                case t.drag:
                  return t.menu;
                case t.menu:
                  if (this._hasChilds()) return t.expand;
                case t.expand:
                  if ((this || _global).fieldEditable) return t.field;
                case t.field:
                  if (!this._hasChilds()) return t.value;
                default:
                  return null;
              }
            }
          }, {
            key: "_getElementName",
            value: function (t) {
              var n = this || _global;
              return Object.keys((this || _global).dom).find(function (e) {
                return n.dom[e] === t;
              });
            }
          }, {
            key: "_hasChilds",
            value: function () {
              return "array" === (this || _global).type || "object" === (this || _global).type;
            }
          }, {
            key: "addTemplates",
            value: function (t, n) {
              var i = this || _global,
                e = i.editor.options.templates;
              null != e && (e.length && t.push({
                type: "separator"
              }), e.forEach(function (e) {
                t.push({
                  text: e.text,
                  className: e.className || "jsoneditor-type-object",
                  title: e.title,
                  click: (n ? function (e, t) {
                    i._onAppend(e, t);
                  } : function (e, t) {
                    i._onInsertBefore(e, t);
                  }).bind(this || _global, e.field, e.value)
                });
              }));
            }
          }, {
            key: "showContextMenu",
            value: function (e, t) {
              var n,
                i = this || _global,
                o = [];
              (this || _global).editable.value && o.push({
                text: (0, l.Iu)("type"),
                title: (0, l.Iu)("typeTitle"),
                className: "jsoneditor-type-" + (this || _global).type,
                submenu: [{
                  text: (0, l.Iu)("auto"),
                  className: "jsoneditor-type-auto" + ("auto" === (this || _global).type ? " jsoneditor-selected" : ""),
                  title: (0, l.Iu)("autoType"),
                  click: function () {
                    i._onChangeType("auto");
                  }
                }, {
                  text: (0, l.Iu)("array"),
                  className: "jsoneditor-type-array" + ("array" === (this || _global).type ? " jsoneditor-selected" : ""),
                  title: (0, l.Iu)("arrayType"),
                  click: function () {
                    i._onChangeType("array");
                  }
                }, {
                  text: (0, l.Iu)("object"),
                  className: "jsoneditor-type-object" + ("object" === (this || _global).type ? " jsoneditor-selected" : ""),
                  title: (0, l.Iu)("objectType"),
                  click: function () {
                    i._onChangeType("object");
                  }
                }, {
                  text: (0, l.Iu)("string"),
                  className: "jsoneditor-type-string" + ("string" === (this || _global).type ? " jsoneditor-selected" : ""),
                  title: (0, l.Iu)("stringType"),
                  click: function () {
                    i._onChangeType("string");
                  }
                }]
              }), this._hasChilds() && ((this || _global).editor.options.enableSort && o.push({
                text: (0, l.Iu)("sort"),
                title: (0, l.Iu)("sortTitle", {
                  type: (this || _global).type
                }),
                className: "jsoneditor-sort-asc",
                click: function () {
                  i.showSortModal();
                }
              }), (this || _global).editor.options.enableTransform && o.push({
                text: (0, l.Iu)("transform"),
                title: (0, l.Iu)("transformTitle", {
                  type: (this || _global).type
                }),
                className: "jsoneditor-transform",
                click: function () {
                  i.showTransformModal();
                }
              }), (this || _global).parent) && o.push({
                text: (0, l.Iu)("extract"),
                title: (0, l.Iu)("extractTitle", {
                  type: (this || _global).type
                }),
                className: "jsoneditor-extract",
                click: function () {
                  i.extract();
                }
              }), (this || _global).parent && (this || _global).parent._hasChilds() && (o.length && o.push({
                type: "separator"
              }), n = i.parent.childs, i === n[n.length - 1] && (n = [{
                text: (0, l.Iu)("auto"),
                className: "jsoneditor-type-auto",
                title: (0, l.Iu)("autoType"),
                click: function () {
                  i._onAppend("", "", "auto");
                }
              }, {
                text: (0, l.Iu)("array"),
                className: "jsoneditor-type-array",
                title: (0, l.Iu)("arrayType"),
                click: function () {
                  i._onAppend("", []);
                }
              }, {
                text: (0, l.Iu)("object"),
                className: "jsoneditor-type-object",
                title: (0, l.Iu)("objectType"),
                click: function () {
                  i._onAppend("", {});
                }
              }, {
                text: (0, l.Iu)("string"),
                className: "jsoneditor-type-string",
                title: (0, l.Iu)("stringType"),
                click: function () {
                  i._onAppend("", "", "string");
                }
              }], i.addTemplates(n, !0), o.push({
                text: (0, l.Iu)("appendText"),
                title: (0, l.Iu)("appendTitle"),
                submenuTitle: (0, l.Iu)("appendSubmenuTitle"),
                className: "jsoneditor-append",
                click: function () {
                  i._onAppend("", "", "auto");
                },
                submenu: n
              })), n = [{
                text: (0, l.Iu)("auto"),
                className: "jsoneditor-type-auto",
                title: (0, l.Iu)("autoType"),
                click: function () {
                  i._onInsertBefore("", "", "auto");
                }
              }, {
                text: (0, l.Iu)("array"),
                className: "jsoneditor-type-array",
                title: (0, l.Iu)("arrayType"),
                click: function () {
                  i._onInsertBefore("", []);
                }
              }, {
                text: (0, l.Iu)("object"),
                className: "jsoneditor-type-object",
                title: (0, l.Iu)("objectType"),
                click: function () {
                  i._onInsertBefore("", {});
                }
              }, {
                text: (0, l.Iu)("string"),
                className: "jsoneditor-type-string",
                title: (0, l.Iu)("stringType"),
                click: function () {
                  i._onInsertBefore("", "", "string");
                }
              }], i.addTemplates(n, !1), o.push({
                text: (0, l.Iu)("insert"),
                title: (0, l.Iu)("insertTitle"),
                submenuTitle: (0, l.Iu)("insertSub"),
                className: "jsoneditor-insert",
                click: function () {
                  i._onInsertBefore("", "", "auto");
                },
                submenu: n
              }), (this || _global).editable.field) && (o.push({
                text: (0, l.Iu)("duplicateText"),
                title: (0, l.Iu)("duplicateField"),
                className: "jsoneditor-duplicate",
                click: function () {
                  x.onDuplicate(i);
                }
              }), o.push({
                text: (0, l.Iu)("removeText"),
                title: (0, l.Iu)("removeField"),
                className: "jsoneditor-remove",
                click: function () {
                  x.onRemove(i);
                }
              })), (this || _global).editor.options.onCreateMenu && (n = i.getPath(), o = (this || _global).editor.options.onCreateMenu(o, {
                type: "single",
                path: n,
                paths: [n]
              })), new s.x(o, {
                close: t
              }).show(e, (this || _global).editor.getPopupAnchor());
            }
          }, {
            key: "showSortModal",
            value: function () {
              var n = this || _global,
                e = (this || _global).editor.options.modalAnchor || p.qD,
                t = this.getValue();
              (0, u.showSortModal)(e, t, function (e) {
                var t = e.path,
                  t = (0, k.parsePath)(t);
                n.sortedBy = e, n.sort(t, e.direction);
              }, n.sortedBy);
            }
          }, {
            key: "showTransformModal",
            value: function () {
              var t = this || _global,
                e = (this || _global).editor.options,
                n = e.modalAnchor,
                i = e.createQuery,
                o = e.executeQuery,
                e = e.queryDescription,
                r = this.getValue();
              (0, g.showTransformModal)({
                container: n || p.qD,
                json: r,
                queryDescription: e,
                createQuery: i,
                executeQuery: o,
                onTransform: function (e) {
                  t.transform(e);
                }
              });
            }
          }, {
            key: "_getType",
            value: function (e) {
              return e instanceof Array ? "array" : e instanceof Object ? "object" : "string" == typeof e && "string" != typeof (0, k.parseString)(e) ? "string" : "auto";
            }
          }, {
            key: "_escapeHTML",
            value: function (e) {
              return "string" != typeof e ? String(e) : (e = String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ {2}/g, " &nbsp;").replace(/^ /, "&nbsp;").replace(/ $/, "&nbsp;"), e = (e = JSON.stringify(e)).substring(1, e.length - 1), !0 === (this || _global).editor.options.escapeUnicode ? (0, k.escapeUnicodeChars)(e) : e);
            }
          }, {
            key: "_unescapeHTML",
            value: function (e) {
              e = "\"" + this._escapeJSON(e) + "\"";
              return (0, k.parse)(e).replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&nbsp;|\u00A0/g, " ").replace(/&amp;/g, "&");
            }
          }, {
            key: "_escapeJSON",
            value: function (e) {
              for (var t = "", n = 0; n < e.length;) {
                var i = e.charAt(n);
                "\n" === i ? t += "\\n" : "\\" === i ? (t += i, n++, "" !== (i = e.charAt(n)) && -1 !== "\"\\/bfnrtu".indexOf(i) || (t += "\\"), t += i) : t += "\"" === i ? "\\\"" : i, n++;
              }
              return t;
            }
          }, {
            key: "updateNodeName",
            value: function () {
              var e = (this || _global).childs ? (this || _global).childs.length : 0;
              if ("object" === (this || _global).type || "array" === (this || _global).type) {
                if ((this || _global).editor.options.onNodeName) try {
                  var t = (this || _global).getValue.bind(this || _global),
                    n = (this || _global).editor.options.onNodeName({
                      path: this.getPath(),
                      size: e,
                      type: (this || _global).type,
                      get value() {
                        return t();
                      }
                    });
                } catch (e) {
                  console.error("Error in onNodeName callback: ", e);
                }
                (this || _global).dom.value.textContent = "object" === (this || _global).type ? "{" + (n || e) + "}" : "[" + (n || e) + "]";
              }
            }
          }, {
            key: "recursivelyUpdateNodeName",
            value: function () {
              if ((this || _global).expanded && (this.updateNodeName(), "undefined" !== (this || _global).childs)) for (var e in (this || _global).childs) (this || _global).childs[e].recursivelyUpdateNodeName();
            }
          }]) && C(e.prototype, t), n && C(e, n), Object.defineProperty(e, "prototype", {
            writable: !1
          }), x;
        }(),
        P = (T.prototype.DEBOUNCE_INTERVAL = 150, T.prototype.MAX_SEARCH_RESULTS = 999, 100);
      function y(e) {
        return e.getInternalPath();
      }
      function R(e) {
        return e.getField();
      }
      function v(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
      T.focusElement = void 0, T.select = function (e) {
        setTimeout(function () {
          (0, k.selectContentEditable)(e);
        }, 0);
      }, T.onDragStart = function (t, e) {
        if (!Array.isArray(t)) return T.onDragStart([t], e);
        var n, i, o, r, s;
        0 !== t.length && (n = t[0], i = t[t.length - 1], o = n.parent, s = T.getNodeFromTarget(e.target), r = n.editor, s = (0, k.getAbsoluteTop)(s.dom.tr) - (0, k.getAbsoluteTop)(n.dom.tr), r.mousemove || (r.mousemove = (0, k.addEventListener)(e.view, "mousemove", function (e) {
          T.onDrag(t, e);
        })), r.mouseup || (r.mouseup = (0, k.addEventListener)(e.view, "mouseup", function (e) {
          T.onDragEnd(t, e);
        })), r.highlighter.lock(), r.drag = {
          oldCursor: document.body.style.cursor,
          oldSelection: r.getDomSelection(),
          oldPaths: t.map(y),
          oldParent: o,
          oldNextNode: o.childs[i.getIndex() + 1] || o.append,
          oldParentPathRedo: o.getInternalPath(),
          oldIndexRedo: n.getIndex(),
          mouseX: e.pageX,
          offsetY: s,
          level: n.getLevel()
        }, document.body.style.cursor = "move", e.preventDefault());
      }, T.onDrag = function (e, t) {
        if (!Array.isArray(e)) return T.onDrag([e], t);
        if (0 !== e.length) {
          var n,
            i,
            o,
            r,
            s,
            a = e[0].editor,
            l = t.pageY - a.drag.offsetY,
            c = t.pageX,
            h = !1,
            d = e[0],
            u = d.dom.tr,
            g = (0, k.getAbsoluteTop)(u),
            p = u.offsetHeight;
          if (l < g) {
            for (y = u; y = y.previousSibling, v = T.getNodeFromTarget(y), o = y ? (0, k.getAbsoluteTop)(y) : 0, y && l < o;);
            (v = v && !v.parent ? void 0 : v) || (y = (u = u.parentNode.firstChild) ? u.nextSibling : void 0, (v = T.getNodeFromTarget(y)) === d && (v = void 0)), !(v = v && v.isVisible() && (o = (y = v.dom.tr) ? (0, k.getAbsoluteTop)(y) : 0) + p < l ? void 0 : v) || !1 !== a.options.limitDragging && v.parent !== e[0].parent || (e.forEach(function (e) {
              v.parent.moveBefore(e, v);
            }), h = !0);
          } else {
            var m = e[e.length - 1];
            if (p = (u = m.expanded && m.append ? m.append.getDom() : m.dom.tr) ? u.nextSibling : void 0) {
              for (r = (0, k.getAbsoluteTop)(p), n = p; i = T.getNodeFromTarget(n), n && (s = n.nextSibling ? (0, k.getAbsoluteTop)(n.nextSibling) : 0, s = n ? s - r : 0, i && i.parent.childs.length === e.length && i.parent.childs[e.length - 1] === m && (g += 27), n = n.nextSibling), n && g + s < l;);
              if (i && i.parent) {
                for (var p = c - a.drag.mouseX, p = Math.round(p / 24 / 2), f = a.drag.level + p, C = i.getLevel(), y = i.dom.tr && i.dom.tr.previousSibling; C < f && y;) {
                  var v = T.getNodeFromTarget(y),
                    I = e.some(function (e) {
                      return e === v || v.isDescendantOf(e);
                    });
                  if (!I) {
                    if (!(v instanceof _)) break;
                    I = v.parent.childs;
                    if (I.length === e.length && I[e.length - 1] === m) break;
                    C = (i = T.getNodeFromTarget(y)).getLevel();
                  }
                  y = y.previousSibling;
                }
                (i = i instanceof _ && !i.isVisible() && i.parent.showMore.isVisible() ? i._nextNode() : i) && (!1 === a.options.limitDragging || i.parent === e[0].parent) && i.dom.tr && i.dom.tr !== u.nextSibling && (e.forEach(function (e) {
                  i.parent.moveBefore(e, i);
                }), h = !0);
              }
            }
          }
          h && (a.drag.mouseX = c, a.drag.level = d.getLevel()), a.startAutoScroll(l), t.preventDefault();
        }
      }, T.onDragEnd = function (e, t) {
        if (!Array.isArray(e)) return T.onDrag([e], t);
        var n, i, o, r, s, a, l, c, h;
        0 !== e.length && (a = e[0], n = a.editor, a && a.dom.menu && a.dom.menu.focus(), i = n.drag.oldParent.getInternalPath(), o = a.parent.getInternalPath(), r = n.drag.oldParent === a.parent, s = n.drag.oldNextNode.getIndex(), a = a.getIndex(), l = n.drag.oldParentPathRedo, c = n.drag.oldIndexRedo, h = r && c < a ? a + e.length : a, r && c === a || n._onAction("moveNodes", {
          count: e.length,
          fieldNames: e.map(R),
          oldParentPath: i,
          newParentPath: o,
          oldIndex: s,
          newIndex: a,
          oldIndexRedo: c,
          newIndexRedo: h,
          oldParentPathRedo: l,
          newParentPathRedo: null,
          oldSelection: n.drag.oldSelection,
          newSelection: n.getDomSelection()
        }), document.body.style.cursor = n.drag.oldCursor, n.highlighter.unlock(), e.forEach(function (e) {
          e.updateDom(), t.target !== e.dom.drag && t.target !== e.dom.menu && n.highlighter.unhighlight();
        }), delete n.drag, n.mousemove && ((0, k.removeEventListener)(t.view, "mousemove", n.mousemove), delete n.mousemove), n.mouseup && ((0, k.removeEventListener)(t.view, "mouseup", n.mouseup), delete n.mouseup), n.stopAutoScroll(), t.preventDefault());
      }, T._findEnum = function (e) {
        if (e.enum) return e.enum;
        e = e.oneOf || e.anyOf || e.allOf;
        if (e) {
          e = e.filter(function (e) {
            return e.enum;
          });
          if (0 < e.length) return e[0].enum;
        }
        return null;
      }, T._findSchema = function (e, t, n) {
        for (var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : e, o = n.slice(1, n.length), r = n[0], s = [i], a = 0, l = [i.oneOf, i.anyOf, i.allOf]; a < l.length; a++) {
          var c = l[a];
          Array.isArray(c) && (s = s.concat(c));
        }
        var h,
          d = x(s);
        try {
          for (d.s(); !(h = d.n()).done;) {
            if ("$ref" in (i = h.value) && "string" == typeof i.$ref) {
              var u,
                g = i.$ref;
              if (g in t) i = t[g];else {
                if (!g.startsWith("#/")) {
                  if (1 === (null == (u = g.match(/#\//g)) ? void 0 : u.length)) {
                    var p,
                      m,
                      f,
                      C = G(g.split("#/"), 2),
                      y = C[0],
                      v = C[1];
                    if (y in t) return p = t[y], m = {
                      $ref: "#/".concat(v)
                    }, (f = []).push(r), 0 < o.length && f.push.apply(f, H(o)), T._findSchema(p, t, f, m);
                  }
                  throw Error("Unable to resolve reference ".concat(g));
                }
                var I,
                  b = g.substring(2).split("/"),
                  i = e,
                  A = x(b);
                try {
                  for (A.s(); !(I = A.n()).done;) {
                    var w = I.value;
                    if (!(w in i)) throw Error("Unable to resolve reference ".concat(g));
                    i = i[w];
                  }
                } catch (e) {
                  A.e(e);
                } finally {
                  A.f();
                }
              }
            }
            if (void 0 === r) return i;
            if ("string" == typeof r) {
              if ("object" === E(i.properties) && null !== i.properties && r in i.properties) return i = i.properties[r], T._findSchema(e, t, o, i);
              if ("object" === E(i.patternProperties) && null !== i.patternProperties) for (var S in i.patternProperties) if (r.match(S)) return i = i.patternProperties[S], T._findSchema(e, t, o, i);
              if ("object" === E(i.additionalProperties)) return i = i.additionalProperties, T._findSchema(e, t, o, i);
            } else if ("number" == typeof r && "object" === E(i.items) && null !== i.items) return i = i.items, T._findSchema(e, t, o, i);
          }
        } catch (e) {
          d.e(e);
        } finally {
          d.f();
        }
        return null;
      }, T.onRemove = function (e) {
        if (!Array.isArray(e)) return T.onRemove([e]);
        var t, n, i, o, r, s;
        e && 0 < e.length && (t = (i = e[0]).parent, n = i.editor, i = i.getIndex(), n.highlighter.unhighlight(), o = n.getDomSelection(), T.blurNodes(e), r = n.getDomSelection(), s = e.map(y), e.forEach(function (e) {
          e.parent._remove(e);
        }), n._onAction("removeNodes", {
          nodes: e,
          paths: s,
          parentPath: t.getInternalPath(),
          index: i,
          oldSelection: o,
          newSelection: r
        }));
      }, T.onDuplicate = function (e) {
        if (!Array.isArray(e)) return T.onDuplicate([e]);
        var t, i, n, o, r, s, a;
        e && 0 < e.length && (t = e[e.length - 1], i = t.parent, (n = t.editor).deselect(n.multiselection.nodes), o = n.getDomSelection(), r = t, s = e.map(function (e) {
          var t,
            n = e.clone();
          return "object" === e.parent.type && (t = e.parent.getFieldNames(), n.field = (0, k.findUniqueName)(e.field, t)), i.insertAfter(n, r), r = n;
        }), 1 === e.length ? "object" === s[0].parent.type ? (s[0].dom.field.innerHTML = e[0]._escapeHTML(e[0].field), s[0].focus("field")) : s[0].focus() : n.select(s), a = n.getDomSelection(), n._onAction("duplicateNodes", {
          paths: e.map(y),
          clonePaths: s.map(y),
          afterPath: t.getInternalPath(),
          parentPath: i.getInternalPath(),
          oldSelection: o,
          newSelection: a
        }));
      }, T.getNodeFromTarget = function (e) {
        for (; e;) {
          if (e.node) return e.node;
          e = e.parentNode;
        }
      }, T.targetIsColorPicker = function (e) {
        var t = T.getNodeFromTarget(e);
        if (t) for (var n = e && e.parentNode; n;) {
          if (n === t.dom.color) return !0;
          n = n.parentNode;
        }
        return !1;
      }, T.blurNodes = function (e) {
        var t, n;
        Array.isArray(e) ? (t = (n = e[0]).parent, n = n.getIndex(), (t.childs[n + e.length] ? t.childs[n + e.length] : t.childs[n - 1] || t).focus()) : T.blurNodes([e]);
      };
      (n.prototype = new T()).getDom = function () {
        var e = (this || _global).dom;
        if (e.tr) return e.tr;
        this._updateEditability();
        var t = document.createElement("tr"),
          n = (t.className = "jsoneditor-append", t.node = this || _global, e.tr = t, "tree" === (this || _global).editor.options.mode && (e.tdDrag = document.createElement("td"), i = document.createElement("td"), e.tdMenu = i, (n = document.createElement("button")).type = "button", n.className = "jsoneditor-button jsoneditor-contextmenu-button", n.title = "Click to open the actions menu (Ctrl+M)", e.menu = n, i.appendChild(e.menu)), document.createElement("td")),
          i = document.createElement("div");
        return i.appendChild(document.createTextNode("(" + (0, l.Iu)("empty") + ")")), i.className = "jsoneditor-readonly", n.appendChild(i), e.td = n, e.text = i, this.updateDom(), t;
      }, n.prototype.getPath = function () {
        return null;
      }, n.prototype.getIndex = function () {
        return null;
      }, n.prototype.updateDom = function (e) {
        var t = (this || _global).dom,
          n = t.td,
          i = (n && (n.style.paddingLeft = 24 * this.getLevel() + 26 + "px"), t.text),
          i = (i && (i.firstChild.nodeValue = "(" + (0, l.Iu)("empty") + " " + (this || _global).parent.type + ")"), t.tr);
        this.isVisible() ? t.tr.firstChild || (t.tdDrag && i.appendChild(t.tdDrag), t.tdMenu && i.appendChild(t.tdMenu), i.appendChild(n)) : t.tr.firstChild && (t.tdDrag && i.removeChild(t.tdDrag), t.tdMenu && i.removeChild(t.tdMenu), i.removeChild(n));
      }, n.prototype.isVisible = function () {
        return 0 === (this || _global).parent.childs.length;
      }, n.prototype.showContextMenu = function (e, t) {
        var n,
          i = this || _global,
          o = [{
            text: (0, l.Iu)("auto"),
            className: "jsoneditor-type-auto",
            title: (0, l.Iu)("autoType"),
            click: function () {
              i._onAppend("", "", "auto");
            }
          }, {
            text: (0, l.Iu)("array"),
            className: "jsoneditor-type-array",
            title: (0, l.Iu)("arrayType"),
            click: function () {
              i._onAppend("", []);
            }
          }, {
            text: (0, l.Iu)("object"),
            className: "jsoneditor-type-object",
            title: (0, l.Iu)("objectType"),
            click: function () {
              i._onAppend("", {});
            }
          }, {
            text: (0, l.Iu)("string"),
            className: "jsoneditor-type-string",
            title: (0, l.Iu)("stringType"),
            click: function () {
              i._onAppend("", "", "string");
            }
          }],
          o = (i.addTemplates(o, !0), [{
            text: (0, l.Iu)("appendText"),
            title: (0, l.Iu)("appendTitleAuto"),
            submenuTitle: (0, l.Iu)("appendSubmenuTitle"),
            className: "jsoneditor-insert",
            click: function () {
              i._onAppend("", "", "auto");
            },
            submenu: o
          }]);
        (this || _global).editor.options.onCreateMenu && (n = i.parent.getPath(), o = (this || _global).editor.options.onCreateMenu(o, {
          type: "append",
          path: n,
          paths: [n]
        })), new s.x(o, {
          close: t
        }).show(e, (this || _global).editor.getPopupAnchor());
      }, n.prototype.onEvent = function (e) {
        var t,
          n = e.type,
          i = e.target || e.srcElement,
          o = (this || _global).dom;
        i === o.menu && ("mouseover" === n ? (this || _global).editor.highlighter.highlight((this || _global).parent) : "mouseout" === n && (this || _global).editor.highlighter.unhighlight()), "click" === n && i === o.menu && ((t = (this || _global).editor.highlighter).highlight((this || _global).parent), t.lock(), (0, k.addClassName)(o.menu, "jsoneditor-selected"), this.showContextMenu(o.menu, function () {
          (0, k.removeClassName)(o.menu, "jsoneditor-selected"), t.unlock(), t.unhighlight();
        })), "keydown" === n && this.onKeyDown(e);
      };
      var _ = n;
      function n(e) {
        (this || _global).editor = e, (this || _global).dom = {};
      }
      (I.prototype = new T()).getDom = function () {
        var t, n, e, i, o, r;
        return (this || _global).dom.tr || (this._updateEditability(), (this || _global).dom.tr || (n = (t = this || _global).parent, (o = document.createElement("a")).appendChild(document.createTextNode((0, l.Iu)("showMore"))), o.href = "#", o.onclick = function (e) {
          return n.visibleChilds = Math.floor(n.visibleChilds / n.getMaxVisibleChilds() + 1) * n.getMaxVisibleChilds(), t.updateDom(), n.showChilds(), e.preventDefault(), !1;
        }, (r = document.createElement("a")).appendChild(document.createTextNode((0, l.Iu)("showAll"))), r.href = "#", r.onclick = function (e) {
          return n.visibleChilds = 1 / 0, t.updateDom(), n.showChilds(), e.preventDefault(), !1;
        }, e = document.createElement("div"), i = document.createTextNode(this._getShowMoreText()), e.className = "jsoneditor-show-more", e.appendChild(i), e.appendChild(o), e.appendChild(document.createTextNode(". ")), e.appendChild(r), e.appendChild(document.createTextNode(". ")), (o = document.createElement("td")).appendChild(e), r = document.createElement("tr"), "tree" === (this || _global).editor.options.mode && (r.appendChild(document.createElement("td")), r.appendChild(document.createElement("td"))), r.appendChild(o), r.className = "jsoneditor-show-more", (this || _global).dom.tr = r, (this || _global).dom.moreContents = e, (this || _global).dom.moreText = i), this.updateDom()), (this || _global).dom.tr;
      }, I.prototype.updateDom = function (e) {
        var t;
        this.isVisible() ? ((this || _global).dom.tr.node = (this || _global).parent.childs[(this || _global).parent.visibleChilds], (this || _global).dom.tr.parentNode || (t = (this || _global).parent._getNextTr()) && t.parentNode.insertBefore((this || _global).dom.tr, t), (this || _global).dom.moreText.nodeValue = this._getShowMoreText(), (this || _global).dom.moreContents.style.marginLeft = 24 * (this.getLevel() + 1) + "px") : (this || _global).dom.tr && (this || _global).dom.tr.parentNode && (this || _global).dom.tr.parentNode.removeChild((this || _global).dom.tr);
      }, I.prototype._getShowMoreText = function () {
        return (0, l.Iu)("showMoreStatus", {
          visibleChilds: (this || _global).parent.visibleChilds,
          totalChilds: (this || _global).parent.childs.length
        }) + " ";
      }, I.prototype.isVisible = function () {
        return (this || _global).parent.expanded && (this || _global).parent.childs.length > (this || _global).parent.visibleChilds;
      }, I.prototype.onEvent = function (e) {
        "keydown" === e.type && this.onKeyDown(e);
      };
      var F = I;
      function I(e, t) {
        (this || _global).editor = e, (this || _global).parent = t, (this || _global).dom = {};
      }
      function b(e) {
        return (b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function A(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== b(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== b(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === b(e) ? e : String(e);
          }(i.key), i);
        }
      }
      var V = function () {
        function e(t) {
          if (!((this || _global) instanceof e)) throw new TypeError("Cannot call a class as a function");
          function r(e) {
            return t.node.findNodeByInternalPath(e);
          }
          (this || _global).editor = t, (this || _global).history = [], (this || _global).index = -1, this.clear(), (this || _global).actions = {
            editField: {
              undo: function (e) {
                r(e.parentPath).childs[e.index].updateField(e.oldValue);
              },
              redo: function (e) {
                r(e.parentPath).childs[e.index].updateField(e.newValue);
              }
            },
            editValue: {
              undo: function (e) {
                r(e.path).updateValue(e.oldValue);
              },
              redo: function (e) {
                r(e.path).updateValue(e.newValue);
              }
            },
            changeType: {
              undo: function (e) {
                r(e.path).changeType(e.oldType);
              },
              redo: function (e) {
                r(e.path).changeType(e.newType);
              }
            },
            appendNodes: {
              undo: function (e) {
                var t = r(e.parentPath);
                e.paths.map(r).forEach(function (e) {
                  t.removeChild(e);
                });
              },
              redo: function (e) {
                var t = r(e.parentPath);
                e.nodes.forEach(function (e) {
                  t.appendChild(e);
                });
              }
            },
            insertBeforeNodes: {
              undo: function (e) {
                var t = r(e.parentPath);
                e.paths.map(r).forEach(function (e) {
                  t.removeChild(e);
                });
              },
              redo: function (e) {
                var t = r(e.parentPath),
                  n = r(e.beforePath);
                e.nodes.forEach(function (e) {
                  t.insertBefore(e, n);
                });
              }
            },
            insertAfterNodes: {
              undo: function (e) {
                var t = r(e.parentPath);
                e.paths.map(r).forEach(function (e) {
                  t.removeChild(e);
                });
              },
              redo: function (e) {
                var t = r(e.parentPath),
                  n = r(e.afterPath);
                e.nodes.forEach(function (e) {
                  t.insertAfter(e, n), n = e;
                });
              }
            },
            removeNodes: {
              undo: function (e) {
                var t = r(e.parentPath),
                  n = t.childs[e.index] || t.append;
                e.nodes.forEach(function (e) {
                  t.insertBefore(e, n);
                });
              },
              redo: function (e) {
                var t = r(e.parentPath);
                e.paths.map(r).forEach(function (e) {
                  t.removeChild(e);
                });
              }
            },
            duplicateNodes: {
              undo: function (e) {
                var t = r(e.parentPath);
                e.clonePaths.map(r).forEach(function (e) {
                  t.removeChild(e);
                });
              },
              redo: function (e) {
                var i = r(e.parentPath),
                  o = r(e.afterPath);
                e.paths.map(r).forEach(function (e) {
                  var t,
                    n = e.clone();
                  "object" === i.type && (t = i.getFieldNames(), n.field = (0, k.findUniqueName)(e.field, t)), i.insertAfter(n, o), o = n;
                });
              }
            },
            moveNodes: {
              undo: function (n) {
                var i = r(n.oldParentPath),
                  e = r(n.newParentPath),
                  o = i.childs[n.oldIndex] || i.append;
                e.childs.slice(n.newIndex, n.newIndex + n.count).forEach(function (e, t) {
                  e.field = n.fieldNames[t], i.moveBefore(e, o);
                }), null === n.newParentPathRedo && (n.newParentPathRedo = e.getInternalPath());
              },
              redo: function (n) {
                var e = r(n.oldParentPathRedo),
                  i = r(n.newParentPathRedo),
                  o = i.childs[n.newIndexRedo] || i.append;
                e.childs.slice(n.oldIndexRedo, n.oldIndexRedo + n.count).forEach(function (e, t) {
                  e.field = n.fieldNames[t], i.moveBefore(e, o);
                });
              }
            },
            sort: {
              undo: function (e) {
                var t = r(e.path);
                t.hideChilds(), t.childs = e.oldChilds, t.updateDom({
                  updateIndexes: !0
                }), t.showChilds();
              },
              redo: function (e) {
                var t = r(e.path);
                t.hideChilds(), t.childs = e.newChilds, t.updateDom({
                  updateIndexes: !0
                }), t.showChilds();
              }
            },
            transform: {
              undo: function (e) {
                r(e.path).setInternalValue(e.oldValue);
              },
              redo: function (e) {
                r(e.path).setInternalValue(e.newValue);
              }
            }
          };
        }
        var t, n, i;
        return t = e, (n = [{
          key: "onChange",
          value: function () {}
        }, {
          key: "add",
          value: function (e, t) {
            (this || _global).index++, (this || _global).history[(this || _global).index] = {
              action: e,
              params: t,
              timestamp: new Date()
            }, (this || _global).index < (this || _global).history.length - 1 && (this || _global).history.splice((this || _global).index + 1, (this || _global).history.length - (this || _global).index - 1), this.onChange();
          }
        }, {
          key: "clear",
          value: function () {
            (this || _global).history = [], (this || _global).index = -1, this.onChange();
          }
        }, {
          key: "canUndo",
          value: function () {
            return 0 <= (this || _global).index;
          }
        }, {
          key: "canRedo",
          value: function () {
            return (this || _global).index < (this || _global).history.length - 1;
          }
        }, {
          key: "undo",
          value: function () {
            if (this.canUndo()) {
              var e = (this || _global).history[(this || _global).index];
              if (e) {
                var t = (this || _global).actions[e.action];
                if (t && t.undo) {
                  if (t.undo(e.params), e.params.oldSelection) try {
                    (this || _global).editor.setDomSelection(e.params.oldSelection);
                  } catch (e) {
                    console.error(e);
                  }
                } else console.error(new Error("unknown action \"" + e.action + "\""));
              }
              (this || _global).index--, this.onChange();
            }
          }
        }, {
          key: "redo",
          value: function () {
            if (this.canRedo()) {
              (this || _global).index++;
              var e = (this || _global).history[(this || _global).index];
              if (e) {
                var t = (this || _global).actions[e.action];
                if (t && t.redo) {
                  if (t.redo(e.params), e.params.newSelection) try {
                    (this || _global).editor.setDomSelection(e.params.newSelection);
                  } catch (e) {
                    console.error(e);
                  }
                } else console.error(new Error("unknown action \"" + e.action + "\""));
              }
              this.onChange();
            }
          }
        }, {
          key: "destroy",
          value: function () {
            (this || _global).editor = null, (this || _global).history = [], (this || _global).index = -1;
          }
        }]) && A(t.prototype, n), i && A(t, i), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }();
      function $(e) {
        return ($ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function L(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== $(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== $(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === $(e) ? e : String(e);
          }(i.key), i);
        }
      }
      var Z = function () {
        function o(e, t) {
          if (!((this || _global) instanceof o)) throw new TypeError("Cannot call a class as a function");
          var n = this || _global,
            e = ((this || _global).editor = e, (this || _global).timeout = void 0, (this || _global).delay = 200, (this || _global).lastText = void 0, (this || _global).results = null, (this || _global).dom = {}, (this || _global).dom.container = t, document.createElement("div")),
            t = (((this || _global).dom.wrapper = e).className = "jsoneditor-search", t.appendChild(e), document.createElement("div")),
            t = (((this || _global).dom.results = t).className = "jsoneditor-results", e.appendChild(t), document.createElement("div")),
            e = (((this || _global).dom.input = t).className = "jsoneditor-frame", t.title = (0, l.Iu)("searchTitle"), e.appendChild(t), document.createElement("button")),
            i = (e.type = "button", e.className = "jsoneditor-refresh", t.appendChild(e), document.createElement("input")),
            e = (i.type = "text", ((this || _global).dom.search = i).oninput = function (e) {
              n._onDelayedSearch(e);
            }, i.onchange = function (e) {
              n._onSearch();
            }, i.onkeydown = function (e) {
              n._onKeyDown(e);
            }, i.onkeyup = function (e) {
              n._onKeyUp(e);
            }, e.onclick = function (e) {
              i.select();
            }, t.appendChild(i), document.createElement("button")),
            e = (e.type = "button", e.title = (0, l.Iu)("searchNextResultTitle"), e.className = "jsoneditor-next", e.onclick = function () {
              n.next();
            }, t.appendChild(e), document.createElement("button"));
          e.type = "button", e.title = (0, l.Iu)("searchPreviousResultTitle"), e.className = "jsoneditor-previous", e.onclick = function () {
            n.previous();
          }, t.appendChild(e);
        }
        var e, t, n;
        return e = o, (t = [{
          key: "next",
          value: function (e) {
            var t;
            (this || _global).results && ((t = null !== (this || _global).resultIndex ? (this || _global).resultIndex + 1 : 0) > (this || _global).results.length - 1 && (t = 0), this._setActiveResult(t, e));
          }
        }, {
          key: "previous",
          value: function (e) {
            var t, n;
            (this || _global).results && (t = (this || _global).results.length - 1, n = null !== (this || _global).resultIndex ? (this || _global).resultIndex - 1 : t, this._setActiveResult(n = n < 0 ? t : n, e));
          }
        }, {
          key: "_setActiveResult",
          value: function (e, t) {
            var n, i, o;
            (this || _global).activeResult && (n = (this || _global).activeResult.node, "field" === (this || _global).activeResult.elem ? delete n.searchFieldActive : delete n.searchValueActive, n.updateDom()), (this || _global).results && (this || _global).results[e] ? ((this || _global).resultIndex = e, i = (this || _global).results[(this || _global).resultIndex].node, "field" === (o = (this || _global).results[(this || _global).resultIndex].elem) ? i.searchFieldActive = !0 : i.searchValueActive = !0, (this || _global).activeResult = (this || _global).results[(this || _global).resultIndex], i.updateDom(), i.scrollTo(function () {
              t && i.focus(o);
            })) : ((this || _global).resultIndex = void 0, (this || _global).activeResult = void 0);
          }
        }, {
          key: "_clearDelay",
          value: function () {
            void 0 !== (this || _global).timeout && (clearTimeout((this || _global).timeout), delete (this || _global).timeout);
          }
        }, {
          key: "_onDelayedSearch",
          value: function (e) {
            this._clearDelay();
            var t = this || _global;
            (this || _global).timeout = setTimeout(function (e) {
              t._onSearch();
            }, (this || _global).delay);
          }
        }, {
          key: "_onSearch",
          value: function (e) {
            this._clearDelay();
            var t = (this || _global).dom.search.value,
              t = 0 < t.length ? t : void 0;
            if (t !== (this || _global).lastText || e) {
              (this || _global).lastText = t, (this || _global).results = (this || _global).editor.search(t);
              var e = (this || _global).results[0] ? (this || _global).results[0].node.MAX_SEARCH_RESULTS : 1 / 0,
                n = 0;
              if ((this || _global).activeResult) for (var i = 0; i < (this || _global).results.length; i++) if ((this || _global).results[i].node === (this || _global).activeResult.node) {
                n = i;
                break;
              }
              this._setActiveResult(n, !1), void 0 !== t ? (t = (this || _global).results.length, (this || _global).dom.results.textContent = 0 === t ? "no\xA0results" : 1 === t ? "1\xA0result" : e < t ? e + "+\xA0results" : t + "\xA0results") : (this || _global).dom.results.textContent = "";
            }
          }
        }, {
          key: "_onKeyDown",
          value: function (e) {
            var t = e.which;
            27 === t ? ((this || _global).dom.search.value = "", this._onSearch(), e.preventDefault(), e.stopPropagation()) : 13 === t && (e.ctrlKey ? this._onSearch(!0) : e.shiftKey ? this.previous() : this.next(), e.preventDefault(), e.stopPropagation());
          }
        }, {
          key: "_onKeyUp",
          value: function (e) {
            var t = e.keyCode;
            27 !== t && 13 !== t && this._onDelayedSearch(e);
          }
        }, {
          key: "clear",
          value: function () {
            (this || _global).dom.search.value = "", this._onSearch();
          }
        }, {
          key: "forceSearch",
          value: function () {
            this._onSearch(!0);
          }
        }, {
          key: "isEmpty",
          value: function () {
            return "" === (this || _global).dom.search.value;
          }
        }, {
          key: "destroy",
          value: function () {
            (this || _global).editor = null, (this || _global).dom.container.removeChild((this || _global).dom.wrapper), (this || _global).dom = null, (this || _global).results = null, (this || _global).activeResult = null, this._clearDelay();
          }
        }]) && L(e.prototype, t), n && L(e, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), o;
      }();
      function N(e) {
        return (N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function B(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== N(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== N(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === N(e) ? e : String(e);
          }(i.key), i);
        }
      }
      var O = function () {
          function n(e, t) {
            if (!((this || _global) instanceof n)) throw new TypeError("Cannot call a class as a function");
            e && ((this || _global).root = t, (this || _global).path = document.createElement("div"), (this || _global).path.className = "jsoneditor-treepath", (this || _global).path.setAttribute("tabindex", 0), (this || _global).contentMenuClicked = !1, e.appendChild((this || _global).path), this.reset());
          }
          var e, t, i;
          return e = n, (t = [{
            key: "reset",
            value: function () {
              (this || _global).path.textContent = (0, l.Iu)("selectNode");
            }
          }, {
            key: "setPath",
            value: function (o) {
              var r = this || _global;
              (this || _global).path.textContent = "", o && o.length && o.forEach(function (n, i) {
                var e,
                  t = document.createElement("span");
                t.className = "jsoneditor-treepath-element", t.innerText = n.name, t.onclick = function (e) {
                  (this || _global).selectionCallback && this.selectionCallback(e);
                }.bind(r, n), r.path.appendChild(t), n.children.length && ((e = document.createElement("span")).className = "jsoneditor-treepath-seperator", e.textContent = "\u25BA", e.onclick = function () {
                  r.contentMenuClicked = !0;
                  var t = [];
                  n.children.forEach(function (e) {
                    t.push({
                      text: e.name,
                      className: "jsoneditor-type-modes" + (o[i + 1] + 1 && o[i + 1].name === e.name ? " jsoneditor-selected" : ""),
                      click: function (e, t) {
                        (this || _global).contextMenuCallback && this.contextMenuCallback(e, t);
                      }.bind(r, n, e.name)
                    });
                  }), new s.x(t, {
                    limitHeight: !0
                  }).show(e, r.root, !0);
                }, r.path.appendChild(e)), i === o.length - 1 && (t = (e || t).getBoundingClientRect().right, r.path.offsetWidth < t && (r.path.scrollLeft = t), r.path.scrollLeft) && ((t = document.createElement("span")).className = "jsoneditor-treepath-show-all-btn", t.title = "show all path", t.textContent = "...", t.onclick = function (e) {
                  (r.contentMenuClicked = !1, k.addClassName)(r.path, "show-all"), r.path.style.width = r.path.parentNode.getBoundingClientRect().width - 10 + "px", r.path.onblur = function () {
                    r.contentMenuClicked ? (r.contentMenuClicked = !1, r.path.focus()) : ((0, k.removeClassName)(r.path, "show-all"), r.path.onblur = void 0, r.path.style.width = "", r.setPath(e));
                  };
                }.bind(r, o), r.path.insertBefore(t, r.path.firstChild));
              });
            }
          }, {
            key: "onSectionSelected",
            value: function (e) {
              "function" == typeof e && ((this || _global).selectionCallback = e);
            }
          }, {
            key: "onContextMenuItemSelected",
            value: function (e) {
              "function" == typeof e && ((this || _global).contextMenuCallback = e);
            }
          }]) && B(e.prototype, t), i && B(e, i), Object.defineProperty(e, "prototype", {
            writable: !1
          }), n;
        }(),
        e = t(8037),
        M = t.n(e),
        t = {},
        D = (t.create = function (e, t) {
          if (!e) throw new Error("No container element provided.");
          function r(e) {
            var t, n;
            document.createRange ? ((t = document.createRange()).selectNodeContents(e), t.collapse(!1), (n = window.getSelection()).removeAllRanges(), n.addRange(t)) : document.selection && ((t = document.body.createTextRange()).moveToElementText(e), t.collapse(!1), t.select());
          }
          function s(e) {
            return void 0 === n && ((n = document.createElement("span")).style.visibility = "hidden", n.style.position = "fixed", n.style.outline = "0", n.style.margin = "0", n.style.padding = "0", n.style.border = "0", n.style.left = "0", n.style.whiteSpace = "pre", n.style.fontSize = o, n.style.fontFamily = u, n.style.fontWeight = "normal", document.body.appendChild(n)), n.textContent = e, n.getBoundingClientRect().right;
          }
          function a() {
            (this || _global).style.backgroundColor = "#ddd";
          }
          function l() {
            (this || _global).style.backgroundColor = "";
          }
          function c() {
            y.hide(), y.onmouseselection((this || _global).__hint, y.rs);
          }
          var h, n, d, o, u, g, p, m, f, C, i, y, v, I, b, A;
          (this || _global).container = e, (this || _global).dom = {}, (this || _global).highlighter = new S(), (this || _global).selection = void 0, (this || _global).multiselection = {
            nodes: []
          }, (this || _global).validateSchema = null, (this || _global).validationSequence = 0, (this || _global).errorNodes = [], (this || _global).lastSchemaErrors = void 0, (this || _global).node = null, (this || _global).focusTarget = null, this._setOptions(t), t.autocomplete && ((this || _global).autocomplete = ((h = (h = t.autocomplete) || {}).filter = h.filter || "start", h.trigger = h.trigger || "keydown", h.confirmKeys = h.confirmKeys || [39, 35, 9], h.caseSensitive = h.caseSensitive || !1, u = o = "", (g = document.createElement("div")).style.position = "relative", g.style.outline = "0", g.style.border = "0", g.style.margin = "0", g.style.padding = "0", (p = document.createElement("div")).className = "autocomplete dropdown", p.style.position = "absolute", p.style.visibility = "hidden", m = p, f = [], i = -1, I = y = {
            rs: v = {
              onArrowDown: function () {},
              onArrowUp: function () {},
              onEnter: function () {},
              onTab: function () {},
              startFrom: C = 0,
              options: [],
              element: null,
              elementHint: null,
              elementStyle: null,
              wrapper: g,
              show: function (e, t, n) {
                var i = this || _global;
                (this || _global).startFrom = t, (this || _global).wrapper.remove(), (this || _global).elementHint && ((this || _global).elementHint.remove(), (this || _global).elementHint = null), "" === o && (o = window.getComputedStyle(e).getPropertyValue("font-size")), "" === u && (u = window.getComputedStyle(e).getPropertyValue("font-family")), p.style.marginLeft = "0", p.style.marginTop = e.getBoundingClientRect().height + "px", (this || _global).options = n.map(String), (this || _global).element !== e && ((this || _global).element = e, (this || _global).elementStyle = {
                  zIndex: (this || _global).element.style.zIndex,
                  position: (this || _global).element.style.position,
                  backgroundColor: (this || _global).element.style.backgroundColor,
                  borderColor: (this || _global).element.style.borderColor
                }), (this || _global).element.style.zIndex = 3, (this || _global).element.style.position = "relative", (this || _global).element.style.backgroundColor = "transparent", (this || _global).element.style.borderColor = "transparent", (this || _global).elementHint = e.cloneNode(), (this || _global).elementHint.className = "autocomplete hint", (this || _global).elementHint.style.zIndex = 2, (this || _global).elementHint.style.position = "absolute", (this || _global).elementHint.onfocus = function () {
                  i.element.focus();
                }, (this || _global).element.addEventListener && ((this || _global).element.removeEventListener("keydown", b), (this || _global).element.addEventListener("keydown", b, !1), (this || _global).element.removeEventListener("blur", A), (this || _global).element.addEventListener("blur", A, !1)), g.appendChild((this || _global).elementHint), g.appendChild(p), e.parentElement.appendChild(g), this.repaint(e);
              },
              setText: function (e) {
                (this || _global).element.innerText = e;
              },
              getText: function () {
                return (this || _global).element.innerText;
              },
              hideDropDown: function () {
                (this || _global).wrapper.remove(), (this || _global).elementHint && ((this || _global).elementHint.remove(), (this || _global).elementHint = null, I.hide(), (this || _global).element.style.zIndex = (this || _global).elementStyle.zIndex, (this || _global).element.style.position = (this || _global).elementStyle.position, (this || _global).element.style.backgroundColor = (this || _global).elementStyle.backgroundColor, (this || _global).element.style.borderColor = (this || _global).elementStyle.borderColor);
              },
              repaint: function (e) {
                var e = (e = e.innerText).replace("\n", ""),
                  t = (this || _global).options.length,
                  n = e.substring((this || _global).startFrom);
                d = e.substring(0, (this || _global).startFrom);
                for (var i = 0; i < t; i++) {
                  var o = (this || _global).options[i];
                  if (!h.caseSensitive && 0 === o.toLowerCase().indexOf(n.toLowerCase()) || h.caseSensitive && 0 === o.indexOf(n)) {
                    (this || _global).elementHint.innerText = d + n + o.substring(n.length), (this || _global).elementHint.realInnerText = d + o;
                    break;
                  }
                }
                p.style.left = s(d) + "px", I.refresh(n, (this || _global).options), (this || _global).elementHint.style.width = s((this || _global).elementHint.innerText) + 10 + "px", "hidden" !== p.style.visibility && ((this || _global).elementHint.style.width = s((this || _global).elementHint.innerText) + p.clientWidth + "px");
              }
            },
            hide: function () {
              m.style.visibility = "hidden";
            },
            refresh: function (i, e) {
              m.style.visibility = "hidden", C = 0, m.textContent = "";
              var t = window.innerHeight || document.documentElement.clientHeight,
                n = m.parentNode.getBoundingClientRect(),
                o = n.top - 6,
                t = t - n.bottom - 6,
                r = (f = [], "function" == typeof h.filter ? h.filter : w[h.filter]),
                n = r ? e.filter(function (e) {
                  return r(h.caseSensitive ? i : i.toLowerCase(), h.caseSensitive ? e : e.toLowerCase(), h);
                }) : [];
              0 === (f = n.map(function (e) {
                var t = document.createElement("div"),
                  n = (t.className = "item", t.onmouseover = a, t.onmouseout = l, t.onmousedown = c, t.__hint = e, t.textContent = "", t.appendChild(document.createTextNode(e.substring(0, i.length))), document.createElement("b"));
                return n.appendChild(document.createTextNode(e.substring(i.length))), t.appendChild(n), m.appendChild(t), t;
              })).length || 1 === f.length && (i.toLowerCase() === f[0].__hint.toLowerCase() && !h.caseSensitive || i === f[0].__hint && h.caseSensitive) || f.length < 2 || (y.highlight(0), 3 * t < o ? (m.style.maxHeight = o + "px", m.style.top = "", m.style.bottom = "100%") : (m.style.top = "100%", m.style.bottom = "", m.style.maxHeight = t + "px"), m.style.visibility = "visible");
            },
            highlight: function (e) {
              -1 !== i && f[i] && (f[i].className = "item"), f[e].className = "item hover", i = e;
            },
            move: function (e) {
              return "hidden" === m.style.visibility ? "" : (C + e !== -1 && C + e !== f.length && (C += e, y.highlight(C)), f[C].__hint);
            },
            onmouseselection: function () {}
          }, b = function (e) {
            var t = (e = e || window.event).keyCode;
            if (null != (this || _global).elementHint && 33 !== t && 34 !== t) if (27 === t) v.hideDropDown(), v.element.focus(), e.preventDefault(), e.stopPropagation();else {
              var n,
                i = (i = (this || _global).element.innerText).replace("\n", "");
              if (0 <= h.confirmKeys.indexOf(t)) 9 === t && 0 === (this || _global).elementHint.innerText.length && v.onTab(), 0 < (this || _global).elementHint.innerText.length && (this || _global).element.innerText !== (this || _global).elementHint.realInnerText && ((this || _global).element.innerText = (this || _global).elementHint.realInnerText, v.hideDropDown(), r((this || _global).element), 9 === t) && (v.element.focus(), e.preventDefault(), e.stopPropagation());else if (13 === t) {
                if (0 === (this || _global).elementHint.innerText.length) v.onEnter();else {
                  var o = "hidden" === p.style.visibility;
                  if (I.hide(), o) return v.hideDropDown(), v.element.focus(), void v.onEnter();
                  (this || _global).element.innerText = (this || _global).elementHint.realInnerText, v.hideDropDown(), r((this || _global).element), e.preventDefault(), e.stopPropagation();
                }
              } else 40 === t ? (o = i.substring((this || _global).startFrom), "" === (n = I.move(1)) && v.onArrowDown(), (this || _global).elementHint.innerText = d + o + n.substring(o.length), (this || _global).elementHint.realInnerText = d + n, e.preventDefault(), e.stopPropagation()) : 38 === t && (o = i.substring((this || _global).startFrom), "" === (n = I.move(-1)) && v.onArrowUp(), (this || _global).elementHint.innerText = d + o + n.substring(o.length), (this || _global).elementHint.realInnerText = d + n, e.preventDefault(), e.stopPropagation());
            }
          }.bind(v), A = function (e) {
            v.hideDropDown();
          }, I.onmouseselection = function (e, t) {
            t.element.innerText = t.elementHint.innerText = d + e, t.hideDropDown(), window.setTimeout(function () {
              t.element.focus(), r(t.element);
            }, 1);
          }, v)), (this || _global).options.history && "view" !== (this || _global).options.mode && ((this || _global).history = new V(this || _global)), this._createFrame(), this._createTable();
        }, t.destroy = function () {
          (this || _global).frame && (this || _global).container && (this || _global).frame.parentNode === (this || _global).container && ((this || _global).container.removeChild((this || _global).frame), (this || _global).frame = null), (this || _global).container = null, (this || _global).dom = null, this.clear(), (this || _global).node = null, (this || _global).focusTarget = null, (this || _global).selection = null, (this || _global).multiselection = null, (this || _global).errorNodes = null, (this || _global).validateSchema = null, (this || _global)._debouncedValidate = null, (this || _global).history && ((this || _global).history.destroy(), (this || _global).history = null), (this || _global).searchBox && ((this || _global).searchBox.destroy(), (this || _global).searchBox = null), (this || _global).modeSwitcher && ((this || _global).modeSwitcher.destroy(), (this || _global).modeSwitcher = null), (this || _global).frameFocusTracker.destroy();
        }, t._setOptions = function (t) {
          var n = this || _global;
          (this || _global).options = {
            search: !0,
            history: !0,
            mode: "tree",
            name: void 0,
            schema: null,
            schemaRefs: null,
            autocomplete: null,
            navigationBar: !0,
            mainMenuBar: !0,
            limitDragging: !1,
            onSelectionChange: null,
            colorPicker: !0,
            onColorPicker: function (e, t, n) {
              var i;
              M() ? (i = e.getBoundingClientRect().top, i = (0, k.getWindow)(e).innerHeight - i < 300 && 300 < i, new (M())({
                parent: e,
                color: t,
                popup: i ? "top" : "bottom",
                onDone: function (e) {
                  e = 1 === e.rgba[3] ? e.hex.substr(0, 7) : e.hex;
                  n(e);
                }
              }).show()) : console.warn("Cannot open color picker: the `vanilla-picker` library is not included in the bundle. Either use the full bundle or implement your own color picker using `onColorPicker`.");
            },
            timestampTag: !0,
            timestampFormat: null,
            createQuery: i.r,
            executeQuery: i.J,
            onEvent: null,
            enableSort: !0,
            enableTransform: !0
          }, t && (Object.keys(t).forEach(function (e) {
            n.options[e] = t[e];
          }), null == t.limitDragging) && null != t.schema && ((this || _global).options.limitDragging = !0), this.setSchema((this || _global).options.schema, (this || _global).options.schemaRefs), (this || _global)._debouncedValidate = (0, k.debounce)((this || _global)._validateAndCatch.bind(this || _global), (this || _global).DEBOUNCE_INTERVAL), t.onSelectionChange && this.onSelectionChange(t.onSelectionChange), (0, l.cC)((this || _global).options.languages), (0, l.m0)((this || _global).options.language);
        }, t.set = function (e) {
          e instanceof Function || void 0 === e ? this.clear() : ((this || _global).content.removeChild((this || _global).table), e = {
            field: (this || _global).options.name,
            value: e
          }, e = new T(this || _global, e), this._setRoot(e), this._validateAndCatch(), (this || _global).node.expand(!1), (this || _global).content.appendChild((this || _global).table)), (this || _global).history && (this || _global).history.clear(), (this || _global).searchBox && (this || _global).searchBox.clear();
        }, t.update = function (e) {
          var t, n;
          (this || _global).node.deepEqual(e) || (t = this.getSelection(), (this || _global).onChangeDisabled = !0, (this || _global).node.update(e), (this || _global).onChangeDisabled = !1, this._validateAndCatch(), (this || _global).searchBox && !(this || _global).searchBox.isEmpty() && (this || _global).searchBox.forceSearch(), t && t.start && t.end && (e = (this || _global).node.findNodeByPath(t.start.path), n = (this || _global).node.findNodeByPath(t.end.path), e) && n ? this.setSelection(t.start, t.end) : this.setSelection({}, {}));
        }, t.get = function () {
          if ((this || _global).node) return (this || _global).node.getValue();
        }, t.getText = function () {
          return JSON.stringify(this.get());
        }, t.setText = function (t) {
          try {
            this.set((0, k.parse)(t));
          } catch (e) {
            t = (0, k.tryJsonRepair)(t);
            this.set((0, k.parse)(t));
          }
        }, t.updateText = function (t) {
          try {
            this.update((0, k.parse)(t));
          } catch (e) {
            t = (0, k.tryJsonRepair)(t);
            this.update((0, k.parse)(t));
          }
        }, t.setName = function (e) {
          (this || _global).options.name = e, (this || _global).node && (this || _global).node.updateField((this || _global).options.name);
        }, t.getName = function () {
          return (this || _global).options.name;
        }, t.focus = function () {
          var e = (this || _global).scrollableContent.querySelector("[contenteditable=true]");
          e ? e.focus() : (this || _global).node.dom.expand ? (this || _global).node.dom.expand.focus() : (this || _global).node.dom.menu ? (this || _global).node.dom.menu.focus() : (e = (this || _global).frame.querySelector("button")) && e.focus();
        }, t.clear = function () {
          (this || _global).node && ((this || _global).node.hide(), delete (this || _global).node), (this || _global).treePath && (this || _global).treePath.reset();
        }, t._setRoot = function (e) {
          this.clear(), ((this || _global).node = e).setParent(null), e.setField(this.getName(), !1), delete e.index, (this || _global).tbody.appendChild(e.getDom());
        }, t.search = function (e) {
          var t;
          return (this || _global).node ? ((this || _global).content.removeChild((this || _global).table), t = (this || _global).node.search(e), (this || _global).content.appendChild((this || _global).table)) : t = [], t;
        }, t.expandAll = function () {
          (this || _global).node && ((this || _global).content.removeChild((this || _global).table), (this || _global).node.expand(), (this || _global).content.appendChild((this || _global).table));
        }, t.collapseAll = function () {
          (this || _global).node && ((this || _global).content.removeChild((this || _global).table), (this || _global).node.collapse(), (this || _global).content.appendChild((this || _global).table));
        }, t.expand = function (e) {
          var t;
          e && (t = (this || _global).node ? (this || _global).node.findNodeByPath(e.path) : null) && (e.isExpand ? t.expand(e.recursive) : t.collapse(e.recursive));
        }, t._onAction = function (e, t) {
          (this || _global).history && (this || _global).history.add(e, t), this._onChange();
        }, t._onChange = function () {
          if (!(this || _global).onChangeDisabled) {
            var e;
            if ((this || _global).selection = this.getDomSelection(), this._debouncedValidate(), (this || _global).treePath && ((e = (this || _global).node && (this || _global).selection ? (this || _global).node.findNodeByInternalPath((this || _global).selection.path) : (this || _global).multiselection ? (this || _global).multiselection.nodes[0] : void 0) ? this._updateTreePath(e.getNodePath()) : (this || _global).treePath.reset()), (this || _global).options.onChange) try {
              (this || _global).options.onChange();
            } catch (e) {
              console.error("Error in onChange callback: ", e);
            }
            if ((this || _global).options.onChangeJSON) try {
              (this || _global).options.onChangeJSON(this.get());
            } catch (e) {
              console.error("Error in onChangeJSON callback: ", e);
            }
            if ((this || _global).options.onChangeText) try {
              (this || _global).options.onChangeText(this.getText());
            } catch (e) {
              console.error("Error in onChangeText callback: ", e);
            }
            if ((this || _global).options.onClassName && (this || _global).node.recursivelyUpdateCssClassesOnNodes(), (this || _global).options.onNodeName && (this || _global).node.childs) try {
              (this || _global).node.recursivelyUpdateNodeName();
            } catch (e) {
              console.error("Error in onNodeName callback: ", e);
            }
          }
        }, t.validate = function () {
          var t = this || _global,
            n = (this || _global).node;
          if (n) {
            var e = n.getValue(),
              i = [];
            (this || _global).validateSchema && !this.validateSchema(e) && (i = (this || _global).validateSchema.errors.map(function (e) {
              return (0, k.improveSchemaError)(e);
            }).map(function (e) {
              return {
                node: n.findNode(e.dataPath),
                error: e,
                type: "validation"
              };
            }).filter(function (e) {
              return null != e.node;
            }));
            try {
              (this || _global).validationSequence++;
              var o = this || _global,
                r = (this || _global).validationSequence;
              return this._validateCustom(e).then(function (e) {
                return r === o.validationSequence && (e = [].concat(i, e || []), o._renderValidationErrors(e), "function" == typeof t.options.onValidationError && (0, k.isValidationErrorChanged)(e, t.lastSchemaErrors) && t.options.onValidationError.call(t, e), t.lastSchemaErrors = e), t.lastSchemaErrors;
              });
            } catch (e) {
              return Promise.reject(e);
            }
          }
        }, t._validateAndCatch = function () {
          this.validate().catch(function (e) {
            console.error("Error running validation:", e);
          });
        }, t._renderValidationErrors = function (e) {
          (this || _global).errorNodes && (this || _global).errorNodes.forEach(function (e) {
            e.setError(null);
          });
          var t = e.reduce(function (e, t) {
            return t.node.findParents().filter(function (t) {
              return !e.some(function (e) {
                return e[0] === t;
              });
            }).map(function (e) {
              return [e, t.node];
            }).concat(e);
          }, []);
          (this || _global).errorNodes = t.map(function (e) {
            return {
              node: e[0],
              child: e[1],
              error: {
                message: "object" === e[0].type ? (0, l.Iu)("containsInvalidProperties") : (0, l.Iu)("containsInvalidItems")
              }
            };
          }).concat(e).map(function (e) {
            return e.node.setError(e.error, e.child), e.node;
          });
        }, t._validateCustom = function (e) {
          try {
            var n, t;
            if ((this || _global).options.onValidate) return n = (this || _global).node, t = (this || _global).options.onValidate(e), ((0, k.isPromise)(t) ? t : Promise.resolve(t)).then(function (e) {
              return Array.isArray(e) ? e.filter(function (e) {
                var t = (0, k.isValidValidationError)(e);
                return t || console.warn("Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: \"...\"}. Actual error:", e), t;
              }).map(function (e) {
                var t;
                try {
                  t = e && e.path ? n.findNodeByPath(e.path) : null;
                } catch (e) {}
                return t || console.warn("Ignoring validation error: node not found. Path:", e.path, "Error:", e), {
                  node: t,
                  error: e,
                  type: "customValidation"
                };
              }).filter(function (e) {
                return e && e.node && e.error && e.error.message;
              }) : null;
            });
          } catch (e) {
            return Promise.reject(e);
          }
          return Promise.resolve(null);
        }, t.refresh = function () {
          (this || _global).node && (this || _global).node.updateDom({
            recurse: !0
          });
        }, t.startAutoScroll = function (e) {
          var t = this || _global,
            n = (this || _global).scrollableContent,
            i = (0, k.getAbsoluteTop)(n),
            o = n.clientHeight,
            r = i + o;
          e < i + 24 && 0 < n.scrollTop ? (this || _global).autoScrollStep = (i + 24 - e) / 3 : r - 24 < e && o + n.scrollTop < n.scrollHeight ? (this || _global).autoScrollStep = (r - 24 - e) / 3 : (this || _global).autoScrollStep = void 0, (this || _global).autoScrollStep ? (this || _global).autoScrollTimer || ((this || _global).autoScrollTimer = setInterval(function () {
            t.autoScrollStep ? n.scrollTop -= t.autoScrollStep : t.stopAutoScroll();
          }, 50)) : this.stopAutoScroll();
        }, t.stopAutoScroll = function () {
          (this || _global).autoScrollTimer && (clearTimeout((this || _global).autoScrollTimer), delete (this || _global).autoScrollTimer), (this || _global).autoScrollStep && delete (this || _global).autoScrollStep;
        }, t.setDomSelection = function (e) {
          var t, n, i;
          e && ("scrollTop" in e && (this || _global).scrollableContent && ((this || _global).scrollableContent.scrollTop = e.scrollTop), e.paths ? (t = this || _global, n = e.paths.map(function (e) {
            return t.node.findNodeByInternalPath(e);
          }), this.select(n)) : (i = (n = e.path ? (this || _global).node.findNodeByInternalPath(e.path) : null) && e.domName ? n.dom[e.domName] : null, e.range && i ? (e = Object.assign({}, e.range, {
            container: i
          }), (0, k.setSelectionOffset)(e)) : n && n.focus()));
        }, t.getDomSelection = function () {
          var t = T.getNodeFromTarget((this || _global).focusTarget),
            n = (this || _global).focusTarget,
            e = t ? Object.keys(t.dom).find(function (e) {
              return t.dom[e] === n;
            }) : null,
            i = (0, k.getSelectionOffset)();
          return (i = (i = i && "DIV" !== i.container.nodeName ? null : i) && i.container !== n ? null : i) && delete i.container, {
            path: t ? t.getInternalPath() : null,
            domName: e,
            range: i,
            paths: 0 < (this || _global).multiselection.length ? (this || _global).multiselection.nodes.map(function (e) {
              return e.getInternalPath();
            }) : null,
            scrollTop: (this || _global).scrollableContent ? (this || _global).scrollableContent.scrollTop : 0
          };
        }, t.scrollTo = function (e, n) {
          var i,
            t,
            o,
            r,
            s = (this || _global).scrollableContent;
          s ? ((i = this || _global).animateTimeout && (clearTimeout(i.animateTimeout), delete i.animateTimeout), i.animateCallback && (i.animateCallback(!1), delete i.animateCallback), t = s.clientHeight, o = s.scrollHeight - t, r = Math.min(Math.max(e - t / 4, 0), o), function e() {
            var t = s.scrollTop,
              t = r - t;
            3 < Math.abs(t) ? (s.scrollTop += t / 3, i.animateCallback = n, i.animateTimeout = setTimeout(e, 50)) : (n && n(!0), s.scrollTop = r, delete i.animateTimeout, delete i.animateCallback);
          }()) : n && n(!1);
        }, t._createFrame = function () {
          var e = this || _global,
            t = ((this || _global).frame = document.createElement("div"), (this || _global).frame.className = "jsoneditor jsoneditor-mode-" + (this || _global).options.mode, (this || _global).container.appendChild((this || _global).frame), (this || _global).contentOuter = document.createElement("div"), (this || _global).contentOuter.className = "jsoneditor-outer", this || _global);
          function n(e) {
            t._onEvent && t._onEvent(e);
          }
          var i,
            o,
            r,
            s = {
              target: (this || _global).frame,
              onFocus: (this || _global).options.onFocus || null,
              onBlur: (this || _global).options.onBlur || null
            };
          (this || _global).frameFocusTracker = new a.R(s), (this || _global).frame.onclick = function (e) {
            var t = e.target;
            n(e), "BUTTON" === t.nodeName && e.preventDefault();
          }, (this || _global).frame.oninput = n, (this || _global).frame.onchange = n, (this || _global).frame.onkeydown = n, (this || _global).frame.onkeyup = n, (this || _global).frame.oncut = n, (this || _global).frame.onpaste = n, (this || _global).frame.onmousedown = n, (this || _global).frame.onmouseup = n, (this || _global).frame.onmouseover = n, (this || _global).frame.onmouseout = n, (0, k.addEventListener)((this || _global).frame, "focus", n, !0), (0, k.addEventListener)((this || _global).frame, "blur", n, !0), (this || _global).frame.onfocusin = n, (this || _global).frame.onfocusout = n, (this || _global).options.mainMenuBar && ((0, k.addClassName)((this || _global).contentOuter, "has-main-menu-bar"), (this || _global).menu = document.createElement("div"), (this || _global).menu.className = "jsoneditor-menu", (this || _global).frame.appendChild((this || _global).menu), (s = document.createElement("button")).type = "button", s.className = "jsoneditor-expand-all", s.title = (0, l.Iu)("expandAll"), s.onclick = function () {
            t.expandAll(), "function" == typeof e.options.onExpand && e.options.onExpand({
              path: [],
              isExpand: !0,
              recursive: !0
            });
          }, (this || _global).menu.appendChild(s), (s = document.createElement("button")).type = "button", s.title = (0, l.Iu)("collapseAll"), s.className = "jsoneditor-collapse-all", s.onclick = function () {
            t.collapseAll(), "function" == typeof e.options.onExpand && e.options.onExpand({
              path: [],
              isExpand: !1,
              recursive: !0
            });
          }, (this || _global).menu.appendChild(s), (this || _global).options.enableSort && ((s = document.createElement("button")).type = "button", s.className = "jsoneditor-sort", s.title = (0, l.Iu)("sortTitleShort"), s.onclick = function () {
            t.node.showSortModal();
          }, (this || _global).menu.appendChild(s)), (this || _global).options.enableTransform && ((s = document.createElement("button")).type = "button", s.title = (0, l.Iu)("transformTitleShort"), s.className = "jsoneditor-transform", s.onclick = function () {
            t.node.showTransformModal();
          }, (this || _global).menu.appendChild(s)), (this || _global).history && ((i = document.createElement("button")).type = "button", i.className = "jsoneditor-undo jsoneditor-separator", i.title = (0, l.Iu)("undo"), i.onclick = function () {
            t._onUndo();
          }, (this || _global).menu.appendChild(i), (this || _global).dom.undo = i, (o = document.createElement("button")).type = "button", o.className = "jsoneditor-redo", o.title = (0, l.Iu)("redo"), o.onclick = function () {
            t._onRedo();
          }, (this || _global).menu.appendChild(o), (this || _global).dom.redo = o, (this || _global).history.onChange = function () {
            i.disabled = !t.history.canUndo(), o.disabled = !t.history.canRedo();
          }, (this || _global).history.onChange()), (this || _global).options && (this || _global).options.modes && (this || _global).options.modes.length && ((r = this || _global).modeSwitcher = new c.x((this || _global).menu, (this || _global).options.modes, (this || _global).options.mode, function (e) {
            try {
              r.setMode(e), r.modeSwitcher.focus();
            } catch (e) {
              r._onError(e);
            }
          })), (this || _global).options.search) && ((this || _global).searchBox = new Z(this || _global, (this || _global).menu)), (this || _global).options.navigationBar && ((this || _global).navBar = document.createElement("div"), (this || _global).navBar.className = "jsoneditor-navigation-bar nav-bar-empty", (this || _global).frame.appendChild((this || _global).navBar), (this || _global).treePath = new O((this || _global).navBar, this.getPopupAnchor()), (this || _global).treePath.onSectionSelected((this || _global)._onTreePathSectionSelected.bind(this || _global)), (this || _global).treePath.onContextMenuItemSelected((this || _global)._onTreePathMenuItemSelected.bind(this || _global)));
        }, t._onUndo = function () {
          (this || _global).history && ((this || _global).history.undo(), this._onChange());
        }, t._onRedo = function () {
          (this || _global).history && ((this || _global).history.redo(), this._onChange());
        }, t._onEvent = function (e) {
          if (!T.targetIsColorPicker(e.target)) {
            var t,
              n = T.getNodeFromTarget(e.target);
            if ("keydown" === e.type && this._onKeyDown(e), n && "focus" === e.type && ((this || _global).focusTarget = e.target, (this || _global).options.autocomplete) && "focus" === (this || _global).options.autocomplete.trigger && this._showAutoComplete(e.target), "mousedown" === e.type && this._startDragDistance(e), "mousemove" !== e.type && "mouseup" !== e.type && "click" !== e.type || this._updateDragDistance(e), n && (this || _global).options && (this || _global).options.navigationBar && n && ("keydown" === e.type || "mousedown" === e.type) && (t = this || _global, setTimeout(function () {
              t._updateTreePath(n.getNodePath());
            })), n && n.selected) {
              if ("click" === e.type) {
                if (e.target === n.dom.menu) return void this.showContextMenu(e.target);
                e.hasMoved || this.deselect();
              }
              "mousedown" === e.type && T.onDragStart((this || _global).multiselection.nodes, e);
            } else "mousedown" === e.type && (0, k.hasParentNode)(e.target, (this || _global).content) && (this.deselect(), n && e.target === n.dom.drag ? T.onDragStart(n, e) : n && (e.target === n.dom.field || e.target === n.dom.value || e.target === n.dom.select) || this._onMultiSelectStart(e));
            n && n.onEvent(e);
          }
        }, t._updateTreePath = function (e) {
          var n;
          function i(e) {
            return e.parent ? "array" === e.parent.type ? e.index : e.field : e.field || e.type;
          }
          e && e.length ? ((0, k.removeClassName)((this || _global).navBar, "nav-bar-empty"), n = [], e.forEach(function (e) {
            var t = {
              name: i(e),
              node: e,
              children: []
            };
            e.childs && e.childs.length && e.childs.forEach(function (e) {
              t.children.push({
                name: i(e),
                node: e
              });
            }), n.push(t);
          }), (this || _global).treePath.setPath(n)) : (0, k.addClassName)((this || _global).navBar, "nav-bar-empty");
        }, t._onTreePathSectionSelected = function (e) {
          e && e.node && (e.node.expandTo(), e.node.focus());
        }, t._onTreePathMenuItemSelected = function (e, t) {
          e && e.children.length && (e = e.children.find(function (e) {
            return e.name === t;
          })) && e.node && (this._updateTreePath(e.node.getNodePath()), e.node.expandTo(), e.node.focus());
        }, t._startDragDistance = function (e) {
          (this || _global).dragDistanceEvent = {
            initialTarget: e.target,
            initialPageX: e.pageX,
            initialPageY: e.pageY,
            dragDistance: 0,
            hasMoved: !1
          };
        }, t._updateDragDistance = function (e) {
          (this || _global).dragDistanceEvent || this._startDragDistance(e);
          var t = e.pageX - (this || _global).dragDistanceEvent.initialPageX,
            n = e.pageY - (this || _global).dragDistanceEvent.initialPageY;
          return (this || _global).dragDistanceEvent.dragDistance = Math.sqrt(t * t + n * n), (this || _global).dragDistanceEvent.hasMoved = (this || _global).dragDistanceEvent.hasMoved || 10 < (this || _global).dragDistanceEvent.dragDistance, e.dragDistance = (this || _global).dragDistanceEvent.dragDistance, e.hasMoved = (this || _global).dragDistanceEvent.hasMoved, e.dragDistance;
        }, t._onMultiSelectStart = function (e) {
          var t,
            n = T.getNodeFromTarget(e.target);
          "tree" === (this || _global).options.mode && void 0 === (this || _global).options.onEditable && ((this || _global).multiselection = {
            start: n || null,
            end: null,
            nodes: []
          }, this._startDragDistance(e), (t = this || _global).mousemove || ((this || _global).mousemove = (0, k.addEventListener)(e.view, "mousemove", function (e) {
            t._onMultiSelect(e);
          })), (this || _global).mouseup || ((this || _global).mouseup = (0, k.addEventListener)(e.view, "mouseup", function (e) {
            t._onMultiSelectEnd(e);
          })), e.preventDefault());
        }, t._onMultiSelect = function (e) {
          var t;
          e.preventDefault(), this._updateDragDistance(e), e.hasMoved && ((e = T.getNodeFromTarget(e.target)) && (null == (this || _global).multiselection.start && ((this || _global).multiselection.start = e), (this || _global).multiselection.end = e), this.deselect(), e = (this || _global).multiselection.start, t = (this || _global).multiselection.end || (this || _global).multiselection.start, e) && t && ((this || _global).multiselection.nodes = this._findTopLevelNodes(e, t), (this || _global).multiselection.nodes && (this || _global).multiselection.nodes.length && (e = (this || _global).multiselection.nodes[0], (this || _global).multiselection.start === e || (this || _global).multiselection.start.isDescendantOf(e) ? (this || _global).multiselection.direction = "down" : (this || _global).multiselection.direction = "up"), this.select((this || _global).multiselection.nodes));
        }, t._onMultiSelectEnd = function (e) {
          var t = (this || _global).multiselection.nodes[0];
          t && t.dom.menu && t.dom.menu.focus(), (this || _global).multiselection.start = null, (this || _global).multiselection.end = null, (this || _global).mousemove && ((0, k.removeEventListener)(e.view, "mousemove", (this || _global).mousemove), delete (this || _global).mousemove), (this || _global).mouseup && ((0, k.removeEventListener)(e.view, "mouseup", (this || _global).mouseup), delete (this || _global).mouseup);
        }, t.deselect = function (e) {
          var t = !!(this || _global).multiselection.nodes.length;
          (this || _global).multiselection.nodes.forEach(function (e) {
            e.setSelected(!1);
          }), (this || _global).multiselection.nodes = [], e && ((this || _global).multiselection.start = null, (this || _global).multiselection.end = null), t && (this || _global)._selectionChangedHandler && this._selectionChangedHandler();
        }, t.select = function (e) {
          if (!Array.isArray(e)) return this.select([e]);
          var t;
          e && (this.deselect(), (this || _global).multiselection.nodes = e.slice(0), t = e[0], e.forEach(function (e) {
            e.expandPathToNode(), e.setSelected(!0, e === t);
          }), (this || _global)._selectionChangedHandler) && (e = this.getSelection(), this._selectionChangedHandler(e.start, e.end));
        }, t._findTopLevelNodes = function (e, t) {
          for (var n = e.getNodePath(), i = t.getNodePath(), o = 0; o < n.length && n[o] === i[o];) o++;
          var r,
            e = n[o - 1],
            t = n[o],
            s = i[o];
          return t && s || (e.parent ? e = (s = t = e).parent : (t = e.childs[0], s = e.childs[e.childs.length - 1])), e && t && s ? (t = e.childs.indexOf(t), s = e.childs.indexOf(s), r = Math.min(t, s), t = Math.max(t, s), e.childs.slice(r, t + 1)) : [];
        }, t._showAutoComplete = function (t) {
          var n,
            i = T.getNodeFromTarget(t),
            o = "";
          0 <= t.className.indexOf("jsoneditor-value") && (o = "value"), "" !== (o = 0 <= t.className.indexOf("jsoneditor-field") ? "field" : o) && (n = this || _global, setTimeout(function () {
            var e;
            !i || !("focus" === n.options.autocomplete.trigger || 0 < t.innerText.length) || null === (e = n.options.autocomplete.getOptions(t.innerText, i.getPath(), o, i.editor)) ? n.autocomplete.hideDropDown() : "function" == typeof e.then ? e.then(function (e) {
              null === e ? n.autocomplete.hideDropDown() : e.options ? n.autocomplete.show(t, e.startFrom, e.options) : n.autocomplete.show(t, 0, e);
            }).catch(function (e) {
              console.error(e);
            }) : e.options ? n.autocomplete.show(t, e.startFrom, e.options) : n.autocomplete.show(t, 0, e);
          }, 50));
        }, t._onKeyDown = function (e) {
          var t,
            n = e.which || e.keyCode,
            i = e.altKey,
            o = e.ctrlKey,
            r = e.metaKey,
            s = e.shiftKey,
            a = !1,
            l = (this || _global).focusTarget;
          9 === n && (t = this || _global, setTimeout(function () {
            t.focusTarget !== l && (0, k.selectContentEditable)(t.focusTarget);
          }, 0)), (this || _global).searchBox && (o && 70 === n ? ((this || _global).searchBox.dom.search.focus(), (this || _global).searchBox.dom.search.select(), a = !0) : (114 === n || o && 71 === n) && (s ? (this || _global).searchBox.previous(!0) : (this || _global).searchBox.next(!0), a = !0)), (this || _global).history && (o && !s && 90 === n ? (this._onUndo(), a = !0) : o && s && 90 === n && (this._onRedo(), a = !0)), !(this || _global).options.autocomplete || a || o || i || r || 1 !== e.key.length && 8 !== n && 46 !== n || (a = !1, this._showAutoComplete(e.target)), a && (e.preventDefault(), e.stopPropagation());
        }, t._createTable = function () {
          var e;
          (this || _global).options.navigationBar && (0, k.addClassName)((this || _global).contentOuter, "has-nav-bar"), (this || _global).scrollableContent = document.createElement("div"), (this || _global).scrollableContent.className = "jsoneditor-tree", (this || _global).contentOuter.appendChild((this || _global).scrollableContent), (this || _global).content = document.createElement("div"), (this || _global).content.className = "jsoneditor-tree-inner", (this || _global).scrollableContent.appendChild((this || _global).content), (this || _global).table = document.createElement("table"), (this || _global).table.className = "jsoneditor-tree", (this || _global).content.appendChild((this || _global).table), (this || _global).colgroupContent = document.createElement("colgroup"), "tree" === (this || _global).options.mode && ((e = document.createElement("col")).width = "24px", (this || _global).colgroupContent.appendChild(e)), (e = document.createElement("col")).width = "24px", (this || _global).colgroupContent.appendChild(e), e = document.createElement("col"), (this || _global).colgroupContent.appendChild(e), (this || _global).table.appendChild((this || _global).colgroupContent), (this || _global).tbody = document.createElement("tbody"), (this || _global).table.appendChild((this || _global).tbody), (this || _global).frame.appendChild((this || _global).contentOuter);
        }, t.showContextMenu = function (e, t) {
          var n,
            i = [],
            o = (this || _global).multiselection.nodes.slice();
          i.push({
            text: (0, l.Iu)("duplicateText"),
            title: (0, l.Iu)("duplicateTitle"),
            className: "jsoneditor-duplicate",
            click: function () {
              T.onDuplicate(o);
            }
          }), i.push({
            text: (0, l.Iu)("remove"),
            title: (0, l.Iu)("removeTitle"),
            className: "jsoneditor-remove",
            click: function () {
              T.onRemove(o);
            }
          }), (this || _global).options.onCreateMenu && (n = o.map(function (e) {
            return e.getPath();
          }), i = (this || _global).options.onCreateMenu(i, {
            type: "multiple",
            path: n[0],
            paths: n
          })), new s.x(i, {
            close: t
          }).show(e, this.getPopupAnchor());
        }, t.getPopupAnchor = function () {
          return (this || _global).options.popupAnchor || (this || _global).frame;
        }, t.getSelection = function () {
          var e,
            t,
            n = {
              start: null,
              end: null
            };
          return (this || _global).multiselection.nodes && (this || _global).multiselection.nodes.length && (this || _global).multiselection.nodes.length && (e = (this || _global).multiselection.nodes[0], t = (this || _global).multiselection.nodes[(this || _global).multiselection.nodes.length - 1], "down" === (this || _global).multiselection.direction ? (n.start = e.serialize(), n.end = t.serialize()) : (n.start = t.serialize(), n.end = e.serialize())), n;
        }, t.onSelectionChange = function (e) {
          "function" == typeof e && ((this || _global)._selectionChangedHandler = (0, k.debounce)(e, (this || _global).DEBOUNCE_INTERVAL));
        }, t.setSelection = function (e, t) {
          e && e.dom && e.range && (console.warn("setSelection/getSelection usage for text selection is deprecated and should not be used, see documentation for supported selection options"), this.setDomSelection(e));
          e = this._getNodeInstancesByRange(e, t);
          e.forEach(function (e) {
            e.expandTo();
          }), this.select(e);
        }, t._getNodeInstancesByRange = function (e, t) {
          e && e.path && (n = (this || _global).node.findNodeByPath(e.path), t) && t.path && (i = (this || _global).node.findNodeByPath(t.path));
          var n,
            i,
            o = [];
          if (n instanceof T) if (i instanceof T && i !== n) {
            if (n.parent === i.parent) {
              t = n.getIndex() < i.getIndex() ? (e = n, i) : (e = i, n);
              var r = e;
              for (o.push(r); r = r.nextSibling(), o.push(r), r && r !== t;);
            } else o = this._findTopLevelNodes(n, i);
          } else o.push(n);
          return o;
        }, t.getNodesByRange = function (e, t) {
          var e = this._getNodeInstancesByRange(e, t),
            n = [];
          return e.forEach(function (e) {
            n.push(e.serialize());
          }), n;
        }, [{
          mode: "tree",
          mixin: t,
          data: "json"
        }, {
          mode: "view",
          mixin: t,
          data: "json"
        }, {
          mode: "form",
          mixin: t,
          data: "json"
        }]);
    },
    2744: function (e, t, n) {
      t.tryRequireAjv = function () {
        try {
          return n(8903);
        } catch (e) {}
      };
    },
    9125: function (e, t, n) {
      t.O = function () {
        try {
          n(4864);
        } catch (e) {
          console.error(e);
        }
      };
    },
    9791: function (W, e, t) {
      "use strict";

      t.r(e), t.d(e, {
        addClassName: function () {
          return P;
        },
        addEventListener: function () {
          return X;
        },
        asyncExec: function () {
          return Ie;
        },
        clear: function () {
          return C;
        },
        compileJSONPointer: function () {
          return $;
        },
        contains: function () {
          return Ce;
        },
        debounce: function () {
          return ne;
        },
        escapeUnicodeChars: function () {
          return p;
        },
        extend: function () {
          return f;
        },
        findUniqueName: function () {
          return ce;
        },
        formatSize: function () {
          return me;
        },
        get: function () {
          return N;
        },
        getAbsoluteLeft: function () {
          return H;
        },
        getAbsoluteTop: function () {
          return G;
        },
        getChildPaths: function () {
          return he;
        },
        getColorCSS: function () {
          return L;
        },
        getIndexForPosition: function () {
          return re;
        },
        getInnerText: function () {
          return k;
        },
        getInputSelection: function () {
          return oe;
        },
        getInternetExplorerVersion: function () {
          return z;
        },
        getPositionForPath: function () {
          return se;
        },
        getSelection: function () {
          return S;
        },
        getSelectionOffset: function () {
          return D;
        },
        getType: function () {
          return y;
        },
        getWindow: function () {
          return A;
        },
        hasParentNode: function () {
          return j;
        },
        improveSchemaError: function () {
          return Q;
        },
        insideRect: function () {
          return te;
        },
        isArray: function () {
          return b;
        },
        isChildOf: function () {
          return J;
        },
        isFirefox: function () {
          return R;
        },
        isObject: function () {
          return B;
        },
        isPromise: function () {
          return q;
        },
        isTimestamp: function () {
          return pe;
        },
        isUrl: function () {
          return I;
        },
        isValidColor: function () {
          return ae;
        },
        isValidValidationError: function () {
          return ee;
        },
        isValidationErrorChanged: function () {
          return ye;
        },
        limitCharacters: function () {
          return fe;
        },
        makeFieldTooltip: function () {
          return le;
        },
        parse: function () {
          return u;
        },
        parsePath: function () {
          return _;
        },
        parseString: function () {
          return ge;
        },
        removeAllClassNames: function () {
          return F;
        },
        removeClassName: function () {
          return V;
        },
        removeEventListener: function () {
          return Y;
        },
        removeReturnsAndSurroundingWhitespace: function () {
          return E;
        },
        selectContentEditable: function () {
          return O;
        },
        setEndOfContentEditable: function () {
          return Z;
        },
        setSelection: function () {
          return x;
        },
        setSelectionOffset: function () {
          return K;
        },
        sort: function () {
          return de;
        },
        sortObjectKeys: function () {
          return ue;
        },
        stringifyPath: function () {
          return U;
        },
        stripFormatting: function () {
          return w;
        },
        textDiff: function () {
          return ie;
        },
        tryJsonRepair: function () {
          return g;
        },
        uniqueMergeArrays: function () {
          return ve;
        },
        validate: function () {
          return m;
        }
      });
      t(4987);
      var e = t(233),
        o = t.n(e),
        n = t(1262),
        i = t(6589),
        r = t(7026),
        s = t(7907);
      function a(e) {
        return function (e) {
          if (Array.isArray(e)) return l(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function (e, t) {
          var n;
          if (e) return "string" == typeof e ? l(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? l(e, t) : void 0;
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function l(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
        return i;
      }
      function c(e) {
        return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      var h = 10000,
        d = 946684800000;
      function u(t) {
        try {
          return JSON.parse(t);
        } catch (e) {
          throw m(t), e;
        }
      }
      function g(t) {
        try {
          return (0, n.K)(t);
        } catch (e) {
          return t;
        }
      }
      function p(e) {
        return e.replace(/[\u007F-\uFFFF]/g, function (e) {
          return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
        });
      }
      function m(e) {
        (void 0 !== i ? i : JSON).parse(e);
      }
      function f(e, t) {
        for (var n in t) M(t, n) && (e[n] = t[n]);
        return e;
      }
      function C(e) {
        for (var t in e) M(e, t) && delete e[t];
        return e;
      }
      function y(e) {
        return null === e ? "null" : void 0 === e ? "undefined" : e instanceof Number || "number" == typeof e ? "number" : e instanceof String || "string" == typeof e ? "string" : e instanceof Boolean || "boolean" == typeof e ? "boolean" : e instanceof RegExp ? "regexp" : b(e) ? "array" : "object";
      }
      var v = /^https?:\/\/\S+$/;
      function I(e) {
        return ("string" == typeof e || e instanceof String) && v.test(e);
      }
      function b(e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }
      function A(e) {
        return e.ownerDocument.defaultView;
      }
      function H(e) {
        return e.getBoundingClientRect().left + window.pageXOffset || document.scrollLeft || 0;
      }
      function G(e) {
        return e.getBoundingClientRect().top + window.pageYOffset || document.scrollTop || 0;
      }
      function P(e, t) {
        var n = e.className.split(" ");
        -1 === n.indexOf(t) && (n.push(t), e.className = n.join(" "));
      }
      function F(e) {
        e.className = "";
      }
      function V(e, t) {
        var n = e.className.split(" "),
          t = n.indexOf(t);
        -1 !== t && (n.splice(t, 1), e.className = n.join(" "));
      }
      function w(e) {
        for (var t = e.childNodes, n = 0, i = t.length; n < i; n++) {
          var o = t[n],
            r = (o.style && o.removeAttribute("style"), o.attributes);
          if (r) for (var s = r.length - 1; 0 <= s; s--) {
            var a = r[s];
            !0 === a.specified && o.removeAttribute(a.name);
          }
          w(o);
        }
      }
      function Z(e) {
        var t;
        document.createRange && ((t = document.createRange()).selectNodeContents(e), t.collapse(!1), (e = window.getSelection()).removeAllRanges(), e.addRange(t));
      }
      function O(e) {
        var t;
        e && "DIV" === e.nodeName && window.getSelection && document.createRange && ((t = document.createRange()).selectNodeContents(e), (e = window.getSelection()).removeAllRanges(), e.addRange(t));
      }
      function S() {
        if (window.getSelection) {
          var e = window.getSelection();
          if (e.getRangeAt && e.rangeCount) return e.getRangeAt(0);
        }
        return null;
      }
      function x(e) {
        var t;
        e && window.getSelection && ((t = window.getSelection()).removeAllRanges(), t.addRange(e));
      }
      function D() {
        var e = S();
        return e && "startOffset" in e && "endOffset" in e && e.startContainer && e.startContainer === e.endContainer ? {
          startOffset: e.startOffset,
          endOffset: e.endOffset,
          container: e.startContainer.parentNode
        } : null;
      }
      function K(e) {
        var t;
        document.createRange && window.getSelection && window.getSelection() && (t = document.createRange(), e.container.firstChild || e.container.appendChild(document.createTextNode("")), t.setStart(e.container.firstChild, e.startOffset), t.setEnd(e.container.firstChild, e.endOffset), x(t));
      }
      function k(e, t) {
        var n;
        if (void 0 === t && (t = {
          _text: "",
          flush: function () {
            var e = (this || _global)._text;
            return (this || _global)._text = "", e;
          },
          set: function (e) {
            (this || _global)._text = e;
          }
        }), e.nodeValue) return "" !== (n = E(e.nodeValue)) ? t.flush() + n : "";
        if (e.hasChildNodes()) {
          for (var i = e.childNodes, o = "", r = 0, s = i.length; r < s; r++) {
            var a,
              l = i[r];
            "DIV" === l.nodeName || "P" === l.nodeName ? ((a = (a = i[r - 1]) ? a.nodeName : void 0) && "DIV" !== a && "P" !== a && "BR" !== a && ("" !== o && (o += "\n"), t.flush()), o += k(l, t), t.set("\n")) : "BR" === l.nodeName ? (o += t.flush(), t.set("\n")) : o += k(l, t);
          }
          return o;
        }
        return "";
      }
      function E(e) {
        return e.replace(/(\b|^)\s*(\b|$)/g, function (e) {
          return /\n/.exec(e) ? "" : e;
        });
      }
      function j(e, t) {
        for (var n = e ? e.parentNode : void 0; n;) {
          if (n === t) return !0;
          n = n.parentNode;
        }
        return !1;
      }
      function z() {
        var e;
        return -1 === T && (e = -1, "undefined" != typeof navigator && "Microsoft Internet Explorer" === navigator.appName && null != /MSIE ([0-9]+[.0-9]+)/.exec(navigator.userAgent) && (e = parseFloat(RegExp.$1)), T = e), T;
      }
      var T = -1;
      function R() {
        return "undefined" != typeof navigator && -1 !== navigator.userAgent.indexOf("Firefox");
      }
      function X(e, t, n, i) {
        return e.addEventListener ? (void 0 === i && (i = !1), "mousewheel" === t && R() && (t = "DOMMouseScroll"), e.addEventListener(t, n, i), n) : e.attachEvent ? (e.attachEvent("on" + t, i = function () {
          return n.call(e, window.event);
        }), i) : void 0;
      }
      function Y(e, t, n, i) {
        e.removeEventListener ? (void 0 === i && (i = !1), "mousewheel" === t && R() && (t = "DOMMouseScroll"), e.removeEventListener(t, n, i)) : e.detachEvent && e.detachEvent("on" + t, n);
      }
      function J(e, t) {
        for (var n = e.parentNode; n;) {
          if (n === t) return !0;
          n = n.parentNode;
        }
        return !1;
      }
      function _(n) {
        var e = [],
          i = 0;
        function t(e) {
          for (var t = ""; void 0 !== n[i] && n[i] !== e;) t += n[i], i++;
          if (n[i] !== e) throw new Error("Invalid JSON path: unexpected end, character " + e + " expected");
          return t;
        }
        for (; void 0 !== n[i];) if ("." === n[i]) i++, e.push(function () {
          for (var e = ""; void 0 !== n[i] && /[\w$]/.test(n[i]);) e += n[i], i++;
          if ("" === e) throw new Error("Invalid JSON path: property name expected at index " + i);
          return e;
        }());else {
          if ("[" !== n[i]) throw new Error("Invalid JSON path: unexpected character \"" + n[i] + "\" at index " + i);
          if ("'" === n[++i] || "\"" === n[i]) {
            var o = n[i];
            if (i++, e.push(t(o)), n[i] !== o) throw new Error("Invalid JSON path: closing quote ' expected at index " + i);
            i++;
          } else {
            o = t("]").trim();
            if (0 === o.length) throw new Error("Invalid JSON path: array value expected at index " + i);
            o = "*" === o ? o : JSON.parse(o), e.push(o);
          }
          if ("]" !== n[i]) throw new Error("Invalid JSON path: closing bracket ] expected at index " + i);
          i++;
        }
        return e;
      }
      function U(e) {
        return e.map(function (e) {
          return "number" == typeof e ? "[" + e + "]" : "string" == typeof e && e.match(/^[A-Za-z0-9_$]+$/) ? "." + e : "[\"" + e + "\"]";
        }).join("");
      }
      function Q(e) {
        var t, n;
        return "enum" === e.keyword && Array.isArray(e.schema) && (n = e.schema) && (5 < (n = n.map(function (e) {
          return JSON.stringify(e);
        })).length && (t = ["(" + (n.length - 5) + " more...)"], (n = n.slice(0, 5)).push(t)), e.message = "should be equal to one of: " + n.join(", ")), "additionalProperties" === e.keyword && (e.message = "should NOT have additional property: " + e.params.additionalProperty), e;
      }
      function q(e) {
        return e && "function" == typeof e.then && "function" == typeof e.catch;
      }
      function ee(e) {
        return "object" === c(e) && Array.isArray(e.path) && "string" == typeof e.message;
      }
      function te(e, t, n) {
        n = void 0 !== n ? n : 0;
        return t.left - n >= e.left && t.right + n <= e.right && t.top - n >= e.top && t.bottom + n <= e.bottom;
      }
      function ne(i, o, r) {
        var s;
        return function () {
          var e = this || _global,
            t = arguments,
            n = r && !s;
          clearTimeout(s), s = setTimeout(function () {
            s = null, r || i.apply(e, t);
          }, o), n && i.apply(e, t);
        };
      }
      function ie(e, t) {
        for (var n = t.length, i = 0, o = e.length, r = t.length; t.charAt(i) === e.charAt(i) && i < n;) i++;
        for (; t.charAt(r - 1) === e.charAt(o - 1) && i < r && 0 < o;) r--, o--;
        return {
          start: i,
          end: r
        };
      }
      function oe(t) {
        var e,
          n,
          i,
          o,
          r = 0,
          s = 0;
        return "number" == typeof t.selectionStart && "number" == typeof t.selectionEnd ? (r = t.selectionStart, s = t.selectionEnd) : (o = document.selection.createRange()) && o.parentElement() === t && (i = t.value.length, e = t.value.replace(/\r\n/g, "\n"), (n = t.createTextRange()).moveToBookmark(o.getBookmark()), (o = t.createTextRange()).collapse(!1), -1 < n.compareEndPoints("StartToEnd", o) ? r = s = i : (r = -n.moveStart("character", -i), r += e.slice(0, r).split("\n").length - 1, -1 < n.compareEndPoints("EndToEnd", o) ? s = i : (s = -n.moveEnd("character", -i), s += e.slice(0, s).split("\n").length - 1))), {
          startIndex: r,
          endIndex: s,
          start: a(r),
          end: a(s)
        };
        function a(e) {
          e = t.value.substring(0, e);
          return {
            row: (e.match(/\n/g) || []).length + 1,
            column: e.length - e.lastIndexOf("\n")
          };
        }
      }
      function re(e, t, n) {
        var e = e.value || "";
        return 0 < t && 0 < n ? (e = e.split("\n", t), t = Math.min(e.length, t), n = Math.min(e[t - 1].length, n - 1), n = 1 === t ? n : n + 1, e.slice(0, t - 1).join("\n").length + n) : -1;
      }
      function se(e, t) {
        var n,
          i = [];
        if (t && t.length) {
          try {
            n = r.parse(e);
          } catch (e) {
            return i;
          }
          t.forEach(function (e) {
            var t = $(_(e)),
              t = n.pointers[t];
            t && i.push({
              path: e,
              line: t.key ? t.key.line : t.value ? t.value.line : 0,
              column: t.key ? t.key.column : t.value ? t.value.column : 0
            });
          });
        }
        return i;
      }
      function $(e) {
        return e.map(function (e) {
          return "/" + String(e).replace(/~/g, "~0").replace(/\//g, "~1");
        }).join("");
      }
      function L(e) {
        var t = document.createElement("div");
        return t.style.color = e, t.style.color.split(/\s+/).join("").toLowerCase() || null;
      }
      function ae(e) {
        return !!L(e);
      }
      function le(n, e) {
        var i;
        return n ? (i = "", n.title && (i += n.title), n.description && (0 < i.length && (i += "\n"), i += n.description), n.default && (0 < i.length && (i += "\n\n"), i = (i += (0, s.Iu)("default", void 0, e) + "\n") + JSON.stringify(n.default, null, 2)), Array.isArray(n.examples) && 0 < n.examples.length && (0 < i.length && (i += "\n\n"), i += (0, s.Iu)("examples", void 0, e) + "\n", n.examples.forEach(function (e, t) {
          i += JSON.stringify(e, null, 2), t !== n.examples.length - 1 && (i += "\n");
        })), i) : "";
      }
      function N(e, t) {
        for (var n = e, i = 0; i < t.length && null != n; i++) n = n[t[i]];
        return n;
      }
      function ce(e, t) {
        for (var n = e.replace(/ \(copy( \d+)?\)$/, ""), i = n, o = 1; -1 !== t.indexOf(i);) {
          i = n + " (" + ("copy" + (1 < o ? " " + o : "")) + ")";
          o++;
        }
        return i;
      }
      function he(e, t) {
        var n = {};
        if (Array.isArray(e)) for (var i = Math.min(e.length, h), o = 0; o < i; o++) !function t(n, i, o, r) {
          (Array.isArray(n) || B(n)) && !r || (i[o || ""] = !0), B(n) && Object.keys(n).forEach(function (e) {
            t(n[e], i, o + "." + e, r);
          });
        }(e[o], n, "", t);else n[""] = !0;
        return Object.keys(n).sort();
      }
      function de(e, t, n) {
        var i = t && "." !== t ? _(t) : [],
          o = "desc" === n ? -1 : 1,
          t = e.slice();
        return t.sort(function (e, t) {
          e = N(e, i), t = N(t, i);
          return o * (t < e ? 1 : e < t ? -1 : 0);
        }), t;
      }
      function ue(t, e) {
        var n = "desc" === e ? -1 : 1,
          e = Object.keys(t).sort(function (e, t) {
            return n * o()(e, t);
          }),
          i = {};
        return e.forEach(function (e) {
          i[e] = t[e];
        }), i;
      }
      function ge(e) {
        var t, n;
        return "" === e ? "" : "null" === (t = e.toLowerCase()) ? null : "true" === t || "false" !== t && (t = Number(e), n = parseFloat(e), isNaN(t) || isNaN(n) ? e : t);
      }
      function pe(e, t) {
        return "number" == typeof t && d < t && isFinite(t) && Math.floor(t) === t && !isNaN(new Date(t).valueOf());
      }
      function me(e) {
        return e < 900 ? e.toFixed() + " B" : (e = e / 1000) < 900 ? e.toFixed(1) + " KB" : (e = e / 1000) < 900 ? e.toFixed(1) + " MB" : (e = e / 1000) < 900 ? e.toFixed(1) + " GB" : (e / 1000).toFixed(1) + " TB";
      }
      function fe(e, t) {
        return e.length <= t ? e : e.slice(0, t) + "...";
      }
      function B(e) {
        return "object" === c(e) && null !== e && !Array.isArray(e);
      }
      function Ce(e, t) {
        return -1 !== e.indexOf(t);
      }
      function ye(n, i) {
        if (i || n) {
          if (i && !n || !i && n) return !0;
          if (i.length !== n.length) return !0;
          for (var e = 0; e < n.length; ++e) {
            var t = function (t) {
              var e = "error" === n[t].type ? i.find(function (e) {
                return e.line === n[t].line;
              }) : i.find(function (e) {
                return e.dataPath === n[t].dataPath && e.schemaPath === n[t].schemaPath;
              });
              if (!e) return {
                v: !0
              };
            }(e);
            if ("object" === c(t)) return t.v;
          }
        }
        return !1;
      }
      function ve(e, t) {
        e = null != e && e.length ? e : [], t = null != t && t.length ? t : [];
        return a(new Set(e.concat(t)));
      }
      function Ie(e) {
        setTimeout(e);
      }
      function M(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
    },
    8037: function (e, t, n) {
      var i;
      if (window.Picker) i = window.Picker;else try {
        i = n(4049);
      } catch (e) {}
      e.exports = i;
    },
    6225: function (n, e, C) {
      function l(e, n) {
        var t, i;
        return n = a(e, n), (e = r.modules[n]) || ("function" == typeof (e = r.payloads[n]) && (t = {
          id: n,
          uri: "",
          exports: i = {},
          packaged: !0
        }, i = e(function (e, t) {
          return s(n, e, t);
        }, i, t) || t.exports, r.modules[n] = i, delete r.payloads[n]), e = r.modules[n] = i || e), e;
      }
      var t, i, o, r, s, c, a;
      n = C.nmd(n), (o = function () {
        return this || _global;
      }()) || "undefined" == typeof window || (o = window), (r = function (e, t, n) {
        "string" != typeof e ? r.original ? r.original.apply(this || _global, arguments) : (console.error("dropping module because define wasn't a string."), console.trace()) : (2 == arguments.length && (n = t), r.modules[e] || (r.payloads[e] = n, r.modules[e] = null));
      }).modules = {}, r.payloads = {}, s = function (e, t, n) {
        if ("string" == typeof t) {
          var i = l(e, t);
          if (null != i) return n && n(), i;
        } else if ("[object Array]" === Object.prototype.toString.call(t)) {
          for (var o = [], r = 0, s = t.length; r < s; ++r) {
            var a = l(e, t[r]);
            if (null == a && c.original) return;
            o.push(a);
          }
          return n && n.apply(null, o) || !0;
        }
      }, c = function (e, t) {
        var n = s("", e, t);
        return null == n && c.original ? c.original.apply(this || _global, arguments) : n;
      }, a = function (e, t) {
        var n;
        if (-1 !== t.indexOf("!")) return n = t.split("!"), a(e, n[0]) + "!" + a(e, n[1]);
        if ("." == t.charAt(0)) for (t = e.split("/").slice(0, -1).join("/") + "/" + t; -1 !== t.indexOf(".") && i != t;) {
          var i = t;
          t = t.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
        }
        return t;
      }, i = o, (t = "ace") && (o[t] || (o[t] = {}), i = o[t]), i.define && i.define.packaged || (r.original = i.define, i.define = r, i.define.packaged = !0), i.require && i.require.packaged || (c.original = i.require, i.require = c, i.require.packaged = !0), ace.define("ace/lib/es6-shim", ["require", "exports", "module"], function (e, t, n) {
        function i(e, t, n) {
          Object.defineProperty(e, t, {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          });
        }
        String.prototype.startsWith || i(String.prototype, "startsWith", function (e, t) {
          return this.lastIndexOf(e, t = t || 0) === t;
        }), String.prototype.endsWith || i(String.prototype, "endsWith", function (e, t) {
          (void 0 === t || t > (this || _global).length) && (t = (this || _global).length), t -= e.length;
          e = this.indexOf(e, t);
          return -1 !== e && e === t;
        }), String.prototype.repeat || i(String.prototype, "repeat", function (e) {
          for (var t = "", n = this || _global; 0 < e;) 1 & e && (t += n), (e >>= 1) && (n += n);
          return t;
        }), String.prototype.includes || i(String.prototype, "includes", function (e, t) {
          return -1 != this.indexOf(e, t);
        }), Object.assign || (Object.assign = function (e) {
          if (null == e) throw new TypeError("Cannot convert undefined or null to object");
          for (var t = Object(e), n = 1; n < arguments.length; n++) {
            var i = arguments[n];
            null != i && Object.keys(i).forEach(function (e) {
              t[e] = i[e];
            });
          }
          return t;
        }), Object.values || (Object.values = function (t) {
          return Object.keys(t).map(function (e) {
            return t[e];
          });
        }), Array.prototype.find || i(Array.prototype, "find", function (e) {
          for (var t = (this || _global).length, n = arguments[1], i = 0; i < t; i++) {
            var o = (this || _global)[i];
            if (e.call(n, o, i, this || _global)) return o;
          }
        }), Array.prototype.findIndex || i(Array.prototype, "findIndex", function (e) {
          for (var t = (this || _global).length, n = arguments[1], i = 0; i < t; i++) {
            var o = (this || _global)[i];
            if (e.call(n, o, i, this || _global)) return i;
          }
        }), Array.prototype.includes || i(Array.prototype, "includes", function (e, t) {
          return -1 != this.indexOf(e, t);
        }), Array.prototype.fill || i(Array.prototype, "fill", function (e) {
          for (var t = (this || _global).length >>> 0, n = arguments[1] >> 0, i = n < 0 ? Math.max(t + n, 0) : Math.min(n, t), n = arguments[2], n = void 0 === n ? t : n >> 0, o = n < 0 ? Math.max(t + n, 0) : Math.min(n, t); i < o;) (this || _global)[i] = e, i++;
          return this || _global;
        }), Array.of || i(Array, "of", function () {
          return Array.prototype.slice.call(arguments);
        });
      }), ace.define("ace/lib/fixoldbrowsers", ["require", "exports", "module", "ace/lib/es6-shim"], function (e, t, n) {
        "use strict";

        e("./es6-shim");
      }), ace.define("ace/lib/lang", ["require", "exports", "module"], function (e, t, n) {
        "use strict";

        t.last = function (e) {
          return e[e.length - 1];
        }, t.stringReverse = function (e) {
          return e.split("").reverse().join("");
        }, t.stringRepeat = function (e, t) {
          for (var n = ""; 0 < t;) 1 & t && (n += e), (t >>= 1) && (e += e);
          return n;
        };
        var i = /^\s\s*/,
          o = /\s\s*$/;
        t.stringTrimLeft = function (e) {
          return e.replace(i, "");
        }, t.stringTrimRight = function (e) {
          return e.replace(o, "");
        }, t.copyObject = function (e) {
          var t,
            n = {};
          for (t in e) n[t] = e[t];
          return n;
        }, t.copyArray = function (e) {
          for (var t = [], n = 0, i = e.length; n < i; n++) e[n] && "object" == typeof e[n] ? t[n] = this.copyObject(e[n]) : t[n] = e[n];
          return t;
        }, t.deepCopy = function e(t) {
          if ("object" != typeof t || !t) return t;
          if (Array.isArray(t)) for (var n = [], i = 0; i < t.length; i++) n[i] = e(t[i]);else {
            if ("[object Object]" !== Object.prototype.toString.call(t)) return t;
            for (var i in n = {}, t) n[i] = e(t[i]);
          }
          return n;
        }, t.arrayToMap = function (e) {
          for (var t = {}, n = 0; n < e.length; n++) t[e[n]] = 1;
          return t;
        }, t.createMap = function (e) {
          var t,
            n = Object.create(null);
          for (t in e) n[t] = e[t];
          return n;
        }, t.arrayRemove = function (e, t) {
          for (var n = 0; n <= e.length; n++) t === e[n] && e.splice(n, 1);
        }, t.escapeRegExp = function (e) {
          return e.replace(/([.*+?^${}()|[\]\/\\])/g, "\\$1");
        }, t.escapeHTML = function (e) {
          return ("" + e).replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
        }, t.getMatchOffsets = function (e, t) {
          var n = [];
          return e.replace(t, function (e) {
            n.push({
              offset: arguments[arguments.length - 2],
              length: e.length
            });
          }), n;
        }, t.deferredCall = function (e) {
          function t() {
            i = null, e();
          }
          function n(e) {
            return n.cancel(), i = setTimeout(t, e || 0), n;
          }
          var i = null;
          return (n.schedule = n).call = function () {
            return this.cancel(), e(), n;
          }, n.cancel = function () {
            return clearTimeout(i), i = null, n;
          }, n.isPending = function () {
            return i;
          }, n;
        }, t.delayedCall = function (e, t) {
          function n() {
            o = null, e();
          }
          function i(e) {
            null == o && (o = setTimeout(n, e || t));
          }
          var o = null;
          return i.delay = function (e) {
            o && clearTimeout(o), o = setTimeout(n, e || t);
          }, (i.schedule = i).call = function () {
            this.cancel(), e();
          }, i.cancel = function () {
            o && clearTimeout(o), o = null;
          }, i.isPending = function () {
            return o;
          }, i;
        };
      }), ace.define("ace/lib/useragent", ["require", "exports", "module"], function (e, t, n) {
        "use strict";

        t.OS = {
          LINUX: "LINUX",
          MAC: "MAC",
          WINDOWS: "WINDOWS"
        }, t.getOS = function () {
          return t.isMac ? t.OS.MAC : t.isLinux ? t.OS.LINUX : t.OS.WINDOWS;
        };
        var i = "object" == typeof navigator ? navigator : {},
          o = (/mac|win|linux/i.exec(i.platform) || ["other"])[0].toLowerCase(),
          r = i.userAgent || "",
          i = i.appName || "";
        t.isWin = "win" == o, t.isMac = "mac" == o, t.isLinux = "linux" == o, t.isIE = "Microsoft Internet Explorer" == i || 0 <= i.indexOf("MSAppHost") ? parseFloat((r.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]) : parseFloat((r.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]), t.isOldIE = t.isIE && t.isIE < 9, t.isGecko = t.isMozilla = r.match(/ Gecko\/\d+/), t.isOpera = "object" == typeof opera && "[object Opera]" == Object.prototype.toString.call(window.opera), t.isWebKit = parseFloat(r.split("WebKit/")[1]) || void 0, t.isChrome = parseFloat(r.split(" Chrome/")[1]) || void 0, t.isEdge = parseFloat(r.split(" Edge/")[1]) || void 0, t.isAIR = 0 <= r.indexOf("AdobeAIR"), t.isAndroid = 0 <= r.indexOf("Android"), t.isChromeOS = 0 <= r.indexOf(" CrOS "), t.isIOS = /iPad|iPhone|iPod/.test(r) && !window.MSStream, t.isIOS && (t.isMac = !0), t.isMobile = t.isIOS || t.isAndroid;
      }), ace.define("ace/lib/dom", ["require", "exports", "module", "ace/lib/useragent"], function (e, r, t) {
        "use strict";

        var s,
          n,
          e = e("./useragent"),
          a = (r.buildDom = function e(t, n, i) {
            if ("string" == typeof t && t) return c = document.createTextNode(t), n && n.appendChild(c), c;
            if (!Array.isArray(t)) return t && t.appendChild && n && n.appendChild(t), t;
            if ("string" != typeof t[0] || !t[0]) {
              for (var o = [], r = 0; r < t.length; r++) {
                var s = e(t[r], n, i);
                s && o.push(s);
              }
              return o;
            }
            for (var a = document.createElement(t[0]), l = t[1], c = 1, r = c = l && "object" == typeof l && !Array.isArray(l) ? 2 : c; r < t.length; r++) e(t[r], a, i);
            return 2 == c && Object.keys(l).forEach(function (e) {
              var t = l[e];
              "class" === e ? a.className = Array.isArray(t) ? t.join(" ") : t : "function" == typeof t || "value" == e || "$" == e[0] ? a[e] = t : "ref" === e ? i && (i[t] = a) : "style" === e ? "string" == typeof t && (a.style.cssText = t) : null != t && a.setAttribute(e, t);
            }), n && n.appendChild(a), a;
          }, r.getDocumentHead = function (e) {
            return (e = e || document).head || e.getElementsByTagName("head")[0] || e.documentElement;
          }, r.createElement = function (e, t) {
            return document.createElementNS ? document.createElementNS(t || "http://www.w3.org/1999/xhtml", e) : document.createElement(e);
          }, r.removeChildren = function (e) {
            e.innerHTML = "";
          }, r.createTextNode = function (e, t) {
            return (t ? t.ownerDocument : document).createTextNode(e);
          }, r.createFragment = function (e) {
            return (e ? e.ownerDocument : document).createDocumentFragment();
          }, r.hasCssClass = function (e, t) {
            return -1 !== (e.className + "").split(/\s+/g).indexOf(t);
          }, r.addCssClass = function (e, t) {
            r.hasCssClass(e, t) || (e.className += " " + t);
          }, r.removeCssClass = function (e, t) {
            for (var n = e.className.split(/\s+/g);;) {
              var i = n.indexOf(t);
              if (-1 == i) break;
              n.splice(i, 1);
            }
            e.className = n.join(" ");
          }, r.toggleCssClass = function (e, t) {
            for (var n = e.className.split(/\s+/g), i = !0;;) {
              var o = n.indexOf(t);
              if (-1 == o) break;
              i = !1, n.splice(o, 1);
            }
            return i && n.push(t), e.className = n.join(" "), i;
          }, r.setCssClass = function (e, t, n) {
            n ? r.addCssClass(e, t) : r.removeCssClass(e, t);
          }, r.hasCssString = function (e, t) {
            var n,
              i = 0;
            if (n = (t = t || document).querySelectorAll("style")) for (; i < n.length;) if (n[i++].id === e) return !0;
          }, r.removeElementById = function (e, t) {
            (t = t || document).getElementById(e) && t.getElementById(e).remove();
          }, []);
        function l() {
          var e = a;
          a = null, e && e.forEach(function (e) {
            i(e[0], e[1]);
          });
        }
        function i(e, t, n) {
          if ("undefined" != typeof document) {
            if (a) if (n) l();else if (!1 === n) return a.push([e, t]);
            if (!s) {
              var i = n,
                n = (i = n && n.getRootNode && (i = n.getRootNode()) && i != n ? i : document).ownerDocument || i;
              if (t && r.hasCssString(t, i)) return null;
              t && (e += "\n/*# sourceURL=ace/css/" + t + " */");
              var o = r.createElement("style");
              o.appendChild(n.createTextNode(e)), t && (o.id = t), (i = i == n ? r.getDocumentHead(n) : i).insertBefore(o, i.firstChild);
            }
          }
        }
        r.useStrictCSP = function (e) {
          0 == (s = e) ? l() : a = a || [];
        }, r.importCssString = i, r.importCssStylsheet = function (e, t) {
          r.buildDom(["link", {
            rel: "stylesheet",
            href: e
          }], r.getDocumentHead(t));
        }, r.scrollbarWidth = function (e) {
          var t = r.createElement("ace_inner"),
            n = (t.style.width = "100%", t.style.minWidth = "0px", t.style.height = "200px", t.style.display = "block", r.createElement("ace_outer")),
            i = n.style,
            e = (i.position = "absolute", i.left = "-10000px", i.overflow = "hidden", i.width = "200px", i.minWidth = "0px", i.height = "150px", i.display = "block", n.appendChild(t), e && e.documentElement || document && document.documentElement);
          if (!e) return 0;
          e.appendChild(n);
          var o = t.offsetWidth,
            i = (i.overflow = "scroll", t.offsetWidth);
          return o === i && (i = n.clientWidth), e.removeChild(n), o - i;
        }, r.computedStyle = function (e, t) {
          return window.getComputedStyle(e, "") || {};
        }, r.setStyle = function (e, t, n) {
          e[t] !== n && (e[t] = n);
        }, r.HAS_CSS_ANIMATION = !1, r.HAS_CSS_TRANSFORMS = !1, r.HI_DPI = !e.isWin || "undefined" != typeof window && 1.5 <= window.devicePixelRatio, e.isChromeOS && (r.HI_DPI = !1), "undefined" != typeof document && (n = document.createElement("div"), r.HI_DPI && void 0 !== n.style.transform && (r.HAS_CSS_TRANSFORMS = !0), e.isEdge || void 0 === n.style.animationName || (r.HAS_CSS_ANIMATION = !0), n = null), r.HAS_CSS_TRANSFORMS ? r.translate = function (e, t, n) {
          e.style.transform = "translate(" + Math.round(t) + "px, " + Math.round(n) + "px)";
        } : r.translate = function (e, t, n) {
          e.style.top = Math.round(n) + "px", e.style.left = Math.round(t) + "px";
        };
      }), ace.define("ace/lib/net", ["require", "exports", "module", "ace/lib/dom"], function (e, t, n) {
        /*
         * based on code from:
         *
         * @license RequireJS text 0.25.0 Copyright (c) 2010-2011, The Dojo Foundation All Rights Reserved.
         * Available via the MIT or new BSD license.
         * see: http://github.com/jrburke/requirejs for details
         */
        "use strict";

        var o = e("./dom");
        t.get = function (e, t) {
          var n = new XMLHttpRequest();
          n.open("GET", e, !0), n.onreadystatechange = function () {
            4 === n.readyState && t(n.responseText);
          }, n.send(null);
        }, t.loadScript = function (e, n) {
          var t = o.getDocumentHead(),
            i = document.createElement("script");
          i.src = e, t.appendChild(i), i.onload = i.onreadystatechange = function (e, t) {
            !t && i.readyState && "loaded" != i.readyState && "complete" != i.readyState || (i = i.onload = i.onreadystatechange = null, t) || n();
          };
        }, t.qualifyURL = function (e) {
          var t = document.createElement("a");
          return t.href = e, t.href;
        };
      }), ace.define("ace/lib/oop", ["require", "exports", "module"], function (e, n, t) {
        "use strict";

        n.inherits = function (e, t) {
          e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          });
        }, n.mixin = function (e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        }, n.implement = function (e, t) {
          n.mixin(e, t);
        };
      }), ace.define("ace/lib/event_emitter", ["require", "exports", "module"], function (e, t, n) {
        "use strict";

        function r() {
          (this || _global).propagationStopped = !0;
        }
        function s() {
          (this || _global).defaultPrevented = !0;
        }
        var i = {};
        i._emit = i._dispatchEvent = function (e, t) {
          (this || _global)._eventRegistry || ((this || _global)._eventRegistry = {}), (this || _global)._defaultHandlers || ((this || _global)._defaultHandlers = {});
          var n = (this || _global)._eventRegistry[e] || [],
            i = (this || _global)._defaultHandlers[e];
          if (n.length || i) {
            (t = "object" == typeof t && t ? t : {}).type || (t.type = e), t.stopPropagation || (t.stopPropagation = r), t.preventDefault || (t.preventDefault = s);
            for (var n = n.slice(), o = 0; o < n.length && (n[o](t, this || _global), !t.propagationStopped); o++);
            return i && !t.defaultPrevented ? i(t, this || _global) : void 0;
          }
        }, i._signal = function (e, t) {
          if (n = ((this || _global)._eventRegistry || {})[e]) for (var n = n.slice(), i = 0; i < n.length; i++) n[i](t, this || _global);
        }, i.once = function (t, n) {
          var i = this || _global;
          if (this.on(t, function e() {
            i.off(t, e), n.apply(null, arguments);
          }), !n) return new Promise(function (e) {
            n = e;
          });
        }, i.setDefaultHandler = function (e, t) {
          var n,
            i,
            o = (this || _global)._defaultHandlers;
          (o = o || ((this || _global)._defaultHandlers = {
            _disabled_: {}
          }))[e] && (i = o[e], (n = o._disabled_[e]) || (o._disabled_[e] = n = []), n.push(i), -1 != (i = n.indexOf(t))) && n.splice(i, 1), o[e] = t;
        }, i.removeDefaultHandler = function (e, t) {
          var n,
            i = (this || _global)._defaultHandlers;
          i && (n = i._disabled_[e], i[e] == t ? n && this.setDefaultHandler(e, n.pop()) : n && -1 != (i = n.indexOf(t)) && n.splice(i, 1));
        }, i.on = i.addEventListener = function (e, t, n) {
          (this || _global)._eventRegistry = (this || _global)._eventRegistry || {};
          var i = (this || _global)._eventRegistry[e];
          return -1 == (i = i || ((this || _global)._eventRegistry[e] = [])).indexOf(t) && i[n ? "unshift" : "push"](t), t;
        }, i.off = i.removeListener = i.removeEventListener = function (e, t) {
          (this || _global)._eventRegistry = (this || _global)._eventRegistry || {};
          e = (this || _global)._eventRegistry[e];
          e && -1 !== (t = e.indexOf(t)) && e.splice(t, 1);
        }, i.removeAllListeners = function (e) {
          e || ((this || _global)._eventRegistry = (this || _global)._defaultHandlers = void 0), (this || _global)._eventRegistry && ((this || _global)._eventRegistry[e] = void 0), (this || _global)._defaultHandlers && ((this || _global)._defaultHandlers[e] = void 0);
        }, t.EventEmitter = i;
      }), ace.define("ace/lib/app_config", ["require", "exports", "module", "ace/lib/oop", "ace/lib/event_emitter"], function (e, t, n) {
        var i,
          o = e("./oop"),
          e = e("./event_emitter").EventEmitter,
          r = {
            setOptions: function (t) {
              Object.keys(t).forEach(function (e) {
                this.setOption(e, t[e]);
              }, this || _global);
            },
            getOptions: function (e) {
              var t,
                n = {};
              return e ? Array.isArray(e) || (n = e, e = Object.keys(n)) : (t = (this || _global).$options, e = Object.keys(t).filter(function (e) {
                return !t[e].hidden;
              })), e.forEach(function (e) {
                n[e] = this.getOption(e);
              }, this || _global), n;
            },
            setOption: function (e, t) {
              var n;
              if ((this || _global)["$" + e] !== t) return (n = (this || _global).$options[e]) ? n.forwardTo ? (this || _global)[n.forwardTo] && (this || _global)[n.forwardTo].setOption(e, t) : (n.handlesSet || ((this || _global)["$" + e] = t), void (n && n.set && n.set.call(this || _global, t))) : s("misspelled option \"" + e + "\"");
            },
            getOption: function (e) {
              var t = (this || _global).$options[e];
              return t ? t.forwardTo ? (this || _global)[t.forwardTo] && (this || _global)[t.forwardTo].getOption(e) : t && t.get ? t.get.call(this || _global) : (this || _global)["$" + e] : s("misspelled option \"" + e + "\"");
            }
          };
        function s(e) {
          "undefined" != typeof console && console.warn && console.warn.apply(console, arguments);
        }
        l.prototype.defineOptions = function (n, e, i) {
          return n.$options || ((this || _global).$defaultOptions[e] = n.$options = {}), Object.keys(i).forEach(function (e) {
            var t = i[e];
            (t = "string" == typeof t ? {
              forwardTo: t
            } : t).name || (t.name = e), "initialValue" in (n.$options[t.name] = t) && (n["$" + t.name] = t.initialValue);
          }), o.implement(n, r), this || _global;
        }, l.prototype.resetOptions = function (n) {
          Object.keys(n.$options).forEach(function (e) {
            var t = n.$options[e];
            "value" in t && n.setOption(e, t.value);
          });
        }, l.prototype.setDefaultValue = function (e, t, n) {
          if (!e) {
            for (e in (this || _global).$defaultOptions) if ((this || _global).$defaultOptions[e][t]) break;
            if (!(this || _global).$defaultOptions[e][t]) return !1;
          }
          var i = (this || _global).$defaultOptions[e] || ((this || _global).$defaultOptions[e] = {});
          i[t] && (i.forwardTo ? this.setDefaultValue(i.forwardTo, t, n) : i[t].value = n);
        }, l.prototype.setDefaultValues = function (t, n) {
          Object.keys(n).forEach(function (e) {
            this.setDefaultValue(t, e, n[e]);
          }, this || _global);
        }, l.prototype.setMessages = function (e) {
          i = e;
        }, l.prototype.nls = function (e, n) {
          e = i && i[e] || e;
          return e = n ? e.replace(/\$(\$|[\d]+)/g, function (e, t) {
            return "$" == t ? "$" : n[t];
          }) : e;
        };
        var a = l;
        function l() {
          (this || _global).$defaultOptions = {};
        }
        a.prototype.warn = s, a.prototype.reportError = function (e, t) {
          var n = new Error(e);
          n.data = t, "object" == typeof console && console.error && console.error(n), setTimeout(function () {
            throw n;
          });
        }, o.implement(a.prototype, e), t.AppConfig = a;
      }), ace.define("ace/theme/textmate.css", ["require", "exports", "module"], function (e, t, n) {
        n.exports = ".ace-tm .ace_gutter {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.ace-tm .ace_print-margin {\n  width: 1px;\n  background: #e8e8e8;\n}\n\n.ace-tm .ace_fold {\n    background-color: #6B72E6;\n}\n\n.ace-tm {\n  background-color: #FFFFFF;\n  color: black;\n}\n\n.ace-tm .ace_cursor {\n  color: black;\n}\n        \n.ace-tm .ace_invisible {\n  color: rgb(191, 191, 191);\n}\n\n.ace-tm .ace_storage,\n.ace-tm .ace_keyword {\n  color: blue;\n}\n\n.ace-tm .ace_constant {\n  color: rgb(197, 6, 11);\n}\n\n.ace-tm .ace_constant.ace_buildin {\n  color: rgb(88, 72, 246);\n}\n\n.ace-tm .ace_constant.ace_language {\n  color: rgb(88, 92, 246);\n}\n\n.ace-tm .ace_constant.ace_library {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_invalid {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: red;\n}\n\n.ace-tm .ace_support.ace_function {\n  color: rgb(60, 76, 114);\n}\n\n.ace-tm .ace_support.ace_constant {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_support.ace_type,\n.ace-tm .ace_support.ace_class {\n  color: rgb(109, 121, 222);\n}\n\n.ace-tm .ace_keyword.ace_operator {\n  color: rgb(104, 118, 135);\n}\n\n.ace-tm .ace_string {\n  color: rgb(3, 106, 7);\n}\n\n.ace-tm .ace_comment {\n  color: rgb(76, 136, 107);\n}\n\n.ace-tm .ace_comment.ace_doc {\n  color: rgb(0, 102, 255);\n}\n\n.ace-tm .ace_comment.ace_doc.ace_tag {\n  color: rgb(128, 159, 191);\n}\n\n.ace-tm .ace_constant.ace_numeric {\n  color: rgb(0, 0, 205);\n}\n\n.ace-tm .ace_variable {\n  color: rgb(49, 132, 149);\n}\n\n.ace-tm .ace_xml-pe {\n  color: rgb(104, 104, 91);\n}\n\n.ace-tm .ace_entity.ace_name.ace_function {\n  color: #0000A2;\n}\n\n\n.ace-tm .ace_heading {\n  color: rgb(12, 7, 255);\n}\n\n.ace-tm .ace_list {\n  color:rgb(185, 6, 144);\n}\n\n.ace-tm .ace_meta.ace_tag {\n  color:rgb(0, 22, 142);\n}\n\n.ace-tm .ace_string.ace_regex {\n  color: rgb(255, 0, 0)\n}\n\n.ace-tm .ace_marker-layer .ace_selection {\n  background: rgb(181, 213, 255);\n}\n.ace-tm.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px white;\n}\n.ace-tm .ace_marker-layer .ace_step {\n  background: rgb(252, 255, 0);\n}\n\n.ace-tm .ace_marker-layer .ace_stack {\n  background: rgb(164, 229, 101);\n}\n\n.ace-tm .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid rgb(192, 192, 192);\n}\n\n.ace-tm .ace_marker-layer .ace_active-line {\n  background: rgba(0, 0, 0, 0.07);\n}\n\n.ace-tm .ace_gutter-active-line {\n    background-color : #dcdcdc;\n}\n\n.ace-tm .ace_marker-layer .ace_selected-word {\n  background: rgb(250, 250, 255);\n  border: 1px solid rgb(200, 200, 250);\n}\n\n.ace-tm .ace_indent-guide {\n  background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\n}\n\n.ace-tm .ace_indent-guide-active {\n  background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC\") right repeat-y;\n}\n";
      }), ace.define("ace/theme/textmate", ["require", "exports", "module", "ace/theme/textmate.css", "ace/lib/dom"], function (e, t, n) {
        "use strict";

        t.isDark = !1, t.cssClass = "ace-tm", t.cssText = e("./textmate.css"), t.$id = "ace/theme/textmate", e("../lib/dom").importCssString(t.cssText, t.cssClass, !1);
      }), ace.define("ace/config", ["require", "exports", "module", "ace/lib/lang", "ace/lib/net", "ace/lib/dom", "ace/lib/app_config", "ace/theme/textmate"], function (r, s, e) {
        var t = r("./lib/lang"),
          a = r("./lib/net"),
          n = r("./lib/dom"),
          i = r("./lib/app_config").AppConfig,
          l = (e.exports = s = new i(), {
            packaged: !1,
            workerPath: null,
            modePath: null,
            themePath: null,
            basePath: "",
            suffix: ".js",
            $moduleUrls: {},
            loadWorkerFromBlob: !0,
            sharedPopups: !1,
            useStrictCSP: null
          }),
          c = (s.get = function (e) {
            if (l.hasOwnProperty(e)) return l[e];
            throw new Error("Unknown config key: " + e);
          }, s.set = function (e, t) {
            if (l.hasOwnProperty(e)) l[e] = t;else if (0 == this.setDefaultValue("", e, t)) throw new Error("Unknown config key: " + e);
            "useStrictCSP" == e && n.useStrictCSP(t);
          }, s.all = function () {
            return t.copyObject(l);
          }, s.$modes = {}, s.moduleUrl = function (e, t) {
            var n, i, o;
            return l.$moduleUrls[e] || (e = e.split("/"), n = "snippets" == (t = t || e[e.length - 2] || "") ? "/" : "-", i = e[e.length - 1], "worker" == t && "-" == n && (o = new RegExp("^" + t + "[\\-_]|[\\-_]" + t + "$", "g"), i = i.replace(o, "")), (!i || i == t) && 1 < e.length && (i = e[e.length - 2]), null == (o = l[t + "Path"]) ? o = l.basePath : "/" == n && (t = n = ""), o && "/" != o.slice(-1) && (o += "/"), o + t + n + i + this.get("suffix"));
          }, s.setModuleUrl = function (e, t) {
            return l.$moduleUrls[e] = t;
          }, function (e, t) {
            return "ace/theme/textmate" === e || "./theme/textmate" === e ? t(null, r("./theme/textmate")) : console.error("loader is not configured");
          }),
          h = (s.setLoader = function (e) {
            c = e;
          }, s.dynamicModules = Object.create(null), s.$loading = {}, s.loadModule = function (i, n) {
            function t(e) {
              if (e && !s.$loading[i]) return n && n(e);
              if (s.$loading[i] || (s.$loading[i] = []), s.$loading[i].push(n), !(1 < s.$loading[i].length)) {
                function t() {
                  c(i, function (e, t) {
                    s._emit("load.module", {
                      name: i,
                      module: t
                    });
                    var n = s.$loading[i];
                    s.$loading[i] = null, n.forEach(function (e) {
                      e && e(t);
                    });
                  });
                }
                if (!s.get("packaged")) return t();
                a.loadScript(s.moduleUrl(i, o), t), h();
              }
            }
            var e, o;
            Array.isArray(i) && (o = i[0], i = i[1]);
            if (s.dynamicModules[i]) s.dynamicModules[i]().then(function (e) {
              e.default ? t(e.default) : t(e);
            });else {
              try {
                e = r(i);
              } catch (e) {}
              t(e);
            }
          }, s.setModuleLoader = function (e, t) {
            s.dynamicModules[e] = t;
          }, function () {
            l.basePath || l.workerPath || l.modePath || l.themePath || Object.keys(l.$moduleUrls).length || (console.error("Unable to infer path to ace from script src,", "use ace.config.set('basePath', 'path') to enable dynamic loading of modes and themes", "or with webpack use ace/webpack-resolver"), h = function () {});
          });
        s.version = "1.20.0";
      }), ace.define("ace/loader_build", ["require", "exports", "module", "ace/lib/fixoldbrowsers", "ace/config"], function (g, e, p) {
        "use strict";

        g("./lib/fixoldbrowsers");
        var m = g("./config"),
          f = (m.setLoader(function (e, t) {
            g([e], function (e) {
              t(null, e);
            });
          }), function () {
            return this || _global || "undefined" != typeof window && window;
          }());
        function t(e) {
          if (f && f.document) {
            m.set("packaged", e || g.packaged || p.packaged || f.define && C.amdD.packaged);
            for (var t, n = {}, i = "", e = document.currentScript || document._currentScript, o = e && e.ownerDocument || document, r = (e && e.src && (i = e.src.split(/[?#]/)[0].split("/").slice(0, -1).join("/") || ""), o.getElementsByTagName("script")), s = 0; s < r.length; s++) {
              var a = r[s],
                l = a.src || a.getAttribute("src");
              if (l) {
                for (var c = a.attributes, h = 0, d = c.length; h < d; h++) {
                  var u = c[h];
                  0 === u.name.indexOf("data-ace-") && (n[u.name.replace(/^data-ace-/, "").replace(/-(.)/g, function (e, t) {
                    return t.toUpperCase();
                  })] = u.value);
                }
                a = l.match(/^(.*)\/ace([\-.]\w+)?\.js(\?|$)/);
                a && (i = a[1]);
              }
            }
            for (t in i && (n.base = n.base || i, n.packaged = !0), n.basePath = n.base, n.workerPath = n.workerPath || n.base, n.modePath = n.modePath || n.base, n.themePath = n.themePath || n.base, delete n.base, n) void 0 !== n[t] && m.set(t, n[t]);
          }
        }
        p.exports = function (e) {
          m.init = t, e.require = g, e.define = C.amdD;
        }, t(!0);
      }), ace.define("ace/range", ["require", "exports", "module"], function (e, t, n) {
        "use strict";

        r.prototype.isEqual = function (e) {
          return (this || _global).start.row === e.start.row && (this || _global).end.row === e.end.row && (this || _global).start.column === e.start.column && (this || _global).end.column === e.end.column;
        }, r.prototype.toString = function () {
          return "Range: [" + (this || _global).start.row + "/" + (this || _global).start.column + "] -> [" + (this || _global).end.row + "/" + (this || _global).end.column + "]";
        }, r.prototype.contains = function (e, t) {
          return 0 == this.compare(e, t);
        }, r.prototype.compareRange = function (e) {
          var t = e.end,
            e = e.start,
            t = this.compare(t.row, t.column);
          return 1 == t ? 1 == (t = this.compare(e.row, e.column)) ? 2 : 0 == t ? 1 : 0 : -1 == t ? -2 : -1 == (t = this.compare(e.row, e.column)) ? -1 : 1 == t ? 42 : 0;
        }, r.prototype.comparePoint = function (e) {
          return this.compare(e.row, e.column);
        }, r.prototype.containsRange = function (e) {
          return 0 == this.comparePoint(e.start) && 0 == this.comparePoint(e.end);
        }, r.prototype.intersects = function (e) {
          e = this.compareRange(e);
          return -1 == e || 0 == e || 1 == e;
        }, r.prototype.isEnd = function (e, t) {
          return (this || _global).end.row == e && (this || _global).end.column == t;
        }, r.prototype.isStart = function (e, t) {
          return (this || _global).start.row == e && (this || _global).start.column == t;
        }, r.prototype.setStart = function (e, t) {
          "object" == typeof e ? ((this || _global).start.column = e.column, (this || _global).start.row = e.row) : ((this || _global).start.row = e, (this || _global).start.column = t);
        }, r.prototype.setEnd = function (e, t) {
          "object" == typeof e ? ((this || _global).end.column = e.column, (this || _global).end.row = e.row) : ((this || _global).end.row = e, (this || _global).end.column = t);
        }, r.prototype.inside = function (e, t) {
          return 0 == this.compare(e, t) && !this.isEnd(e, t) && !this.isStart(e, t);
        }, r.prototype.insideStart = function (e, t) {
          return 0 == this.compare(e, t) && !this.isEnd(e, t);
        }, r.prototype.insideEnd = function (e, t) {
          return 0 == this.compare(e, t) && !this.isStart(e, t);
        }, r.prototype.compare = function (e, t) {
          return this.isMultiLine() || e !== (this || _global).start.row ? e < (this || _global).start.row ? -1 : e > (this || _global).end.row ? 1 : (this || _global).start.row === e ? t >= (this || _global).start.column ? 0 : -1 : (this || _global).end.row !== e || t <= (this || _global).end.column ? 0 : 1 : t < (this || _global).start.column ? -1 : t > (this || _global).end.column ? 1 : 0;
        }, r.prototype.compareStart = function (e, t) {
          return (this || _global).start.row == e && (this || _global).start.column == t ? -1 : this.compare(e, t);
        }, r.prototype.compareEnd = function (e, t) {
          return (this || _global).end.row == e && (this || _global).end.column == t ? 1 : this.compare(e, t);
        }, r.prototype.compareInside = function (e, t) {
          return (this || _global).end.row == e && (this || _global).end.column == t ? 1 : (this || _global).start.row == e && (this || _global).start.column == t ? -1 : this.compare(e, t);
        }, r.prototype.clipRows = function (e, t) {
          var n, i;
          return (this || _global).end.row > t ? n = {
            row: t + 1,
            column: 0
          } : (this || _global).end.row < e && (n = {
            row: e,
            column: 0
          }), (this || _global).start.row > t ? i = {
            row: t + 1,
            column: 0
          } : (this || _global).start.row < e && (i = {
            row: e,
            column: 0
          }), r.fromPoints(i || (this || _global).start, n || (this || _global).end);
        }, r.prototype.extend = function (e, t) {
          var n,
            i,
            o = this.compare(e, t);
          return 0 == o ? this || _global : (-1 == o ? n = {
            row: e,
            column: t
          } : i = {
            row: e,
            column: t
          }, r.fromPoints(n || (this || _global).start, i || (this || _global).end));
        }, r.prototype.isEmpty = function () {
          return (this || _global).start.row === (this || _global).end.row && (this || _global).start.column === (this || _global).end.column;
        }, r.prototype.isMultiLine = function () {
          return (this || _global).start.row !== (this || _global).end.row;
        }, r.prototype.clone = function () {
          return r.fromPoints((this || _global).start, (this || _global).end);
        }, r.prototype.collapseRows = function () {
          return 0 == (this || _global).end.column ? new r((this || _global).start.row, 0, Math.max((this || _global).start.row, (this || _global).end.row - 1), 0) : new r((this || _global).start.row, 0, (this || _global).end.row, 0);
        }, r.prototype.toScreenRange = function (e) {
          var t = e.documentToScreenPosition((this || _global).start),
            e = e.documentToScreenPosition((this || _global).end);
          return new r(t.row, t.column, e.row, e.column);
        }, r.prototype.moveBy = function (e, t) {
          (this || _global).start.row += e, (this || _global).start.column += t, (this || _global).end.row += e, (this || _global).end.column += t;
        };
        var i = r;
        function r(e, t, n, i) {
          (this || _global).start = {
            row: e,
            column: t
          }, (this || _global).end = {
            row: n,
            column: i
          };
        }
        i.fromPoints = function (e, t) {
          return new i(e.row, e.column, t.row, t.column);
        }, i.comparePoints = function (e, t) {
          return e.row - t.row || e.column - t.column;
        }, i.comparePoints = function (e, t) {
          return e.row - t.row || e.column - t.column;
        }, t.Range = i;
      }), ace.define("ace/lib/keys", ["require", "exports", "module", "ace/lib/oop"], function (e, t, n) {
        /*! @license
        ==========================================================================
        SproutCore -- JavaScript Application Framework
        copyright 2006-2009, Sprout Systems Inc., Apple Inc. and contributors.
        
        Permission is hereby granted, free of charge, to any person obtaining a
        copy of this software and associated documentation files (the "Software"),
        to deal in the Software without restriction, including without limitation
        the rights to use, copy, modify, merge, publish, distribute, sublicense,
        and/or sell copies of the Software, and to permit persons to whom the
        Software is furnished to do so, subject to the following conditions:
        
        The above copyright notice and this permission notice shall be included in
        all copies or substantial portions of the Software.
        
        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
        DEALINGS IN THE SOFTWARE.
        
        SproutCore and the SproutCore logo are trademarks of Sprout Systems, Inc.
        
        For more information about SproutCore, visit http://www.sproutcore.com
        
        
        ==========================================================================
        @license */
        "use strict";

        var r = e("./oop"),
          i = function () {
            var e,
              t,
              n = {
                MODIFIER_KEYS: {
                  16: "Shift",
                  17: "Ctrl",
                  18: "Alt",
                  224: "Meta",
                  91: "MetaLeft",
                  92: "MetaRight",
                  93: "ContextMenu"
                },
                KEY_MODS: {
                  ctrl: 1,
                  alt: 2,
                  option: 2,
                  shift: 4,
                  super: 8,
                  meta: 8,
                  command: 8,
                  cmd: 8,
                  control: 1
                },
                FUNCTION_KEYS: {
                  8: "Backspace",
                  9: "Tab",
                  13: "Return",
                  19: "Pause",
                  27: "Esc",
                  32: "Space",
                  33: "PageUp",
                  34: "PageDown",
                  35: "End",
                  36: "Home",
                  37: "Left",
                  38: "Up",
                  39: "Right",
                  40: "Down",
                  44: "Print",
                  45: "Insert",
                  46: "Delete",
                  96: "Numpad0",
                  97: "Numpad1",
                  98: "Numpad2",
                  99: "Numpad3",
                  100: "Numpad4",
                  101: "Numpad5",
                  102: "Numpad6",
                  103: "Numpad7",
                  104: "Numpad8",
                  105: "Numpad9",
                  "-13": "NumpadEnter",
                  112: "F1",
                  113: "F2",
                  114: "F3",
                  115: "F4",
                  116: "F5",
                  117: "F6",
                  118: "F7",
                  119: "F8",
                  120: "F9",
                  121: "F10",
                  122: "F11",
                  123: "F12",
                  144: "Numlock",
                  145: "Scrolllock"
                },
                PRINTABLE_KEYS: {
                  32: " ",
                  48: "0",
                  49: "1",
                  50: "2",
                  51: "3",
                  52: "4",
                  53: "5",
                  54: "6",
                  55: "7",
                  56: "8",
                  57: "9",
                  59: ";",
                  61: "=",
                  65: "a",
                  66: "b",
                  67: "c",
                  68: "d",
                  69: "e",
                  70: "f",
                  71: "g",
                  72: "h",
                  73: "i",
                  74: "j",
                  75: "k",
                  76: "l",
                  77: "m",
                  78: "n",
                  79: "o",
                  80: "p",
                  81: "q",
                  82: "r",
                  83: "s",
                  84: "t",
                  85: "u",
                  86: "v",
                  87: "w",
                  88: "x",
                  89: "y",
                  90: "z",
                  107: "+",
                  109: "-",
                  110: ".",
                  186: ";",
                  187: "=",
                  188: ",",
                  189: "-",
                  190: ".",
                  191: "/",
                  192: "`",
                  219: "[",
                  220: "\\",
                  221: "]",
                  222: "'",
                  111: "/",
                  106: "*"
                }
              };
            for (t in n.PRINTABLE_KEYS[173] = "-", n.FUNCTION_KEYS) e = n.FUNCTION_KEYS[t].toLowerCase(), n[e] = parseInt(t, 10);
            for (t in n.PRINTABLE_KEYS) e = n.PRINTABLE_KEYS[t].toLowerCase(), n[e] = parseInt(t, 10);
            r.mixin(n, n.MODIFIER_KEYS), r.mixin(n, n.PRINTABLE_KEYS), r.mixin(n, n.FUNCTION_KEYS), n.enter = n.return, n.escape = n.esc, n.del = n.delete;
            for (var i = ["cmd", "ctrl", "alt", "shift"], o = Math.pow(2, i.length); o--;) n.KEY_MODS[o] = i.filter(function (e) {
              return o & n.KEY_MODS[e];
            }).join("-") + "-";
            return n.KEY_MODS[0] = "", n.KEY_MODS[-1] = "input-", n;
          }();
        r.mixin(t, i), t.keyCodeToString = function (e) {
          var t = i[e];
          return (t = "string" != typeof t ? String.fromCharCode(e) : t).toLowerCase();
        };
      }), ace.define("ace/lib/event", ["require", "exports", "module", "ace/lib/keys", "ace/lib/useragent"], function (e, d, t) {
        "use strict";

        var n,
          r = e("./keys"),
          u = e("./useragent"),
          s = null,
          a = 0;
        function o() {
          if (null == n) {
            n = !1;
            try {
              document.createComment("").addEventListener("test", function () {}, {
                get passive() {
                  n = {
                    passive: !1
                  };
                }
              });
            } catch (e) {}
          }
          return n;
        }
        function l(e, t, n) {
          (this || _global).elem = e, (this || _global).type = t, (this || _global).callback = n;
        }
        l.prototype.destroy = function () {
          p((this || _global).elem, (this || _global).type, (this || _global).callback), (this || _global).elem = (this || _global).type = (this || _global).callback = void 0;
        };
        function c(e) {
          return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
        }
        var h,
          g = d.addListener = function (e, t, n, i) {
            e.addEventListener(t, n, o()), i && i.$toDestroy.push(new l(e, t, n));
          },
          p = d.removeListener = function (e, t, n) {
            e.removeEventListener(t, n, o());
          };
        d.stopEvent = function (e) {
          return d.stopPropagation(e), d.preventDefault(e), !1;
        }, d.stopPropagation = function (e) {
          e.stopPropagation && e.stopPropagation();
        }, d.preventDefault = function (e) {
          e.preventDefault && e.preventDefault();
        }, d.getButton = function (e) {
          return "dblclick" == e.type ? 0 : "contextmenu" == e.type || u.isMac && e.ctrlKey && !e.altKey && !e.shiftKey ? 2 : e.button;
        }, d.capture = function (e, t, n) {
          var i = e && e.ownerDocument || document;
          function o(e) {
            t && t(e), n && n(e), p(i, "mousemove", t), p(i, "mouseup", o), p(i, "dragstart", o);
          }
          return g(i, "mousemove", t), g(i, "mouseup", o), g(i, "dragstart", o), o;
        }, d.addMouseWheelListener = function (e, i, t) {
          g(e, "wheel", function (e) {
            var t = e.deltaX || 0,
              n = e.deltaY || 0;
            switch (e.deltaMode) {
              case e.DOM_DELTA_PIXEL:
                e.wheelX = 0.15 * t, e.wheelY = 0.15 * n;
                break;
              case e.DOM_DELTA_LINE:
                e.wheelX = 15 * t, e.wheelY = 15 * n;
                break;
              case e.DOM_DELTA_PAGE:
                e.wheelX = 150 * t, e.wheelY = 150 * n;
            }
            i(e);
          }, t);
        }, d.addMultiMouseDownListener = function (e, n, i, o, t) {
          var r,
            s,
            a,
            l = 0,
            c = {
              2: "dblclick",
              3: "tripleclick",
              4: "quadclick"
            };
          function h(e) {
            var t;
            if (0 !== d.getButton(e) ? l = 0 : 1 < e.detail && !(4 < ++l) || (l = 1), u.isIE && (t = 5 < Math.abs(e.clientX - r) || 5 < Math.abs(e.clientY - s), a && !t || (l = 1), a && clearTimeout(a), a = setTimeout(function () {
              a = null;
            }, n[l - 1] || 600), 1 == l) && (r = e.clientX, s = e.clientY), e._clicks = l, i[o]("mousedown", e), 4 < l) l = 0;else if (1 < l) return i[o](c[l], e);
          }
          (e = Array.isArray(e) ? e : [e]).forEach(function (e) {
            g(e, "mousedown", h, t);
          });
        };
        function m(e, t, n) {
          var i = c(t);
          if (!u.isMac && s) {
            if (t.getModifierState && (t.getModifierState("OS") || t.getModifierState("Win")) && (i |= 8), s.altGr) {
              if (3 == (3 & i)) return;
              s.altGr = 0;
            }
            18 !== n && 17 !== n || (o = "location" in t ? t.location : t.keyLocation, 17 === n && 1 === o ? 1 == s[n] && (a = t.timeStamp) : 18 === n && 3 === i && 2 === o && t.timeStamp - a < 50 && (s.altGr = !0));
          }
          if (n in r.MODIFIER_KEYS && (n = -1), !i && 13 === n) {
            var o = "location" in t ? t.location : t.keyLocation;
            if (3 === o && (e(t, i, -n), t.defaultPrevented)) return;
          }
          if (u.isChromeOS && 8 & i) {
            if (e(t, i, n), t.defaultPrevented) return;
            i &= -9;
          }
          return !!(i || n in r.FUNCTION_KEYS || n in r.PRINTABLE_KEYS) && e(t, i, n);
        }
        function f() {
          s = Object.create(null);
        }
        d.getModifierString = function (e) {
          return r.KEY_MODS[c(e)];
        }, d.addCommandKeyListener = function (e, n, t) {
          var i, o;
          u.isOldGecko || u.isOpera && !("KeyboardEvent" in window) ? (i = null, g(e, "keydown", function (e) {
            i = e.keyCode;
          }, t), g(e, "keypress", function (e) {
            return m(n, e, i);
          }, t)) : (o = null, g(e, "keydown", function (e) {
            s[e.keyCode] = (s[e.keyCode] || 0) + 1;
            var t = m(n, e, e.keyCode);
            return o = e.defaultPrevented, t;
          }, t), g(e, "keypress", function (e) {
            o && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && (d.stopEvent(e), o = null);
          }, t), g(e, "keyup", function (e) {
            s[e.keyCode] = null;
          }, t), s || (f(), g(window, "focus", f)));
        }, "object" == typeof window && window.postMessage && !u.isOldIE && (h = 1, d.nextTick = function (t, n) {
          n = n || window;
          function i(e) {
            e.data == o && (d.stopPropagation(e), p(n, "message", i), t());
          }
          var o = "zero-timeout-message-" + h++;
          g(n, "message", i), n.postMessage(o, "*");
        }), d.$idleBlocked = !1, d.onIdle = function (t, e) {
          return setTimeout(function e() {
            d.$idleBlocked ? setTimeout(e, 100) : t();
          }, e);
        }, d.$idleBlockId = null, d.blockIdle = function (e) {
          d.$idleBlockId && clearTimeout(d.$idleBlockId), d.$idleBlocked = !0, d.$idleBlockId = setTimeout(function () {
            d.$idleBlocked = !1;
          }, e || 100);
        }, d.nextFrame = "object" == typeof window && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame), d.nextFrame ? d.nextFrame = d.nextFrame.bind(window) : d.nextFrame = function (e) {
          setTimeout(e, 17);
        };
      }), ace.define("ace/clipboard", ["require", "exports", "module"], function (e, t, n) {
        "use strict";

        var i;
        n.exports = {
          lineMode: !1,
          pasteCancelled: function () {
            return !!(i && i > Date.now() - 50) || (i = !1);
          },
          cancel: function () {
            i = Date.now();
          }
        };
      }), ace.define("ace/keyboard/textinput", ["require", "exports", "module", "ace/lib/event", "ace/config", "ace/lib/useragent", "ace/lib/dom", "ace/lib/lang", "ace/clipboard", "ace/lib/keys"], function (e, t, n) {
        "use strict";

        var P = e("../lib/event"),
          F = e("../config").nls,
          V = e("../lib/useragent"),
          Z = e("../lib/dom"),
          O = e("../lib/lang"),
          D = e("../clipboard"),
          K = V.isChrome < 18,
          j = V.isIE,
          z = 63 < V.isChrome,
          X = e("../lib/keys"),
          Y = X.KEY_MODS,
          J = V.isIOS,
          U = J ? /\s/ : /\n/,
          Q = V.isMobile;
        t.TextInput = function (e, d) {
          var u = Z.createElement("textarea"),
            r = (u.className = "ace_text-input", u.setAttribute("wrap", "off"), u.setAttribute("autocorrect", "off"), u.setAttribute("autocapitalize", "off"), u.setAttribute("spellcheck", !1), u.style.opacity = "0", e.insertBefore(u, e.firstChild), !1),
            g = !1,
            s = !1,
            p = !1,
            a = "",
            m = (Q || (u.style.fontSize = "1px"), !1),
            t = !1,
            f = "",
            C = 0,
            y = 0,
            v = 0;
          try {
            var l = document.activeElement === u;
          } catch (e) {}
          (this || _global).setAriaOptions = function (e) {
            e.activeDescendant ? (u.setAttribute("aria-haspopup", "true"), u.setAttribute("aria-autocomplete", e.inline ? "both" : "list"), u.setAttribute("aria-activedescendant", e.activeDescendant)) : (u.setAttribute("aria-haspopup", "false"), u.setAttribute("aria-autocomplete", "both"), u.removeAttribute("aria-activedescendant")), e.role && u.setAttribute("role", e.role);
          }, (this || _global).setAriaLabel = function () {
            var e;
            d.session && d.renderer.enableKeyboardAccessibility ? (e = d.session.selection.cursor.row, u.setAttribute("aria-roledescription", F("editor")), u.setAttribute("aria-label", F("Cursor at row $0", [e + 1]))) : (u.removeAttribute("aria-roledescription"), u.removeAttribute("aria-label"));
          }, this.setAriaOptions({
            role: "textbox"
          }), this.setAriaLabel(), P.addListener(u, "blur", function (e) {
            t || (d.onBlur(e), l = !1, Q && !J && document.removeEventListener("selectionchange", c));
          }, d), P.addListener(u, "focus", function (e) {
            if (!t) {
              if (l = !0, V.isEdge) try {
                if (!document.hasFocus()) return;
              } catch (e) {}
              d.onFocus(e), V.isEdge ? setTimeout(I) : I(), Q && !J && document.addEventListener("selectionchange", c);
            }
          }, d), (this || _global).$focusScroll = !1, (this || _global).focus = function () {
            if (this.setAriaLabel(), a || z || "browser" == (this || _global).$focusScroll) return u.focus({
              preventScroll: !0
            });
            var e = u.style.top;
            u.style.position = "fixed", u.style.top = "0px";
            try {
              var t = 0 != u.getBoundingClientRect().top;
            } catch (e) {
              return;
            }
            var n = [];
            if (t) for (var i = u.parentElement; i && 1 == i.nodeType;) n.push(i), i.setAttribute("ace_nocontext", !0), i = !i.parentElement && i.getRootNode ? i.getRootNode().host : i.parentElement;
            u.focus({
              preventScroll: !0
            }), t && n.forEach(function (e) {
              e.removeAttribute("ace_nocontext");
            }), setTimeout(function () {
              u.style.position = "", "0px" == u.style.top && (u.style.top = e);
            }, 0);
          }, (this || _global).blur = function () {
            u.blur();
          }, (this || _global).isFocused = function () {
            return l;
          }, d.on("beforeEndOperation", function () {
            var e = d.curOp,
              t = e && e.command && e.command.name;
            "insertstring" != t && (t = t && (e.docChanged || e.selectionChanged), s && t && (f = u.value = "", E()), I());
          });
          var I = J ? function (e) {
              var t;
              !l || r && !e || p || ((t = "\n ab" + (e = e || "") + "cde fg\n") != u.value && (u.value = f = t), t = 4 + (e.length || (d.selection.isEmpty() ? 0 : 1)), 4 == C && y == t || u.setSelectionRange(4, t), C = 4, y = t);
            } : function () {
              if (!s && !p && (l || b)) {
                s = !0;
                var e,
                  t,
                  n = 0,
                  i = 0,
                  o = "",
                  r = (d.session && (r = (e = d.selection).getRange(), e = e.cursor.row, n = r.start.column, i = r.end.column, o = d.session.getLine(e), r.start.row != e ? (t = d.session.getLine(e - 1), n = r.start.row < e - 1 ? 0 : n, i += t.length + 1, o = t + "\n" + o) : r.end.row != e ? (t = d.session.getLine(e + 1), i = r.end.row > e + 1 ? t.length : i, i += o.length + 1, o = o + "\n" + t) : Q && 0 < e && (o = "\n" + o, i += 1, n += 1), 400 < o.length) && (n < 400 && i < 400 ? o = o.slice(0, 400) : (o = "\n", n == i ? n = i = 0 : (n = 0, i = 1))), o + "\n\n");
                if (r != f && (u.value = f = r, C = y = r.length), b && (C = u.selectionStart, y = u.selectionEnd), y != i || C != n || u.selectionEnd != y) try {
                  u.setSelectionRange(n, i), C = n, y = i;
                } catch (e) {}
                s = !1;
              }
            },
            W = ((this || _global).resetSelection = I, l && d.onFocus(), function (e) {
              return 0 === e.selectionStart && e.selectionEnd >= f.length && e.value === f && f && e.selectionEnd !== y;
            });
          function c(e) {
            if (u && u.parentNode || document.removeEventListener("selectionchange", c), !s && u.selectionStart === u.selectionEnd) for (var t = u.selectionStart - C, n = y - C, i = (0 < t ? t = Math.max(t - n, 1) : 0 === t && n && (t = -1), Math.abs(t)), o = 0 < t ? X.right : X.left, r = 0; r < i; r++) d.onCommandKey({}, 0, o);
          }
          function n(e) {
            x(e, !0);
          }
          function i(e) {
            x(e, !1);
          }
          function o(e) {
            var t = S(e);
            D.pasteCancelled() || ("string" == typeof t ? (t && d.onPaste(t, e), V.isIE && setTimeout(I), P.preventDefault(e)) : (u.value = "", g = !0));
          }
          var h = null,
            b = ((this || _global).setInputHandler = function (e) {
              h = e;
            }, !((this || _global).getInputHandler = function () {
              return h;
            })),
            A = function (e, t) {
              if (b = b && !1, g) return I(), e && d.onPaste(e), g = !1, "";
              for (var n = u.selectionStart, i = u.selectionEnd, o = C, r = f.length - y, s = e, a = e.length - n, l = e.length - i, c = 0; 0 < o && f[c] == e[c];) c++, o--;
              for (s = s.slice(c), c = 1; 0 < r && f.length - c > C - 1 && f[f.length - c] == e[e.length - c];) c++, r--;
              a -= c - 1, l -= c - 1;
              var h = s.length - c + 1;
              return h < 0 && (o = -h, h = 0), s = s.slice(0, h), t || s || a || o || r || l ? (h = !(p = !0), V.isAndroid && ". " == s && (s = "  ", h = !0), s && !o && !r && !a && !l || m ? d.onTextInput(s) : d.onTextInput(s, {
                extendLeft: o,
                extendRight: r,
                restoreStart: a,
                restoreEnd: l
              }), p = !1, f = e, C = n, y = i, v = l, h ? "\n" : s) : "";
            },
            w = function (e) {
              if (s) return k();
              if (e && e.inputType) {
                if ("historyUndo" == e.inputType) return d.execCommand("undo");
                if ("historyRedo" == e.inputType) return d.execCommand("redo");
              }
              var e = u.value,
                t = A(e, !0);
              (500 < e.length || U.test(t) || Q && C < 1 && C == y) && I();
            },
            S = function (e, t, n) {
              var i = e.clipboardData || window.clipboardData;
              if (i && !K) {
                var o = j || n ? "Text" : "text/plain";
                try {
                  return t ? !1 !== i.setData(o, t) : i.getData(o);
                } catch (e) {
                  if (!n) return S(e, t, !0);
                }
              }
            },
            x = function (e, t) {
              var n = d.getCopyText();
              if (!n) return P.preventDefault(e);
              S(e, n) ? (J && (I(n), r = n, setTimeout(function () {
                r = !1;
              }, 10)), t ? d.onCut() : d.onCopy(), P.preventDefault(e)) : (r = !0, u.value = n, u.select(), setTimeout(function () {
                r = !1, I(), t ? d.onCut() : d.onCopy();
              }));
            },
            k = (P.addCommandKeyListener(u, d.onCommandKey.bind(d), d), P.addListener(u, "select", function (e) {
              s || (r ? r = !1 : W(u) ? (d.selectAll(), I()) : Q && u.selectionStart != C && I());
            }, d), P.addListener(u, "input", w, d), P.addListener(u, "cut", n, d), P.addListener(u, "copy", i, d), P.addListener(u, "paste", o, d), "oncut" in u && "oncopy" in u && "onpaste" in u || P.addListener(e, "keydown", function (e) {
              if ((!V.isMac || e.metaKey) && e.ctrlKey) switch (e.keyCode) {
                case 67:
                  i(e);
                  break;
                case 86:
                  o(e);
                  break;
                case 88:
                  n(e);
              }
            }, d), function () {
              var e;
              if (s && d.onCompositionUpdate && !d.$readOnly) return m ? T() : void (s.useTextareaForIME ? d.onCompositionUpdate(u.value) : (e = u.value, A(e), s.markerRange && (s.context && (s.markerRange.start.column = s.selectionStart = s.context.compositionStartOffset), s.markerRange.end.column = s.markerRange.start.column + y - s.selectionStart + v)));
            }),
            E = function (e) {
              d.onCompositionEnd && !d.$readOnly && (s = !1, d.onCompositionEnd(), d.off("mousedown", T), e) && w();
            };
          function T() {
            t = !0, u.blur(), u.focus(), t = !1;
          }
          var R,
            H = O.delayedCall(k, 50).schedule.bind(null, null);
          function _() {
            clearTimeout(R), R = setTimeout(function () {
              a && (u.style.cssText = a, a = ""), d.renderer.$isMousePressed = !1, d.renderer.$keepTextAreaAtCursor && d.renderer.$moveTextAreaToCursor();
            }, 0);
          }
          P.addListener(u, "compositionstart", function (e) {
            s || !d.onCompositionStart || d.$readOnly || (s = {}, m) || (e.data && (s.useTextareaForIME = !1), setTimeout(k, 0), d._signal("compositionStart"), d.on("mousedown", T), (e = d.getSelectionRange()).end.row = e.start.row, e.end.column = e.start.column, s.markerRange = e, s.selectionStart = C, d.onCompositionStart(s), s.useTextareaForIME ? (f = u.value = "", y = C = 0) : (u.msGetInputContext && (s.context = u.msGetInputContext()), u.getInputContext && (s.context = u.getInputContext())));
          }, d), P.addListener(u, "compositionupdate", k, d), P.addListener(u, "keyup", function (e) {
            27 == e.keyCode && u.value.length < u.selectionStart && (s || (f = u.value), C = y = -1, I()), H();
          }, d), P.addListener(u, "keydown", H, d), P.addListener(u, "compositionend", E, d), (this || _global).getElement = function () {
            return u;
          }, (this || _global).setCommandMode = function (e) {
            m = e, u.readOnly = !1;
          }, (this || _global).setReadOnly = function (e) {
            m || (u.readOnly = e);
          }, (this || _global).setCopyWithEmptySelection = function (e) {}, (this || _global).onContextMenu = function (e) {
            b = !0, I(), d._emit("nativecontextmenu", {
              target: d,
              domEvent: e
            }), this.moveToMouse(e, !0);
          }, (this || _global).moveToMouse = function (e, t) {
            a = a || u.style.cssText, u.style.cssText = (t ? "z-index:100000;" : "") + (V.isIE ? "opacity:0.1;" : "") + "text-indent: -" + (C + y) * d.renderer.characterWidth * 0.5 + "px;";
            function n(e) {
              Z.translate(u, e.clientX - r - 2, Math.min(e.clientY - o - 2, s));
            }
            var t = d.container.getBoundingClientRect(),
              i = Z.computedStyle(d.container),
              o = t.top + (parseInt(i.borderTopWidth) || 0),
              r = t.left + (parseInt(t.borderLeftWidth) || 0),
              s = t.bottom - o - u.clientHeight - 2;
            n(e), "mousedown" == e.type && (d.renderer.$isMousePressed = !0, clearTimeout(R), V.isWin) && P.capture(d.container, n, _);
          }, (this || _global).onContextMenuClose = _;
          function $(e) {
            d.textInput.onContextMenu(e), _();
          }
          if (P.addListener(u, "mouseup", $, d), P.addListener(u, "mousedown", function (e) {
            e.preventDefault(), _();
          }, d), P.addListener(d.renderer.scroller, "contextmenu", $, d), P.addListener(u, "contextmenu", $, d), J) {
            var L = d,
              N = u;
            function G(e) {
              var t, n, i, o;
              document.activeElement !== N || M || s || L.$mouseHandler.isMousePressed || r || (t = N.selectionStart, n = N.selectionEnd, i = null, (o = 0) == t ? i = X.up : 1 == t ? i = X.home : y < n && "\n" == f[n] ? i = X.end : t < C && " " == f[t - 1] ? (i = X.left, o = Y.option) : t < C || t == C && y != C && t == n ? i = X.left : y < n && 2 < f.slice(0, n).split("\n").length ? i = X.down : y < n && " " == f[n - 1] ? (i = X.right, o = Y.option) : (y < n || n == y && y != C && t == n) && (i = X.right), t !== n && (o |= Y.shift), i && (!L.onCommandKey({}, o, i) && L.commands && (i = X.keyCodeToString(i), o = L.commands.findKeyCommand(o, i)) && L.execCommand(o), C = t, y = n, I("")));
            }
            var B = null,
              M = !1;
            N.addEventListener("keydown", function (e) {
              B && clearTimeout(B), M = !0;
            }, !0), N.addEventListener("keyup", function (e) {
              B = setTimeout(function () {
                M = !1;
              }, 100);
            }, !0), document.addEventListener("selectionchange", G), L.on("destroy", function () {
              document.removeEventListener("selectionchange", G);
            });
          }
          (this || _global).destroy = function () {
            u.parentElement && u.parentElement.removeChild(u);
          };
        }, t.$setUserAgentForTests = function (e, t) {
          Q = e, J = t;
        };
      }), ace.define("ace/mouse/default_handlers", ["require", "exports", "module", "ace/lib/useragent"], function (e, t, n) {
        "use strict";

        var r = e("../lib/useragent"),
          e = (i.prototype.onMouseDown = function (e) {
            var t = e.inSelection(),
              n = e.getDocumentPosition(),
              i = ((this || _global).mousedownEvent = e, (this || _global).editor),
              o = e.getButton();
            if (0 !== o) !i.getSelectionRange().isEmpty() && 1 != o || i.selection.moveToPosition(n), 2 == o && (i.textInput.onContextMenu(e.domEvent), r.isMozilla || e.preventDefault());else {
              if ((this || _global).mousedownEvent.time = Date.now(), !t || i.isFocused() || (i.focus(), !(this || _global).$focusTimeout) || (this || _global).$clickSelection || i.inMultiSelectMode) return this.captureMouse(e), this.startSelect(n, 1 < e.domEvent._clicks), e.preventDefault();
              this.setState("focusWait"), this.captureMouse(e);
            }
          }, i.prototype.startSelect = function (e, t) {
            e = e || (this || _global).editor.renderer.screenToTextCoordinates((this || _global).x, (this || _global).y);
            var n = (this || _global).editor;
            (this || _global).mousedownEvent && ((this || _global).mousedownEvent.getShiftKey() ? n.selection.selectToPosition(e) : t || n.selection.moveToPosition(e), t || this.select(), n.setStyle("ace_selecting"), this.setState("select"));
          }, i.prototype.select = function () {
            var e,
              t = (this || _global).editor,
              n = t.renderer.screenToTextCoordinates((this || _global).x, (this || _global).y);
            (this || _global).$clickSelection && (e = -1 == (e = (this || _global).$clickSelection.comparePoint(n)) ? (this || _global).$clickSelection.end : 1 == e ? (this || _global).$clickSelection.start : (n = (e = s((this || _global).$clickSelection, n)).cursor, e.anchor), t.selection.setSelectionAnchor(e.row, e.column)), t.selection.selectToPosition(n), t.renderer.scrollCursorIntoView();
          }, i.prototype.extendSelectionBy = function (e) {
            var t,
              n,
              i,
              o = (this || _global).editor,
              r = o.renderer.screenToTextCoordinates((this || _global).x, (this || _global).y),
              e = o.selection[e](r.row, r.column);
            (this || _global).$clickSelection && (n = (this || _global).$clickSelection.comparePoint(e.start), t = (this || _global).$clickSelection.comparePoint(e.end), -1 == n && t <= 0 ? (i = (this || _global).$clickSelection.end, e.end.row == r.row && e.end.column == r.column || (r = e.start)) : 1 == t && 0 <= n ? (i = (this || _global).$clickSelection.start, e.start.row == r.row && e.start.column == r.column || (r = e.end)) : i = -1 == n && 1 == t ? (r = e.end, e.start) : (r = (n = s((this || _global).$clickSelection, r)).cursor, n.anchor), o.selection.setSelectionAnchor(i.row, i.column)), o.selection.selectToPosition(r), o.renderer.scrollCursorIntoView();
          }, i.prototype.selectByLinesEnd = function () {
            (this || _global).$clickSelection = null, (this || _global).editor.unsetStyle("ace_selecting");
          }, i.prototype.focusWait = function () {
            i = (this || _global).mousedownEvent.x, e = (this || _global).mousedownEvent.y, n = (this || _global).x, t = (this || _global).y;
            var e,
              t,
              n = Math.sqrt(Math.pow(n - i, 2) + Math.pow(t - e, 2)),
              i = Date.now();
            (0 < n || i - (this || _global).mousedownEvent.time > (this || _global).$focusTimeout) && this.startSelect((this || _global).mousedownEvent.getDocumentPosition());
          }, i.prototype.onDoubleClick = function (e) {
            var e = e.getDocumentPosition(),
              t = (this || _global).editor,
              n = t.session.getBracketRange(e);
            n ? (n.isEmpty() && (n.start.column--, n.end.column++), this.setState("select")) : (n = t.selection.getWordRange(e.row, e.column), this.setState("selectByWords")), (this || _global).$clickSelection = n, this.select();
          }, i.prototype.onTripleClick = function (e) {
            var e = e.getDocumentPosition(),
              t = (this || _global).editor,
              n = (this.setState("selectByLines"), t.getSelectionRange());
            n.isMultiLine() && n.contains(e.row, e.column) ? ((this || _global).$clickSelection = t.selection.getLineRange(n.start.row), (this || _global).$clickSelection.end = t.selection.getLineRange(n.end.row).end) : (this || _global).$clickSelection = t.selection.getLineRange(e.row), this.select();
          }, i.prototype.onQuadClick = function (e) {
            var t = (this || _global).editor;
            t.selectAll(), (this || _global).$clickSelection = t.getSelectionRange(), this.setState("selectAll");
          }, i.prototype.onMouseWheel = function (e) {
            var t, n, i, o, r, s, a;
            if (!e.getAccelKey()) return e.getShiftKey() && e.wheelY && !e.wheelX && (e.wheelX = e.wheelY, e.wheelY = 0), t = (this || _global).editor, (this || _global).$lastScroll || ((this || _global).$lastScroll = {
              t: 0,
              vx: 0,
              vy: 0,
              allowed: 0
            }), n = (this || _global).$lastScroll, o = (a = (i = e.domEvent.timeStamp) - n.t) ? e.wheelX / a : n.vx, r = a ? e.wheelY / a : n.vy, a < 550 && (o = (o + n.vx) / 2, r = (r + n.vy) / 2), a = !1, 1 <= (s = Math.abs(o / r)) && t.renderer.isScrollableBy(e.wheelX * e.speed, 0) && (a = !0), (a = s <= 1 && t.renderer.isScrollableBy(0, e.wheelY * e.speed) ? !0 : a) ? n.allowed = i : i - n.allowed < 550 && (Math.abs(o) <= 1.5 * Math.abs(n.vx) && Math.abs(r) <= 1.5 * Math.abs(n.vy) ? (a = !0, n.allowed = i) : n.allowed = 0), n.t = i, n.vx = o, n.vy = r, a ? (t.renderer.scrollBy(e.wheelX * e.speed, e.wheelY * e.speed), e.stop()) : void 0;
          }, i);
        function i(t) {
          t.$clickSelection = null;
          var e = t.editor;
          e.setDefaultHandler("mousedown", (this || _global).onMouseDown.bind(t)), e.setDefaultHandler("dblclick", (this || _global).onDoubleClick.bind(t)), e.setDefaultHandler("tripleclick", (this || _global).onTripleClick.bind(t)), e.setDefaultHandler("quadclick", (this || _global).onQuadClick.bind(t)), e.setDefaultHandler("mousewheel", (this || _global).onMouseWheel.bind(t));
          ["select", "startSelect", "selectEnd", "selectAllEnd", "selectByWordsEnd", "selectByLinesEnd", "dragWait", "dragWaitEnd", "focusWait"].forEach(function (e) {
            t[e] = (this || _global)[e];
          }, this || _global), t.selectByLines = (this || _global).extendSelectionBy.bind(t, "getLineRange"), t.selectByWords = (this || _global).extendSelectionBy.bind(t, "getWordRange");
        }
        function s(e, t) {
          return (e.start.row == e.end.row ? 2 * t.column - e.start.column - e.end.column : e.start.row != e.end.row - 1 || e.start.column || e.end.column ? 2 * t.row - e.start.row - e.end.row : t.column - 4) < 0 ? {
            cursor: e.start,
            anchor: e.end
          } : {
            cursor: e.end,
            anchor: e.start
          };
        }
        e.prototype.selectEnd = e.prototype.selectByLinesEnd, e.prototype.selectAllEnd = e.prototype.selectByLinesEnd, e.prototype.selectByWordsEnd = e.prototype.selectByLinesEnd, t.DefaultHandlers = e;
      }), ace.define("ace/tooltip", ["require", "exports", "module", "ace/lib/dom", "ace/range"], function (e, t, n) {
        "use strict";

        var i,
          o = (this || _global) && (this || _global).__extends || (i = function (e, t) {
            return (i = Object.setPrototypeOf || ({
              __proto__: []
            } instanceof Array ? function (e, t) {
              e.__proto__ = t;
            } : function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }))(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              (this || _global).constructor = e;
            }
            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          u = (this || _global) && (this || _global).__values || function (e) {
            var t = "function" == typeof Symbol && Symbol.iterator,
              n = t && e[t],
              i = 0;
            if (n) return n.call(e);
            if (e && "number" == typeof e.length) return {
              next: function () {
                return {
                  value: (e = e && i >= e.length ? void 0 : e) && e[i++],
                  done: !e
                };
              }
            };
            throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          r = e("./lib/dom"),
          a = e("./range").Range,
          s = "ace_tooltip",
          e = (l.prototype.$init = function () {
            return (this || _global).$element = r.createElement("div"), (this || _global).$element.className = s, (this || _global).$element.style.display = "none", (this || _global).$parentNode.appendChild((this || _global).$element), (this || _global).$element;
          }, l.prototype.getElement = function () {
            return (this || _global).$element || this.$init();
          }, l.prototype.setText = function (e) {
            this.getElement().textContent = e;
          }, l.prototype.setHtml = function (e) {
            this.getElement().innerHTML = e;
          }, l.prototype.setPosition = function (e, t) {
            this.getElement().style.left = e + "px", this.getElement().style.top = t + "px";
          }, l.prototype.setClassName = function (e) {
            r.addCssClass(this.getElement(), e);
          }, l.prototype.setTheme = function (e) {
            (this || _global).$element.className = s + " " + (e.isDark ? "ace_dark " : "") + (e.cssClass || "");
          }, l.prototype.show = function (e, t, n) {
            null != e && this.setText(e), null != t && null != n && this.setPosition(t, n), (this || _global).isOpen || (this.getElement().style.display = "block", (this || _global).isOpen = !0);
          }, l.prototype.hide = function () {
            (this || _global).isOpen && (this.getElement().style.display = "none", this.getElement().className = s, (this || _global).isOpen = !1);
          }, l.prototype.getHeight = function () {
            return this.getElement().offsetHeight;
          }, l.prototype.getWidth = function () {
            return this.getElement().offsetWidth;
          }, l.prototype.destroy = function () {
            (this || _global).isOpen = !1, (this || _global).$element && (this || _global).$element.parentNode && (this || _global).$element.parentNode.removeChild((this || _global).$element);
          }, l);
        function l(e) {
          (this || _global).isOpen = !1, (this || _global).$element = null, (this || _global).$parentNode = e;
        }
        function c() {
          (this || _global).popups = [];
        }
        c.prototype.addPopup = function (e) {
          (this || _global).popups.push(e), this.updatePopups();
        }, c.prototype.removePopup = function (e) {
          e = (this || _global).popups.indexOf(e);
          -1 !== e && ((this || _global).popups.splice(e, 1), this.updatePopups());
        }, c.prototype.updatePopups = function () {
          (this || _global).popups.sort(function (e, t) {
            return t.priority - e.priority;
          });
          var t,
            e,
            n,
            i,
            o = [];
          try {
            for (var r = u((this || _global).popups), s = r.next(); !s.done; s = r.next()) {
              var a = s.value,
                l = !0;
              try {
                n = void 0;
                for (var c = u(o), h = c.next(); !h.done; h = c.next()) {
                  var d = h.value;
                  if (this.doPopupsOverlap(d, a)) {
                    l = !1;
                    break;
                  }
                }
              } catch (e) {
                n = {
                  error: e
                };
              } finally {
                try {
                  h && !h.done && (i = c.return) && i.call(c);
                } finally {
                  if (n) throw n.error;
                }
              }
              l ? o.push(a) : a.hide();
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              s && !s.done && (e = r.return) && e.call(r);
            } finally {
              if (t) throw t.error;
            }
          }
        }, c.prototype.doPopupsOverlap = function (e, t) {
          e = e.getElement().getBoundingClientRect(), t = t.getElement().getBoundingClientRect();
          return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
        };
        var h,
          d = new c(),
          o = (t.popupManager = d, t.Tooltip = e, o(g, h = e), g.prototype.addToEditor = function (e) {
            e.on("mousemove", (this || _global).onMouseMove), e.on("mousedown", (this || _global).hide), e.renderer.getMouseEventTarget().addEventListener("mouseout", (this || _global).onMouseOut, !0);
          }, g.prototype.removeFromEditor = function (e) {
            e.off("mousemove", (this || _global).onMouseMove), e.off("mousedown", (this || _global).hide), e.renderer.getMouseEventTarget().removeEventListener("mouseout", (this || _global).onMouseOut, !0), (this || _global).timeout && (clearTimeout((this || _global).timeout), (this || _global).timeout = null);
          }, g.prototype.onMouseMove = function (e, t) {
            (this || _global).lastEvent = e, (this || _global).lastT = Date.now();
            var n,
              t = t.$mouseHandler.isMousePressed;
            (this || _global).isOpen && (n = (this || _global).lastEvent && (this || _global).lastEvent.getDocumentPosition(), (this || _global).range && (this || _global).range.contains(n.row, n.column) && !t && !this.isOutsideOfText((this || _global).lastEvent) || this.hide()), (this || _global).timeout || t || ((this || _global).lastEvent = e, (this || _global).timeout = setTimeout((this || _global).waitForHover, (this || _global).idleTime));
          }, g.prototype.waitForHover = function () {
            (this || _global).timeout && clearTimeout((this || _global).timeout);
            var e = Date.now() - (this || _global).lastT;
            10 < (this || _global).idleTime - e ? (this || _global).timeout = setTimeout((this || _global).waitForHover, (this || _global).idleTime - e) : ((this || _global).timeout = null, (this || _global).lastEvent && !this.isOutsideOfText((this || _global).lastEvent) && this.$gatherData((this || _global).lastEvent, (this || _global).lastEvent.editor));
          }, g.prototype.isOutsideOfText = function (e) {
            var t = e.editor,
              n = e.getDocumentPosition(),
              i = t.session.getLine(n.row);
            if (n.column == i.length) {
              i = t.renderer.pixelToScreenCoordinates(e.clientX, e.clientY), e = t.session.documentToScreenPosition(n.row, n.column);
              if (e.column != i.column || e.row != i.row) return !0;
            }
            return !1;
          }, g.prototype.setDataProvider = function (e) {
            (this || _global).$gatherData = e;
          }, g.prototype.showForRange = function (e, t, n, i) {
            var o, r, s;
            i && i != (this || _global).lastEvent || (this || _global).isOpen && document.activeElement == this.getElement() || (i = e.renderer, (this || _global).isOpen || (d.addPopup(this || _global), this.$registerCloseEvents(), this.setTheme(i.theme)), (this || _global).isOpen = !0, this.addMarker(t, e.session), (this || _global).range = a.fromPoints(t.start, t.end), (o = this.getElement()).innerHTML = "", o.appendChild(n), o.style.display = "block", n = i.textToScreenCoordinates(t.start.row, t.start.column), t = e.getCursorPosition(), e = o.clientHeight, r = i.scroller.getBoundingClientRect(), s = !0, (this || _global).row > t.row ? s = !0 : (this || _global).row < t.row && (s = !1), n.pageY - e + i.lineHeight < r.top ? s = !0 : n.pageY + e > r.bottom && (s = !1), s ? n.pageY += i.lineHeight : n.pageY -= e, o.style.maxWidth = r.width - (n.pageX - r.left) + "px", this.setPosition(n.pageX, n.pageY));
          }, g.prototype.addMarker = function (e, t) {
            (this || _global).marker && (this || _global).$markerSession.removeMarker((this || _global).marker), (this || _global).$markerSession = t, (this || _global).marker = t && t.addMarker(e, "ace_highlight-marker", "text");
          }, g.prototype.hide = function (e) {
            !e && document.activeElement == this.getElement() || e && e.target && ("keydown" != e.type || e.ctrlKey || e.metaKey) && (this || _global).$element.contains(e.target) || ((this || _global).lastEvent = null, (this || _global).timeout && clearTimeout((this || _global).timeout), (this || _global).timeout = null, this.addMarker(null), (this || _global).isOpen && (this.$removeCloseEvents(), this.getElement().style.display = "none", (this || _global).isOpen = !1, d.removePopup(this || _global)));
          }, g.prototype.$registerCloseEvents = function () {
            window.addEventListener("keydown", (this || _global).hide, !0), window.addEventListener("mousewheel", (this || _global).hide, !0), window.addEventListener("mousedown", (this || _global).hide, !0);
          }, g.prototype.$removeCloseEvents = function () {
            window.removeEventListener("keydown", (this || _global).hide, !0), window.removeEventListener("mousewheel", (this || _global).hide, !0), window.removeEventListener("mousedown", (this || _global).hide, !0);
          }, g.prototype.onMouseOut = function (e) {
            (this || _global).timeout && (clearTimeout((this || _global).timeout), (this || _global).timeout = null), (this || _global).lastEvent = null, !(this || _global).isOpen || !e.relatedTarget || e.relatedTarget == this.getElement() || e && e.currentTarget.contains(e.relatedTarget) || e.relatedTarget.classList.contains("ace_content") || this.hide();
          }, g);
        function g(e) {
          void 0 === e && (e = document.body);
          var e = h.call(this || _global, e) || this || _global,
            t = (e.timeout = void 0, e.lastT = 0, e.idleTime = 350, e.lastEvent = void 0, e.onMouseOut = e.onMouseOut.bind(e), e.onMouseMove = e.onMouseMove.bind(e), e.waitForHover = e.waitForHover.bind(e), e.hide = e.hide.bind(e), e.getElement());
          return t.style.whiteSpace = "pre-wrap", t.style.pointerEvents = "auto", t.addEventListener("mouseout", e.onMouseOut), t.tabIndex = -1, t.addEventListener("blur", function () {
            t.contains(document.activeElement) || this.hide();
          }.bind(e)), e;
        }
        t.HoverTooltip = o;
      }), ace.define("ace/mouse/default_gutter_handler", ["require", "exports", "module", "ace/lib/dom", "ace/lib/event", "ace/tooltip", "ace/config"], function (e, t, n) {
        "use strict";

        var i,
          o = (this || _global) && (this || _global).__extends || (i = function (e, t) {
            return (i = Object.setPrototypeOf || ({
              __proto__: []
            } instanceof Array ? function (e, t) {
              e.__proto__ = t;
            } : function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }))(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              (this || _global).constructor = e;
            }
            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          l = (this || _global) && (this || _global).__values || function (e) {
            var t = "function" == typeof Symbol && Symbol.iterator,
              n = t && e[t],
              i = 0;
            if (n) return n.call(e);
            if (e && "number" == typeof e.length) return {
              next: function () {
                return {
                  value: (e = e && i >= e.length ? void 0 : e) && e[i++],
                  done: !e
                };
              }
            };
            throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          d = e("../lib/dom"),
          u = e("../lib/event"),
          s = e("../tooltip").Tooltip,
          r = e("../config").nls;
        t.GutterHandler = function (i) {
          var o,
            r,
            s = i.editor,
            a = s.renderer.$gutterLayer,
            l = new g(s);
          function c() {
            o = o && clearTimeout(o), l.isOpen && (l.hide(), s._signal("hideGutterTooltip", l), s.off("mousewheel", c));
          }
          function h(e) {
            l.setPosition(e.x, e.y);
          }
          i.editor.setDefaultHandler("guttermousedown", function (e) {
            if (s.isFocused() && 0 == e.getButton()) {
              var t = a.getRegion(e);
              if ("foldWidgets" != t) {
                var t = e.getDocumentPosition().row,
                  n = s.session.selection;
                if (e.getShiftKey()) n.selectTo(t, 0);else {
                  if (2 == e.domEvent.detail) return s.selectAll(), e.preventDefault();
                  i.$clickSelection = s.selection.getLineRange(t);
                }
                return i.setState("selectByLines"), i.captureMouse(e), e.preventDefault();
              }
            }
          }), i.editor.setDefaultHandler("guttermousemove", function (e) {
            var t = e.domEvent.target || e.domEvent.srcElement;
            if (d.hasCssClass(t, "ace_fold-widget")) return c();
            l.isOpen && i.$tooltipFollowsMouse && h(e), r = e, o = o || setTimeout(function () {
              if (o = null, r && !i.isMousePressed) {
                var e = r.getDocumentPosition().row;
                if (e == s.session.getLength()) {
                  var t = s.renderer.pixelToScreenCoordinates(0, r.y).row,
                    n = r.$pos;
                  if (t > s.session.documentToScreenRow(n.row, n.column)) return void c();
                }
                l.showTooltip(e), s.on("mousewheel", c), i.$tooltipFollowsMouse ? h(r) : (t = a.$lines.cells[e].element.querySelector("[class*=ace_icon]").getBoundingClientRect(), (n = l.getElement().style).left = t.right + "px", n.top = t.bottom + "px");
              } else c();
            }, 50);
          }), u.addListener(s.renderer.$gutter, "mouseout", function (e) {
            r = null, l.isOpen && (o = o || setTimeout(function () {
              o = null, c();
            }, 50));
          }, s), s.on("changeSession", c);
        };
        o(p, a = s), p.prototype.setPosition = function (e, t) {
          var n = window.innerWidth || document.documentElement.clientWidth,
            i = window.innerHeight || document.documentElement.clientHeight,
            o = this.getWidth(),
            r = this.getHeight();
          n < (e += 15) + o && (e -= e + o - n), i < (t += 15) + r && (t -= 20 + r), s.prototype.setPosition.call(this || _global, e, t);
        }, Object.defineProperty(p, "annotationLabels", {
          get: function () {
            return {
              error: {
                singular: r("error"),
                plural: r("errors")
              },
              warning: {
                singular: r("warning"),
                plural: r("warnings")
              },
              info: {
                singular: r("information message"),
                plural: r("information messages")
              }
            };
          },
          enumerable: !1,
          configurable: !0
        }), p.prototype.showTooltip = function (e) {
          var t = (this || _global).editor.renderer.$gutterLayer,
            n = t.$annotations[e],
            i = n ? {
              text: Array.from(n.text),
              type: Array.from(n.type)
            } : {
              text: [],
              type: []
            },
            o = t.session.getFoldLine(e);
          if (o && t.$showFoldedAnnotations) {
            for (var r, s = {
                error: [],
                warning: [],
                info: []
              }, a = e + 1; a <= o.end.row; a++) if (t.$annotations[a]) for (var l = 0; l < t.$annotations[a].text.length; l++) {
              var c = t.$annotations[a].type[l];
              s[c].push(t.$annotations[a].text[l]), "error" === c ? r = "error_fold" : "warning" === c && (r = "warning_fold");
            }
            "error_fold" !== r && "warning_fold" !== r || (n = "".concat(p.annotationsToSummaryString(s), " in folded code."), i.text.push(n), i.type.push(r));
          }
          if (0 === i.text.length) return this.hide();
          for (var h = {
              error: [],
              warning: [],
              info: []
            }, d = t.$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon", a = 0; a < i.text.length; a++) {
            var u = "<span class='ace_".concat(i.type[a], " ").concat(d, "' aria-label='").concat(p.annotationLabels[i.type[a].replace("_fold", "")].singular, "' role=img> </span> ").concat(i.text[a]);
            h[i.type[a].replace("_fold", "")].push(u);
          }
          e = [].concat(h.error, h.warning, h.info).join("<br>");
          this.setHtml(e), this.setClassName("ace_gutter-tooltip"), (this || _global).$element.setAttribute("aria-live", "polite"), (this || _global).isOpen || this.setTheme((this || _global).editor.renderer.theme), (this || _global).editor._signal("showGutterTooltip", this || _global), this.show();
        }, p.annotationsToSummaryString = function (e) {
          var t,
            n,
            i = [];
          try {
            for (var o = l(["error", "warning", "info"]), r = o.next(); !r.done; r = o.next()) {
              var s,
                a = r.value;
              e[a].length && (s = 1 === e[a].length ? p.annotationLabels[a].singular : p.annotationLabels[a].plural, i.push("".concat(e[a].length, " ").concat(s)));
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (n = o.return) && n.call(o);
            } finally {
              if (t) throw t.error;
            }
          }
          return i.join(", ");
        };
        var a,
          g = p;
        function p(e) {
          var t = a.call(this || _global, e.container) || this || _global;
          return t.editor = e, t;
        }
        t.GutterTooltip = g;
      }), ace.define("ace/mouse/mouse_event", ["require", "exports", "module", "ace/lib/event", "ace/lib/useragent"], function (e, t, n) {
        "use strict";

        var i = e("../lib/event"),
          o = e("../lib/useragent");
        function r(e, t) {
          (this || _global).domEvent = e, (this || _global).editor = t, (this || _global).x = (this || _global).clientX = e.clientX, (this || _global).y = (this || _global).clientY = e.clientY, (this || _global).$pos = null, (this || _global).$inSelection = null, (this || _global).propagationStopped = !1, (this || _global).defaultPrevented = !1;
        }
        r.prototype.stopPropagation = function () {
          i.stopPropagation((this || _global).domEvent), (this || _global).propagationStopped = !0;
        }, r.prototype.preventDefault = function () {
          i.preventDefault((this || _global).domEvent), (this || _global).defaultPrevented = !0;
        }, r.prototype.stop = function () {
          this.stopPropagation(), this.preventDefault();
        }, r.prototype.getDocumentPosition = function () {
          return (this || _global).$pos || ((this || _global).$pos = (this || _global).editor.renderer.screenToTextCoordinates((this || _global).clientX, (this || _global).clientY)), (this || _global).$pos;
        }, r.prototype.inSelection = function () {
          var e, t;
          return null === (this || _global).$inSelection && ((e = (this || _global).editor.getSelectionRange()).isEmpty() ? (this || _global).$inSelection = !1 : (t = this.getDocumentPosition(), (this || _global).$inSelection = e.contains(t.row, t.column))), (this || _global).$inSelection;
        }, r.prototype.getButton = function () {
          return i.getButton((this || _global).domEvent);
        }, r.prototype.getShiftKey = function () {
          return (this || _global).domEvent.shiftKey;
        }, r.prototype.getAccelKey = function () {
          return o.isMac ? (this || _global).domEvent.metaKey : (this || _global).domEvent.ctrlKey;
        }, t.MouseEvent = r;
      }), ace.define("ace/mouse/dragdrop_handler", ["require", "exports", "module", "ace/lib/dom", "ace/lib/event", "ace/lib/useragent"], function (e, t, n) {
        "use strict";

        var w = e("../lib/dom"),
          S = e("../lib/event"),
          x = e("../lib/useragent");
        function i(t) {
          var n,
            c,
            h,
            e,
            i,
            d,
            o,
            r,
            u,
            g,
            p,
            m = t.editor,
            s = w.createElement("div"),
            a = (s.style.cssText = "top:-100px;position:absolute;z-index:2147483647;opacity:0.5", s.textContent = "\xA0", ["dragWait", "dragWaitEnd", "startDrag", "dragReadyEnd", "onMouseDrag"].forEach(function (e) {
              t[e] = (this || _global)[e];
            }, this || _global), m.on("mousedown", (this || _global).onMouseDown.bind(t)), m.container),
            l = 0;
          function f() {
            var e,
              t,
              n,
              i,
              o,
              r,
              s,
              a,
              l = d;
            d = m.renderer.screenToTextCoordinates(c, h), n = d, t = l, i = Date.now(), e = !t || n.row != t.row, t = !t || n.column != t.column, !g || e || t ? (m.moveCursorToPosition(n), g = i, p = {
              x: c,
              y: h
            }) : 5 < k(p.x, p.y, c, h) ? g = null : 200 <= i - g && (m.renderer.scrollCursorIntoView(), g = null), e = d, t = l, n = Date.now(), i = m.renderer.layerConfig.lineHeight, l = m.renderer.layerConfig.characterWidth, o = m.renderer.scroller.getBoundingClientRect(), o = {
              x: {
                left: c - o.left,
                right: o.right - c
              },
              y: {
                top: h - o.top,
                bottom: o.bottom - h
              }
            }, r = Math.min(o.x.left, o.x.right), s = Math.min(o.y.top, o.y.bottom), a = {
              row: e.row,
              column: e.column
            }, r / l <= 2 && (a.column += o.x.left < o.x.right ? -3 : 2), s / i <= 1 && (a.row += o.y.top < o.y.bottom ? -1 : 1), r = e.row != a.row, l = e.column != a.column, s = !t || e.row != t.row, r || l && !s ? u ? 200 <= n - u && m.renderer.scrollCursorIntoView(a) : u = n : u = null;
          }
          function C() {
            i = m.selection.toOrientedRange(), n = m.session.addMarker(i, "ace_selection", m.getSelectionStyle()), m.clearSelection(), m.isFocused() && m.renderer.$cursorLayer.setBlinking(!1), clearInterval(e), f(), e = setInterval(f, 20), l = 0, S.addListener(document, "mousemove", I);
          }
          function y() {
            clearInterval(e), m.session.removeMarker(n), n = null, m.selection.fromOrientedRange(i), m.isFocused() && !r && m.$resetCursorStyle(), l = 0, g = u = d = i = null, S.removeListener(document, "mousemove", I);
          }
          (this || _global).onDragStart = function (e) {
            var t;
            if ((this || _global).cancelDrag || !a.draggable) return t = this || _global, setTimeout(function () {
              t.startSelect(), t.captureMouse(e);
            }, 0), e.preventDefault();
            i = m.getSelectionRange();
            var n = e.dataTransfer;
            n.effectAllowed = m.getReadOnly() ? "copy" : "copyMove", m.container.appendChild(s), n.setDragImage && n.setDragImage(s, 0, 0), setTimeout(function () {
              m.container.removeChild(s);
            }), n.clearData(), n.setData("Text", m.session.getTextRange()), r = !0, this.setState("drag");
          }, (this || _global).onDragEnd = function (e) {
            a.draggable = !1, r = !1, this.setState(null), m.getReadOnly() || (e = e.dataTransfer.dropEffect, o || "move" != e || m.session.remove(m.getSelectionRange()), m.$resetCursorStyle()), (this || _global).editor.unsetStyle("ace_dragging"), (this || _global).editor.renderer.setCursorStyle("");
          }, (this || _global).onDragEnter = function (e) {
            if (!m.getReadOnly() && b(e.dataTransfer)) return c = e.clientX, h = e.clientY, n || C(), l++, e.dataTransfer.dropEffect = o = A(e), S.preventDefault(e);
          }, (this || _global).onDragOver = function (e) {
            if (!m.getReadOnly() && b(e.dataTransfer)) return c = e.clientX, h = e.clientY, n || (C(), l++), null !== v && (v = null), e.dataTransfer.dropEffect = o = A(e), S.preventDefault(e);
          }, (this || _global).onDragLeave = function (e) {
            if (--l <= 0 && n) return y(), o = null, S.preventDefault(e);
          }, (this || _global).onDrop = function (e) {
            if (d) {
              var t = e.dataTransfer;
              if (r) switch (o) {
                case "move":
                  i = i.contains(d.row, d.column) ? {
                    start: d,
                    end: d
                  } : m.moveText(i, d);
                  break;
                case "copy":
                  i = m.moveText(i, d, !0);
              } else {
                t = t.getData("Text");
                i = {
                  start: d,
                  end: m.session.insert(d, t)
                }, m.focus(), o = null;
              }
              return y(), S.preventDefault(e);
            }
          }, S.addListener(a, "dragstart", (this || _global).onDragStart.bind(t), m), S.addListener(a, "dragend", (this || _global).onDragEnd.bind(t), m), S.addListener(a, "dragenter", (this || _global).onDragEnter.bind(t), m), S.addListener(a, "dragover", (this || _global).onDragOver.bind(t), m), S.addListener(a, "dragleave", (this || _global).onDragLeave.bind(t), m), S.addListener(a, "drop", (this || _global).onDrop.bind(t), m);
          var v = null;
          function I() {
            null == v && (v = setTimeout(function () {
              null != v && n && y();
            }, 20));
          }
          function b(e) {
            e = e.types;
            return !e || Array.prototype.some.call(e, function (e) {
              return "text/plain" == e || "Text" == e;
            });
          }
          function A(e) {
            var t = ["copy", "copymove", "all", "uninitialized"],
              n = x.isMac ? e.altKey : e.ctrlKey,
              i = "uninitialized";
            try {
              i = e.dataTransfer.effectAllowed.toLowerCase();
            } catch (e) {}
            var o = "none";
            return n && 0 <= t.indexOf(i) ? o = "copy" : 0 <= ["move", "copymove", "linkmove", "all", "uninitialized"].indexOf(i) ? o = "move" : 0 <= t.indexOf(i) && (o = "copy"), o;
          }
        }
        function k(e, t, n, i) {
          return Math.sqrt(Math.pow(n - e, 2) + Math.pow(i - t, 2));
        }
        !function () {
          (this || _global).dragWait = function () {
            Date.now() - (this || _global).mousedownEvent.time > (this || _global).editor.getDragDelay() && this.startDrag();
          }, (this || _global).dragWaitEnd = function () {
            (this || _global).editor.container.draggable = !1, this.startSelect((this || _global).mousedownEvent.getDocumentPosition()), this.selectEnd();
          }, (this || _global).dragReadyEnd = function (e) {
            (this || _global).editor.$resetCursorStyle(), (this || _global).editor.unsetStyle("ace_dragging"), (this || _global).editor.renderer.setCursorStyle(""), this.dragWaitEnd();
          }, (this || _global).startDrag = function () {
            (this || _global).cancelDrag = !1;
            var e = (this || _global).editor,
              t = (e.container.draggable = !0, e.renderer.$cursorLayer.setBlinking(!1), e.setStyle("ace_dragging"), x.isWin ? "default" : "move");
            e.renderer.setCursorStyle(t), this.setState("dragReady");
          }, (this || _global).onMouseDrag = function (e) {
            var t = (this || _global).editor.container;
            x.isIE && "dragReady" == (this || _global).state && 3 < k((this || _global).mousedownEvent.x, (this || _global).mousedownEvent.y, (this || _global).x, (this || _global).y) && t.dragDrop(), "dragWait" === (this || _global).state && 0 < k((this || _global).mousedownEvent.x, (this || _global).mousedownEvent.y, (this || _global).x, (this || _global).y) && (t.draggable = !1, this.startSelect((this || _global).mousedownEvent.getDocumentPosition()));
          }, (this || _global).onMouseDown = function (e) {
            var t, n, i;
            (this || _global).$dragEnabled && ((this || _global).mousedownEvent = e, t = (this || _global).editor, n = e.inSelection(), i = e.getButton(), 1 !== (e.domEvent.detail || 1) || 0 !== i || !n || e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey()) || ((this || _global).mousedownEvent.time = Date.now(), "unselectable" in (i = e.domEvent.target || e.domEvent.srcElement) && (i.unselectable = "on"), t.getDragDelay() ? (x.isWebKit && ((this || _global).cancelDrag = !0, t.container.draggable = !0), this.setState("dragWait")) : this.startDrag(), this.captureMouse(e, (this || _global).onMouseDrag.bind(this || _global)), e.defaultPrevented = !0));
          };
        }.call(i.prototype), t.DragdropHandler = i;
      }), ace.define("ace/mouse/touch_handler", ["require", "exports", "module", "ace/mouse/mouse_event", "ace/lib/event", "ace/lib/dom"], function (e, t, n) {
        "use strict";

        var S = e("./mouse_event").MouseEvent,
          i = e("../lib/event"),
          a = e("../lib/dom");
        t.addTouchListeners = function (e, h) {
          var d,
            u,
            g,
            p,
            m,
            t,
            f,
            C,
            r,
            y = "scroll",
            v = 0,
            I = 0,
            b = 0,
            A = 0;
          function o() {
            function t(e) {
              var t,
                n = e.target.getAttribute("action");
              "more" != n && o ? ("paste" == n ? i.readText().then(function (e) {
                h.execCommand(n, e);
              }) : n && ("cut" != n && "copy" != n || (i ? i.writeText(h.getCopyText()) : document.execCommand("copy")), h.execCommand(n)), r.firstChild.style.display = "none", o = !1, "openCommandPallete" != n && h.focus()) : (o = !o, e = h.getCopyText(), t = h.session.getUndoManager().hasUndo(), r.replaceChild(a.buildDom(o ? ["span", !e && ["span", {
                class: "ace_mobile-button",
                action: "selectall"
              }, "Select All"], e && ["span", {
                class: "ace_mobile-button",
                action: "copy"
              }, "Copy"], e && ["span", {
                class: "ace_mobile-button",
                action: "cut"
              }, "Cut"], i && ["span", {
                class: "ace_mobile-button",
                action: "paste"
              }, "Paste"], t && ["span", {
                class: "ace_mobile-button",
                action: "undo"
              }, "Undo"], ["span", {
                class: "ace_mobile-button",
                action: "find"
              }, "Find"], ["span", {
                class: "ace_mobile-button",
                action: "openCommandPallete"
              }, "Palette"]] : ["span"]), r.firstChild));
            }
            var i = window.navigator && window.navigator.clipboard,
              o = !1;
            r = a.buildDom(["div", {
              class: "ace_mobile-menu",
              ontouchstart: function (e) {
                y = "menu", e.stopPropagation(), e.preventDefault(), h.textInput.focus();
              },
              ontouchend: function (e) {
                e.stopPropagation(), e.preventDefault(), t(e);
              },
              onclick: t
            }, ["span"], ["span", {
              class: "ace_mobile-button",
              action: "more"
            }, "..."]], h.container);
          }
          function n() {
            r || o();
            var e = h.selection.cursor,
              e = h.renderer.textToScreenCoordinates(e.row, e.column),
              t = h.renderer.textToScreenCoordinates(0, 0).pageX,
              n = h.renderer.scrollLeft,
              i = h.container.getBoundingClientRect();
            r.style.top = e.pageY - i.top - 3 + "px", e.pageX - i.left < i.width - 70 ? (r.style.left = "", r.style.right = "10px") : (r.style.right = "", r.style.left = t + n - i.left + "px"), r.style.display = "", r.firstChild.style.display = "none", h.on("input", s);
          }
          function s(e) {
            r && (r.style.display = "none"), h.off("input", s);
          }
          function w() {
            m = null, clearTimeout(m);
            var e = h.selection.getRange(),
              t = e.contains(f.row, f.column);
            !e.isEmpty() && t || (h.selection.moveToPosition(f), h.selection.selectWord()), y = "wait", n();
          }
          i.addListener(e, "contextmenu", function (e) {
            C && h.textInput.getElement().focus();
          }, h), i.addListener(e, "touchstart", function (e) {
            var t = e.touches;
            if (m || 1 < t.length) clearTimeout(m), m = null, g = -1, y = "zoom";else {
              C = h.$mouseHandler.isMousePressed = !0;
              var n = h.renderer.layerConfig.lineHeight,
                i = h.renderer.layerConfig.lineHeight,
                o = e.timeStamp,
                r = (p = o, t[0]),
                s = r.clientX,
                r = r.clientY,
                s = (Math.abs(d - s) + Math.abs(u - r) > n && (g = -1), d = e.clientX = s, u = e.clientY = r, b = A = 0, new S(e, h));
              if (f = s.getDocumentPosition(), o - g < 500 && 1 == t.length && !v) I++, e.preventDefault(), e.button = 0, m = null, clearTimeout(m), h.selection.moveToPosition(f), (r = 2 <= I ? h.selection.getLineRange(f.row) : h.session.getBracketRange(f)) && !r.isEmpty() ? h.selection.setRange(r) : h.selection.selectWord(), y = "wait";else {
                I = 0;
                var s = h.selection.cursor,
                  t = h.selection.isEmpty() ? s : h.selection.anchor,
                  r = h.renderer.$cursorLayer.getPixelPosition(s, !0),
                  s = h.renderer.$cursorLayer.getPixelPosition(t, !0),
                  t = h.renderer.scroller.getBoundingClientRect(),
                  a = h.renderer.layerConfig.offset,
                  l = h.renderer.scrollLeft,
                  c = function (e, t) {
                    return (e /= i) * e + (t = t / n - 0.75) * t;
                  };
                if (e.clientX < t.left) return void (y = "zoom");
                r = c(e.clientX - t.left - r.left + l, e.clientY - t.top - r.top + a), c = c(e.clientX - t.left - s.left + l, e.clientY - t.top - s.top + a);
                r < 3.5 && c < 3.5 && (y = c < r ? "cursor" : "anchor"), y = c < 3.5 ? "anchor" : r < 3.5 ? "cursor" : "scroll", m = setTimeout(w, 450);
              }
              g = o;
            }
          }, h), i.addListener(e, "touchend", function (e) {
            C = h.$mouseHandler.isMousePressed = !1, t && clearInterval(t), "zoom" == y ? (y = "", v = 0) : (m ? (h.selection.moveToPosition(f), v = 0, n) : "scroll" == y ? (v += 60, t = setInterval(function () {
              v-- <= 0 && (clearInterval(t), t = null), Math.abs(b) < 0.01 && (b = 0), Math.abs(A) < 0.01 && (A = 0), v < 20 && (b *= 0.9), v < 20 && (A *= 0.9);
              var e = h.session.getScrollTop();
              h.renderer.scrollBy(10 * b, 10 * A), e == h.session.getScrollTop() && (v = 0);
            }, 10), s) : n)(), clearTimeout(m), m = null;
          }, h), i.addListener(e, "touchmove", function (e) {
            m && (clearTimeout(m), m = null);
            var t = e.touches;
            if (!(1 < t.length || "zoom" == y)) {
              var t = t[0],
                n = d - t.clientX,
                i = u - t.clientY;
              if ("wait" == y) {
                if (!(4 < n * n + i * i)) return e.preventDefault();
                y = "cursor";
              }
              d = t.clientX, u = t.clientY, e.clientX = t.clientX, e.clientY = t.clientY;
              var t = e.timeStamp,
                o = t - p;
              p = t, "scroll" == y ? ((t = new S(e, h)).speed = 1, t.wheelX = n, t.wheelY = i, 10 * Math.abs(n) < Math.abs(i) && (n = 0), 10 * Math.abs(i) < Math.abs(n) && (i = 0), 0 != o && (b = n / o, A = i / o), h._emit("mousewheel", t), t.propagationStopped || (b = A = 0)) : (n = new S(e, h).getDocumentPosition(), "cursor" == y ? h.selection.moveCursorToPosition(n) : "anchor" == y && h.selection.setSelectionAnchor(n.row, n.column), h.renderer.scrollCursorIntoView(n), e.preventDefault());
            }
          }, h);
        };
      }), ace.define("ace/mouse/mouse_handler", ["require", "exports", "module", "ace/lib/event", "ace/lib/useragent", "ace/mouse/default_handlers", "ace/mouse/default_gutter_handler", "ace/mouse/mouse_event", "ace/mouse/dragdrop_handler", "ace/mouse/touch_handler", "ace/config"], function (e, t, n) {
        "use strict";

        var h = e("../lib/event"),
          d = e("../lib/useragent"),
          r = e("./default_handlers").DefaultHandlers,
          s = e("./default_gutter_handler").GutterHandler,
          u = e("./mouse_event").MouseEvent,
          a = e("./dragdrop_handler").DragdropHandler,
          l = e("./touch_handler").addTouchListeners,
          e = e("../config"),
          i = (o.prototype.onMouseEvent = function (e, t) {
            (this || _global).editor.session && (this || _global).editor._emit(e, new u(t, (this || _global).editor));
          }, o.prototype.onMouseMove = function (e, t) {
            var n = (this || _global).editor._eventRegistry && (this || _global).editor._eventRegistry.mousemove;
            n && n.length && (this || _global).editor._emit(e, new u(t, (this || _global).editor));
          }, o.prototype.onMouseWheel = function (e, t) {
            var n = new u(t, (this || _global).editor);
            n.speed = 2 * (this || _global).$scrollSpeed, n.wheelX = t.wheelX, n.wheelY = t.wheelY, (this || _global).editor._emit(e, n);
          }, o.prototype.setState = function (e) {
            (this || _global).state = e;
          }, o.prototype.captureMouse = function (e, t) {
            (this || _global).x = e.x, (this || _global).y = e.y, (this || _global).isMousePressed = !0;
            function n(e) {
              if (e) {
                if (d.isWebKit && !e.which && a.releaseMouse) return a.releaseMouse();
                a.x = e.clientX, a.y = e.clientY, t && t(e), a.mouseEvent = new u(e, a.editor), a.$mouseMoved = !0;
              }
            }
            function i(e) {
              r.off("beforeEndOperation", l), clearInterval(c), r.session && o(), a[a.state + "End"] && a[a.state + "End"](e), a.state = "", a.isMousePressed = s.$isMousePressed = !1, s.$keepTextAreaAtCursor && s.$moveTextAreaToCursor(), a.$onCaptureMouseMove = a.releaseMouse = null, e && a.onMouseEvent("mouseup", e), r.endOperation();
            }
            function o() {
              a[a.state] && a[a.state](), a.$mouseMoved = !1;
            }
            var r = (this || _global).editor,
              s = (this || _global).editor.renderer,
              a = (s.$isMousePressed = !0, this || _global);
            if (d.isOldIE && "dblclick" == e.domEvent.type) return setTimeout(function () {
              i(e);
            });
            var l = function (e) {
                a.releaseMouse && r.curOp.command.name && r.curOp.selectionChanged && (a[a.state + "End"] && a[a.state + "End"](), a.state = "", a.releaseMouse());
              },
              c = (r.on("beforeEndOperation", l), r.startOperation({
                command: {
                  name: "mouse"
                }
              }), a.$onCaptureMouseMove = n, a.releaseMouse = h.capture((this || _global).editor.container, n, i), setInterval(o, 20));
          }, o.prototype.cancelContextMenu = function () {
            var t = function (e) {
              e && e.domEvent && "contextmenu" != e.domEvent.type || ((this || _global).editor.off("nativecontextmenu", t), e && e.domEvent && h.stopEvent(e.domEvent));
            }.bind(this || _global);
            setTimeout(t, 10), (this || _global).editor.on("nativecontextmenu", t);
          }, o.prototype.destroy = function () {
            (this || _global).releaseMouse && this.releaseMouse();
          }, o);
        function o(i) {
          function e(e) {
            document.hasFocus && document.hasFocus() && (i.isFocused() || document.activeElement != (i.textInput && i.textInput.getElement())) || window.focus(), i.focus(), setTimeout(function () {
              i.isFocused() || i.focus();
            });
          }
          var o = this || _global,
            t = ((this || _global).editor = i, new r(this || _global), new s(this || _global), new a(this || _global), i.renderer.getMouseEventTarget()),
            n = (h.addListener(t, "click", (this || _global).onMouseEvent.bind(this || _global, "click"), i), h.addListener(t, "mousemove", (this || _global).onMouseMove.bind(this || _global, "mousemove"), i), h.addMultiMouseDownListener([t, i.renderer.scrollBarV && i.renderer.scrollBarV.inner, i.renderer.scrollBarH && i.renderer.scrollBarH.inner, i.textInput && i.textInput.getElement()].filter(Boolean), [400, 300, 250], this || _global, "onMouseEvent", i), h.addMouseWheelListener(i.container, (this || _global).onMouseWheel.bind(this || _global, "mousewheel"), i), l(i.container, i), i.renderer.$gutter);
          h.addListener(n, "mousedown", (this || _global).onMouseEvent.bind(this || _global, "guttermousedown"), i), h.addListener(n, "click", (this || _global).onMouseEvent.bind(this || _global, "gutterclick"), i), h.addListener(n, "dblclick", (this || _global).onMouseEvent.bind(this || _global, "gutterdblclick"), i), h.addListener(n, "mousemove", (this || _global).onMouseEvent.bind(this || _global, "guttermousemove"), i), h.addListener(t, "mousedown", e, i), h.addListener(n, "mousedown", e, i), d.isIE && i.renderer.scrollBarV && (h.addListener(i.renderer.scrollBarV.element, "mousedown", e, i), h.addListener(i.renderer.scrollBarH.element, "mousedown", e, i)), i.on("mousemove", function (e) {
            var t, n;
            o.state || o.$dragDelay || !o.$dragEnabled || (e = i.renderer.screenToTextCoordinates(e.x, e.y), t = i.session.selection.getRange(), n = i.renderer, !t.isEmpty() && t.insideStart(e.row, e.column) ? n.setCursorStyle("default") : n.setCursorStyle(""));
          }, i);
        }
        i.prototype.releaseMouse = null, e.defineOptions(i.prototype, "mouseHandler", {
          scrollSpeed: {
            initialValue: 2
          },
          dragDelay: {
            initialValue: d.isMac ? 150 : 0
          },
          dragEnabled: {
            initialValue: !0
          },
          focusTimeout: {
            initialValue: 0
          },
          tooltipFollowsMouse: {
            initialValue: !0
          }
        }), t.MouseHandler = i;
      }), ace.define("ace/mouse/fold_handler", ["require", "exports", "module", "ace/lib/dom"], function (e, t, n) {
        "use strict";

        var i = e("../lib/dom");
        t.FoldHandler = function (o) {
          o.on("click", function (e) {
            var t = e.getDocumentPosition(),
              n = o.session,
              t = n.getFoldAt(t.row, t.column, 1),
              t = (t && (e.getAccelKey() ? n.removeFold(t) : n.expandFold(t), e.stop()), e.domEvent && e.domEvent.target);
            t && i.hasCssClass(t, "ace_inline_button") && i.hasCssClass(t, "ace_toggle_wrap") && (n.setOption("wrap", !n.getUseWrapMode()), o.renderer.scrollCursorIntoView());
          }), o.on("gutterclick", function (e) {
            var t, n;
            "foldWidgets" == o.renderer.$gutterLayer.getRegion(e) && (t = e.getDocumentPosition().row, (n = o.session).foldWidgets && n.foldWidgets[t] && o.session.onFoldWidgetClick(t, e), o.isFocused() || o.focus(), e.stop());
          }), o.on("gutterdblclick", function (e) {
            var t, n, i;
            "foldWidgets" == o.renderer.$gutterLayer.getRegion(e) && (i = e.getDocumentPosition().row, (n = (n = (t = o.session).getParentFoldRangeData(i, !0)).range || n.firstRange) && (i = n.start.row, (i = t.getFoldAt(i, t.getLine(i).length, 1)) ? t.removeFold(i) : (t.addFold("...", n), o.renderer.scrollCursorIntoView({
              row: n.start.row,
              column: 0
            }))), e.stop());
          });
        };
      }), ace.define("ace/keyboard/keybinding", ["require", "exports", "module", "ace/lib/keys", "ace/lib/event"], function (e, t, n) {
        "use strict";

        var o = e("../lib/keys"),
          l = e("../lib/event");
        function i(e) {
          (this || _global).$editor = e, (this || _global).$data = {
            editor: e
          }, (this || _global).$handlers = [], this.setDefaultHandler(e.commands);
        }
        i.prototype.setDefaultHandler = function (e) {
          this.removeKeyboardHandler((this || _global).$defaultHandler), (this || _global).$defaultHandler = e, this.addKeyboardHandler(e, 0);
        }, i.prototype.setKeyboardHandler = function (e) {
          var t = (this || _global).$handlers;
          if (t[t.length - 1] != e) {
            for (; t[t.length - 1] && t[t.length - 1] != (this || _global).$defaultHandler;) this.removeKeyboardHandler(t[t.length - 1]);
            this.addKeyboardHandler(e, 1);
          }
        }, i.prototype.addKeyboardHandler = function (e, t) {
          var n;
          e && ("function" != typeof e || e.handleKeyboard || (e.handleKeyboard = e), -1 != (n = (this || _global).$handlers.indexOf(e)) && (this || _global).$handlers.splice(n, 1), null == t ? (this || _global).$handlers.push(e) : (this || _global).$handlers.splice(t, 0, e), -1 == n) && e.attach && e.attach((this || _global).$editor);
        }, i.prototype.removeKeyboardHandler = function (e) {
          var t = (this || _global).$handlers.indexOf(e);
          return -1 != t && ((this || _global).$handlers.splice(t, 1), e.detach && e.detach((this || _global).$editor), !0);
        }, i.prototype.getKeyboardHandler = function () {
          return (this || _global).$handlers[(this || _global).$handlers.length - 1];
        }, i.prototype.getStatusText = function () {
          var t = (this || _global).$data,
            n = t.editor;
          return (this || _global).$handlers.map(function (e) {
            return e.getStatusText && e.getStatusText(n, t) || "";
          }).filter(Boolean).join(" ");
        }, i.prototype.$callKeyboardHandlers = function (e, t, n, i) {
          for (var o, r = !1, s = (this || _global).$editor.commands, a = (this || _global).$handlers.length; a-- && !((o = (this || _global).$handlers[a].handleKeyboard((this || _global).$data, e, t, n, i)) && o.command && ((r = "null" == o.command || s.exec(o.command, (this || _global).$editor, o.args, i)) && i && -1 != e && 1 != o.passEvent && 1 != o.command.passEvent && l.stopEvent(i), r)););
          return r || -1 != e || (o = {
            command: "insertstring"
          }, r = s.exec("insertstring", (this || _global).$editor, t)), r && (this || _global).$editor._signal && (this || _global).$editor._signal("keyboardActivity", o), r;
        }, i.prototype.onCommandKey = function (e, t, n) {
          var i = o.keyCodeToString(n);
          return this.$callKeyboardHandlers(t, i, n, e);
        }, i.prototype.onTextInput = function (e) {
          return this.$callKeyboardHandlers(-1, e);
        }, t.KeyBinding = i;
      }), ace.define("ace/lib/bidiutil", ["require", "exports", "module"], function (e, l, t) {
        "use strict";

        var p = 0,
          m = 0,
          f = !1,
          C = !1,
          y = !1,
          v = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]],
          I = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]],
          b = 0,
          A = 1,
          w = 2,
          S = 3,
          x = 4,
          k = 5,
          E = 6,
          T = 7,
          R = 8,
          _ = 9,
          $ = 10,
          L = 11,
          N = 12,
          B = 13,
          M = 14,
          W = 15,
          H = 16,
          G = 17,
          P = 18,
          i = [P, P, P, P, P, P, P, P, P, E, k, E, R, k, P, P, P, P, P, P, P, P, P, P, P, P, P, P, k, k, k, E, R, x, x, L, L, L, x, x, x, x, x, $, _, $, _, _, w, w, w, w, w, w, w, w, w, w, _, x, x, x, x, x, x, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, x, x, x, x, x, x, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, x, x, x, x, P, P, P, P, P, P, k, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, P, _, x, L, L, L, L, x, x, x, x, b, x, x, P, x, x, L, L, w, w, x, b, x, x, x, w, b, x, x, x, x, x],
          o = [R, R, R, R, R, R, R, R, R, R, R, P, P, P, b, A, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, R, k, B, M, W, H, G, _, L, L, L, L, L, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, _, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, R];
        function c(e, t, n, i) {
          var o,
            r,
            s,
            a = p ? I : v,
            l = 0,
            c = -1,
            h = null,
            d = null,
            u = [];
          if (!i) for (h = 0, i = []; h < n; h++) i[h] = F(e[h]);
          for (m = p, y = C = f = !1, d = 0; d < n; d++) {
            if (s = l, u[d] = o = function (e, t, n, i) {
              var o,
                r,
                s,
                a = t[i];
              switch (a) {
                case b:
                case A:
                  f = !1;
                case x:
                case S:
                  return a;
                case w:
                  return f ? S : w;
                case T:
                  return f = !0, A;
                case R:
                  return x;
                case _:
                  return i < 1 || i + 1 >= t.length || (o = n[i - 1]) != w && o != S || (l = t[i + 1]) != w && l != S ? x : (l = f ? S : l) == o ? l : x;
                case $:
                  return (o = 0 < i ? n[i - 1] : k) == w && i + 1 < t.length && t[i + 1] == w ? w : x;
                case L:
                  if (0 < i && n[i - 1] == w) return w;
                  if (f) return x;
                  for (s = i + 1, r = t.length; s < r && t[s] == L;) s++;
                  return s < r && t[s] == w ? w : x;
                case N:
                  for (r = t.length, s = i + 1; s < r && t[s] == N;) s++;
                  if (s < r) {
                    var l = e[i],
                      l = 1425 <= l && l <= 2303 || 64286 == l;
                    if (o = t[s], l && (o == A || o == T)) return A;
                  }
                  return i < 1 || (o = t[i - 1]) == k ? x : n[i - 1];
                case k:
                  return C = !(f = !1), p;
                case E:
                  return y = !0, x;
                case B:
                case M:
                case H:
                case G:
                case W:
                  f = !1;
                case P:
                  return x;
              }
            }(e, i, u, d), s = 240 & (l = a[s][o]), l &= 15, t[d] = r = a[l][5], 0 < s) {
              if (16 == s) for (h = c; h < d; h++) t[h] = 1;
              c = -1;
            }
            if (a[l][6]) -1 == c && (c = d);else if (-1 < c) {
              for (h = c; h < d; h++) t[h] = r;
              c = -1;
            }
            i[d] == k && (t[d] = 0), m |= r;
          }
          if (y) for (h = 0; h < n; h++) if (i[h] == E) {
            t[h] = p;
            for (var g = h - 1; 0 <= g && i[g] == R; g--) t[g] = p;
          }
        }
        function h(e, t, n) {
          if (!(m < e)) if (1 != e || 1 != p || C) for (var i, o, r, s, a = n.length, l = 0; l < a;) {
            if (t[l] >= e) {
              for (i = l + 1; i < a && t[i] >= e;) i++;
              for (o = l, r = i - 1; o < r; o++, r--) s = n[o], n[o] = n[r], n[r] = s;
              l = i;
            }
            l++;
          } else n.reverse();
        }
        function F(e) {
          var t = e.charCodeAt(0),
            n = t >> 8;
          return 0 == n ? 191 < t ? b : i[t] : 5 == n ? /[\u0591-\u05f4]/.test(e) ? A : b : 6 == n ? /[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(e) ? N : /[\u0660-\u0669\u066b-\u066c]/.test(e) ? S : 1642 == t ? L : /[\u06f0-\u06f9]/.test(e) ? w : T : 32 == n && t <= 8287 ? o[255 & t] : 254 == n && 65136 <= t ? T : x;
        }
        l.L = b, l.R = A, l.EN = w, l.ON_R = 3, l.AN = 4, l.R_H = 5, l.B = 6, l.RLE = 7, l.DOT = "\xB7", l.doBidiReorder = function (e, t, n) {
          if (e.length < 2) return {};
          var i = e.split(""),
            o = new Array(i.length),
            r = new Array(i.length),
            s = [];
          p = n ? 1 : 0, c(i, s, i.length, t);
          for (var a = 0; a < o.length; o[a] = a, a++);
          h(2, s, o), h(1, s, o);
          for (a = 0; a < o.length - 1; a++) t[a] === S ? s[a] = l.AN : s[a] === A && (t[a] > T && t[a] < B || t[a] === x || t[a] === P) ? s[a] = l.ON_R : 0 < a && "\u0644" === i[a - 1] && /\u0622|\u0623|\u0625|\u0627/.test(i[a]) && (s[a - 1] = s[a] = l.R_H, a++);
          i[i.length - 1] === l.DOT && (s[i.length - 1] = l.B), "\u202B" === i[0] && (s[0] = l.RLE);
          for (a = 0; a < o.length; a++) r[a] = s[o[a]];
          return {
            logicalFromVisual: o,
            bidiLevels: r
          };
        }, l.hasBidiCharacters = function (e, t) {
          for (var n = !1, i = 0; i < e.length; i++) t[i] = F(e.charAt(i)), n || t[i] != A && t[i] != T && t[i] != S || (n = !0);
          return n;
        }, l.getVisualFromLogicalIdx = function (e, t) {
          for (var n = 0; n < t.logicalFromVisual.length; n++) if (t.logicalFromVisual[n] == e) return n;
          return 0;
        };
      }), ace.define("ace/bidihandler", ["require", "exports", "module", "ace/lib/bidiutil", "ace/lib/lang"], function (e, t, n) {
        "use strict";

        var a = e("./lib/bidiutil"),
          s = e("./lib/lang"),
          i = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\u202B]/;
        function o(e) {
          (this || _global).session = e, (this || _global).bidiMap = {}, (this || _global).currentRow = null, (this || _global).bidiUtil = a, (this || _global).charWidths = [], (this || _global).EOL = "\xAC", (this || _global).showInvisibles = !0, (this || _global).isRtlDir = !1, (this || _global).$isRtl = !1, (this || _global).line = "", (this || _global).wrapIndent = 0, (this || _global).EOF = "\xB6", (this || _global).RLE = "\u202B", (this || _global).contentWidth = 0, (this || _global).fontMetrics = null, (this || _global).rtlLineOffset = 0, (this || _global).wrapOffset = 0, (this || _global).isMoveLeftOperation = !1, (this || _global).seenBidi = i.test(e.getValue());
        }
        o.prototype.isBidiRow = function (e, t, n) {
          return !!(this || _global).seenBidi && (e !== (this || _global).currentRow && ((this || _global).currentRow = e, this.updateRowLine(t, n), this.updateBidiMap()), (this || _global).bidiMap.bidiLevels);
        }, o.prototype.onChange = function (e) {
          (this || _global).seenBidi ? (this || _global).currentRow = null : "insert" == e.action && i.test(e.lines.join("\n")) && ((this || _global).seenBidi = !0, (this || _global).currentRow = null);
        }, o.prototype.getDocumentRow = function () {
          var e = 0,
            t = (this || _global).session.$screenRowCache;
          return e = t.length && 0 <= (t = (this || _global).session.$getRowCacheIndex(t, (this || _global).currentRow)) ? (this || _global).session.$docRowCache[t] : e;
        }, o.prototype.getSplitIndex = function () {
          var e = 0,
            t = (this || _global).session.$screenRowCache;
          if (t.length) for (var n, i = (this || _global).session.$getRowCacheIndex(t, (this || _global).currentRow); 0 < (this || _global).currentRow - e && (n = (this || _global).session.$getRowCacheIndex(t, (this || _global).currentRow - e - 1)) === i;) i = n, e++;else e = (this || _global).currentRow;
          return e;
        }, o.prototype.updateRowLine = function (e, t) {
          var n,
            i = (e = void 0 === e ? this.getDocumentRow() : e) === (this || _global).session.getLength() - 1 ? (this || _global).EOF : (this || _global).EOL,
            o = ((this || _global).wrapIndent = 0, (this || _global).line = (this || _global).session.getLine(e), (this || _global).isRtlDir = (this || _global).$isRtl || (this || _global).line.charAt(0) === (this || _global).RLE, (!(this || _global).session.$useWrapMode || (e = (this || _global).session.$wrapData[e]) && (0 < (t = void 0 === t ? this.getSplitIndex() : t) && e.length ? ((this || _global).wrapIndent = e.indent, (this || _global).wrapOffset = (this || _global).wrapIndent * (this || _global).charWidths[a.L], (this || _global).line = t < e.length ? (this || _global).line.substring(e[t - 1], e[t]) : (this || _global).line.substring(e[e.length - 1])) : (this || _global).line = (this || _global).line.substring(0, e[t]), t == e.length)) && ((this || _global).line += (this || _global).showInvisibles ? i : a.DOT), (this || _global).session),
            r = 0;
          (this || _global).line = (this || _global).line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g, function (e, t) {
            return "\t" === e || o.isFullWidth(e.charCodeAt(0)) ? (n = "\t" === e ? o.getScreenTabSize(t + r) : 2, r += n - 1, s.stringRepeat(a.DOT, n)) : e;
          }), (this || _global).isRtlDir && ((this || _global).fontMetrics.$main.textContent = (this || _global).line.charAt((this || _global).line.length - 1) == a.DOT ? (this || _global).line.substr(0, (this || _global).line.length - 1) : (this || _global).line, (this || _global).rtlLineOffset = (this || _global).contentWidth - (this || _global).fontMetrics.$main.getBoundingClientRect().width);
        }, o.prototype.updateBidiMap = function () {
          var e = [];
          a.hasBidiCharacters((this || _global).line, e) || (this || _global).isRtlDir ? (this || _global).bidiMap = a.doBidiReorder((this || _global).line, e, (this || _global).isRtlDir) : (this || _global).bidiMap = {};
        }, o.prototype.markAsDirty = function () {
          (this || _global).currentRow = null;
        }, o.prototype.updateCharacterWidths = function (e) {
          var t;
          (this || _global).characterWidth !== e.$characterSize.width && ((this || _global).fontMetrics = e, t = (this || _global).characterWidth = e.$characterSize.width, e = e.$measureCharWidth("\u05D4"), (this || _global).charWidths[a.L] = (this || _global).charWidths[a.EN] = (this || _global).charWidths[a.ON_R] = t, (this || _global).charWidths[a.R] = (this || _global).charWidths[a.AN] = e, (this || _global).charWidths[a.R_H] = 0.45 * e, (this || _global).charWidths[a.B] = (this || _global).charWidths[a.RLE] = 0, (this || _global).currentRow = null);
        }, o.prototype.setShowInvisibles = function (e) {
          (this || _global).showInvisibles = e, (this || _global).currentRow = null;
        }, o.prototype.setEolChar = function (e) {
          (this || _global).EOL = e;
        }, o.prototype.setContentWidth = function (e) {
          (this || _global).contentWidth = e;
        }, o.prototype.isRtlLine = function (e) {
          return !!(this || _global).$isRtl || (null != e ? (this || _global).session.getLine(e).charAt(0) == (this || _global).RLE : (this || _global).isRtlDir);
        }, o.prototype.setRtlDirection = function (e, t) {
          for (var n = e.getCursorPosition(), i = e.selection.getSelectionAnchor().row; i <= n.row; i++) t || e.session.getLine(i).charAt(0) !== e.session.$bidiHandler.RLE ? t && e.session.getLine(i).charAt(0) !== e.session.$bidiHandler.RLE && e.session.doc.insert({
            column: 0,
            row: i
          }, e.session.$bidiHandler.RLE) : e.session.doc.removeInLine(i, 0, 1);
        }, o.prototype.getPosLeft = function (e) {
          e -= (this || _global).wrapIndent;
          var t = (this || _global).line.charAt(0) === (this || _global).RLE ? 1 : 0,
            n = t < e ? (this || _global).session.getOverwrite() ? e : e - 1 : t,
            i = a.getVisualFromLogicalIdx(n, (this || _global).bidiMap),
            o = (this || _global).bidiMap.bidiLevels,
            r = 0;
          !(this || _global).session.getOverwrite() && e <= t && o[i] % 2 != 0 && i++;
          for (var s = 0; s < i; s++) r += (this || _global).charWidths[o[s]];
          return !(this || _global).session.getOverwrite() && t < e && o[i] % 2 == 0 && (r += (this || _global).charWidths[o[i]]), (this || _global).wrapIndent && (r += (this || _global).isRtlDir ? -1 * (this || _global).wrapOffset : (this || _global).wrapOffset), (this || _global).isRtlDir && (r += (this || _global).rtlLineOffset), r;
        }, o.prototype.getSelections = function (e, t) {
          var n,
            i = (this || _global).bidiMap,
            o = i.bidiLevels,
            r = [],
            s = 0,
            a = Math.min(e, t) - (this || _global).wrapIndent,
            l = Math.max(e, t) - (this || _global).wrapIndent,
            c = !1,
            h = !1,
            d = 0;
          (this || _global).wrapIndent && (s += (this || _global).isRtlDir ? -1 * (this || _global).wrapOffset : (this || _global).wrapOffset);
          for (var u, g = 0; g < o.length; g++) u = i.logicalFromVisual[g], n = o[g], (c = a <= u && u < l) && !h ? d = s : !c && h && r.push({
            left: d,
            width: s - d
          }), s += (this || _global).charWidths[n], h = c;
          if (c && g === o.length && r.push({
            left: d,
            width: s - d
          }), (this || _global).isRtlDir) for (var p = 0; p < r.length; p++) r[p].left += (this || _global).rtlLineOffset;
          return r;
        }, o.prototype.offsetToCol = function (e) {
          (this || _global).isRtlDir && (e -= (this || _global).rtlLineOffset);
          var t = 0,
            e = Math.max(e, 0),
            n = 0,
            i = 0,
            o = (this || _global).bidiMap.bidiLevels,
            r = (this || _global).charWidths[o[i]];
          for ((this || _global).wrapIndent && (e -= (this || _global).isRtlDir ? -1 * (this || _global).wrapOffset : (this || _global).wrapOffset); n + r / 2 < e;) {
            if (n += r, i === o.length - 1) {
              r = 0;
              break;
            }
            r = (this || _global).charWidths[o[++i]];
          }
          return 0 === (t = 0 < i && o[i - 1] % 2 != 0 && o[i] % 2 == 0 ? (e < n && i--, (this || _global).bidiMap.logicalFromVisual[i]) : 0 < i && o[i - 1] % 2 == 0 && o[i] % 2 != 0 ? 1 + (n < e ? (this || _global).bidiMap.logicalFromVisual[i] : (this || _global).bidiMap.logicalFromVisual[i - 1]) : (this || _global).isRtlDir && i === o.length - 1 && 0 === r && o[i - 1] % 2 == 0 || !(this || _global).isRtlDir && 0 === i && o[i] % 2 != 0 ? 1 + (this || _global).bidiMap.logicalFromVisual[i] : (0 < i && o[i - 1] % 2 != 0 && 0 !== r && i--, (this || _global).bidiMap.logicalFromVisual[i])) && (this || _global).isRtlDir && t++, t + (this || _global).wrapIndent;
        }, t.BidiHandler = o;
      }), ace.define("ace/selection", ["require", "exports", "module", "ace/lib/oop", "ace/lib/lang", "ace/lib/event_emitter", "ace/range"], function (e, t, n) {
        "use strict";

        function i(e) {
          (this || _global).session = e, (this || _global).doc = e.getDocument(), this.clearSelection(), (this || _global).cursor = (this || _global).lead = (this || _global).doc.createAnchor(0, 0), (this || _global).anchor = (this || _global).doc.createAnchor(0, 0), (this || _global).$silent = !1;
          var t = this || _global;
          (this || _global).cursor.on("change", function (e) {
            t.$cursorChanged = !0, t.$silent || t._emit("changeCursor"), t.$isEmpty || t.$silent || t._emit("changeSelection"), t.$keepDesiredColumnOnChange || e.old.column == e.value.column || (t.$desiredColumn = null);
          }), (this || _global).anchor.on("change", function () {
            t.$anchorChanged = !0, t.$isEmpty || t.$silent || t._emit("changeSelection");
          });
        }
        var o = e("./lib/oop"),
          r = e("./lib/lang"),
          s = e("./lib/event_emitter").EventEmitter,
          a = e("./range").Range;
        !function () {
          o.implement(this || _global, s), (this || _global).isEmpty = function () {
            return (this || _global).$isEmpty || (this || _global).anchor.row == (this || _global).lead.row && (this || _global).anchor.column == (this || _global).lead.column;
          }, (this || _global).isMultiLine = function () {
            return !(this || _global).$isEmpty && (this || _global).anchor.row != (this || _global).cursor.row;
          }, (this || _global).getCursor = function () {
            return (this || _global).lead.getPosition();
          }, (this || _global).setAnchor = function (e, t) {
            (this || _global).$isEmpty = !1, (this || _global).anchor.setPosition(e, t);
          }, (this || _global).setSelectionAnchor = (this || _global).setAnchor, (this || _global).getAnchor = function () {
            return (this || _global).$isEmpty ? this.getSelectionLead() : (this || _global).anchor.getPosition();
          }, (this || _global).getSelectionAnchor = (this || _global).getAnchor, (this || _global).getSelectionLead = function () {
            return (this || _global).lead.getPosition();
          }, (this || _global).isBackwards = function () {
            var e = (this || _global).anchor,
              t = (this || _global).lead;
            return e.row > t.row || e.row == t.row && e.column > t.column;
          }, (this || _global).getRange = function () {
            var e = (this || _global).anchor,
              t = (this || _global).lead;
            return (this || _global).$isEmpty ? a.fromPoints(t, t) : this.isBackwards() ? a.fromPoints(t, e) : a.fromPoints(e, t);
          }, (this || _global).clearSelection = function () {
            (this || _global).$isEmpty || ((this || _global).$isEmpty = !0, this._emit("changeSelection"));
          }, (this || _global).selectAll = function () {
            this.$setSelection(0, 0, Number.MAX_VALUE, Number.MAX_VALUE);
          }, (this || _global).setRange = (this || _global).setSelectionRange = function (e, t) {
            var n = t ? e.end : e.start,
              t = t ? e.start : e.end;
            this.$setSelection(n.row, n.column, t.row, t.column);
          }, (this || _global).$setSelection = function (e, t, n, i) {
            var o, r;
            !(this || _global).$silent && (o = (this || _global).$isEmpty, r = (this || _global).inMultiSelectMode, (this || _global).$silent = !0, (this || _global).$cursorChanged = (this || _global).$anchorChanged = !1, (this || _global).anchor.setPosition(e, t), (this || _global).cursor.setPosition(n, i), (this || _global).$isEmpty = !a.comparePoints((this || _global).anchor, (this || _global).cursor), (this || _global).$silent = !1, (this || _global).$cursorChanged && this._emit("changeCursor"), (this || _global).$cursorChanged || (this || _global).$anchorChanged || o != (this || _global).$isEmpty || r) && this._emit("changeSelection");
          }, (this || _global).$moveSelection = function (e) {
            var t = (this || _global).lead;
            (this || _global).$isEmpty && this.setSelectionAnchor(t.row, t.column), e.call(this || _global);
          }, (this || _global).selectTo = function (e, t) {
            this.$moveSelection(function () {
              this.moveCursorTo(e, t);
            });
          }, (this || _global).selectToPosition = function (e) {
            this.$moveSelection(function () {
              this.moveCursorToPosition(e);
            });
          }, (this || _global).moveTo = function (e, t) {
            this.clearSelection(), this.moveCursorTo(e, t);
          }, (this || _global).moveToPosition = function (e) {
            this.clearSelection(), this.moveCursorToPosition(e);
          }, (this || _global).selectUp = function () {
            this.$moveSelection((this || _global).moveCursorUp);
          }, (this || _global).selectDown = function () {
            this.$moveSelection((this || _global).moveCursorDown);
          }, (this || _global).selectRight = function () {
            this.$moveSelection((this || _global).moveCursorRight);
          }, (this || _global).selectLeft = function () {
            this.$moveSelection((this || _global).moveCursorLeft);
          }, (this || _global).selectLineStart = function () {
            this.$moveSelection((this || _global).moveCursorLineStart);
          }, (this || _global).selectLineEnd = function () {
            this.$moveSelection((this || _global).moveCursorLineEnd);
          }, (this || _global).selectFileEnd = function () {
            this.$moveSelection((this || _global).moveCursorFileEnd);
          }, (this || _global).selectFileStart = function () {
            this.$moveSelection((this || _global).moveCursorFileStart);
          }, (this || _global).selectWordRight = function () {
            this.$moveSelection((this || _global).moveCursorWordRight);
          }, (this || _global).selectWordLeft = function () {
            this.$moveSelection((this || _global).moveCursorWordLeft);
          }, (this || _global).getWordRange = function (e, t) {
            var n;
            return void 0 === t && (e = (n = e || (this || _global).lead).row, t = n.column), (this || _global).session.getWordRange(e, t);
          }, (this || _global).selectWord = function () {
            this.setSelectionRange(this.getWordRange());
          }, (this || _global).selectAWord = function () {
            var e = this.getCursor(),
              e = (this || _global).session.getAWordRange(e.row, e.column);
            this.setSelectionRange(e);
          }, (this || _global).getLineRange = function (e, t) {
            var e = "number" == typeof e ? e : (this || _global).lead.row,
              n = (this || _global).session.getFoldLine(e),
              n = n ? (e = n.start.row, n.end.row) : e;
            return !0 === t ? new a(e, 0, n, (this || _global).session.getLine(n).length) : new a(e, 0, n + 1, 0);
          }, (this || _global).selectLine = function () {
            this.setSelectionRange(this.getLineRange());
          }, (this || _global).moveCursorUp = function () {
            this.moveCursorBy(-1, 0);
          }, (this || _global).moveCursorDown = function () {
            this.moveCursorBy(1, 0);
          }, (this || _global).wouldMoveIntoSoftTab = function (e, t, n) {
            var i = e.column,
              o = e.column + t;
            return n < 0 && (i = e.column - t, o = e.column), (this || _global).session.isTabStop(e) && (this || _global).doc.getLine(e.row).slice(i, o).split(" ").length - 1 == t;
          }, (this || _global).moveCursorLeft = function () {
            var e,
              t = (this || _global).lead.getPosition();
            (e = (this || _global).session.getFoldAt(t.row, t.column, -1)) ? this.moveCursorTo(e.start.row, e.start.column) : 0 === t.column ? 0 < t.row && this.moveCursorTo(t.row - 1, (this || _global).doc.getLine(t.row - 1).length) : (e = (this || _global).session.getTabSize(), this.wouldMoveIntoSoftTab(t, e, -1) && !(this || _global).session.getNavigateWithinSoftTabs() ? this.moveCursorBy(0, -e) : this.moveCursorBy(0, -1));
          }, (this || _global).moveCursorRight = function () {
            var e,
              t = (this || _global).lead.getPosition();
            (e = (this || _global).session.getFoldAt(t.row, t.column, 1)) ? this.moveCursorTo(e.end.row, e.end.column) : (this || _global).lead.column == (this || _global).doc.getLine((this || _global).lead.row).length ? (this || _global).lead.row < (this || _global).doc.getLength() - 1 && this.moveCursorTo((this || _global).lead.row + 1, 0) : (e = (this || _global).session.getTabSize(), t = (this || _global).lead, this.wouldMoveIntoSoftTab(t, e, 1) && !(this || _global).session.getNavigateWithinSoftTabs() ? this.moveCursorBy(0, e) : this.moveCursorBy(0, 1));
          }, (this || _global).moveCursorLineStart = function () {
            var e = (this || _global).lead.row,
              t = (this || _global).lead.column,
              n = (this || _global).session.documentToScreenRow(e, t),
              n = (this || _global).session.screenToDocumentPosition(n, 0),
              e = (this || _global).session.getDisplayLine(e, null, n.row, n.column).match(/^\s*/);
            e[0].length == t || (this || _global).session.$useEmacsStyleLineStart || (n.column += e[0].length), this.moveCursorToPosition(n);
          }, (this || _global).moveCursorLineEnd = function () {
            var e,
              t = (this || _global).lead,
              t = (this || _global).session.getDocumentLastRowColumnPosition(t.row, t.column);
            (this || _global).lead.column == t.column && (e = (this || _global).session.getLine(t.row), t.column == e.length) && 0 < (e = e.search(/\s+$/)) && (t.column = e), this.moveCursorTo(t.row, t.column);
          }, (this || _global).moveCursorFileEnd = function () {
            var e = (this || _global).doc.getLength() - 1,
              t = (this || _global).doc.getLine(e).length;
            this.moveCursorTo(e, t);
          }, (this || _global).moveCursorFileStart = function () {
            this.moveCursorTo(0, 0);
          }, (this || _global).moveCursorLongWordRight = function () {
            var e = (this || _global).lead.row,
              t = (this || _global).lead.column,
              n = (this || _global).doc.getLine(e),
              i = n.substring(t),
              o = ((this || _global).session.nonTokenRe.lastIndex = 0, (this || _global).session.tokenRe.lastIndex = 0, (this || _global).session.getFoldAt(e, t, 1));
            o ? this.moveCursorTo(o.end.row, o.end.column) : ((this || _global).session.nonTokenRe.exec(i) && (t += (this || _global).session.nonTokenRe.lastIndex, (this || _global).session.nonTokenRe.lastIndex = 0, i = n.substring(t)), t >= n.length ? (this.moveCursorTo(e, n.length), this.moveCursorRight(), e < (this || _global).doc.getLength() - 1 && this.moveCursorWordRight()) : ((this || _global).session.tokenRe.exec(i) && (t += (this || _global).session.tokenRe.lastIndex, (this || _global).session.tokenRe.lastIndex = 0), this.moveCursorTo(e, t)));
          }, (this || _global).moveCursorLongWordLeft = function () {
            var e,
              t = (this || _global).lead.row,
              n = (this || _global).lead.column;
            (e = (this || _global).session.getFoldAt(t, n, -1)) ? this.moveCursorTo(e.start.row, e.start.column) : (null == (e = (this || _global).session.getFoldStringAt(t, n, -1)) && (e = (this || _global).doc.getLine(t).substring(0, n)), e = r.stringReverse(e), (this || _global).session.nonTokenRe.lastIndex = 0, (this || _global).session.tokenRe.lastIndex = 0, (this || _global).session.nonTokenRe.exec(e) && (n -= (this || _global).session.nonTokenRe.lastIndex, e = e.slice((this || _global).session.nonTokenRe.lastIndex), (this || _global).session.nonTokenRe.lastIndex = 0), n <= 0 ? (this.moveCursorTo(t, 0), this.moveCursorLeft(), 0 < t && this.moveCursorWordLeft()) : ((this || _global).session.tokenRe.exec(e) && (n -= (this || _global).session.tokenRe.lastIndex, (this || _global).session.tokenRe.lastIndex = 0), this.moveCursorTo(t, n)));
          }, (this || _global).$shortWordEndIndex = function (e) {
            var t,
              n = 0,
              i = /\s/,
              o = (this || _global).session.tokenRe;
            if (o.lastIndex = 0, (this || _global).session.tokenRe.exec(e)) n = (this || _global).session.tokenRe.lastIndex;else {
              for (; (t = e[n]) && i.test(t);) n++;
              if (n < 1) for (o.lastIndex = 0; (t = e[n]) && !o.test(t);) if (o.lastIndex = 0, n++, i.test(t)) {
                if (2 < n) {
                  n--;
                  break;
                }
                for (; (t = e[n]) && i.test(t);) n++;
                if (2 < n) break;
              }
            }
            return o.lastIndex = 0, n;
          }, (this || _global).moveCursorShortWordRight = function () {
            var e = (this || _global).lead.row,
              t = (this || _global).lead.column,
              n = (this || _global).doc.getLine(e),
              i = n.substring(t),
              o = (this || _global).session.getFoldAt(e, t, 1);
            if (o) return this.moveCursorTo(o.end.row, o.end.column);
            if (t == n.length) {
              for (var r = (this || _global).doc.getLength(); i = (this || _global).doc.getLine(++e), e < r && /^\s*$/.test(i););
              /^\s+/.test(i) || (i = ""), t = 0;
            }
            o = this.$shortWordEndIndex(i);
            this.moveCursorTo(e, t + o);
          }, (this || _global).moveCursorShortWordLeft = function () {
            var e = (this || _global).lead.row,
              t = (this || _global).lead.column;
            if (i = (this || _global).session.getFoldAt(e, t, -1)) return this.moveCursorTo(i.start.row, i.start.column);
            var n = (this || _global).session.getLine(e).substring(0, t);
            if (0 === t) {
              for (; n = (this || _global).doc.getLine(--e), 0 < e && /^\s*$/.test(n););
              t = n.length, /\s+$/.test(n) || (n = "");
            }
            var i = r.stringReverse(n),
              i = this.$shortWordEndIndex(i);
            return this.moveCursorTo(e, t - i);
          }, (this || _global).moveCursorWordRight = function () {
            (this || _global).session.$selectLongWords ? this.moveCursorLongWordRight() : this.moveCursorShortWordRight();
          }, (this || _global).moveCursorWordLeft = function () {
            (this || _global).session.$selectLongWords ? this.moveCursorLongWordLeft() : this.moveCursorShortWordLeft();
          }, (this || _global).moveCursorBy = function (e, t) {
            var n,
              i = (this || _global).session.documentToScreenPosition((this || _global).lead.row, (this || _global).lead.column),
              o = (0 === t && (0 !== e && ((this || _global).session.$bidiHandler.isBidiRow(i.row, (this || _global).lead.row) ? (n = (this || _global).session.$bidiHandler.getPosLeft(i.column), i.column = Math.round(n / (this || _global).session.$bidiHandler.charWidths[0])) : n = i.column * (this || _global).session.$bidiHandler.charWidths[0]), (this || _global).$desiredColumn ? i.column = (this || _global).$desiredColumn : (this || _global).$desiredColumn = i.column), 0 != e && (this || _global).session.lineWidgets && (this || _global).session.lineWidgets[(this || _global).lead.row] && (o = (this || _global).session.lineWidgets[(this || _global).lead.row], e < 0 ? e -= o.rowsAbove || 0 : 0 < e && (e += o.rowCount - (o.rowsAbove || 0))), (this || _global).session.screenToDocumentPosition(i.row + e, i.column, n));
            0 !== e && 0 === t && o.row === (this || _global).lead.row && (o.column, (this || _global).lead.column), this.moveCursorTo(o.row, o.column + t, 0 === t);
          }, (this || _global).moveCursorToPosition = function (e) {
            this.moveCursorTo(e.row, e.column);
          }, (this || _global).moveCursorTo = function (e, t, n) {
            var i = (this || _global).session.getFoldAt(e, t, 1),
              i = (i && (e = i.start.row, t = i.start.column), (this || _global).$keepDesiredColumnOnChange = !0, (this || _global).session.getLine(e));
            /[\uDC00-\uDFFF]/.test(i.charAt(t)) && i.charAt(t - 1) && ((this || _global).lead.row == e && (this || _global).lead.column == t + 1 ? t -= 1 : t += 1), (this || _global).lead.setPosition(e, t), (this || _global).$keepDesiredColumnOnChange = !1, n || ((this || _global).$desiredColumn = null);
          }, (this || _global).moveCursorToScreen = function (e, t, n) {
            e = (this || _global).session.screenToDocumentPosition(e, t);
            this.moveCursorTo(e.row, e.column, n);
          }, (this || _global).detach = function () {
            (this || _global).lead.detach(), (this || _global).anchor.detach();
          }, (this || _global).fromOrientedRange = function (e) {
            this.setSelectionRange(e, e.cursor == e.start), (this || _global).$desiredColumn = e.desiredColumn || (this || _global).$desiredColumn;
          }, (this || _global).toOrientedRange = function (e) {
            var t = this.getRange();
            return e ? (e.start.column = t.start.column, e.start.row = t.start.row, e.end.column = t.end.column, e.end.row = t.end.row) : e = t, e.cursor = this.isBackwards() ? e.start : e.end, e.desiredColumn = (this || _global).$desiredColumn, e;
          }, (this || _global).getRangeOfMovements = function (e) {
            var t = this.getCursor();
            try {
              e(this || _global);
              var n = this.getCursor();
              return a.fromPoints(t, n);
            } catch (e) {
              return a.fromPoints(t, t);
            } finally {
              this.moveCursorToPosition(t);
            }
          }, (this || _global).toJSON = function () {
            var e;
            return (this || _global).rangeCount ? e = (this || _global).ranges.map(function (e) {
              var t = e.clone();
              return t.isBackwards = e.cursor == e.start, t;
            }) : (e = this.getRange()).isBackwards = this.isBackwards(), e;
          }, (this || _global).fromJSON = function (e) {
            if (null == e.start) {
              if ((this || _global).rangeList && 1 < e.length) {
                this.toSingleRange(e[0]);
                for (var t = e.length; t--;) {
                  var n = a.fromPoints(e[t].start, e[t].end);
                  e[t].isBackwards && (n.cursor = n.start), this.addRange(n, !0);
                }
                return;
              }
              e = e[0];
            }
            (this || _global).rangeList && this.toSingleRange(e), this.setSelectionRange(e, e.isBackwards);
          }, (this || _global).isEqual = function (e) {
            if ((e.length || (this || _global).rangeCount) && e.length != (this || _global).rangeCount) return !1;
            if (!e.length || !(this || _global).ranges) return this.getRange().isEqual(e);
            for (var t = (this || _global).ranges.length; t--;) if (!(this || _global).ranges[t].isEqual(e[t])) return !1;
            return !0;
          };
        }.call(i.prototype), t.Selection = i;
      }), ace.define("ace/tokenizer", ["require", "exports", "module", "ace/config"], function (e, t, n) {
        "use strict";

        var e = e("./config"),
          y = 2000,
          i = (o.prototype.$setMaxTokenCount = function (e) {
            y = 0 | e;
          }, o.prototype.$applyToken = function (e) {
            var t = (this || _global).splitRegex.exec(e).slice(1),
              n = (this || _global).token.apply(this || _global, t);
            if ("string" == typeof n) return [{
              type: n,
              value: e
            }];
            for (var i = [], o = 0, r = n.length; o < r; o++) t[o] && (i[i.length] = {
              type: n[o],
              value: t[o]
            });
            return i;
          }, o.prototype.$arrayTokens = function (e) {
            if (!e) return [];
            var t = (this || _global).splitRegex.exec(e);
            if (!t) return "text";
            for (var n = [], i = (this || _global).tokenArray, o = 0, r = i.length; o < r; o++) t[o + 1] && (n[n.length] = {
              type: i[o],
              value: t[o + 1]
            });
            return n;
          }, o.prototype.removeCapturingGroups = function (e) {
            return e.replace(/\\.|\[(?:\\.|[^\\\]])*|\(\?[:=!<]|(\()/g, function (e, t) {
              return t ? "(?:" : e;
            });
          }, o.prototype.createSplitterRegexp = function (e, t) {
            var s, a, l;
            return "$" != (e = "^" != (e = -1 != e.indexOf("(?=") && (s = 0, a = !1, l = {}, e.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function (e, t, n, i, o, r) {
              return a ? a = "]" != o : o ? a = !0 : i ? (s == l.stack && (l.end = r + 1, l.stack = -1), s--) : n && (s++, 1 != n.length) && (l.stack = s, l.start = r), e;
            }), null != l.end) && /^\)*$/.test(e.substr(l.end)) ? e.substring(0, l.start) + e.substr(l.end) : e).charAt(0) ? "^" + e : e).charAt(e.length - 1) && (e += "$"), new RegExp(e, (t || "").replace("g", ""));
          }, o.prototype.getLineTokens = function (e, t) {
            t && "string" != typeof t ? "#tmp" === (t = (n = t.slice(0))[0]) && (n.shift(), t = n.shift()) : n = [];
            for (var n, i, o = t || "start", r = (r = (this || _global).states[o]) || (this || _global).states[o = "start"], s = (this || _global).matchMappings[o], a = (this || _global).regExps[o], l = [], c = a.lastIndex = 0, h = 0, d = {
                type: null,
                value: ""
              }; i = a.exec(e);) {
              var u,
                g = s.defaultToken,
                p = null,
                m = i[0],
                f = a.lastIndex;
              f - m.length > c && (u = e.substring(c, f - m.length), d.type == g ? d.value += u : (d.type && l.push(d), d = {
                type: g,
                value: u
              }));
              for (var C = 0; C < i.length - 2; C++) if (void 0 !== i[C + 1]) {
                g = (p = r[s[C]]).onMatch ? p.onMatch(m, o, n, e) : p.token, p.next && (o = "string" == typeof p.next ? p.next : p.next(o, n), (r = (this || _global).states[o]) || (this.reportError("state doesn't exist", o), r = (this || _global).states[o = "start"]), s = (this || _global).matchMappings[o], (a = (this || _global).regExps[o]).lastIndex = c = f), p.consumeLineEnd && (c = f);
                break;
              }
              if (m) if ("string" == typeof g) p && !1 === p.merge || d.type !== g ? (d.type && l.push(d), d = {
                type: g,
                value: m
              }) : d.value += m;else if (g) {
                d.type && l.push(d);
                for (d = {
                  type: null,
                  value: ""
                }, C = 0; C < g.length; C++) l.push(g[C]);
              }
              if (c == e.length) break;
              if (c = f, h++ > y) {
                for (h > 2 * e.length && this.reportError("infinite loop with in ace tokenizer", {
                  startState: t,
                  line: e
                }); c < e.length;) d.type && l.push(d), d = {
                  value: e.substring(c, c += 500),
                  type: "overflow"
                };
                o = "start", n = [];
                break;
              }
            }
            return d.type && l.push(d), 1 < n.length && n[0] !== o && n.unshift("#tmp", o), {
              tokens: l,
              state: n.length ? n : o
            };
          }, o);
        function o(e) {
          for (var t in (this || _global).states = e, (this || _global).regExps = {}, (this || _global).matchMappings = {}, (this || _global).states) {
            for (o = 0; l < n.length; l++) {
              var c,
                h,
                d = n[l];
              d.defaultToken && (r.defaultToken = d.defaultToken), d.caseInsensitive && -1 === s.indexOf("i") && (s += "i"), d.unicode && -1 === s.indexOf("u") && (s += "u"), null == d.regex || (d.regex instanceof RegExp && (d.regex = d.regex.toString().slice(1, -1)), c = d.regex, h = new RegExp("(?:(" + c + ")|(.))").exec("a").length - 2, Array.isArray(d.token) ? 1 == d.token.length || 1 == h ? d.token = d.token[0] : h - 1 != d.token.length ? (this.reportError("number of classes and regexp groups doesn't match", {
                rule: d,
                groupCount: h - 1
              }), d.token = d.token[0]) : (d.tokenArray = d.token, d.token = null, d.onMatch = (this || _global).$arrayTokens) : "function" != typeof d.token || d.onMatch || (d.onMatch = 1 < h ? (this || _global).$applyToken : d.token), 1 < h && (c = /\\\d/.test(d.regex) ? d.regex.replace(/\\([0-9]+)/g, function (e, t) {
                return "\\" + (parseInt(t, 10) + o + 1);
              }) : (h = 1, this.removeCapturingGroups(d.regex)), d.splitRegex || "string" == typeof d.token || a.push(d)), r[o] = l, o += h, i.push(c), d.onMatch) || (d.onMatch = null);
            }
            i.length || (r[0] = 0, i.push("$")), a.forEach(function (e) {
              e.splitRegex = this.createSplitterRegexp(e.regex, s);
            }, this || _global), (this || _global).regExps[t] = new RegExp("(" + i.join(")|(") + ")|($)", s);
          }
        }
        i.prototype.reportError = e.reportError, t.Tokenizer = i;
      }), ace.define("ace/mode/text_highlight_rules", ["require", "exports", "module", "ace/lib/lang"], function (e, t, n) {
        "use strict";

        function i() {
          (this || _global).$rules = {
            start: [{
              token: "empty_line",
              regex: "^$"
            }, {
              defaultToken: "text"
            }]
          };
        }
        var l = e("../lib/lang");
        !function () {
          (this || _global).addRules = function (e, t) {
            if (t) for (var n in e) {
              for (var i = e[n], o = 0; o < i.length; o++) {
                var r = i[o];
                (r.next || r.onMatch) && ("string" == typeof r.next && 0 !== r.next.indexOf(t) && (r.next = t + r.next), r.nextState) && 0 !== r.nextState.indexOf(t) && (r.nextState = t + r.nextState);
              }
              (this || _global).$rules[t + n] = i;
            } else for (var n in e) (this || _global).$rules[n] = e[n];
          }, (this || _global).getRules = function () {
            return (this || _global).$rules;
          }, (this || _global).embedRules = function (e, t, n, i, o) {
            e = "function" == typeof e ? new e().getRules() : e;
            if (i) for (var r = 0; r < i.length; r++) i[r] = t + i[r];else for (var s in i = [], e) i.push(t + s);
            if (this.addRules(e, t), n) for (var a = Array.prototype[o ? "push" : "unshift"], r = 0; r < i.length; r++) a.apply((this || _global).$rules[i[r]], l.deepCopy(n));
            (this || _global).$embeds || ((this || _global).$embeds = []), (this || _global).$embeds.push(t);
          }, (this || _global).getEmbeds = function () {
            return (this || _global).$embeds;
          };
          function d(e, t) {
            return "start" == e && !t.length || t.unshift((this || _global).nextState, e), (this || _global).nextState;
          }
          function u(e, t) {
            return t.shift(), t.shift() || "start";
          }
          (this || _global).normalizeRules = function () {
            var c = 0,
              h = (this || _global).$rules;
            Object.keys(h).forEach(function e(t) {
              var n = h[t];
              n.processed = !0;
              for (var i = 0; i < n.length; i++) {
                var o = n[i],
                  r = null,
                  s = (Array.isArray(o) && (r = o, o = {}), !o.regex && o.start && (o.regex = o.start, o.next || (o.next = []), o.next.push({
                    defaultToken: o.token
                  }, {
                    token: o.token + ".end",
                    regex: o.end || o.start,
                    next: "pop"
                  }), o.token = o.token + ".start", o.push = !0), o.next || o.push);
                if (s && Array.isArray(s) ? ((l = o.stateName) || ("string" != typeof (l = o.token) && (l = l[0] || ""), h[l] && (l += c++)), h[l] = s, e(o.next = l)) : "pop" == s && (o.next = u), o.push && (o.nextState = o.next || o.push, o.next = d, delete o.push), o.rules) for (var a in o.rules) h[a] ? h[a].push && h[a].push.apply(h[a], o.rules[a]) : h[a] = o.rules[a];
                var l = "string" == typeof o ? o : o.include;
                l && ("$self" === l && (l = "start"), r = Array.isArray(l) ? l.map(function (e) {
                  return h[e];
                }) : h[l]), r && (s = [i, 1].concat(r), o.noEscape && (s = s.filter(function (e) {
                  return !e.next;
                })), n.splice.apply(n, s), i--), o.keywordMap && (o.token = this.createKeywordMapper(o.keywordMap, o.defaultToken || "text", o.caseInsensitive), delete o.defaultToken);
              }
            }, this || _global);
          }, (this || _global).createKeywordMapper = function (o, t, r, s) {
            var a = Object.create(null);
            return (this || _global).$keywordList = [], Object.keys(o).forEach(function (e) {
              for (var t = o[e].split(s || "|"), n = t.length; n--;) {
                var i = t[n];
                (this || _global).$keywordList.push(i), r && (i = i.toLowerCase()), a[i] = e;
              }
            }, this || _global), o = null, r ? function (e) {
              return a[e.toLowerCase()] || t;
            } : function (e) {
              return a[e] || t;
            };
          }, (this || _global).getKeywords = function () {
            return (this || _global).$keywords;
          };
        }.call(i.prototype), t.TextHighlightRules = i;
      }), ace.define("ace/mode/behaviour", ["require", "exports", "module"], function (e, t, n) {
        "use strict";

        function i() {
          (this || _global).$behaviours = {};
        }
        !function () {
          (this || _global).add = function (e, t, n) {
            switch (void 0) {
              case (this || _global).$behaviours:
                (this || _global).$behaviours = {};
              case (this || _global).$behaviours[e]:
                (this || _global).$behaviours[e] = {};
            }
            (this || _global).$behaviours[e][t] = n;
          }, (this || _global).addBehaviours = function (e) {
            for (var t in e) for (var n in e[t]) this.add(t, n, e[t][n]);
          }, (this || _global).remove = function (e) {
            (this || _global).$behaviours && (this || _global).$behaviours[e] && delete (this || _global).$behaviours[e];
          }, (this || _global).inherit = function (e, t) {
            e = ("function" == typeof e ? new e() : e).getBehaviours(t), this.addBehaviours(e);
          }, (this || _global).getBehaviours = function (e) {
            if (e) {
              for (var t = {}, n = 0; n < e.length; n++) (this || _global).$behaviours[e[n]] && (t[e[n]] = (this || _global).$behaviours[e[n]]);
              return t;
            }
            return (this || _global).$behaviours;
          };
        }.call(i.prototype), t.Behaviour = i;
      }), ace.define("ace/token_iterator", ["require", "exports", "module", "ace/range"], function (e, t, n) {
        "use strict";

        var i = e("./range").Range;
        function o(e, t, n) {
          (this || _global).$session = e, (this || _global).$row = t, (this || _global).$rowTokens = e.getTokens(t);
          e = e.getTokenAt(t, n);
          (this || _global).$tokenIndex = e ? e.index : -1;
        }
        o.prototype.stepBackward = function () {
          for (--(this || _global).$tokenIndex; (this || _global).$tokenIndex < 0;) {
            if (--(this || _global).$row, (this || _global).$row < 0) return (this || _global).$row = 0, null;
            (this || _global).$rowTokens = (this || _global).$session.getTokens((this || _global).$row), (this || _global).$tokenIndex = (this || _global).$rowTokens.length - 1;
          }
          return (this || _global).$rowTokens[(this || _global).$tokenIndex];
        }, o.prototype.stepForward = function () {
          var e;
          for ((this || _global).$tokenIndex += 1; (this || _global).$tokenIndex >= (this || _global).$rowTokens.length;) {
            if ((this || _global).$row += 1, e = e || (this || _global).$session.getLength(), (this || _global).$row >= e) return (this || _global).$row = e - 1, null;
            (this || _global).$rowTokens = (this || _global).$session.getTokens((this || _global).$row), (this || _global).$tokenIndex = 0;
          }
          return (this || _global).$rowTokens[(this || _global).$tokenIndex];
        }, o.prototype.getCurrentToken = function () {
          return (this || _global).$rowTokens[(this || _global).$tokenIndex];
        }, o.prototype.getCurrentTokenRow = function () {
          return (this || _global).$row;
        }, o.prototype.getCurrentTokenColumn = function () {
          var e = (this || _global).$rowTokens,
            t = (this || _global).$tokenIndex,
            n = e[t].start;
          if (void 0 === n) for (n = 0; 0 < t;) n += e[--t].value.length;
          return n;
        }, o.prototype.getCurrentTokenPosition = function () {
          return {
            row: (this || _global).$row,
            column: this.getCurrentTokenColumn()
          };
        }, o.prototype.getCurrentTokenRange = function () {
          var e = (this || _global).$rowTokens[(this || _global).$tokenIndex],
            t = this.getCurrentTokenColumn();
          return new i((this || _global).$row, t, (this || _global).$row, t + e.value.length);
        }, t.TokenIterator = o;
      }), ace.define("ace/mode/behaviour/cstyle", ["require", "exports", "module", "ace/lib/oop", "ace/mode/behaviour", "ace/token_iterator", "ace/lib/lang"], function (e, t, n) {
        "use strict";

        function u(e) {
          var t = -1;
          if ((l = e.multiSelect && (t = e.selection.index, l.rangeCount != e.multiSelect.rangeCount) ? {
            rangeCount: e.multiSelect.rangeCount
          } : l)[t]) return m = l[t];
          m = l[t] = {
            autoInsertedBrackets: 0,
            autoInsertedRow: -1,
            autoInsertedLineEnd: "",
            maybeInsertedBrackets: 0,
            maybeInsertedRow: -1,
            maybeInsertedLineStart: "",
            maybeInsertedLineEnd: ""
          };
        }
        function g(e, t, n, i) {
          var o = e.end.row - e.start.row;
          return {
            text: n + t + i,
            selection: [0, e.start.column + 1, o, e.end.column + (o ? 0 : 1)]
          };
        }
        function p(d) {
          this.add("braces", "insertion", function (e, t, n, i, o) {
            var r = n.getCursorPosition(),
              s = i.doc.getLine(r.row);
            if ("{" == o) return u(n), l = n.getSelectionRange(), "" !== (c = i.doc.getTextRange(l)) && "{" !== c && n.getWrapBehavioursEnabled() ? g(l, c, "{", "}") : p.isSaneInsertion(n, i) ? /[\]\}\)]/.test(s[r.column]) || n.inMultiSelectMode || d && d.braces ? (p.recordAutoInsert(n, i, "}"), {
              text: "{}",
              selection: [1, 1]
            }) : (p.recordMaybeInsert(n, i, "{"), {
              text: "{",
              selection: [1, 1]
            }) : void 0;
            if ("}" == o) {
              u(n);
              var a = s.substring(r.column, r.column + 1);
              if ("}" == a) if (null !== i.$findOpeningBracket("}", {
                column: r.column + 1,
                row: r.row
              }) && p.isAutoInsertedClosing(r, s, o)) return p.popAutoInsertedClosing(), {
                text: "",
                selection: [1, 1]
              };
            } else {
              if ("\n" == o || "\r\n" == o) {
                u(n);
                var l = "";
                if (p.isMaybeInsertedClosing(r, s) && (l = f.stringRepeat("}", m.maybeInsertedBrackets), p.clearMaybeInsertedClosing()), "}" === (a = s.substring(r.column, r.column + 1))) {
                  var c = i.findMatchingBracket({
                    row: r.row,
                    column: r.column + 1
                  }, "}");
                  if (!c) return null;
                  var h = this.$getIndent(i.getLine(c.row));
                } else {
                  if (!l) return void p.clearMaybeInsertedClosing();
                  h = this.$getIndent(s);
                }
                o = h + i.getTabString();
                return {
                  text: "\n" + o + "\n" + h + l,
                  selection: [1, o.length, 1, o.length]
                };
              }
              p.clearMaybeInsertedClosing();
            }
          }), this.add("braces", "deletion", function (e, t, n, i, o) {
            var r = i.doc.getTextRange(o);
            if (!o.isMultiLine() && "{" == r) {
              if (u(n), "}" == i.doc.getLine(o.start.row).substring(o.end.column, o.end.column + 1)) return o.end.column++, o;
              m.maybeInsertedBrackets--;
            }
          }), this.add("parens", "insertion", function (e, t, n, i, o) {
            if ("(" == o) return u(n), r = n.getSelectionRange(), "" !== (s = i.doc.getTextRange(r)) && n.getWrapBehavioursEnabled() ? g(r, s, "(", ")") : p.isSaneInsertion(n, i) ? (p.recordAutoInsert(n, i, ")"), {
              text: "()",
              selection: [1, 1]
            }) : void 0;
            if (")" == o) {
              u(n);
              var r = n.getCursorPosition(),
                s = i.doc.getLine(r.row),
                n = s.substring(r.column, r.column + 1);
              if (")" == n) if (null !== i.$findOpeningBracket(")", {
                column: r.column + 1,
                row: r.row
              }) && p.isAutoInsertedClosing(r, s, o)) return p.popAutoInsertedClosing(), {
                text: "",
                selection: [1, 1]
              };
            }
          }), this.add("parens", "deletion", function (e, t, n, i, o) {
            var r = i.doc.getTextRange(o);
            if (!o.isMultiLine() && "(" == r && (u(n), ")" == i.doc.getLine(o.start.row).substring(o.start.column + 1, o.start.column + 2))) return o.end.column++, o;
          }), this.add("brackets", "insertion", function (e, t, n, i, o) {
            if ("[" == o) return u(n), r = n.getSelectionRange(), "" !== (s = i.doc.getTextRange(r)) && n.getWrapBehavioursEnabled() ? g(r, s, "[", "]") : p.isSaneInsertion(n, i) ? (p.recordAutoInsert(n, i, "]"), {
              text: "[]",
              selection: [1, 1]
            }) : void 0;
            if ("]" == o) {
              u(n);
              var r = n.getCursorPosition(),
                s = i.doc.getLine(r.row),
                n = s.substring(r.column, r.column + 1);
              if ("]" == n) if (null !== i.$findOpeningBracket("]", {
                column: r.column + 1,
                row: r.row
              }) && p.isAutoInsertedClosing(r, s, o)) return p.popAutoInsertedClosing(), {
                text: "",
                selection: [1, 1]
              };
            }
          }), this.add("brackets", "deletion", function (e, t, n, i, o) {
            var r = i.doc.getTextRange(o);
            if (!o.isMultiLine() && "[" == r && (u(n), "]" == i.doc.getLine(o.start.row).substring(o.start.column + 1, o.start.column + 2))) return o.end.column++, o;
          }), this.add("string_dquotes", "insertion", function (e, t, n, i, o) {
            var r = i.$mode.$quotes || C;
            if (1 == o.length && r[o] && (!(this || _global).lineCommentStart || -1 == (this || _global).lineCommentStart.indexOf(o))) {
              u(n);
              var s = n.getSelectionRange(),
                a = i.doc.getTextRange(s);
              if (!("" === a || 1 == a.length && r[a]) && n.getWrapBehavioursEnabled()) return g(s, a, o, o);
              if (!a) {
                var r = n.getCursorPosition(),
                  s = i.doc.getLine(r.row),
                  a = s.substring(r.column - 1, r.column),
                  n = s.substring(r.column, r.column + 1),
                  l = i.getTokenAt(r.row, r.column),
                  c = i.getTokenAt(r.row, r.column + 1);
                if ("\\" == a && l && /escape/.test(l.type)) return null;
                var h,
                  l = l && /string|escape/.test(l.type),
                  d = !c || /string|escape/.test(c.type);
                if (n == o) (h = l !== d) && /string\.end/.test(c.type) && (h = !1);else {
                  if (l && !d) return null;
                  if (l && d) return null;
                  c = i.$mode.tokenRe, l = (c.lastIndex = 0, c.test(a)), d = (c.lastIndex = 0, c.test(n)), i = i.$mode.$pairQuotesAfter;
                  if (!(i && i[o] && i[o].test(a)) && l || d) return null;
                  if (n && !/[\s;,.})\]\\]/.test(n)) return null;
                  i = s[r.column - 2];
                  if (a == o && (i == o || c.test(i))) return null;
                  h = !0;
                }
                return {
                  text: h ? o + o : "",
                  selection: [1, 1]
                };
              }
            }
          }), this.add("string_dquotes", "deletion", function (e, t, n, i, o) {
            var r = i.$mode.$quotes || C,
              s = i.doc.getTextRange(o);
            if (!o.isMultiLine() && r.hasOwnProperty(s) && (u(n), i.doc.getLine(o.start.row).substring(o.start.column + 1, o.start.column + 2) == s)) return o.end.column++, o;
          });
        }
        var m,
          i = e("../../lib/oop"),
          o = e("../behaviour").Behaviour,
          r = e("../../token_iterator").TokenIterator,
          f = e("../../lib/lang"),
          s = ["text", "paren.rparen", "rparen", "paren", "punctuation.operator"],
          a = ["text", "paren.rparen", "rparen", "paren", "punctuation.operator", "comment"],
          l = {},
          C = {
            "\"": "\"",
            "'": "'"
          };
        p.isSaneInsertion = function (e, t) {
          var n = e.getCursorPosition(),
            i = new r(t, n.row, n.column);
          if (!this.$matchTokenType(i.getCurrentToken() || "text", s)) {
            if (/[)}\]]/.test(e.session.getLine(n.row)[n.column])) return !0;
            e = new r(t, n.row, n.column + 1);
            if (!this.$matchTokenType(e.getCurrentToken() || "text", s)) return !1;
          }
          return i.stepForward(), i.getCurrentTokenRow() !== n.row || this.$matchTokenType(i.getCurrentToken() || "text", a);
        }, p.$matchTokenType = function (e, t) {
          return -1 < t.indexOf(e.type || e);
        }, p.recordAutoInsert = function (e, t, n) {
          e = e.getCursorPosition(), t = t.doc.getLine(e.row);
          this.isAutoInsertedClosing(e, t, m.autoInsertedLineEnd[0]) || (m.autoInsertedBrackets = 0), m.autoInsertedRow = e.row, m.autoInsertedLineEnd = n + t.substr(e.column), m.autoInsertedBrackets++;
        }, p.recordMaybeInsert = function (e, t, n) {
          e = e.getCursorPosition(), t = t.doc.getLine(e.row);
          this.isMaybeInsertedClosing(e, t) || (m.maybeInsertedBrackets = 0), m.maybeInsertedRow = e.row, m.maybeInsertedLineStart = t.substr(0, e.column) + n, m.maybeInsertedLineEnd = t.substr(e.column), m.maybeInsertedBrackets++;
        }, p.isAutoInsertedClosing = function (e, t, n) {
          return 0 < m.autoInsertedBrackets && e.row === m.autoInsertedRow && n === m.autoInsertedLineEnd[0] && t.substr(e.column) === m.autoInsertedLineEnd;
        }, p.isMaybeInsertedClosing = function (e, t) {
          return 0 < m.maybeInsertedBrackets && e.row === m.maybeInsertedRow && t.substr(e.column) === m.maybeInsertedLineEnd && t.substr(0, e.column) == m.maybeInsertedLineStart;
        }, p.popAutoInsertedClosing = function () {
          m.autoInsertedLineEnd = m.autoInsertedLineEnd.substr(1), m.autoInsertedBrackets--;
        }, p.clearMaybeInsertedClosing = function () {
          m && (m.maybeInsertedBrackets = 0, m.maybeInsertedRow = -1);
        }, i.inherits(p, o), t.CstyleBehaviour = p;
      }), ace.define("ace/unicode", ["require", "exports", "module"], function (e, t, n) {
        "use strict";

        for (var i = [48, 9, 8, 25, 5, 0, 2, 25, 48, 0, 11, 0, 5, 0, 6, 22, 2, 30, 2, 457, 5, 11, 15, 4, 8, 0, 2, 0, 18, 116, 2, 1, 3, 3, 9, 0, 2, 2, 2, 0, 2, 19, 2, 82, 2, 138, 2, 4, 3, 155, 12, 37, 3, 0, 8, 38, 10, 44, 2, 0, 2, 1, 2, 1, 2, 0, 9, 26, 6, 2, 30, 10, 7, 61, 2, 9, 5, 101, 2, 7, 3, 9, 2, 18, 3, 0, 17, 58, 3, 100, 15, 53, 5, 0, 6, 45, 211, 57, 3, 18, 2, 5, 3, 11, 3, 9, 2, 1, 7, 6, 2, 2, 2, 7, 3, 1, 3, 21, 2, 6, 2, 0, 4, 3, 3, 8, 3, 1, 3, 3, 9, 0, 5, 1, 2, 4, 3, 11, 16, 2, 2, 5, 5, 1, 3, 21, 2, 6, 2, 1, 2, 1, 2, 1, 3, 0, 2, 4, 5, 1, 3, 2, 4, 0, 8, 3, 2, 0, 8, 15, 12, 2, 2, 8, 2, 2, 2, 21, 2, 6, 2, 1, 2, 4, 3, 9, 2, 2, 2, 2, 3, 0, 16, 3, 3, 9, 18, 2, 2, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 3, 8, 3, 1, 3, 2, 9, 1, 5, 1, 2, 4, 3, 9, 2, 0, 17, 1, 2, 5, 4, 2, 2, 3, 4, 1, 2, 0, 2, 1, 4, 1, 4, 2, 4, 11, 5, 4, 4, 2, 2, 3, 3, 0, 7, 0, 15, 9, 18, 2, 2, 7, 2, 2, 2, 22, 2, 9, 2, 4, 4, 7, 2, 2, 2, 3, 8, 1, 2, 1, 7, 3, 3, 9, 19, 1, 2, 7, 2, 2, 2, 22, 2, 9, 2, 4, 3, 8, 2, 2, 2, 3, 8, 1, 8, 0, 2, 3, 3, 9, 19, 1, 2, 7, 2, 2, 2, 22, 2, 15, 4, 7, 2, 2, 2, 3, 10, 0, 9, 3, 3, 9, 11, 5, 3, 1, 2, 17, 4, 23, 2, 8, 2, 0, 3, 6, 4, 0, 5, 5, 2, 0, 2, 7, 19, 1, 14, 57, 6, 14, 2, 9, 40, 1, 2, 0, 3, 1, 2, 0, 3, 0, 7, 3, 2, 6, 2, 2, 2, 0, 2, 0, 3, 1, 2, 12, 2, 2, 3, 4, 2, 0, 2, 5, 3, 9, 3, 1, 35, 0, 24, 1, 7, 9, 12, 0, 2, 0, 2, 0, 5, 9, 2, 35, 5, 19, 2, 5, 5, 7, 2, 35, 10, 0, 58, 73, 7, 77, 3, 37, 11, 42, 2, 0, 4, 328, 2, 3, 3, 6, 2, 0, 2, 3, 3, 40, 2, 3, 3, 32, 2, 3, 3, 6, 2, 0, 2, 3, 3, 14, 2, 56, 2, 3, 3, 66, 5, 0, 33, 15, 17, 84, 13, 619, 3, 16, 2, 25, 6, 74, 22, 12, 2, 6, 12, 20, 12, 19, 13, 12, 2, 2, 2, 1, 13, 51, 3, 29, 4, 0, 5, 1, 3, 9, 34, 2, 3, 9, 7, 87, 9, 42, 6, 69, 11, 28, 4, 11, 5, 11, 11, 39, 3, 4, 12, 43, 5, 25, 7, 10, 38, 27, 5, 62, 2, 28, 3, 10, 7, 9, 14, 0, 89, 75, 5, 9, 18, 8, 13, 42, 4, 11, 71, 55, 9, 9, 4, 48, 83, 2, 2, 30, 14, 230, 23, 280, 3, 5, 3, 37, 3, 5, 3, 7, 2, 0, 2, 0, 2, 0, 2, 30, 3, 52, 2, 6, 2, 0, 4, 2, 2, 6, 4, 3, 3, 5, 5, 12, 6, 2, 2, 6, 67, 1, 20, 0, 29, 0, 14, 0, 17, 4, 60, 12, 5, 0, 4, 11, 18, 0, 5, 0, 3, 9, 2, 0, 4, 4, 7, 0, 2, 0, 2, 0, 2, 3, 2, 10, 3, 3, 6, 4, 5, 0, 53, 1, 2684, 46, 2, 46, 2, 132, 7, 6, 15, 37, 11, 53, 10, 0, 17, 22, 10, 6, 2, 6, 2, 6, 2, 6, 2, 6, 2, 6, 2, 6, 2, 6, 2, 31, 48, 0, 470, 1, 36, 5, 2, 4, 6, 1, 5, 85, 3, 1, 3, 2, 2, 89, 2, 3, 6, 40, 4, 93, 18, 23, 57, 15, 513, 6581, 75, 20939, 53, 1164, 68, 45, 3, 268, 4, 27, 21, 31, 3, 13, 13, 1, 2, 24, 9, 69, 11, 1, 38, 8, 3, 102, 3, 1, 111, 44, 25, 51, 13, 68, 12, 9, 7, 23, 4, 0, 5, 45, 3, 35, 13, 28, 4, 64, 15, 10, 39, 54, 10, 13, 3, 9, 7, 22, 4, 1, 5, 66, 25, 2, 227, 42, 2, 1, 3, 9, 7, 11171, 13, 22, 5, 48, 8453, 301, 3, 61, 3, 105, 39, 6, 13, 4, 6, 11, 2, 12, 2, 4, 2, 0, 2, 1, 2, 1, 2, 107, 34, 362, 19, 63, 3, 53, 41, 11, 5, 15, 17, 6, 13, 1, 25, 2, 33, 4, 2, 134, 20, 9, 8, 25, 5, 0, 2, 25, 12, 88, 4, 5, 3, 5, 3, 5, 3, 2], o = 0, r = [], s = 0; s < i.length; s += 2) r.push(o += i[s]), i[s + 1] && r.push(45, o += i[s + 1]);
        t.wordChars = String.fromCharCode.apply(null, r);
      }), ace.define("ace/mode/text", ["require", "exports", "module", "ace/config", "ace/tokenizer", "ace/mode/text_highlight_rules", "ace/mode/behaviour/cstyle", "ace/unicode", "ace/lib/lang", "ace/token_iterator", "ace/range"], function (e, t, n) {
        "use strict";

        function i() {
          (this || _global).HighlightRules = r;
        }
        var s = e("../config"),
          o = e("../tokenizer").Tokenizer,
          r = e("./text_highlight_rules").TextHighlightRules,
          a = e("./behaviour/cstyle").CstyleBehaviour,
          l = e("../unicode"),
          b = e("../lib/lang"),
          m = e("../token_iterator").TokenIterator,
          f = e("../range").Range;
        !function () {
          (this || _global).$defaultBehaviour = new a(), (this || _global).tokenRe = new RegExp("^[" + l.wordChars + "\\$_]+", "g"), (this || _global).nonTokenRe = new RegExp("^(?:[^" + l.wordChars + "\\$_]|\\s])+", "g"), (this || _global).getTokenizer = function () {
            return (this || _global).$tokenizer || ((this || _global).$highlightRules = (this || _global).$highlightRules || new (this || _global).HighlightRules((this || _global).$highlightRuleConfig), (this || _global).$tokenizer = new o((this || _global).$highlightRules.getRules())), (this || _global).$tokenizer;
          }, (this || _global).lineCommentStart = "", (this || _global).blockComment = "", (this || _global).toggleCommentLines = function (e, o, n, i) {
            var r = o.doc,
              s = !0,
              a = !0,
              l = 1 / 0,
              c = o.getTabSize(),
              t = !1;
            if ((this || _global).lineCommentStart) {
              m = Array.isArray((this || _global).lineCommentStart) ? (C = (this || _global).lineCommentStart.map(b.escapeRegExp).join("|"), (this || _global).lineCommentStart[0]) : (C = b.escapeRegExp((this || _global).lineCommentStart), (this || _global).lineCommentStart), C = new RegExp("^(\\s*)(?:" + C + ") ?"), t = o.getUseSoftTabs();
              var h = function (e, t) {
                  var n,
                    i,
                    o = e.match(C);
                  o && (n = o[1].length, i = o[0].length, p(e, n, i) || " " != o[0][i - 1] || i--, r.removeInLine(t, n, i));
                },
                d = m + " ",
                u = function (e, t) {
                  s && !/\S/.test(e) || (p(e, l, l) ? r.insertInLine({
                    row: t,
                    column: l
                  }, d) : r.insertInLine({
                    row: t,
                    column: l
                  }, m));
                },
                g = function (e, t) {
                  return C.test(e);
                },
                p = function (e, t, n) {
                  for (var i = 0; t-- && " " == e.charAt(t);) i++;
                  if (i % c != 0) return !1;
                  for (i = 0; " " == e.charAt(n++);) i++;
                  return 2 < c ? i % c != c - 1 : i % c == 0;
                };
            } else {
              if (!(this || _global).blockComment) return !1;
              var m = (this || _global).blockComment.start,
                f = (this || _global).blockComment.end,
                C = new RegExp("^(\\s*)(?:" + b.escapeRegExp(m) + ")"),
                y = new RegExp("(?:" + b.escapeRegExp(f) + ")\\s*$"),
                u = function (e, t) {
                  g(e, t) || s && !/\S/.test(e) || (r.insertInLine({
                    row: t,
                    column: e.length
                  }, f), r.insertInLine({
                    row: t,
                    column: l
                  }, m));
                },
                h = function (e, t) {
                  var n;
                  (n = e.match(y)) && r.removeInLine(t, e.length - n[0].length, e.length), (n = e.match(C)) && r.removeInLine(t, n[1].length, n[0].length);
                },
                g = function (e, t) {
                  if (C.test(e)) return !0;
                  for (var n = o.getTokens(t), i = 0; i < n.length; i++) if ("comment" === n[i].type) return !0;
                };
            }
            function v(e) {
              for (var t = n; t <= i; t++) e(r.getLine(t), t);
            }
            var I = 1 / 0;
            v(function (e, t) {
              var n = e.search(/\S/);
              -1 !== n ? (n < l && (l = n), a && !g(e, t) && (a = !1)) : I > e.length && (I = e.length);
            }), l == 1 / 0 && (l = I, a = s = !1), t && l % c != 0 && (l = Math.floor(l / c) * c), v(a ? h : u);
          }, (this || _global).toggleBlockComment = function (e, t, n, i) {
            var o = (this || _global).blockComment;
            if (o) {
              !o.start && o[0] && (o = o[0]);
              var r,
                s,
                a = (u = new m(t, i.row, i.column)).getCurrentToken(),
                l = (t.selection, t.selection.toOrientedRange());
              if (a && /comment/.test(a.type)) {
                for (; a && /comment/.test(a.type);) {
                  if (-1 != (g = a.value.indexOf(o.start))) {
                    var c = u.getCurrentTokenRow(),
                      h = u.getCurrentTokenColumn() + g,
                      d = new f(c, h, c, h + o.start.length);
                    break;
                  }
                  a = u.stepBackward();
                }
                for (var u, g, a = (u = new m(t, i.row, i.column)).getCurrentToken(); a && /comment/.test(a.type);) {
                  if (-1 != (g = a.value.indexOf(o.end))) {
                    var c = u.getCurrentTokenRow(),
                      h = u.getCurrentTokenColumn() + g,
                      p = new f(c, h, c, h + o.end.length);
                    break;
                  }
                  a = u.stepForward();
                }
                p && t.remove(p), d && (t.remove(d), r = d.start.row, s = -o.start.length);
              } else s = o.start.length, r = n.start.row, t.insert(n.end, o.end), t.insert(n.start, o.start);
              l.start.row == r && (l.start.column += s), l.end.row == r && (l.end.column += s), t.selection.fromOrientedRange(l);
            }
          }, (this || _global).getNextLineIndent = function (e, t, n) {
            return this.$getIndent(t);
          }, (this || _global).checkOutdent = function (e, t, n) {
            return !1;
          }, (this || _global).autoOutdent = function (e, t, n) {}, (this || _global).$getIndent = function (e) {
            return e.match(/^\s*/)[0];
          }, (this || _global).createWorker = function (e) {
            return null;
          }, (this || _global).createModeDelegates = function (e) {
            for (var i in (this || _global).$embeds = [], (this || _global).$modes = {}, e) {
              var t, n, o;
              e[i] && (n = (t = e[i]).prototype.$id, (o = s.$modes[n]) || (s.$modes[n] = o = new t()), s.$modes[i] || (s.$modes[i] = o), (this || _global).$embeds.push(i), (this || _global).$modes[i] = o);
            }
            for (var r = ["toggleBlockComment", "toggleCommentLines", "getNextLineIndent", "checkOutdent", "autoOutdent", "transformAction", "getCompletions"], i = 0; i < r.length; i++) !function (e) {
              var t = r[i],
                n = e[t];
              e[r[i]] = function () {
                return this.$delegator(t, arguments, n);
              };
            }(this || _global);
          }, (this || _global).$delegator = function (e, t, n) {
            var i = t[0] || "start";
            if ("string" != typeof i) {
              if (Array.isArray(i[2])) {
                var o = i[2][i[2].length - 1];
                if (s = (this || _global).$modes[o]) return s[e].apply(s, [i[1]].concat([].slice.call(t, 1)));
              }
              i = i[0] || "start";
            }
            for (var r = 0; r < (this || _global).$embeds.length; r++) if ((this || _global).$modes[(this || _global).$embeds[r]]) {
              var s,
                a = i.split((this || _global).$embeds[r]);
              if (!a[0] && a[1]) return t[0] = a[1], (s = (this || _global).$modes[(this || _global).$embeds[r]])[e].apply(s, t);
            }
            o = n.apply(this || _global, t);
            return n ? o : void 0;
          }, (this || _global).transformAction = function (e, t, n, i, o) {
            if ((this || _global).$behaviour) {
              var r,
                s = (this || _global).$behaviour.getBehaviours();
              for (r in s) if (s[r][t]) {
                var a = s[r][t].apply(this || _global, arguments);
                if (a) return a;
              }
            }
          }, (this || _global).getKeywords = function (e) {
            if (!(this || _global).completionKeywords) {
              var t = (this || _global).$tokenizer.rules,
                n = [];
              for (s in t) for (var i = t[s], o = 0, r = i.length; o < r; o++) if ("string" == typeof i[o].token) /keyword|support|storage/.test(i[o].token) && n.push(i[o].regex);else if ("object" == typeof i[o].token) for (var s, a = 0, l = i[o].token.length; a < l; a++) /keyword|support|storage/.test(i[o].token[a]) && (s = i[o].regex.match(/\(.+?\)/g)[a], n.push(s.substr(1, s.length - 2)));
              (this || _global).completionKeywords = n;
            }
            return e ? n.concat((this || _global).$keywordList || []) : (this || _global).$keywordList;
          }, (this || _global).$createKeywordList = function () {
            return (this || _global).$highlightRules || this.getTokenizer(), (this || _global).$keywordList = (this || _global).$highlightRules.$keywordList || [];
          }, (this || _global).getCompletions = function (e, t, n, i) {
            return ((this || _global).$keywordList || this.$createKeywordList()).map(function (e) {
              return {
                name: e,
                value: e,
                score: 0,
                meta: "keyword"
              };
            });
          }, (this || _global).$id = "ace/mode/text";
        }.call(i.prototype), t.Mode = i;
      }), ace.define("ace/apply_delta", ["require", "exports", "module"], function (e, t, n) {
        "use strict";

        t.applyDelta = function (e, t, n) {
          var i = t.start.row,
            o = t.start.column,
            r = e[i] || "";
          switch (t.action) {
            case "insert":
              1 === t.lines.length ? e[i] = r.substring(0, o) + t.lines[0] + r.substring(o) : (s = [i, 1].concat(t.lines), e.splice.apply(e, s), e[i] = r.substring(0, o) + e[i], e[i + t.lines.length - 1] += r.substring(o));
              break;
            case "remove":
              var s = t.end.column,
                a = t.end.row;
              i === a ? e[i] = r.substring(0, o) + r.substring(s) : e.splice(i, a - i + 1, r.substring(0, o) + e[a].substring(s));
          }
        };
      }), ace.define("ace/anchor", ["require", "exports", "module", "ace/lib/oop", "ace/lib/event_emitter"], function (e, t, n) {
        "use strict";

        var i = e("./lib/oop"),
          e = e("./lib/event_emitter").EventEmitter,
          o = (r.prototype.getPosition = function () {
            return this.$clipPositionToDocument((this || _global).row, (this || _global).column);
          }, r.prototype.getDocument = function () {
            return (this || _global).document;
          }, r.prototype.onChange = function (e) {
            e.start.row == e.end.row && e.start.row != (this || _global).row || e.start.row > (this || _global).row || (e = function (e, t, n) {
              var i = "insert" == e.action,
                o = (i ? 1 : -1) * (e.end.row - e.start.row),
                r = (i ? 1 : -1) * (e.end.column - e.start.column),
                s = e.start,
                i = i ? s : e.end;
              if (a(t, s, n)) return {
                row: t.row,
                column: t.column
              };
              if (a(i, t, !n)) return {
                row: t.row + o,
                column: t.column + (t.row == i.row ? r : 0)
              };
              return {
                row: s.row,
                column: s.column
              };
            }(e, {
              row: (this || _global).row,
              column: (this || _global).column
            }, (this || _global).$insertRight), this.setPosition(e.row, e.column, !0));
          }, r.prototype.setPosition = function (e, t, n) {
            n = n ? {
              row: e,
              column: t
            } : this.$clipPositionToDocument(e, t);
            (this || _global).row == n.row && (this || _global).column == n.column || (e = {
              row: (this || _global).row,
              column: (this || _global).column
            }, (this || _global).row = n.row, (this || _global).column = n.column, this._signal("change", {
              old: e,
              value: n
            }));
          }, r.prototype.detach = function () {
            (this || _global).document.off("change", (this || _global).$onChange);
          }, r.prototype.attach = function (e) {
            (this || _global).document = e || (this || _global).document, (this || _global).document.on("change", (this || _global).$onChange);
          }, r.prototype.$clipPositionToDocument = function (e, t) {
            var n = {};
            return e >= (this || _global).document.getLength() ? (n.row = Math.max(0, (this || _global).document.getLength() - 1), n.column = (this || _global).document.getLine(n.row).length) : e < 0 ? (n.row = 0, n.column = 0) : (n.row = e, n.column = Math.min((this || _global).document.getLine(n.row).length, Math.max(0, t))), t < 0 && (n.column = 0), n;
          }, r);
        function r(e, t, n) {
          (this || _global).$onChange = (this || _global).onChange.bind(this || _global), this.attach(e), void 0 === n ? this.setPosition(t.row, t.column) : this.setPosition(t, n);
        }
        function a(e, t, n) {
          n = n ? e.column <= t.column : e.column < t.column;
          return e.row < t.row || e.row == t.row && n;
        }
        o.prototype.$insertRight = !1, i.implement(o.prototype, e), t.Anchor = o;
      }), ace.define("ace/document", ["require", "exports", "module", "ace/lib/oop", "ace/apply_delta", "ace/lib/event_emitter", "ace/range", "ace/anchor"], function (e, t, n) {
        "use strict";

        var i = e("./lib/oop"),
          o = e("./apply_delta").applyDelta,
          r = e("./lib/event_emitter").EventEmitter,
          s = e("./range").Range,
          a = e("./anchor").Anchor,
          e = (l.prototype.setValue = function (e) {
            var t = this.getLength() - 1;
            this.remove(new s(0, 0, t, this.getLine(t).length)), this.insert({
              row: 0,
              column: 0
            }, e || "");
          }, l.prototype.getValue = function () {
            return this.getAllLines().join(this.getNewLineCharacter());
          }, l.prototype.createAnchor = function (e, t) {
            return new a(this || _global, e, t);
          }, l.prototype.$detectNewLine = function (e) {
            e = e.match(/^.*?(\r\n|\r|\n)/m);
            (this || _global).$autoNewLine = e ? e[1] : "\n", this._signal("changeNewLineMode");
          }, l.prototype.getNewLineCharacter = function () {
            switch ((this || _global).$newLineMode) {
              case "windows":
                return "\r\n";
              case "unix":
                return "\n";
              default:
                return (this || _global).$autoNewLine || "\n";
            }
          }, l.prototype.setNewLineMode = function (e) {
            (this || _global).$newLineMode !== e && ((this || _global).$newLineMode = e, this._signal("changeNewLineMode"));
          }, l.prototype.getNewLineMode = function () {
            return (this || _global).$newLineMode;
          }, l.prototype.isNewLine = function (e) {
            return "\r\n" == e || "\r" == e || "\n" == e;
          }, l.prototype.getLine = function (e) {
            return (this || _global).$lines[e] || "";
          }, l.prototype.getLines = function (e, t) {
            return (this || _global).$lines.slice(e, t + 1);
          }, l.prototype.getAllLines = function () {
            return this.getLines(0, this.getLength());
          }, l.prototype.getLength = function () {
            return (this || _global).$lines.length;
          }, l.prototype.getTextRange = function (e) {
            return this.getLinesForRange(e).join(this.getNewLineCharacter());
          }, l.prototype.getLinesForRange = function (e) {
            var t, n;
            return e.start.row === e.end.row ? t = [this.getLine(e.start.row).substring(e.start.column, e.end.column)] : ((t = this.getLines(e.start.row, e.end.row))[0] = (t[0] || "").substring(e.start.column), n = t.length - 1, e.end.row - e.start.row == n && (t[n] = t[n].substring(0, e.end.column))), t;
          }, l.prototype.insertLines = function (e, t) {
            return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."), this.insertFullLines(e, t);
          }, l.prototype.removeLines = function (e, t) {
            return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."), this.removeFullLines(e, t);
          }, l.prototype.insertNewLine = function (e) {
            return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."), this.insertMergedLines(e, ["", ""]);
          }, l.prototype.insert = function (e, t) {
            return this.getLength() <= 1 && this.$detectNewLine(t), this.insertMergedLines(e, this.$split(t));
          }, l.prototype.insertInLine = function (e, t) {
            var n = this.clippedPos(e.row, e.column),
              e = this.pos(e.row, e.column + t.length);
            return this.applyDelta({
              start: n,
              end: e,
              action: "insert",
              lines: [t]
            }, !0), this.clonePos(e);
          }, l.prototype.clippedPos = function (e, t) {
            var n = this.getLength(),
              n = (void 0 === e ? e = n : e < 0 ? e = 0 : n <= e && (e = n - 1, t = void 0), this.getLine(e));
            return null == t && (t = n.length), {
              row: e,
              column: t = Math.min(Math.max(t, 0), n.length)
            };
          }, l.prototype.clonePos = function (e) {
            return {
              row: e.row,
              column: e.column
            };
          }, l.prototype.pos = function (e, t) {
            return {
              row: e,
              column: t
            };
          }, l.prototype.$clipPosition = function (e) {
            var t = this.getLength();
            return e.row >= t ? (e.row = Math.max(0, t - 1), e.column = this.getLine(t - 1).length) : (e.row = Math.max(0, e.row), e.column = Math.min(Math.max(e.column, 0), this.getLine(e.row).length)), e;
          }, l.prototype.insertFullLines = function (e, t) {
            var n = 0,
              n = (e = Math.min(Math.max(e, 0), this.getLength())) < this.getLength() ? (t = t.concat([""]), 0) : (t = [""].concat(t), (this || _global).$lines[--e].length);
            this.insertMergedLines({
              row: e,
              column: n
            }, t);
          }, l.prototype.insertMergedLines = function (e, t) {
            var e = this.clippedPos(e.row, e.column),
              n = {
                row: e.row + t.length - 1,
                column: (1 == t.length ? e.column : 0) + t[t.length - 1].length
              };
            return this.applyDelta({
              start: e,
              end: n,
              action: "insert",
              lines: t
            }), this.clonePos(n);
          }, l.prototype.remove = function (e) {
            var t = this.clippedPos(e.start.row, e.start.column),
              e = this.clippedPos(e.end.row, e.end.column);
            return this.applyDelta({
              start: t,
              end: e,
              action: "remove",
              lines: this.getLinesForRange({
                start: t,
                end: e
              })
            }), this.clonePos(t);
          }, l.prototype.removeInLine = function (e, t, n) {
            t = this.clippedPos(e, t), e = this.clippedPos(e, n);
            return this.applyDelta({
              start: t,
              end: e,
              action: "remove",
              lines: this.getLinesForRange({
                start: t,
                end: e
              })
            }, !0), this.clonePos(t);
          }, l.prototype.removeFullLines = function (e, t) {
            e = Math.min(Math.max(0, e), this.getLength() - 1);
            var n = (t = Math.min(Math.max(0, t), this.getLength() - 1)) == this.getLength() - 1 && 0 < e,
              i = t < this.getLength() - 1,
              o = n ? e - 1 : e,
              n = n ? this.getLine(o).length : 0,
              r = i ? t + 1 : t,
              i = i ? 0 : this.getLine(r).length,
              o = new s(o, n, r, i),
              n = (this || _global).$lines.slice(e, t + 1);
            return this.applyDelta({
              start: o.start,
              end: o.end,
              action: "remove",
              lines: this.getLinesForRange(o)
            }), n;
          }, l.prototype.removeNewLine = function (e) {
            e < this.getLength() - 1 && 0 <= e && this.applyDelta({
              start: this.pos(e, this.getLine(e).length),
              end: this.pos(e + 1, 0),
              action: "remove",
              lines: ["", ""]
            });
          }, l.prototype.replace = function (e, t) {
            return e instanceof s || (e = s.fromPoints(e.start, e.end)), 0 === t.length && e.isEmpty() ? e.start : t == this.getTextRange(e) ? e.end : (this.remove(e), t ? this.insert(e.start, t) : e.start);
          }, l.prototype.applyDeltas = function (e) {
            for (var t = 0; t < e.length; t++) this.applyDelta(e[t]);
          }, l.prototype.revertDeltas = function (e) {
            for (var t = e.length - 1; 0 <= t; t--) this.revertDelta(e[t]);
          }, l.prototype.applyDelta = function (e, t) {
            var n = "insert" == e.action;
            (n ? e.lines.length <= 1 && !e.lines[0] : !s.comparePoints(e.start, e.end)) || (n && 20000 < e.lines.length ? this.$splitAndapplyLargeDelta(e, 20000) : (o((this || _global).$lines, e, t), this._signal("change", e)));
          }, l.prototype.$safeApplyDelta = function (e) {
            var t = (this || _global).$lines.length;
            ("remove" == e.action && e.start.row < t && e.end.row < t || "insert" == e.action && e.start.row <= t) && this.applyDelta(e);
          }, l.prototype.$splitAndapplyLargeDelta = function (e, t) {
            for (var n = e.lines, i = n.length - t + 1, o = e.start.row, r = e.start.column, s = 0, a = 0; s < i; s = a) {
              a += t - 1;
              var l = n.slice(s, a);
              l.push(""), this.applyDelta({
                start: this.pos(o + s, r),
                end: this.pos(o + a, r = 0),
                action: e.action,
                lines: l
              }, !0);
            }
            e.lines = n.slice(s), e.start.row = o + s, e.start.column = r, this.applyDelta(e, !0);
          }, l.prototype.revertDelta = function (e) {
            this.$safeApplyDelta({
              start: this.clonePos(e.start),
              end: this.clonePos(e.end),
              action: "insert" == e.action ? "remove" : "insert",
              lines: e.lines.slice()
            });
          }, l.prototype.indexToPosition = function (e, t) {
            for (var n = (this || _global).$lines || this.getAllLines(), i = this.getNewLineCharacter().length, o = t || 0, r = n.length; o < r; o++) if ((e -= n[o].length + i) < 0) return {
              row: o,
              column: e + n[o].length + i
            };
            return {
              row: r - 1,
              column: e + n[r - 1].length + i
            };
          }, l.prototype.positionToIndex = function (e, t) {
            for (var n = (this || _global).$lines || this.getAllLines(), i = this.getNewLineCharacter().length, o = 0, r = Math.min(e.row, n.length), s = t || 0; s < r; ++s) o += n[s].length + i;
            return o + e.column;
          }, l.prototype.$split = function (e) {
            return e.split(/\r\n|\r|\n/);
          }, l);
        function l(e) {
          (this || _global).$lines = [""], 0 === e.length ? (this || _global).$lines = [""] : Array.isArray(e) ? this.insertMergedLines({
            row: 0,
            column: 0
          }, e) : this.insert({
            row: 0,
            column: 0
          }, e);
        }
        e.prototype.$autoNewLine = "", e.prototype.$newLineMode = "auto", i.implement(e.prototype, r), t.Document = e;
      }), ace.define("ace/background_tokenizer", ["require", "exports", "module", "ace/lib/oop", "ace/lib/event_emitter"], function (e, t, n) {
        "use strict";

        var i = e("./lib/oop"),
          e = e("./lib/event_emitter").EventEmitter,
          o = (r.prototype.setTokenizer = function (e) {
            (this || _global).tokenizer = e, (this || _global).lines = [], (this || _global).states = [], this.start(0);
          }, r.prototype.setDocument = function (e) {
            (this || _global).doc = e, (this || _global).lines = [], (this || _global).states = [], this.stop();
          }, r.prototype.fireUpdateEvent = function (e, t) {
            this._signal("update", {
              data: {
                first: e,
                last: t
              }
            });
          }, r.prototype.start = function (e) {
            (this || _global).currentLine = Math.min(e || 0, (this || _global).currentLine, (this || _global).doc.getLength()), (this || _global).lines.splice((this || _global).currentLine, (this || _global).lines.length), (this || _global).states.splice((this || _global).currentLine, (this || _global).states.length), this.stop(), (this || _global).running = setTimeout((this || _global).$worker, 700);
          }, r.prototype.scheduleStart = function () {
            (this || _global).running || ((this || _global).running = setTimeout((this || _global).$worker, 700));
          }, r.prototype.$updateOnChange = function (e) {
            var t = e.start.row,
              n = e.end.row - t;
            0 == n ? (this || _global).lines[t] = null : "remove" == e.action ? ((this || _global).lines.splice(t, 1 + n, null), (this || _global).states.splice(t, 1 + n, null)) : ((e = Array(1 + n)).unshift(t, 1), (this || _global).lines.splice.apply((this || _global).lines, e), (this || _global).states.splice.apply((this || _global).states, e)), (this || _global).currentLine = Math.min(t, (this || _global).currentLine, (this || _global).doc.getLength()), this.stop();
          }, r.prototype.stop = function () {
            (this || _global).running && clearTimeout((this || _global).running), (this || _global).running = !1;
          }, r.prototype.getTokens = function (e) {
            return (this || _global).lines[e] || this.$tokenizeRow(e);
          }, r.prototype.getState = function (e) {
            return (this || _global).currentLine == e && this.$tokenizeRow(e), (this || _global).states[e] || "start";
          }, r.prototype.$tokenizeRow = function (e) {
            var t = (this || _global).doc.getLine(e),
              n = (this || _global).states[e - 1],
              t = (this || _global).tokenizer.getLineTokens(t, n, e);
            return (this || _global).states[e] + "" != t.state + "" ? ((this || _global).states[e] = t.state, (this || _global).lines[e + 1] = null, (this || _global).currentLine > e + 1 && ((this || _global).currentLine = e + 1)) : (this || _global).currentLine == e && ((this || _global).currentLine = e + 1), (this || _global).lines[e] = t.tokens;
          }, r.prototype.cleanup = function () {
            (this || _global).running = !1, (this || _global).lines = [], (this || _global).states = [], (this || _global).currentLine = 0, this.removeAllListeners();
          }, r);
        function r(e, t) {
          (this || _global).running = !1, (this || _global).lines = [], (this || _global).states = [], (this || _global).currentLine = 0, (this || _global).tokenizer = e;
          var a = this || _global;
          (this || _global).$worker = function () {
            if (a.running) {
              for (var e = new Date(), t = a.currentLine, n = -1, i = a.doc, o = t; a.lines[t];) t++;
              var r = i.getLength(),
                s = 0;
              for (a.running = !1; t < r;) {
                for (a.$tokenizeRow(t), n = t; t++, a.lines[t];);
                if (++s % 5 == 0 && 20 < new Date() - e) {
                  a.running = setTimeout(a.$worker, 20);
                  break;
                }
              }
              a.currentLine = t, o <= (n = -1 == n ? t : n) && a.fireUpdateEvent(o, n);
            }
          };
        }
        i.implement(o.prototype, e), t.BackgroundTokenizer = o;
      }), ace.define("ace/search_highlight", ["require", "exports", "module", "ace/lib/lang", "ace/range"], function (e, t, n) {
        "use strict";

        var u = e("./lib/lang"),
          g = e("./range").Range,
          e = (i.prototype.setRegexp = function (e) {
            (this || _global).regExp + "" != e + "" && ((this || _global).regExp = e, (this || _global).cache = []);
          }, i.prototype.update = function (e, t, n, i) {
            if ((this || _global).regExp) for (var o = i.firstRow, r = i.lastRow, s = {}, a = o; a <= r; a++) {
              var l = (this || _global).cache[a];
              null == l && (l = (l = (l = u.getMatchOffsets(n.getLine(a), (this || _global).regExp)).length > (this || _global).MAX_RANGES ? l.slice(0, (this || _global).MAX_RANGES) : l).map(function (e) {
                return new g(a, e.offset, a, e.offset + e.length);
              }), (this || _global).cache[a] = l.length ? l : "");
              for (var c = l.length; c--;) {
                var h = l[c].toScreenRange(n),
                  d = h.toString();
                s[d] || (s[d] = !0, t.drawSingleLineMarker(e, h, (this || _global).clazz, i));
              }
            }
          }, i);
        function i(e, t, n) {
          void 0 === n && (n = "text"), this.setRegexp(e), (this || _global).clazz = t, (this || _global).type = n;
        }
        e.prototype.MAX_RANGES = 500, t.SearchHighlight = e;
      }), ace.define("ace/edit_session/fold_line", ["require", "exports", "module", "ace/range"], function (e, t, n) {
        "use strict";

        var i = e("../range").Range;
        function o(e, t) {
          (this || _global).foldData = e, Array.isArray(t) ? (this || _global).folds = t : t = (this || _global).folds = [t];
          e = t[t.length - 1];
          (this || _global).range = new i(t[0].start.row, t[0].start.column, e.end.row, e.end.column), (this || _global).start = (this || _global).range.start, (this || _global).end = (this || _global).range.end, (this || _global).folds.forEach(function (e) {
            e.setFoldLine(this || _global);
          }, this || _global);
        }
        o.prototype.shiftRow = function (t) {
          (this || _global).start.row += t, (this || _global).end.row += t, (this || _global).folds.forEach(function (e) {
            e.start.row += t, e.end.row += t;
          });
        }, o.prototype.addFold = function (e) {
          if (e.sameRow) {
            if (e.start.row < (this || _global).startRow || e.endRow > (this || _global).endRow) throw new Error("Can't add a fold to this FoldLine as it has no connection");
            (this || _global).folds.push(e), (this || _global).folds.sort(function (e, t) {
              return -e.range.compareEnd(t.start.row, t.start.column);
            }), 0 < (this || _global).range.compareEnd(e.start.row, e.start.column) ? ((this || _global).end.row = e.end.row, (this || _global).end.column = e.end.column) : (this || _global).range.compareStart(e.end.row, e.end.column) < 0 && ((this || _global).start.row = e.start.row, (this || _global).start.column = e.start.column);
          } else if (e.start.row == (this || _global).end.row) (this || _global).folds.push(e), (this || _global).end.row = e.end.row, (this || _global).end.column = e.end.column;else {
            if (e.end.row != (this || _global).start.row) throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
            (this || _global).folds.unshift(e), (this || _global).start.row = e.start.row, (this || _global).start.column = e.start.column;
          }
          e.foldLine = this || _global;
        }, o.prototype.containsRow = function (e) {
          return e >= (this || _global).start.row && e <= (this || _global).end.row;
        }, o.prototype.walk = function (e, t, n) {
          var i,
            o,
            r = 0,
            s = (this || _global).folds,
            a = !0;
          null == t && (t = (this || _global).end.row, n = (this || _global).end.column);
          for (var l = 0; l < s.length; l++) {
            if (-1 == (o = (i = s[l]).range.compareStart(t, n))) return void e(null, t, n, r, a);
            if (!e(null, i.start.row, i.start.column, r, a) && e(i.placeholder, i.start.row, i.start.column, r) || 0 === o) return;
            a = !i.sameRow, r = i.end.column;
          }
          e(null, t, n, r, a);
        }, o.prototype.getNextFoldTo = function (e, t) {
          for (var n, i, o = 0; o < (this || _global).folds.length; o++) {
            if (-1 == (i = (n = (this || _global).folds[o]).range.compareEnd(e, t))) return {
              fold: n,
              kind: "after"
            };
            if (0 === i) return {
              fold: n,
              kind: "inside"
            };
          }
          return null;
        }, o.prototype.addRemoveChars = function (e, t, n) {
          var i,
            o = this.getNextFoldTo(e, t);
          if (o) if (i = o.fold, "inside" == o.kind && i.start.column != t && i.start.row != e) window.console && window.console.log(e, t, i);else if (i.start.row == e) {
            var r,
              s = (r = (this || _global).folds).indexOf(i);
            for (0 === s && ((this || _global).start.column += n); s < r.length; s++) {
              if ((i = r[s]).start.column += n, !i.sameRow) return;
              i.end.column += n;
            }
            (this || _global).end.column += n;
          }
        }, o.prototype.split = function (e, t) {
          var n,
            i,
            e = this.getNextFoldTo(e, t);
          return e && "inside" != e.kind ? (t = e.fold, e = (this || _global).folds, n = (this || _global).foldData, t = e.indexOf(t), i = e[t - 1], (this || _global).end.row = i.end.row, (this || _global).end.column = i.end.column, i = new o(n, e = e.splice(t, e.length - t)), n.splice(n.indexOf(this || _global) + 1, 0, i), i) : null;
        }, o.prototype.merge = function (e) {
          for (var t = e.folds, n = 0; n < t.length; n++) this.addFold(t[n]);
          var i = (this || _global).foldData;
          i.splice(i.indexOf(e), 1);
        }, o.prototype.toString = function () {
          var t = [(this || _global).range.toString() + ": ["];
          return (this || _global).folds.forEach(function (e) {
            t.push("  " + e.toString());
          }), t.push("]"), t.join("\n");
        }, o.prototype.idxToPosition = function (e) {
          for (var t = 0, n = 0; n < (this || _global).folds.length; n++) {
            var i = (this || _global).folds[n];
            if ((e -= i.start.column - t) < 0) return {
              row: i.start.row,
              column: i.start.column + e
            };
            if ((e -= i.placeholder.length) < 0) return i.start;
            t = i.end.column;
          }
          return {
            row: (this || _global).end.row,
            column: (this || _global).end.column + e
          };
        }, t.FoldLine = o;
      }), ace.define("ace/range_list", ["require", "exports", "module", "ace/range"], function (e, t, n) {
        "use strict";

        var a = e("./range").Range.comparePoints,
          e = (i.prototype.pointIndex = function (e, t, n) {
            for (var i = (this || _global).ranges, o = n || 0; o < i.length; o++) {
              var r = i[o],
                s = a(e, r.end);
              if (!(0 < s)) return r = a(e, r.start), 0 === s ? t && 0 !== r ? -o - 2 : o : 0 < r || 0 === r && !t ? o : -o - 1;
            }
            return -o - 1;
          }, i.prototype.add = function (e) {
            var t = !e.isEmpty(),
              n = this.pointIndex(e.start, t),
              t = this.pointIndex(e.end, t, n = n < 0 ? -n - 1 : n);
            return t < 0 ? t = -t - 1 : t++, (this || _global).ranges.splice(n, t - n, e);
          }, i.prototype.addList = function (e) {
            for (var t = [], n = e.length; n--;) t.push.apply(t, this.add(e[n]));
            return t;
          }, i.prototype.substractPoint = function (e) {
            e = this.pointIndex(e);
            if (0 <= e) return (this || _global).ranges.splice(e, 1);
          }, i.prototype.merge = function () {
            for (var e = [], t = (this || _global).ranges, n = (t = t.sort(function (e, t) {
                return a(e.start, t.start);
              }))[0], i = 1; i < t.length; i++) {
              var o = n,
                n = t[i],
                r = a(o.end, n.start);
              r < 0 || (0 != r || o.isEmpty() || n.isEmpty()) && (a(o.end, n.end) < 0 && (o.end.row = n.end.row, o.end.column = n.end.column), t.splice(i, 1), e.push(n), n = o, i--);
            }
            return (this || _global).ranges = t, e;
          }, i.prototype.contains = function (e, t) {
            return 0 <= this.pointIndex({
              row: e,
              column: t
            });
          }, i.prototype.containsPoint = function (e) {
            return 0 <= this.pointIndex(e);
          }, i.prototype.rangeAtPoint = function (e) {
            e = this.pointIndex(e);
            if (0 <= e) return (this || _global).ranges[e];
          }, i.prototype.clipRows = function (e, t) {
            var n = (this || _global).ranges;
            if (n[0].start.row > t || n[n.length - 1].start.row < e) return [];
            for (var e = this.pointIndex({
                row: e,
                column: 0
              }), i = this.pointIndex({
                row: t,
                column: 0
              }, e = e < 0 ? -e - 1 : e), o = (i < 0 && (i = -i - 1), []), r = e; r < i; r++) o.push(n[r]);
            return o;
          }, i.prototype.removeAll = function () {
            return (this || _global).ranges.splice(0, (this || _global).ranges.length);
          }, i.prototype.attach = function (e) {
            (this || _global).session && this.detach(), (this || _global).session = e, (this || _global).onChange = (this || _global).$onChange.bind(this || _global), (this || _global).session.on("change", (this || _global).onChange);
          }, i.prototype.detach = function () {
            (this || _global).session && ((this || _global).session.removeListener("change", (this || _global).onChange), (this || _global).session = null);
          }, i.prototype.$onChange = function (e) {
            for (var t = e.start, n = e.end, i = t.row, o = n.row, r = (this || _global).ranges, s = 0, a = r.length; s < a && !((h = r[s]).end.row >= i); s++);
            if ("insert" == e.action) for (var l = o - i, c = -t.column + n.column; s < a; s++) {
              if ((h = r[s]).start.row > i) break;
              h.start.row == i && h.start.column >= t.column && (h.start.column == t.column && (this || _global).$bias <= 0 || (h.start.column += c, h.start.row += l)), h.end.row == i && h.end.column >= t.column && (h.end.column == t.column && (this || _global).$bias < 0 || (h.end.column == t.column && 0 < c && s < a - 1 && h.end.column > h.start.column && h.end.column == r[s + 1].start.column && (h.end.column -= c), h.end.column += c, h.end.row += l));
            } else for (var h, l = i - o, c = t.column - n.column; s < a; s++) {
              if ((h = r[s]).start.row > o) break;
              h.end.row < o && (i < h.end.row || i == h.end.row && t.column < h.end.column) ? (h.end.row = i, h.end.column = t.column) : h.end.row == o ? h.end.column <= n.column ? (l || h.end.column > t.column) && (h.end.column = t.column, h.end.row = t.row) : (h.end.column += c, h.end.row += l) : h.end.row > o && (h.end.row += l), h.start.row < o && (i < h.start.row || i == h.start.row && t.column < h.start.column) ? (h.start.row = i, h.start.column = t.column) : h.start.row == o ? h.start.column <= n.column ? (l || h.start.column > t.column) && (h.start.column = t.column, h.start.row = t.row) : (h.start.column += c, h.start.row += l) : h.start.row > o && (h.start.row += l);
            }
            if (0 != l && s < a) for (; s < a; s++) (h = r[s]).start.row += l, h.end.row += l;
          }, i);
        function i() {
          (this || _global).ranges = [], (this || _global).$bias = 1;
        }
        e.prototype.comparePoints = a, t.RangeList = e;
      }), ace.define("ace/edit_session/fold", ["require", "exports", "module", "ace/range_list"], function (e, t, n) {
        "use strict";

        var i,
          o,
          r = (this || _global) && (this || _global).__extends || (i = function (e, t) {
            return (i = Object.setPrototypeOf || ({
              __proto__: []
            } instanceof Array ? function (e, t) {
              e.__proto__ = t;
            } : function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }))(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              (this || _global).constructor = e;
            }
            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          e = e("../range_list").RangeList,
          r = (r(s, o = e), s.prototype.toString = function () {
            return "\"" + (this || _global).placeholder + "\" " + (this || _global).range.toString();
          }, s.prototype.setFoldLine = function (t) {
            (this || _global).foldLine = t, (this || _global).subFolds.forEach(function (e) {
              e.setFoldLine(t);
            });
          }, s.prototype.clone = function () {
            var t = new s((this || _global).range.clone(), (this || _global).placeholder);
            return (this || _global).subFolds.forEach(function (e) {
              t.subFolds.push(e.clone());
            }), t.collapseChildren = (this || _global).collapseChildren, t;
          }, s.prototype.addSubFold = function (e) {
            if (!(this || _global).range.isEqual(e)) {
              r = e, s = (this || _global).start, d(r.start, s), d(r.end, s);
              for (var t = e.start.row, n = e.start.column, i = 0, o = -1; i < (this || _global).subFolds.length && 1 == (o = (this || _global).subFolds[i].range.compare(t, n)); i++);
              var r = (this || _global).subFolds[i],
                s = 0;
              if (0 == o) {
                if (r.range.containsRange(e)) return r.addSubFold(e);
                s = 1;
              }
              for (var t = e.range.end.row, n = e.range.end.column, a = i, o = -1; a < (this || _global).subFolds.length && 1 == (o = (this || _global).subFolds[a].range.compare(t, n)); a++);
              0 == o && a++;
              for (var l = (this || _global).subFolds.splice(i, a - i, e), c = 0 == o ? l.length - 1 : l.length, h = s; h < c; h++) e.addSubFold(l[h]);
              return e.setFoldLine((this || _global).foldLine), e;
            }
          }, s.prototype.restoreRange = function (e) {
            return e = e, t = (this || _global).start, a(e.start, t), void a(e.end, t);
            var t;
          }, s);
        function s(e, t) {
          var n = o.call(this || _global) || this || _global;
          return n.foldLine = null, n.placeholder = t, n.range = e, n.start = e.start, n.end = e.end, n.sameRow = e.start.row == e.end.row, n.subFolds = n.ranges = [], n;
        }
        function d(e, t) {
          e.row -= t.row, 0 == e.row && (e.column -= t.column);
        }
        function a(e, t) {
          0 == e.row && (e.column += t.column), e.row += t.row;
        }
        t.Fold = r;
      }), ace.define("ace/edit_session/folding", ["require", "exports", "module", "ace/range", "ace/edit_session/fold_line", "ace/edit_session/fold", "ace/token_iterator", "ace/mouse/mouse_event"], function (e, t, n) {
        "use strict";

        var c = e("../range").Range,
          u = e("./fold_line").FoldLine,
          g = e("./fold").Fold,
          h = e("../token_iterator").TokenIterator,
          i = e("../mouse/mouse_event").MouseEvent;
        t.Folding = function () {
          (this || _global).getFoldAt = function (e, t, n) {
            var i = this.getFoldLine(e);
            if (!i) return null;
            for (var o = i.folds, r = 0; r < o.length; r++) {
              var s = o[r].range;
              if (s.contains(e, t) && (1 != n || !s.isEnd(e, t) || s.isEmpty()) && (-1 != n || !s.isStart(e, t) || s.isEmpty())) return o[r];
            }
          }, (this || _global).getFoldsInRange = function (e) {
            var t = e.start,
              n = e.end,
              i = (this || _global).$foldData,
              o = [];
            t.column += 1, --n.column;
            for (var r = 0; r < i.length; r++) {
              var s = i[r].range.compareRange(e);
              if (2 != s) {
                if (-2 == s) break;
                for (var a = i[r].folds, l = 0; l < a.length; l++) {
                  var c = a[l];
                  if (-2 == (s = c.range.compareRange(e))) break;
                  if (2 != s) {
                    if (42 == s) break;
                    o.push(c);
                  }
                }
              }
            }
            return --t.column, n.column += 1, o;
          }, (this || _global).getFoldsInRangeList = function (e) {
            var t;
            return Array.isArray(e) ? (t = [], e.forEach(function (e) {
              t = t.concat(this.getFoldsInRange(e));
            }, this || _global)) : t = this.getFoldsInRange(e), t;
          }, (this || _global).getAllFolds = function () {
            for (var e = [], t = (this || _global).$foldData, n = 0; n < t.length; n++) for (var i = 0; i < t[n].folds.length; i++) e.push(t[n].folds[i]);
            return e;
          }, (this || _global).getFoldStringAt = function (e, t, n, i) {
            if (!(i = i || this.getFoldLine(e))) return null;
            for (var o, r = {
                end: {
                  column: 0
                }
              }, s = 0; s < i.folds.length; s++) {
              var a,
                l = (a = i.folds[s]).range.compareEnd(e, t);
              if (-1 == l) {
                o = this.getLine(a.start.row).substring(r.end.column, a.start.column);
                break;
              }
              if (0 === l) return null;
              r = a;
            }
            return o = o || this.getLine(a.start.row).substring(r.end.column), -1 == n ? o.substring(0, t - r.end.column) : 1 == n ? o.substring(t - r.end.column) : o;
          }, (this || _global).getFoldLine = function (e, t) {
            var n = (this || _global).$foldData,
              i = 0;
            for (-1 == (i = t ? n.indexOf(t) : i) && (i = 0); i < n.length; i++) {
              var o = n[i];
              if (o.start.row <= e && o.end.row >= e) return o;
              if (o.end.row > e) return null;
            }
            return null;
          }, (this || _global).getNextFoldLine = function (e, t) {
            var n = (this || _global).$foldData,
              i = 0;
            for (-1 == (i = t ? n.indexOf(t) : i) && (i = 0); i < n.length; i++) {
              var o = n[i];
              if (o.end.row >= e) return o;
            }
            return null;
          }, (this || _global).getFoldedRowCount = function (e, t) {
            for (var n = (this || _global).$foldData, i = t - e + 1, o = 0; o < n.length; o++) {
              var r = n[o],
                s = r.end.row,
                r = r.start.row;
              if (t <= s) {
                r < t && (e <= r ? i -= t - r : i = 0);
                break;
              }
              e <= s && (i -= e <= r ? s - r : s - e + 1);
            }
            return i;
          }, (this || _global).$addFoldLine = function (e) {
            return (this || _global).$foldData.push(e), (this || _global).$foldData.sort(function (e, t) {
              return e.start.row - t.start.row;
            }), e;
          }, (this || _global).addFold = function (e, t) {
            var n,
              i = (this || _global).$foldData,
              o = !1,
              r = (e instanceof g ? n = e : (n = new g(t, e)).collapseChildren = t.collapseChildren, this.$clipRangeToDocument(n.range), n.start.row),
              e = n.start.column,
              s = n.end.row,
              t = n.end.column,
              a = this.getFoldAt(r, e, 1),
              l = this.getFoldAt(s, t, -1);
            if (a && l == a) return a.addSubFold(n);
            a && !a.range.isStart(r, e) && this.removeFold(a), l && !l.range.isEnd(s, t) && this.removeFold(l);
            e = this.getFoldsInRange(n.range);
            0 < e.length && (this.removeFolds(e), n.collapseChildren || e.forEach(function (e) {
              n.addSubFold(e);
            }));
            for (var c = 0; c < i.length; c++) {
              var h = i[c];
              if (s == h.start.row) {
                h.addFold(n), o = !0;
                break;
              }
              if (r == h.end.row) {
                if (h.addFold(n), o = !0, !n.sameRow) {
                  var d = i[c + 1];
                  if (d && d.start.row == s) {
                    h.merge(d);
                    break;
                  }
                }
                break;
              }
              if (s <= h.start.row) break;
            }
            return o || (h = this.$addFoldLine(new u((this || _global).$foldData, n))), (this || _global).$useWrapMode ? this.$updateWrapData(h.start.row, h.start.row) : this.$updateRowLengthCache(h.start.row, h.start.row), (this || _global).$modified = !0, this._signal("changeFold", {
              data: n,
              action: "add"
            }), n;
          }, (this || _global).addFolds = function (e) {
            e.forEach(function (e) {
              this.addFold(e);
            }, this || _global);
          }, (this || _global).removeFold = function (e) {
            var t = e.foldLine,
              n = t.start.row,
              i = t.end.row,
              o = (this || _global).$foldData,
              r = t.folds;
            1 == r.length ? o.splice(o.indexOf(t), 1) : t.range.isEnd(e.end.row, e.end.column) ? (r.pop(), t.end.row = r[r.length - 1].end.row, t.end.column = r[r.length - 1].end.column) : t.range.isStart(e.start.row, e.start.column) ? (r.shift(), t.start.row = r[0].start.row, t.start.column = r[0].start.column) : e.sameRow ? r.splice(r.indexOf(e), 1) : ((r = (o = t.split(e.start.row, e.start.column)).folds).shift(), o.start.row = r[0].start.row, o.start.column = r[0].start.column), (this || _global).$updating || ((this || _global).$useWrapMode ? this.$updateWrapData(n, i) : this.$updateRowLengthCache(n, i)), (this || _global).$modified = !0, this._signal("changeFold", {
              data: e,
              action: "remove"
            });
          }, (this || _global).removeFolds = function (e) {
            for (var t = [], n = 0; n < e.length; n++) t.push(e[n]);
            t.forEach(function (e) {
              this.removeFold(e);
            }, this || _global), (this || _global).$modified = !0;
          }, (this || _global).expandFold = function (t) {
            this.removeFold(t), t.subFolds.forEach(function (e) {
              t.restoreRange(e), this.addFold(e);
            }, this || _global), 0 < t.collapseChildren && this.foldAll(t.start.row + 1, t.end.row, t.collapseChildren - 1), t.subFolds = [];
          }, (this || _global).expandFolds = function (e) {
            e.forEach(function (e) {
              this.expandFold(e);
            }, this || _global);
          }, (this || _global).unfold = function (e, t) {
            var n;
            if (null == e) n = new c(0, 0, this.getLength(), 0), null == t && (t = !0);else if ("number" == typeof e) n = new c(e, 0, e, this.getLine(e).length);else if ("row" in e) n = c.fromPoints(e, e);else {
              if (Array.isArray(e)) return i = [], e.forEach(function (e) {
                i = i.concat(this.unfold(e));
              }, this || _global), i;
              n = e;
            }
            for (var i, e = i = this.getFoldsInRangeList(n); 1 == i.length && c.comparePoints(i[0].start, n.start) < 0 && 0 < c.comparePoints(i[0].end, n.end);) this.expandFolds(i), i = this.getFoldsInRangeList(n);
            if (0 != t ? this.removeFolds(i) : this.expandFolds(i), e.length) return e;
          }, (this || _global).isRowFolded = function (e, t) {
            return !!this.getFoldLine(e, t);
          }, (this || _global).getRowFoldEnd = function (e, t) {
            t = this.getFoldLine(e, t);
            return t ? t.end.row : e;
          }, (this || _global).getRowFoldStart = function (e, t) {
            t = this.getFoldLine(e, t);
            return t ? t.start.row : e;
          }, (this || _global).getFoldDisplayLine = function (e, t, n, o, r) {
            null == o && (o = e.start.row), null == r && (r = 0), null == t && (t = e.end.row), null == n && (n = this.getLine(t).length);
            var s = (this || _global).doc,
              a = "";
            return e.walk(function (e, t, n, i) {
              if (!(t < o)) {
                if (t == o) {
                  if (n < r) return;
                  i = Math.max(r, i);
                }
                a += null != e ? e : s.getLine(t).substring(i, n);
              }
            }, t, n), a;
          }, (this || _global).getDisplayLine = function (e, t, n, i) {
            var o = this.getFoldLine(e);
            return o ? this.getFoldDisplayLine(o, e, t, n, i) : (o = (this || _global).doc.getLine(e)).substring(i || 0, t || o.length);
          }, (this || _global).$cloneFoldData = function () {
            var t = [];
            return t = (this || _global).$foldData.map(function (e) {
              e = e.folds.map(function (e) {
                return e.clone();
              });
              return new u(t, e);
            });
          }, (this || _global).toggleFold = function (e) {
            var t = (this || _global).selection.getRange();
            if (t.isEmpty()) {
              var n,
                i = t.start;
              if (n = this.getFoldAt(i.row, i.column)) return void this.expandFold(n);
              (o = this.findMatchingBracket(i)) ? 1 == t.comparePoint(o) ? t.end = o : (t.start = o, t.start.column++, t.end.column--) : (o = this.findMatchingBracket({
                row: i.row,
                column: i.column + 1
              })) ? (1 == t.comparePoint(o) ? t.end = o : t.start = o, t.start.column++) : t = this.getCommentFoldRange(i.row, i.column) || t;
            } else {
              var o = this.getFoldsInRange(t);
              if (e && o.length) return void this.expandFolds(o);
              1 == o.length && (n = o[0]);
            }
            if ((n = n || this.getFoldAt(t.start.row, t.start.column)) && n.range.toString() == t.toString()) this.expandFold(n);else {
              i = "...";
              if (!t.isMultiLine()) {
                if ((i = this.getTextRange(t)).length < 4) return;
                i = i.trim().substring(0, 2) + "..";
              }
              this.addFold(i, t);
            }
          }, (this || _global).getCommentFoldRange = function (e, t, n) {
            var i = new h(this || _global, e, t),
              o = i.getCurrentToken(),
              r = o && o.type;
            if (o && /^comment|string/.test(r)) {
              "comment" == (r = r.match(/comment|string/)[0]) && (r += "|doc-start");
              var s = new RegExp(r),
                r = new c();
              if (1 != n) {
                for (; (o = i.stepBackward()) && s.test(o.type) && !/^comment.end/.test(o.type););
                o = i.stepForward();
              }
              if (r.start.row = i.getCurrentTokenRow(), r.start.column = i.getCurrentTokenColumn() + (/^comment.start/.test(o.type) ? o.value.length : 2), i = new h(this || _global, e, t), -1 != n) {
                var a = -1;
                do {
                  if (o = i.stepForward(), -1 == a) {
                    var l = this.getState(i.$row);
                    s.test(l) || (a = i.$row);
                  } else if (i.$row > a) break;
                } while (o && s.test(o.type) && !/^comment.start/.test(o.type));
                o = i.stepBackward();
              } else o = i.getCurrentToken();
              return r.end.row = i.getCurrentTokenRow(), r.end.column = i.getCurrentTokenColumn(), /^comment.end/.test(o.type) || (r.end.column += o.value.length - 2), r;
            }
          }, (this || _global).foldAll = function (e, t, n, i) {
            null == n && (n = 100000);
            var o = (this || _global).foldWidgets;
            if (o) {
              t = t || this.getLength();
              for (var r, s = e = e || 0; s < t; s++) null == o[s] && (o[s] = this.getFoldWidget(s)), "start" != o[s] || i && !i(s) || (r = this.getFoldWidgetRange(s)) && r.isMultiLine() && r.end.row <= t && r.start.row >= e && (s = r.end.row, r.collapseChildren = n, this.addFold("...", r));
            }
          }, (this || _global).foldToLevel = function (e) {
            for (this.foldAll(); 0 < e--;) this.unfold(null, !1);
          }, (this || _global).foldAllComments = function () {
            var o = this || _global;
            this.foldAll(null, null, null, function (e) {
              for (var t = o.getTokens(e), n = 0; n < t.length; n++) {
                var i = t[n];
                if ("text" != i.type || !/^\s+$/.test(i.value)) return !!/comment/.test(i.type);
              }
            });
          }, (this || _global).$foldStyles = {
            manual: 1,
            markbegin: 1,
            markbeginend: 1
          }, (this || _global).$foldStyle = "markbegin", (this || _global).setFoldStyle = function (e) {
            if (!(this || _global).$foldStyles[e]) throw new Error("invalid fold style: " + e + "[" + Object.keys((this || _global).$foldStyles).join(", ") + "]");
            (this || _global).$foldStyle != e && ("manual" == ((this || _global).$foldStyle = e) && this.unfold(), e = (this || _global).$foldMode, this.$setFolding(null), this.$setFolding(e));
          }, (this || _global).$setFolding = function (e) {
            (this || _global).$foldMode != e && ((this || _global).$foldMode = e, this.off("change", (this || _global).$updateFoldWidgets), this.off("tokenizerUpdate", (this || _global).$tokenizerUpdateFoldWidgets), this._signal("changeAnnotation"), e && "manual" != (this || _global).$foldStyle ? ((this || _global).foldWidgets = [], (this || _global).getFoldWidget = e.getFoldWidget.bind(e, this || _global, (this || _global).$foldStyle), (this || _global).getFoldWidgetRange = e.getFoldWidgetRange.bind(e, this || _global, (this || _global).$foldStyle), (this || _global).$updateFoldWidgets = (this || _global).updateFoldWidgets.bind(this || _global), (this || _global).$tokenizerUpdateFoldWidgets = (this || _global).tokenizerUpdateFoldWidgets.bind(this || _global), this.on("change", (this || _global).$updateFoldWidgets), this.on("tokenizerUpdate", (this || _global).$tokenizerUpdateFoldWidgets)) : (this || _global).foldWidgets = null);
          }, (this || _global).getParentFoldRangeData = function (e, t) {
            var n = (this || _global).foldWidgets;
            if (!n || t && n[e]) return {};
            for (var i = e - 1; 0 <= i;) {
              var o = n[i];
              if ("start" == (o = null == o ? n[i] = this.getFoldWidget(i) : o)) {
                var r = this.getFoldWidgetRange(i),
                  s = s || r;
                if (r && r.end.row >= e) break;
              }
              i--;
            }
            return {
              range: -1 !== i && r,
              firstRange: s
            };
          }, (this || _global).onFoldWidgetClick = function (e, t) {
            var n = {
              children: (t = t instanceof i ? t.domEvent : t).shiftKey,
              all: t.ctrlKey || t.metaKey,
              siblings: t.altKey
            };
            this.$toggleFoldWidget(e, n) || (e = t.target || t.srcElement) && /ace_fold-widget/.test(e.className) && (e.className += " ace_invalid");
          }, (this || _global).$toggleFoldWidget = function (e, t) {
            var n, i, o, r;
            if ((this || _global).getFoldWidget) return n = this.getFoldWidget(e), i = this.getLine(e), (i = this.getFoldAt(e, -1 == (n = "end" === n ? -1 : 1) ? 0 : i.length, n)) ? (t.children || t.all ? this.removeFold(i) : this.expandFold(i), i) : (n = this.getFoldWidgetRange(e, !0)) && !n.isMultiLine() && (i = this.getFoldAt(n.start.row, n.start.column, 1)) && n.isEqual(i.range) ? (this.removeFold(i), i) : (t.siblings ? ((i = this.getParentFoldRangeData(e)).range && (o = i.range.start.row + 1, r = i.range.end.row), this.foldAll(o, r, t.all ? 10000 : 0)) : t.children ? (r = n ? n.end.row : this.getLength(), this.foldAll(e + 1, r, t.all ? 10000 : 0)) : n && (t.all && (n.collapseChildren = 10000), this.addFold("...", n)), n);
          }, (this || _global).toggleFoldWidget = function (e) {
            var t,
              n = (this || _global).selection.getCursor().row;
            n = this.getRowFoldStart(n), !this.$toggleFoldWidget(n, {}) && (t = (t = this.getParentFoldRangeData(n, !0)).range || t.firstRange) && (n = t.start.row, (n = this.getFoldAt(n, this.getLine(n).length, 1)) ? this.removeFold(n) : this.addFold("...", t));
          }, (this || _global).updateFoldWidgets = function (e) {
            var t = e.start.row,
              n = e.end.row - t;
            0 == n ? (this || _global).foldWidgets[t] = null : "remove" == e.action ? (this || _global).foldWidgets.splice(t, 1 + n, null) : ((e = Array(1 + n)).unshift(t, 1), (this || _global).foldWidgets.splice.apply((this || _global).foldWidgets, e));
          }, (this || _global).tokenizerUpdateFoldWidgets = function (e) {
            e = e.data;
            e.first != e.last && (this || _global).foldWidgets.length > e.first && (this || _global).foldWidgets.splice(e.first, (this || _global).foldWidgets.length);
          };
        };
      }), ace.define("ace/edit_session/bracket_match", ["require", "exports", "module", "ace/token_iterator", "ace/range"], function (e, t, n) {
        "use strict";

        var d = e("../token_iterator").TokenIterator,
          C = e("../range").Range;
        t.BracketMatch = function () {
          (this || _global).findMatchingBracket = function (e, t) {
            return 0 != e.column && "" != (t = t || this.getLine(e.row).charAt(e.column - 1)) && (t = t.match(/([\(\[\{])|([\)\]\}])/)) ? t[1] ? this.$findClosingBracket(t[1], e) : this.$findOpeningBracket(t[2], e) : null;
          }, (this || _global).getBracketRange = function (e) {
            var t,
              n,
              i = this.getLine(e.row),
              o = !0,
              r = i.charAt(e.column - 1),
              s = r && r.match(/([\(\[\{])|([\)\]\}])/);
            if (s || (r = i.charAt(e.column), e = {
              row: e.row,
              column: e.column + 1
            }, s = r && r.match(/([\(\[\{])|([\)\]\}])/), o = !1), !s) return null;
            if (s[1]) {
              if (!(n = this.$findClosingBracket(s[1], e))) return null;
              t = C.fromPoints(e, n), o || (t.end.column++, t.start.column--), t.cursor = t.end;
            } else {
              if (!(n = this.$findOpeningBracket(s[2], e))) return null;
              t = C.fromPoints(n, e), o || (t.start.column++, t.end.column--), t.cursor = t.start;
            }
            return t;
          }, (this || _global).getMatchingBracketRanges = function (e, t) {
            var n = this.getLine(e.row),
              i = /([\(\[\{])|([\)\]\}])/,
              o = !t && n.charAt(e.column - 1),
              r = o && o.match(i);
            return r || (o = (void 0 === t || t) && n.charAt(e.column), e = {
              row: e.row,
              column: e.column + 1
            }, r = o && o.match(i)), r ? (t = new C(e.row, e.column - 1, e.row, e.column), (n = r[1] ? this.$findClosingBracket(r[1], e) : this.$findOpeningBracket(r[2], e)) ? [t, new C(n.row, n.column, n.row, n.column + 1)] : [t]) : null;
          }, (this || _global).$brackets = {
            ")": "(",
            "(": ")",
            "]": "[",
            "[": "]",
            "{": "}",
            "}": "{",
            "<": ">",
            ">": "<"
          }, (this || _global).$findOpeningBracket = function (e, t, n) {
            var i = (this || _global).$brackets[e],
              o = 1,
              r = new d(this || _global, t.row, t.column),
              s = r.getCurrentToken();
            if (s = s || r.stepForward()) {
              n = n || new RegExp("(\\.?" + s.type.replace(".", "\\.").replace("rparen", ".paren").replace(/\b(?:end)\b/, "(?:start|begin|end)").replace(/-close\b/, "-(close|open)") + ")+");
              for (var a = t.column - r.getCurrentTokenColumn() - 2, l = s.value;;) {
                for (; 0 <= a;) {
                  var c = l.charAt(a);
                  if (c == i) {
                    if (0 == --o) return {
                      row: r.getCurrentTokenRow(),
                      column: a + r.getCurrentTokenColumn()
                    };
                  } else c == e && (o += 1);
                  --a;
                }
                for (; (s = r.stepBackward()) && !n.test(s.type););
                if (null == s) break;
                a = (l = s.value).length - 1;
              }
              return null;
            }
          }, (this || _global).$findClosingBracket = function (e, t, n) {
            var i = (this || _global).$brackets[e],
              o = 1,
              r = new d(this || _global, t.row, t.column),
              s = r.getCurrentToken();
            if (s = s || r.stepForward()) {
              n = n || new RegExp("(\\.?" + s.type.replace(".", "\\.").replace("lparen", ".paren").replace(/\b(?:start|begin)\b/, "(?:start|begin|end)").replace(/-open\b/, "-(close|open)") + ")+");
              for (var a = t.column - r.getCurrentTokenColumn();;) {
                for (var l = s.value, c = l.length; a < c;) {
                  var h = l.charAt(a);
                  if (h == i) {
                    if (0 == --o) return {
                      row: r.getCurrentTokenRow(),
                      column: a + r.getCurrentTokenColumn()
                    };
                  } else h == e && (o += 1);
                  a += 1;
                }
                for (; (s = r.stepForward()) && !n.test(s.type););
                if (null == s) break;
                a = 0;
              }
              return null;
            }
          }, (this || _global).getMatchingTags = function (e) {
            var e = new d(this || _global, e.row, e.column),
              t = this.$findTagName(e);
            if (t) return "<" === e.stepBackward().value ? this.$findClosingTag(e, t) : this.$findOpeningTag(e, t);
          }, (this || _global).$findTagName = function (e) {
            var t = e.getCurrentToken(),
              n = !1,
              i = !1;
            if (t && -1 === t.type.indexOf("tag-name")) for (; (t = i ? e.stepBackward() : e.stepForward()) && ("/>" === t.value ? i = !0 : -1 !== t.type.indexOf("tag-name") && (n = !0)), t && !n;);
            return t;
          }, (this || _global).$findClosingTag = function (e, t) {
            var n = t.value,
              i = t.value,
              o = 0,
              r = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1),
              s = (t = e.stepForward(), new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + t.value.length)),
              a = !1;
            do {
              var l,
                c = t;
              if (t = e.stepForward()) if (">" !== t.value || a || (l = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1), a = !0), -1 !== t.type.indexOf("tag-name")) {
                if (i === (n = t.value)) if ("<" === c.value) o++;else if ("</" === c.value && --o < 0) {
                  e.stepBackward();
                  var h = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 2),
                    d = (t = e.stepForward(), new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + t.value.length));
                  if (!(t = e.stepForward()) || ">" !== t.value) return;
                  var u = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1);
                }
              } else i === n && "/>" === t.value && --o < 0 && (u = d = h = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 2), l = new C(s.end.row, s.end.column, s.end.row, s.end.column + 1));
            } while (t && 0 <= o);
            if (r && l && h && u && s && d) return {
              openTag: new C(r.start.row, r.start.column, l.end.row, l.end.column),
              closeTag: new C(h.start.row, h.start.column, u.end.row, u.end.column),
              openTagName: s,
              closeTagName: d
            };
          }, (this || _global).$findOpeningTag = function (e, t) {
            var n,
              i = e.getCurrentToken(),
              o = t.value,
              r = 0,
              s = e.getCurrentTokenRow(),
              a = e.getCurrentTokenColumn(),
              l = new C(s, a, s, a + 2),
              c = (e.stepForward(), new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + t.value.length));
            if ((t = e.stepForward()) && ">" === t.value) {
              var h = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1);
              e.stepBackward(), e.stepBackward();
              do {
                if (t = i, s = e.getCurrentTokenRow(), n = (a = e.getCurrentTokenColumn()) + t.value.length, i = e.stepBackward(), t) if (-1 !== t.type.indexOf("tag-name")) {
                  if (o === t.value) if ("<" === i.value) {
                    if (0 < ++r) {
                      for (var d = new C(s, a, s, n), u = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1); (t = e.stepForward()) && ">" !== t.value;);
                      var g = new C(e.getCurrentTokenRow(), e.getCurrentTokenColumn(), e.getCurrentTokenRow(), e.getCurrentTokenColumn() + 1);
                    }
                  } else "</" === i.value && r--;
                } else if ("/>" === t.value) {
                  for (var p = 0, m = i; m;) {
                    if (-1 !== m.type.indexOf("tag-name") && m.value === o) {
                      r--;
                      break;
                    }
                    if ("<" === m.value) break;
                    m = e.stepBackward(), p++;
                  }
                  for (var f = 0; f < p; f++) e.stepForward();
                }
              } while (i && r <= 0);
              return u && g && l && h && d && c ? {
                openTag: new C(u.start.row, u.start.column, g.end.row, g.end.column),
                closeTag: new C(l.start.row, l.start.column, h.end.row, h.end.column),
                openTagName: d,
                closeTagName: c
              } : void 0;
            }
          };
        };
      }), ace.define("ace/edit_session", ["require", "exports", "module", "ace/lib/oop", "ace/lib/lang", "ace/bidihandler", "ace/config", "ace/lib/event_emitter", "ace/selection", "ace/mode/text", "ace/range", "ace/document", "ace/background_tokenizer", "ace/search_highlight", "ace/edit_session/folding", "ace/edit_session/bracket_match"], function (e, t, n) {
        "use strict";

        var i = e("./lib/oop"),
          o = e("./lib/lang"),
          r = e("./bidihandler").BidiHandler,
          s = e("./config"),
          a = e("./lib/event_emitter").EventEmitter,
          l = e("./selection").Selection,
          c = e("./mode/text").Mode,
          h = e("./range").Range,
          d = e("./document").Document,
          u = e("./background_tokenizer").BackgroundTokenizer,
          g = e("./search_highlight").SearchHighlight,
          p = (m.prototype.setDocument = function (e) {
            (this || _global).doc && (this || _global).doc.off("change", (this || _global).$onChange), ((this || _global).doc = e).on("change", (this || _global).$onChange, !0), (this || _global).bgTokenizer.setDocument(this.getDocument()), this.resetCaches();
          }, m.prototype.getDocument = function () {
            return (this || _global).doc;
          }, m.prototype.$resetRowCache = function (e) {
            var t;
            e ? (t = (this || _global).$docRowCache.length, (e = this.$getRowCacheIndex((this || _global).$docRowCache, e) + 1) < t && ((this || _global).$docRowCache.splice(e, t), (this || _global).$screenRowCache.splice(e, t))) : ((this || _global).$docRowCache = [], (this || _global).$screenRowCache = []);
          }, m.prototype.$getRowCacheIndex = function (e, t) {
            for (var n = 0, i = e.length - 1; n <= i;) {
              var o = n + i >> 1,
                r = e[o];
              if (r < t) n = 1 + o;else {
                if (!(t < r)) return o;
                i = o - 1;
              }
            }
            return n - 1;
          }, m.prototype.resetCaches = function () {
            (this || _global).$modified = !0, (this || _global).$wrapData = [], (this || _global).$rowLengthCache = [], this.$resetRowCache(0), (this || _global).destroyed || (this || _global).bgTokenizer.start(0);
          }, m.prototype.onChangeFold = function (e) {
            e = e.data;
            this.$resetRowCache(e.start.row);
          }, m.prototype.onChange = function (e) {
            (this || _global).$modified = !0, (this || _global).$bidiHandler.onChange(e), this.$resetRowCache(e.start.row);
            var t = this.$updateInternalDataOnChange(e);
            !(this || _global).$fromUndo && (this || _global).$undoManager && (t && t.length && ((this || _global).$undoManager.add({
              action: "removeFolds",
              folds: t
            }, (this || _global).mergeUndoDeltas), (this || _global).mergeUndoDeltas = !0), (this || _global).$undoManager.add(e, (this || _global).mergeUndoDeltas), (this || _global).mergeUndoDeltas = !0, (this || _global).$informUndoManager.schedule()), (this || _global).bgTokenizer.$updateOnChange(e), this._signal("change", e);
          }, m.prototype.setValue = function (e) {
            (this || _global).doc.setValue(e), (this || _global).selection.moveTo(0, 0), this.$resetRowCache(0), this.setUndoManager((this || _global).$undoManager), this.getUndoManager().reset();
          }, m.prototype.toString = function () {
            return (this || _global).doc.getValue();
          }, m.prototype.getSelection = function () {
            return (this || _global).selection;
          }, m.prototype.getState = function (e) {
            return (this || _global).bgTokenizer.getState(e);
          }, m.prototype.getTokens = function (e) {
            return (this || _global).bgTokenizer.getTokens(e);
          }, m.prototype.getTokenAt = function (e, t) {
            var n = (this || _global).bgTokenizer.getTokens(e),
              i = 0;
            if (null == t) var o = n.length - 1,
              i = this.getLine(e).length;else for (o = 0; o < n.length && !(t <= (i += n[o].value.length)); o++);
            return (e = n[o]) ? (e.index = o, e.start = i - e.value.length, e) : null;
          }, m.prototype.setUndoManager = function (e) {
            var t;
            (this || _global).$undoManager = e, (this || _global).$informUndoManager && (this || _global).$informUndoManager.cancel(), e ? (e.addSession(t = this || _global), (this || _global).$syncInformUndoManager = function () {
              t.$informUndoManager.cancel(), t.mergeUndoDeltas = !1;
            }, (this || _global).$informUndoManager = o.delayedCall((this || _global).$syncInformUndoManager)) : (this || _global).$syncInformUndoManager = function () {};
          }, m.prototype.markUndoGroup = function () {
            (this || _global).$syncInformUndoManager && this.$syncInformUndoManager();
          }, m.prototype.getUndoManager = function () {
            return (this || _global).$undoManager || (this || _global).$defaultUndoManager;
          }, m.prototype.getTabString = function () {
            return this.getUseSoftTabs() ? o.stringRepeat(" ", this.getTabSize()) : "\t";
          }, m.prototype.setUseSoftTabs = function (e) {
            this.setOption("useSoftTabs", e);
          }, m.prototype.getUseSoftTabs = function () {
            return (this || _global).$useSoftTabs && !(this || _global).$mode.$indentWithTabs;
          }, m.prototype.setTabSize = function (e) {
            this.setOption("tabSize", e);
          }, m.prototype.getTabSize = function () {
            return (this || _global).$tabSize;
          }, m.prototype.isTabStop = function (e) {
            return (this || _global).$useSoftTabs && e.column % (this || _global).$tabSize == 0;
          }, m.prototype.setNavigateWithinSoftTabs = function (e) {
            this.setOption("navigateWithinSoftTabs", e);
          }, m.prototype.getNavigateWithinSoftTabs = function () {
            return (this || _global).$navigateWithinSoftTabs;
          }, m.prototype.setOverwrite = function (e) {
            this.setOption("overwrite", e);
          }, m.prototype.getOverwrite = function () {
            return (this || _global).$overwrite;
          }, m.prototype.toggleOverwrite = function () {
            this.setOverwrite(!(this || _global).$overwrite);
          }, m.prototype.addGutterDecoration = function (e, t) {
            (this || _global).$decorations[e] || ((this || _global).$decorations[e] = ""), (this || _global).$decorations[e] += " " + t, this._signal("changeBreakpoint", {});
          }, m.prototype.removeGutterDecoration = function (e, t) {
            (this || _global).$decorations[e] = ((this || _global).$decorations[e] || "").replace(" " + t, ""), this._signal("changeBreakpoint", {});
          }, m.prototype.getBreakpoints = function () {
            return (this || _global).$breakpoints;
          }, m.prototype.setBreakpoints = function (e) {
            (this || _global).$breakpoints = [];
            for (var t = 0; t < e.length; t++) (this || _global).$breakpoints[e[t]] = "ace_breakpoint";
            this._signal("changeBreakpoint", {});
          }, m.prototype.clearBreakpoints = function () {
            (this || _global).$breakpoints = [], this._signal("changeBreakpoint", {});
          }, m.prototype.setBreakpoint = function (e, t) {
            (t = void 0 === t ? "ace_breakpoint" : t) ? (this || _global).$breakpoints[e] = t : delete (this || _global).$breakpoints[e], this._signal("changeBreakpoint", {});
          }, m.prototype.clearBreakpoint = function (e) {
            delete (this || _global).$breakpoints[e], this._signal("changeBreakpoint", {});
          }, m.prototype.addMarker = function (e, t, n, i) {
            var o = (this || _global).$markerId++,
              e = {
                range: e,
                type: n || "line",
                renderer: "function" == typeof n ? n : null,
                clazz: t,
                inFront: !!i,
                id: o
              };
            return i ? ((this || _global).$frontMarkers[o] = e, this._signal("changeFrontMarker")) : ((this || _global).$backMarkers[o] = e, this._signal("changeBackMarker")), o;
          }, m.prototype.addDynamicMarker = function (e, t) {
            var n;
            if (e.update) return n = (this || _global).$markerId++, e.id = n, e.inFront = !!t, t ? ((this || _global).$frontMarkers[n] = e, this._signal("changeFrontMarker")) : ((this || _global).$backMarkers[n] = e, this._signal("changeBackMarker")), e;
          }, m.prototype.removeMarker = function (e) {
            var t = (this || _global).$frontMarkers[e] || (this || _global).$backMarkers[e];
            t && (delete (t.inFront ? (this || _global).$frontMarkers : (this || _global).$backMarkers)[e], this._signal(t.inFront ? "changeFrontMarker" : "changeBackMarker"));
          }, m.prototype.getMarkers = function (e) {
            return e ? (this || _global).$frontMarkers : (this || _global).$backMarkers;
          }, m.prototype.highlight = function (e) {
            var t;
            (this || _global).$searchHighlight || (t = new g(null, "ace_selected-word", "text"), (this || _global).$searchHighlight = this.addDynamicMarker(t)), (this || _global).$searchHighlight.setRegexp(e);
          }, m.prototype.highlightLines = function (e, t, n, i) {
            "number" != typeof t && (n = t, t = e), n = n || "ace_step";
            e = new h(e, 0, t, 1 / 0);
            return e.id = this.addMarker(e, n, "fullLine", i), e;
          }, m.prototype.setAnnotations = function (e) {
            (this || _global).$annotations = e, this._signal("changeAnnotation", {});
          }, m.prototype.getAnnotations = function () {
            return (this || _global).$annotations || [];
          }, m.prototype.clearAnnotations = function () {
            this.setAnnotations([]);
          }, m.prototype.$detectNewLine = function (e) {
            e = e.match(/^.*?(\r?\n)/m);
            (this || _global).$autoNewLine = e ? e[1] : "\n";
          }, m.prototype.getWordRange = function (e, t) {
            var n,
              i = this.getLine(e),
              o = !1,
              r = (n = (o = (o = 0 < t ? !!i.charAt(t - 1).match((this || _global).tokenRe) : o) || !!i.charAt(t).match((this || _global).tokenRe)) ? (this || _global).tokenRe : /^\s+$/.test(i.slice(t - 1, t + 1)) ? /\s/ : (this || _global).nonTokenRe, t);
            if (0 < r) {
              for (; 0 <= --r && i.charAt(r).match(n););
              r++;
            }
            for (var s = t; s < i.length && i.charAt(s).match(n);) s++;
            return new h(e, r, e, s);
          }, m.prototype.getAWordRange = function (e, t) {
            for (var n = this.getWordRange(e, t), i = this.getLine(n.end.row); i.charAt(n.end.column).match(/[ \t]/);) n.end.column += 1;
            return n;
          }, m.prototype.setNewLineMode = function (e) {
            (this || _global).doc.setNewLineMode(e);
          }, m.prototype.getNewLineMode = function () {
            return (this || _global).doc.getNewLineMode();
          }, m.prototype.setUseWorker = function (e) {
            this.setOption("useWorker", e);
          }, m.prototype.getUseWorker = function () {
            return (this || _global).$useWorker;
          }, m.prototype.onReloadTokenizer = function (e) {
            var t = e.data;
            (this || _global).bgTokenizer.start(t.first), this._signal("tokenizerUpdate", e);
          }, m.prototype.setMode = function (e, t) {
            if (e && "object" == typeof e) {
              if (e.getTokenizer) return this.$onChangeMode(e);
              var n = e,
                i = n.path;
            } else i = e || "ace/mode/text";
            (this || _global).$modes["ace/mode/text"] || ((this || _global).$modes["ace/mode/text"] = new c()), (this || _global).$modes[i] && !n ? (this.$onChangeMode((this || _global).$modes[i]), t && t()) : ((this || _global).$modeId = i, s.loadModule(["mode", i], function (e) {
              if ((this || _global).$modeId !== i) return t && t();
              (this || _global).$modes[i] && !n ? this.$onChangeMode((this || _global).$modes[i]) : e && e.Mode && (e = new e.Mode(n), n || (((this || _global).$modes[i] = e).$id = i), this.$onChangeMode(e)), t && t();
            }.bind(this || _global)), (this || _global).$mode || this.$onChangeMode((this || _global).$modes["ace/mode/text"], !0));
          }, m.prototype.$onChangeMode = function (e, t) {
            var n, i, o;
            t || ((this || _global).$modeId = e.$id), (this || _global).$mode === e || (n = (this || _global).$mode, (this || _global).$mode = e, this.$stopWorker(), (this || _global).$useWorker && this.$startWorker(), void 0 !== (i = e.getTokenizer()).on && (o = (this || _global).onReloadTokenizer.bind(this || _global), i.on("update", o)), (this || _global).bgTokenizer.setTokenizer(i), (this || _global).bgTokenizer.setDocument(this.getDocument()), (this || _global).tokenRe = e.tokenRe, (this || _global).nonTokenRe = e.nonTokenRe, t) || (e.attachToSession && e.attachToSession(this || _global), (this || _global).$options.wrapMethod.set.call(this || _global, (this || _global).$wrapMethod), this.$setFolding(e.foldingRules), (this || _global).bgTokenizer.start(0), this._emit("changeMode", {
              oldMode: n,
              mode: e
            }));
          }, m.prototype.$stopWorker = function () {
            (this || _global).$worker && ((this || _global).$worker.terminate(), (this || _global).$worker = null);
          }, m.prototype.$startWorker = function () {
            try {
              (this || _global).$worker = (this || _global).$mode.createWorker(this || _global);
            } catch (e) {
              s.warn("Could not load worker", e), (this || _global).$worker = null;
            }
          }, m.prototype.getMode = function () {
            return (this || _global).$mode;
          }, m.prototype.setScrollTop = function (e) {
            (this || _global).$scrollTop === e || isNaN(e) || ((this || _global).$scrollTop = e, this._signal("changeScrollTop", e));
          }, m.prototype.getScrollTop = function () {
            return (this || _global).$scrollTop;
          }, m.prototype.setScrollLeft = function (e) {
            (this || _global).$scrollLeft === e || isNaN(e) || ((this || _global).$scrollLeft = e, this._signal("changeScrollLeft", e));
          }, m.prototype.getScrollLeft = function () {
            return (this || _global).$scrollLeft;
          }, m.prototype.getScreenWidth = function () {
            return this.$computeWidth(), (this || _global).lineWidgets ? Math.max(this.getLineWidgetMaxWidth(), (this || _global).screenWidth) : (this || _global).screenWidth;
          }, m.prototype.getLineWidgetMaxWidth = function () {
            var t;
            return null != (this || _global).lineWidgetsWidth ? (this || _global).lineWidgetsWidth : (t = 0, (this || _global).lineWidgets.forEach(function (e) {
              e && e.screenWidth > t && (t = e.screenWidth);
            }), (this || _global).lineWidgetWidth = t);
          }, m.prototype.$computeWidth = function (e) {
            if ((this || _global).$modified || e) {
              if ((this || _global).$modified = !1, (this || _global).$useWrapMode) return (this || _global).screenWidth = (this || _global).$wrapLimit;
              for (var t = (this || _global).doc.getAllLines(), n = (this || _global).$rowLengthCache, i = 0, o = 0, r = (this || _global).$foldData[o], s = r ? r.start.row : 1 / 0, a = t.length, l = 0; l < a; l++) {
                if (s < l) {
                  if (a <= (l = r.end.row + 1)) break;
                  s = (r = (this || _global).$foldData[o++]) ? r.start.row : 1 / 0;
                }
                null == n[l] && (n[l] = this.$getStringScreenWidth(t[l])[0]), n[l] > i && (i = n[l]);
              }
              (this || _global).screenWidth = i;
            }
          }, m.prototype.getLine = function (e) {
            return (this || _global).doc.getLine(e);
          }, m.prototype.getLines = function (e, t) {
            return (this || _global).doc.getLines(e, t);
          }, m.prototype.getLength = function () {
            return (this || _global).doc.getLength();
          }, m.prototype.getTextRange = function (e) {
            return (this || _global).doc.getTextRange(e || (this || _global).selection.getRange());
          }, m.prototype.insert = function (e, t) {
            return (this || _global).doc.insert(e, t);
          }, m.prototype.remove = function (e) {
            return (this || _global).doc.remove(e);
          }, m.prototype.removeFullLines = function (e, t) {
            return (this || _global).doc.removeFullLines(e, t);
          }, m.prototype.undoChanges = function (e, t) {
            if (e.length) {
              (this || _global).$fromUndo = !0;
              for (var n = e.length - 1; -1 != n; n--) {
                var i = e[n];
                "insert" == i.action || "remove" == i.action ? (this || _global).doc.revertDelta(i) : i.folds && this.addFolds(i.folds);
              }
              !t && (this || _global).$undoSelect && (e.selectionBefore ? (this || _global).selection.fromJSON(e.selectionBefore) : (this || _global).selection.setRange(this.$getUndoSelection(e, !0))), (this || _global).$fromUndo = !1;
            }
          }, m.prototype.redoChanges = function (e, t) {
            if (e.length) {
              (this || _global).$fromUndo = !0;
              for (var n = 0; n < e.length; n++) {
                var i = e[n];
                "insert" != i.action && "remove" != i.action || (this || _global).doc.$safeApplyDelta(i);
              }
              !t && (this || _global).$undoSelect && (e.selectionAfter ? (this || _global).selection.fromJSON(e.selectionAfter) : (this || _global).selection.setRange(this.$getUndoSelection(e, !1))), (this || _global).$fromUndo = !1;
            }
          }, m.prototype.setUndoSelect = function (e) {
            (this || _global).$undoSelect = e;
          }, m.prototype.$getUndoSelection = function (e, t) {
            function n(e) {
              return t ? "insert" !== e.action : "insert" === e.action;
            }
            for (var i, o, r = 0; r < e.length; r++) {
              var s = e[r];
              s.start && (i ? n(s) ? (o = s.start, -1 == i.compare(o.row, o.column) && i.setStart(o), o = s.end, 1 == i.compare(o.row, o.column) && i.setEnd(o)) : (o = s.start, -1 == i.compare(o.row, o.column) && (i = h.fromPoints(s.start, s.start))) : i = n(s) ? h.fromPoints(s.start, s.end) : h.fromPoints(s.start, s.start));
            }
            return i;
          }, m.prototype.replace = function (e, t) {
            return (this || _global).doc.replace(e, t);
          }, m.prototype.moveText = function (e, t, n) {
            var i,
              o,
              r,
              s = this.getTextRange(e),
              a = this.getFoldsInRange(e),
              t = h.fromPoints(t, t);
            return n || (this.remove(e), o = e.start.row - e.end.row, (r = o ? -e.end.column : e.start.column - e.end.column) && (t.start.row == e.end.row && t.start.column > e.end.column && (t.start.column += r), t.end.row == e.end.row) && t.end.column > e.end.column && (t.end.column += r), o && t.start.row >= e.end.row && (t.start.row += o, t.end.row += o)), t.end = this.insert(t.start, s), a.length && (i = e.start, n = t.start, o = n.row - i.row, r = n.column - i.column, this.addFolds(a.map(function (e) {
              return (e = e.clone()).start.row == i.row && (e.start.column += r), e.end.row == i.row && (e.end.column += r), e.start.row += o, e.end.row += o, e;
            }))), t;
          }, m.prototype.indentRows = function (e, t, n) {
            n = n.replace(/\t/g, this.getTabString());
            for (var i = e; i <= t; i++) (this || _global).doc.insertInLine({
              row: i,
              column: 0
            }, n);
          }, m.prototype.outdentRows = function (e) {
            for (var t = e.collapseRows(), n = new h(0, 0, 0, 0), i = this.getTabSize(), o = t.start.row; o <= t.end.row; ++o) {
              var r = this.getLine(o);
              n.start.row = o, n.end.row = o;
              for (var s = 0; s < i && " " == r.charAt(s); ++s);
              s < i && "\t" == r.charAt(s) ? (n.start.column = s, n.end.column = s + 1) : (n.start.column = 0, n.end.column = s), this.remove(n);
            }
          }, m.prototype.$moveLines = function (e, t, n) {
            if (e = this.getRowFoldStart(e), t = this.getRowFoldEnd(t), n < 0) {
              if ((o = this.getRowFoldStart(e + n)) < 0) return 0;
              var i = o - e;
            } else if (0 < n) {
              if ((o = this.getRowFoldEnd(t + n)) > (this || _global).doc.getLength() - 1) return 0;
              i = o - t;
            } else {
              e = this.$clipRowToDocument(e);
              i = (t = this.$clipRowToDocument(t)) - e + 1;
            }
            var o = new h(e, 0, t, Number.MAX_VALUE),
              o = this.getFoldsInRange(o).map(function (e) {
                return (e = e.clone()).start.row += i, e.end.row += i, e;
              }),
              n = 0 == n ? (this || _global).doc.getLines(e, t) : (this || _global).doc.removeFullLines(e, t);
            return (this || _global).doc.insertFullLines(e + i, n), o.length && this.addFolds(o), i;
          }, m.prototype.moveLinesUp = function (e, t) {
            return this.$moveLines(e, t, -1);
          }, m.prototype.moveLinesDown = function (e, t) {
            return this.$moveLines(e, t, 1);
          }, m.prototype.duplicateLines = function (e, t) {
            return this.$moveLines(e, t, 0);
          }, m.prototype.$clipRowToDocument = function (e) {
            return Math.max(0, Math.min(e, (this || _global).doc.getLength() - 1));
          }, m.prototype.$clipColumnToRow = function (e, t) {
            return t < 0 ? 0 : Math.min((this || _global).doc.getLine(e).length, t);
          }, m.prototype.$clipPositionToDocument = function (e, t) {
            var n;
            return t = Math.max(0, t), t = e < 0 ? e = 0 : (n = (this || _global).doc.getLength()) <= e ? (this || _global).doc.getLine(e = n - 1).length : Math.min((this || _global).doc.getLine(e).length, t), {
              row: e,
              column: t
            };
          }, m.prototype.$clipRangeToDocument = function (e) {
            e.start.row < 0 ? (e.start.row = 0, e.start.column = 0) : e.start.column = this.$clipColumnToRow(e.start.row, e.start.column);
            var t = (this || _global).doc.getLength() - 1;
            return e.end.row > t ? (e.end.row = t, e.end.column = (this || _global).doc.getLine(t).length) : e.end.column = this.$clipColumnToRow(e.end.row, e.end.column), e;
          }, m.prototype.setUseWrapMode = function (e) {
            e != (this || _global).$useWrapMode && ((this || _global).$useWrapMode = e, (this || _global).$modified = !0, this.$resetRowCache(0), e && (e = this.getLength(), (this || _global).$wrapData = Array(e), this.$updateWrapData(0, e - 1)), this._signal("changeWrapMode"));
          }, m.prototype.getUseWrapMode = function () {
            return (this || _global).$useWrapMode;
          }, m.prototype.setWrapLimitRange = function (e, t) {
            (this || _global).$wrapLimitRange.min === e && (this || _global).$wrapLimitRange.max === t || ((this || _global).$wrapLimitRange = {
              min: e,
              max: t
            }, (this || _global).$modified = !0, (this || _global).$bidiHandler.markAsDirty(), (this || _global).$useWrapMode && this._signal("changeWrapMode"));
          }, m.prototype.adjustWrapLimit = function (e, t) {
            var n = (this || _global).$wrapLimitRange,
              t = (n.max < 0 && (n = {
                min: t,
                max: t
              }), this.$constrainWrapLimit(e, n.min, n.max));
            return t != (this || _global).$wrapLimit && 1 < t && ((this || _global).$wrapLimit = t, (this || _global).$modified = !0, (this || _global).$useWrapMode && (this.$updateWrapData(0, this.getLength() - 1), this.$resetRowCache(0), this._signal("changeWrapLimit")), !0);
          }, m.prototype.$constrainWrapLimit = function (e, t, n) {
            return t && (e = Math.max(t, e)), e = n ? Math.min(n, e) : e;
          }, m.prototype.getWrapLimit = function () {
            return (this || _global).$wrapLimit;
          }, m.prototype.setWrapLimit = function (e) {
            this.setWrapLimitRange(e, e);
          }, m.prototype.getWrapLimitRange = function () {
            return {
              min: (this || _global).$wrapLimitRange.min,
              max: (this || _global).$wrapLimitRange.max
            };
          }, m.prototype.$updateInternalDataOnChange = function (e) {
            var t = (this || _global).$useWrapMode,
              n = e.action,
              i = e.start,
              o = e.end,
              r = i.row,
              s = o.row,
              a = s - r,
              l = null;
            if ((this || _global).$updating = !0, 0 != a) {
              if ("remove" === n) {
                (this || _global)[t ? "$wrapData" : "$rowLengthCache"].splice(r, a);
                var c = (this || _global).$foldData,
                  l = this.getFoldsInRange(e);
                this.removeFolds(l);
                var h = 0;
                for ((g = this.getFoldLine(o.row)) && (g.addRemoveChars(o.row, o.column, i.column - o.column), g.shiftRow(-a), (d = this.getFoldLine(r)) && d !== g && (d.merge(g), g = d), h = c.indexOf(g) + 1); h < c.length; h++) (g = c[h]).start.row >= o.row && g.shiftRow(-a);
                s = r;
              } else {
                var d = Array(a),
                  u = (d.unshift(r, 0), t ? (this || _global).$wrapData : (this || _global).$rowLengthCache),
                  c = (u.splice.apply(u, d), (this || _global).$foldData),
                  h = 0;
                for ((g = this.getFoldLine(r)) && (0 == (u = g.range.compareInside(i.row, i.column)) ? (g = g.split(i.row, i.column)) && (g.shiftRow(a), g.addRemoveChars(s, 0, o.column - i.column)) : -1 == u && (g.addRemoveChars(r, 0, o.column - i.column), g.shiftRow(a)), h = c.indexOf(g) + 1); h < c.length; h++) (g = c[h]).start.row >= r && g.shiftRow(a);
              }
            } else {
              var g,
                a = Math.abs(e.start.column - e.end.column);
              "remove" === n && (l = this.getFoldsInRange(e), this.removeFolds(l), a = -a), (g = this.getFoldLine(r)) && g.addRemoveChars(r, i.column, a);
            }
            return t && (this || _global).$wrapData.length != (this || _global).doc.getLength() && console.error("doc.getLength() and $wrapData.length have to be the same!"), (this || _global).$updating = !1, t ? this.$updateWrapData(r, s) : this.$updateRowLengthCache(r, s), l;
          }, m.prototype.$updateRowLengthCache = function (e, t, n) {
            (this || _global).$rowLengthCache[e] = null, (this || _global).$rowLengthCache[t] = null;
          }, m.prototype.$updateWrapData = function (e, t) {
            var s,
              n,
              a = (this || _global).doc.getAllLines(),
              i = this.getTabSize(),
              o = (this || _global).$wrapData,
              r = (this || _global).$wrapLimit,
              l = e;
            for (t = Math.min(t, a.length - 1); l <= t;) (n = this.getFoldLine(l, n)) ? (s = [], n.walk(function (e, t, n, i) {
              var o;
              if (null != e) {
                (o = this.$getDisplayTokens(e, s.length))[0] = y;
                for (var r = 1; r < o.length; r++) o[r] = v;
              } else o = this.$getDisplayTokens(a[t].substring(i, n), s.length);
              s = s.concat(o);
            }.bind(this || _global), n.end.row, a[n.end.row].length + 1), o[n.start.row] = this.$computeWrapSplits(s, r, i), l = n.end.row + 1) : (s = this.$getDisplayTokens(a[l]), o[l] = this.$computeWrapSplits(s, r, i), l++);
          }, m.prototype.$computeWrapSplits = function (o, e, r) {
            if (0 == o.length) return [];
            var s = [],
              t = o.length,
              a = 0,
              l = 0,
              c = (this || _global).$wrapAsCode,
              h = (this || _global).$indentedSoftWrap,
              d = e <= Math.max(2 * r, 8) || !1 === h ? 0 : Math.floor(e / 2);
            function n(e) {
              for (var t = e - a, n = a; n < e; n++) {
                var i = o[n];
                12 !== i && 2 !== i || --t;
              }
              s.length || (u = function () {
                var e = 0;
                if (0 === d) return e;
                if (h) for (var t = 0; t < o.length; t++) {
                  var n = o[t];
                  if (n == b) e += 1;else if (n == A) e += r;else if (n != w) break;
                }
                return c && !1 !== h && (e += r), Math.min(e, d);
              }(), s.indent = u), l += t, s.push(l), a = e;
            }
            for (var u = 0; e - u < t - a;) {
              var i = a + e - u;
              if (o[i - 1] >= b && o[i] >= b) n(i);else if (o[i] == y || o[i] == v) {
                for (; i != a - 1 && o[i] != y; i--);
                if (a < i) ;else {
                  for (i = a + e; i < o.length && o[i] == v; i++);
                  if (i == o.length) break;
                }
                n(i);
              } else {
                for (var g = Math.max(i - (e - (e >> 2)), a - 1); g < i && o[i] < y;) i--;
                if (c) {
                  for (; g < i && o[i] < y;) i--;
                  for (; g < i && o[i] == I;) i--;
                } else for (; g < i && o[i] < b;) i--;
                g < i ? n(++i) : (o[i = a + e] == C && i--, n(i - u));
              }
            }
            return s;
          }, m.prototype.$getDisplayTokens = function (e, t) {
            var n,
              i = [];
            t = t || 0;
            for (var o = 0; o < e.length; o++) {
              var r = e.charCodeAt(o);
              if (9 == r) {
                n = this.getScreenTabSize(i.length + t), i.push(A);
                for (var s = 1; s < n; s++) i.push(w);
              } else 32 == r ? i.push(b) : 39 < r && r < 48 || 57 < r && r < 64 ? i.push(I) : 4352 <= r && S(r) ? i.push(f, C) : i.push(f);
            }
            return i;
          }, m.prototype.$getStringScreenWidth = function (e, t, n) {
            if (0 == t) return [0, 0];
            var i, o;
            for (null == t && (t = 1 / 0), n = n || 0, o = 0; o < e.length && (9 == (i = e.charCodeAt(o)) ? n += this.getScreenTabSize(n) : 4352 <= i && S(i) ? n += 2 : n += 1, !(t < n)); o++);
            return [n, o];
          }, m.prototype.getRowLength = function (e) {
            var t = 1;
            return (this || _global).lineWidgets && (t += (this || _global).lineWidgets[e] && (this || _global).lineWidgets[e].rowCount || 0), (this || _global).$useWrapMode && (this || _global).$wrapData[e] ? (this || _global).$wrapData[e].length + t : t;
          }, m.prototype.getRowLineCount = function (e) {
            return (this || _global).$useWrapMode && (this || _global).$wrapData[e] ? (this || _global).$wrapData[e].length + 1 : 1;
          }, m.prototype.getRowWrapIndent = function (e) {
            var t;
            return (this || _global).$useWrapMode && (e = this.screenToDocumentPosition(e, Number.MAX_VALUE), (t = (this || _global).$wrapData[e.row]).length) && t[0] < e.column ? t.indent : 0;
          }, m.prototype.getScreenLastRowColumn = function (e) {
            e = this.screenToDocumentPosition(e, Number.MAX_VALUE);
            return this.documentToScreenColumn(e.row, e.column);
          }, m.prototype.getDocumentLastRowColumn = function (e, t) {
            e = this.documentToScreenRow(e, t);
            return this.getScreenLastRowColumn(e);
          }, m.prototype.getDocumentLastRowColumnPosition = function (e, t) {
            e = this.documentToScreenRow(e, t);
            return this.screenToDocumentPosition(e, Number.MAX_VALUE / 10);
          }, m.prototype.getRowSplitData = function (e) {
            if ((this || _global).$useWrapMode) return (this || _global).$wrapData[e];
          }, m.prototype.getScreenTabSize = function (e) {
            return (this || _global).$tabSize - (e % (this || _global).$tabSize | 0);
          }, m.prototype.screenToDocumentRow = function (e, t) {
            return this.screenToDocumentPosition(e, t).row;
          }, m.prototype.screenToDocumentColumn = function (e, t) {
            return this.screenToDocumentPosition(e, t).column;
          }, m.prototype.screenToDocumentPosition = function (e, t, n) {
            if (e < 0) return {
              row: 0,
              column: 0
            };
            for (var i, o, r, s = 0, a = 0, l = 0, c = 0, h = (this || _global).$screenRowCache, d = this.$getRowCacheIndex(h, e), u = h.length, g = (r = u && 0 <= d ? (l = h[d], s = (this || _global).$docRowCache[d], e > h[u - 1]) : !u, this.getLength() - 1), p = this.getNextFoldLine(s), m = p ? p.start.row : 1 / 0; l <= e && !(e < l + (c = this.getRowLength(s)) || g <= s);) l += c, m < ++s && (s = p.end.row + 1, m = (p = this.getNextFoldLine(s, p)) ? p.start.row : 1 / 0), r && ((this || _global).$docRowCache.push(s), (this || _global).$screenRowCache.push(l));
            if (p && p.start.row <= s) i = this.getFoldDisplayLine(p), s = p.start.row;else {
              if (l + c <= e || g < s) return {
                row: g,
                column: this.getLine(g).length
              };
              i = this.getLine(s), p = null;
            }
            d = 0, h = Math.floor(e - l);
            return (this || _global).$useWrapMode && (u = (this || _global).$wrapData[s]) && (o = u[h], 0 < h) && u.length && (d = u.indent, a = u[h - 1] || u[u.length - 1], i = i.substring(a)), void 0 !== n && (this || _global).$bidiHandler.isBidiRow(l + h, s, h) && (t = (this || _global).$bidiHandler.offsetToCol(n)), a += this.$getStringScreenWidth(i, t - d)[1], (this || _global).$useWrapMode && o <= a && (a = o - 1), p ? p.idxToPosition(a) : {
              row: s,
              column: a
            };
          }, m.prototype.documentToScreenPosition = function (e, t) {
            var n = void 0 === t ? this.$clipPositionToDocument(e.row, e.column) : this.$clipPositionToDocument(e, t),
              i = (e = n.row, t = n.column, 0),
              n = null;
            (a = this.getFoldAt(e, t, 1)) && (e = a.start.row, t = a.start.column);
            for (var o, r, s = 0, a = (this || _global).$docRowCache, l = this.$getRowCacheIndex(a, e), c = a.length, h = (r = c && 0 <= l ? (s = a[l], i = (this || _global).$screenRowCache[l], e > a[c - 1]) : !c, this.getNextFoldLine(s)), d = h ? h.start.row : 1 / 0; s < e;) {
              if (d <= s) {
                if (e < (o = h.end.row + 1)) break;
                d = (h = this.getNextFoldLine(o, h)) ? h.start.row : 1 / 0;
              } else o = s + 1;
              i += this.getRowLength(s), s = o, r && ((this || _global).$docRowCache.push(s), (this || _global).$screenRowCache.push(i));
            }
            var u = "",
              n = h && d <= s ? (u = this.getFoldDisplayLine(h, e, t), h.start.row) : (u = this.getLine(e).substring(0, t), e),
              l = 0;
            if ((this || _global).$useWrapMode) {
              var g = (this || _global).$wrapData[n];
              if (g) {
                for (var p = 0; u.length >= g[p];) i++, p++;
                u = u.substring(g[p - 1] || 0, u.length), l = 0 < p ? g.indent : 0;
              }
            }
            return (this || _global).lineWidgets && (this || _global).lineWidgets[s] && (this || _global).lineWidgets[s].rowsAbove && (i += (this || _global).lineWidgets[s].rowsAbove), {
              row: i,
              column: l + this.$getStringScreenWidth(u)[0]
            };
          }, m.prototype.documentToScreenColumn = function (e, t) {
            return this.documentToScreenPosition(e, t).column;
          }, m.prototype.documentToScreenRow = function (e, t) {
            return this.documentToScreenPosition(e, t).row;
          }, m.prototype.getScreenLength = function () {
            var e = 0,
              t = null;
            if ((this || _global).$useWrapMode) for (var n = (this || _global).$wrapData.length, i = 0, o = 0, r = (t = (this || _global).$foldData[o++]) ? t.start.row : 1 / 0; i < n;) {
              var s = (this || _global).$wrapData[i];
              e += s ? s.length + 1 : 1, r < ++i && (i = t.end.row + 1, r = (t = (this || _global).$foldData[o++]) ? t.start.row : 1 / 0);
            } else for (var e = this.getLength(), a = (this || _global).$foldData, o = 0; o < a.length; o++) e -= (t = a[o]).end.row - t.start.row;
            return (this || _global).lineWidgets && (e += this.$getWidgetScreenLength()), e;
          }, m.prototype.$setFontMetrics = function (r) {
            (this || _global).$enableVarChar && ((this || _global).$getStringScreenWidth = function (e, t, n) {
              if (0 === t) return [0, 0];
              var i, o;
              for (t = t || 1 / 0, n = n || 0, o = 0; o < e.length && !(t < (n += "\t" === (i = e.charAt(o)) ? this.getScreenTabSize(n) : r.getCharacterWidth(i))); o++);
              return [n, o];
            });
          }, m.prototype.destroy = function () {
            (this || _global).destroyed || ((this || _global).bgTokenizer.setDocument(null), (this || _global).bgTokenizer.cleanup(), (this || _global).destroyed = !0), this.$stopWorker(), this.removeAllListeners(), (this || _global).doc && (this || _global).doc.off("change", (this || _global).$onChange), (this || _global).selection.detach();
          }, m);
        function m(e, t) {
          (this || _global).$breakpoints = [], (this || _global).$decorations = [], (this || _global).$frontMarkers = {}, (this || _global).$backMarkers = {}, (this || _global).$markerId = 1, (this || _global).$undoSelect = !0, (this || _global).$foldData = [], (this || _global).id = "session" + ++m.$uid, (this || _global).$foldData.toString = function () {
            return this.join("\n");
          }, (this || _global).bgTokenizer = new u(new c().getTokenizer(), this || _global);
          var n = this || _global;
          (this || _global).bgTokenizer.on("update", function (e) {
            n._signal("tokenizerUpdate", e);
          }), this.on("changeFold", (this || _global).onChangeFold.bind(this || _global)), (this || _global).$onChange = (this || _global).onChange.bind(this || _global), "object" == typeof e && e.getLine || (e = new d(e)), this.setDocument(e), (this || _global).selection = new l(this || _global), (this || _global).$bidiHandler = new r(this || _global), s.resetOptions(this || _global), this.setMode(t), s._signal("session", this || _global), (this || _global).destroyed = !1;
        }
        p.$uid = 0, p.prototype.$modes = s.$modes, p.prototype.getValue = p.prototype.toString, p.prototype.$defaultUndoManager = {
          undo: function () {},
          redo: function () {},
          hasUndo: function () {},
          hasRedo: function () {},
          reset: function () {},
          add: function () {},
          addSelection: function () {},
          startNewGroup: function () {},
          addSession: function () {}
        }, p.prototype.$overwrite = !1, p.prototype.$mode = null, p.prototype.$modeId = null, p.prototype.$scrollTop = 0, p.prototype.$scrollLeft = 0, p.prototype.$wrapLimit = 80, p.prototype.$useWrapMode = !1, p.prototype.$wrapLimitRange = {
          min: null,
          max: null
        }, p.prototype.lineWidgets = null, p.prototype.isFullWidth = S, i.implement(p.prototype, a);
        var f = 1,
          C = 2,
          y = 3,
          v = 4,
          I = 9,
          b = 10,
          A = 11,
          w = 12;
        function S(e) {
          return !(e < 4352) && (4352 <= e && e <= 4447 || 4515 <= e && e <= 4519 || 4602 <= e && e <= 4607 || 9001 <= e && e <= 9002 || 11904 <= e && e <= 11929 || 11931 <= e && e <= 12019 || 12032 <= e && e <= 12245 || 12272 <= e && e <= 12283 || 12288 <= e && e <= 12350 || 12353 <= e && e <= 12438 || 12441 <= e && e <= 12543 || 12549 <= e && e <= 12589 || 12593 <= e && e <= 12686 || 12688 <= e && e <= 12730 || 12736 <= e && e <= 12771 || 12784 <= e && e <= 12830 || 12832 <= e && e <= 12871 || 12880 <= e && e <= 13054 || 13056 <= e && e <= 19903 || 19968 <= e && e <= 42124 || 42128 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 55216 <= e && e <= 55238 || 55243 <= e && e <= 55291 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65106 || 65108 <= e && e <= 65126 || 65128 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510);
        }
        e("./edit_session/folding").Folding.call(p.prototype), e("./edit_session/bracket_match").BracketMatch.call(p.prototype), s.defineOptions(p.prototype, "session", {
          wrap: {
            set: function (e) {
              e && "off" != e ? "free" == e ? e = !0 : "printMargin" == e ? e = -1 : "string" == typeof e && (e = parseInt(e, 10) || !1) : e = !1, (this || _global).$wrap != e && (((this || _global).$wrap = e) ? (this.setWrapLimitRange(e = "number" == typeof e ? e : null, e), this.setUseWrapMode(!0)) : this.setUseWrapMode(!1));
            },
            get: function () {
              return this.getUseWrapMode() ? -1 == (this || _global).$wrap ? "printMargin" : this.getWrapLimitRange().min ? (this || _global).$wrap : "free" : "off";
            },
            handlesSet: !0
          },
          wrapMethod: {
            set: function (e) {
              (e = "auto" == e ? "text" != (this || _global).$mode.type : "text" != e) != (this || _global).$wrapAsCode && ((this || _global).$wrapAsCode = e, (this || _global).$useWrapMode) && ((this || _global).$useWrapMode = !1, this.setUseWrapMode(!0));
            },
            initialValue: "auto"
          },
          indentedSoftWrap: {
            set: function () {
              (this || _global).$useWrapMode && ((this || _global).$useWrapMode = !1, this.setUseWrapMode(!0));
            },
            initialValue: !0
          },
          firstLineNumber: {
            set: function () {
              this._signal("changeBreakpoint");
            },
            initialValue: 1
          },
          useWorker: {
            set: function (e) {
              (this || _global).$useWorker = e, this.$stopWorker(), e && this.$startWorker();
            },
            initialValue: !0
          },
          useSoftTabs: {
            initialValue: !0
          },
          tabSize: {
            set: function (e) {
              0 < (e = parseInt(e)) && (this || _global).$tabSize !== e && ((this || _global).$modified = !0, (this || _global).$rowLengthCache = [], (this || _global).$tabSize = e, this._signal("changeTabSize"));
            },
            initialValue: 4,
            handlesSet: !0
          },
          navigateWithinSoftTabs: {
            initialValue: !1
          },
          foldStyle: {
            set: function (e) {
              this.setFoldStyle(e);
            },
            handlesSet: !0
          },
          overwrite: {
            set: function (e) {
              this._signal("changeOverwrite");
            },
            initialValue: !1
          },
          newLineMode: {
            set: function (e) {
              (this || _global).doc.setNewLineMode(e);
            },
            get: function () {
              return (this || _global).doc.getNewLineMode();
            },
            handlesSet: !0
          },
          mode: {
            set: function (e) {
              this.setMode(e);
            },
            get: function () {
              return (this || _global).$modeId;
            },
            handlesSet: !0
          }
        }), t.EditSession = p;
      }), ace.define("ace/search", ["require", "exports", "module", "ace/lib/lang", "ace/lib/oop", "ace/range"], function (e, t, n) {
        "use strict";

        var v = e("./lib/lang"),
          i = e("./lib/oop"),
          I = e("./range").Range;
        function o() {
          (this || _global).$options = {};
        }
        o.prototype.set = function (e) {
          return i.mixin((this || _global).$options, e), this || _global;
        }, o.prototype.getOptions = function () {
          return v.copyObject((this || _global).$options);
        }, o.prototype.setOptions = function (e) {
          (this || _global).$options = e;
        }, o.prototype.find = function (e) {
          var o,
            r = (this || _global).$options,
            e = this.$matchIterator(e, r);
          return !!e && (o = null, e.forEach(function (e, t, n, i) {
            return o = new I(e, t, n, i), !(t == i && r.start && r.start.start && 0 != r.skipCurrent && o.isEqual(r.start) && (o = null, 1));
          }), o);
        }, o.prototype.findAll = function (e) {
          var t = (this || _global).$options;
          if (!t.needle) return [];
          this.$assembleRegExp(t);
          var n = t.range,
            i = n ? e.getLines(n.start.row, n.end.row) : e.doc.getAllLines(),
            o = [],
            r = t.re;
          if (t.$isMultiLine) {
            var s,
              a = r.length,
              l = i.length - a;
            e: for (var c = r.offset || 0; c <= l; c++) {
              for (var h = 0; h < a; h++) if (-1 == i[c + h].search(r[h])) continue e;
              var d = i[c],
                u = i[c + a - 1],
                d = d.length - d.match(r[0])[0].length,
                u = u.match(r[a - 1])[0].length;
              s && s.end.row === c && s.end.column > d || (o.push(s = new I(c, d, c + a - 1, u)), 2 < a && (c = c + a - 2));
            }
          } else for (var g = 0; g < i.length; g++) for (var p = v.getMatchOffsets(i[g], r), h = 0; h < p.length; h++) {
            var m = p[h];
            o.push(new I(g, m.offset, g, m.offset + m.length));
          }
          if (n) {
            for (var f = n.start.column, C = n.end.column, g = 0, h = o.length - 1; g < h && o[g].start.column < f && 0 == o[g].start.row;) g++;
            for (var y = n.end.row - n.start.row; g < h && o[h].end.column > C && o[h].end.row == y;) h--;
            for (o = o.slice(g, h + 1), g = 0, h = o.length; g < h; g++) o[g].start.row += n.start.row, o[g].end.row += n.start.row;
          }
          return o;
        }, o.prototype.replace = function (e, t) {
          var n = (this || _global).$options,
            i = this.$assembleRegExp(n);
          if (n.$isMultiLine) return t;
          if (i) {
            var o = i.exec(e);
            if (!o || o[0].length != e.length) return null;
            if (t = e.replace(i, t), n.preserveCase) {
              t = t.split("");
              for (var r = Math.min(e.length, e.length); r--;) {
                var s = e[r];
                s && s.toLowerCase() != s ? t[r] = t[r].toUpperCase() : t[r] = t[r].toLowerCase();
              }
              t = t.join("");
            }
            return t;
          }
        }, o.prototype.$assembleRegExp = function (e, t) {
          if (e.needle instanceof RegExp) return e.re = e.needle;
          var n,
            i = e.needle;
          if (!e.needle) return e.re = !1;
          function o(e) {
            return /\w/.test(e) || n.regExp ? "\\b" : "";
          }
          e.regExp || (i = v.escapeRegExp(i)), e.wholeWord && (n = e, i = o((r = i)[0]) + r + o(r[r.length - 1]));
          var r = e.caseSensitive ? "gm" : "gmi";
          if (e.$isMultiLine = !t && /[\n\r]/.test(i), e.$isMultiLine) return e.re = this.$assembleMultilineRegExp(i, r);
          try {
            var s = new RegExp(i, r);
          } catch (e) {
            s = !1;
          }
          return e.re = s;
        }, o.prototype.$assembleMultilineRegExp = function (e, t) {
          for (var n = e.replace(/\r\n|\r|\n/g, "$\n^").split("\n"), i = [], o = 0; o < n.length; o++) try {
            i.push(new RegExp(n[o], t));
          } catch (e) {
            return !1;
          }
          return i;
        }, o.prototype.$matchIterator = function (h, n) {
          var a,
            e,
            t,
            i,
            o,
            r,
            l,
            s,
            d = this.$assembleRegExp(n);
          return !!d && (a = 1 == n.backwards, e = 0 != n.skipCurrent, t = n.range, (i = (i = n.start) || (t ? t[a ? "end" : "start"] : h.selection.getRange())).start && (i = i[e != a ? "end" : "start"]), o = t ? t.start.row : 0, r = t ? t.end.row : h.getLength() - 1, s = n.$isMultiLine ? (l = d.length, function (e, t, n) {
            var i = a ? e - l + 1 : e;
            if (!(i < 0 || i + l > h.getLength())) {
              var o = h.getLine(i),
                e = o.search(d[0]);
              if (!(!a && e < t || -1 === e)) {
                for (var r = 1; r < l; r++) if (-1 == (o = h.getLine(i + r)).search(d[r])) return;
                var s = o.match(d[l - 1])[0].length;
                if (!(a && t < s)) return !!n(i, e, i + l - 1, s) || void 0;
              }
            }
          }) : a ? function (e, t, n) {
            var i,
              o = h.getLine(e),
              r = [];
            for (d.lastIndex = 0; i = d.exec(o);) {
              var s = i[0].length,
                a = i.index;
              if (!s) {
                if (a >= o.length) break;
                d.lastIndex = a += 1;
              }
              if (i.index + s > t) break;
              r.push(i.index, s);
            }
            for (var l = r.length - 1; 0 <= l; l -= 2) {
              var c = r[l - 1];
              if (n(e, c, e, c + (s = r[l]))) return !0;
            }
          } : function (e, t, n) {
            var i = h.getLine(e);
            for (d.lastIndex = t; o = d.exec(i);) {
              var o,
                r = o[0].length;
              if (n(e, o = o.index, e, o + r)) return !0;
              if (!r && (d.lastIndex = o += 1, o >= i.length)) return !1;
            }
          }, {
            forEach: a ? function (e) {
              var t = i.row;
              if (!s(t, i.column, e)) {
                for (t--; o <= t; t--) if (s(t, Number.MAX_VALUE, e)) return;
                if (0 != n.wrap) for (t = r, o = i.row; o <= t; t--) if (s(t, Number.MAX_VALUE, e)) return;
              }
            } : function (e) {
              var t = i.row;
              if (!s(t, i.column, e)) {
                for (t += 1; t <= r; t++) if (s(t, 0, e)) return;
                if (0 != n.wrap) for (t = o, r = i.row; t <= r; t++) if (s(t, 0, e)) return;
              }
            }
          });
        }, t.Search = o;
      }), ace.define("ace/keyboard/hash_handler", ["require", "exports", "module", "ace/lib/keys", "ace/lib/useragent"], function (e, t, n) {
        "use strict";

        var a = e("../lib/keys"),
          i = e("../lib/useragent"),
          l = a.KEY_MODS;
        function o(e, t) {
          (this || _global).platform = t || (i.isMac ? "mac" : "win"), (this || _global).commands = {}, (this || _global).commandKeyBinding = {}, this.addCommands(e), (this || _global).$singleCommand = !0;
        }
        function r(e, t) {
          o.call(this || _global, e, t), (this || _global).$singleCommand = !1;
        }
        r.prototype = o.prototype, function () {
          function s(e) {
            return "object" == typeof e && e.bindKey && e.bindKey.position || (e.isDefault ? -100 : 0);
          }
          (this || _global).addCommand = function (e) {
            (this || _global).commands[e.name] && this.removeCommand(e), ((this || _global).commands[e.name] = e).bindKey && this._buildKeyHash(e);
          }, (this || _global).removeCommand = function (e, t) {
            var n,
              i = e && ("string" == typeof e ? e : e.name),
              o = (e = (this || _global).commands[i], t || delete (this || _global).commands[i], (this || _global).commandKeyBinding);
            for (n in o) {
              var r,
                s = o[n];
              s == e ? delete o[n] : Array.isArray(s) && -1 != (r = s.indexOf(e)) && (s.splice(r, 1), 1 == s.length) && (o[n] = s[0]);
            }
          }, (this || _global).bindKey = function (e, i, o) {
            if ("object" == typeof e && e && (null == o && (o = e.position), e = e[(this || _global).platform]), e) return "function" == typeof i ? this.addCommand({
              exec: i,
              bindKey: e,
              name: i.name || e
            }) : void e.split("|").forEach(function (e) {
              var t = "",
                n = (-1 != e.indexOf(" ") && (e = (n = e.split(/\s+/)).pop(), n.forEach(function (e) {
                  e = this.parseKeys(e), e = l[e.hashId] + e.key;
                  t += (t ? " " : "") + e, this._addCommandToBinding(t, "chainKeys");
                }, this || _global), t += " "), this.parseKeys(e)),
                e = l[n.hashId] + n.key;
              this._addCommandToBinding(t + e, i, o);
            }, this || _global);
          }, (this || _global)._addCommandToBinding = function (e, t, n) {
            var i = (this || _global).commandKeyBinding;
            if (t) {
              if (!i[e] || (this || _global).$singleCommand) i[e] = t;else {
                Array.isArray(i[e]) ? -1 != (r = i[e].indexOf(t)) && i[e].splice(r, 1) : i[e] = [i[e]], "number" != typeof n && (n = s(t));
                for (var o = i[e], r = 0; r < o.length; r++) if (n < s(o[r])) break;
                o.splice(r, 0, t);
              }
            } else delete i[e];
          }, (this || _global).addCommands = function (n) {
            n && Object.keys(n).forEach(function (e) {
              var t = n[e];
              if (t) {
                if ("string" == typeof t) return this.bindKey(t, e);
                "object" == typeof (t = "function" == typeof t ? {
                  exec: t
                } : t) && (t.name || (t.name = e), this.addCommand(t));
              }
            }, this || _global);
          }, (this || _global).removeCommands = function (t) {
            Object.keys(t).forEach(function (e) {
              this.removeCommand(t[e]);
            }, this || _global);
          }, (this || _global).bindKeys = function (t) {
            Object.keys(t).forEach(function (e) {
              this.bindKey(e, t[e]);
            }, this || _global);
          }, (this || _global)._buildKeyHash = function (e) {
            this.bindKey(e.bindKey, e);
          }, (this || _global).parseKeys = function (e) {
            var t = e.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function (e) {
                return e;
              }),
              n = t.pop(),
              i = a[n];
            if (a.FUNCTION_KEYS[i]) n = a.FUNCTION_KEYS[i].toLowerCase();else {
              if (!t.length) return {
                key: n,
                hashId: -1
              };
              if (1 == t.length && "shift" == t[0]) return {
                key: n.toUpperCase(),
                hashId: -1
              };
            }
            for (var o = 0, r = t.length; r--;) {
              var s = a.KEY_MODS[t[r]];
              if (null == s) return "undefined" != typeof console && console.error("invalid modifier " + t[r] + " in " + e), !1;
              o |= s;
            }
            return {
              key: n,
              hashId: o
            };
          }, (this || _global).findKeyCommand = function (e, t) {
            e = l[e] + t;
            return (this || _global).commandKeyBinding[e];
          }, (this || _global).handleKeyboard = function (e, t, n, i) {
            var o, r;
            if (!(i < 0)) return o = l[t] + n, r = (this || _global).commandKeyBinding[o], e.$keyChain && (e.$keyChain += " " + o, r = (this || _global).commandKeyBinding[e.$keyChain] || r), !r || "chainKeys" != r && "chainKeys" != r[r.length - 1] ? (e.$keyChain && (t && 4 != t || 1 != n.length ? (-1 == t || 0 < i) && (e.$keyChain = "") : e.$keyChain = e.$keyChain.slice(0, -o.length - 1)), {
              command: r
            }) : (e.$keyChain = e.$keyChain || o, {
              command: "null"
            });
          }, (this || _global).getStatusText = function (e, t) {
            return t.$keyChain || "";
          };
        }.call(o.prototype), t.HashHandler = o, t.MultiHashHandler = r;
      }), ace.define("ace/commands/command_manager", ["require", "exports", "module", "ace/lib/oop", "ace/keyboard/hash_handler", "ace/lib/event_emitter"], function (e, t, n) {
        "use strict";

        var i,
          o,
          r = (this || _global) && (this || _global).__extends || (i = function (e, t) {
            return (i = Object.setPrototypeOf || ({
              __proto__: []
            } instanceof Array ? function (e, t) {
              e.__proto__ = t;
            } : function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }))(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              (this || _global).constructor = e;
            }
            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          s = e("../lib/oop"),
          a = e("../keyboard/hash_handler").MultiHashHandler,
          e = e("../lib/event_emitter").EventEmitter,
          r = (r(l, o = a), l.prototype.exec = function (e, t, n) {
            if (Array.isArray(e)) {
              for (var i = e.length; i--;) if (this.exec(e[i], t, n)) return !0;
              return !1;
            }
            var o;
            return !!(e = "string" == typeof e ? (this || _global).commands[e] : e) && !(t && t.$readOnly && !e.readOnly || 0 != (this || _global).$checkCommandState && e.isAvailable && !e.isAvailable(t) || ((o = {
              editor: t,
              command: e,
              args: n
            }).returnValue = this._emit("exec", o), this._signal("afterExec", o), !1 === o.returnValue));
          }, l.prototype.toggleRecording = function (e) {
            if (!(this || _global).$inReplay) return e && e._emit("changeStatus"), (this || _global).recording ? ((this || _global).macro.pop(), this.off("exec", (this || _global).$addCommandToMacro), (this || _global).macro.length || ((this || _global).macro = (this || _global).oldMacro), (this || _global).recording = !1) : ((this || _global).$addCommandToMacro || ((this || _global).$addCommandToMacro = function (e) {
              (this || _global).macro.push([e.command, e.args]);
            }.bind(this || _global)), (this || _global).oldMacro = (this || _global).macro, (this || _global).macro = [], this.on("exec", (this || _global).$addCommandToMacro), (this || _global).recording = !0);
          }, l.prototype.replay = function (t) {
            if (!(this || _global).$inReplay && (this || _global).macro) {
              if ((this || _global).recording) return this.toggleRecording(t);
              try {
                (this || _global).$inReplay = !0, (this || _global).macro.forEach(function (e) {
                  "string" == typeof e ? this.exec(e, t) : this.exec(e[0], t, e[1]);
                }, this || _global);
              } finally {
                (this || _global).$inReplay = !1;
              }
            }
          }, l.prototype.trimMacro = function (e) {
            return e.map(function (e) {
              return "string" != typeof e[0] && (e[0] = e[0].name), e = e[1] ? e : e[0];
            });
          }, l);
        function l(e, t) {
          t = o.call(this || _global, t, e) || this || _global;
          return t.byName = t.commands, t.setDefaultHandler("exec", function (e) {
            return e.args ? e.command.exec(e.editor, e.args, e.event, !1) : e.command.exec(e.editor, {}, e.event, !0);
          }), t;
        }
        s.implement(r.prototype, e), t.CommandManager = r;
      }), ace.define("ace/commands/default_commands", ["require", "exports", "module", "ace/lib/lang", "ace/config", "ace/range"], function (e, t, n) {
        "use strict";

        var l = e("../lib/lang"),
          i = e("../config"),
          c = e("../range").Range;
        function o(e, t) {
          return {
            win: e,
            mac: t
          };
        }
        t.commands = [{
          name: "showSettingsMenu",
          description: "Show settings menu",
          bindKey: o("Ctrl-,", "Command-,"),
          exec: function (t) {
            i.loadModule("ace/ext/settings_menu", function (e) {
              e.init(t), t.showSettingsMenu();
            });
          },
          readOnly: !0
        }, {
          name: "goToNextError",
          description: "Go to next error",
          bindKey: o("Alt-E", "F4"),
          exec: function (t) {
            i.loadModule("ace/ext/error_marker", function (e) {
              e.showErrorMarker(t, 1);
            });
          },
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "goToPreviousError",
          description: "Go to previous error",
          bindKey: o("Alt-Shift-E", "Shift-F4"),
          exec: function (t) {
            i.loadModule("ace/ext/error_marker", function (e) {
              e.showErrorMarker(t, -1);
            });
          },
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "selectall",
          description: "Select all",
          bindKey: o("Ctrl-A", "Command-A"),
          exec: function (e) {
            e.selectAll();
          },
          readOnly: !0
        }, {
          name: "centerselection",
          description: "Center selection",
          bindKey: o(null, "Ctrl-L"),
          exec: function (e) {
            e.centerSelection();
          },
          readOnly: !0
        }, {
          name: "gotoline",
          description: "Go to line...",
          bindKey: o("Ctrl-L", "Command-L"),
          exec: function (e, t) {
            "number" != typeof t || isNaN(t) || e.gotoLine(t), e.prompt({
              $type: "gotoLine"
            });
          },
          readOnly: !0
        }, {
          name: "fold",
          bindKey: o("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
          exec: function (e) {
            e.session.toggleFold(!1);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "unfold",
          bindKey: o("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
          exec: function (e) {
            e.session.toggleFold(!0);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "toggleFoldWidget",
          description: "Toggle fold widget",
          bindKey: o("F2", "F2"),
          exec: function (e) {
            e.session.toggleFoldWidget();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "toggleParentFoldWidget",
          description: "Toggle parent fold widget",
          bindKey: o("Alt-F2", "Alt-F2"),
          exec: function (e) {
            e.session.toggleFoldWidget(!0);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "foldall",
          description: "Fold all",
          bindKey: o(null, "Ctrl-Command-Option-0"),
          exec: function (e) {
            e.session.foldAll();
          },
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "foldAllComments",
          description: "Fold all comments",
          bindKey: o(null, "Ctrl-Command-Option-0"),
          exec: function (e) {
            e.session.foldAllComments();
          },
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "foldOther",
          description: "Fold other",
          bindKey: o("Alt-0", "Command-Option-0"),
          exec: function (e) {
            e.session.foldAll(), e.session.unfold(e.selection.getAllRanges());
          },
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "unfoldall",
          description: "Unfold all",
          bindKey: o("Alt-Shift-0", "Command-Option-Shift-0"),
          exec: function (e) {
            e.session.unfold();
          },
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "findnext",
          description: "Find next",
          bindKey: o("Ctrl-K", "Command-G"),
          exec: function (e) {
            e.findNext();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "findprevious",
          description: "Find previous",
          bindKey: o("Ctrl-Shift-K", "Command-Shift-G"),
          exec: function (e) {
            e.findPrevious();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "selectOrFindNext",
          description: "Select or find next",
          bindKey: o("Alt-K", "Ctrl-G"),
          exec: function (e) {
            e.selection.isEmpty() ? e.selection.selectWord() : e.findNext();
          },
          readOnly: !0
        }, {
          name: "selectOrFindPrevious",
          description: "Select or find previous",
          bindKey: o("Alt-Shift-K", "Ctrl-Shift-G"),
          exec: function (e) {
            e.selection.isEmpty() ? e.selection.selectWord() : e.findPrevious();
          },
          readOnly: !0
        }, {
          name: "find",
          description: "Find",
          bindKey: o("Ctrl-F", "Command-F"),
          exec: function (t) {
            i.loadModule("ace/ext/searchbox", function (e) {
              e.Search(t);
            });
          },
          readOnly: !0
        }, {
          name: "overwrite",
          description: "Overwrite",
          bindKey: "Insert",
          exec: function (e) {
            e.toggleOverwrite();
          },
          readOnly: !0
        }, {
          name: "selecttostart",
          description: "Select to start",
          bindKey: o("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
          exec: function (e) {
            e.getSelection().selectFileStart();
          },
          multiSelectAction: "forEach",
          readOnly: !0,
          scrollIntoView: "animate",
          aceCommandGroup: "fileJump"
        }, {
          name: "gotostart",
          description: "Go to start",
          bindKey: o("Ctrl-Home", "Command-Home|Command-Up"),
          exec: function (e) {
            e.navigateFileStart();
          },
          multiSelectAction: "forEach",
          readOnly: !0,
          scrollIntoView: "animate",
          aceCommandGroup: "fileJump"
        }, {
          name: "selectup",
          description: "Select up",
          bindKey: o("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
          exec: function (e) {
            e.getSelection().selectUp();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "golineup",
          description: "Go line up",
          bindKey: o("Up", "Up|Ctrl-P"),
          exec: function (e, t) {
            e.navigateUp(t.times);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selecttoend",
          description: "Select to end",
          bindKey: o("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
          exec: function (e) {
            e.getSelection().selectFileEnd();
          },
          multiSelectAction: "forEach",
          readOnly: !0,
          scrollIntoView: "animate",
          aceCommandGroup: "fileJump"
        }, {
          name: "gotoend",
          description: "Go to end",
          bindKey: o("Ctrl-End", "Command-End|Command-Down"),
          exec: function (e) {
            e.navigateFileEnd();
          },
          multiSelectAction: "forEach",
          readOnly: !0,
          scrollIntoView: "animate",
          aceCommandGroup: "fileJump"
        }, {
          name: "selectdown",
          description: "Select down",
          bindKey: o("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
          exec: function (e) {
            e.getSelection().selectDown();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "golinedown",
          description: "Go line down",
          bindKey: o("Down", "Down|Ctrl-N"),
          exec: function (e, t) {
            e.navigateDown(t.times);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectwordleft",
          description: "Select word left",
          bindKey: o("Ctrl-Shift-Left", "Option-Shift-Left"),
          exec: function (e) {
            e.getSelection().selectWordLeft();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotowordleft",
          description: "Go to word left",
          bindKey: o("Ctrl-Left", "Option-Left"),
          exec: function (e) {
            e.navigateWordLeft();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selecttolinestart",
          description: "Select to line start",
          bindKey: o("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
          exec: function (e) {
            e.getSelection().selectLineStart();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotolinestart",
          description: "Go to line start",
          bindKey: o("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
          exec: function (e) {
            e.navigateLineStart();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectleft",
          description: "Select left",
          bindKey: o("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
          exec: function (e) {
            e.getSelection().selectLeft();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotoleft",
          description: "Go to left",
          bindKey: o("Left", "Left|Ctrl-B"),
          exec: function (e, t) {
            e.navigateLeft(t.times);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectwordright",
          description: "Select word right",
          bindKey: o("Ctrl-Shift-Right", "Option-Shift-Right"),
          exec: function (e) {
            e.getSelection().selectWordRight();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotowordright",
          description: "Go to word right",
          bindKey: o("Ctrl-Right", "Option-Right"),
          exec: function (e) {
            e.navigateWordRight();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selecttolineend",
          description: "Select to line end",
          bindKey: o("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
          exec: function (e) {
            e.getSelection().selectLineEnd();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotolineend",
          description: "Go to line end",
          bindKey: o("Alt-Right|End", "Command-Right|End|Ctrl-E"),
          exec: function (e) {
            e.navigateLineEnd();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectright",
          description: "Select right",
          bindKey: o("Shift-Right", "Shift-Right"),
          exec: function (e) {
            e.getSelection().selectRight();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotoright",
          description: "Go to right",
          bindKey: o("Right", "Right|Ctrl-F"),
          exec: function (e, t) {
            e.navigateRight(t.times);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectpagedown",
          description: "Select page down",
          bindKey: "Shift-PageDown",
          exec: function (e) {
            e.selectPageDown();
          },
          readOnly: !0
        }, {
          name: "pagedown",
          description: "Page down",
          bindKey: o(null, "Option-PageDown"),
          exec: function (e) {
            e.scrollPageDown();
          },
          readOnly: !0
        }, {
          name: "gotopagedown",
          description: "Go to page down",
          bindKey: o("PageDown", "PageDown|Ctrl-V"),
          exec: function (e) {
            e.gotoPageDown();
          },
          readOnly: !0
        }, {
          name: "selectpageup",
          description: "Select page up",
          bindKey: "Shift-PageUp",
          exec: function (e) {
            e.selectPageUp();
          },
          readOnly: !0
        }, {
          name: "pageup",
          description: "Page up",
          bindKey: o(null, "Option-PageUp"),
          exec: function (e) {
            e.scrollPageUp();
          },
          readOnly: !0
        }, {
          name: "gotopageup",
          description: "Go to page up",
          bindKey: "PageUp",
          exec: function (e) {
            e.gotoPageUp();
          },
          readOnly: !0
        }, {
          name: "scrollup",
          description: "Scroll up",
          bindKey: o("Ctrl-Up", null),
          exec: function (e) {
            e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight);
          },
          readOnly: !0
        }, {
          name: "scrolldown",
          description: "Scroll down",
          bindKey: o("Ctrl-Down", null),
          exec: function (e) {
            e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight);
          },
          readOnly: !0
        }, {
          name: "selectlinestart",
          description: "Select line start",
          bindKey: "Shift-Home",
          exec: function (e) {
            e.getSelection().selectLineStart();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectlineend",
          description: "Select line end",
          bindKey: "Shift-End",
          exec: function (e) {
            e.getSelection().selectLineEnd();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "togglerecording",
          description: "Toggle recording",
          bindKey: o("Ctrl-Alt-E", "Command-Option-E"),
          exec: function (e) {
            e.commands.toggleRecording(e);
          },
          readOnly: !0
        }, {
          name: "replaymacro",
          description: "Replay macro",
          bindKey: o("Ctrl-Shift-E", "Command-Shift-E"),
          exec: function (e) {
            e.commands.replay(e);
          },
          readOnly: !0
        }, {
          name: "jumptomatching",
          description: "Jump to matching",
          bindKey: o("Ctrl-\\|Ctrl-P", "Command-\\"),
          exec: function (e) {
            e.jumpToMatching();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "selecttomatching",
          description: "Select to matching",
          bindKey: o("Ctrl-Shift-\\|Ctrl-Shift-P", "Command-Shift-\\"),
          exec: function (e) {
            e.jumpToMatching(!0);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "expandToMatching",
          description: "Expand to matching",
          bindKey: o("Ctrl-Shift-M", "Ctrl-Shift-M"),
          exec: function (e) {
            e.jumpToMatching(!0, !0);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "passKeysToBrowser",
          description: "Pass keys to browser",
          bindKey: o(null, null),
          exec: function () {},
          passEvent: !0,
          readOnly: !0
        }, {
          name: "copy",
          description: "Copy",
          exec: function (e) {},
          readOnly: !0
        }, {
          name: "cut",
          description: "Cut",
          exec: function (e) {
            var t = e.$copyWithEmptySelection && e.selection.isEmpty() ? e.selection.getLineRange() : e.selection.getRange();
            e._emit("cut", t), t.isEmpty() || e.session.remove(t), e.clearSelection();
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEach"
        }, {
          name: "paste",
          description: "Paste",
          exec: function (e, t) {
            e.$handlePaste(t);
          },
          scrollIntoView: "cursor"
        }, {
          name: "removeline",
          description: "Remove line",
          bindKey: o("Ctrl-D", "Command-D"),
          exec: function (e) {
            e.removeLines();
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEachLine"
        }, {
          name: "duplicateSelection",
          description: "Duplicate selection",
          bindKey: o("Ctrl-Shift-D", "Command-Shift-D"),
          exec: function (e) {
            e.duplicateSelection();
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEach"
        }, {
          name: "sortlines",
          description: "Sort lines",
          bindKey: o("Ctrl-Alt-S", "Command-Alt-S"),
          exec: function (e) {
            e.sortLines();
          },
          scrollIntoView: "selection",
          multiSelectAction: "forEachLine"
        }, {
          name: "togglecomment",
          description: "Toggle comment",
          bindKey: o("Ctrl-/", "Command-/"),
          exec: function (e) {
            e.toggleCommentLines();
          },
          multiSelectAction: "forEachLine",
          scrollIntoView: "selectionPart"
        }, {
          name: "toggleBlockComment",
          description: "Toggle block comment",
          bindKey: o("Ctrl-Shift-/", "Command-Shift-/"),
          exec: function (e) {
            e.toggleBlockComment();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "selectionPart"
        }, {
          name: "modifyNumberUp",
          description: "Modify number up",
          bindKey: o("Ctrl-Shift-Up", "Alt-Shift-Up"),
          exec: function (e) {
            e.modifyNumber(1);
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEach"
        }, {
          name: "modifyNumberDown",
          description: "Modify number down",
          bindKey: o("Ctrl-Shift-Down", "Alt-Shift-Down"),
          exec: function (e) {
            e.modifyNumber(-1);
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEach"
        }, {
          name: "replace",
          description: "Replace",
          bindKey: o("Ctrl-H", "Command-Option-F"),
          exec: function (t) {
            i.loadModule("ace/ext/searchbox", function (e) {
              e.Search(t, !0);
            });
          }
        }, {
          name: "undo",
          description: "Undo",
          bindKey: o("Ctrl-Z", "Command-Z"),
          exec: function (e) {
            e.undo();
          }
        }, {
          name: "redo",
          description: "Redo",
          bindKey: o("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
          exec: function (e) {
            e.redo();
          }
        }, {
          name: "copylinesup",
          description: "Copy lines up",
          bindKey: o("Alt-Shift-Up", "Command-Option-Up"),
          exec: function (e) {
            e.copyLinesUp();
          },
          scrollIntoView: "cursor"
        }, {
          name: "movelinesup",
          description: "Move lines up",
          bindKey: o("Alt-Up", "Option-Up"),
          exec: function (e) {
            e.moveLinesUp();
          },
          scrollIntoView: "cursor"
        }, {
          name: "copylinesdown",
          description: "Copy lines down",
          bindKey: o("Alt-Shift-Down", "Command-Option-Down"),
          exec: function (e) {
            e.copyLinesDown();
          },
          scrollIntoView: "cursor"
        }, {
          name: "movelinesdown",
          description: "Move lines down",
          bindKey: o("Alt-Down", "Option-Down"),
          exec: function (e) {
            e.moveLinesDown();
          },
          scrollIntoView: "cursor"
        }, {
          name: "del",
          description: "Delete",
          bindKey: o("Delete", "Delete|Ctrl-D|Shift-Delete"),
          exec: function (e) {
            e.remove("right");
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "backspace",
          description: "Backspace",
          bindKey: o("Shift-Backspace|Backspace", "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),
          exec: function (e) {
            e.remove("left");
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "cut_or_delete",
          description: "Cut or delete",
          bindKey: o("Shift-Delete", null),
          exec: function (e) {
            if (!e.selection.isEmpty()) return !1;
            e.remove("left");
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removetolinestart",
          description: "Remove to line start",
          bindKey: o("Alt-Backspace", "Command-Backspace"),
          exec: function (e) {
            e.removeToLineStart();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removetolineend",
          description: "Remove to line end",
          bindKey: o("Alt-Delete", "Ctrl-K|Command-Delete"),
          exec: function (e) {
            e.removeToLineEnd();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removetolinestarthard",
          description: "Remove to line start hard",
          bindKey: o("Ctrl-Shift-Backspace", null),
          exec: function (e) {
            var t = e.selection.getRange();
            t.start.column = 0, e.session.remove(t);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removetolineendhard",
          description: "Remove to line end hard",
          bindKey: o("Ctrl-Shift-Delete", null),
          exec: function (e) {
            var t = e.selection.getRange();
            t.end.column = Number.MAX_VALUE, e.session.remove(t);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removewordleft",
          description: "Remove word left",
          bindKey: o("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
          exec: function (e) {
            e.removeWordLeft();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removewordright",
          description: "Remove word right",
          bindKey: o("Ctrl-Delete", "Alt-Delete"),
          exec: function (e) {
            e.removeWordRight();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "outdent",
          description: "Outdent",
          bindKey: o("Shift-Tab", "Shift-Tab"),
          exec: function (e) {
            e.blockOutdent();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "selectionPart"
        }, {
          name: "indent",
          description: "Indent",
          bindKey: o("Tab", "Tab"),
          exec: function (e) {
            e.indent();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "selectionPart"
        }, {
          name: "blockoutdent",
          description: "Block outdent",
          bindKey: o("Ctrl-[", "Ctrl-["),
          exec: function (e) {
            e.blockOutdent();
          },
          multiSelectAction: "forEachLine",
          scrollIntoView: "selectionPart"
        }, {
          name: "blockindent",
          description: "Block indent",
          bindKey: o("Ctrl-]", "Ctrl-]"),
          exec: function (e) {
            e.blockIndent();
          },
          multiSelectAction: "forEachLine",
          scrollIntoView: "selectionPart"
        }, {
          name: "insertstring",
          description: "Insert string",
          exec: function (e, t) {
            e.insert(t);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "inserttext",
          description: "Insert text",
          exec: function (e, t) {
            e.insert(l.stringRepeat(t.text || "", t.times || 1));
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "splitline",
          description: "Split line",
          bindKey: o(null, "Ctrl-O"),
          exec: function (e) {
            e.splitLine();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "transposeletters",
          description: "Transpose letters",
          bindKey: o("Alt-Shift-X", "Ctrl-T"),
          exec: function (e) {
            e.transposeLetters();
          },
          multiSelectAction: function (e) {
            e.transposeSelections(1);
          },
          scrollIntoView: "cursor"
        }, {
          name: "touppercase",
          description: "To uppercase",
          bindKey: o("Ctrl-U", "Ctrl-U"),
          exec: function (e) {
            e.toUpperCase();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "tolowercase",
          description: "To lowercase",
          bindKey: o("Ctrl-Shift-U", "Ctrl-Shift-U"),
          exec: function (e) {
            e.toLowerCase();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "autoindent",
          description: "Auto Indent",
          bindKey: o(null, null),
          exec: function (e) {
            e.autoIndent();
          },
          multiSelectAction: "forEachLine",
          scrollIntoView: "animate"
        }, {
          name: "expandtoline",
          description: "Expand to line",
          bindKey: o("Ctrl-Shift-L", "Command-Shift-L"),
          exec: function (e) {
            var t = e.selection.getRange();
            t.start.column = t.end.column = 0, t.end.row++, e.selection.setRange(t, !1);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "openlink",
          bindKey: o("Ctrl+F3", "F3"),
          exec: function (e) {
            e.openLink();
          }
        }, {
          name: "joinlines",
          description: "Join lines",
          bindKey: o(null, null),
          exec: function (e) {
            for (var t = e.selection.isBackwards(), n = t ? e.selection.getSelectionLead() : e.selection.getSelectionAnchor(), i = t ? e.selection.getSelectionAnchor() : e.selection.getSelectionLead(), t = e.session.doc.getLine(n.row).length, o = e.session.doc.getTextRange(e.selection.getRange()).replace(/\n\s*/, " ").length, r = e.session.doc.getLine(n.row), s = n.row + 1; s <= i.row + 1; s++) {
              var a = l.stringTrimLeft(l.stringTrimRight(e.session.doc.getLine(s)));
              r += a = 0 !== a.length ? " " + a : a;
            }
            i.row + 1 < e.session.doc.getLength() - 1 && (r += e.session.doc.getNewLineCharacter()), e.clearSelection(), e.session.doc.replace(new c(n.row, 0, i.row + 2, 0), r), 0 < o ? (e.selection.moveCursorTo(n.row, n.column), e.selection.selectTo(n.row, n.column + o)) : (t = e.session.doc.getLine(n.row).length > t ? t + 1 : t, e.selection.moveCursorTo(n.row, t));
          },
          multiSelectAction: "forEach",
          readOnly: !0
        }, {
          name: "invertSelection",
          description: "Invert selection",
          bindKey: o(null, null),
          exec: function (e) {
            var t = e.session.doc.getLength() - 1,
              n = e.session.doc.getLine(t).length,
              i = e.selection.rangeList.ranges,
              o = [];
            i.length < 1 && (i = [e.selection.getRange()]);
            for (var r = 0; r < i.length; r++) r != i.length - 1 || i[r].end.row === t && i[r].end.column === n || o.push(new c(i[r].end.row, i[r].end.column, t, n)), 0 === r ? 0 === i[r].start.row && 0 === i[r].start.column || o.push(new c(0, 0, i[r].start.row, i[r].start.column)) : o.push(new c(i[r - 1].end.row, i[r - 1].end.column, i[r].start.row, i[r].start.column));
            e.exitMultiSelectMode(), e.clearSelection();
            for (r = 0; r < o.length; r++) e.selection.addRange(o[r], !1);
          },
          readOnly: !0,
          scrollIntoView: "none"
        }, {
          name: "addLineAfter",
          description: "Add new line after the current line",
          exec: function (e) {
            e.selection.clearSelection(), e.navigateLineEnd(), e.insert("\n");
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "addLineBefore",
          description: "Add new line before the current line",
          exec: function (e) {
            e.selection.clearSelection();
            var t = e.getCursorPosition();
            e.selection.moveTo(t.row - 1, Number.MAX_VALUE), e.insert("\n"), 0 === t.row && e.navigateUp();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "openCommandPallete",
          description: "Open command palette",
          bindKey: o("F1", "F1"),
          exec: function (e) {
            e.prompt({
              $type: "commands"
            });
          },
          readOnly: !0
        }, {
          name: "modeSelect",
          description: "Change language mode...",
          bindKey: o(null, null),
          exec: function (e) {
            e.prompt({
              $type: "modes"
            });
          },
          readOnly: !0
        }];
        for (var r = 1; r < 9; r++) t.commands.push({
          name: "foldToLevel" + r,
          description: "Fold To Level " + r,
          level: r,
          exec: function (e) {
            e.session.foldToLevel((this || _global).level);
          },
          scrollIntoView: "center",
          readOnly: !0
        });
      }), ace.define("ace/line_widgets", ["require", "exports", "module", "ace/lib/dom"], function (e, t, n) {
        "use strict";

        var o = e("./lib/dom");
        function i(e) {
          (this || _global).session = e, ((this || _global).session.widgetManager = this || _global).session.getRowLength = (this || _global).getRowLength, (this || _global).session.$getWidgetScreenLength = (this || _global).$getWidgetScreenLength, (this || _global).updateOnChange = (this || _global).updateOnChange.bind(this || _global), (this || _global).renderWidgets = (this || _global).renderWidgets.bind(this || _global), (this || _global).measureWidgets = (this || _global).measureWidgets.bind(this || _global), (this || _global).session._changedWidgets = [], (this || _global).$onChangeEditor = (this || _global).$onChangeEditor.bind(this || _global), (this || _global).session.on("change", (this || _global).updateOnChange), (this || _global).session.on("changeFold", (this || _global).updateOnFold), (this || _global).session.on("changeEditor", (this || _global).$onChangeEditor);
        }
        i.prototype.getRowLength = function (e) {
          var t = (this || _global).lineWidgets && (this || _global).lineWidgets[e] && (this || _global).lineWidgets[e].rowCount || 0;
          return (this || _global).$useWrapMode && (this || _global).$wrapData[e] ? (this || _global).$wrapData[e].length + 1 + t : 1 + t;
        }, i.prototype.$getWidgetScreenLength = function () {
          var t = 0;
          return (this || _global).lineWidgets.forEach(function (e) {
            e && e.rowCount && !e.hidden && (t += e.rowCount);
          }), t;
        }, i.prototype.$onChangeEditor = function (e) {
          this.attach(e.editor);
        }, i.prototype.attach = function (e) {
          e && e.widgetManager && e.widgetManager != (this || _global) && e.widgetManager.detach(), (this || _global).editor != e && (this.detach(), (this || _global).editor = e) && (e.widgetManager = this || _global, e.renderer.on("beforeRender", (this || _global).measureWidgets), e.renderer.on("afterRender", (this || _global).renderWidgets));
        }, i.prototype.detach = function (e) {
          var t = (this || _global).editor;
          t && ((this || _global).editor = null, t.widgetManager = null, t.renderer.off("beforeRender", (this || _global).measureWidgets), t.renderer.off("afterRender", (this || _global).renderWidgets), t = (this || _global).session.lineWidgets) && t.forEach(function (e) {
            e && e.el && e.el.parentNode && (e._inDocument = !1, e.el.parentNode.removeChild(e.el));
          });
        }, i.prototype.updateOnFold = function (e, t) {
          var n = t.lineWidgets;
          if (n && e.action) {
            for (var t = e.data, i = t.start.row, o = t.end.row, r = "add" == e.action, s = i + 1; s < o; s++) n[s] && (n[s].hidden = r);
            n[o] && (r ? n[i] ? n[o].hidden = r : n[i] = n[o] : (n[i] == n[o] && (n[i] = void 0), n[o].hidden = r));
          }
        }, i.prototype.updateOnChange = function (e) {
          var t,
            n,
            i,
            o = (this || _global).session.lineWidgets;
          o && (t = e.start.row, 0 != (n = e.end.row - t)) && ("remove" == e.action ? (i = o.splice(t + 1, n), !o[t] && i[i.length - 1] && (o[t] = i.pop()), i.forEach(function (e) {
            e && this.removeLineWidget(e);
          }, this || _global)) : (i = new Array(n), o[t] && null != o[t].column && e.start.column > o[t].column && t++, i.unshift(t, 0), o.splice.apply(o, i)), this.$updateRows());
        }, i.prototype.$updateRows = function () {
          var n,
            e = (this || _global).session.lineWidgets;
          e && (n = !0, e.forEach(function (e, t) {
            if (e) for (n = !1, e.row = t; e.$oldWidget;) e.$oldWidget.row = t, e = e.$oldWidget;
          }), n) && ((this || _global).session.lineWidgets = null);
        }, i.prototype.$registerLineWidget = function (e) {
          (this || _global).session.lineWidgets || ((this || _global).session.lineWidgets = new Array((this || _global).session.getLength()));
          var t = (this || _global).session.lineWidgets[e.row];
          return t && (e.$oldWidget = t).el && t.el.parentNode && (t.el.parentNode.removeChild(t.el), t._inDocument = !1), (this || _global).session.lineWidgets[e.row] = e;
        }, i.prototype.addLineWidget = function (e) {
          var t, n, i;
          return this.$registerLineWidget(e), e.session = (this || _global).session, (this || _global).editor && (t = (this || _global).editor.renderer, e.html && !e.el && (e.el = o.createElement("div"), e.el.innerHTML = e.html), e.text && !e.el && (e.el = o.createElement("div"), e.el.textContent = e.text), e.el && (o.addCssClass(e.el, "ace_lineWidgetContainer"), e.className && o.addCssClass(e.el, e.className), e.el.style.position = "absolute", e.el.style.zIndex = 5, t.container.appendChild(e.el), e._inDocument = !0, e.coverGutter || (e.el.style.zIndex = 3), null == e.pixelHeight) && (e.pixelHeight = e.el.offsetHeight), null == e.rowCount && (e.rowCount = e.pixelHeight / t.layerConfig.lineHeight), n = (this || _global).session.getFoldAt(e.row, 0), (e.$fold = n) && (i = (this || _global).session.lineWidgets, e.row != n.end.row || i[n.start.row] ? e.hidden = !0 : i[n.start.row] = e), (this || _global).session._emit("changeFold", {
            data: {
              start: {
                row: e.row
              }
            }
          }), this.$updateRows(), this.renderWidgets(null, t), this.onWidgetChanged(e)), e;
        }, i.prototype.removeLineWidget = function (e) {
          if (e._inDocument = !1, e.session = null, e.el && e.el.parentNode && e.el.parentNode.removeChild(e.el), e.editor && e.editor.destroy) try {
            e.editor.destroy();
          } catch (e) {}
          if ((this || _global).session.lineWidgets) {
            var t = (this || _global).session.lineWidgets[e.row];
            if (t == e) (this || _global).session.lineWidgets[e.row] = e.$oldWidget, e.$oldWidget && this.onWidgetChanged(e.$oldWidget);else for (; t;) {
              if (t.$oldWidget == e) {
                t.$oldWidget = e.$oldWidget;
                break;
              }
              t = t.$oldWidget;
            }
          }
          (this || _global).session._emit("changeFold", {
            data: {
              start: {
                row: e.row
              }
            }
          }), this.$updateRows();
        }, i.prototype.getWidgetsAtRow = function (e) {
          for (var t = (this || _global).session.lineWidgets, n = t && t[e], i = []; n;) i.push(n), n = n.$oldWidget;
          return i;
        }, i.prototype.onWidgetChanged = function (e) {
          (this || _global).session._changedWidgets.push(e), (this || _global).editor && (this || _global).editor.renderer.updateFull();
        }, i.prototype.measureWidgets = function (e, t) {
          var n = (this || _global).session._changedWidgets,
            i = t.layerConfig;
          if (n && n.length) {
            for (var o = 1 / 0, r = 0; r < n.length; r++) {
              var s = n[r];
              if (s && s.el && s.session == (this || _global).session) {
                if (!s._inDocument) {
                  if ((this || _global).session.lineWidgets[s.row] != s) continue;
                  s._inDocument = !0, t.container.appendChild(s.el);
                }
                s.h = s.el.offsetHeight, s.fixedWidth || (s.w = s.el.offsetWidth, s.screenWidth = Math.ceil(s.w / i.characterWidth));
                var a = s.h / i.lineHeight;
                s.coverLine && (a -= (this || _global).session.getRowLineCount(s.row)) < 0 && (a = 0), s.rowCount != a && (s.rowCount = a, s.row < o) && (o = s.row);
              }
            }
            o != 1 / 0 && ((this || _global).session._emit("changeFold", {
              data: {
                start: {
                  row: o
                }
              }
            }), (this || _global).session.lineWidgetWidth = null), (this || _global).session._changedWidgets = [];
          }
        }, i.prototype.renderWidgets = function (e, t) {
          var n = t.layerConfig,
            i = (this || _global).session.lineWidgets;
          if (i) {
            for (var o = Math.min((this || _global).firstRow, n.firstRow), r = Math.max((this || _global).lastRow, n.lastRow, i.length); 0 < o && !i[o];) o--;
            (this || _global).firstRow = n.firstRow, (this || _global).lastRow = n.lastRow, t.$cursorLayer.config = n;
            for (var s = o; s <= r; s++) {
              var a,
                l = i[s];
              l && l.el && (l.hidden ? l.el.style.top = -100 - (l.pixelHeight || 0) + "px" : (l._inDocument || (l._inDocument = !0, t.container.appendChild(l.el)), a = t.$cursorLayer.getPixelPosition({
                row: s,
                column: 0
              }, !0).top, l.coverLine || (a += n.lineHeight * (this || _global).session.getRowLineCount(l.row)), l.el.style.top = a - n.offset + "px", a = l.coverGutter ? 0 : t.gutterWidth, l.fixedWidth || (a -= t.scrollLeft), l.el.style.left = a + "px", l.fullWidth && l.screenWidth && (l.el.style.minWidth = n.width + 2 * n.padding + "px"), l.fixedWidth ? l.el.style.right = t.scrollBar.getWidth() + "px" : l.el.style.right = ""));
            }
          }
        }, t.LineWidgets = i;
      }), ace.define("ace/keyboard/gutter_handler", ["require", "exports", "module", "ace/lib/keys", "ace/mouse/default_gutter_handler"], function (e, t, n) {
        "use strict";

        var r = e("../lib/keys"),
          i = e("../mouse/default_gutter_handler").GutterTooltip;
        function o(e) {
          (this || _global).editor = e, (this || _global).gutterLayer = e.renderer.$gutterLayer, (this || _global).element = e.renderer.$gutter, (this || _global).lines = e.renderer.$gutterLayer.$lines, (this || _global).activeRowIndex = null, (this || _global).activeLane = null, (this || _global).annotationTooltip = new i((this || _global).editor);
        }
        o.prototype.addListener = function () {
          (this || _global).element.addEventListener("keydown", (this || _global).$onGutterKeyDown.bind(this || _global)), (this || _global).element.addEventListener("focusout", (this || _global).$blurGutter.bind(this || _global)), (this || _global).editor.on("mousewheel", (this || _global).$blurGutter.bind(this || _global));
        }, o.prototype.removeListener = function () {
          (this || _global).element.removeEventListener("keydown", (this || _global).$onGutterKeyDown.bind(this || _global)), (this || _global).element.removeEventListener("focusout", (this || _global).$blurGutter.bind(this || _global)), (this || _global).editor.off("mousewheel", (this || _global).$blurGutter.bind(this || _global));
        }, o.prototype.$onGutterKeyDown = function (e) {
          var t;
          if ((this || _global).annotationTooltip.isOpen) e.preventDefault(), e.keyCode === r.escape && (this || _global).annotationTooltip.hide();else if (e.target === (this || _global).element) e.keyCode == r.enter && (e.preventDefault(), t = (this || _global).editor.getCursorPosition().row, (this || _global).editor.isRowVisible(t) || (this || _global).editor.scrollToLine(t, !0, !0), setTimeout(function () {
            var e = this.$rowToRowIndex((this || _global).gutterLayer.$cursorCell.row),
              t = this.$findNearestFoldWidget(e),
              n = this.$findNearestAnnotation(e);
            null === t && null === n || (null === t && null !== n || (null === t || null !== n) && Math.abs(n - e) < Math.abs(t - e) ? ((this || _global).activeRowIndex = n, (this || _global).activeLane = "annotation", this.$focusAnnotation((this || _global).activeRowIndex)) : ((this || _global).activeRowIndex = t, (this || _global).activeLane = "fold", this.$focusFoldWidget((this || _global).activeRowIndex)));
          }.bind(this || _global), 10));else if (e.keyCode === r.tab) e.preventDefault();else if (e.keyCode === r.escape) e.preventDefault(), this.$blurGutter(), (this || _global).element.focus(), (this || _global).lane = null;else if (e.keyCode === r.up) switch (e.preventDefault(), (this || _global).activeLane) {
            case "fold":
              this.$moveFoldWidgetUp();
              break;
            case "annotation":
              this.$moveAnnotationUp();
          } else if (e.keyCode === r.down) switch (e.preventDefault(), (this || _global).activeLane) {
            case "fold":
              this.$moveFoldWidgetDown();
              break;
            case "annotation":
              this.$moveAnnotationDown();
          } else if (e.keyCode === r.left && (e.preventDefault(), this.$switchLane("annotation")), e.keyCode === r.right && (e.preventDefault(), this.$switchLane("fold")), e.keyCode === r.enter || e.keyCode === r.space) switch (e.preventDefault(), (this || _global).activeLane) {
            case "fold":
              if ("start" === (this || _global).gutterLayer.session.foldWidgets[this.$rowIndexToRow((this || _global).activeRowIndex)]) {
                var n = this.$rowIndexToRow((this || _global).activeRowIndex);
                (this || _global).editor.session.onFoldWidgetClick(this.$rowIndexToRow((this || _global).activeRowIndex), e), setTimeout(function () {
                  this.$rowIndexToRow((this || _global).activeRowIndex) !== n && (this.$blurFoldWidget((this || _global).activeRowIndex), (this || _global).activeRowIndex = this.$rowToRowIndex(n), this.$focusFoldWidget((this || _global).activeRowIndex));
                }.bind(this || _global), 10);
                break;
              }
              if ("end" === (this || _global).gutterLayer.session.foldWidgets[this.$rowIndexToRow((this || _global).activeRowIndex)]) break;
              return;
            case "annotation":
              var i = (this || _global).lines.cells[(this || _global).activeRowIndex].element.childNodes[2].getBoundingClientRect(),
                o = (this || _global).annotationTooltip.getElement().style;
              o.left = i.right + "px", o.top = i.bottom + "px", (this || _global).annotationTooltip.showTooltip(this.$rowIndexToRow((this || _global).activeRowIndex));
          }
        }, o.prototype.$blurGutter = function () {
          if (null !== (this || _global).activeRowIndex) switch ((this || _global).activeLane) {
            case "fold":
              this.$blurFoldWidget((this || _global).activeRowIndex);
              break;
            case "annotation":
              this.$blurAnnotation((this || _global).activeRowIndex);
          }
          (this || _global).annotationTooltip.isOpen && (this || _global).annotationTooltip.hide();
        }, o.prototype.$isFoldWidgetVisible = function (e) {
          var t = (this || _global).editor.isRowFullyVisible(this.$rowIndexToRow(e)),
            e = "none" !== this.$getFoldWidget(e).style.display;
          return t && e;
        }, o.prototype.$isAnnotationVisible = function (e) {
          var t = (this || _global).editor.isRowFullyVisible(this.$rowIndexToRow(e)),
            e = "none" !== this.$getAnnotation(e).style.display;
          return t && e;
        }, o.prototype.$getFoldWidget = function (e) {
          return (this || _global).lines.get(e).element.childNodes[1];
        }, o.prototype.$getAnnotation = function (e) {
          return (this || _global).lines.get(e).element.childNodes[2];
        }, o.prototype.$findNearestFoldWidget = function (e) {
          if (this.$isFoldWidgetVisible(e)) return e;
          for (var t = 0; 0 < e - t || e + t < (this || _global).lines.getLength() - 1;) {
            if (0 <= e - ++t && this.$isFoldWidgetVisible(e - t)) return e - t;
            if (e + t <= (this || _global).lines.getLength() - 1 && this.$isFoldWidgetVisible(e + t)) return e + t;
          }
          return null;
        }, o.prototype.$findNearestAnnotation = function (e) {
          if (this.$isAnnotationVisible(e)) return e;
          for (var t = 0; 0 < e - t || e + t < (this || _global).lines.getLength() - 1;) {
            if (0 <= e - ++t && this.$isAnnotationVisible(e - t)) return e - t;
            if (e + t <= (this || _global).lines.getLength() - 1 && this.$isAnnotationVisible(e + t)) return e + t;
          }
          return null;
        }, o.prototype.$focusFoldWidget = function (e) {
          null != e && ((e = this.$getFoldWidget(e)).classList.add((this || _global).editor.renderer.keyboardFocusClassName), e.focus());
        }, o.prototype.$focusAnnotation = function (e) {
          null != e && ((e = this.$getAnnotation(e)).classList.add((this || _global).editor.renderer.keyboardFocusClassName), e.setAttribute("role", "button"), e.focus());
        }, o.prototype.$blurFoldWidget = function (e) {
          e = this.$getFoldWidget(e);
          e.classList.remove((this || _global).editor.renderer.keyboardFocusClassName), e.blur();
        }, o.prototype.$blurAnnotation = function (e) {
          e = this.$getAnnotation(e);
          e.classList.remove((this || _global).editor.renderer.keyboardFocusClassName), e.removeAttribute("role"), e.blur();
        }, o.prototype.$moveFoldWidgetUp = function () {
          for (var e = (this || _global).activeRowIndex; 0 < e;) if (this.$isFoldWidgetVisible(--e)) return this.$blurFoldWidget((this || _global).activeRowIndex), (this || _global).activeRowIndex = e, void this.$focusFoldWidget((this || _global).activeRowIndex);
        }, o.prototype.$moveFoldWidgetDown = function () {
          for (var e = (this || _global).activeRowIndex; e < (this || _global).lines.getLength() - 1;) if (this.$isFoldWidgetVisible(++e)) return this.$blurFoldWidget((this || _global).activeRowIndex), (this || _global).activeRowIndex = e, void this.$focusFoldWidget((this || _global).activeRowIndex);
        }, o.prototype.$moveAnnotationUp = function () {
          for (var e = (this || _global).activeRowIndex; 0 < e;) if (this.$isAnnotationVisible(--e)) return this.$blurAnnotation((this || _global).activeRowIndex), (this || _global).activeRowIndex = e, void this.$focusAnnotation((this || _global).activeRowIndex);
        }, o.prototype.$moveAnnotationDown = function () {
          for (var e = (this || _global).activeRowIndex; e < (this || _global).lines.getLength() - 1;) if (this.$isAnnotationVisible(++e)) return this.$blurAnnotation((this || _global).activeRowIndex), (this || _global).activeRowIndex = e, void this.$focusAnnotation((this || _global).activeRowIndex);
        }, o.prototype.$switchLane = function (e) {
          switch (e) {
            case "annotation":
              "annotation" !== (this || _global).activeLane && null != (t = this.$findNearestAnnotation((this || _global).activeRowIndex)) && ((this || _global).activeLane = "annotation", this.$blurFoldWidget((this || _global).activeRowIndex), (this || _global).activeRowIndex = t, this.$focusAnnotation((this || _global).activeRowIndex));
              break;
            case "fold":
              var t;
              "fold" !== (this || _global).activeLane && null != (t = this.$findNearestFoldWidget((this || _global).activeRowIndex)) && ((this || _global).activeLane = "fold", this.$blurAnnotation((this || _global).activeRowIndex), (this || _global).activeRowIndex = t, this.$focusFoldWidget((this || _global).activeRowIndex));
          }
        }, o.prototype.$rowIndexToRow = function (e) {
          e = (this || _global).lines.get(e);
          return e ? e.row : null;
        }, o.prototype.$rowToRowIndex = function (e) {
          for (var t = 0; t < (this || _global).lines.getLength(); t++) if ((this || _global).lines.get(t).row == e) return t;
          return null;
        }, t.GutterKeyboardHandler = o;
      }), ace.define("ace/editor", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/lib/lang", "ace/lib/useragent", "ace/keyboard/textinput", "ace/mouse/mouse_handler", "ace/mouse/fold_handler", "ace/keyboard/keybinding", "ace/edit_session", "ace/search", "ace/range", "ace/lib/event_emitter", "ace/commands/command_manager", "ace/commands/default_commands", "ace/config", "ace/token_iterator", "ace/line_widgets", "ace/keyboard/gutter_handler", "ace/config", "ace/clipboard", "ace/lib/keys"], function (e, t, n) {
        "use strict";

        var d = (this || _global) && (this || _global).__values || function (e) {
            var t = "function" == typeof Symbol && Symbol.iterator,
              n = t && e[t],
              i = 0;
            if (n) return n.call(e);
            if (e && "number" == typeof e.length) return {
              next: function () {
                return {
                  value: (e = e && i >= e.length ? void 0 : e) && e[i++],
                  done: !e
                };
              }
            };
            throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = e("./lib/oop"),
          i = e("./lib/dom"),
          m = e("./lib/lang"),
          r = e("./lib/useragent"),
          s = e("./keyboard/textinput").TextInput,
          a = e("./mouse/mouse_handler").MouseHandler,
          l = e("./mouse/fold_handler").FoldHandler,
          c = e("./keyboard/keybinding").KeyBinding,
          h = e("./edit_session").EditSession,
          u = e("./search").Search,
          f = e("./range").Range,
          g = e("./lib/event_emitter").EventEmitter,
          p = e("./commands/command_manager").CommandManager,
          C = e("./commands/default_commands").commands,
          y = e("./config"),
          v = e("./token_iterator").TokenIterator,
          I = e("./line_widgets").LineWidgets,
          b = e("./keyboard/gutter_handler").GutterKeyboardHandler,
          A = e("./config").nls,
          w = e("./clipboard"),
          S = e("./lib/keys"),
          e = (x.prototype.$initOperationListeners = function () {
            (this || _global).commands.on("exec", (this || _global).startOperation.bind(this || _global), !0), (this || _global).commands.on("afterExec", (this || _global).endOperation.bind(this || _global), !0), (this || _global).$opResetTimer = m.delayedCall((this || _global).endOperation.bind(this || _global, !0)), this.on("change", function () {
              (this || _global).curOp || (this.startOperation(), (this || _global).curOp.selectionBefore = (this || _global).$lastSel), (this || _global).curOp.docChanged = !0;
            }.bind(this || _global), !0), this.on("changeSelection", function () {
              (this || _global).curOp || (this.startOperation(), (this || _global).curOp.selectionBefore = (this || _global).$lastSel), (this || _global).curOp.selectionChanged = !0;
            }.bind(this || _global), !0);
          }, x.prototype.startOperation = function (e) {
            if ((this || _global).curOp) {
              if (!e || (this || _global).curOp.command) return;
              (this || _global).prevOp = (this || _global).curOp;
            }
            e || ((this || _global).previousCommand = null, e = {}), (this || _global).$opResetTimer.schedule(), (this || _global).curOp = (this || _global).session.curOp = {
              command: e.command || {},
              args: e.args,
              scrollTop: (this || _global).renderer.scrollTop
            }, (this || _global).curOp.selectionBefore = (this || _global).selection.toJSON();
          }, x.prototype.endOperation = function (e) {
            if ((this || _global).curOp && (this || _global).session) {
              if (e && !1 === e.returnValue || !(this || _global).session) return (this || _global).curOp = null;
              if ((1 != e || !(this || _global).curOp.command || "mouse" != (this || _global).curOp.command.name) && (this._signal("beforeEndOperation"), (this || _global).curOp)) {
                var e = (this || _global).curOp.command,
                  t = e && e.scrollIntoView;
                if (t) {
                  switch (t) {
                    case "center-animate":
                      t = "animate";
                    case "center":
                      (this || _global).renderer.scrollCursorIntoView(null, 0.5);
                      break;
                    case "animate":
                    case "cursor":
                      (this || _global).renderer.scrollCursorIntoView();
                      break;
                    case "selectionPart":
                      var n = (this || _global).selection.getRange(),
                        i = (this || _global).renderer.layerConfig;
                      (n.start.row >= i.lastRow || n.end.row <= i.firstRow) && (this || _global).renderer.scrollSelectionIntoView((this || _global).selection.anchor, (this || _global).selection.lead);
                  }
                  "animate" == t && (this || _global).renderer.animateScrolling((this || _global).curOp.scrollTop);
                }
                e = (this || _global).selection.toJSON();
                (this || _global).curOp.selectionAfter = e, (this || _global).$lastSel = (this || _global).selection.toJSON(), (this || _global).session.getUndoManager().addSelection(e), (this || _global).prevOp = (this || _global).curOp, (this || _global).curOp = null;
              }
            }
          }, x.prototype.$historyTracker = function (e) {
            var t, n, i, o;
            (this || _global).$mergeUndoDeltas && (t = (this || _global).prevOp, n = (this || _global).$mergeableCommands, i = t.command && e.command.name == t.command.name, "insertstring" == e.command.name ? (o = e.args, void 0 === (this || _global).mergeNextCommand && ((this || _global).mergeNextCommand = !0), i = i && (this || _global).mergeNextCommand && (!/\s/.test(o) || /\s/.test(t.args)), (this || _global).mergeNextCommand = !0) : i = i && -1 !== n.indexOf(e.command.name), (i = "always" != (this || _global).$mergeUndoDeltas && 2000 < Date.now() - (this || _global).sequenceStartTime ? !1 : i) ? (this || _global).session.mergeUndoDeltas = !0 : -1 !== n.indexOf(e.command.name) && ((this || _global).sequenceStartTime = Date.now()));
          }, x.prototype.setKeyboardHandler = function (t, n) {
            var i;
            t && "string" == typeof t && "ace" != t ? ((this || _global).$keybindingId = t, i = this || _global, y.loadModule(["keybinding", t], function (e) {
              i.$keybindingId == t && i.keyBinding.setKeyboardHandler(e && e.handler), n && n();
            })) : ((this || _global).$keybindingId = null, (this || _global).keyBinding.setKeyboardHandler(t), n && n());
          }, x.prototype.getKeyboardHandler = function () {
            return (this || _global).keyBinding.getKeyboardHandler();
          }, x.prototype.setSession = function (e) {
            var t, n;
            (this || _global).session != e && ((this || _global).curOp && this.endOperation(), (this || _global).curOp = {}, (t = (this || _global).session) && ((this || _global).session.off("change", (this || _global).$onDocumentChange), (this || _global).session.off("changeMode", (this || _global).$onChangeMode), (this || _global).session.off("tokenizerUpdate", (this || _global).$onTokenizerUpdate), (this || _global).session.off("changeTabSize", (this || _global).$onChangeTabSize), (this || _global).session.off("changeWrapLimit", (this || _global).$onChangeWrapLimit), (this || _global).session.off("changeWrapMode", (this || _global).$onChangeWrapMode), (this || _global).session.off("changeFold", (this || _global).$onChangeFold), (this || _global).session.off("changeFrontMarker", (this || _global).$onChangeFrontMarker), (this || _global).session.off("changeBackMarker", (this || _global).$onChangeBackMarker), (this || _global).session.off("changeBreakpoint", (this || _global).$onChangeBreakpoint), (this || _global).session.off("changeAnnotation", (this || _global).$onChangeAnnotation), (this || _global).session.off("changeOverwrite", (this || _global).$onCursorChange), (this || _global).session.off("changeScrollTop", (this || _global).$onScrollTopChange), (this || _global).session.off("changeScrollLeft", (this || _global).$onScrollLeftChange), (n = (this || _global).session.getSelection()).off("changeCursor", (this || _global).$onCursorChange), n.off("changeSelection", (this || _global).$onSelectionChange)), ((this || _global).session = e) ? ((this || _global).$onDocumentChange = (this || _global).onDocumentChange.bind(this || _global), e.on("change", (this || _global).$onDocumentChange), (this || _global).renderer.setSession(e), (this || _global).$onChangeMode = (this || _global).onChangeMode.bind(this || _global), e.on("changeMode", (this || _global).$onChangeMode), (this || _global).$onTokenizerUpdate = (this || _global).onTokenizerUpdate.bind(this || _global), e.on("tokenizerUpdate", (this || _global).$onTokenizerUpdate), (this || _global).$onChangeTabSize = (this || _global).renderer.onChangeTabSize.bind((this || _global).renderer), e.on("changeTabSize", (this || _global).$onChangeTabSize), (this || _global).$onChangeWrapLimit = (this || _global).onChangeWrapLimit.bind(this || _global), e.on("changeWrapLimit", (this || _global).$onChangeWrapLimit), (this || _global).$onChangeWrapMode = (this || _global).onChangeWrapMode.bind(this || _global), e.on("changeWrapMode", (this || _global).$onChangeWrapMode), (this || _global).$onChangeFold = (this || _global).onChangeFold.bind(this || _global), e.on("changeFold", (this || _global).$onChangeFold), (this || _global).$onChangeFrontMarker = (this || _global).onChangeFrontMarker.bind(this || _global), (this || _global).session.on("changeFrontMarker", (this || _global).$onChangeFrontMarker), (this || _global).$onChangeBackMarker = (this || _global).onChangeBackMarker.bind(this || _global), (this || _global).session.on("changeBackMarker", (this || _global).$onChangeBackMarker), (this || _global).$onChangeBreakpoint = (this || _global).onChangeBreakpoint.bind(this || _global), (this || _global).session.on("changeBreakpoint", (this || _global).$onChangeBreakpoint), (this || _global).$onChangeAnnotation = (this || _global).onChangeAnnotation.bind(this || _global), (this || _global).session.on("changeAnnotation", (this || _global).$onChangeAnnotation), (this || _global).$onCursorChange = (this || _global).onCursorChange.bind(this || _global), (this || _global).session.on("changeOverwrite", (this || _global).$onCursorChange), (this || _global).$onScrollTopChange = (this || _global).onScrollTopChange.bind(this || _global), (this || _global).session.on("changeScrollTop", (this || _global).$onScrollTopChange), (this || _global).$onScrollLeftChange = (this || _global).onScrollLeftChange.bind(this || _global), (this || _global).session.on("changeScrollLeft", (this || _global).$onScrollLeftChange), (this || _global).selection = e.getSelection(), (this || _global).selection.on("changeCursor", (this || _global).$onCursorChange), (this || _global).$onSelectionChange = (this || _global).onSelectionChange.bind(this || _global), (this || _global).selection.on("changeSelection", (this || _global).$onSelectionChange), this.onChangeMode(), this.onCursorChange(), this.onScrollTopChange(), this.onScrollLeftChange(), this.onSelectionChange(), this.onChangeFrontMarker(), this.onChangeBackMarker(), this.onChangeBreakpoint(), this.onChangeAnnotation(), (this || _global).session.getUseWrapMode() && (this || _global).renderer.adjustWrapLimit(), (this || _global).renderer.updateFull()) : ((this || _global).selection = null, (this || _global).renderer.setSession(e)), this._signal("changeSession", {
              session: e,
              oldSession: t
            }), (this || _global).curOp = null, t && t._signal("changeEditor", {
              oldEditor: this || _global
            }), e && e._signal("changeEditor", {
              editor: this || _global
            }), e) && !e.destroyed && e.bgTokenizer.scheduleStart();
          }, x.prototype.getSession = function () {
            return (this || _global).session;
          }, x.prototype.setValue = function (e, t) {
            return (this || _global).session.doc.setValue(e), t ? 1 == t ? this.navigateFileEnd() : -1 == t && this.navigateFileStart() : this.selectAll(), e;
          }, x.prototype.getValue = function () {
            return (this || _global).session.getValue();
          }, x.prototype.getSelection = function () {
            return (this || _global).selection;
          }, x.prototype.resize = function (e) {
            (this || _global).renderer.onResize(e);
          }, x.prototype.setTheme = function (e, t) {
            (this || _global).renderer.setTheme(e, t);
          }, x.prototype.getTheme = function () {
            return (this || _global).renderer.getTheme();
          }, x.prototype.setStyle = function (e) {
            (this || _global).renderer.setStyle(e);
          }, x.prototype.unsetStyle = function (e) {
            (this || _global).renderer.unsetStyle(e);
          }, x.prototype.getFontSize = function () {
            return this.getOption("fontSize") || i.computedStyle((this || _global).container).fontSize;
          }, x.prototype.setFontSize = function (e) {
            this.setOption("fontSize", e);
          }, x.prototype.$highlightBrackets = function () {
            var r;
            (this || _global).$highlightPending || ((r = this || _global).$highlightPending = !0, setTimeout(function () {
              r.$highlightPending = !1;
              var e,
                t,
                n,
                i,
                o = r.session;
              o && !o.destroyed && (o.$bracketHighlight && (o.$bracketHighlight.markerIds.forEach(function (e) {
                o.removeMarker(e);
              }), o.$bracketHighlight = null), e = r.getCursorPosition(), t = (t = r.getKeyboardHandler()) && t.$getDirectionForHighlight && t.$getDirectionForHighlight(r), (t = o.getMatchingBracketRanges(e, t)) || (n = new v(o, e.row, e.column).getCurrentToken()) && /\b(?:tag-open|tag-name)/.test(n.type) && (n = o.getMatchingTags(e)) && (t = [n.openTagName, n.closeTagName]), (t = !t && o.$mode.getMatching ? o.$mode.getMatching(r.session) : t) && (i = "ace_bracket", Array.isArray(t) ? 1 == t.length && (i = "ace_error_bracket") : t = [t], 2 == t.length && (0 == f.comparePoints(t[0].end, t[1].start) ? t = [f.fromPoints(t[0].start, t[1].end)] : 0 == f.comparePoints(t[0].start, t[1].end) && (t = [f.fromPoints(t[1].start, t[0].end)])), o.$bracketHighlight = {
                ranges: t,
                markerIds: t.map(function (e) {
                  return o.addMarker(e, i, "text");
                })
              }), r.getHighlightIndentGuides()) && r.renderer.$textLayer.$highlightIndentGuide();
            }, 50));
          }, x.prototype.focus = function () {
            (this || _global).textInput.focus();
          }, x.prototype.isFocused = function () {
            return (this || _global).textInput.isFocused();
          }, x.prototype.blur = function () {
            (this || _global).textInput.blur();
          }, x.prototype.onFocus = function (e) {
            (this || _global).$isFocused || ((this || _global).$isFocused = !0, (this || _global).renderer.showCursor(), (this || _global).renderer.visualizeFocus(), this._emit("focus", e));
          }, x.prototype.onBlur = function (e) {
            (this || _global).$isFocused && ((this || _global).$isFocused = !1, (this || _global).renderer.hideCursor(), (this || _global).renderer.visualizeBlur(), this._emit("blur", e));
          }, x.prototype.$cursorChange = function () {
            (this || _global).renderer.updateCursor(), this.$highlightBrackets(), this.$updateHighlightActiveLine();
          }, x.prototype.onDocumentChange = function (e) {
            var t = (this || _global).session.$useWrapMode,
              n = e.start.row == e.end.row ? e.end.row : 1 / 0;
            (this || _global).renderer.updateLines(e.start.row, n, t), this._signal("change", e), this.$cursorChange();
          }, x.prototype.onTokenizerUpdate = function (e) {
            e = e.data;
            (this || _global).renderer.updateLines(e.first, e.last);
          }, x.prototype.onScrollTopChange = function () {
            (this || _global).renderer.scrollToY((this || _global).session.getScrollTop());
          }, x.prototype.onScrollLeftChange = function () {
            (this || _global).renderer.scrollToX((this || _global).session.getScrollLeft());
          }, x.prototype.onCursorChange = function () {
            this.$cursorChange(), this._signal("changeSelection");
          }, x.prototype.$updateHighlightActiveLine = function () {
            var e,
              t,
              n = this.getSession();
            (this || _global).$highlightActiveLine && ("line" == (this || _global).$selectionStyle && (this || _global).selection.isMultiLine() || (e = this.getCursorPosition()), (this || _global).renderer.theme && (this || _global).renderer.theme.$selectionColorConflict && !(this || _global).selection.isEmpty() && (e = !1), !(this || _global).renderer.$maxLines || 1 !== (this || _global).session.getLength() || 1 < (this || _global).renderer.$minLines || (e = !1)), n.$highlightLineMarker && !e ? (n.removeMarker(n.$highlightLineMarker.id), n.$highlightLineMarker = null) : !n.$highlightLineMarker && e ? ((t = new f(e.row, e.column, e.row, 1 / 0)).id = n.addMarker(t, "ace_active-line", "screenLine"), n.$highlightLineMarker = t) : e && (n.$highlightLineMarker.start.row = e.row, n.$highlightLineMarker.end.row = e.row, n.$highlightLineMarker.start.column = e.column, n._signal("changeBackMarker"));
          }, x.prototype.onSelectionChange = function (e) {
            var t,
              n,
              i = (this || _global).session,
              i = (i.$selectionMarker && i.removeMarker(i.$selectionMarker), i.$selectionMarker = null, (this || _global).selection.isEmpty() ? this.$updateHighlightActiveLine() : (t = (this || _global).selection.getRange(), n = this.getSelectionStyle(), i.$selectionMarker = i.addMarker(t, "ace_selection", n)), (this || _global).$highlightSelectedWord && this.$getSelectionHighLightRegexp());
            (this || _global).session.highlight(i), this._signal("changeSelection");
          }, x.prototype.$getSelectionHighLightRegexp = function () {
            var e = (this || _global).session,
              t = this.getSelectionRange();
            if (!t.isEmpty() && !t.isMultiLine()) {
              var n = t.start.column,
                i = t.end.column,
                e = e.getLine(t.start.row),
                t = e.substring(n, i);
              if (!(5000 < t.length) && /[\w\d]/.test(t)) {
                t = (this || _global).$search.$assembleRegExp({
                  wholeWord: !0,
                  caseSensitive: !0,
                  needle: t
                }), e = e.substring(n - 1, i + 1);
                if (t.test(e)) return t;
              }
            }
          }, x.prototype.onChangeFrontMarker = function () {
            (this || _global).renderer.updateFrontMarkers();
          }, x.prototype.onChangeBackMarker = function () {
            (this || _global).renderer.updateBackMarkers();
          }, x.prototype.onChangeBreakpoint = function () {
            (this || _global).renderer.updateBreakpoints();
          }, x.prototype.onChangeAnnotation = function () {
            (this || _global).renderer.setAnnotations((this || _global).session.getAnnotations());
          }, x.prototype.onChangeMode = function (e) {
            (this || _global).renderer.updateText(), this._emit("changeMode", e);
          }, x.prototype.onChangeWrapLimit = function () {
            (this || _global).renderer.updateFull();
          }, x.prototype.onChangeWrapMode = function () {
            (this || _global).renderer.onResize(!0);
          }, x.prototype.onChangeFold = function () {
            this.$updateHighlightActiveLine(), (this || _global).renderer.updateFull();
          }, x.prototype.getSelectedText = function () {
            return (this || _global).session.getTextRange(this.getSelectionRange());
          }, x.prototype.getCopyText = function () {
            var e = this.getSelectedText(),
              t = (this || _global).session.doc.getNewLineCharacter(),
              n = !1;
            if (!e && (this || _global).$copyWithEmptySelection) for (var n = !0, i = (this || _global).selection.getAllRanges(), o = 0; o < i.length; o++) {
              var r = i[o];
              o && i[o - 1].start.row == r.start.row || (e += (this || _global).session.getLine(r.start.row) + t);
            }
            var s = {
              text: e
            };
            return this._signal("copy", s), w.lineMode = !!n && s.text, s.text;
          }, x.prototype.onCopy = function () {
            (this || _global).commands.exec("copy", this || _global);
          }, x.prototype.onCut = function () {
            (this || _global).commands.exec("cut", this || _global);
          }, x.prototype.onPaste = function (e, t) {
            (this || _global).commands.exec("paste", this || _global, {
              text: e,
              event: t
            });
          }, x.prototype.$handlePaste = function (e) {
            this._signal("paste", e = "string" == typeof e ? {
              text: e
            } : e);
            var t = e.text,
              e = t === w.lineMode,
              n = (this || _global).session;
            if (!(this || _global).inMultiSelectMode || (this || _global).inVirtualSelectionMode) e ? n.insert({
              row: (this || _global).selection.lead.row,
              column: 0
            }, t) : this.insert(t);else if (e) (this || _global).selection.rangeList.ranges.forEach(function (e) {
              n.insert({
                row: e.start.row,
                column: 0
              }, t);
            });else {
              var i = t.split(/\r\n|\r|\n/),
                o = (this || _global).selection.rangeList.ranges,
                e = !(2 != i.length || i[0] && i[1]);
              if (i.length != o.length || e) return (this || _global).commands.exec("insertstring", this || _global, t);
              for (var r = o.length; r--;) {
                var s = o[r];
                s.isEmpty() || n.remove(s), n.insert(s.start, i[r]);
              }
            }
          }, x.prototype.execCommand = function (e, t) {
            return (this || _global).commands.exec(e, this || _global, t);
          }, x.prototype.insert = function (e, t) {
            var n,
              i = (this || _global).session,
              o = i.getMode(),
              r = this.getCursorPosition(),
              s = (this.getBehavioursEnabled() && !t && (n = o.transformAction(i.getState(r.row), "insertion", this || _global, i, e)) && (e === n.text || (this || _global).inVirtualSelectionMode || ((this || _global).session.mergeUndoDeltas = !1, (this || _global).mergeNextCommand = !1), e = n.text), "\t" == e && (e = (this || _global).session.getTabString()), (this || _global).selection.isEmpty() ? (this || _global).session.getOverwrite() && -1 == e.indexOf("\n") && ((s = new f.fromPoints(r, r)).end.column += e.length, (this || _global).session.remove(s)) : (s = this.getSelectionRange(), r = (this || _global).session.remove(s), this.clearSelection()), "\n" != e && "\r\n" != e || (a = i.getLine(r.row), r.column > a.search(/\S|$/) && (t = a.substr(r.column).search(/\S|$/), i.doc.removeInLine(r.row, r.column, r.column + t))), this.clearSelection(), r.column),
              t = i.getState(r.row),
              a = i.getLine(r.row),
              l = o.checkOutdent(t, a, e);
            i.insert(r, e), n && n.selection && (2 == n.selection.length ? (this || _global).selection.setSelectionRange(new f(r.row, s + n.selection[0], r.row, s + n.selection[1])) : (this || _global).selection.setSelectionRange(new f(r.row + n.selection[0], n.selection[1], r.row + n.selection[2], n.selection[3]))), (this || _global).$enableAutoIndent && (i.getDocument().isNewLine(e) && (s = o.getNextLineIndent(t, a.slice(0, r.column), i.getTabString()), i.insert({
              row: r.row + 1,
              column: 0
            }, s)), l) && o.autoOutdent(t, i, r.row);
          }, x.prototype.autoIndent = function () {
            for (var e, t, n, i, o, r = (this || _global).session, s = r.getMode(), a = (n = (this || _global).selection.isEmpty() ? (t = 0, r.doc.getLength() - 1) : (t = (e = this.getSelectionRange()).start.row, e.end.row), ""), l = "", c = r.getTabString(), h = t; h <= n; h++) 0 < h && (a = r.getState(h - 1), i = r.getLine(h - 1), l = s.getNextLineIndent(a, i, c)), i = r.getLine(h), l !== (o = s.$getIndent(i)) && (0 < o.length && (o = new f(h, 0, h, o.length), r.remove(o)), 0 < l.length) && r.insert({
              row: h,
              column: 0
            }, l), s.autoOutdent(a, r, h);
          }, x.prototype.onTextInput = function (e, t) {
            if (!t) return (this || _global).keyBinding.onTextInput(e);
            this.startOperation({
              command: {
                name: "insertstring"
              }
            });
            e = (this || _global).applyComposition.bind(this || _global, e, t);
            (this || _global).selection.rangeCount ? this.forEachSelection(e) : e(), this.endOperation();
          }, x.prototype.applyComposition = function (e, t) {
            var n;
            (t.extendLeft || t.extendRight) && ((n = (this || _global).selection.getRange()).start.column -= t.extendLeft, n.end.column += t.extendRight, n.start.column < 0 && (n.start.row--, n.start.column += (this || _global).session.getLine(n.start.row).length + 1), (this || _global).selection.setRange(n), e || n.isEmpty() || this.remove()), !e && (this || _global).selection.isEmpty() || this.insert(e, !0), (t.restoreStart || t.restoreEnd) && ((n = (this || _global).selection.getRange()).start.column -= t.restoreStart, n.end.column -= t.restoreEnd, (this || _global).selection.setRange(n));
          }, x.prototype.onCommandKey = function (e, t, n) {
            return (this || _global).keyBinding.onCommandKey(e, t, n);
          }, x.prototype.setOverwrite = function (e) {
            (this || _global).session.setOverwrite(e);
          }, x.prototype.getOverwrite = function () {
            return (this || _global).session.getOverwrite();
          }, x.prototype.toggleOverwrite = function () {
            (this || _global).session.toggleOverwrite();
          }, x.prototype.setScrollSpeed = function (e) {
            this.setOption("scrollSpeed", e);
          }, x.prototype.getScrollSpeed = function () {
            return this.getOption("scrollSpeed");
          }, x.prototype.setDragDelay = function (e) {
            this.setOption("dragDelay", e);
          }, x.prototype.getDragDelay = function () {
            return this.getOption("dragDelay");
          }, x.prototype.setSelectionStyle = function (e) {
            this.setOption("selectionStyle", e);
          }, x.prototype.getSelectionStyle = function () {
            return this.getOption("selectionStyle");
          }, x.prototype.setHighlightActiveLine = function (e) {
            this.setOption("highlightActiveLine", e);
          }, x.prototype.getHighlightActiveLine = function () {
            return this.getOption("highlightActiveLine");
          }, x.prototype.setHighlightGutterLine = function (e) {
            this.setOption("highlightGutterLine", e);
          }, x.prototype.getHighlightGutterLine = function () {
            return this.getOption("highlightGutterLine");
          }, x.prototype.setHighlightSelectedWord = function (e) {
            this.setOption("highlightSelectedWord", e);
          }, x.prototype.getHighlightSelectedWord = function () {
            return (this || _global).$highlightSelectedWord;
          }, x.prototype.setAnimatedScroll = function (e) {
            (this || _global).renderer.setAnimatedScroll(e);
          }, x.prototype.getAnimatedScroll = function () {
            return (this || _global).renderer.getAnimatedScroll();
          }, x.prototype.setShowInvisibles = function (e) {
            (this || _global).renderer.setShowInvisibles(e);
          }, x.prototype.getShowInvisibles = function () {
            return (this || _global).renderer.getShowInvisibles();
          }, x.prototype.setDisplayIndentGuides = function (e) {
            (this || _global).renderer.setDisplayIndentGuides(e);
          }, x.prototype.getDisplayIndentGuides = function () {
            return (this || _global).renderer.getDisplayIndentGuides();
          }, x.prototype.setHighlightIndentGuides = function (e) {
            (this || _global).renderer.setHighlightIndentGuides(e);
          }, x.prototype.getHighlightIndentGuides = function () {
            return (this || _global).renderer.getHighlightIndentGuides();
          }, x.prototype.setShowPrintMargin = function (e) {
            (this || _global).renderer.setShowPrintMargin(e);
          }, x.prototype.getShowPrintMargin = function () {
            return (this || _global).renderer.getShowPrintMargin();
          }, x.prototype.setPrintMarginColumn = function (e) {
            (this || _global).renderer.setPrintMarginColumn(e);
          }, x.prototype.getPrintMarginColumn = function () {
            return (this || _global).renderer.getPrintMarginColumn();
          }, x.prototype.setReadOnly = function (e) {
            this.setOption("readOnly", e);
          }, x.prototype.getReadOnly = function () {
            return this.getOption("readOnly");
          }, x.prototype.setBehavioursEnabled = function (e) {
            this.setOption("behavioursEnabled", e);
          }, x.prototype.getBehavioursEnabled = function () {
            return this.getOption("behavioursEnabled");
          }, x.prototype.setWrapBehavioursEnabled = function (e) {
            this.setOption("wrapBehavioursEnabled", e);
          }, x.prototype.getWrapBehavioursEnabled = function () {
            return this.getOption("wrapBehavioursEnabled");
          }, x.prototype.setShowFoldWidgets = function (e) {
            this.setOption("showFoldWidgets", e);
          }, x.prototype.getShowFoldWidgets = function () {
            return this.getOption("showFoldWidgets");
          }, x.prototype.setFadeFoldWidgets = function (e) {
            this.setOption("fadeFoldWidgets", e);
          }, x.prototype.getFadeFoldWidgets = function () {
            return this.getOption("fadeFoldWidgets");
          }, x.prototype.remove = function (e) {
            (this || _global).selection.isEmpty() && ("left" == e ? (this || _global).selection.selectLeft() : (this || _global).selection.selectRight());
            var t,
              n,
              i,
              e = this.getSelectionRange();
            this.getBehavioursEnabled() && (n = (t = (this || _global).session).getState(e.start.row), n = t.getMode().transformAction(n, "deletion", this || _global, t, e), 0 === e.end.column && "\n" == (i = t.getTextRange(e))[i.length - 1] && (i = t.getLine(e.end.row), /^\s+$/.test(i)) && (e.end.column = i.length), n) && (e = n), (this || _global).session.remove(e), this.clearSelection();
          }, x.prototype.removeWordRight = function () {
            (this || _global).selection.isEmpty() && (this || _global).selection.selectWordRight(), (this || _global).session.remove(this.getSelectionRange()), this.clearSelection();
          }, x.prototype.removeWordLeft = function () {
            (this || _global).selection.isEmpty() && (this || _global).selection.selectWordLeft(), (this || _global).session.remove(this.getSelectionRange()), this.clearSelection();
          }, x.prototype.removeToLineStart = function () {
            (this || _global).selection.isEmpty() && (this || _global).selection.selectLineStart(), (this || _global).selection.isEmpty() && (this || _global).selection.selectLeft(), (this || _global).session.remove(this.getSelectionRange()), this.clearSelection();
          }, x.prototype.removeToLineEnd = function () {
            (this || _global).selection.isEmpty() && (this || _global).selection.selectLineEnd();
            var e = this.getSelectionRange();
            e.start.column == e.end.column && e.start.row == e.end.row && (e.end.column = 0, e.end.row++), (this || _global).session.remove(e), this.clearSelection();
          }, x.prototype.splitLine = function () {
            (this || _global).selection.isEmpty() || ((this || _global).session.remove(this.getSelectionRange()), this.clearSelection());
            var e = this.getCursorPosition();
            this.insert("\n"), this.moveCursorToPosition(e);
          }, x.prototype.setGhostText = function (e, t) {
            (this || _global).session.widgetManager || ((this || _global).session.widgetManager = new I((this || _global).session), (this || _global).session.widgetManager.attach(this || _global)), (this || _global).renderer.setGhostText(e, t);
          }, x.prototype.removeGhostText = function () {
            (this || _global).session.widgetManager && (this || _global).renderer.removeGhostText();
          }, x.prototype.transposeLetters = function () {
            var e, t, n, i;
            (this || _global).selection.isEmpty() && 0 !== (t = (e = this.getCursorPosition()).column) && (i = t < (i = (this || _global).session.getLine(e.row)).length ? (n = i.charAt(t) + i.charAt(t - 1), new f(e.row, t - 1, e.row, t + 1)) : (n = i.charAt(t - 1) + i.charAt(t - 2), new f(e.row, t - 2, e.row, t)), (this || _global).session.replace(i, n), (this || _global).session.selection.moveToPosition(i.end));
          }, x.prototype.toLowerCase = function () {
            var e = this.getSelectionRange(),
              t = ((this || _global).selection.isEmpty() && (this || _global).selection.selectWord(), this.getSelectionRange()),
              n = (this || _global).session.getTextRange(t);
            (this || _global).session.replace(t, n.toLowerCase()), (this || _global).selection.setSelectionRange(e);
          }, x.prototype.toUpperCase = function () {
            var e = this.getSelectionRange(),
              t = ((this || _global).selection.isEmpty() && (this || _global).selection.selectWord(), this.getSelectionRange()),
              n = (this || _global).session.getTextRange(t);
            (this || _global).session.replace(t, n.toUpperCase()), (this || _global).selection.setSelectionRange(e);
          }, x.prototype.indent = function () {
            var e = (this || _global).session,
              t = this.getSelectionRange();
            if (!(t.start.row < t.end.row)) {
              if (t.start.column < t.end.column) {
                var n,
                  i = e.getTextRange(t);
                if (!/^\s+$/.test(i)) return n = this.$getSelectedRows(), void e.indentRows(n.first, n.last, "\t");
              }
              var o = e.getLine(t.start.row),
                i = t.start,
                r = e.getTabSize(),
                i = e.documentToScreenColumn(i.row, i.column);
              if ((this || _global).session.getUseSoftTabs()) var s = r - i % r,
                a = m.stringRepeat(" ", s);else {
                for (s = i % r; " " == o[t.start.column - 1] && s;) t.start.column--, s--;
                (this || _global).selection.setSelectionRange(t), a = "\t";
              }
              return this.insert(a);
            }
            n = this.$getSelectedRows(), e.indentRows(n.first, n.last, "\t");
          }, x.prototype.blockIndent = function () {
            var e = this.$getSelectedRows();
            (this || _global).session.indentRows(e.first, e.last, "\t");
          }, x.prototype.blockOutdent = function () {
            var e = (this || _global).session.getSelection();
            (this || _global).session.outdentRows(e.getRange());
          }, x.prototype.sortLines = function () {
            for (var e = this.$getSelectedRows(), t = (this || _global).session, n = [], i = e.first; i <= e.last; i++) n.push(t.getLine(i));
            n.sort(function (e, t) {
              return e.toLowerCase() < t.toLowerCase() ? -1 : e.toLowerCase() > t.toLowerCase() ? 1 : 0;
            });
            for (var o = new f(0, 0, 0, 0), i = e.first; i <= e.last; i++) {
              var r = t.getLine(i);
              o.start.row = i, o.end.row = i, o.end.column = r.length, t.replace(o, n[i - e.first]);
            }
          }, x.prototype.toggleCommentLines = function () {
            var e = (this || _global).session.getState(this.getCursorPosition().row),
              t = this.$getSelectedRows();
            (this || _global).session.getMode().toggleCommentLines(e, (this || _global).session, t.first, t.last);
          }, x.prototype.toggleBlockComment = function () {
            var e = this.getCursorPosition(),
              t = (this || _global).session.getState(e.row),
              n = this.getSelectionRange();
            (this || _global).session.getMode().toggleBlockComment(t, (this || _global).session, n, e);
          }, x.prototype.getNumberAt = function (e, t) {
            for (var n = /[\-]?[0-9]+(?:\.[0-9]+)?/g, i = (n.lastIndex = 0, (this || _global).session.getLine(e)); n.lastIndex < t;) {
              var o = n.exec(i);
              if (o.index <= t && o.index + o[0].length >= t) return {
                value: o[0],
                start: o.index,
                end: o.index + o[0].length
              };
            }
            return null;
          }, x.prototype.modifyNumber = function (e) {
            var t,
              n,
              i,
              o = (this || _global).selection.getCursor().row,
              r = (this || _global).selection.getCursor().column,
              s = new f(o, r - 1, o, r),
              s = (this || _global).session.getTextRange(s);
            !isNaN(parseFloat(s)) && isFinite(s) ? (s = this.getNumberAt(o, r)) && (i = 0 <= s.value.indexOf(".") ? s.start + s.value.indexOf(".") + 1 : s.end, t = s.start + s.value.length - i, n = parseFloat(s.value), n *= Math.pow(10, t), i !== s.end && r < i ? e *= Math.pow(10, s.end - r - 1) : e *= Math.pow(10, s.end - r), i = (n = (n += e) / Math.pow(10, t)).toFixed(t), e = new f(o, s.start, o, s.end), (this || _global).session.replace(e, i), this.moveCursorTo(o, Math.max(s.start + 1, r + i.length - s.value.length))) : this.toggleWord();
          }, x.prototype.toggleWord = function () {
            for (var n, i = (this || _global).selection.getCursor().row, e = (this || _global).selection.getCursor().column, o = ((this || _global).selection.selectWord(), this.getSelectedText()), r = (this || _global).selection.getWordRange().start.column, t = o.replace(/([a-z]+|[A-Z]+)(?=[A-Z_]|$)/g, "$1 ").split(/\s/), s = e - r - 1, a = (s < 0 && (s = 0), 0), l = this || _global, c = (o.match(/[A-Za-z0-9_]+/) && t.forEach(function (e, t) {
                n = a + e.length, a <= s && s <= n && (o = e, l.selection.clearSelection(), l.moveCursorTo(i, a + r), l.selection.selectTo(i, n + r)), a = n;
              }), (this || _global).$toggleWordPairs), h = 0; h < c.length; h++) for (var d = c[h], u = 0; u <= 1; u++) {
              var g = +!u,
                p = o.match(new RegExp("^\\s?_?(" + m.escapeRegExp(d[u]) + ")\\s?$", "i"));
              p && o.match(new RegExp("([_]|^|\\s)(" + m.escapeRegExp(p[1]) + ")($|\\s)", "g")) && (p = o.replace(new RegExp(m.escapeRegExp(d[u]), "i"), function (e) {
                var t = d[g];
                return e.toUpperCase() == e ? t = t.toUpperCase() : e.charAt(0).toUpperCase() == e.charAt(0) && (t = t.substr(0, 0) + d[g].charAt(0).toUpperCase() + t.substr(1)), t;
              }), this.insert(p));
            }
          }, x.prototype.findLinkAt = function (e, t) {
            var n,
              i,
              o,
              e = (this || _global).session.getLine(e).split(/((?:https?|ftp):\/\/[\S]+)/),
              r = t,
              s = (r < 0 && (r = 0), 0);
            try {
              for (var a = d(e), l = a.next(); !l.done; l = a.next()) {
                var c = l.value,
                  h = s + c.length;
                if (s <= r && r <= h && c.match(/((?:https?|ftp):\/\/[\S]+)/)) {
                  o = c.replace(/[\s:.,'";}\]]+$/, "");
                  break;
                }
                s = h;
              }
            } catch (e) {
              n = {
                error: e
              };
            } finally {
              try {
                l && !l.done && (i = a.return) && i.call(a);
              } finally {
                if (n) throw n.error;
              }
            }
            return o;
          }, x.prototype.openLink = function () {
            var e = (this || _global).selection.getCursor(),
              e = this.findLinkAt(e.row, e.column);
            return e && window.open(e, "_blank"), null != e;
          }, x.prototype.removeLines = function () {
            var e = this.$getSelectedRows();
            (this || _global).session.removeFullLines(e.first, e.last), this.clearSelection();
          }, x.prototype.duplicateSelection = function () {
            var e,
              t = (this || _global).selection,
              n = (this || _global).session,
              i = t.getRange(),
              o = t.isBackwards();
            i.isEmpty() ? (e = i.start.row, n.duplicateLines(e, e)) : (e = o ? i.start : i.end, n = n.insert(e, n.getTextRange(i), !1), i.start = e, i.end = n, t.setSelectionRange(i, o));
          }, x.prototype.moveLinesDown = function () {
            this.$moveLines(1, !1);
          }, x.prototype.moveLinesUp = function () {
            this.$moveLines(-1, !1);
          }, x.prototype.moveText = function (e, t, n) {
            return (this || _global).session.moveText(e, t, n);
          }, x.prototype.copyLinesUp = function () {
            this.$moveLines(-1, !0);
          }, x.prototype.copyLinesDown = function () {
            this.$moveLines(1, !0);
          }, x.prototype.$moveLines = function (e, t) {
            var n = (this || _global).selection;
            if (!n.inMultiSelectMode || (this || _global).inVirtualSelectionMode) {
              var i = n.toOrientedRange(),
                o = this.$getSelectedRows(i),
                r = (this || _global).session.$moveLines(o.first, o.last, t ? 0 : e);
              i.moveBy(r = t && -1 == e ? 0 : r, 0), n.fromOrientedRange(i);
            } else {
              for (var s = n.rangeList.ranges, a = (n.rangeList.detach((this || _global).session), (this || _global).inVirtualSelectionMode = !0, 0), l = 0, c = s.length, h = 0; h < c; h++) {
                for (var d = h, u = (s[h].moveBy(a, 0), (o = this.$getSelectedRows(s[h])).first), g = o.last; ++h < c;) {
                  l && s[h].moveBy(l, 0);
                  var p = this.$getSelectedRows(s[h]);
                  if (t && p.first != g) break;
                  if (!t && p.first > g + 1) break;
                  g = p.last;
                }
                for (h--, a = (this || _global).session.$moveLines(u, g, t ? 0 : e), t && -1 == e && (d = h + 1); d <= h;) s[d].moveBy(a, 0), d++;
                l += a = t ? a : 0;
              }
              n.fromOrientedRange(n.ranges[0]), n.rangeList.attach((this || _global).session), (this || _global).inVirtualSelectionMode = !1;
            }
          }, x.prototype.$getSelectedRows = function (e) {
            return e = (e || this.getSelectionRange()).collapseRows(), {
              first: (this || _global).session.getRowFoldStart(e.start.row),
              last: (this || _global).session.getRowFoldEnd(e.end.row)
            };
          }, x.prototype.onCompositionStart = function (e) {
            (this || _global).renderer.showComposition(e);
          }, x.prototype.onCompositionUpdate = function (e) {
            (this || _global).renderer.setCompositionText(e);
          }, x.prototype.onCompositionEnd = function () {
            (this || _global).renderer.hideComposition();
          }, x.prototype.getFirstVisibleRow = function () {
            return (this || _global).renderer.getFirstVisibleRow();
          }, x.prototype.getLastVisibleRow = function () {
            return (this || _global).renderer.getLastVisibleRow();
          }, x.prototype.isRowVisible = function (e) {
            return e >= this.getFirstVisibleRow() && e <= this.getLastVisibleRow();
          }, x.prototype.isRowFullyVisible = function (e) {
            return e >= (this || _global).renderer.getFirstFullyVisibleRow() && e <= (this || _global).renderer.getLastFullyVisibleRow();
          }, x.prototype.$getVisibleRowCount = function () {
            return (this || _global).renderer.getScrollBottomRow() - (this || _global).renderer.getScrollTopRow() + 1;
          }, x.prototype.$moveByPage = function (e, t) {
            var n = (this || _global).renderer,
              i = (this || _global).renderer.layerConfig,
              o = e * Math.floor(i.height / i.lineHeight),
              e = (!0 === t ? (this || _global).selection.$moveSelection(function () {
                this.moveCursorBy(o, 0);
              }) : !1 === t && ((this || _global).selection.moveCursorBy(o, 0), (this || _global).selection.clearSelection()), n.scrollTop);
            n.scrollBy(0, o * i.lineHeight), null != t && n.scrollCursorIntoView(null, 0.5), n.animateScrolling(e);
          }, x.prototype.selectPageDown = function () {
            this.$moveByPage(1, !0);
          }, x.prototype.selectPageUp = function () {
            this.$moveByPage(-1, !0);
          }, x.prototype.gotoPageDown = function () {
            this.$moveByPage(1, !1);
          }, x.prototype.gotoPageUp = function () {
            this.$moveByPage(-1, !1);
          }, x.prototype.scrollPageDown = function () {
            this.$moveByPage(1);
          }, x.prototype.scrollPageUp = function () {
            this.$moveByPage(-1);
          }, x.prototype.scrollToRow = function (e) {
            (this || _global).renderer.scrollToRow(e);
          }, x.prototype.scrollToLine = function (e, t, n, i) {
            (this || _global).renderer.scrollToLine(e, t, n, i);
          }, x.prototype.centerSelection = function () {
            var e = this.getSelectionRange(),
              e = {
                row: Math.floor(e.start.row + (e.end.row - e.start.row) / 2),
                column: Math.floor(e.start.column + (e.end.column - e.start.column) / 2)
              };
            (this || _global).renderer.alignCursor(e, 0.5);
          }, x.prototype.getCursorPosition = function () {
            return (this || _global).selection.getCursor();
          }, x.prototype.getCursorPositionScreen = function () {
            return (this || _global).session.documentToScreenPosition(this.getCursorPosition());
          }, x.prototype.getSelectionRange = function () {
            return (this || _global).selection.getRange();
          }, x.prototype.selectAll = function () {
            (this || _global).selection.selectAll();
          }, x.prototype.clearSelection = function () {
            (this || _global).selection.clearSelection();
          }, x.prototype.moveCursorTo = function (e, t) {
            (this || _global).selection.moveCursorTo(e, t);
          }, x.prototype.moveCursorToPosition = function (e) {
            (this || _global).selection.moveCursorToPosition(e);
          }, x.prototype.jumpToMatching = function (e, t) {
            var n = this.getCursorPosition(),
              i = new v((this || _global).session, n.row, n.column),
              o = i.getCurrentToken(),
              r = 0,
              s = (o = o && -1 !== o.type.indexOf("tag-name") ? i.stepBackward() : o) || i.stepForward();
            if (s) {
              var a,
                l,
                c = !1,
                h = {},
                d = n.column - s.start,
                u = {
                  ")": "(",
                  "(": "(",
                  "]": "[",
                  "[": "[",
                  "{": "{",
                  "}": "{"
                };
              do {
                if (s.value.match(/[{}()\[\]]/g)) {
                  for (; d < s.value.length && !c; d++) if (u[s.value[d]]) switch (l = u[s.value[d]] + "." + s.type.replace("rparen", "lparen"), isNaN(h[l]) && (h[l] = 0), s.value[d]) {
                    case "(":
                    case "[":
                    case "{":
                      h[l]++;
                      break;
                    case ")":
                    case "]":
                    case "}":
                      h[l]--, -1 === h[l] && (a = "bracket", c = !0);
                  }
                } else -1 !== s.type.indexOf("tag-name") && (isNaN(h[s.value]) && (h[s.value] = 0), "<" === o.value && 1 < r ? h[s.value]++ : "</" === o.value && h[s.value]--, -1 === h[s.value]) && (a = "tag", c = !0);
              } while ((c || (o = s, r++, s = i.stepForward(), d = 0), s && !c));
              if (a) {
                if ("bracket" === a) !(p = (this || _global).session.getBracketRange(n)) && (m = (p = new f(i.getCurrentTokenRow(), i.getCurrentTokenColumn() + d - 1, i.getCurrentTokenRow(), i.getCurrentTokenColumn() + d - 1)).start, t || m.row === n.row && Math.abs(m.column - n.column) < 2) && (p = (this || _global).session.getBracketRange(m));else if ("tag" === a) {
                  if (!s || -1 === s.type.indexOf("tag-name")) return;
                  var g,
                    p,
                    m = (m = 0 === (p = new f(i.getCurrentTokenRow(), i.getCurrentTokenColumn() - 2, i.getCurrentTokenRow(), i.getCurrentTokenColumn() - 2)).compare(n.row, n.column) && (g = (this || _global).session.getMatchingTags(n)) ? g.openTag.contains(n.row, n.column) ? (p = g.closeTag).start : (p = g.openTag, g.closeTag.start.row === n.row && g.closeTag.start.column === n.column ? p.end : p.start) : m) || p.start;
                }
                (m = p && p.cursor || m) && (e ? p && t ? (this || _global).selection.setRange(p) : p && p.isEqual(this.getSelectionRange()) ? this.clearSelection() : (this || _global).selection.selectTo(m.row, m.column) : (this || _global).selection.moveTo(m.row, m.column));
              }
            }
          }, x.prototype.gotoLine = function (e, t, n) {
            (this || _global).selection.clearSelection(), (this || _global).session.unfold({
              row: e - 1,
              column: t || 0
            }), (this || _global).exitMultiSelectMode && this.exitMultiSelectMode(), this.moveCursorTo(e - 1, t || 0), this.isRowFullyVisible(e - 1) || this.scrollToLine(e - 1, !0, n);
          }, x.prototype.navigateTo = function (e, t) {
            (this || _global).selection.moveTo(e, t);
          }, x.prototype.navigateUp = function (e) {
            var t;
            if ((this || _global).selection.isMultiLine() && !(this || _global).selection.isBackwards()) return t = (this || _global).selection.anchor.getPosition(), this.moveCursorToPosition(t);
            (this || _global).selection.clearSelection(), (this || _global).selection.moveCursorBy(-e || -1, 0);
          }, x.prototype.navigateDown = function (e) {
            var t;
            if ((this || _global).selection.isMultiLine() && (this || _global).selection.isBackwards()) return t = (this || _global).selection.anchor.getPosition(), this.moveCursorToPosition(t);
            (this || _global).selection.clearSelection(), (this || _global).selection.moveCursorBy(e || 1, 0);
          }, x.prototype.navigateLeft = function (e) {
            if ((this || _global).selection.isEmpty()) for (e = e || 1; e--;) (this || _global).selection.moveCursorLeft();else {
              var t = this.getSelectionRange().start;
              this.moveCursorToPosition(t);
            }
            this.clearSelection();
          }, x.prototype.navigateRight = function (e) {
            if ((this || _global).selection.isEmpty()) for (e = e || 1; e--;) (this || _global).selection.moveCursorRight();else {
              var t = this.getSelectionRange().end;
              this.moveCursorToPosition(t);
            }
            this.clearSelection();
          }, x.prototype.navigateLineStart = function () {
            (this || _global).selection.moveCursorLineStart(), this.clearSelection();
          }, x.prototype.navigateLineEnd = function () {
            (this || _global).selection.moveCursorLineEnd(), this.clearSelection();
          }, x.prototype.navigateFileEnd = function () {
            (this || _global).selection.moveCursorFileEnd(), this.clearSelection();
          }, x.prototype.navigateFileStart = function () {
            (this || _global).selection.moveCursorFileStart(), this.clearSelection();
          }, x.prototype.navigateWordRight = function () {
            (this || _global).selection.moveCursorWordRight(), this.clearSelection();
          }, x.prototype.navigateWordLeft = function () {
            (this || _global).selection.moveCursorWordLeft(), this.clearSelection();
          }, x.prototype.replace = function (e, t) {
            t && (this || _global).$search.set(t);
            var t = (this || _global).$search.find((this || _global).session),
              n = 0;
            return t && (this.$tryReplace(t, e) && (n = 1), (this || _global).selection.setSelectionRange(t), (this || _global).renderer.scrollSelectionIntoView(t.start, t.end)), n;
          }, x.prototype.replaceAll = function (e, t) {
            t && (this || _global).$search.set(t);
            var n = (this || _global).$search.findAll((this || _global).session),
              i = 0;
            if (n.length) {
              t = this.getSelectionRange();
              (this || _global).selection.moveTo(0, 0);
              for (var o = n.length - 1; 0 <= o; --o) this.$tryReplace(n[o], e) && i++;
              (this || _global).selection.setSelectionRange(t);
            }
            return i;
          }, x.prototype.$tryReplace = function (e, t) {
            var n = (this || _global).session.getTextRange(e);
            return null !== (t = (this || _global).$search.replace(n, t)) ? (e.end = (this || _global).session.replace(e, t), e) : null;
          }, x.prototype.getLastSearchOptions = function () {
            return (this || _global).$search.getOptions();
          }, x.prototype.find = function (e, t, n) {
            t = t || {}, "string" == typeof e || e instanceof RegExp ? t.needle = e : "object" == typeof e && o.mixin(t, e);
            var i = (this || _global).selection.getRange(),
              e = (null == t.needle && ((e = (this || _global).session.getTextRange(i) || (this || _global).$search.$options.needle) || (i = (this || _global).session.getWordRange(i.start.row, i.start.column), e = (this || _global).session.getTextRange(i)), (this || _global).$search.set({
                needle: e
              })), (this || _global).$search.set(t), t.start || (this || _global).$search.set({
                start: i
              }), (this || _global).$search.find((this || _global).session));
            return t.preventScroll ? e : e ? (this.revealRange(e, n), e) : (t.backwards ? i.start = i.end : i.end = i.start, void (this || _global).selection.setRange(i));
          }, x.prototype.findNext = function (e, t) {
            this.find({
              skipCurrent: !0,
              backwards: !1
            }, e, t);
          }, x.prototype.findPrevious = function (e, t) {
            this.find(e, {
              skipCurrent: !0,
              backwards: !0
            }, t);
          }, x.prototype.revealRange = function (e, t) {
            (this || _global).session.unfold(e), (this || _global).selection.setSelectionRange(e);
            var n = (this || _global).renderer.scrollTop;
            (this || _global).renderer.scrollSelectionIntoView(e.start, e.end, 0.5), !1 !== t && (this || _global).renderer.animateScrolling(n);
          }, x.prototype.undo = function () {
            (this || _global).session.getUndoManager().undo((this || _global).session), (this || _global).renderer.scrollCursorIntoView(null, 0.5);
          }, x.prototype.redo = function () {
            (this || _global).session.getUndoManager().redo((this || _global).session), (this || _global).renderer.scrollCursorIntoView(null, 0.5);
          }, x.prototype.destroy = function () {
            (this || _global).$toDestroy && ((this || _global).$toDestroy.forEach(function (e) {
              e.destroy();
            }), (this || _global).$toDestroy = null), (this || _global).$mouseHandler && (this || _global).$mouseHandler.destroy(), (this || _global).renderer.destroy(), this._signal("destroy", this || _global), (this || _global).session && (this || _global).session.destroy(), (this || _global)._$emitInputEvent && (this || _global)._$emitInputEvent.cancel(), this.removeAllListeners();
          }, x.prototype.setAutoScrollEditorIntoView = function (e) {
            var i, o, r, s, t, n, a;
            e && (r = !1, (o = this || _global).$scrollAnchor || ((this || _global).$scrollAnchor = document.createElement("div")), (s = (this || _global).$scrollAnchor).style.cssText = "position:absolute", (this || _global).container.insertBefore(s, (this || _global).container.firstChild), t = this.on("changeSelection", function () {
              r = !0;
            }), n = (this || _global).renderer.on("beforeRender", function () {
              r && (i = o.renderer.container.getBoundingClientRect());
            }), a = (this || _global).renderer.on("afterRender", function () {
              var e, t, n;
              r && i && (o.isFocused() || o.searchBox && o.searchBox.isFocused()) && (e = (t = o.renderer).$cursorLayer.$pixelPos, t = t.layerConfig, n = e.top - t.offset, null != (r = 0 <= e.top && n + i.top < 0 || !(e.top < t.height && e.top + i.top + t.lineHeight > window.innerHeight) && null) && (s.style.top = n + "px", s.style.left = e.left + "px", s.style.height = t.lineHeight + "px", s.scrollIntoView(r)), r = i = null);
            }), (this || _global).setAutoScrollEditorIntoView = function (e) {
              e || (delete (this || _global).setAutoScrollEditorIntoView, this.off("changeSelection", t), (this || _global).renderer.off("afterRender", a), (this || _global).renderer.off("beforeRender", n));
            });
          }, x.prototype.$resetCursorStyle = function () {
            var e = (this || _global).$cursorStyle || "ace",
              t = (this || _global).renderer.$cursorLayer;
            t && (t.setSmoothBlinking(/smooth/.test(e)), t.isBlinking = !(this || _global).$readOnly && "wide" != e, i.setCssClass(t.element, "ace_slim-cursors", /slim/.test(e)));
          }, x.prototype.prompt = function (t, n, i) {
            var o = this || _global;
            y.loadModule("ace/ext/prompt", function (e) {
              e.prompt(o, t, n, i);
            });
          }, x);
        function x(e, t, n) {
          (this || _global).$toDestroy = [];
          var i = e.getContainerElement();
          (this || _global).container = i, (this || _global).renderer = e, (this || _global).id = "editor" + ++x.$uid, (this || _global).commands = new p(r.isMac ? "mac" : "win", C), "object" == typeof document && ((this || _global).textInput = new s(e.getTextAreaContainer(), this || _global), (this || _global).renderer.textarea = (this || _global).textInput.getElement(), (this || _global).$mouseHandler = new a(this || _global), new l(this || _global)), (this || _global).keyBinding = new c(this || _global), (this || _global).$search = new u().set({
            wrap: !0
          }), (this || _global).$historyTracker = (this || _global).$historyTracker.bind(this || _global), (this || _global).commands.on("exec", (this || _global).$historyTracker), this.$initOperationListeners(), (this || _global)._$emitInputEvent = m.delayedCall(function () {
            this._signal("input", {}), (this || _global).session && !(this || _global).session.destroyed && (this || _global).session.bgTokenizer.scheduleStart();
          }.bind(this || _global)), this.on("change", function (e, t) {
            t._$emitInputEvent.schedule(31);
          }), this.setSession(t || n && n.session || new h("")), y.resetOptions(this || _global), n && this.setOptions(n), y._signal("editor", this || _global);
        }
        e.$uid = 0, e.prototype.curOp = null, e.prototype.prevOp = {}, e.prototype.$mergeableCommands = ["backspace", "del", "insertstring"], e.prototype.$toggleWordPairs = [["first", "last"], ["true", "false"], ["yes", "no"], ["width", "height"], ["top", "bottom"], ["right", "left"], ["on", "off"], ["x", "y"], ["get", "set"], ["max", "min"], ["horizontal", "vertical"], ["show", "hide"], ["add", "remove"], ["up", "down"], ["before", "after"], ["even", "odd"], ["in", "out"], ["inside", "outside"], ["next", "previous"], ["increase", "decrease"], ["attach", "detach"], ["&&", "||"], ["==", "!="]], o.implement(e.prototype, g), y.defineOptions(e.prototype, "editor", {
          selectionStyle: {
            set: function (e) {
              this.onSelectionChange(), this._signal("changeSelectionStyle", {
                data: e
              });
            },
            initialValue: "line"
          },
          highlightActiveLine: {
            set: function () {
              this.$updateHighlightActiveLine();
            },
            initialValue: !0
          },
          highlightSelectedWord: {
            set: function (e) {
              this.$onSelectionChange();
            },
            initialValue: !0
          },
          readOnly: {
            set: function (e) {
              (this || _global).textInput.setReadOnly(e), this.$resetCursorStyle();
            },
            initialValue: !1
          },
          copyWithEmptySelection: {
            set: function (e) {
              (this || _global).textInput.setCopyWithEmptySelection(e);
            },
            initialValue: !1
          },
          cursorStyle: {
            set: function (e) {
              this.$resetCursorStyle();
            },
            values: ["ace", "slim", "smooth", "wide"],
            initialValue: "ace"
          },
          mergeUndoDeltas: {
            values: [!1, !0, "always"],
            initialValue: !0
          },
          behavioursEnabled: {
            initialValue: !0
          },
          wrapBehavioursEnabled: {
            initialValue: !0
          },
          enableAutoIndent: {
            initialValue: !0
          },
          autoScrollEditorIntoView: {
            set: function (e) {
              this.setAutoScrollEditorIntoView(e);
            }
          },
          keyboardHandler: {
            set: function (e) {
              this.setKeyboardHandler(e);
            },
            get: function () {
              return (this || _global).$keybindingId;
            },
            handlesSet: !0
          },
          value: {
            set: function (e) {
              (this || _global).session.setValue(e);
            },
            get: function () {
              return this.getValue();
            },
            handlesSet: !0,
            hidden: !0
          },
          session: {
            set: function (e) {
              this.setSession(e);
            },
            get: function () {
              return (this || _global).session;
            },
            handlesSet: !0,
            hidden: !0
          },
          showLineNumbers: {
            set: function (e) {
              (this || _global).renderer.$gutterLayer.setShowLineNumbers(e), (this || _global).renderer.$loop.schedule((this || _global).renderer.CHANGE_GUTTER), e && (this || _global).$relativeLineNumbers ? k.attach(this || _global) : k.detach(this || _global);
            },
            initialValue: !0
          },
          relativeLineNumbers: {
            set: function (e) {
              (this || _global).$showLineNumbers && e ? k.attach(this || _global) : k.detach(this || _global);
            }
          },
          placeholder: {
            set: function (e) {
              (this || _global).$updatePlaceholder || ((this || _global).$updatePlaceholder = function () {
                var e = (this || _global).session && ((this || _global).renderer.$composition || this.getValue());
                e && (this || _global).renderer.placeholderNode ? ((this || _global).renderer.off("afterRender", (this || _global).$updatePlaceholder), i.removeCssClass((this || _global).container, "ace_hasPlaceholder"), (this || _global).renderer.placeholderNode.remove(), (this || _global).renderer.placeholderNode = null) : e || (this || _global).renderer.placeholderNode ? !e && (this || _global).renderer.placeholderNode && ((this || _global).renderer.placeholderNode.textContent = (this || _global).$placeholder || "") : ((this || _global).renderer.on("afterRender", (this || _global).$updatePlaceholder), i.addCssClass((this || _global).container, "ace_hasPlaceholder"), (e = i.createElement("div")).className = "ace_placeholder", e.textContent = (this || _global).$placeholder || "", (this || _global).renderer.placeholderNode = e, (this || _global).renderer.content.appendChild((this || _global).renderer.placeholderNode));
              }.bind(this || _global), this.on("input", (this || _global).$updatePlaceholder)), this.$updatePlaceholder();
            }
          },
          enableKeyboardAccessibility: {
            set: function (e) {
              function t(e) {
                e.target == (this || _global).renderer.scroller && e.keyCode === S.enter && (e.preventDefault(), e = this.getCursorPosition().row, this.isRowVisible(e) || this.scrollToLine(e, !0, !0), this.focus());
              }
              var n,
                i = {
                  name: "blurTextInput",
                  description: "Set focus to the editor content div to allow tabbing through the page",
                  bindKey: "Esc",
                  exec: function (e) {
                    e.blur(), e.renderer.scroller.focus();
                  },
                  readOnly: !0
                };
              e ? ((this || _global).renderer.enableKeyboardAccessibility = !0, (this || _global).renderer.keyboardFocusClassName = "ace_keyboard-focus", (this || _global).textInput.getElement().setAttribute("tabindex", -1), (this || _global).renderer.scroller.setAttribute("tabindex", 0), (this || _global).renderer.scroller.setAttribute("role", "group"), (this || _global).renderer.scroller.setAttribute("aria-roledescription", A("editor")), (this || _global).renderer.scroller.classList.add((this || _global).renderer.keyboardFocusClassName), (this || _global).renderer.scroller.setAttribute("aria-label", A("Editor content, press Enter to start editing, press Escape to exit")), (this || _global).renderer.scroller.addEventListener("keyup", t.bind(this || _global)), (this || _global).commands.addCommand(i), (this || _global).renderer.$gutter.setAttribute("tabindex", 0), (this || _global).renderer.$gutter.setAttribute("aria-hidden", !1), (this || _global).renderer.$gutter.setAttribute("role", "group"), (this || _global).renderer.$gutter.setAttribute("aria-roledescription", A("editor")), (this || _global).renderer.$gutter.setAttribute("aria-label", A("Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit")), (this || _global).renderer.$gutter.classList.add((this || _global).renderer.keyboardFocusClassName), (this || _global).renderer.content.setAttribute("aria-hidden", !0), (n = n || new b(this || _global)).addListener()) : ((this || _global).renderer.enableKeyboardAccessibility = !1, (this || _global).textInput.getElement().setAttribute("tabindex", 0), (this || _global).renderer.scroller.setAttribute("tabindex", -1), (this || _global).renderer.scroller.removeAttribute("role"), (this || _global).renderer.scroller.removeAttribute("aria-roledescription"), (this || _global).renderer.scroller.classList.remove((this || _global).renderer.keyboardFocusClassName), (this || _global).renderer.scroller.removeAttribute("aria-label"), (this || _global).renderer.scroller.removeEventListener("keyup", t.bind(this || _global)), (this || _global).commands.removeCommand(i), (this || _global).renderer.content.removeAttribute("aria-hidden"), (this || _global).renderer.$gutter.setAttribute("tabindex", -1), (this || _global).renderer.$gutter.setAttribute("aria-hidden", !0), (this || _global).renderer.$gutter.removeAttribute("role"), (this || _global).renderer.$gutter.removeAttribute("aria-roledescription"), (this || _global).renderer.$gutter.removeAttribute("aria-label"), (this || _global).renderer.$gutter.classList.remove((this || _global).renderer.keyboardFocusClassName), n && n.removeListener());
            },
            initialValue: !1
          },
          customScrollbar: "renderer",
          hScrollBarAlwaysVisible: "renderer",
          vScrollBarAlwaysVisible: "renderer",
          highlightGutterLine: "renderer",
          animatedScroll: "renderer",
          showInvisibles: "renderer",
          showPrintMargin: "renderer",
          printMarginColumn: "renderer",
          printMargin: "renderer",
          fadeFoldWidgets: "renderer",
          showFoldWidgets: "renderer",
          displayIndentGuides: "renderer",
          highlightIndentGuides: "renderer",
          showGutter: "renderer",
          fontSize: "renderer",
          fontFamily: "renderer",
          maxLines: "renderer",
          minLines: "renderer",
          scrollPastEnd: "renderer",
          fixedWidthGutter: "renderer",
          theme: "renderer",
          hasCssTransforms: "renderer",
          maxPixelHeight: "renderer",
          useTextareaForIME: "renderer",
          useResizeObserver: "renderer",
          useSvgGutterIcons: "renderer",
          showFoldedAnnotations: "renderer",
          scrollSpeed: "$mouseHandler",
          dragDelay: "$mouseHandler",
          dragEnabled: "$mouseHandler",
          focusTimeout: "$mouseHandler",
          tooltipFollowsMouse: "$mouseHandler",
          firstLineNumber: "session",
          overwrite: "session",
          newLineMode: "session",
          useWorker: "session",
          useSoftTabs: "session",
          navigateWithinSoftTabs: "session",
          tabSize: "session",
          wrap: "session",
          indentedSoftWrap: "session",
          foldStyle: "session",
          mode: "session"
        });
        var k = {
          getText: function (e, t) {
            return (Math.abs(e.selection.lead.row - t) || t + 1 + (t < 9 ? "\xB7" : "")) + "";
          },
          getWidth: function (e, t, n) {
            return Math.max(t.toString().length, (n.lastRow + 1).toString().length, 2) * n.characterWidth;
          },
          update: function (e, t) {
            t.renderer.$loop.schedule(t.renderer.CHANGE_GUTTER);
          },
          attach: function (e) {
            e.renderer.$gutterLayer.$renderer = this || _global, e.on("changeSelection", (this || _global).update), this.update(null, e);
          },
          detach: function (e) {
            e.renderer.$gutterLayer.$renderer == (this || _global) && (e.renderer.$gutterLayer.$renderer = null), e.off("changeSelection", (this || _global).update), this.update(null, e);
          }
        };
        t.Editor = e;
      }), ace.define("ace/undomanager", ["require", "exports", "module", "ace/range"], function (e, t, n) {
        "use strict";

        o.prototype.addSession = function (e) {
          (this || _global).$session = e;
        }, o.prototype.add = function (e, t, n) {
          (this || _global).$fromUndo || e != (this || _global).$lastDelta && ((this || _global).$keepRedoStack || ((this || _global).$redoStack.length = 0), !1 !== t && (this || _global).lastDeltas || ((this || _global).lastDeltas = [], (t = (this || _global).$undoStack.length) > (this || _global).$undoDepth - 1 && (this || _global).$undoStack.splice(0, t - (this || _global).$undoDepth + 1), (this || _global).$undoStack.push((this || _global).lastDeltas), e.id = (this || _global).$rev = ++(this || _global).$maxRev), "remove" != e.action && "insert" != e.action || ((this || _global).$lastDelta = e), (this || _global).lastDeltas.push(e));
        }, o.prototype.addSelection = function (e, t) {
          (this || _global).selections.push({
            value: e,
            rev: t || (this || _global).$rev
          });
        }, o.prototype.startNewGroup = function () {
          return (this || _global).lastDeltas = null, (this || _global).$rev;
        }, o.prototype.markIgnored = function (e, t) {
          null == t && (t = (this || _global).$rev + 1);
          for (var n = (this || _global).$undoStack, i = n.length; i--;) {
            var o = n[i][0];
            if (o.id <= e) break;
            o.id < t && (o.ignore = !0);
          }
          (this || _global).lastDeltas = null;
        }, o.prototype.getSelection = function (e, t) {
          for (var n = (this || _global).selections, i = n.length; i--;) {
            var o = n[i];
            if (o.rev < e) return o = t ? n[i + 1] : o;
          }
        }, o.prototype.getRevision = function () {
          return (this || _global).$rev;
        }, o.prototype.getDeltas = function (e, t) {
          null == t && (t = (this || _global).$rev + 1);
          for (var n = (this || _global).$undoStack, i = null, o = 0, r = n.length; r--;) {
            var s = n[r][0];
            if (s.id < t && !i && (i = r + 1), s.id <= e) {
              o = r + 1;
              break;
            }
          }
          return n.slice(o, i);
        }, o.prototype.getChangedRanges = function (e, t) {
          null == t && (this || _global).$rev;
        }, o.prototype.getChangedLines = function (e, t) {
          null == t && (this || _global).$rev;
        }, o.prototype.undo = function (e, t) {
          (this || _global).lastDeltas = null;
          var n,
            i = (this || _global).$undoStack;
          if (function (e, t) {
            for (var n = t; n--;) {
              var i = e[n];
              if (i && !i[0].ignore) {
                for (; n < t - 1;) {
                  var o = function (e, t) {
                    for (var n = e.length; n--;) for (var i = 0; i < t.length; i++) if (!a(e[n], t[i])) {
                      for (; n < e.length;) {
                        for (; i--;) a(t[i], e[n]);
                        i = t.length, n++;
                      }
                      return [e, t];
                    }
                    return e.selectionBefore = t.selectionBefore = e.selectionAfter = t.selectionAfter = null, [t, e];
                  }(e[n], e[n + 1]);
                  e[n] = o[0], e[n + 1] = o[1], n++;
                }
                return 1;
              }
            }
          }(i, i.length)) return e = e || (this || _global).$session, (this || _global).$redoStackBaseRev !== (this || _global).$rev && (this || _global).$redoStack.length && ((this || _global).$redoStack = []), (this || _global).$fromUndo = !0, n = null, (i = i.pop()) && (n = e.undoChanges(i, t), (this || _global).$redoStack.push(i), this.$syncRev()), (this || _global).$fromUndo = !1, n;
        }, o.prototype.redo = function (e, t) {
          if ((this || _global).lastDeltas = null, e = e || (this || _global).$session, (this || _global).$fromUndo = !0, (this || _global).$redoStackBaseRev != (this || _global).$rev) {
            for (var n = this.getDeltas((this || _global).$redoStackBaseRev, (this || _global).$rev + 1), i = (this || _global).$redoStack, o = n, r = 0; r < o.length; r++) for (var s = o[r], a = 0; a < s.length; a++) {
              l = void 0;
              c = void 0;
              h = void 0;
              d = void 0;
              u = void 0;
              g = void 0;
              var l = i;
              var c = s[a];
              c = function (e) {
                return {
                  start: C(e.start),
                  end: C(e.end),
                  action: e.action,
                  lines: e.lines.slice()
                };
              }(c);
              for (var h = l.length; h--;) {
                for (var d = l[h], u = 0; u < d.length; u++) {
                  var g = function (e, t) {
                    var n,
                      i,
                      o = "insert" == e.action,
                      r = "insert" == t.action;
                    if (o && r) f(e.start, t.start) < 0 ? y(t, e, 1) : y(e, t, 1);else if (o && !r) 0 <= f(e.start, t.end) ? y(e, t, -1) : (f(e.start, t.start) <= 0 || y(e, m.fromPoints(t.start, e.start), -1), y(t, e, 1));else if (!o && r) 0 <= f(t.start, e.end) ? y(t, e, -1) : (f(t.start, e.start) <= 0 || y(t, m.fromPoints(e.start, t.start), -1), y(e, t, 1));else if (!o && !r) if (0 <= f(t.start, e.end)) y(t, e, -1);else {
                      if (!(f(t.end, e.start) <= 0)) return f(e.start, t.start) < 0 && (e = I(n = e, t.start)), 0 < f(e.end, t.end) && (i = I(e, t.end)), v(t.end, e.start, e.end, -1), i && !n && (e.lines = i.lines, e.start = i.start, e.end = i.end, i = e), [t, n, i].filter(Boolean);
                      y(e, t, -1);
                    }
                    return [t, e];
                  }(d[u], c);
                  c = g[0], 2 != g.length && (g[2] ? (d.splice(u + 1, 1, g[1], g[2]), u++) : g[1] || (d.splice(u, 1), u--));
                }
                d.length || l.splice(h, 1);
              }
            }
            (this || _global).$redoStackBaseRev = (this || _global).$rev, (this || _global).$redoStack.forEach(function (e) {
              e[0].id = ++(this || _global).$maxRev;
            }, this || _global);
          }
          var n = (this || _global).$redoStack.pop(),
            p = null;
          return n && (p = e.redoChanges(n, t), (this || _global).$undoStack.push(n), this.$syncRev()), (this || _global).$fromUndo = !1, p;
        }, o.prototype.$syncRev = function () {
          var e = (this || _global).$undoStack,
            e = e[e.length - 1],
            e = e && e[0].id || 0;
          (this || _global).$redoStackBaseRev = e, (this || _global).$rev = e;
        }, o.prototype.reset = function () {
          (this || _global).lastDeltas = null, (this || _global).$lastDelta = null, (this || _global).$undoStack = [], (this || _global).$redoStack = [], (this || _global).$rev = 0, (this || _global).mark = 0, (this || _global).$redoStackBaseRev = (this || _global).$rev, (this || _global).selections = [];
        }, o.prototype.canUndo = function () {
          return 0 < (this || _global).$undoStack.length;
        }, o.prototype.canRedo = function () {
          return 0 < (this || _global).$redoStack.length;
        }, o.prototype.bookmark = function (e) {
          null == e && (e = (this || _global).$rev), (this || _global).mark = e;
        }, o.prototype.isAtBookmark = function () {
          return (this || _global).$rev === (this || _global).mark;
        }, o.prototype.toJSON = function () {}, o.prototype.fromJSON = function () {}, o.prototype.$prettyPrint = function (e) {
          return e ? r(e) : r((this || _global).$undoStack) + "\n---\n" + r((this || _global).$redoStack);
        };
        var i = o;
        function o() {
          (this || _global).$maxRev = 0, (this || _global).$fromUndo = !1, (this || _global).$undoDepth = 1 / 0, this.reset();
        }
        i.prototype.hasUndo = i.prototype.canUndo, i.prototype.hasRedo = i.prototype.canRedo, i.prototype.isClean = i.prototype.isAtBookmark, i.prototype.markClean = i.prototype.bookmark;
        var m = e("./range").Range,
          f = m.comparePoints;
        m.comparePoints;
        function C(e) {
          return {
            row: e.row,
            column: e.column
          };
        }
        function r(e) {
          var t;
          return e = e || this || _global, Array.isArray(e) ? e.map(r).join("\n") : (t = "", e.action ? (t = "insert" == e.action ? "+" : "-", t += "[" + e.lines + "]") : e.value && (t = Array.isArray(e.value) ? e.value.map(s).join("\n") : s(e.value)), e.start && (t += s(e)), (e.id || e.rev) && (t += "\t(" + (e.id || e.rev) + ")"), t);
        }
        function s(e) {
          return e.start.row + ":" + e.start.column + "=>" + e.end.row + ":" + e.end.column;
        }
        function a(e, t) {
          var n = "insert" == e.action,
            i = "insert" == t.action;
          if (n && i) {
            if (0 <= f(t.start, e.end)) y(t, e, -1);else {
              if (!(f(t.start, e.start) <= 0)) return;
              y(e, t, 1);
            }
          } else if (n && !i) {
            if (0 <= f(t.start, e.end)) y(t, e, -1);else {
              if (!(f(t.end, e.start) <= 0)) return;
              y(e, t, -1);
            }
          } else if (!n && i) {
            if (0 <= f(t.start, e.start)) y(t, e, 1);else {
              if (!(f(t.start, e.start) <= 0)) return;
              y(e, t, 1);
            }
          } else if (!n && !i) if (0 <= f(t.start, e.start)) y(t, e, 1);else {
            if (!(f(t.end, e.start) <= 0)) return;
            y(e, t, -1);
          }
          return 1;
        }
        function y(e, t, n) {
          v(e.start, t.start, t.end, n), v(e.end, t.start, t.end, n);
        }
        function v(e, t, n, i) {
          e.row == (1 == i ? t : n).row && (e.column += i * (n.column - t.column)), e.row += i * (n.row - t.row);
        }
        function I(e, t) {
          var n = e.lines,
            i = e.end,
            o = (e.end = C(t), e.end.row - e.start.row),
            r = n.splice(o, n.length),
            o = o ? t.column : t.column - e.start.column;
          return n.push(r[0].substring(0, o)), r[0] = r[0].substr(o), {
            start: C(t),
            end: i,
            lines: r,
            action: e.action
          };
        }
        t.UndoManager = i;
      }), ace.define("ace/layer/lines", ["require", "exports", "module", "ace/lib/dom"], function (e, t, n) {
        "use strict";

        var s = e("../lib/dom");
        function i(e, t) {
          (this || _global).element = e, (this || _global).canvasHeight = t || 500000, (this || _global).element.style.height = 2 * (this || _global).canvasHeight + "px", (this || _global).cells = [], (this || _global).cellCache = [], (this || _global).$offsetCoefficient = 0;
        }
        i.prototype.moveContainer = function (e) {
          s.translate((this || _global).element, 0, -(e.firstRowScreen * e.lineHeight % (this || _global).canvasHeight) - e.offset * (this || _global).$offsetCoefficient);
        }, i.prototype.pageChanged = function (e, t) {
          return Math.floor(e.firstRowScreen * e.lineHeight / (this || _global).canvasHeight) !== Math.floor(t.firstRowScreen * t.lineHeight / (this || _global).canvasHeight);
        }, i.prototype.computeLineTop = function (e, t, n) {
          var i = t.firstRowScreen * t.lineHeight,
            i = Math.floor(i / (this || _global).canvasHeight);
          return n.documentToScreenRow(e, 0) * t.lineHeight - i * (this || _global).canvasHeight;
        }, i.prototype.computeLineHeight = function (e, t, n) {
          return t.lineHeight * n.getRowLineCount(e);
        }, i.prototype.getLength = function () {
          return (this || _global).cells.length;
        }, i.prototype.get = function (e) {
          return (this || _global).cells[e];
        }, i.prototype.shift = function () {
          this.$cacheCell((this || _global).cells.shift());
        }, i.prototype.pop = function () {
          this.$cacheCell((this || _global).cells.pop());
        }, i.prototype.push = function (e) {
          if (Array.isArray(e)) {
            (this || _global).cells.push.apply((this || _global).cells, e);
            for (var t = s.createFragment((this || _global).element), n = 0; n < e.length; n++) t.appendChild(e[n].element);
            (this || _global).element.appendChild(t);
          } else (this || _global).cells.push(e), (this || _global).element.appendChild(e.element);
        }, i.prototype.unshift = function (e) {
          if (Array.isArray(e)) {
            (this || _global).cells.unshift.apply((this || _global).cells, e);
            for (var t = s.createFragment((this || _global).element), n = 0; n < e.length; n++) t.appendChild(e[n].element);
            (this || _global).element.firstChild ? (this || _global).element.insertBefore(t, (this || _global).element.firstChild) : (this || _global).element.appendChild(t);
          } else (this || _global).cells.unshift(e), (this || _global).element.insertAdjacentElement("afterbegin", e.element);
        }, i.prototype.last = function () {
          return (this || _global).cells.length ? (this || _global).cells[(this || _global).cells.length - 1] : null;
        }, i.prototype.$cacheCell = function (e) {
          e && (e.element.remove(), (this || _global).cellCache.push(e));
        }, i.prototype.createCell = function (e, t, n, i) {
          var o,
            r = (this || _global).cellCache.pop();
          return r || (o = s.createElement("div"), i && i(o), (this || _global).element.appendChild(o), r = {
            element: o,
            text: "",
            row: e
          }), r.row = e, r;
        }, t.Lines = i;
      }), ace.define("ace/layer/gutter", ["require", "exports", "module", "ace/lib/dom", "ace/lib/oop", "ace/lib/lang", "ace/lib/event_emitter", "ace/layer/lines", "ace/config"], function (e, t, n) {
        "use strict";

        var w = e("../lib/dom"),
          i = e("../lib/oop"),
          s = e("../lib/lang"),
          o = e("../lib/event_emitter").EventEmitter,
          r = e("./lines").Lines,
          S = e("../config").nls,
          e = (a.prototype.setSession = function (e) {
            (this || _global).session && (this || _global).session.off("change", (this || _global).$updateAnnotations), ((this || _global).session = e) && e.on("change", (this || _global).$updateAnnotations);
          }, a.prototype.addGutterDecoration = function (e, t) {
            window.console && console.warn && console.warn("deprecated use session.addGutterDecoration"), (this || _global).session.addGutterDecoration(e, t);
          }, a.prototype.removeGutterDecoration = function (e, t) {
            window.console && console.warn && console.warn("deprecated use session.removeGutterDecoration"), (this || _global).session.removeGutterDecoration(e, t);
          }, a.prototype.setAnnotations = function (e) {
            (this || _global).$annotations = [];
            for (var t = 0; t < e.length; t++) {
              var n = e[t],
                i = n.row,
                o = (o = (this || _global).$annotations[i]) || ((this || _global).$annotations[i] = {
                  text: [],
                  type: []
                }),
                i = n.text,
                r = n.type,
                i = i ? s.escapeHTML(i) : n.html || "",
                i = (-1 === o.text.indexOf(i) && (o.text.push(i), o.type.push(r)), n.className);
              i ? o.className = i : "error" == r ? o.className = " ace_error" : "warning" == r && " ace_error" != o.className ? o.className = " ace_warning" : "info" != r || o.className || (o.className = " ace_info");
            }
          }, a.prototype.$updateAnnotations = function (e) {
            var t, n;
            (this || _global).$annotations.length && (t = e.start.row, 0 != (n = e.end.row - t)) && ("remove" == e.action ? (this || _global).$annotations.splice(t, 1 + n, null) : ((e = new Array(1 + n)).unshift(t, 1), (this || _global).$annotations.splice.apply((this || _global).$annotations, e)));
          }, a.prototype.update = function (e) {
            (this || _global).config = e;
            for (var t = (this || _global).session, n = e.firstRow, i = Math.min(e.lastRow + e.gutterOffset, t.getLength() - 1), o = ((this || _global).oldLastRow = i, (this || _global).config = e, (this || _global).$lines.moveContainer(e), this.$updateCursorRow(), t.getNextFoldLine(n)), r = o ? o.start.row : 1 / 0, s = null, a = -1, l = n;;) {
              if (r < l && (l = o.end.row + 1, r = (o = t.getNextFoldLine(l, o)) ? o.start.row : 1 / 0), i < l) {
                for (; (this || _global).$lines.getLength() > a + 1;) (this || _global).$lines.pop();
                break;
              }
              (s = (this || _global).$lines.get(++a)) ? s.row = l : (s = (this || _global).$lines.createCell(l, e, (this || _global).session, c), (this || _global).$lines.push(s)), this.$renderCell(s, e, o, l), l++;
            }
            this._signal("afterRender"), this.$updateGutterWidth(e);
          }, a.prototype.$updateGutterWidth = function (e) {
            var t = (this || _global).session,
              n = t.gutterRenderer || (this || _global).$renderer,
              i = t.$firstLineNumber,
              o = (this || _global).$lines.last() ? (this || _global).$lines.last().text : "",
              i = (((this || _global).$fixedWidth || t.$useWrapMode) && (o = t.getLength() + i - 1), n ? n.getWidth(t, o, e) : o.toString().length * e.characterWidth),
              n = (this || _global).$padding || this.$computePadding();
            (i += n.left + n.right) === (this || _global).gutterWidth || isNaN(i) || ((this || _global).gutterWidth = i, (this || _global).element.parentNode.style.width = (this || _global).element.style.width = Math.ceil((this || _global).gutterWidth) + "px", this._signal("changeGutterWidth", i));
          }, a.prototype.$updateCursorRow = function () {
            var e;
            (this || _global).$highlightGutterLine && (e = (this || _global).session.selection.getCursor(), (this || _global).$cursorRow !== e.row) && ((this || _global).$cursorRow = e.row);
          }, a.prototype.updateLineHighlight = function () {
            if ((this || _global).$highlightGutterLine) {
              var e = (this || _global).session.selection.cursor.row;
              if ((this || _global).$cursorRow = e, !(this || _global).$cursorCell || (this || _global).$cursorCell.row != e) {
                (this || _global).$cursorCell && ((this || _global).$cursorCell.element.className = (this || _global).$cursorCell.element.className.replace("ace_gutter-active-line ", ""));
                var t = (this || _global).$lines.cells;
                (this || _global).$cursorCell = null;
                for (var n = 0; n < t.length; n++) {
                  var i = t[n];
                  if (i.row >= (this || _global).$cursorRow) {
                    if (i.row > (this || _global).$cursorRow) {
                      var o = (this || _global).session.getFoldLine((this || _global).$cursorRow);
                      if (!(0 < n && o && o.start.row == t[n - 1].row)) break;
                      i = t[n - 1];
                    }
                    i.element.className = "ace_gutter-active-line " + i.element.className, (this || _global).$cursorCell = i;
                    break;
                  }
                }
              }
            }
          }, a.prototype.scrollLines = function (e) {
            var t = (this || _global).config;
            if ((this || _global).config = e, this.$updateCursorRow(), (this || _global).$lines.pageChanged(t, e)) return this.update(e);
            (this || _global).$lines.moveContainer(e);
            var n = Math.min(e.lastRow + e.gutterOffset, (this || _global).session.getLength() - 1),
              i = (this || _global).oldLastRow;
            if ((this || _global).oldLastRow = n, !t || i < e.firstRow) return this.update(e);
            if (n < t.firstRow) return this.update(e);
            if (t.firstRow < e.firstRow) for (var o = (this || _global).session.getFoldedRowCount(t.firstRow, e.firstRow - 1); 0 < o; o--) (this || _global).$lines.shift();
            if (n < i) for (o = (this || _global).session.getFoldedRowCount(n + 1, i); 0 < o; o--) (this || _global).$lines.pop();
            e.firstRow < t.firstRow && (this || _global).$lines.unshift(this.$renderLines(e, e.firstRow, t.firstRow - 1)), i < n && (this || _global).$lines.push(this.$renderLines(e, i + 1, n)), this.updateLineHighlight(), this._signal("afterRender"), this.$updateGutterWidth(e);
          }, a.prototype.$renderLines = function (e, t, n) {
            for (var i = [], o = t, r = (this || _global).session.getNextFoldLine(o), s = r ? r.start.row : 1 / 0; s < o && (o = r.end.row + 1, s = (r = (this || _global).session.getNextFoldLine(o, r)) ? r.start.row : 1 / 0), !(n < o);) {
              var a = (this || _global).$lines.createCell(o, e, (this || _global).session, c);
              this.$renderCell(a, e, r, o), i.push(a), o++;
            }
            return i;
          }, a.prototype.$renderCell = function (e, t, n, i) {
            var o,
              r = e.element,
              s = (this || _global).session,
              a = r.childNodes[0],
              l = r.childNodes[1],
              c = r.childNodes[2],
              h = c.firstChild,
              d = s.$firstLineNumber,
              u = s.$breakpoints,
              g = s.$decorations,
              p = s.gutterRenderer || (this || _global).$renderer,
              m = (this || _global).$showFoldWidgets && s.foldWidgets,
              f = n ? n.start.row : Number.MAX_VALUE,
              C = t.lineHeight + "px",
              y = (this || _global).$useSvgGutterIcons ? "ace_gutter-cell_svg-icons " : "ace_gutter-cell ",
              v = (this || _global).$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon",
              p = (p ? p.getText(s, i) : i + d).toString();
            if ((this || _global).$highlightGutterLine && (i == (this || _global).$cursorRow || n && i < (this || _global).$cursorRow && f <= i && (this || _global).$cursorRow <= n.end.row) && (y += "ace_gutter-active-line ", (this || _global).$cursorCell != e) && ((this || _global).$cursorCell && ((this || _global).$cursorCell.element.className = (this || _global).$cursorCell.element.className.replace("ace_gutter-active-line ", "")), (this || _global).$cursorCell = e), u[i] && (y += u[i]), g[i] && (y += g[i]), (this || _global).$annotations[i] && i !== f && (y += (this || _global).$annotations[i].className), r.className != y && (r.className = y), o = m && null == (o = m[i]) ? m[i] = s.getFoldWidget(i) : o) {
              y = "ace_fold-widget ace_" + o;
              if ("start" == o && i == f && i < n.end.row) {
                y += " ace_closed";
                for (var I, b = !1, A = i + 1; A <= n.end.row; A++) if ((this || _global).$annotations[A]) {
                  if (" ace_error" === (this || _global).$annotations[A].className) {
                    b = !0, I = " ace_error_fold";
                    break;
                  }
                  " ace_warning" === (this || _global).$annotations[A].className && (b = !0, I = " ace_warning_fold");
                }
                r.className += I;
              } else y += " ace_open";
              l.className != y && (l.className = y), w.setStyle(l.style, "height", C), w.setStyle(l.style, "display", "inline-block"), l.setAttribute("role", "button"), l.setAttribute("tabindex", "-1"), (n = s.getFoldLine(p - 1)) ? (l.setAttribute("aria-label", S("Unfold rows $0 to $1", [p, n.end.row + 1])), l.setAttribute("title", S("Unfold code"))) : (l.setAttribute("aria-label", S("Fold at row $0", [p])), l.setAttribute("title", S("Fold code")));
            } else l && (w.setStyle(l.style, "display", "none"), l.setAttribute("tabindex", "0"), l.removeAttribute("role"), l.removeAttribute("aria-label"));
            return b && (this || _global).$showFoldedAnnotations ? (c.className = "ace_gutter_annotation", h.className = v, h.className += I, w.setStyle(h.style, "height", C), w.setStyle(c.style, "display", "block"), w.setStyle(c.style, "height", C), c.setAttribute("aria-label", S("Read annotations row $0", [p])), c.setAttribute("tabindex", "-1")) : (this || _global).$annotations[i] ? (c.className = "ace_gutter_annotation", h.className = v, (this || _global).$useSvgGutterIcons ? h.className += (this || _global).$annotations[i].className : r.classList.add((this || _global).$annotations[i].className.replace(" ", "")), w.setStyle(h.style, "height", C), w.setStyle(c.style, "display", "block"), w.setStyle(c.style, "height", C), c.setAttribute("aria-label", S("Read annotations row $0", [p])), c.setAttribute("tabindex", "-1")) : (w.setStyle(c.style, "display", "none"), c.removeAttribute("aria-label"), c.setAttribute("tabindex", "0")), p !== a.data && (a.data = p), w.setStyle(e.element.style, "height", (this || _global).$lines.computeLineHeight(i, t, s) + "px"), w.setStyle(e.element.style, "top", (this || _global).$lines.computeLineTop(i, t, s) + "px"), e.text = p, "none" === c.style.display && "none" === l.style.display ? e.element.setAttribute("aria-hidden", !0) : e.element.setAttribute("aria-hidden", !1), e;
          }, a.prototype.setHighlightGutterLine = function (e) {
            (this || _global).$highlightGutterLine = e;
          }, a.prototype.setShowLineNumbers = function (e) {
            (this || _global).$renderer = !e && {
              getWidth: function () {
                return 0;
              },
              getText: function () {
                return "";
              }
            };
          }, a.prototype.getShowLineNumbers = function () {
            return (this || _global).$showLineNumbers;
          }, a.prototype.setShowFoldWidgets = function (e) {
            e ? w.addCssClass((this || _global).element, "ace_folding-enabled") : w.removeCssClass((this || _global).element, "ace_folding-enabled"), (this || _global).$showFoldWidgets = e, (this || _global).$padding = null;
          }, a.prototype.getShowFoldWidgets = function () {
            return (this || _global).$showFoldWidgets;
          }, a.prototype.$computePadding = function () {
            var e;
            return (this || _global).element.firstChild ? (e = w.computedStyle((this || _global).element.firstChild), (this || _global).$padding = {}, (this || _global).$padding.left = (parseInt(e.borderLeftWidth) || 0) + (parseInt(e.paddingLeft) || 0) + 1, (this || _global).$padding.right = (parseInt(e.borderRightWidth) || 0) + (parseInt(e.paddingRight) || 0), (this || _global).$padding) : {
              left: 0,
              right: 0
            };
          }, a.prototype.getRegion = function (e) {
            var t = (this || _global).$padding || this.$computePadding(),
              n = (this || _global).element.getBoundingClientRect();
            return e.x < t.left + n.left ? "markers" : (this || _global).$showFoldWidgets && e.x > n.right - t.right ? "foldWidgets" : void 0;
          }, a);
        function a(e) {
          (this || _global).element = w.createElement("div"), (this || _global).element.className = "ace_layer ace_gutter-layer", e.appendChild((this || _global).element), this.setShowFoldWidgets((this || _global).$showFoldWidgets), (this || _global).gutterWidth = 0, (this || _global).$annotations = [], (this || _global).$updateAnnotations = (this || _global).$updateAnnotations.bind(this || _global), (this || _global).$lines = new r((this || _global).element), (this || _global).$lines.$offsetCoefficient = 1;
        }
        function c(e) {
          var t = document.createTextNode(""),
            t = (e.appendChild(t), w.createElement("span")),
            t = (e.appendChild(t), w.createElement("span")),
            n = (e.appendChild(t), w.createElement("span"));
          return t.appendChild(n), e;
        }
        e.prototype.$fixedWidth = !1, e.prototype.$highlightGutterLine = !0, e.prototype.$renderer = "", e.prototype.$showLineNumbers = !0, e.prototype.$showFoldWidgets = !0, i.implement(e.prototype, o), t.Gutter = e;
      }), ace.define("ace/layer/marker", ["require", "exports", "module", "ace/range", "ace/lib/dom"], function (e, t, n) {
        "use strict";

        var g = e("../range").Range,
          i = e("../lib/dom"),
          e = (o.prototype.setPadding = function (e) {
            (this || _global).$padding = e;
          }, o.prototype.setSession = function (e) {
            (this || _global).session = e;
          }, o.prototype.setMarkers = function (e) {
            (this || _global).markers = e;
          }, o.prototype.elt = function (e, t) {
            var n = -1 != (this || _global).i && (this || _global).element.childNodes[(this || _global).i];
            n ? (this || _global).i++ : (n = document.createElement("div"), (this || _global).element.appendChild(n), (this || _global).i = -1), n.style.cssText = t, n.className = e;
          }, o.prototype.update = function (e) {
            if (e) {
              var t, n;
              for (n in (this || _global).config = e, (this || _global).i = 0, (this || _global).markers) {
                var i,
                  o,
                  r,
                  s = (this || _global).markers[n];
                s.range ? (r = s.range.clipRows(e.firstRow, e.lastRow)).isEmpty() || (r = r.toScreenRange((this || _global).session), s.renderer ? (i = this.$getTop(r.start.row, e), o = (this || _global).$padding + r.start.column * e.characterWidth, s.renderer(t, r, o, i, e)) : "fullLine" == s.type ? this.drawFullLineMarker(t, r, s.clazz, e) : "screenLine" == s.type ? this.drawScreenLineMarker(t, r, s.clazz, e) : r.isMultiLine() ? "text" == s.type ? this.drawTextMarker(t, r, s.clazz, e) : this.drawMultiLineMarker(t, r, s.clazz, e) : this.drawSingleLineMarker(t, r, s.clazz + " ace_start ace_br15", e)) : s.update(t, this || _global, (this || _global).session, e);
              }
              if (-1 != (this || _global).i) for (; (this || _global).i < (this || _global).element.childElementCount;) (this || _global).element.removeChild((this || _global).element.lastChild);
            }
          }, o.prototype.$getTop = function (e, t) {
            return (e - t.firstRowScreen) * t.lineHeight;
          }, o.prototype.drawTextMarker = function (e, t, n, i, o) {
            for (var r, s = (this || _global).session, a = t.start.row, l = t.end.row, c = a, h = 0, d = s.getScreenLastRowColumn(c), u = new g(c, t.start.column, c, h); c <= l; c++) u.start.row = u.end.row = c, u.start.column = c == a ? t.start.column : s.getRowWrapIndent(c), u.end.column = d, r = h, h = d, d = c + 1 < l ? s.getScreenLastRowColumn(c + 1) : c == l ? 0 : t.end.column, this.drawSingleLineMarker(e, u, n + (c == a ? " ace_start" : "") + " ace_br" + ((c == a || c == a + 1 && t.start.column ? 1 : 0) | (r < h ? 2 : 0) | (d < h ? 4 : 0) | (c == l ? 8 : 0)), i, c == l ? 0 : 1, o);
          }, o.prototype.drawMultiLineMarker = function (e, t, n, i, o) {
            var r,
              s = (this || _global).$padding,
              a = i.lineHeight,
              l = this.$getTop(t.start.row, i),
              c = s + t.start.column * i.characterWidth;
            o = o || "", (this || _global).session.$bidiHandler.isBidiRow(t.start.row) ? ((r = t.clone()).end.row = r.start.row, r.end.column = (this || _global).session.getLine(r.start.row).length, this.drawBidiSingleLineMarker(e, r, n + " ace_br1 ace_start", i, null, o)) : this.elt(n + " ace_br1 ace_start", "height:" + a + "px;right:0;top:" + l + "px;left:" + c + "px;" + (o || "")), (this || _global).session.$bidiHandler.isBidiRow(t.end.row) ? ((r = t.clone()).start.row = r.end.row, r.start.column = 0, this.drawBidiSingleLineMarker(e, r, n + " ace_br12", i, null, o)) : (l = this.$getTop(t.end.row, i), c = t.end.column * i.characterWidth, this.elt(n + " ace_br12", "height:" + a + "px;width:" + c + "px;top:" + l + "px;left:" + s + "px;" + (o || ""))), (a = (t.end.row - t.start.row - 1) * i.lineHeight) <= 0 || (l = this.$getTop(t.start.row + 1, i), e = (t.start.column ? 1 : 0) | (t.end.column ? 0 : 8), this.elt(n + (e ? " ace_br" + e : ""), "height:" + a + "px;right:0;top:" + l + "px;left:" + s + "px;" + (o || "")));
          }, o.prototype.drawSingleLineMarker = function (e, t, n, i, o, r) {
            if ((this || _global).session.$bidiHandler.isBidiRow(t.start.row)) return this.drawBidiSingleLineMarker(e, t, n, i, o, r);
            var e = i.lineHeight,
              o = (t.end.column + (o || 0) - t.start.column) * i.characterWidth,
              s = this.$getTop(t.start.row, i),
              t = (this || _global).$padding + t.start.column * i.characterWidth;
            this.elt(n, "height:" + e + "px;width:" + o + "px;top:" + s + "px;left:" + t + "px;" + (r || ""));
          }, o.prototype.drawBidiSingleLineMarker = function (e, t, n, i, o, r) {
            var s = i.lineHeight,
              a = this.$getTop(t.start.row, i),
              l = (this || _global).$padding;
            (this || _global).session.$bidiHandler.getSelections(t.start.column, t.end.column).forEach(function (e) {
              this.elt(n, "height:" + s + "px;width:" + (e.width + (o || 0)) + "px;top:" + a + "px;left:" + (l + e.left) + "px;" + (r || ""));
            }, this || _global);
          }, o.prototype.drawFullLineMarker = function (e, t, n, i, o) {
            var r = this.$getTop(t.start.row, i),
              s = i.lineHeight;
            t.start.row != t.end.row && (s += this.$getTop(t.end.row, i) - r), this.elt(n, "height:" + s + "px;top:" + r + "px;left:0;right:0;" + (o || ""));
          }, o.prototype.drawScreenLineMarker = function (e, t, n, i, o) {
            t = this.$getTop(t.start.row, i), i = i.lineHeight;
            this.elt(n, "height:" + i + "px;top:" + t + "px;left:0;right:0;" + (o || ""));
          }, o);
        function o(e) {
          (this || _global).element = i.createElement("div"), (this || _global).element.className = "ace_layer ace_marker-layer", e.appendChild((this || _global).element);
        }
        e.prototype.$padding = 0, t.Marker = e;
      }), ace.define("ace/layer/text", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/lib/lang", "ace/layer/lines", "ace/lib/event_emitter"], function (e, t, n) {
        "use strict";

        var i = e("../lib/oop"),
          c = e("../lib/dom"),
          C = e("../lib/lang"),
          o = e("./lines").Lines,
          e = e("../lib/event_emitter").EventEmitter,
          r = (s.prototype.$updateEolChar = function () {
            var e = (this || _global).session.doc,
              e = "\n" == e.getNewLineCharacter() && "windows" != e.getNewLineMode() ? (this || _global).EOL_CHAR_LF : (this || _global).EOL_CHAR_CRLF;
            if ((this || _global).EOL_CHAR != e) return (this || _global).EOL_CHAR = e, !0;
          }, s.prototype.setPadding = function (e) {
            (this || _global).$padding = e, (this || _global).element.style.margin = "0 " + e + "px";
          }, s.prototype.getLineHeight = function () {
            return (this || _global).$fontMetrics.$characterSize.height || 0;
          }, s.prototype.getCharacterWidth = function () {
            return (this || _global).$fontMetrics.$characterSize.width || 0;
          }, s.prototype.$setFontMetrics = function (e) {
            (this || _global).$fontMetrics = e, (this || _global).$fontMetrics.on("changeCharacterSize", function (e) {
              this._signal("changeCharacterSize", e);
            }.bind(this || _global)), this.$pollSizeChanges();
          }, s.prototype.checkForSizeChanges = function () {
            (this || _global).$fontMetrics.checkForSizeChanges();
          }, s.prototype.$pollSizeChanges = function () {
            return (this || _global).$pollSizeChangesTimer = (this || _global).$fontMetrics.$pollSizeChanges();
          }, s.prototype.setSession = function (e) {
            ((this || _global).session = e) && this.$computeTabString();
          }, s.prototype.setShowInvisibles = function (e) {
            return (this || _global).showInvisibles != e && ("string" == typeof ((this || _global).showInvisibles = e) ? ((this || _global).showSpaces = /tab/i.test(e), (this || _global).showTabs = /space/i.test(e), (this || _global).showEOL = /eol/i.test(e)) : (this || _global).showSpaces = (this || _global).showTabs = (this || _global).showEOL = e, this.$computeTabString(), !0);
          }, s.prototype.setDisplayIndentGuides = function (e) {
            return (this || _global).displayIndentGuides != e && ((this || _global).displayIndentGuides = e, this.$computeTabString(), !0);
          }, s.prototype.setHighlightIndentGuides = function (e) {
            return (this || _global).$highlightIndentGuides !== e && ((this || _global).$highlightIndentGuides = e);
          }, s.prototype.$computeTabString = function () {
            for (var e, t, n, i, o, r, s = (this || _global).session.getTabSize(), a = ((this || _global).tabSize = s, (this || _global).$tabStrings = [0]), l = 1; l < s + 1; l++) (this || _global).showTabs ? ((r = (this || _global).dom.createElement("span")).className = "ace_invisible ace_invisible_tab", r.textContent = C.stringRepeat((this || _global).TAB_CHAR, l), a.push(r)) : a.push((this || _global).dom.createTextNode(C.stringRepeat(" ", l), (this || _global).element));
            (this || _global).displayIndentGuides && ((this || _global).$indentGuideRe = /\s\S| \t|\t |\s$/, e = "ace_indent-guide", t = (this || _global).showSpaces ? " ace_invisible ace_invisible_space" : "", n = (this || _global).showSpaces ? C.stringRepeat((this || _global).SPACE_CHAR, (this || _global).tabSize) : C.stringRepeat(" ", (this || _global).tabSize), i = (this || _global).showTabs ? " ace_invisible ace_invisible_tab" : "", o = (this || _global).showTabs ? C.stringRepeat((this || _global).TAB_CHAR, (this || _global).tabSize) : n, (r = (this || _global).dom.createElement("span")).className = e + t, r.textContent = n, (this || _global).$tabStrings[" "] = r, (r = (this || _global).dom.createElement("span")).className = e + i, r.textContent = o, (this || _global).$tabStrings["\t"] = r);
          }, s.prototype.updateLines = function (e, t, n) {
            if ((this || _global).config.lastRow != e.lastRow || (this || _global).config.firstRow != e.firstRow) return this.update(e);
            (this || _global).config = e;
            for (var i = Math.max(t, e.firstRow), o = Math.min(n, e.lastRow), r = (this || _global).element.childNodes, s = 0, a = e.firstRow; a < i; a++) {
              if (l = (this || _global).session.getFoldLine(a)) {
                if (l.containsRow(i)) {
                  i = l.start.row;
                  break;
                }
                a = l.end.row;
              }
              s++;
            }
            for (var l, c = !1, a = i, h = (l = (this || _global).session.getNextFoldLine(a)) ? l.start.row : 1 / 0; h < a && (a = l.end.row + 1, h = (l = (this || _global).session.getNextFoldLine(a, l)) ? l.start.row : 1 / 0), !(o < a);) {
              var d,
                u = r[s++];
              u && ((this || _global).dom.removeChildren(u), this.$renderLine(u, a, a == h && l), c && (u.style.top = (this || _global).$lines.computeLineTop(a, e, (this || _global).session) + "px"), d = e.lineHeight * (this || _global).session.getRowLength(a) + "px", u.style.height != d) && (c = !0, u.style.height = d), a++;
            }
            if (c) for (; s < (this || _global).$lines.cells.length;) {
              var g = (this || _global).$lines.cells[s++];
              g.element.style.top = (this || _global).$lines.computeLineTop(g.row, e, (this || _global).session) + "px";
            }
          }, s.prototype.scrollLines = function (e) {
            var t = (this || _global).config;
            if ((this || _global).config = e, (this || _global).$lines.pageChanged(t, e)) return this.update(e);
            (this || _global).$lines.moveContainer(e);
            var n = e.lastRow,
              i = t ? t.lastRow : -1;
            if (!t || i < e.firstRow) return this.update(e);
            if (n < t.firstRow) return this.update(e);
            if (!t || t.lastRow < e.firstRow) return this.update(e);
            if (e.lastRow < t.firstRow) return this.update(e);
            if (t.firstRow < e.firstRow) for (var o = (this || _global).session.getFoldedRowCount(t.firstRow, e.firstRow - 1); 0 < o; o--) (this || _global).$lines.shift();
            if (t.lastRow > e.lastRow) for (o = (this || _global).session.getFoldedRowCount(e.lastRow + 1, t.lastRow); 0 < o; o--) (this || _global).$lines.pop();
            e.firstRow < t.firstRow && (this || _global).$lines.unshift(this.$renderLinesFragment(e, e.firstRow, t.firstRow - 1)), e.lastRow > t.lastRow && (this || _global).$lines.push(this.$renderLinesFragment(e, t.lastRow + 1, e.lastRow)), this.$highlightIndentGuide();
          }, s.prototype.$renderLinesFragment = function (e, t, n) {
            for (var i = [], o = t, r = (this || _global).session.getNextFoldLine(o), s = r ? r.start.row : 1 / 0; s < o && (o = r.end.row + 1, s = (r = (this || _global).session.getNextFoldLine(o, r)) ? r.start.row : 1 / 0), !(n < o);) {
              var a = (this || _global).$lines.createCell(o, e, (this || _global).session),
                l = a.element;
              (this || _global).dom.removeChildren(l), c.setStyle(l.style, "height", (this || _global).$lines.computeLineHeight(o, e, (this || _global).session) + "px"), c.setStyle(l.style, "top", (this || _global).$lines.computeLineTop(o, e, (this || _global).session) + "px"), this.$renderLine(l, o, o == s && r), this.$useLineGroups() ? l.className = "ace_line_group" : l.className = "ace_line", i.push(a), o++;
            }
            return i;
          }, s.prototype.update = function (e) {
            (this || _global).$lines.moveContainer(e);
            for (var t = ((this || _global).config = e).firstRow, n = e.lastRow, i = (this || _global).$lines; i.getLength();) i.pop();
            i.push(this.$renderLinesFragment(e, t, n));
          }, s.prototype.$renderToken = function (e, t, n, i) {
            for (var o, r, s = this || _global, a = /(\t)|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\uFEFF\uFFF9-\uFFFC\u2066\u2067\u2068\u202A\u202B\u202D\u202E\u202C\u2069]+)|(\u3000)|([\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF])/g, l = (this || _global).dom.createFragment((this || _global).element), c = 0; o = a.exec(i);) {
              var h,
                d,
                u = o[1],
                g = o[2],
                p = o[3],
                m = o[4],
                f = o[5];
              !s.showSpaces && g || (h = c != o.index ? i.slice(c, o.index) : "", c = o.index + o[0].length, h && l.appendChild((this || _global).dom.createTextNode(h, (this || _global).element)), u ? (h = s.session.getScreenTabSize(t + o.index), l.appendChild(s.$tabStrings[h].cloneNode(!0)), t += h - 1) : g ? s.showSpaces ? ((d = (this || _global).dom.createElement("span")).className = "ace_invisible ace_invisible_space", d.textContent = C.stringRepeat(s.SPACE_CHAR, g.length), l.appendChild(d)) : l.appendChild((this || _global).com.createTextNode(g, (this || _global).element)) : p ? ((d = (this || _global).dom.createElement("span")).className = "ace_invisible ace_invisible_space ace_invalid", d.textContent = C.stringRepeat(s.SPACE_CHAR, p.length), l.appendChild(d)) : m ? (t += 1, (d = (this || _global).dom.createElement("span")).style.width = 2 * s.config.characterWidth + "px", d.className = s.showSpaces ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk", d.textContent = s.showSpaces ? s.SPACE_CHAR : m, l.appendChild(d)) : f && (t += 1, (d = (this || _global).dom.createElement("span")).style.width = 2 * s.config.characterWidth + "px", d.className = "ace_cjk", d.textContent = f, l.appendChild(d)));
            }
            return l.appendChild((this || _global).dom.createTextNode(c ? i.slice(c) : i, (this || _global).element)), (this || _global).$textToken[n.type] ? e.appendChild(l) : (r = "ace_" + n.type.replace(/\./g, " ace_"), d = (this || _global).dom.createElement("span"), "fold" == n.type && (d.style.width = n.value.length * (this || _global).config.characterWidth + "px", d.setAttribute("title", "Unfold code")), d.className = r, d.appendChild(l), e.appendChild(d)), t + i.length;
          }, s.prototype.renderIndentGuide = function (e, t, n) {
            var i = t.search((this || _global).$indentGuideRe);
            if (!(i <= 0 || n <= i)) {
              if (" " == t[0]) {
                for (var o = (i -= i % (this || _global).tabSize) / (this || _global).tabSize, r = 0; r < o; r++) e.appendChild((this || _global).$tabStrings[" "].cloneNode(!0));
                return this.$highlightIndentGuide(), t.substr(i);
              }
              if ("\t" == t[0]) {
                for (r = 0; r < i; r++) e.appendChild((this || _global).$tabStrings["\t"].cloneNode(!0));
                return this.$highlightIndentGuide(), t.substr(i);
              }
              this.$highlightIndentGuide();
            }
            return t;
          }, s.prototype.$highlightIndentGuide = function () {
            if ((this || _global).$highlightIndentGuides && (this || _global).displayIndentGuides) {
              (this || _global).$highlightIndentGuideMarker = {
                indentLevel: void 0,
                start: void 0,
                end: void 0,
                dir: void 0
              };
              var e = (this || _global).session.doc.$lines;
              if (e) {
                var t = (this || _global).session.selection.getCursor(),
                  n = /^\s*/.exec((this || _global).session.doc.getLine(t.row))[0].length,
                  i = Math.floor(n / (this || _global).tabSize);
                if ((this || _global).$highlightIndentGuideMarker = {
                  indentLevel: i,
                  start: t.row
                }, (this || _global).session.$bracketHighlight) for (var o = (this || _global).session.$bracketHighlight.ranges, r = 0; r < o.length; r++) if (t.row !== o[r].start.row) {
                  (this || _global).$highlightIndentGuideMarker.end = o[r].start.row, t.row > o[r].start.row ? (this || _global).$highlightIndentGuideMarker.dir = -1 : (this || _global).$highlightIndentGuideMarker.dir = 1;
                  break;
                }
                if (!(this || _global).$highlightIndentGuideMarker.end && "" !== e[t.row] && t.column === e[t.row].length) {
                  (this || _global).$highlightIndentGuideMarker.dir = 1;
                  for (r = t.row + 1; r < e.length; r++) {
                    var s = e[r],
                      a = /^\s*/.exec(s)[0].length;
                    if ("" !== s && ((this || _global).$highlightIndentGuideMarker.end = r, a <= n)) break;
                  }
                }
                this.$renderHighlightIndentGuide();
              }
            }
          }, s.prototype.$clearActiveIndentGuide = function () {
            for (var e = (this || _global).$lines.cells, t = 0; t < e.length; t++) {
              var n = e[t].element.childNodes;
              if (0 < n.length) for (var i = 0; i < n.length; i++) if (n[i].classList && n[i].classList.contains("ace_indent-guide-active")) {
                n[i].classList.remove("ace_indent-guide-active");
                break;
              }
            }
          }, s.prototype.$setIndentGuideActive = function (e, t) {
            "" !== (this || _global).session.doc.getLine(e.row) && (e = e.element.childNodes) && (e = e[t - 1]) && e.classList && e.classList.contains("ace_indent-guide") && e.classList.add("ace_indent-guide-active");
          }, s.prototype.$renderHighlightIndentGuide = function () {
            if ((this || _global).$lines) {
              var e = (this || _global).$lines.cells,
                t = (this.$clearActiveIndentGuide(), (this || _global).$highlightIndentGuideMarker.indentLevel);
              if (0 !== t) if (1 === (this || _global).$highlightIndentGuideMarker.dir) for (var n = 0; n < e.length; n++) {
                var i = e[n];
                if ((this || _global).$highlightIndentGuideMarker.end && i.row >= (this || _global).$highlightIndentGuideMarker.start + 1) {
                  if (i.row >= (this || _global).$highlightIndentGuideMarker.end) break;
                  this.$setIndentGuideActive(i, t);
                }
              } else for (n = e.length - 1; 0 <= n; n--) {
                i = e[n];
                if ((this || _global).$highlightIndentGuideMarker.end && i.row < (this || _global).$highlightIndentGuideMarker.start) {
                  if (i.row <= (this || _global).$highlightIndentGuideMarker.end) break;
                  this.$setIndentGuideActive(i, t);
                }
              }
            }
          }, s.prototype.$createLineElement = function (e) {
            var t = (this || _global).dom.createElement("div");
            return t.className = "ace_line", t.style.height = (this || _global).config.lineHeight + "px", t;
          }, s.prototype.$renderWrappedLine = function (e, t, n) {
            var i = 0,
              o = 0,
              r = n[0],
              s = 0,
              a = this.$createLineElement();
            e.appendChild(a);
            for (var l = 0; l < t.length; l++) {
              var c = t[l],
                h = c.value;
              if (0 == l && (this || _global).displayIndentGuides) {
                if (i = h.length, !(h = this.renderIndentGuide(a, h, r))) continue;
                i -= h.length;
              }
              if (i + h.length < r) s = this.$renderToken(a, s, c, h), i += h.length;else {
                for (; i + h.length >= r;) s = this.$renderToken(a, s, c, h.substring(0, r - i)), h = h.substring(r - i), i = r, a = this.$createLineElement(), e.appendChild(a), a.appendChild((this || _global).dom.createTextNode(C.stringRepeat("\xA0", n.indent), (this || _global).element)), s = 0, r = n[++o] || Number.MAX_VALUE;
                0 != h.length && (i += h.length, s = this.$renderToken(a, s, c, h));
              }
            }
            n[n.length - 1] > (this || _global).MAX_LINE_LENGTH && this.$renderOverflowMessage(a, s, null, "", !0);
          }, s.prototype.$renderSimpleLine = function (e, t) {
            for (var n = 0, i = 0; i < t.length; i++) {
              var o = t[i],
                r = o.value;
              if (0 != i || !(this || _global).displayIndentGuides || (r = this.renderIndentGuide(e, r))) {
                if (n + r.length > (this || _global).MAX_LINE_LENGTH) return this.$renderOverflowMessage(e, n, o, r);
                n = this.$renderToken(e, n, o, r);
              }
            }
          }, s.prototype.$renderOverflowMessage = function (e, t, n, i, o) {
            n && this.$renderToken(e, t, n, i.slice(0, (this || _global).MAX_LINE_LENGTH - t));
            n = (this || _global).dom.createElement("span");
            n.className = "ace_inline_button ace_keyword ace_toggle_wrap", n.textContent = o ? "<hide>" : "<click to see more...>", e.appendChild(n);
          }, s.prototype.$renderLine = function (e, t, n) {
            var i,
              o,
              r = e;
            (i = (n = n || 0 == n ? n : (this || _global).session.getFoldLine(t)) ? this.$getFoldLineTokens(t, n) : (this || _global).session.getTokens(t)).length ? (o = (this || _global).session.getRowSplitData(t)) && o.length ? (this.$renderWrappedLine(e, i, o), r = e.lastChild) : (r = e, this.$useLineGroups() && (r = this.$createLineElement(), e.appendChild(r)), this.$renderSimpleLine(r, i)) : this.$useLineGroups() && (r = this.$createLineElement(), e.appendChild(r)), (this || _global).showEOL && r && (n && (t = n.end.row), (o = (this || _global).dom.createElement("span")).className = "ace_invisible ace_invisible_eol", o.textContent = t == (this || _global).session.getLength() - 1 ? (this || _global).EOF_CHAR : (this || _global).EOL_CHAR, r.appendChild(o));
          }, s.prototype.$getFoldLineTokens = function (e, t) {
            var d = (this || _global).session,
              u = [];
            var g = d.getTokens(e);
            return t.walk(function (e, t, n, i, o) {
              if (null != e) u.push({
                type: "fold",
                value: e
              });else if ((g = o ? d.getTokens(t) : g).length) {
                for (var r, s = g, a = i, l = n, c = 0, h = 0; h + s[c].value.length < a;) if (h += s[c].value.length, ++c == s.length) return void !void 0;
                for (h != a && ((r = s[c].value.substring(a - h)).length > l - a && (r = r.substring(0, l - a)), u.push({
                  type: s[c].type,
                  value: r
                }), h = a + r.length, c += 1); h < l && c < s.length;) (r = s[c].value).length + h > l ? u.push({
                  type: s[c].type,
                  value: r.substring(0, l - h)
                }) : u.push(s[c]), h += r.length, c += 1;
              }
            }, t.end.row, (this || _global).session.getLine(t.end.row).length), u;
          }, s.prototype.$useLineGroups = function () {
            return (this || _global).session.getUseWrapMode();
          }, s);
        function s(e) {
          (this || _global).dom = c, (this || _global).element = (this || _global).dom.createElement("div"), (this || _global).element.className = "ace_layer ace_text-layer", e.appendChild((this || _global).element), (this || _global).$updateEolChar = (this || _global).$updateEolChar.bind(this || _global), (this || _global).$lines = new o((this || _global).element);
        }
        r.prototype.$textToken = {
          text: !0,
          rparen: !0,
          lparen: !0
        }, r.prototype.EOF_CHAR = "\xB6", r.prototype.EOL_CHAR_LF = "\xAC", r.prototype.EOL_CHAR_CRLF = "\xA4", r.prototype.EOL_CHAR = r.prototype.EOL_CHAR_LF, r.prototype.TAB_CHAR = "\u2014", r.prototype.SPACE_CHAR = "\xB7", r.prototype.$padding = 0, r.prototype.MAX_LINE_LENGTH = 10000, r.prototype.showInvisibles = !1, r.prototype.showSpaces = !1, r.prototype.showTabs = !1, r.prototype.showEOL = !1, r.prototype.displayIndentGuides = !0, r.prototype.$highlightIndentGuides = !0, r.prototype.$tabStrings = [], r.prototype.destroy = {}, r.prototype.onChangeTabSize = r.prototype.$computeTabString, i.implement(r.prototype, e), t.Text = r;
      }), ace.define("ace/layer/cursor", ["require", "exports", "module", "ace/lib/dom"], function (e, t, n) {
        "use strict";

        var c = e("../lib/dom"),
          e = (i.prototype.$updateOpacity = function (e) {
            for (var t = (this || _global).cursors, n = t.length; n--;) c.setStyle(t[n].style, "opacity", e ? "" : "0");
          }, i.prototype.$startCssAnimation = function () {
            for (var e = (this || _global).cursors, t = e.length; t--;) e[t].style.animationDuration = (this || _global).blinkInterval + "ms";
            (this || _global).$isAnimating = !0, setTimeout(function () {
              (this || _global).$isAnimating && c.addCssClass((this || _global).element, "ace_animate-blinking");
            }.bind(this || _global));
          }, i.prototype.$stopCssAnimation = function () {
            (this || _global).$isAnimating = !1, c.removeCssClass((this || _global).element, "ace_animate-blinking");
          }, i.prototype.setPadding = function (e) {
            (this || _global).$padding = e;
          }, i.prototype.setSession = function (e) {
            (this || _global).session = e;
          }, i.prototype.setBlinking = function (e) {
            e != (this || _global).isBlinking && ((this || _global).isBlinking = e, this.restartTimer());
          }, i.prototype.setBlinkInterval = function (e) {
            e != (this || _global).blinkInterval && ((this || _global).blinkInterval = e, this.restartTimer());
          }, i.prototype.setSmoothBlinking = function (e) {
            e != (this || _global).smoothBlinking && ((this || _global).smoothBlinking = e, c.setCssClass((this || _global).element, "ace_smooth-blinking", e), this.$updateCursors(!0), this.restartTimer());
          }, i.prototype.addCursor = function () {
            var e = c.createElement("div");
            return e.className = "ace_cursor", (this || _global).element.appendChild(e), (this || _global).cursors.push(e), e;
          }, i.prototype.removeCursor = function () {
            var e;
            if (1 < (this || _global).cursors.length) return (e = (this || _global).cursors.pop()).parentNode.removeChild(e), e;
          }, i.prototype.hideCursor = function () {
            (this || _global).isVisible = !1, c.addCssClass((this || _global).element, "ace_hidden-cursors"), this.restartTimer();
          }, i.prototype.showCursor = function () {
            (this || _global).isVisible = !0, c.removeCssClass((this || _global).element, "ace_hidden-cursors"), this.restartTimer();
          }, i.prototype.restartTimer = function () {
            var e,
              t = (this || _global).$updateCursors;
            clearInterval((this || _global).intervalId), clearTimeout((this || _global).timeoutId), this.$stopCssAnimation(), (this || _global).smoothBlinking && ((this || _global).$isSmoothBlinking = !1, c.removeCssClass((this || _global).element, "ace_smooth-blinking")), t(!0), (this || _global).isBlinking && (this || _global).blinkInterval && (this || _global).isVisible ? ((this || _global).smoothBlinking && ((this || _global).$isSmoothBlinking = !0, setTimeout(function () {
              (this || _global).$isSmoothBlinking && c.addCssClass((this || _global).element, "ace_smooth-blinking");
            }.bind(this || _global))), c.HAS_CSS_ANIMATION ? this.$startCssAnimation() : (e = function () {
              (this || _global).timeoutId = setTimeout(function () {
                t(!1);
              }, 0.6 * (this || _global).blinkInterval);
            }.bind(this || _global), (this || _global).intervalId = setInterval(function () {
              t(!0), e();
            }, (this || _global).blinkInterval), e())) : this.$stopCssAnimation();
          }, i.prototype.getPixelPosition = function (e, t) {
            if (!(this || _global).config || !(this || _global).session) return {
              left: 0,
              top: 0
            };
            e = e || (this || _global).session.selection.getCursor();
            var n = (this || _global).session.documentToScreenPosition(e);
            return {
              left: (this || _global).$padding + ((this || _global).session.$bidiHandler.isBidiRow(n.row, e.row) ? (this || _global).session.$bidiHandler.getPosLeft(n.column) : n.column * (this || _global).config.characterWidth),
              top: (n.row - (t ? (this || _global).config.firstRowScreen : 0)) * (this || _global).config.lineHeight
            };
          }, i.prototype.isCursorInView = function (e, t) {
            return 0 <= e.top && e.top < t.maxHeight;
          }, i.prototype.update = function (e) {
            (this || _global).config = e;
            for (var t = (this || _global).session.$selectionMarkers, n = 0, i = 0, n = 0, o = (t = void 0 !== t && 0 !== t.length ? t : [{
                cursor: null
              }]).length; n < o; n++) {
              var r,
                s,
                a = this.getPixelPosition(t[n].cursor, !0);
              (a.top > e.height + e.offset || a.top < 0) && 1 < n || (s = (r = (this || _global).cursors[i++] || this.addCursor()).style, (this || _global).drawCursor ? this.drawCursor(r, a, e, t[n], (this || _global).session) : this.isCursorInView(a, e) ? (c.setStyle(s, "display", "block"), c.translate(r, a.left, a.top), c.setStyle(s, "width", Math.round(e.characterWidth) + "px"), c.setStyle(s, "height", e.lineHeight + "px")) : c.setStyle(s, "display", "none"));
            }
            for (; (this || _global).cursors.length > i;) this.removeCursor();
            var l = (this || _global).session.getOverwrite();
            this.$setOverwrite(l), (this || _global).$pixelPos = a, this.restartTimer();
          }, i.prototype.$setOverwrite = function (e) {
            e != (this || _global).overwrite && (((this || _global).overwrite = e) ? c.addCssClass((this || _global).element, "ace_overwrite-cursors") : c.removeCssClass((this || _global).element, "ace_overwrite-cursors"));
          }, i.prototype.destroy = function () {
            clearInterval((this || _global).intervalId), clearTimeout((this || _global).timeoutId);
          }, i);
        function i(e) {
          (this || _global).element = c.createElement("div"), (this || _global).element.className = "ace_layer ace_cursor-layer", e.appendChild((this || _global).element), (this || _global).isVisible = !1, (this || _global).isBlinking = !0, (this || _global).blinkInterval = 1000, (this || _global).smoothBlinking = !1, (this || _global).cursors = [], (this || _global).cursor = this.addCursor(), c.addCssClass((this || _global).element, "ace_hidden-cursors"), (this || _global).$updateCursors = (this || _global).$updateOpacity.bind(this || _global);
        }
        e.prototype.$padding = 0, e.prototype.drawCursor = null, t.Cursor = e;
      }), ace.define("ace/scrollbar", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/lib/event", "ace/lib/event_emitter"], function (e, t, n) {
        "use strict";

        var i,
          o = (this || _global) && (this || _global).__extends || (i = function (e, t) {
            return (i = Object.setPrototypeOf || ({
              __proto__: []
            } instanceof Array ? function (e, t) {
              e.__proto__ = t;
            } : function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }))(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              (this || _global).constructor = e;
            }
            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          r = e("./lib/oop"),
          s = e("./lib/dom"),
          a = e("./lib/event"),
          e = e("./lib/event_emitter").EventEmitter,
          l = (c.prototype.setVisible = function (e) {
            (this || _global).element.style.display = e ? "" : "none", (this || _global).isVisible = e, (this || _global).coeff = 1;
          }, c);
        function c(e, t) {
          (this || _global).element = s.createElement("div"), (this || _global).element.className = "ace_scrollbar ace_scrollbar" + t, (this || _global).inner = s.createElement("div"), (this || _global).inner.className = "ace_scrollbar-inner", (this || _global).inner.textContent = "\xA0", (this || _global).element.appendChild((this || _global).inner), e.appendChild((this || _global).element), this.setVisible(!1), (this || _global).skipEvent = !1, a.addListener((this || _global).element, "scroll", (this || _global).onScroll.bind(this || _global)), a.addListener((this || _global).element, "mousedown", a.preventDefault);
        }
        r.implement(l.prototype, e);
        o(d, h = l), d.prototype.onScroll = function () {
          var e;
          (this || _global).skipEvent || ((this || _global).scrollTop = (this || _global).element.scrollTop, 1 != (this || _global).coeff && (e = (this || _global).element.clientHeight / (this || _global).scrollHeight, (this || _global).scrollTop = (this || _global).scrollTop * (1 - e) / ((this || _global).coeff - e)), this._emit("scroll", {
            data: (this || _global).scrollTop
          })), (this || _global).skipEvent = !1;
        }, d.prototype.getWidth = function () {
          return Math.max((this || _global).isVisible ? (this || _global).width : 0, (this || _global).$minWidth || 0);
        }, d.prototype.setHeight = function (e) {
          (this || _global).element.style.height = e + "px";
        }, d.prototype.setScrollHeight = function (e) {
          32768 < ((this || _global).scrollHeight = e) ? ((this || _global).coeff = 32768 / e, e = 32768) : 1 != (this || _global).coeff && ((this || _global).coeff = 1), (this || _global).inner.style.height = e + "px";
        }, d.prototype.setScrollTop = function (e) {
          (this || _global).scrollTop != e && ((this || _global).skipEvent = !0, (this || _global).scrollTop = e, (this || _global).element.scrollTop = e * (this || _global).coeff);
        };
        var h,
          r = d;
        function d(e, t) {
          var n = h.call(this || _global, e, "-v") || this || _global;
          return n.scrollTop = 0, n.scrollHeight = 0, t.$scrollbarWidth = n.width = s.scrollbarWidth(e.ownerDocument), n.inner.style.width = n.element.style.width = (n.width || 15) + 5 + "px", n.$minWidth = 0, n;
        }
        r.prototype.setInnerHeight = r.prototype.setScrollHeight;
        o(g, u = l), g.prototype.onScroll = function () {
          (this || _global).skipEvent || ((this || _global).scrollLeft = (this || _global).element.scrollLeft, this._emit("scroll", {
            data: (this || _global).scrollLeft
          })), (this || _global).skipEvent = !1;
        }, g.prototype.getHeight = function () {
          return (this || _global).isVisible ? (this || _global).height : 0;
        }, g.prototype.setWidth = function (e) {
          (this || _global).element.style.width = e + "px";
        }, g.prototype.setInnerWidth = function (e) {
          (this || _global).inner.style.width = e + "px";
        }, g.prototype.setScrollWidth = function (e) {
          (this || _global).inner.style.width = e + "px";
        }, g.prototype.setScrollLeft = function (e) {
          (this || _global).scrollLeft != e && ((this || _global).skipEvent = !0, (this || _global).scrollLeft = (this || _global).element.scrollLeft = e);
        };
        var u,
          e = g;
        function g(e, t) {
          e = u.call(this || _global, e, "-h") || this || _global;
          return e.scrollLeft = 0, e.height = t.$scrollbarWidth, e.inner.style.height = e.element.style.height = (e.height || 15) + 5 + "px", e;
        }
        t.ScrollBar = r, t.ScrollBarV = r, t.ScrollBarH = e, t.VScrollBar = r, t.HScrollBar = e;
      }), ace.define("ace/scrollbar_custom", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/lib/event", "ace/lib/event_emitter"], function (e, t, n) {
        "use strict";

        var i,
          o = (this || _global) && (this || _global).__extends || (i = function (e, t) {
            return (i = Object.setPrototypeOf || ({
              __proto__: []
            } instanceof Array ? function (e, t) {
              e.__proto__ = t;
            } : function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }))(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              (this || _global).constructor = e;
            }
            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          r = e("./lib/oop"),
          s = e("./lib/dom"),
          a = e("./lib/event"),
          e = e("./lib/event_emitter").EventEmitter,
          l = (s.importCssString(".ace_editor>.ace_sb-v div, .ace_editor>.ace_sb-h div{\n  position: absolute;\n  background: rgba(128, 128, 128, 0.6);\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #bbb;\n  border-radius: 2px;\n  z-index: 8;\n}\n.ace_editor>.ace_sb-v, .ace_editor>.ace_sb-h {\n  position: absolute;\n  z-index: 6;\n  background: none;\n  overflow: hidden!important;\n}\n.ace_editor>.ace_sb-v {\n  z-index: 6;\n  right: 0;\n  top: 0;\n  width: 12px;\n}\n.ace_editor>.ace_sb-v div {\n  z-index: 8;\n  right: 0;\n  width: 100%;\n}\n.ace_editor>.ace_sb-h {\n  bottom: 0;\n  left: 0;\n  height: 12px;\n}\n.ace_editor>.ace_sb-h div {\n  bottom: 0;\n  height: 100%;\n}\n.ace_editor>.ace_sb_grabbed {\n  z-index: 8;\n  background: #000;\n}", "ace_scrollbar.css", !1), c.prototype.setVisible = function (e) {
            (this || _global).element.style.display = e ? "" : "none", (this || _global).isVisible = e, (this || _global).coeff = 1;
          }, c);
        function c(e, t) {
          (this || _global).element = s.createElement("div"), (this || _global).element.className = "ace_sb" + t, (this || _global).inner = s.createElement("div"), (this || _global).inner.className = "", (this || _global).element.appendChild((this || _global).inner), (this || _global).VScrollWidth = 12, (this || _global).HScrollHeight = 12, e.appendChild((this || _global).element), this.setVisible(!1), (this || _global).skipEvent = !1, a.addMultiMouseDownListener((this || _global).element, [500, 300, 300], this || _global, "onMouseDown");
        }
        r.implement(l.prototype, e);
        o(d, h = l), d.prototype.onMouseDown = function (e, t) {
          var n, i, o, r, s;
          if ("mousedown" === e && 0 === a.getButton(t) && 2 !== t.detail) return t.target === (this || _global).inner ? (n = this || _global, i = t.clientY, o = t.clientY, r = (this || _global).thumbTop, a.capture((this || _global).inner, function (e) {
            i = e.clientY;
          }, function () {
            clearInterval(s);
          }), s = setInterval(function () {
            var e;
            void 0 !== i && (e = n.scrollTopFromThumbTop(r + i - o)) !== n.scrollTop && n._emit("scroll", {
              data: e
            });
          }, 20)) : (e = t.clientY - (this || _global).element.getBoundingClientRect().top - (this || _global).thumbHeight / 2, this._emit("scroll", {
            data: this.scrollTopFromThumbTop(e)
          })), a.preventDefault(t);
        }, d.prototype.getHeight = function () {
          return (this || _global).height;
        }, d.prototype.scrollTopFromThumbTop = function (e) {
          e = e * ((this || _global).pageHeight - (this || _global).viewHeight) / ((this || _global).slideHeight - (this || _global).thumbHeight);
          return (e >>= 0) < 0 ? e = 0 : e > (this || _global).pageHeight - (this || _global).viewHeight && (e = (this || _global).pageHeight - (this || _global).viewHeight), e;
        }, d.prototype.getWidth = function () {
          return Math.max((this || _global).isVisible ? (this || _global).width : 0, (this || _global).$minWidth || 0);
        }, d.prototype.setHeight = function (e) {
          (this || _global).height = Math.max(0, e), (this || _global).slideHeight = (this || _global).height, (this || _global).viewHeight = (this || _global).height, this.setScrollHeight((this || _global).pageHeight, !0);
        }, d.prototype.setScrollHeight = function (e, t) {
          ((this || _global).pageHeight !== e || t) && ((this || _global).pageHeight = e, (this || _global).thumbHeight = (this || _global).slideHeight * (this || _global).viewHeight / (this || _global).pageHeight, (this || _global).thumbHeight > (this || _global).slideHeight && ((this || _global).thumbHeight = (this || _global).slideHeight), (this || _global).thumbHeight < 15 && ((this || _global).thumbHeight = 15), (this || _global).inner.style.height = (this || _global).thumbHeight + "px", (this || _global).scrollTop > (this || _global).pageHeight - (this || _global).viewHeight) && ((this || _global).scrollTop = (this || _global).pageHeight - (this || _global).viewHeight, (this || _global).scrollTop < 0 && ((this || _global).scrollTop = 0), this._emit("scroll", {
            data: (this || _global).scrollTop
          }));
        }, d.prototype.setScrollTop = function (e) {
          (this || _global).scrollTop = e, (this || _global).thumbTop = (e = e < 0 ? 0 : e) * ((this || _global).slideHeight - (this || _global).thumbHeight) / ((this || _global).pageHeight - (this || _global).viewHeight), (this || _global).inner.style.top = (this || _global).thumbTop + "px";
        };
        var h,
          r = d;
        function d(e, t) {
          var n = h.call(this || _global, e, "-v") || this || _global;
          return n.scrollTop = 0, n.scrollHeight = 0, n.parent = e, n.width = n.VScrollWidth, n.renderer = t, n.inner.style.width = n.element.style.width = (n.width || 15) + "px", n.$minWidth = 0, n;
        }
        r.prototype.setInnerHeight = r.prototype.setScrollHeight;
        o(g, u = l), g.prototype.onMouseDown = function (e, t) {
          var n, i, o, r, s;
          if ("mousedown" === e && 0 === a.getButton(t) && 2 !== t.detail) return t.target === (this || _global).inner ? (n = this || _global, i = t.clientX, o = t.clientX, r = (this || _global).thumbLeft, a.capture((this || _global).inner, function (e) {
            i = e.clientX;
          }, function () {
            clearInterval(s);
          }), s = setInterval(function () {
            var e;
            void 0 !== i && (e = n.scrollLeftFromThumbLeft(r + i - o)) !== n.scrollLeft && n._emit("scroll", {
              data: e
            });
          }, 20)) : (e = t.clientX - (this || _global).element.getBoundingClientRect().left - (this || _global).thumbWidth / 2, this._emit("scroll", {
            data: this.scrollLeftFromThumbLeft(e)
          })), a.preventDefault(t);
        }, g.prototype.getHeight = function () {
          return (this || _global).isVisible ? (this || _global).height : 0;
        }, g.prototype.scrollLeftFromThumbLeft = function (e) {
          e = e * ((this || _global).pageWidth - (this || _global).viewWidth) / ((this || _global).slideWidth - (this || _global).thumbWidth);
          return (e >>= 0) < 0 ? e = 0 : e > (this || _global).pageWidth - (this || _global).viewWidth && (e = (this || _global).pageWidth - (this || _global).viewWidth), e;
        }, g.prototype.setWidth = function (e) {
          (this || _global).width = Math.max(0, e), (this || _global).element.style.width = (this || _global).width + "px", (this || _global).slideWidth = (this || _global).width, (this || _global).viewWidth = (this || _global).width, this.setScrollWidth((this || _global).pageWidth, !0);
        }, g.prototype.setScrollWidth = function (e, t) {
          ((this || _global).pageWidth !== e || t) && ((this || _global).pageWidth = e, (this || _global).thumbWidth = (this || _global).slideWidth * (this || _global).viewWidth / (this || _global).pageWidth, (this || _global).thumbWidth > (this || _global).slideWidth && ((this || _global).thumbWidth = (this || _global).slideWidth), (this || _global).thumbWidth < 15 && ((this || _global).thumbWidth = 15), (this || _global).inner.style.width = (this || _global).thumbWidth + "px", (this || _global).scrollLeft > (this || _global).pageWidth - (this || _global).viewWidth) && ((this || _global).scrollLeft = (this || _global).pageWidth - (this || _global).viewWidth, (this || _global).scrollLeft < 0 && ((this || _global).scrollLeft = 0), this._emit("scroll", {
            data: (this || _global).scrollLeft
          }));
        }, g.prototype.setScrollLeft = function (e) {
          (this || _global).scrollLeft = e, (this || _global).thumbLeft = (e = e < 0 ? 0 : e) * ((this || _global).slideWidth - (this || _global).thumbWidth) / ((this || _global).pageWidth - (this || _global).viewWidth), (this || _global).inner.style.left = (this || _global).thumbLeft + "px";
        };
        var u,
          e = g;
        function g(e, t) {
          e = u.call(this || _global, e, "-h") || this || _global;
          return e.scrollLeft = 0, e.scrollWidth = 0, e.height = e.HScrollHeight, e.inner.style.height = e.element.style.height = (e.height || 12) + "px", e.renderer = t, e;
        }
        e.prototype.setInnerWidth = e.prototype.setScrollWidth, t.ScrollBar = r, t.ScrollBarV = r, t.ScrollBarH = e, t.VScrollBar = r, t.HScrollBar = e;
      }), ace.define("ace/renderloop", ["require", "exports", "module", "ace/lib/event"], function (e, t, n) {
        "use strict";

        var i = e("./lib/event");
        function o(e, t) {
          (this || _global).onRender = e, (this || _global).pending = !1, (this || _global).changes = 0, (this || _global).$recursionLimit = 2, (this || _global).window = t || window;
          var n = this || _global;
          (this || _global)._flush = function (e) {
            n.pending = !1;
            var t = n.changes;
            t && (i.blockIdle(100), n.changes = 0, n.onRender(t)), n.changes ? n.$recursionLimit-- < 0 || n.schedule() : n.$recursionLimit = 2;
          };
        }
        o.prototype.schedule = function (e) {
          (this || _global).changes = (this || _global).changes | e, (this || _global).changes && !(this || _global).pending && (i.nextFrame((this || _global)._flush), (this || _global).pending = !0);
        }, o.prototype.clear = function (e) {
          var t = (this || _global).changes;
          return (this || _global).changes = 0, t;
        }, t.RenderLoop = o;
      }), ace.define("ace/layer/font_metrics", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/lib/lang", "ace/lib/event", "ace/lib/useragent", "ace/lib/event_emitter"], function (e, t, n) {
        var i = e("../lib/oop"),
          o = e("../lib/dom"),
          r = e("../lib/lang"),
          s = e("../lib/event"),
          a = e("../lib/useragent"),
          e = e("../lib/event_emitter").EventEmitter,
          l = "function" == typeof ResizeObserver,
          c = (h.prototype.$setMeasureNodeStyles = function (e, t) {
            e.width = e.height = "auto", e.left = e.top = "0px", e.visibility = "hidden", e.position = "absolute", e.whiteSpace = "pre", a.isIE < 8 ? e["font-family"] = "inherit" : e.font = "inherit", e.overflow = t ? "hidden" : "visible";
          }, h.prototype.checkForSizeChanges = function (e) {
            var t;
            !(e = void 0 === e ? this.$measureSizes() : e) || (this || _global).$characterSize.width === e.width && (this || _global).$characterSize.height === e.height || ((this || _global).$measureNode.style.fontWeight = "bold", t = this.$measureSizes(), (this || _global).$measureNode.style.fontWeight = "", (this || _global).$characterSize = e, (this || _global).charSizes = Object.create(null), (this || _global).allowBoldFonts = t && t.width === e.width && t.height === e.height, this._emit("changeCharacterSize", {
              data: e
            }));
          }, h.prototype.$addObserver = function () {
            var t = this || _global;
            (this || _global).$observer = new window.ResizeObserver(function (e) {
              t.checkForSizeChanges();
            }), (this || _global).$observer.observe((this || _global).$measureNode);
          }, h.prototype.$pollSizeChanges = function () {
            var t;
            return (this || _global).$pollSizeChangesTimer || (this || _global).$observer ? (this || _global).$pollSizeChangesTimer : (t = this || _global).$pollSizeChangesTimer = s.onIdle(function e() {
              t.checkForSizeChanges(), s.onIdle(e, 500);
            }, 500);
          }, h.prototype.setPolling = function (e) {
            e ? this.$pollSizeChanges() : (this || _global).$pollSizeChangesTimer && (clearInterval((this || _global).$pollSizeChangesTimer), (this || _global).$pollSizeChangesTimer = 0);
          }, h.prototype.$measureSizes = function (e) {
            e = {
              height: (e || (this || _global).$measureNode).clientHeight,
              width: (e || (this || _global).$measureNode).clientWidth / 512
            };
            return 0 === e.width || 0 === e.height ? null : e;
          }, h.prototype.$measureCharWidth = function (e) {
            return (this || _global).$main.textContent = r.stringRepeat(e, 512), (this || _global).$main.getBoundingClientRect().width / 512;
          }, h.prototype.getCharacterWidth = function (e) {
            var t = (this || _global).charSizes[e];
            return t = void 0 === t ? (this || _global).charSizes[e] = this.$measureCharWidth(e) / (this || _global).$characterSize.width : t;
          }, h.prototype.destroy = function () {
            clearInterval((this || _global).$pollSizeChangesTimer), (this || _global).$observer && (this || _global).$observer.disconnect(), (this || _global).el && (this || _global).el.parentNode && (this || _global).el.parentNode.removeChild((this || _global).el);
          }, h.prototype.$getZoom = function (e) {
            return e && e.parentElement ? (window.getComputedStyle(e).zoom || 1) * this.$getZoom(e.parentElement) : 1;
          }, h.prototype.$initTransformMeasureNodes = function () {
            function e(e, t) {
              return ["div", {
                style: "position: absolute;top:" + e + "px;left:" + t + "px;"
              }];
            }
            (this || _global).els = o.buildDom([e(0, 0), e(200, 0), e(0, 200), e(200, 200)], (this || _global).el);
          }, h.prototype.transformCoordinates = function (e, t) {
            function n(e, t, n) {
              var i = e[1] * t[0] - e[0] * t[1];
              return [(-t[1] * n[0] + t[0] * n[1]) / i, (+e[1] * n[0] - e[0] * n[1]) / i];
            }
            function i(e, t) {
              return [e[0] - t[0], e[1] - t[1]];
            }
            function o(e, t) {
              return [e[0] + t[0], e[1] + t[1]];
            }
            function r(e, t) {
              return [e * t[0], e * t[1]];
            }
            function s(e) {
              e = e.getBoundingClientRect();
              return [e.left, e.top];
            }
            e = e && r(1 / this.$getZoom((this || _global).el), e), (this || _global).els || this.$initTransformMeasureNodes();
            var a,
              l = s((this || _global).els[0]),
              c = s((this || _global).els[1]),
              h = s((this || _global).els[2]),
              d = s((this || _global).els[3]),
              d = n(i(d, c), i(d, h), i(o(c, h), o(d, l))),
              c = r(1 + d[0], i(c, l)),
              h = r(1 + d[1], i(h, l));
            return t ? (a = d[0] * t[0] / 200 + d[1] * t[1] / 200 + 1, t = o(r(t[0], c), r(t[1], h)), o(r(1 / a / 200, t), l)) : (a = i(e, l), t = n(i(c, r(d[0], a)), i(h, r(d[1], a)), a), r(200, t));
          }, h);
        function h(e) {
          (this || _global).el = o.createElement("div"), this.$setMeasureNodeStyles((this || _global).el.style, !0), (this || _global).$main = o.createElement("div"), this.$setMeasureNodeStyles((this || _global).$main.style), (this || _global).$measureNode = o.createElement("div"), this.$setMeasureNodeStyles((this || _global).$measureNode.style), (this || _global).el.appendChild((this || _global).$main), (this || _global).el.appendChild((this || _global).$measureNode), e.appendChild((this || _global).el), (this || _global).$measureNode.textContent = r.stringRepeat("X", 512), (this || _global).$characterSize = {
            width: 0,
            height: 0
          }, l ? this.$addObserver() : this.checkForSizeChanges();
        }
        c.prototype.$characterSize = {
          width: 0,
          height: 0
        }, i.implement(c.prototype, e), t.FontMetrics = c;
      }), ace.define("ace/css/editor.css", ["require", "exports", "module"], function (e, t, n) {
        n.exports = "\n.ace_br1 {border-top-left-radius    : 3px;}\n.ace_br2 {border-top-right-radius   : 3px;}\n.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\n.ace_br4 {border-bottom-right-radius: 3px;}\n.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\n.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\n.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\n.ace_br8 {border-bottom-left-radius : 3px;}\n.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\n.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\n.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\n.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\n\n\n.ace_editor {\n    position: relative;\n    overflow: hidden;\n    padding: 0;\n    font: 12px/normal 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'Source Code Pro', 'source-code-pro', monospace;\n    direction: ltr;\n    text-align: left;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.ace_scroller {\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    bottom: 0;\n    background-color: inherit;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: text;\n}\n\n.ace_content {\n    position: absolute;\n    box-sizing: border-box;\n    min-width: 100%;\n    contain: style size layout;\n    font-variant-ligatures: no-common-ligatures;\n}\n\n.ace_keyboard-focus:focus {\n    box-shadow: inset 0 0 0 2px #5E9ED6;\n    outline: none;\n}\n\n.ace_dragging .ace_scroller:before{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: '';\n    background: rgba(250, 250, 250, 0.01);\n    z-index: 1000;\n}\n.ace_dragging.ace_dark .ace_scroller:before{\n    background: rgba(0, 0, 0, 0.01);\n}\n\n.ace_gutter {\n    position: absolute;\n    overflow : hidden;\n    width: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    cursor: default;\n    z-index: 4;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    contain: style size layout;\n}\n\n.ace_gutter-active-line {\n    position: absolute;\n    left: 0;\n    right: 0;\n}\n\n.ace_scroller.ace_scroll-left:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\n    pointer-events: none;\n}\n\n.ace_gutter-cell, .ace_gutter-cell_svg-icons {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding-left: 19px;\n    padding-right: 6px;\n    background-repeat: no-repeat;\n}\n\n.ace_gutter-cell_svg-icons .ace_gutter_annotation {\n    margin-left: -14px;\n    float: left;\n}\n\n.ace_gutter-cell .ace_gutter_annotation {\n    margin-left: -19px;\n    float: left;\n}\n\n.ace_gutter-cell.ace_error, .ace_icon.ace_error, .ace_icon.ace_error_fold {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==\");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_warning, .ace_icon.ace_warning, .ace_icon.ace_warning_fold {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==\");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_info, .ace_icon.ace_info {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=\");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n.ace_dark .ace_gutter-cell.ace_info, .ace_dark .ace_icon.ace_info {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC\");\n}\n\n.ace_icon_svg.ace_error {\n    -webkit-mask-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJyZWQiIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIj4KPGNpcmNsZSBmaWxsPSJub25lIiBjeD0iOCIgY3k9IjgiIHI9IjciIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjExIiB5MT0iNSIgeDI9IjUiIHkyPSIxMSIvPgo8bGluZSB4MT0iMTEiIHkxPSIxMSIgeDI9IjUiIHkyPSI1Ii8+CjwvZz4KPC9zdmc+\");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning {\n    -webkit-mask-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJkYXJrb3JhbmdlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+Cjxwb2x5Z29uIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGZpbGw9Im5vbmUiIHBvaW50cz0iOCAxIDE1IDE1IDEgMTUgOCAxIi8+CjxyZWN0IHg9IjgiIHk9IjEyIiB3aWR0aD0iMC4wMSIgaGVpZ2h0PSIwLjAxIi8+CjxsaW5lIHgxPSI4IiB5MT0iNiIgeDI9IjgiIHkyPSIxMCIvPgo8L2c+Cjwvc3ZnPg==\");\n    background-color: darkorange;\n}\n.ace_icon_svg.ace_info {\n    -webkit-mask-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJibHVlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CjxjaXJjbGUgZmlsbD0ibm9uZSIgY3g9IjgiIGN5PSI4IiByPSI3IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjxwb2x5bGluZSBwb2ludHM9IjggMTEgOCA4Ii8+Cjxwb2x5bGluZSBwb2ludHM9IjkgOCA2IDgiLz4KPGxpbmUgeDE9IjEwIiB5MT0iMTEiIHgyPSI2IiB5Mj0iMTEiLz4KPHJlY3QgeD0iOCIgeT0iNSIgd2lkdGg9IjAuMDEiIGhlaWdodD0iMC4wMSIvPgo8L2c+Cjwvc3ZnPg==\");\n    background-color: royalblue;\n}\n\n.ace_icon_svg.ace_error_fold {\n    -webkit-mask-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0ibSAxOC45Mjk4NTEsNy44Mjk4MDc2IGMgMC4xNDYzNTMsNi4zMzc0NjA0IC02LjMyMzE0Nyw3Ljc3Nzg0NDQgLTcuNDc3OTEyLDcuNzc3ODQ0NCAtMi4xMDcyNzI2LC0wLjEyODc1IDUuMTE3Njc4LDAuMzU2MjQ5IDUuMDUxNjk4LC03Ljg3MDA2MTggLTAuNjA0NjcyLC04LjAwMzk3MzQ5IC03LjA3NzI3MDYsLTcuNTYzMTE4OSAtNC44NTczLC03LjQzMDM5NTU2IDEuNjA2LC0wLjExNTE0MjI1IDYuODk3NDg1LDEuMjYyNTQ1OTYgNy4yODM1MTQsNy41MjI2MTI5NiB6IiBmaWxsPSJjcmltc29uIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibSA4LjExNDc1NjIsMi4wNTI5ODI4IGMgMy4zNDkxNjk4LDAgNi4wNjQxMzI4LDIuNjc2ODYyNyA2LjA2NDEzMjgsNS45Nzg5NTMgMCwzLjMwMjExMjIgLTIuNzE0OTYzLDUuOTc4OTIwMiAtNi4wNjQxMzI4LDUuOTc4OTIwMiAtMy4zNDkxNDczLDAgLTYuMDY0MTc3MiwtMi42NzY4MDggLTYuMDY0MTc3MiwtNS45Nzg5MjAyIDAuMDA1MzksLTMuMjk5ODg2MSAyLjcxNzI2NTYsLTUuOTczNjQwOCA2LjA2NDE3NzIsLTUuOTc4OTUzIHogbSAwLC0xLjczNTgyNzE5IGMgLTQuMzIxNDgzNiwwIC03LjgyNDc0MDM4LDMuNDU0MDE4NDkgLTcuODI0NzQwMzgsNy43MTQ3ODAxOSAwLDQuMjYwNzI4MiAzLjUwMzI1Njc4LDcuNzE0NzQ1MiA3LjgyNDc0MDM4LDcuNzE0NzQ1MiA0LjMyMTQ0OTgsMCA3LjgyNDY5OTgsLTMuNDU0MDE3IDcuODI0Njk5OCwtNy43MTQ3NDUyIDAsLTIuMDQ2MDkxNCAtMC44MjQzOTIsLTQuMDA4MzY3MiAtMi4yOTE3NTYsLTUuNDU1MTc0NiBDIDEyLjE4MDIyNSwxLjEyOTk2NDggMTAuMTkwMDEzLDAuMzE3MTU1NjEgOC4xMTQ3NTYyLDAuMzE3MTU1NjEgWiBNIDYuOTM3NDU2Myw4LjI0MDU5ODUgNC42NzE4Njg1LDEwLjQ4NTg1MiA2LjAwODY4MTQsMTEuODc2NzI4IDguMzE3MDAzNSw5LjYwMDc5MTEgMTAuNjI1MzM3LDExLjg3NjcyOCAxMS45NjIxMzgsMTAuNDg1ODUyIDkuNjk2NTUwOCw4LjI0MDU5ODUgMTEuOTYyMTM4LDYuMDA2ODA2NiAxMC41NzMyNDYsNC42Mzc0MzM1IDguMzE3MDAzNSw2Ljg3MzQyOTcgNi4wNjA3NjA3LDQuNjM3NDMzNSA0LjY3MTg2ODUsNi4wMDY4MDY2IFoiIGZpbGw9ImNyaW1zb24iIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4=\");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning_fold {\n    -webkit-mask-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43NzY5IDE0LjczMzdMOC42NTE5MiAyLjQ4MzY5QzguMzI5NDYgMS44Mzg3NyA3LjQwOTEzIDEuODM4NzcgNy4wODY2NyAyLjQ4MzY5TDAuOTYxNjY5IDE0LjczMzdDMC42NzA3NzUgMTUuMzE1NSAxLjA5MzgzIDE2IDEuNzQ0MjkgMTZIMTMuOTk0M0MxNC42NDQ4IDE2IDE1LjA2NzggMTUuMzE1NSAxNC43NzY5IDE0LjczMzdaTTMuMTYwMDcgMTQuMjVMNy44NjkyOSA0LjgzMTU2TDEyLjU3ODUgMTQuMjVIMy4xNjAwN1pNOC43NDQyOSAxMS42MjVWMTMuMzc1SDYuOTk0MjlWMTEuNjI1SDguNzQ0MjlaTTYuOTk0MjkgMTAuNzVWNy4yNUg4Ljc0NDI5VjEwLjc1SDYuOTk0MjlaIiBmaWxsPSIjRUM3MjExIi8+CjxwYXRoIGQ9Ik0xMS4xOTkxIDIuOTUyMzhDMTAuODgwOSAyLjMxNDY3IDEwLjM1MzcgMS44MDUyNiA5LjcwNTUgMS41MDlMMTEuMDQxIDEuMDY5NzhDMTEuNjg4MyAwLjk0OTgxNCAxMi4zMzcgMS4yNzI2MyAxMi42MzE3IDEuODYxNDFMMTcuNjEzNiAxMS44MTYxQzE4LjM1MjcgMTMuMjkyOSAxNy41OTM4IDE1LjA4MDQgMTYuMDE4IDE1LjU3NDVDMTYuNDA0NCAxNC40NTA3IDE2LjMyMzEgMTMuMjE4OCAxNS43OTI0IDEyLjE1NTVMMTEuMTk5MSAyLjk1MjM4WiIgZmlsbD0iI0VDNzIxMSIvPgo8L3N2Zz4=\");\n    background-color: darkorange;\n}\n\n.ace_scrollbar {\n    contain: strict;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 6;\n}\n\n.ace_scrollbar-inner {\n    position: absolute;\n    cursor: text;\n    left: 0;\n    top: 0;\n}\n\n.ace_scrollbar-v{\n    overflow-x: hidden;\n    overflow-y: scroll;\n    top: 0;\n}\n\n.ace_scrollbar-h {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    left: 0;\n}\n\n.ace_print-margin {\n    position: absolute;\n    height: 100%;\n}\n\n.ace_text-input {\n    position: absolute;\n    z-index: 0;\n    width: 0.5em;\n    height: 1em;\n    opacity: 0;\n    background: transparent;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    resize: none;\n    outline: none;\n    overflow: hidden;\n    font: inherit;\n    padding: 0 1px;\n    margin: 0 -1px;\n    contain: strict;\n    -ms-user-select: text;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    user-select: text;\n    /*with `pre-line` chrome inserts &nbsp; instead of space*/\n    white-space: pre!important;\n}\n.ace_text-input.ace_composition {\n    background: transparent;\n    color: inherit;\n    z-index: 1000;\n    opacity: 1;\n}\n.ace_composition_placeholder { color: transparent }\n.ace_composition_marker { \n    border-bottom: 1px solid;\n    position: absolute;\n    border-radius: 0;\n    margin-top: 1px;\n}\n\n[ace_nocontext=true] {\n    transform: none!important;\n    filter: none!important;\n    clip-path: none!important;\n    mask : none!important;\n    contain: none!important;\n    perspective: none!important;\n    mix-blend-mode: initial!important;\n    z-index: auto;\n}\n\n.ace_layer {\n    z-index: 1;\n    position: absolute;\n    overflow: hidden;\n    /* workaround for chrome bug https://github.com/ajaxorg/ace/issues/2312*/\n    word-wrap: normal;\n    white-space: pre;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    /* setting pointer-events: auto; on node under the mouse, which changes\n        during scroll, will break mouse wheel scrolling in Safari */\n    pointer-events: none;\n}\n\n.ace_gutter-layer {\n    position: relative;\n    width: auto;\n    text-align: right;\n    pointer-events: auto;\n    height: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer {\n    font: inherit !important;\n    position: absolute;\n    height: 1000000px;\n    width: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer > .ace_line, .ace_text-layer > .ace_line_group {\n    contain: style size layout;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.ace_hidpi .ace_text-layer,\n.ace_hidpi .ace_gutter-layer,\n.ace_hidpi .ace_content,\n.ace_hidpi .ace_gutter {\n    contain: strict;\n}\n.ace_hidpi .ace_text-layer > .ace_line, \n.ace_hidpi .ace_text-layer > .ace_line_group {\n    contain: strict;\n}\n\n.ace_cjk {\n    display: inline-block;\n    text-align: center;\n}\n\n.ace_cursor-layer {\n    z-index: 4;\n}\n\n.ace_cursor {\n    z-index: 4;\n    position: absolute;\n    box-sizing: border-box;\n    border-left: 2px solid;\n    /* workaround for smooth cursor repaintng whole screen in chrome */\n    transform: translatez(0);\n}\n\n.ace_multiselect .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_slim-cursors .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_overwrite-cursors .ace_cursor {\n    border-left-width: 0;\n    border-bottom: 1px solid;\n}\n\n.ace_hidden-cursors .ace_cursor {\n    opacity: 0.2;\n}\n\n.ace_hasPlaceholder .ace_hidden-cursors .ace_cursor {\n    opacity: 0;\n}\n\n.ace_smooth-blinking .ace_cursor {\n    transition: opacity 0.18s;\n}\n\n.ace_animate-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: step-end;\n    animation-name: blink-ace-animate;\n    animation-iteration-count: infinite;\n}\n\n.ace_animate-blinking.ace_smooth-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: ease-in-out;\n    animation-name: blink-ace-animate-smooth;\n}\n    \n@keyframes blink-ace-animate {\n    from, to { opacity: 1; }\n    60% { opacity: 0; }\n}\n\n@keyframes blink-ace-animate-smooth {\n    from, to { opacity: 1; }\n    45% { opacity: 1; }\n    60% { opacity: 0; }\n    85% { opacity: 0; }\n}\n\n.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\n    position: absolute;\n    z-index: 3;\n}\n\n.ace_marker-layer .ace_selection {\n    position: absolute;\n    z-index: 5;\n}\n\n.ace_marker-layer .ace_bracket {\n    position: absolute;\n    z-index: 6;\n}\n\n.ace_marker-layer .ace_error_bracket {\n    position: absolute;\n    border-bottom: 1px solid #DE5555;\n    border-radius: 0;\n}\n\n.ace_marker-layer .ace_active-line {\n    position: absolute;\n    z-index: 2;\n}\n\n.ace_marker-layer .ace_selected-word {\n    position: absolute;\n    z-index: 4;\n    box-sizing: border-box;\n}\n\n.ace_line .ace_fold {\n    box-sizing: border-box;\n\n    display: inline-block;\n    height: 11px;\n    margin-top: -2px;\n    vertical-align: middle;\n\n    background-image:\n        url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\n        url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=\");\n    background-repeat: no-repeat, repeat-x;\n    background-position: center center, top left;\n    color: transparent;\n\n    border: 1px solid black;\n    border-radius: 2px;\n\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.ace_dark .ace_fold {\n}\n\n.ace_fold:hover{\n    background-image:\n        url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\n        url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC\");\n}\n\n.ace_tooltip {\n    background-color: #f5f5f5;\n    border: 1px solid gray;\n    border-radius: 1px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    color: black;\n    max-width: 100%;\n    padding: 3px 4px;\n    position: fixed;\n    z-index: 999999;\n    box-sizing: border-box;\n    cursor: default;\n    white-space: pre;\n    word-wrap: break-word;\n    line-height: normal;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    pointer-events: none;\n}\n\n.ace_tooltip.ace_dark {\n    background-color: #636363;\n    color: #fff;\n}\n\n.ace_tooltip:focus {\n    outline: 1px solid #5E9ED6;\n}\n\n.ace_icon {\n    display: inline-block;\n    width: 18px;\n    vertical-align: top;\n}\n\n.ace_icon_svg {\n    display: inline-block;\n    width: 12px;\n    vertical-align: top;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: 12px;\n    -webkit-mask-position: center;\n}\n\n.ace_folding-enabled > .ace_gutter-cell, .ace_folding-enabled > .ace_gutter-cell_svg-icons {\n    padding-right: 13px;\n}\n\n.ace_fold-widget {\n    box-sizing: border-box;\n\n    margin: 0 -12px 0 1px;\n    display: none;\n    width: 11px;\n    vertical-align: top;\n\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==\");\n    background-repeat: no-repeat;\n    background-position: center;\n\n    border-radius: 3px;\n    \n    border: 1px solid transparent;\n    cursor: pointer;\n}\n\n.ace_folding-enabled .ace_fold-widget {\n    display: inline-block;   \n}\n\n.ace_fold-widget.ace_end {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==\");\n}\n\n.ace_fold-widget.ace_closed {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==\");\n}\n\n.ace_fold-widget:hover {\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: rgba(255, 255, 255, 0.2);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\n}\n\n.ace_fold-widget:active {\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    background-color: rgba(0, 0, 0, 0.05);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\n}\n/**\n * Dark version for fold widgets\n */\n.ace_dark .ace_fold-widget {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC\");\n}\n.ace_dark .ace_fold-widget.ace_end {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==\");\n}\n.ace_dark .ace_fold-widget.ace_closed {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==\");\n}\n.ace_dark .ace_fold-widget:hover {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n    background-color: rgba(255, 255, 255, 0.1);\n}\n.ace_dark .ace_fold-widget:active {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n}\n\n.ace_inline_button {\n    border: 1px solid lightgray;\n    display: inline-block;\n    margin: -1px 8px;\n    padding: 0 5px;\n    pointer-events: auto;\n    cursor: pointer;\n}\n.ace_inline_button:hover {\n    border-color: gray;\n    background: rgba(200,200,200,0.2);\n    display: inline-block;\n    pointer-events: auto;\n}\n\n.ace_fold-widget.ace_invalid {\n    background-color: #FFB4B4;\n    border-color: #DE5555;\n}\n\n.ace_fade-fold-widgets .ace_fold-widget {\n    transition: opacity 0.4s ease 0.05s;\n    opacity: 0;\n}\n\n.ace_fade-fold-widgets:hover .ace_fold-widget {\n    transition: opacity 0.05s ease 0.05s;\n    opacity:1;\n}\n\n.ace_underline {\n    text-decoration: underline;\n}\n\n.ace_bold {\n    font-weight: bold;\n}\n\n.ace_nobold .ace_bold {\n    font-weight: normal;\n}\n\n.ace_italic {\n    font-style: italic;\n}\n\n\n.ace_error-marker {\n    background-color: rgba(255, 0, 0,0.2);\n    position: absolute;\n    z-index: 9;\n}\n\n.ace_highlight-marker {\n    background-color: rgba(255, 255, 0,0.2);\n    position: absolute;\n    z-index: 8;\n}\n\n.ace_mobile-menu {\n    position: absolute;\n    line-height: 1.5;\n    border-radius: 4px;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    background: white;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #dcdcdc;\n    color: black;\n}\n.ace_dark > .ace_mobile-menu {\n    background: #333;\n    color: #ccc;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #444;\n\n}\n.ace_mobile-button {\n    padding: 2px;\n    cursor: pointer;\n    overflow: hidden;\n}\n.ace_mobile-button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_mobile-button:active {\n    background-color: #ddd;\n}\n\n.ace_placeholder {\n    font-family: arial;\n    transform: scale(0.9);\n    transform-origin: left;\n    white-space: pre;\n    opacity: 0.7;\n    margin: 0 10px;\n}\n\n.ace_ghost_text {\n    opacity: 0.5;\n    font-style: italic;\n    white-space: pre;\n}";
      }), ace.define("ace/layer/decorators", ["require", "exports", "module", "ace/lib/dom", "ace/lib/oop", "ace/lib/event_emitter"], function (e, t, n) {
        "use strict";

        var i = e("../lib/dom"),
          o = e("../lib/oop"),
          e = e("../lib/event_emitter").EventEmitter,
          r = (s.prototype.$updateDecorators = function (e) {
            var t = !0 === (this || _global).renderer.theme.isDark ? (this || _global).colors.dark : (this || _global).colors.light,
              n = (e && ((this || _global).maxHeight = e.maxHeight, (this || _global).lineHeight = e.lineHeight, (this || _global).canvasHeight = e.height, (e.lastRow + 1) * (this || _global).lineHeight < (this || _global).canvasHeight ? (this || _global).heightRatio = 1 : (this || _global).heightRatio = (this || _global).canvasHeight / (this || _global).maxHeight), (this || _global).canvas.getContext("2d"));
            var i = (this || _global).renderer.session.$annotations;
            if (n.clearRect(0, 0, (this || _global).canvas.width, (this || _global).canvas.height), i) for (var o = {
                info: 1,
                warning: 2,
                error: 3
              }, r = (i.forEach(function (e) {
                e.priority = o[e.type] || null;
              }), i = i.sort(function (e, t) {
                return e.priority < t.priority ? -1 : e.priority > t.priority ? 1 : 0;
              }), (this || _global).renderer.session.$foldData), s = 0; s < i.length; s++) {
              var a,
                l = i[s].row,
                c = this.compensateFoldRows(l, r),
                h = Math.round((l - c) * (this || _global).lineHeight * (this || _global).heightRatio),
                d = Math.round((l - c) * (this || _global).lineHeight * (this || _global).heightRatio),
                l = Math.round(((l - c) * (this || _global).lineHeight + (this || _global).lineHeight) * (this || _global).heightRatio);
              l - d < (this || _global).minDecorationHeight && ((a = (d + l) / 2 | 0) < (this || _global).halfMinDecorationHeight ? a = (this || _global).halfMinDecorationHeight : a + (this || _global).halfMinDecorationHeight > (this || _global).canvasHeight && (a = (this || _global).canvasHeight - (this || _global).halfMinDecorationHeight), d = Math.round(a - (this || _global).halfMinDecorationHeight), l = Math.round(a + (this || _global).halfMinDecorationHeight)), n.fillStyle = t[i[s].type] || null, n.fillRect(0, h, (this || _global).canvasWidth, l - d);
            }
            e = (this || _global).renderer.session.selection.getCursor();
            e && (c = this.compensateFoldRows(e.row, r), h = Math.round((e.row - c) * (this || _global).lineHeight * (this || _global).heightRatio), n.fillStyle = "rgba(0, 0, 0, 0.5)", n.fillRect(0, h, (this || _global).canvasWidth, 2));
          }, s.prototype.compensateFoldRows = function (e, t) {
            var n = 0;
            if (t && 0 < t.length) for (var i = 0; i < t.length; i++) e > t[i].start.row && e < t[i].end.row ? n += e - t[i].start.row : e >= t[i].end.row && (n += t[i].end.row - t[i].start.row);
            return n;
          }, s);
        function s(e, t) {
          (this || _global).canvas = i.createElement("canvas"), (this || _global).renderer = t, (this || _global).pixelRatio = 1, (this || _global).maxHeight = t.layerConfig.maxHeight, (this || _global).lineHeight = t.layerConfig.lineHeight, (this || _global).canvasHeight = e.parent.scrollHeight, (this || _global).heightRatio = (this || _global).canvasHeight / (this || _global).maxHeight, (this || _global).canvasWidth = e.width, (this || _global).minDecorationHeight = 2 * (this || _global).pixelRatio | 0, (this || _global).halfMinDecorationHeight = (this || _global).minDecorationHeight / 2 | 0, (this || _global).canvas.width = (this || _global).canvasWidth, (this || _global).canvas.height = (this || _global).canvasHeight, (this || _global).canvas.style.top = "0px", (this || _global).canvas.style.right = "0px", (this || _global).canvas.style.zIndex = "7px", (this || _global).canvas.style.position = "absolute", (this || _global).colors = {}, (this || _global).colors.dark = {
            error: "rgba(255, 18, 18, 1)",
            warning: "rgba(18, 136, 18, 1)",
            info: "rgba(18, 18, 136, 1)"
          }, (this || _global).colors.light = {
            error: "rgb(255,51,51)",
            warning: "rgb(32,133,72)",
            info: "rgb(35,68,138)"
          }, e.element.appendChild((this || _global).canvas);
        }
        o.implement(r.prototype, e), t.Decorator = r;
      }), ace.define("ace/virtual_renderer", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/lib/lang", "ace/config", "ace/layer/gutter", "ace/layer/marker", "ace/layer/text", "ace/layer/cursor", "ace/scrollbar", "ace/scrollbar", "ace/scrollbar_custom", "ace/scrollbar_custom", "ace/renderloop", "ace/layer/font_metrics", "ace/lib/event_emitter", "ace/css/editor.css", "ace/layer/decorators", "ace/lib/useragent"], function (e, t, n) {
        "use strict";

        var i = e("./lib/oop"),
          a = e("./lib/dom"),
          o = e("./lib/lang"),
          r = e("./config"),
          s = e("./layer/gutter").Gutter,
          l = e("./layer/marker").Marker,
          c = e("./layer/text").Text,
          h = e("./layer/cursor").Cursor,
          d = e("./scrollbar").HScrollBar,
          u = e("./scrollbar").VScrollBar,
          g = e("./scrollbar_custom").HScrollBar,
          p = e("./scrollbar_custom").VScrollBar,
          m = e("./renderloop").RenderLoop,
          f = e("./layer/font_metrics").FontMetrics,
          C = e("./lib/event_emitter").EventEmitter,
          y = e("./css/editor.css"),
          v = e("./layer/decorators").Decorator,
          I = e("./lib/useragent"),
          e = (a.importCssString(y, "ace_editor.css", !1), b.prototype.updateCharacterSize = function () {
            (this || _global).$textLayer.allowBoldFonts != (this || _global).$allowBoldFonts && ((this || _global).$allowBoldFonts = (this || _global).$textLayer.allowBoldFonts, this.setStyle("ace_nobold", !(this || _global).$allowBoldFonts)), (this || _global).layerConfig.characterWidth = (this || _global).characterWidth = (this || _global).$textLayer.getCharacterWidth(), (this || _global).layerConfig.lineHeight = (this || _global).lineHeight = (this || _global).$textLayer.getLineHeight(), this.$updatePrintMargin(), a.setStyle((this || _global).scroller.style, "line-height", (this || _global).lineHeight + "px");
          }, b.prototype.setSession = function (e) {
            (this || _global).session && (this || _global).session.doc.off("changeNewLineMode", (this || _global).onChangeNewLineMode), ((this || _global).session = e) && (this || _global).scrollMargin.top && e.getScrollTop() <= 0 && e.setScrollTop(-(this || _global).scrollMargin.top), (this || _global).$cursorLayer.setSession(e), (this || _global).$markerBack.setSession(e), (this || _global).$markerFront.setSession(e), (this || _global).$gutterLayer.setSession(e), (this || _global).$textLayer.setSession(e), e && ((this || _global).$loop.schedule((this || _global).CHANGE_FULL), (this || _global).session.$setFontMetrics((this || _global).$fontMetrics), (this || _global).scrollBarH.scrollLeft = (this || _global).scrollBarV.scrollTop = null, (this || _global).onChangeNewLineMode = (this || _global).onChangeNewLineMode.bind(this || _global), this.onChangeNewLineMode(), (this || _global).session.doc.on("changeNewLineMode", (this || _global).onChangeNewLineMode));
          }, b.prototype.updateLines = function (e, t, n) {
            if (void 0 === t && (t = 1 / 0), (this || _global).$changedLines ? ((this || _global).$changedLines.firstRow > e && ((this || _global).$changedLines.firstRow = e), (this || _global).$changedLines.lastRow < t && ((this || _global).$changedLines.lastRow = t)) : (this || _global).$changedLines = {
              firstRow: e,
              lastRow: t
            }, (this || _global).$changedLines.lastRow < (this || _global).layerConfig.firstRow) {
              if (!n) return;
              (this || _global).$changedLines.lastRow = (this || _global).layerConfig.lastRow;
            }
            (this || _global).$changedLines.firstRow > (this || _global).layerConfig.lastRow || (this || _global).$loop.schedule((this || _global).CHANGE_LINES);
          }, b.prototype.onChangeNewLineMode = function () {
            (this || _global).$loop.schedule((this || _global).CHANGE_TEXT), (this || _global).$textLayer.$updateEolChar(), (this || _global).session.$bidiHandler.setEolChar((this || _global).$textLayer.EOL_CHAR);
          }, b.prototype.onChangeTabSize = function () {
            (this || _global).$loop.schedule((this || _global).CHANGE_TEXT | (this || _global).CHANGE_MARKER), (this || _global).$textLayer.onChangeTabSize();
          }, b.prototype.updateText = function () {
            (this || _global).$loop.schedule((this || _global).CHANGE_TEXT);
          }, b.prototype.updateFull = function (e) {
            e ? this.$renderChanges((this || _global).CHANGE_FULL, !0) : (this || _global).$loop.schedule((this || _global).CHANGE_FULL);
          }, b.prototype.updateFontSize = function () {
            (this || _global).$textLayer.checkForSizeChanges();
          }, b.prototype.$updateSizeAsync = function () {
            (this || _global).$loop.pending ? (this || _global).$size.$dirty = !0 : this.onResize();
          }, b.prototype.onResize = function (e, t, n, i) {
            if (!(2 < (this || _global).resizing)) {
              0 < (this || _global).resizing ? (this || _global).resizing++ : (this || _global).resizing = e ? 1 : 0;
              var o = (this || _global).container,
                o = (i = i || o.clientHeight || o.scrollHeight, n = n || o.clientWidth || o.scrollWidth, this.$updateCachedSize(e, t, n, i));
              if ((this || _global).$resizeTimer && (this || _global).$resizeTimer.cancel(), !(this || _global).$size.scrollerHeight || !n && !i) return (this || _global).resizing = 0;
              e && ((this || _global).$gutterLayer.$padding = null), e ? this.$renderChanges(o | (this || _global).$changes, !0) : (this || _global).$loop.schedule(o | (this || _global).$changes), (this || _global).resizing && ((this || _global).resizing = 0), (this || _global).scrollBarH.scrollLeft = (this || _global).scrollBarV.scrollTop = null, (this || _global).$customScrollbar && this.$updateCustomScrollbar(!0);
            }
          }, b.prototype.$updateCachedSize = function (e, t, n, i) {
            i -= (this || _global).$extraHeight || 0;
            var o = 0,
              r = (this || _global).$size,
              s = {
                width: r.width,
                height: r.height,
                scrollerHeight: r.scrollerHeight,
                scrollerWidth: r.scrollerWidth
              };
            return i && (e || r.height != i) && (r.height = i, o |= (this || _global).CHANGE_SIZE, r.scrollerHeight = r.height, (this || _global).$horizScroll && (r.scrollerHeight -= (this || _global).scrollBarH.getHeight()), (this || _global).scrollBarV.setHeight(r.scrollerHeight), (this || _global).scrollBarV.element.style.bottom = (this || _global).scrollBarH.getHeight() + "px", o |= (this || _global).CHANGE_SCROLL), n && (e || r.width != n) && (o |= (this || _global).CHANGE_SIZE, r.width = n, null == t && (t = (this || _global).$showGutter ? (this || _global).$gutter.offsetWidth : 0), (this || _global).gutterWidth = t, a.setStyle((this || _global).scrollBarH.element.style, "left", t + "px"), a.setStyle((this || _global).scroller.style, "left", t + (this || _global).margin.left + "px"), r.scrollerWidth = Math.max(0, n - t - (this || _global).scrollBarV.getWidth() - (this || _global).margin.h), a.setStyle((this || _global).$gutter.style, "left", (this || _global).margin.left + "px"), t = (this || _global).scrollBarV.getWidth() + "px", a.setStyle((this || _global).scrollBarH.element.style, "right", t), a.setStyle((this || _global).scroller.style, "right", t), a.setStyle((this || _global).scroller.style, "bottom", (this || _global).scrollBarH.getHeight()), (this || _global).scrollBarH.setWidth(r.scrollerWidth), (this || _global).session && (this || _global).session.getUseWrapMode() && this.adjustWrapLimit() || e) && (o |= (this || _global).CHANGE_FULL), r.$dirty = !n || !i, o && this._signal("resize", s), o;
          }, b.prototype.onGutterResize = function (e) {
            e = (this || _global).$showGutter ? e : 0;
            e != (this || _global).gutterWidth && ((this || _global).$changes |= this.$updateCachedSize(!0, e, (this || _global).$size.width, (this || _global).$size.height)), (this || _global).session.getUseWrapMode() && this.adjustWrapLimit() || (this || _global).$size.$dirty ? (this || _global).$loop.schedule((this || _global).CHANGE_FULL) : this.$computeLayerConfig();
          }, b.prototype.adjustWrapLimit = function () {
            var e = (this || _global).$size.scrollerWidth - 2 * (this || _global).$padding,
              e = Math.floor(e / (this || _global).characterWidth);
            return (this || _global).session.adjustWrapLimit(e, (this || _global).$showPrintMargin && (this || _global).$printMarginColumn);
          }, b.prototype.setAnimatedScroll = function (e) {
            this.setOption("animatedScroll", e);
          }, b.prototype.getAnimatedScroll = function () {
            return (this || _global).$animatedScroll;
          }, b.prototype.setShowInvisibles = function (e) {
            this.setOption("showInvisibles", e), (this || _global).session.$bidiHandler.setShowInvisibles(e);
          }, b.prototype.getShowInvisibles = function () {
            return this.getOption("showInvisibles");
          }, b.prototype.getDisplayIndentGuide = function () {
            return this.getOption("displayIndentGuides");
          }, b.prototype.setDisplayIndentGuides = function (e) {
            this.setOption("displayIndentGuides", e);
          }, b.prototype.getHighlightIndentGuides = function () {
            return this.getOption("highlightIndentGuides");
          }, b.prototype.setHighlightIndentGuides = function (e) {
            this.setOption("highlightIndentGuides", e);
          }, b.prototype.setShowPrintMargin = function (e) {
            this.setOption("showPrintMargin", e);
          }, b.prototype.getShowPrintMargin = function () {
            return this.getOption("showPrintMargin");
          }, b.prototype.setPrintMarginColumn = function (e) {
            this.setOption("printMarginColumn", e);
          }, b.prototype.getPrintMarginColumn = function () {
            return this.getOption("printMarginColumn");
          }, b.prototype.getShowGutter = function () {
            return this.getOption("showGutter");
          }, b.prototype.setShowGutter = function (e) {
            return this.setOption("showGutter", e);
          }, b.prototype.getFadeFoldWidgets = function () {
            return this.getOption("fadeFoldWidgets");
          }, b.prototype.setFadeFoldWidgets = function (e) {
            this.setOption("fadeFoldWidgets", e);
          }, b.prototype.setHighlightGutterLine = function (e) {
            this.setOption("highlightGutterLine", e);
          }, b.prototype.getHighlightGutterLine = function () {
            return this.getOption("highlightGutterLine");
          }, b.prototype.$updatePrintMargin = function () {
            var e;
            ((this || _global).$showPrintMargin || (this || _global).$printMarginEl) && ((this || _global).$printMarginEl || ((e = a.createElement("div")).className = "ace_layer ace_print-margin-layer", (this || _global).$printMarginEl = a.createElement("div"), (this || _global).$printMarginEl.className = "ace_print-margin", e.appendChild((this || _global).$printMarginEl), (this || _global).content.insertBefore(e, (this || _global).content.firstChild)), (e = (this || _global).$printMarginEl.style).left = Math.round((this || _global).characterWidth * (this || _global).$printMarginColumn + (this || _global).$padding) + "px", e.visibility = (this || _global).$showPrintMargin ? "visible" : "hidden", (this || _global).session) && -1 == (this || _global).session.$wrap && this.adjustWrapLimit();
          }, b.prototype.getContainerElement = function () {
            return (this || _global).container;
          }, b.prototype.getMouseEventTarget = function () {
            return (this || _global).scroller;
          }, b.prototype.getTextAreaContainer = function () {
            return (this || _global).container;
          }, b.prototype.$moveTextAreaToCursor = function () {
            var e, t, n, i, o, r, s;
            (this || _global).$isMousePressed || (e = (this || _global).textarea.style, r = (this || _global).$composition, (this || _global).$keepTextAreaAtCursor || r ? (n = (this || _global).$cursorLayer.$pixelPos) && (r && r.markerRange && (n = (this || _global).$cursorLayer.getPixelPosition(r.markerRange.start, !0)), s = (this || _global).layerConfig, t = n.top, n = n.left, t -= s.offset, i = r && r.useTextareaForIME || I.isMobile ? (this || _global).lineHeight : 1, t < 0 || t > s.height - i ? a.translate((this || _global).textarea, 0, 0) : (s = 1, o = (this || _global).$size.height - i, r ? r.useTextareaForIME ? (r = (this || _global).textarea.value, s = (this || _global).characterWidth * (this || _global).session.$getStringScreenWidth(r)[0]) : t += (this || _global).lineHeight + 2 : t += (this || _global).lineHeight, (n -= (this || _global).scrollLeft) > (this || _global).$size.scrollerWidth - s && (n = (this || _global).$size.scrollerWidth - s), n += (this || _global).gutterWidth + (this || _global).margin.left, a.setStyle(e, "height", i + "px"), a.setStyle(e, "width", s + "px"), a.translate((this || _global).textarea, Math.min(n, (this || _global).$size.scrollerWidth - s), Math.min(t, o)))) : a.translate((this || _global).textarea, -100, 0));
          }, b.prototype.getFirstVisibleRow = function () {
            return (this || _global).layerConfig.firstRow;
          }, b.prototype.getFirstFullyVisibleRow = function () {
            return (this || _global).layerConfig.firstRow + (0 === (this || _global).layerConfig.offset ? 0 : 1);
          }, b.prototype.getLastFullyVisibleRow = function () {
            var e = (this || _global).layerConfig,
              t = e.lastRow;
            return (this || _global).session.documentToScreenRow(t, 0) * e.lineHeight - (this || _global).session.getScrollTop() > e.height - e.lineHeight ? t - 1 : t;
          }, b.prototype.getLastVisibleRow = function () {
            return (this || _global).layerConfig.lastRow;
          }, b.prototype.setPadding = function (e) {
            (this || _global).$padding = e, (this || _global).$textLayer.setPadding(e), (this || _global).$cursorLayer.setPadding(e), (this || _global).$markerFront.setPadding(e), (this || _global).$markerBack.setPadding(e), (this || _global).$loop.schedule((this || _global).CHANGE_FULL), this.$updatePrintMargin();
          }, b.prototype.setScrollMargin = function (e, t, n, i) {
            var o = (this || _global).scrollMargin;
            o.top = 0 | e, o.bottom = 0 | t, o.right = 0 | i, o.left = 0 | n, o.v = o.top + o.bottom, o.h = o.left + o.right, o.top && (this || _global).scrollTop <= 0 && (this || _global).session && (this || _global).session.setScrollTop(-o.top), this.updateFull();
          }, b.prototype.setMargin = function (e, t, n, i) {
            var o = (this || _global).margin;
            o.top = 0 | e, o.bottom = 0 | t, o.right = 0 | i, o.left = 0 | n, o.v = o.top + o.bottom, o.h = o.left + o.right, this.$updateCachedSize(!0, (this || _global).gutterWidth, (this || _global).$size.width, (this || _global).$size.height), this.updateFull();
          }, b.prototype.getHScrollBarAlwaysVisible = function () {
            return (this || _global).$hScrollBarAlwaysVisible;
          }, b.prototype.setHScrollBarAlwaysVisible = function (e) {
            this.setOption("hScrollBarAlwaysVisible", e);
          }, b.prototype.getVScrollBarAlwaysVisible = function () {
            return (this || _global).$vScrollBarAlwaysVisible;
          }, b.prototype.setVScrollBarAlwaysVisible = function (e) {
            this.setOption("vScrollBarAlwaysVisible", e);
          }, b.prototype.$updateScrollBarV = function () {
            var e = (this || _global).layerConfig.maxHeight,
              t = (this || _global).$size.scrollerHeight;
            !(this || _global).$maxLines && (this || _global).$scrollPastEnd && (e -= (t - (this || _global).lineHeight) * (this || _global).$scrollPastEnd, (this || _global).scrollTop > e - t) && (e = (this || _global).scrollTop + t, (this || _global).scrollBarV.scrollTop = null), (this || _global).scrollBarV.setScrollHeight(e + (this || _global).scrollMargin.v), (this || _global).scrollBarV.setScrollTop((this || _global).scrollTop + (this || _global).scrollMargin.top);
          }, b.prototype.$updateScrollBarH = function () {
            (this || _global).scrollBarH.setScrollWidth((this || _global).layerConfig.width + 2 * (this || _global).$padding + (this || _global).scrollMargin.h), (this || _global).scrollBarH.setScrollLeft((this || _global).scrollLeft + (this || _global).scrollMargin.left);
          }, b.prototype.freeze = function () {
            (this || _global).$frozen = !0;
          }, b.prototype.unfreeze = function () {
            (this || _global).$frozen = !1;
          }, b.prototype.$renderChanges = function (e, t) {
            if ((this || _global).$changes && (e |= (this || _global).$changes, (this || _global).$changes = 0), (this || _global).session && (this || _global).container.offsetWidth && !(this || _global).$frozen && (e || t)) {
              if ((this || _global).$size.$dirty) return (this || _global).$changes |= e, this.onResize(!0);
              (this || _global).lineHeight || (this || _global).$textLayer.checkForSizeChanges(), this._signal("beforeRender", e), (this || _global).session && (this || _global).session.$bidiHandler && (this || _global).session.$bidiHandler.updateCharacterWidths((this || _global).$fontMetrics);
              var n,
                i,
                t = (this || _global).layerConfig;
              (e & (this || _global).CHANGE_FULL || e & (this || _global).CHANGE_SIZE || e & (this || _global).CHANGE_TEXT || e & (this || _global).CHANGE_LINES || e & (this || _global).CHANGE_SCROLL || e & (this || _global).CHANGE_H_SCROLL) && (e |= this.$computeLayerConfig() | (this || _global).$loop.clear(), t.firstRow != (this || _global).layerConfig.firstRow && t.firstRowScreen == (this || _global).layerConfig.firstRowScreen && 0 < (n = (this || _global).scrollTop + (t.firstRow - Math.max((this || _global).layerConfig.firstRow, 0)) * (this || _global).lineHeight) && ((this || _global).scrollTop = n, e = (e |= (this || _global).CHANGE_SCROLL) | (this.$computeLayerConfig() | (this || _global).$loop.clear())), t = (this || _global).layerConfig, this.$updateScrollBarV(), e & (this || _global).CHANGE_H_SCROLL && this.$updateScrollBarH(), a.translate((this || _global).content, -(this || _global).scrollLeft, -t.offset), n = t.width + 2 * (this || _global).$padding + "px", i = t.minHeight + "px", a.setStyle((this || _global).content.style, "width", n), a.setStyle((this || _global).content.style, "height", i)), e & (this || _global).CHANGE_H_SCROLL && (a.translate((this || _global).content, -(this || _global).scrollLeft, -t.offset), (this || _global).scroller.className = (this || _global).scrollLeft <= 0 ? "ace_scroller " : "ace_scroller ace_scroll-left ", (this || _global).enableKeyboardAccessibility) && ((this || _global).scroller.className += (this || _global).keyboardFocusClassName), e & (this || _global).CHANGE_FULL ? ((this || _global).$changedLines = null, (this || _global).$textLayer.update(t), (this || _global).$showGutter && (this || _global).$gutterLayer.update(t), (this || _global).$customScrollbar && (this || _global).$scrollDecorator.$updateDecorators(t), (this || _global).$markerBack.update(t), (this || _global).$markerFront.update(t), (this || _global).$cursorLayer.update(t), this.$moveTextAreaToCursor()) : e & (this || _global).CHANGE_SCROLL ? ((this || _global).$changedLines = null, e & (this || _global).CHANGE_TEXT || e & (this || _global).CHANGE_LINES ? (this || _global).$textLayer.update(t) : (this || _global).$textLayer.scrollLines(t), (this || _global).$showGutter && (e & (this || _global).CHANGE_GUTTER || e & (this || _global).CHANGE_LINES ? (this || _global).$gutterLayer.update(t) : (this || _global).$gutterLayer.scrollLines(t)), (this || _global).$customScrollbar && (this || _global).$scrollDecorator.$updateDecorators(t), (this || _global).$markerBack.update(t), (this || _global).$markerFront.update(t), (this || _global).$cursorLayer.update(t), this.$moveTextAreaToCursor()) : (e & (this || _global).CHANGE_TEXT ? ((this || _global).$changedLines = null, (this || _global).$textLayer.update(t), (this || _global).$showGutter && (this || _global).$gutterLayer.update(t), (this || _global).$customScrollbar && (this || _global).$scrollDecorator.$updateDecorators(t)) : e & (this || _global).CHANGE_LINES ? ((this.$updateLines() || e & (this || _global).CHANGE_GUTTER && (this || _global).$showGutter) && (this || _global).$gutterLayer.update(t), (this || _global).$customScrollbar && (this || _global).$scrollDecorator.$updateDecorators(t)) : e & (this || _global).CHANGE_TEXT || e & (this || _global).CHANGE_GUTTER ? ((this || _global).$showGutter && (this || _global).$gutterLayer.update(t), (this || _global).$customScrollbar && (this || _global).$scrollDecorator.$updateDecorators(t)) : e & (this || _global).CHANGE_CURSOR && ((this || _global).$highlightGutterLine && (this || _global).$gutterLayer.updateLineHighlight(t), (this || _global).$customScrollbar) && (this || _global).$scrollDecorator.$updateDecorators(t), e & (this || _global).CHANGE_CURSOR && ((this || _global).$cursorLayer.update(t), this.$moveTextAreaToCursor()), e & ((this || _global).CHANGE_MARKER | (this || _global).CHANGE_MARKER_FRONT) && (this || _global).$markerFront.update(t), e & ((this || _global).CHANGE_MARKER | (this || _global).CHANGE_MARKER_BACK) && (this || _global).$markerBack.update(t)), this._signal("afterRender", e);
            } else (this || _global).$changes |= e;
          }, b.prototype.$autosize = function () {
            var e = (this || _global).session.getScreenLength() * (this || _global).lineHeight,
              t = (this || _global).$maxLines * (this || _global).lineHeight,
              n = Math.min(t, Math.max(((this || _global).$minLines || 1) * (this || _global).lineHeight, e)) + (this || _global).scrollMargin.v + ((this || _global).$extraHeight || 0);
            (this || _global).$horizScroll && (n += (this || _global).scrollBarH.getHeight());
            t = !((n = (this || _global).$maxPixelHeight && n > (this || _global).$maxPixelHeight ? (this || _global).$maxPixelHeight : n) <= 2 * (this || _global).lineHeight) && t < e;
            n == (this || _global).desiredHeight && (this || _global).$size.height == (this || _global).desiredHeight && t == (this || _global).$vScroll || (t != (this || _global).$vScroll && ((this || _global).$vScroll = t, (this || _global).scrollBarV.setVisible(t)), e = (this || _global).container.clientWidth, (this || _global).container.style.height = n + "px", this.$updateCachedSize(!0, (this || _global).$gutterWidth, e, n), (this || _global).desiredHeight = n, this._signal("autosize"));
          }, b.prototype.$computeLayerConfig = function () {
            var e,
              t = (this || _global).session,
              n = (this || _global).$size,
              i = n.height <= 2 * (this || _global).lineHeight,
              o = (this || _global).session.getScreenLength() * (this || _global).lineHeight,
              r = this.$getLongestLine(),
              s = !i && ((this || _global).$hScrollBarAlwaysVisible || n.scrollerWidth - r - 2 * (this || _global).$padding < 0),
              a = (this || _global).$horizScroll !== s,
              s = (a && ((this || _global).$horizScroll = s, (this || _global).scrollBarH.setVisible(s)), (this || _global).$vScroll),
              l = ((this || _global).$maxLines && 1 < (this || _global).lineHeight && this.$autosize(), n.scrollerHeight + (this || _global).lineHeight),
              c = !(this || _global).$maxLines && (this || _global).$scrollPastEnd ? (n.scrollerHeight - (this || _global).lineHeight) * (this || _global).$scrollPastEnd : 0,
              h = (o += c, (this || _global).scrollMargin),
              i = ((this || _global).session.setScrollTop(Math.max(-h.top, Math.min((this || _global).scrollTop, o - n.scrollerHeight + h.bottom))), (this || _global).session.setScrollLeft(Math.max(-h.left, Math.min((this || _global).scrollLeft, r + 2 * (this || _global).$padding - n.scrollerWidth + h.right))), !i && ((this || _global).$vScrollBarAlwaysVisible || n.scrollerHeight - o + c < 0 || (this || _global).scrollTop > h.top)),
              c = s !== i,
              h = (c && ((this || _global).$vScroll = i, (this || _global).scrollBarV.setVisible(i)), (this || _global).scrollTop % (this || _global).lineHeight),
              s = Math.ceil(l / (this || _global).lineHeight) - 1,
              s = (i = Math.max(0, Math.round(((this || _global).scrollTop - h) / (this || _global).lineHeight))) + s,
              d = (this || _global).lineHeight,
              i = t.screenToDocumentRow(i, 0),
              u = t.getFoldLine(i),
              t = (u && (i = u.start.row), u = t.documentToScreenRow(i, 0), e = t.getRowLength(i) * d, s = Math.min(t.screenToDocumentRow(s, 0), t.getLength() - 1), l = n.scrollerHeight + t.getRowLength(s) * d + e, h = (this || _global).scrollTop - u * d, 0);
            return (this || _global).layerConfig.width == r && !a || (t = (this || _global).CHANGE_H_SCROLL), (a || c) && (t |= this.$updateCachedSize(!0, (this || _global).gutterWidth, n.width, n.height), this._signal("scrollbarVisibilityChanged"), c) && (r = this.$getLongestLine()), (this || _global).layerConfig = {
              width: r,
              padding: (this || _global).$padding,
              firstRow: i,
              firstRowScreen: u,
              lastRow: s,
              lineHeight: d,
              characterWidth: (this || _global).characterWidth,
              minHeight: l,
              maxHeight: o,
              offset: h,
              gutterOffset: d ? Math.max(0, Math.ceil((h + n.height - n.scrollerHeight) / d)) : 0,
              height: (this || _global).$size.scrollerHeight
            }, (this || _global).session.$bidiHandler && (this || _global).session.$bidiHandler.setContentWidth(r - (this || _global).$padding), t;
          }, b.prototype.$updateLines = function () {
            if ((this || _global).$changedLines) {
              var e = (this || _global).$changedLines.firstRow,
                t = (this || _global).$changedLines.lastRow,
                n = ((this || _global).$changedLines = null, (this || _global).layerConfig);
              if (!(e > n.lastRow + 1 || t < n.firstRow)) {
                if (t !== 1 / 0) return (this || _global).$textLayer.updateLines(n, e, t), !0;
                (this || _global).$showGutter && (this || _global).$gutterLayer.update(n), (this || _global).$textLayer.update(n);
              }
            }
          }, b.prototype.$getLongestLine = function () {
            var e = (this || _global).session.getScreenWidth();
            return (this || _global).showInvisibles && !(this || _global).session.$useWrapMode && (e += 1), (this || _global).$textLayer && e > (this || _global).$textLayer.MAX_LINE_LENGTH && (e = (this || _global).$textLayer.MAX_LINE_LENGTH + 30), Math.max((this || _global).$size.scrollerWidth - 2 * (this || _global).$padding, Math.round(e * (this || _global).characterWidth));
          }, b.prototype.updateFrontMarkers = function () {
            (this || _global).$markerFront.setMarkers((this || _global).session.getMarkers(!0)), (this || _global).$loop.schedule((this || _global).CHANGE_MARKER_FRONT);
          }, b.prototype.updateBackMarkers = function () {
            (this || _global).$markerBack.setMarkers((this || _global).session.getMarkers()), (this || _global).$loop.schedule((this || _global).CHANGE_MARKER_BACK);
          }, b.prototype.addGutterDecoration = function (e, t) {
            (this || _global).$gutterLayer.addGutterDecoration(e, t);
          }, b.prototype.removeGutterDecoration = function (e, t) {
            (this || _global).$gutterLayer.removeGutterDecoration(e, t);
          }, b.prototype.updateBreakpoints = function (e) {
            (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
          }, b.prototype.setAnnotations = function (e) {
            (this || _global).$gutterLayer.setAnnotations(e), (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
          }, b.prototype.updateCursor = function () {
            (this || _global).$loop.schedule((this || _global).CHANGE_CURSOR);
          }, b.prototype.hideCursor = function () {
            (this || _global).$cursorLayer.hideCursor();
          }, b.prototype.showCursor = function () {
            (this || _global).$cursorLayer.showCursor();
          }, b.prototype.scrollSelectionIntoView = function (e, t, n) {
            this.scrollCursorIntoView(e, n), this.scrollCursorIntoView(t, n);
          }, b.prototype.scrollCursorIntoView = function (e, t, n) {
            var i, o, r;
            0 !== (this || _global).$size.scrollerHeight && (i = (e = (this || _global).$cursorLayer.getPixelPosition(e)).left, e = e.top, o = n && n.top || 0, n = n && n.bottom || 0, (this || _global).$scrollAnimation && ((this || _global).$stopAnimation = !0), e < (r = (this || _global).$scrollAnimation ? (this || _global).session.getScrollTop() : (this || _global).scrollTop) + o ? (t && r + o > e + (this || _global).lineHeight && (e -= t * (this || _global).$size.scrollerHeight), 0 === e && (e = -(this || _global).scrollMargin.top), (this || _global).session.setScrollTop(e)) : r + (this || _global).$size.scrollerHeight - n < e + (this || _global).lineHeight && (t && r + (this || _global).$size.scrollerHeight - n < e - (this || _global).lineHeight && (e += t * (this || _global).$size.scrollerHeight), (this || _global).session.setScrollTop(e + (this || _global).lineHeight + n - (this || _global).$size.scrollerHeight)), o = (this || _global).scrollLeft, i - (r = 2 * (this || _global).layerConfig.characterWidth) < o ? ((i -= r) < (this || _global).$padding + r && (i = -(this || _global).scrollMargin.left), (this || _global).session.setScrollLeft(i)) : o + (this || _global).$size.scrollerWidth < (i += r) + (this || _global).characterWidth ? (this || _global).session.setScrollLeft(Math.round(i + (this || _global).characterWidth - (this || _global).$size.scrollerWidth)) : o <= (this || _global).$padding && i - o < (this || _global).characterWidth && (this || _global).session.setScrollLeft(0));
          }, b.prototype.getScrollTop = function () {
            return (this || _global).session.getScrollTop();
          }, b.prototype.getScrollLeft = function () {
            return (this || _global).session.getScrollLeft();
          }, b.prototype.getScrollTopRow = function () {
            return (this || _global).scrollTop / (this || _global).lineHeight;
          }, b.prototype.getScrollBottomRow = function () {
            return Math.max(0, Math.floor(((this || _global).scrollTop + (this || _global).$size.scrollerHeight) / (this || _global).lineHeight) - 1);
          }, b.prototype.scrollToRow = function (e) {
            (this || _global).session.setScrollTop(e * (this || _global).lineHeight);
          }, b.prototype.alignCursor = function (e, t) {
            var e = (this || _global).$cursorLayer.getPixelPosition(e = "number" == typeof e ? {
                row: e,
                column: 0
              } : e),
              n = (this || _global).$size.scrollerHeight - (this || _global).lineHeight,
              e = e.top - n * (t || 0);
            return (this || _global).session.setScrollTop(e), e;
          }, b.prototype.$calcSteps = function (e, t) {
            for (var n, i, o = 0, r = (this || _global).STEPS, s = [], o = 0; o < r; ++o) s.push((n = o / (this || _global).STEPS, (t - (i = e)) * (Math.pow(n - 1, 3) + 1) + i));
            return s;
          }, b.prototype.scrollToLine = function (e, t, n, i) {
            e = (this || _global).$cursorLayer.getPixelPosition({
              row: e,
              column: 0
            }).top, t && (e -= (this || _global).$size.scrollerHeight / 2), t = (this || _global).scrollTop;
            (this || _global).session.setScrollTop(e), !1 !== n && this.animateScrolling(t, i);
          }, b.prototype.animateScrolling = function (e, t) {
            var n = (this || _global).scrollTop;
            if ((this || _global).$animatedScroll) {
              var i = this || _global;
              if (e != n) {
                if ((this || _global).$scrollAnimation) {
                  var o = (this || _global).$scrollAnimation.steps;
                  if (o.length && (e = o[0]) == n) return;
                }
                var r = i.$calcSteps(e, n);
                (this || _global).$scrollAnimation = {
                  from: e,
                  to: n,
                  steps: r
                }, clearInterval((this || _global).$timer), i.session.setScrollTop(r.shift()), i.session.$scrollTop = n, (this || _global).$timer = setInterval(function () {
                  if (!i.$stopAnimation) return i.session ? void (r.length ? (i.session.setScrollTop(r.shift()), i.session.$scrollTop = n) : null != n ? (i.session.$scrollTop = -1, i.session.setScrollTop(n), n = null) : s()) : clearInterval(i.$timer);
                  s();
                }, 10);
              }
            }
            function s() {
              i.$timer = clearInterval(i.$timer), i.$scrollAnimation = null, i.$stopAnimation = !1, t && t();
            }
          }, b.prototype.scrollToY = function (e) {
            (this || _global).scrollTop !== e && ((this || _global).$loop.schedule((this || _global).CHANGE_SCROLL), (this || _global).scrollTop = e);
          }, b.prototype.scrollToX = function (e) {
            (this || _global).scrollLeft !== e && ((this || _global).scrollLeft = e), (this || _global).$loop.schedule((this || _global).CHANGE_H_SCROLL);
          }, b.prototype.scrollTo = function (e, t) {
            (this || _global).session.setScrollTop(t), (this || _global).session.setScrollLeft(e);
          }, b.prototype.scrollBy = function (e, t) {
            t && (this || _global).session.setScrollTop((this || _global).session.getScrollTop() + t), e && (this || _global).session.setScrollLeft((this || _global).session.getScrollLeft() + e);
          }, b.prototype.isScrollableBy = function (e, t) {
            return t < 0 && (this || _global).session.getScrollTop() >= 1 - (this || _global).scrollMargin.top || 0 < t && (this || _global).session.getScrollTop() + (this || _global).$size.scrollerHeight - (this || _global).layerConfig.maxHeight < -1 + (this || _global).scrollMargin.bottom || e < 0 && (this || _global).session.getScrollLeft() >= 1 - (this || _global).scrollMargin.left || 0 < e && (this || _global).session.getScrollLeft() + (this || _global).$size.scrollerWidth - (this || _global).layerConfig.width < -1 + (this || _global).scrollMargin.right || void 0;
          }, b.prototype.pixelToScreenCoordinates = function (e, t) {
            (this || _global).$hasCssTransforms ? (i = {
              top: 0,
              left: 0
            }, e = (n = (this || _global).$fontMetrics.transformCoordinates([e, t]))[1] - (this || _global).gutterWidth - (this || _global).margin.left, t = n[0]) : i = (this || _global).scroller.getBoundingClientRect();
            var n = e + (this || _global).scrollLeft - i.left - (this || _global).$padding,
              e = n / (this || _global).characterWidth,
              t = Math.floor((t + (this || _global).scrollTop - i.top) / (this || _global).lineHeight),
              i = (this || _global).$blockCursor ? Math.floor(e) : Math.round(e);
            return {
              row: t,
              column: i,
              side: 0 < e - i ? 1 : -1,
              offsetX: n
            };
          }, b.prototype.screenToTextCoordinates = function (e, t) {
            (this || _global).$hasCssTransforms ? (n = {
              top: 0,
              left: 0
            }, e = (i = (this || _global).$fontMetrics.transformCoordinates([e, t]))[1] - (this || _global).gutterWidth - (this || _global).margin.left, t = i[0]) : n = (this || _global).scroller.getBoundingClientRect();
            var n,
              i = e + (this || _global).scrollLeft - n.left - (this || _global).$padding,
              e = i / (this || _global).characterWidth,
              e = (this || _global).$blockCursor ? Math.floor(e) : Math.round(e),
              t = Math.floor((t + (this || _global).scrollTop - n.top) / (this || _global).lineHeight);
            return (this || _global).session.screenToDocumentPosition(t, Math.max(e, 0), i);
          }, b.prototype.textToScreenCoordinates = function (e, t) {
            var n = (this || _global).scroller.getBoundingClientRect(),
              t = (this || _global).session.documentToScreenPosition(e, t),
              e = (this || _global).$padding + ((this || _global).session.$bidiHandler.isBidiRow(t.row, e) ? (this || _global).session.$bidiHandler.getPosLeft(t.column) : Math.round(t.column * (this || _global).characterWidth)),
              t = t.row * (this || _global).lineHeight;
            return {
              pageX: n.left + e - (this || _global).scrollLeft,
              pageY: n.top + t - (this || _global).scrollTop
            };
          }, b.prototype.visualizeFocus = function () {
            a.addCssClass((this || _global).container, "ace_focus");
          }, b.prototype.visualizeBlur = function () {
            a.removeCssClass((this || _global).container, "ace_focus");
          }, b.prototype.showComposition = function (e) {
            ((this || _global).$composition = e).cssText || (e.cssText = (this || _global).textarea.style.cssText), null == e.useTextareaForIME && (e.useTextareaForIME = (this || _global).$useTextareaForIME), (this || _global).$useTextareaForIME ? (a.addCssClass((this || _global).textarea, "ace_composition"), (this || _global).textarea.style.cssText = "", this.$moveTextAreaToCursor(), (this || _global).$cursorLayer.element.style.display = "none") : e.markerId = (this || _global).session.addMarker(e.markerRange, "ace_composition_marker", "text");
          }, b.prototype.setCompositionText = function (e) {
            var t = (this || _global).session.selection.cursor;
            this.addToken(e, "composition_placeholder", t.row, t.column), this.$moveTextAreaToCursor();
          }, b.prototype.hideComposition = function () {
            var e;
            (this || _global).$composition && ((this || _global).$composition.markerId && (this || _global).session.removeMarker((this || _global).$composition.markerId), a.removeCssClass((this || _global).textarea, "ace_composition"), (this || _global).textarea.style.cssText = (this || _global).$composition.cssText, e = (this || _global).session.selection.cursor, this.removeExtraToken(e.row, e.column), (this || _global).$composition = null, (this || _global).$cursorLayer.element.style.display = "");
          }, b.prototype.setGhostText = function (e, t) {
            var n = (this || _global).session.selection.cursor,
              t = t || {
                row: n.row,
                column: n.column
              },
              n = (this.removeGhostText(), e.split("\n"));
            this.addToken(n[0], "ghost_text", t.row, t.column), (this || _global).$ghostText = {
              text: e,
              position: {
                row: t.row,
                column: t.column
              }
            }, 1 < n.length && ((this || _global).$ghostTextWidget = {
              text: n.slice(1).join("\n"),
              row: t.row,
              column: t.column,
              className: "ace_ghost_text"
            }, (this || _global).session.widgetManager.addLineWidget((this || _global).$ghostTextWidget));
          }, b.prototype.removeGhostText = function () {
            var e;
            (this || _global).$ghostText && (e = (this || _global).$ghostText.position, this.removeExtraToken(e.row, e.column), (this || _global).$ghostTextWidget && ((this || _global).session.widgetManager.removeLineWidget((this || _global).$ghostTextWidget), (this || _global).$ghostTextWidget = null), (this || _global).$ghostText = null);
          }, b.prototype.addToken = function (e, t, n, i) {
            var o = (this || _global).session,
              r = (o.bgTokenizer.lines[n] = null, {
                type: t,
                value: e
              }),
              s = o.getTokens(n);
            if (null != i && s.length) for (var a = 0, l = 0; l < s.length; l++) {
              var c = s[l];
              if (i <= (a += c.value.length)) {
                var h = c.value.length - (a - i),
                  d = c.value.slice(0, h),
                  h = c.value.slice(h);
                s.splice(l, 1, {
                  type: c.type,
                  value: d
                }, r, {
                  type: c.type,
                  value: h
                });
                break;
              }
            } else s.push(r);
            this.updateLines(n, n);
          }, b.prototype.removeExtraToken = function (e, t) {
            (this || _global).session.bgTokenizer.lines[e] = null, this.updateLines(e, e);
          }, b.prototype.setTheme = function (n, i) {
            var e,
              o = this || _global;
            function t(e) {
              if (o.$themeId != n) return i && i();
              if (!e || !e.cssClass) throw new Error("couldn't load module " + n + " or it didn't call define");
              e.$id && (o.$themeId = e.$id), a.importCssString(e.cssText, e.cssClass, o.container), o.theme && a.removeCssClass(o.container, o.theme.cssClass);
              var t = "padding" in e ? e.padding : "padding" in (o.theme || {}) ? 4 : o.$padding;
              o.$padding && t != o.$padding && o.setPadding(t), o.$theme = e.cssClass, o.theme = e, a.addCssClass(o.container, e.cssClass), a.setCssClass(o.container, "ace_dark", e.isDark), o.$size && (o.$size.width = 0, o.$updateSizeAsync()), o._dispatchEvent("themeLoaded", {
                theme: e
              }), i && i();
            }
            (this || _global).$themeId = n, o._dispatchEvent("themeChange", {
              theme: n
            }), n && "string" != typeof n ? t(n) : (e = n || (this || _global).$options.theme.initialValue, r.loadModule(["theme", e], t));
          }, b.prototype.getTheme = function () {
            return (this || _global).$themeId;
          }, b.prototype.setStyle = function (e, t) {
            a.setCssClass((this || _global).container, e, !1 !== t);
          }, b.prototype.unsetStyle = function (e) {
            a.removeCssClass((this || _global).container, e);
          }, b.prototype.setCursorStyle = function (e) {
            a.setStyle((this || _global).scroller.style, "cursor", e);
          }, b.prototype.setMouseCursor = function (e) {
            a.setStyle((this || _global).scroller.style, "cursor", e);
          }, b.prototype.attachToShadowRoot = function () {
            a.importCssString(y, "ace_editor.css", (this || _global).container);
          }, b.prototype.destroy = function () {
            this.freeze(), (this || _global).$fontMetrics.destroy(), (this || _global).$cursorLayer.destroy(), this.removeAllListeners(), (this || _global).container.textContent = "", this.setOption("useResizeObserver", !1);
          }, b.prototype.$updateCustomScrollbar = function (e) {
            var t = this || _global;
            (this || _global).$horizScroll = (this || _global).$vScroll = null, (this || _global).scrollBarV.element.remove(), (this || _global).scrollBarH.element.remove(), (this || _global).$scrollDecorator && delete (this || _global).$scrollDecorator, !0 === e ? ((this || _global).scrollBarV = new p((this || _global).container, this || _global), (this || _global).scrollBarH = new g((this || _global).container, this || _global), (this || _global).scrollBarV.setHeight((this || _global).$size.scrollerHeight), (this || _global).scrollBarH.setWidth((this || _global).$size.scrollerWidth), (this || _global).scrollBarV.addEventListener("scroll", function (e) {
              t.$scrollAnimation || t.session.setScrollTop(e.data - t.scrollMargin.top);
            }), (this || _global).scrollBarH.addEventListener("scroll", function (e) {
              t.$scrollAnimation || t.session.setScrollLeft(e.data - t.scrollMargin.left);
            }), (this || _global).$scrollDecorator = new v((this || _global).scrollBarV, this || _global), (this || _global).$scrollDecorator.$updateDecorators()) : ((this || _global).scrollBarV = new u((this || _global).container, this || _global), (this || _global).scrollBarH = new d((this || _global).container, this || _global), (this || _global).scrollBarV.addEventListener("scroll", function (e) {
              t.$scrollAnimation || t.session.setScrollTop(e.data - t.scrollMargin.top);
            }), (this || _global).scrollBarH.addEventListener("scroll", function (e) {
              t.$scrollAnimation || t.session.setScrollLeft(e.data - t.scrollMargin.left);
            }));
          }, b.prototype.$addResizeObserver = function () {
            var n;
            window.ResizeObserver && !(this || _global).$resizeObserver && ((n = this || _global).$resizeTimer = o.delayedCall(function () {
              n.destroyed || n.onResize();
            }, 50), (this || _global).$resizeObserver = new window.ResizeObserver(function (e) {
              var t = e[0].contentRect.width,
                e = e[0].contentRect.height;
              1 < Math.abs(n.$size.width - t) || 1 < Math.abs(n.$size.height - e) ? n.$resizeTimer.delay() : n.$resizeTimer.cancel();
            }), (this || _global).$resizeObserver.observe((this || _global).container));
          }, b);
        function b(e, t) {
          var n = this || _global,
            e = ((this || _global).container = e || a.createElement("div"), a.addCssClass((this || _global).container, "ace_editor"), a.HI_DPI && a.addCssClass((this || _global).container, "ace_hidpi"), this.setTheme(t), null == r.get("useStrictCSP") && r.set("useStrictCSP", !1), (this || _global).$gutter = a.createElement("div"), (this || _global).$gutter.className = "ace_gutter", (this || _global).container.appendChild((this || _global).$gutter), (this || _global).$gutter.setAttribute("aria-hidden", !0), (this || _global).scroller = a.createElement("div"), (this || _global).scroller.className = "ace_scroller", (this || _global).container.appendChild((this || _global).scroller), (this || _global).content = a.createElement("div"), (this || _global).content.className = "ace_content", (this || _global).scroller.appendChild((this || _global).content), (this || _global).$gutterLayer = new s((this || _global).$gutter), (this || _global).$gutterLayer.on("changeGutterWidth", (this || _global).onGutterResize.bind(this || _global)), (this || _global).$markerBack = new l((this || _global).content), (this || _global).$textLayer = new c((this || _global).content));
          (this || _global).canvas = e.element, (this || _global).$markerFront = new l((this || _global).content), (this || _global).$cursorLayer = new h((this || _global).content), (this || _global).$horizScroll = !1, (this || _global).$vScroll = !1, (this || _global).scrollBar = (this || _global).scrollBarV = new u((this || _global).container, this || _global), (this || _global).scrollBarH = new d((this || _global).container, this || _global), (this || _global).scrollBarV.on("scroll", function (e) {
            n.$scrollAnimation || n.session.setScrollTop(e.data - n.scrollMargin.top);
          }), (this || _global).scrollBarH.on("scroll", function (e) {
            n.$scrollAnimation || n.session.setScrollLeft(e.data - n.scrollMargin.left);
          }), (this || _global).scrollTop = 0, (this || _global).scrollLeft = 0, (this || _global).cursorPos = {
            row: 0,
            column: 0
          }, (this || _global).$fontMetrics = new f((this || _global).container), (this || _global).$textLayer.$setFontMetrics((this || _global).$fontMetrics), (this || _global).$textLayer.on("changeCharacterSize", function (e) {
            n.updateCharacterSize(), n.onResize(!0, n.gutterWidth, n.$size.width, n.$size.height), n._signal("changeCharacterSize", e);
          }), (this || _global).$size = {
            width: 0,
            height: 0,
            scrollerHeight: 0,
            scrollerWidth: 0,
            $dirty: !0
          }, (this || _global).layerConfig = {
            width: 1,
            padding: 0,
            firstRow: 0,
            firstRowScreen: 0,
            lastRow: 0,
            lineHeight: 0,
            characterWidth: 0,
            minHeight: 1,
            maxHeight: 1,
            offset: 0,
            height: 1,
            gutterOffset: 1
          }, (this || _global).scrollMargin = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            v: 0,
            h: 0
          }, (this || _global).margin = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            v: 0,
            h: 0
          }, (this || _global).$keepTextAreaAtCursor = !I.isIOS, (this || _global).$loop = new m((this || _global).$renderChanges.bind(this || _global), (this || _global).container.ownerDocument.defaultView), (this || _global).$loop.schedule((this || _global).CHANGE_FULL), this.updateCharacterSize(), this.setPadding(4), this.$addResizeObserver(), r.resetOptions(this || _global), r._signal("renderer", this || _global);
        }
        e.prototype.CHANGE_CURSOR = 1, e.prototype.CHANGE_MARKER = 2, e.prototype.CHANGE_GUTTER = 4, e.prototype.CHANGE_SCROLL = 8, e.prototype.CHANGE_LINES = 16, e.prototype.CHANGE_TEXT = 32, e.prototype.CHANGE_SIZE = 64, e.prototype.CHANGE_MARKER_BACK = 128, e.prototype.CHANGE_MARKER_FRONT = 256, e.prototype.CHANGE_FULL = 512, e.prototype.CHANGE_H_SCROLL = 1024, e.prototype.$changes = 0, e.prototype.$padding = null, e.prototype.$frozen = !1, e.prototype.STEPS = 8, i.implement(e.prototype, C), r.defineOptions(e.prototype, "renderer", {
          useResizeObserver: {
            set: function (e) {
              !e && (this || _global).$resizeObserver ? ((this || _global).$resizeObserver.disconnect(), (this || _global).$resizeTimer.cancel(), (this || _global).$resizeTimer = (this || _global).$resizeObserver = null) : e && !(this || _global).$resizeObserver && this.$addResizeObserver();
            }
          },
          animatedScroll: {
            initialValue: !1
          },
          showInvisibles: {
            set: function (e) {
              (this || _global).$textLayer.setShowInvisibles(e) && (this || _global).$loop.schedule((this || _global).CHANGE_TEXT);
            },
            initialValue: !1
          },
          showPrintMargin: {
            set: function () {
              this.$updatePrintMargin();
            },
            initialValue: !0
          },
          printMarginColumn: {
            set: function () {
              this.$updatePrintMargin();
            },
            initialValue: 80
          },
          printMargin: {
            set: function (e) {
              "number" == typeof e && ((this || _global).$printMarginColumn = e), (this || _global).$showPrintMargin = !!e, this.$updatePrintMargin();
            },
            get: function () {
              return (this || _global).$showPrintMargin && (this || _global).$printMarginColumn;
            }
          },
          showGutter: {
            set: function (e) {
              (this || _global).$gutter.style.display = e ? "block" : "none", (this || _global).$loop.schedule((this || _global).CHANGE_FULL), this.onGutterResize();
            },
            initialValue: !0
          },
          useSvgGutterIcons: {
            set: function (e) {
              (this || _global).$gutterLayer.$useSvgGutterIcons = e;
            },
            initialValue: !1
          },
          showFoldedAnnotations: {
            set: function (e) {
              (this || _global).$gutterLayer.$showFoldedAnnotations = e;
            },
            initialValue: !1
          },
          fadeFoldWidgets: {
            set: function (e) {
              a.setCssClass((this || _global).$gutter, "ace_fade-fold-widgets", e);
            },
            initialValue: !1
          },
          showFoldWidgets: {
            set: function (e) {
              (this || _global).$gutterLayer.setShowFoldWidgets(e), (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
            },
            initialValue: !0
          },
          displayIndentGuides: {
            set: function (e) {
              (this || _global).$textLayer.setDisplayIndentGuides(e) && (this || _global).$loop.schedule((this || _global).CHANGE_TEXT);
            },
            initialValue: !0
          },
          highlightIndentGuides: {
            set: function (e) {
              1 == (this || _global).$textLayer.setHighlightIndentGuides(e) ? (this || _global).$textLayer.$highlightIndentGuide() : (this || _global).$textLayer.$clearActiveIndentGuide((this || _global).$textLayer.$lines.cells);
            },
            initialValue: !0
          },
          highlightGutterLine: {
            set: function (e) {
              (this || _global).$gutterLayer.setHighlightGutterLine(e), (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
            },
            initialValue: !0
          },
          hScrollBarAlwaysVisible: {
            set: function (e) {
              (this || _global).$hScrollBarAlwaysVisible && (this || _global).$horizScroll || (this || _global).$loop.schedule((this || _global).CHANGE_SCROLL);
            },
            initialValue: !1
          },
          vScrollBarAlwaysVisible: {
            set: function (e) {
              (this || _global).$vScrollBarAlwaysVisible && (this || _global).$vScroll || (this || _global).$loop.schedule((this || _global).CHANGE_SCROLL);
            },
            initialValue: !1
          },
          fontSize: {
            set: function (e) {
              "number" == typeof e && (e += "px"), (this || _global).container.style.fontSize = e, this.updateFontSize();
            },
            initialValue: 12
          },
          fontFamily: {
            set: function (e) {
              (this || _global).container.style.fontFamily = e, this.updateFontSize();
            }
          },
          maxLines: {
            set: function (e) {
              this.updateFull();
            }
          },
          minLines: {
            set: function (e) {
              (this || _global).$minLines < 562949953421311 || ((this || _global).$minLines = 0), this.updateFull();
            }
          },
          maxPixelHeight: {
            set: function (e) {
              this.updateFull();
            },
            initialValue: 0
          },
          scrollPastEnd: {
            set: function (e) {
              (this || _global).$scrollPastEnd != (e = +e || 0) && ((this || _global).$scrollPastEnd = e, (this || _global).$loop.schedule((this || _global).CHANGE_SCROLL));
            },
            initialValue: 0,
            handlesSet: !0
          },
          fixedWidthGutter: {
            set: function (e) {
              (this || _global).$gutterLayer.$fixedWidth = !!e, (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
            }
          },
          customScrollbar: {
            set: function (e) {
              this.$updateCustomScrollbar(e);
            },
            initialValue: !1
          },
          theme: {
            set: function (e) {
              this.setTheme(e);
            },
            get: function () {
              return (this || _global).$themeId || (this || _global).theme;
            },
            initialValue: "./theme/textmate",
            handlesSet: !0
          },
          hasCssTransforms: {},
          useTextareaForIME: {
            initialValue: !I.isMobile && !I.isIE
          }
        }), t.VirtualRenderer = e;
      }), ace.define("ace/worker/worker_client", ["require", "exports", "module", "ace/lib/oop", "ace/lib/net", "ace/lib/event_emitter", "ace/config"], function (a, e, t) {
        "use strict";

        var n = a("../lib/oop"),
          i = a("../lib/net"),
          c = a("../lib/event_emitter").EventEmitter,
          h = a("../config");
        function l(e) {
          var t;
          return "undefined" == typeof Worker ? {
            postMessage: function () {},
            terminate: function () {}
          } : h.get("loadWorkerFromBlob") ? (t = function (t) {
            t = "importScripts('" + i.qualifyURL(t) + "');";
            try {
              return new Blob([t], {
                type: "application/javascript"
              });
            } catch (e) {
              var n = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder)();
              return n.append(t), n.getBlob("application/javascript");
            }
          }(e), t = (window.URL || window.webkitURL).createObjectURL(t), new Worker(t)) : new Worker(e);
        }
        function d(e) {
          e.postMessage || (e = (this || _global).$createWorkerFromOldConfig.apply(this || _global, arguments)), (this || _global).$worker = e, (this || _global).$sendDeltaQueue = (this || _global).$sendDeltaQueue.bind(this || _global), (this || _global).changeListener = (this || _global).changeListener.bind(this || _global), (this || _global).onMessage = (this || _global).onMessage.bind(this || _global), (this || _global).callbackId = 1, (this || _global).callbacks = {}, (this || _global).$worker.onmessage = (this || _global).onMessage;
        }
        (function () {
          n.implement(this || _global, c), (this || _global).$createWorkerFromOldConfig = function (e, t, n, i, o) {
            var r, s;
            return a.nameToUrl && !a.toUrl && (a.toUrl = a.nameToUrl), h.get("packaged") || !a.toUrl ? i = i || h.moduleUrl(t, "worker") : (r = (this || _global).$normalizePath, i = i || r(a.toUrl("ace/worker/worker.js", null, "_")), s = {}, e.forEach(function (e) {
              s[e] = r(a.toUrl(e, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
            })), (this || _global).$worker = l(i), o && this.send("importScripts", o), (this || _global).$worker.postMessage({
              init: !0,
              tlns: s,
              module: t,
              classname: n
            }), (this || _global).$worker;
          }, (this || _global).onMessage = function (e) {
            var t = e.data;
            switch (t.type) {
              case "event":
                this._signal(t.name, {
                  data: t.data
                });
                break;
              case "call":
                var n = (this || _global).callbacks[t.id];
                n && (n(t.data), delete (this || _global).callbacks[t.id]);
                break;
              case "error":
                this.reportError(t.data);
                break;
              case "log":
                window.console && console.log && console.log.apply(console, t.data);
            }
          }, (this || _global).reportError = function (e) {
            window.console && console.error && console.error(e);
          }, (this || _global).$normalizePath = function (e) {
            return i.qualifyURL(e);
          }, (this || _global).terminate = function () {
            this._signal("terminate", {}), (this || _global).deltaQueue = null, (this || _global).$worker.terminate(), (this || _global).$worker = null, (this || _global).$doc && (this || _global).$doc.off("change", (this || _global).changeListener), (this || _global).$doc = null;
          }, (this || _global).send = function (e, t) {
            (this || _global).$worker.postMessage({
              command: e,
              args: t
            });
          }, (this || _global).call = function (e, t, n) {
            var i;
            n && (i = (this || _global).callbackId++, (this || _global).callbacks[i] = n, t.push(i)), this.send(e, t);
          }, (this || _global).emit = function (e, t) {
            try {
              t.data && t.data.err && (t.data.err = {
                message: t.data.err.message,
                stack: t.data.err.stack,
                code: t.data.err.code
              }), (this || _global).$worker && (this || _global).$worker.postMessage({
                event: e,
                data: {
                  data: t.data
                }
              });
            } catch (e) {
              console.error(e.stack);
            }
          }, (this || _global).attachToDocument = function (e) {
            (this || _global).$doc && this.terminate(), (this || _global).$doc = e, this.call("setValue", [e.getValue()]), e.on("change", (this || _global).changeListener, !0);
          }, (this || _global).changeListener = function (e) {
            (this || _global).deltaQueue || ((this || _global).deltaQueue = [], setTimeout((this || _global).$sendDeltaQueue, 0)), "insert" == e.action ? (this || _global).deltaQueue.push(e.start, e.lines) : (this || _global).deltaQueue.push(e.start, e.end);
          }, (this || _global).$sendDeltaQueue = function () {
            var e = (this || _global).deltaQueue;
            e && ((this || _global).deltaQueue = null, 50 < e.length && e.length > (this || _global).$doc.getLength() >> 1 ? this.call("setValue", [(this || _global).$doc.getValue()]) : this.emit("change", {
              data: e
            }));
          };
        }).call(d.prototype);
        e.UIWorkerClient = function (e, t, n) {
          var i = null,
            o = !1,
            r = Object.create(c),
            s = [],
            a = new d({
              messageBuffer: s,
              terminate: function () {},
              postMessage: function (e) {
                s.push(e), i && (o ? setTimeout(l) : l());
              }
            }),
            l = (a.setEmitSync = function (e) {
              o = e;
            }, function () {
              var e = s.shift();
              e.command ? i[e.command].apply(i, e.args) : e.event && r._signal(e.event, e.data);
            });
          return r.postMessage = function (e) {
            a.onMessage({
              data: e
            });
          }, r.callback = function (e, t) {
            this.postMessage({
              type: "call",
              id: t,
              data: e
            });
          }, r.emit = function (e, t) {
            this.postMessage({
              type: "event",
              name: e,
              data: t
            });
          }, h.loadModule(["worker", t], function (e) {
            for (i = new e[n](r); s.length;) l();
          }), a;
        }, e.WorkerClient = d, e.createWorker = l;
      }), ace.define("ace/placeholder", ["require", "exports", "module", "ace/range", "ace/lib/event_emitter", "ace/lib/oop"], function (e, t, n) {
        "use strict";

        var l = e("./range").Range,
          i = e("./lib/event_emitter").EventEmitter,
          e = e("./lib/oop"),
          o = (r.prototype.setup = function () {
            var t = this || _global,
              n = (this || _global).doc,
              e = (this || _global).session,
              i = ((this || _global).selectionBefore = e.selection.toJSON(), e.selection.inMultiSelectMode && e.selection.toSingleRange(), (this || _global).pos = n.createAnchor((this || _global).$pos.row, (this || _global).$pos.column), (this || _global).pos);
            i.$insertRight = !0, i.detach(), i.markerId = e.addMarker(new l(i.row, i.column, i.row, i.column + (this || _global).length), (this || _global).mainClass, null, !1), (this || _global).others = [], (this || _global).$others.forEach(function (e) {
              e = n.createAnchor(e.row, e.column);
              e.$insertRight = !0, e.detach(), t.others.push(e);
            }), e.setUndoSelect(!1);
          }, r.prototype.showOtherMarkers = function () {
            var t, n;
            (this || _global).othersActive || (t = (this || _global).session, (n = this || _global).othersActive = !0, (this || _global).others.forEach(function (e) {
              e.markerId = t.addMarker(new l(e.row, e.column, e.row, e.column + n.length), n.othersClass, null, !1);
            }));
          }, r.prototype.hideOtherMarkers = function () {
            if ((this || _global).othersActive) {
              (this || _global).othersActive = !1;
              for (var e = 0; e < (this || _global).others.length; e++) (this || _global).session.removeMarker((this || _global).others[e].markerId);
            }
          }, r.prototype.onUpdate = function (e) {
            if ((this || _global).$updating) return this.updateAnchors(e);
            var t = e;
            if (t.start.row === t.end.row && t.start.row === (this || _global).pos.row) {
              (this || _global).$updating = !0;
              var n = "insert" === e.action ? t.end.column - t.start.column : t.start.column - t.end.column,
                i = t.start.column >= (this || _global).pos.column && t.start.column <= (this || _global).pos.column + (this || _global).length + 1,
                o = t.start.column - (this || _global).pos.column;
              if (this.updateAnchors(e), i && ((this || _global).length += n), i && !(this || _global).session.$fromUndo) if ("insert" === e.action) for (var r = (this || _global).others.length - 1; 0 <= r; r--) {
                var s = {
                  row: (a = (this || _global).others[r]).row,
                  column: a.column + o
                };
                (this || _global).doc.insertMergedLines(s, e.lines);
              } else if ("remove" === e.action) for (r = (this || _global).others.length - 1; 0 <= r; r--) {
                var a,
                  s = {
                    row: (a = (this || _global).others[r]).row,
                    column: a.column + o
                  };
                (this || _global).doc.remove(new l(s.row, s.column, s.row, s.column - n));
              }
              (this || _global).$updating = !1, this.updateMarkers();
            }
          }, r.prototype.updateAnchors = function (e) {
            (this || _global).pos.onChange(e);
            for (var t = (this || _global).others.length; t--;) (this || _global).others[t].onChange(e);
            this.updateMarkers();
          }, r.prototype.updateMarkers = function () {
            if (!(this || _global).$updating) {
              var n = this || _global,
                i = (this || _global).session,
                e = function (e, t) {
                  i.removeMarker(e.markerId), e.markerId = i.addMarker(new l(e.row, e.column, e.row, e.column + n.length), t, null, !1);
                };
              e((this || _global).pos, (this || _global).mainClass);
              for (var t = (this || _global).others.length; t--;) e((this || _global).others[t], (this || _global).othersClass);
            }
          }, r.prototype.onCursorChange = function (e) {
            var t;
            !(this || _global).$updating && (this || _global).session && ((t = (this || _global).session.selection.getCursor()).row === (this || _global).pos.row && t.column >= (this || _global).pos.column && t.column <= (this || _global).pos.column + (this || _global).length ? (this.showOtherMarkers(), this._emit("cursorEnter", e)) : (this.hideOtherMarkers(), this._emit("cursorLeave", e)));
          }, r.prototype.detach = function () {
            (this || _global).session.removeMarker((this || _global).pos && (this || _global).pos.markerId), this.hideOtherMarkers(), (this || _global).doc.off("change", (this || _global).$onUpdate), (this || _global).session.selection.off("changeCursor", (this || _global).$onCursorChange), (this || _global).session.setUndoSelect(!0), (this || _global).session = null;
          }, r.prototype.cancel = function () {
            if (-1 !== (this || _global).$undoStackDepth) {
              for (var e = (this || _global).session.getUndoManager(), t = (e.$undoStack || e.$undostack).length - (this || _global).$undoStackDepth, n = 0; n < t; n++) e.undo((this || _global).session, !0);
              (this || _global).selectionBefore && (this || _global).session.selection.fromJSON((this || _global).selectionBefore);
            }
          }, r);
        function r(e, t, n, i, o, r) {
          var s = this || _global,
            t = ((this || _global).length = t, (this || _global).session = e, (this || _global).doc = e.getDocument(), (this || _global).mainClass = o, (this || _global).othersClass = r, (this || _global).$onUpdate = (this || _global).onUpdate.bind(this || _global), (this || _global).doc.on("change", (this || _global).$onUpdate, !0), (this || _global).$others = i, (this || _global).$onCursorChange = function () {
              setTimeout(function () {
                s.onCursorChange();
              });
            }, (this || _global).$pos = n, e.getUndoManager().$undoStack || e.getUndoManager().$undostack || {
              length: -1
            });
          (this || _global).$undoStackDepth = t.length, this.setup(), e.selection.on("changeCursor", (this || _global).$onCursorChange);
        }
        e.implement(o.prototype, i), t.PlaceHolder = o;
      }), ace.define("ace/mouse/multi_select_handler", ["require", "exports", "module", "ace/lib/event", "ace/lib/useragent"], function (e, t, n) {
        var x = e("../lib/event"),
          k = e("../lib/useragent");
        function E(e, t) {
          return e.row == t.row && e.column == t.column;
        }
        t.onMouseDown = function (e) {
          var t = e.domEvent,
            n = t.altKey,
            i = t.shiftKey,
            o = t.ctrlKey,
            r = e.getAccelKey(),
            s = e.getButton();
          if (o && k.isMac && (s = t.button), e.editor.inMultiSelectMode && 2 == s) e.editor.textInput.onContextMenu(e.domEvent);else if (o || n || r) {
            if (0 === s) {
              var a,
                l,
                c,
                h,
                d,
                u,
                g,
                p,
                m = e.editor,
                f = m.selection,
                C = m.inMultiSelectMode,
                y = e.getDocumentPosition(),
                v = f.getCursor(),
                v = e.inSelection() || f.isEmpty() && E(y, v),
                I = e.x,
                b = e.y,
                A = m.session,
                w = m.renderer.pixelToScreenCoordinates(I, b),
                S = w;
              if (m.$mouseHandler.$enableJumpToDef) o && n || r && n ? a = i ? "block" : "add" : n && m.$blockSelectEnabled && (a = "block");else if (r && !n) {
                if (a = "add", !C && i) return;
              } else n && m.$blockSelectEnabled && (a = "block");
              if (a && k.isMac && t.ctrlKey && m.$mouseHandler.cancelContextMenu(), "add" == a) !C && v || (C || (l = f.toOrientedRange(), m.addSelectionMarker(l)), c = f.rangeList.rangeAtPoint(y), m.inVirtualSelectionMode = !0, i && (c = null, l = f.ranges[0] || l, m.removeSelectionMarker(l)), m.once("mouseup", function () {
                var e = f.toOrientedRange();
                c && e.isEmpty() && E(c.cursor, e.cursor) ? f.substractPoint(e.cursor) : (i ? f.substractPoint(l.cursor) : l && (m.removeSelectionMarker(l), f.addRange(l)), f.addRange(e)), m.inVirtualSelectionMode = !1;
              }));else if ("block" == a) return e.stop(), m.inVirtualSelectionMode = !0, d = [], u = function () {
                var e = m.renderer.pixelToScreenCoordinates(I, b),
                  t = A.screenToDocumentPosition(e.row, e.column, e.offsetX);
                E(S, e) && E(t, f.lead) || (S = e, m.selection.moveToPosition(t), m.renderer.scrollCursorIntoView(), m.removeSelectionMarkers(d), d = f.rectangularRangeBlock(S, w), m.$mouseHandler.$clickSelection && 1 == d.length && d[0].isEmpty() && (d[0] = m.$mouseHandler.$clickSelection.clone()), d.forEach(m.addSelectionMarker, m), m.updateSelectionMarkers());
              }, C && !r ? f.toSingleRange() : !C && r && (h = f.toOrientedRange(), m.addSelectionMarker(h)), i ? w = A.documentToScreenPosition(f.lead) : f.moveToPosition(y), S = {
                row: -1,
                column: -1
              }, g = u, x.capture(m.container, function (e) {
                I = e.clientX, b = e.clientY;
              }, function (e) {
                u(), clearInterval(p), m.removeSelectionMarkers(d), d.length || (d = [f.toOrientedRange()]), h && (m.removeSelectionMarker(h), f.toSingleRange(h));
                for (var t = 0; t < d.length; t++) f.addRange(d[t]);
                m.inVirtualSelectionMode = !1, m.$mouseHandler.$clickSelection = null;
              }), p = setInterval(function () {
                g();
              }, 20), e.preventDefault();
            }
          } else 0 === s && e.editor.inMultiSelectMode && e.editor.exitMultiSelectMode();
        };
      }), ace.define("ace/commands/multi_select_commands", ["require", "exports", "module", "ace/keyboard/hash_handler"], function (e, t, n) {
        t.defaultCommands = [{
          name: "addCursorAbove",
          description: "Add cursor above",
          exec: function (e) {
            e.selectMoreLines(-1);
          },
          bindKey: {
            win: "Ctrl-Alt-Up",
            mac: "Ctrl-Alt-Up"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "addCursorBelow",
          description: "Add cursor below",
          exec: function (e) {
            e.selectMoreLines(1);
          },
          bindKey: {
            win: "Ctrl-Alt-Down",
            mac: "Ctrl-Alt-Down"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "addCursorAboveSkipCurrent",
          description: "Add cursor above (skip current)",
          exec: function (e) {
            e.selectMoreLines(-1, !0);
          },
          bindKey: {
            win: "Ctrl-Alt-Shift-Up",
            mac: "Ctrl-Alt-Shift-Up"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "addCursorBelowSkipCurrent",
          description: "Add cursor below (skip current)",
          exec: function (e) {
            e.selectMoreLines(1, !0);
          },
          bindKey: {
            win: "Ctrl-Alt-Shift-Down",
            mac: "Ctrl-Alt-Shift-Down"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectMoreBefore",
          description: "Select more before",
          exec: function (e) {
            e.selectMore(-1);
          },
          bindKey: {
            win: "Ctrl-Alt-Left",
            mac: "Ctrl-Alt-Left"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectMoreAfter",
          description: "Select more after",
          exec: function (e) {
            e.selectMore(1);
          },
          bindKey: {
            win: "Ctrl-Alt-Right",
            mac: "Ctrl-Alt-Right"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectNextBefore",
          description: "Select next before",
          exec: function (e) {
            e.selectMore(-1, !0);
          },
          bindKey: {
            win: "Ctrl-Alt-Shift-Left",
            mac: "Ctrl-Alt-Shift-Left"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectNextAfter",
          description: "Select next after",
          exec: function (e) {
            e.selectMore(1, !0);
          },
          bindKey: {
            win: "Ctrl-Alt-Shift-Right",
            mac: "Ctrl-Alt-Shift-Right"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "toggleSplitSelectionIntoLines",
          description: "Split selection into lines",
          exec: function (e) {
            1 < e.multiSelect.rangeCount ? e.multiSelect.joinSelections() : e.multiSelect.splitIntoLines();
          },
          bindKey: {
            win: "Ctrl-Alt-L",
            mac: "Ctrl-Alt-L"
          },
          readOnly: !0
        }, {
          name: "splitSelectionIntoLines",
          description: "Split into lines",
          exec: function (e) {
            e.multiSelect.splitIntoLines();
          },
          readOnly: !0
        }, {
          name: "alignCursors",
          description: "Align cursors",
          exec: function (e) {
            e.alignCursors();
          },
          bindKey: {
            win: "Ctrl-Alt-A",
            mac: "Ctrl-Alt-A"
          },
          scrollIntoView: "cursor"
        }, {
          name: "findAll",
          description: "Find all",
          exec: function (e) {
            e.findAll();
          },
          bindKey: {
            win: "Ctrl-Alt-K",
            mac: "Ctrl-Alt-G"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }], t.multiSelectCommands = [{
          name: "singleSelection",
          description: "Single selection",
          bindKey: "esc",
          exec: function (e) {
            e.exitMultiSelectMode();
          },
          scrollIntoView: "cursor",
          readOnly: !0,
          isAvailable: function (e) {
            return e && e.inMultiSelectMode;
          }
        }];
        e = e("../keyboard/hash_handler").HashHandler;
        t.keyboardHandler = new e(t.multiSelectCommands);
      }), ace.define("ace/multi_select", ["require", "exports", "module", "ace/range_list", "ace/range", "ace/selection", "ace/mouse/multi_select_handler", "ace/lib/event", "ace/lib/lang", "ace/commands/multi_select_commands", "ace/search", "ace/edit_session", "ace/editor", "ace/config"], function (e, o, t) {
        var n = e("./range_list").RangeList,
          I = e("./range").Range,
          u = e("./selection").Selection,
          r = e("./mouse/multi_select_handler").onMouseDown,
          s = e("./lib/event"),
          g = e("./lib/lang"),
          a = e("./commands/multi_select_commands");
        o.commands = a.defaultCommands.concat(a.multiSelectCommands);
        var l = new (e("./search").Search)();
        var i = e("./edit_session").EditSession,
          i = (!function () {
            (this || _global).getSelectionMarkers = function () {
              return (this || _global).$selectionMarkers;
            };
          }.call(i.prototype), !function () {
            (this || _global).ranges = null, (this || _global).rangeList = null, (this || _global).addRange = function (e, t) {
              if (e) {
                if (!(this || _global).inMultiSelectMode && 0 === (this || _global).rangeCount) {
                  var n = this.toOrientedRange();
                  if ((this || _global).rangeList.add(n), (this || _global).rangeList.add(e), 2 != (this || _global).rangeList.ranges.length) return (this || _global).rangeList.removeAll(), t || this.fromOrientedRange(e);
                  (this || _global).rangeList.removeAll(), (this || _global).rangeList.add(n), this.$onAddRange(n);
                }
                e.cursor || (e.cursor = e.end);
                n = (this || _global).rangeList.add(e);
                return this.$onAddRange(e), n.length && this.$onRemoveRange(n), 1 < (this || _global).rangeCount && !(this || _global).inMultiSelectMode && (this._signal("multiSelect"), (this || _global).inMultiSelectMode = !0, (this || _global).session.$undoSelect = !1, (this || _global).rangeList.attach((this || _global).session)), t || this.fromOrientedRange(e);
              }
            }, (this || _global).toSingleRange = function (e) {
              e = e || (this || _global).ranges[0];
              var t = (this || _global).rangeList.removeAll();
              t.length && this.$onRemoveRange(t), e && this.fromOrientedRange(e);
            }, (this || _global).substractPoint = function (e) {
              e = (this || _global).rangeList.substractPoint(e);
              if (e) return this.$onRemoveRange(e), e[0];
            }, (this || _global).mergeOverlappingRanges = function () {
              var e = (this || _global).rangeList.merge();
              e.length && this.$onRemoveRange(e);
            }, (this || _global).$onAddRange = function (e) {
              (this || _global).rangeCount = (this || _global).rangeList.ranges.length, (this || _global).ranges.unshift(e), this._signal("addRange", {
                range: e
              });
            }, (this || _global).$onRemoveRange = function (e) {
              var t;
              (this || _global).rangeCount = (this || _global).rangeList.ranges.length, 1 == (this || _global).rangeCount && (this || _global).inMultiSelectMode && (t = (this || _global).rangeList.ranges.pop(), e.push(t), (this || _global).rangeCount = 0);
              for (var n = e.length; n--;) {
                var i = (this || _global).ranges.indexOf(e[n]);
                (this || _global).ranges.splice(i, 1);
              }
              this._signal("removeRange", {
                ranges: e
              }), 0 === (this || _global).rangeCount && (this || _global).inMultiSelectMode && ((this || _global).inMultiSelectMode = !1, this._signal("singleSelect"), (this || _global).session.$undoSelect = !0, (this || _global).rangeList.detach((this || _global).session)), (t = t || (this || _global).ranges[0]) && !t.isEqual(this.getRange()) && this.fromOrientedRange(t);
            }, (this || _global).$initRangeList = function () {
              (this || _global).rangeList || ((this || _global).rangeList = new n(), (this || _global).ranges = [], (this || _global).rangeCount = 0);
            }, (this || _global).getAllRanges = function () {
              return (this || _global).rangeCount ? (this || _global).rangeList.ranges.concat() : [this.getRange()];
            }, (this || _global).splitIntoLines = function () {
              for (var e = (this || _global).ranges.length ? (this || _global).ranges : [this.getRange()], t = [], n = 0; n < e.length; n++) {
                var i = e[n],
                  o = i.start.row,
                  r = i.end.row;
                if (o === r) t.push(i.clone());else {
                  for (t.push(new I(o, i.start.column, o, (this || _global).session.getLine(o).length)); ++o < r;) t.push(this.getLineRange(o, !0));
                  t.push(new I(r, 0, r, i.end.column));
                }
                0 != n || this.isBackwards() || (t = t.reverse());
              }
              this.toSingleRange();
              for (n = t.length; n--;) this.addRange(t[n]);
            }, (this || _global).joinSelections = function () {
              var e = (this || _global).rangeList.ranges,
                t = e[e.length - 1],
                e = I.fromPoints(e[0].start, t.end);
              this.toSingleRange(), this.setSelectionRange(e, t.cursor == t.start);
            }, (this || _global).toggleBlockSelection = function () {
              var e, t;
              1 < (this || _global).rangeCount ? (t = (e = (this || _global).rangeList.ranges)[e.length - 1], e = I.fromPoints(e[0].start, t.end), this.toSingleRange(), this.setSelectionRange(e, t.cursor == t.start)) : (e = (this || _global).session.documentToScreenPosition((this || _global).cursor), t = (this || _global).session.documentToScreenPosition((this || _global).anchor), this.rectangularRangeBlock(e, t).forEach((this || _global).addRange, this || _global));
            }, (this || _global).rectangularRangeBlock = function (e, t, n) {
              var i,
                o,
                r,
                s,
                a,
                l,
                c,
                h = [],
                d = e.column < t.column,
                u = (s = (d ? (i = e.column, o = t.column, r = e.offsetX, t) : (i = t.column, o = e.column, r = t.offsetX, e)).offsetX, e.row < t.row);
              l = (u ? (a = e.row, t) : (a = t.row, e)).row, i < 0 && (i = 0), (a = a < 0 ? 0 : a) == l && (n = !0);
              for (var g, p, m = a; m <= l; m++) {
                var f = I.fromPoints((this || _global).session.screenToDocumentPosition(m, i, r), (this || _global).session.screenToDocumentPosition(m, o, s));
                if (f.isEmpty()) {
                  if (c && (g = f.end, p = c, g.row == p.row) && g.column == p.column) break;
                  c = f.end;
                }
                f.cursor = d ? f.start : f.end, h.push(f);
              }
              if (u && h.reverse(), !n) {
                for (var C = h.length - 1; h[C].isEmpty() && 0 < C;) C--;
                if (0 < C) for (var y = 0; h[y].isEmpty();) y++;
                for (var v = C; y <= v; v--) h[v].isEmpty() && h.splice(v, 1);
              }
              return h;
            };
          }.call(u.prototype), e("./editor").Editor);
        function c(e) {
          var t, n;
          function i(e) {
            n && (t.renderer.setMouseCursor(""), n = !1);
          }
          e.$multiselectOnSessionChange || (e.$onAddRange = e.$onAddRange.bind(e), e.$onRemoveRange = e.$onRemoveRange.bind(e), e.$onMultiSelect = e.$onMultiSelect.bind(e), e.$onSingleSelect = e.$onSingleSelect.bind(e), e.$multiselectOnSessionChange = o.onSessionChange.bind(e), e.$checkMultiselectChange = e.$checkMultiselectChange.bind(e), e.$multiselectOnSessionChange(e), e.on("changeSession", e.$multiselectOnSessionChange), e.on("mousedown", r), e.commands.addCommands(a.defaultCommands), (t = e).textInput && (e = t.textInput.getElement(), n = !1, s.addListener(e, "keydown", function (e) {
            e = 18 == e.keyCode && !(e.ctrlKey || e.shiftKey || e.metaKey);
            t.$blockSelectEnabled && e ? n || (t.renderer.setMouseCursor("crosshair"), n = !0) : n && i();
          }, t), s.addListener(e, "keyup", i, t), s.addListener(e, "blur", i, t)));
        }
        !function () {
          (this || _global).updateSelectionMarkers = function () {
            (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers();
          }, (this || _global).addSelectionMarker = function (e) {
            e.cursor || (e.cursor = e.end);
            var t = this.getSelectionStyle();
            return e.marker = (this || _global).session.addMarker(e, "ace_selection", t), (this || _global).session.$selectionMarkers.push(e), (this || _global).session.selectionMarkerCount = (this || _global).session.$selectionMarkers.length, e;
          }, (this || _global).removeSelectionMarker = function (e) {
            e.marker && ((this || _global).session.removeMarker(e.marker), -1 != (e = (this || _global).session.$selectionMarkers.indexOf(e)) && (this || _global).session.$selectionMarkers.splice(e, 1), (this || _global).session.selectionMarkerCount = (this || _global).session.$selectionMarkers.length);
          }, (this || _global).removeSelectionMarkers = function (e) {
            for (var t = (this || _global).session.$selectionMarkers, n = e.length; n--;) {
              var i = e[n];
              i.marker && ((this || _global).session.removeMarker(i.marker), -1 != (i = t.indexOf(i))) && t.splice(i, 1);
            }
            (this || _global).session.selectionMarkerCount = t.length;
          }, (this || _global).$onAddRange = function (e) {
            this.addSelectionMarker(e.range), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers();
          }, (this || _global).$onRemoveRange = function (e) {
            this.removeSelectionMarkers(e.ranges), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers();
          }, (this || _global).$onMultiSelect = function (e) {
            (this || _global).inMultiSelectMode || ((this || _global).inMultiSelectMode = !0, this.setStyle("ace_multiselect"), (this || _global).keyBinding.addKeyboardHandler(a.keyboardHandler), (this || _global).commands.setDefaultHandler("exec", (this || _global).$onMultiSelectExec), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers());
          }, (this || _global).$onSingleSelect = function (e) {
            (this || _global).session.multiSelect.inVirtualMode || ((this || _global).inMultiSelectMode = !1, this.unsetStyle("ace_multiselect"), (this || _global).keyBinding.removeKeyboardHandler(a.keyboardHandler), (this || _global).commands.removeDefaultHandler("exec", (this || _global).$onMultiSelectExec), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers(), this._emit("changeSelection"));
          }, (this || _global).$onMultiSelectExec = function (e) {
            var t,
              n = e.command,
              i = e.editor;
            if (i.multiSelect) return n.multiSelectAction ? t = "forEach" == n.multiSelectAction ? i.forEachSelection(n, e.args) : "forEachLine" == n.multiSelectAction ? i.forEachSelection(n, e.args, !0) : "single" == n.multiSelectAction ? (i.exitMultiSelectMode(), n.exec(i, e.args || {})) : n.multiSelectAction(i, e.args || {}) : (t = n.exec(i, e.args || {}), i.multiSelect.addRange(i.multiSelect.toOrientedRange()), i.multiSelect.mergeOverlappingRanges()), t;
          }, (this || _global).forEachSelection = function (e, t, n) {
            if (!(this || _global).inVirtualSelectionMode) {
              var i,
                o = n && n.keepOrder,
                r = 1 == n || n && n.$byLines,
                s = (this || _global).session,
                n = (this || _global).selection,
                a = n.rangeList,
                l = (o ? n : a).ranges;
              if (!l.length) return e.exec ? e.exec(this || _global, t || {}) : e(this || _global, t || {});
              var o = n._eventRegistry,
                c = (n._eventRegistry = {}, new u(s));
              (this || _global).inVirtualSelectionMode = !0;
              for (var h = l.length; h--;) {
                if (r) for (; 0 < h && l[h].start.row == l[h - 1].end.row;) h--;
                c.fromOrientedRange(l[h]), c.index = h, (this || _global).selection = s.selection = c;
                var d = e.exec ? e.exec(this || _global, t || {}) : e(this || _global, t || {});
                i || void 0 === d || (i = d), c.toOrientedRange(l[h]);
              }
              c.detach(), (this || _global).selection = s.selection = n, (this || _global).inVirtualSelectionMode = !1, n._eventRegistry = o, n.mergeOverlappingRanges(), n.ranges[0] && n.fromOrientedRange(n.ranges[0]);
              a = (this || _global).renderer.$scrollAnimation;
              return this.onCursorChange(), this.onSelectionChange(), a && a.from == a.to && (this || _global).renderer.animateScrolling(a.from), i;
            }
          }, (this || _global).exitMultiSelectMode = function () {
            (this || _global).inMultiSelectMode && !(this || _global).inVirtualSelectionMode && (this || _global).multiSelect.toSingleRange();
          }, (this || _global).getSelectedText = function () {
            var e = "";
            if ((this || _global).inMultiSelectMode && !(this || _global).inVirtualSelectionMode) {
              for (var t = (this || _global).multiSelect.rangeList.ranges, n = [], i = 0; i < t.length; i++) n.push((this || _global).session.getTextRange(t[i]));
              var o = (this || _global).session.getDocument().getNewLineCharacter();
              (e = n.join(o)).length == (n.length - 1) * o.length && (e = "");
            } else (this || _global).selection.isEmpty() || (e = (this || _global).session.getTextRange(this.getSelectionRange()));
            return e;
          }, (this || _global).$checkMultiselectChange = function (e, t) {
            var n;
            (this || _global).inMultiSelectMode && !(this || _global).inVirtualSelectionMode && (n = (this || _global).multiSelect.ranges[0], (this || _global).multiSelect.isEmpty() && t == (this || _global).multiSelect.anchor || ((n = t == (this || _global).multiSelect.anchor ? n.cursor == n.start ? n.end : n.start : n.cursor).row != t.row || (this || _global).session.$clipPositionToDocument(n.row, n.column).column != t.column ? (this || _global).multiSelect.toSingleRange((this || _global).multiSelect.toOrientedRange()) : (this || _global).multiSelect.mergeOverlappingRanges()));
          }, (this || _global).findAll = function (e, t, n) {
            (t = t || {}).needle = e || t.needle, null == t.needle && (i = (this || _global).selection.isEmpty() ? (this || _global).selection.getWordRange() : (this || _global).selection.getRange(), t.needle = (this || _global).session.getTextRange(i)), (this || _global).$search.set(t);
            var i,
              o = (this || _global).$search.findAll((this || _global).session);
            if (!o.length) return 0;
            var r = (this || _global).multiSelect;
            n || r.toSingleRange(o[0]);
            for (var s = o.length; s--;) r.addRange(o[s], !0);
            return i && r.rangeList.rangeAtPoint(i.start) && r.addRange(i, !0), o.length;
          }, (this || _global).selectMoreLines = function (e, t) {
            var n,
              i,
              o,
              r = (this || _global).selection.toOrientedRange(),
              s = r.cursor == r.end,
              a = (this || _global).session.documentToScreenPosition(r.cursor),
              l = ((this || _global).selection.$desiredColumn && (a.column = (this || _global).selection.$desiredColumn), (this || _global).session.screenToDocumentPosition(a.row + e, a.column));
            e = r.isEmpty() ? l : (n = (this || _global).session.documentToScreenPosition(s ? r.end : r.start), (this || _global).session.screenToDocumentPosition(n.row + e, n.column)), s ? (i = I.fromPoints(l, e)).cursor = i.start : (i = I.fromPoints(e, l)).cursor = i.end, i.desiredColumn = a.column, (this || _global).selection.inMultiSelectMode ? t && (o = r.cursor) : (this || _global).selection.addRange(r), (this || _global).selection.addRange(i), o && (this || _global).selection.substractPoint(o);
          }, (this || _global).transposeSelections = function (e) {
            for (var t = (this || _global).session, n = t.multiSelect, i = n.ranges, o = i.length; o--;) (s = i[o]).isEmpty() && (a = t.getWordRange(s.start.row, s.start.column), s.start.row = a.start.row, s.start.column = a.start.column, s.end.row = a.end.row, s.end.column = a.end.column);
            n.mergeOverlappingRanges();
            for (var r = [], o = i.length; o--;) {
              var s = i[o];
              r.unshift(t.getTextRange(s));
            }
            e < 0 ? r.unshift(r.pop()) : r.push(r.shift());
            for (o = i.length; o--;) {
              var a = (s = i[o]).clone();
              t.replace(s, r[o]), s.start.row = a.start.row, s.start.column = a.start.column;
            }
            n.fromOrientedRange(n.ranges[0]);
          }, (this || _global).selectMore = function (e, t, n) {
            var i,
              o = (this || _global).session,
              r = o.multiSelect.toOrientedRange();
            r.isEmpty() && ((r = o.getWordRange(r.start.row, r.start.column)).cursor = -1 == e ? r.start : r.end, (this || _global).multiSelect.addRange(r), n) || (n = o.getTextRange(r), o = o, n = n, i = e, l.$options.wrap = !0, l.$options.needle = n, l.$options.backwards = -1 == i, (n = l.find(o)) && (n.cursor = -1 == e ? n.start : n.end, (this || _global).session.unfold(n), (this || _global).multiSelect.addRange(n), (this || _global).renderer.scrollCursorIntoView(null, 0.5)), t && (this || _global).multiSelect.substractPoint(r.cursor));
          }, (this || _global).alignCursors = function () {
            var o = (this || _global).session,
              t = o.multiSelect,
              e = t.ranges,
              n = -1,
              i = e.filter(function (e) {
                if (e.cursor.row == n) return !0;
                n = e.cursor.row;
              });
            if (e.length && i.length != e.length - 1) {
              i.forEach(function (e) {
                t.substractPoint(e.cursor);
              });
              var r = 0,
                s = 1 / 0,
                a = e.map(function (e) {
                  var e = e.cursor,
                    t = o.getLine(e.row).substr(e.column).search(/\S/g);
                  return e.column > r && (r = e.column), (t = -1 == t ? 0 : t) < s && (s = t), t;
                });
              e.forEach(function (e, t) {
                var n = e.cursor,
                  i = r - n.column,
                  t = a[t] - s;
                t < i ? o.insert(n, g.stringRepeat(" ", i - t)) : o.remove(new I(n.row, n.column, n.row, n.column - i + t)), e.start.column = e.end.column = r, e.start.row = e.end.row = n.row, e.cursor = e.end;
              }), t.fromOrientedRange(e[0]), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers();
            } else {
              var i = (this || _global).selection.getRange(),
                l = i.start.row,
                c = i.end.row,
                e = l == c;
              if (e) {
                for (var h, d = (this || _global).session.getLength(); h = (this || _global).session.getLine(c), /[=:]/.test(h) && ++c < d;);
                for (; h = (this || _global).session.getLine(l), /[=:]/.test(h) && 0 < --l;);
                l < 0 && (l = 0), d <= c && (c = d - 1);
              }
              var u = (this || _global).session.removeFullLines(l, c),
                u = this.$reAlignText(u, e);
              (this || _global).session.insert({
                row: l,
                column: 0
              }, u.join("\n") + "\n"), e || (i.start.column = 0, i.end.column = u[u.length - 1].length), (this || _global).selection.setRange(i);
            }
          }, (this || _global).$reAlignText = function (e, t) {
            var n,
              i,
              o,
              r = !0,
              s = !0;
            return e.map(function (e) {
              var t = e.match(/(\s*)(.*?)(\s*)([=:].*)/);
              return t ? (null == n ? (n = t[1].length, i = t[2].length, o = t[3].length) : (n + i + o != t[1].length + t[2].length + t[3].length && (s = !1), n != t[1].length && (r = !1), n > t[1].length && (n = t[1].length), i < t[2].length && (i = t[2].length), o > t[3].length && (o = t[3].length)), t) : [e];
            }).map(t ? l : r ? s ? function (e) {
              return e[2] ? a(n + i - e[2].length) + e[2] + a(o) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
            } : l : function (e) {
              return e[2] ? a(n) + e[2] + a(o) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
            });
            function a(e) {
              return g.stringRepeat(" ", e);
            }
            function l(e) {
              return e[2] ? a(n) + e[2] + a(i - e[2].length + o) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
            }
          };
        }.call(i.prototype), o.onSessionChange = function (e) {
          var t = e.session,
            e = (t && !t.multiSelect && (t.$selectionMarkers = [], t.selection.$initRangeList(), t.multiSelect = t.selection), (this || _global).multiSelect = t && t.multiSelect, e.oldSession);
          e && (e.multiSelect.off("addRange", (this || _global).$onAddRange), e.multiSelect.off("removeRange", (this || _global).$onRemoveRange), e.multiSelect.off("multiSelect", (this || _global).$onMultiSelect), e.multiSelect.off("singleSelect", (this || _global).$onSingleSelect), e.multiSelect.lead.off("change", (this || _global).$checkMultiselectChange), e.multiSelect.anchor.off("change", (this || _global).$checkMultiselectChange)), t && (t.multiSelect.on("addRange", (this || _global).$onAddRange), t.multiSelect.on("removeRange", (this || _global).$onRemoveRange), t.multiSelect.on("multiSelect", (this || _global).$onMultiSelect), t.multiSelect.on("singleSelect", (this || _global).$onSingleSelect), t.multiSelect.lead.on("change", (this || _global).$checkMultiselectChange), t.multiSelect.anchor.on("change", (this || _global).$checkMultiselectChange)), t && (this || _global).inMultiSelectMode != t.selection.inMultiSelectMode && (t.selection.inMultiSelectMode ? this.$onMultiSelect() : this.$onSingleSelect());
        }, o.MultiSelect = c, e("./config").defineOptions(i.prototype, "editor", {
          enableMultiselect: {
            set: function (e) {
              c(this || _global), e ? (this.on("changeSession", (this || _global).$multiselectOnSessionChange), this.on("mousedown", r)) : (this.off("changeSession", (this || _global).$multiselectOnSessionChange), this.off("mousedown", r));
            },
            value: !0
          },
          enableBlockSelect: {
            set: function (e) {
              (this || _global).$blockSelectEnabled = e;
            },
            value: !0
          }
        });
      }), ace.define("ace/mode/folding/fold_mode", ["require", "exports", "module", "ace/range"], function (e, t, n) {
        "use strict";

        var h = e("../../range").Range,
          e = t.FoldMode = function () {};
        !function () {
          (this || _global).foldingStartMarker = null, (this || _global).foldingStopMarker = null, (this || _global).getFoldWidget = function (e, t, n) {
            e = e.getLine(n);
            return (this || _global).foldingStartMarker.test(e) ? "start" : "markbeginend" == t && (this || _global).foldingStopMarker && (this || _global).foldingStopMarker.test(e) ? "end" : "";
          }, (this || _global).getFoldWidgetRange = function (e, t, n) {
            return null;
          }, (this || _global).indentationBlock = function (e, t, n) {
            var i = /\S/,
              o = e.getLine(t),
              r = o.search(i);
            if (-1 != r) {
              for (var s, n = n || o.length, a = e.getLength(), o = t, l = t; ++t < a;) {
                var c = e.getLine(t).search(i);
                if (-1 != c) {
                  if (c <= r) {
                    c = e.getTokenAt(t, 0);
                    if (!c || "string" !== c.type) break;
                  }
                  l = t;
                }
              }
              return o < l ? (s = e.getLine(l).length, new h(o, n, l, s)) : void 0;
            }
          }, (this || _global).openingBracketBlock = function (e, t, n, i, o) {
            n = {
              row: n,
              column: i + 1
            }, i = e.$findClosingBracket(t, n, o);
            if (i) return "start" == (t = null == (t = e.foldWidgets[i.row]) ? e.getFoldWidget(i.row) : t) && i.row > n.row && (i.row--, i.column = e.getLine(i.row).length), h.fromPoints(n, i);
          }, (this || _global).closingBracketBlock = function (e, t, n, i, o) {
            n = {
              row: n,
              column: i
            }, i = e.$findOpeningBracket(t, n);
            if (i) return i.column++, n.column--, h.fromPoints(i, n);
          };
        }.call(e.prototype);
      }), ace.define("ace/ext/error_marker", ["require", "exports", "module", "ace/line_widgets", "ace/lib/dom", "ace/range", "ace/config"], function (e, t, n) {
        "use strict";

        var c = e("../line_widgets").LineWidgets,
          h = e("../lib/dom"),
          a = e("../range").Range,
          d = e("../config").nls;
        function u(e, t, n) {
          var i = e.getAnnotations().sort(a.comparePoints);
          if (i.length) {
            var o = function (e, t, n) {
                for (var i = 0, o = e.length - 1; i <= o;) {
                  var r = i + o >> 1,
                    s = n(t, e[r]);
                  if (0 < s) i = 1 + r;else {
                    if (!(s < 0)) return r;
                    o = r - 1;
                  }
                }
                return -(i + 1);
              }(i, {
                row: t,
                column: -1
              }, a.comparePoints),
              r = ((o = o < 0 ? -o - 1 : o) >= i.length ? o = 0 < n ? 0 : i.length - 1 : 0 === o && n < 0 && (o = i.length - 1), i[o]);
            if (r && n) {
              if (r.row === t) {
                for (; (r = i[o += n]) && r.row === t;);
                if (!r) return i.slice();
              }
              var s = [];
              for (t = r.row; s[n < 0 ? "unshift" : "push"](r), (r = i[o += n]) && r.row == t;);
              return s.length && s;
            }
          }
        }
        t.showErrorMarker = function (e, t) {
          var n,
            i = e.session,
            o = (i.widgetManager || (i.widgetManager = new c(i), i.widgetManager.attach(e)), e.getCursorPosition()),
            r = o.row,
            s = i.widgetManager.getWidgetsAtRow(r).filter(function (e) {
              return "errorMarker" == e.type;
            })[0],
            r = (s ? s.destroy() : r -= t, u(i, r, t));
          if (r) {
            t = r[0];
            o.column = (t.pos && "number" != typeof t.column ? t.pos.sc : t.column) || 0, o.row = t.row, n = e.renderer.$gutterLayer.$annotations[o.row];
          } else {
            if (s) return;
            n = {
              text: [d("Looks good!")],
              className: "ace_ok"
            };
          }
          e.session.unfold(o.row), e.selection.moveToPosition(o);
          function a(e, t, n) {
            if (0 === t && ("esc" === n || "return" === n)) return l.destroy(), {
              command: "null"
            };
          }
          var l = {
              row: o.row,
              fixedWidth: !0,
              coverGutter: !0,
              el: h.createElement("div"),
              type: "errorMarker"
            },
            r = l.el.appendChild(h.createElement("div")),
            t = l.el.appendChild(h.createElement("div")),
            s = (t.className = "error_widget_arrow " + n.className, e.renderer.$cursorLayer.getPixelPosition(o).left);
          t.style.left = s + e.renderer.gutterWidth - 5 + "px", l.el.className = "error_widget_wrapper", r.className = "error_widget " + n.className, r.innerHTML = n.text.join("<br>"), r.appendChild(h.createElement("div"));
          l.destroy = function () {
            e.$mouseHandler.isMousePressed || (e.keyBinding.removeKeyboardHandler(a), i.widgetManager.removeLineWidget(l), e.off("changeSelection", l.destroy), e.off("changeSession", l.destroy), e.off("mouseup", l.destroy), e.off("change", l.destroy));
          }, e.keyBinding.addKeyboardHandler(a), e.on("changeSelection", l.destroy), e.on("changeSession", l.destroy), e.on("mouseup", l.destroy), e.on("change", l.destroy), e.session.widgetManager.addLineWidget(l), l.el.onmousedown = e.focus.bind(e), e.renderer.scrollCursorIntoView(null, 0.5, {
            bottom: l.el.offsetHeight
          });
        }, h.importCssString("\n    .error_widget_wrapper {\n        background: inherit;\n        color: inherit;\n        border:none\n    }\n    .error_widget {\n        border-top: solid 2px;\n        border-bottom: solid 2px;\n        margin: 5px 0;\n        padding: 10px 40px;\n        white-space: pre-wrap;\n    }\n    .error_widget.ace_error, .error_widget_arrow.ace_error{\n        border-color: #ff5a5a\n    }\n    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\n        border-color: #F1D817\n    }\n    .error_widget.ace_info, .error_widget_arrow.ace_info{\n        border-color: #5a5a5a\n    }\n    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\n        border-color: #5aaa5a\n    }\n    .error_widget_arrow {\n        position: absolute;\n        border: solid 5px;\n        border-top-color: transparent!important;\n        border-right-color: transparent!important;\n        border-left-color: transparent!important;\n        top: -5px;\n    }\n", "error_marker.css", !1);
      }), ace.define("ace/ace", ["require", "exports", "module", "ace/lib/dom", "ace/range", "ace/editor", "ace/edit_session", "ace/undomanager", "ace/virtual_renderer", "ace/worker/worker_client", "ace/keyboard/hash_handler", "ace/placeholder", "ace/multi_select", "ace/mode/folding/fold_mode", "ace/theme/textmate", "ace/ext/error_marker", "ace/config", "ace/loader_build"], function (e, r, t) {
        "use strict";

        e("./loader_build")(r);
        var s = e("./lib/dom"),
          n = e("./range").Range,
          a = e("./editor").Editor,
          i = e("./edit_session").EditSession,
          o = e("./undomanager").UndoManager,
          l = e("./virtual_renderer").VirtualRenderer;
        e("./worker/worker_client"), e("./keyboard/hash_handler"), e("./placeholder"), e("./multi_select"), e("./mode/folding/fold_mode"), e("./theme/textmate"), e("./ext/error_marker"), r.config = e("./config"), r.edit = function (e, t) {
          if ("string" == typeof e) {
            var n = e;
            if (!(e = document.getElementById(n))) throw new Error("ace.edit can't find div #" + n);
          }
          var i, o;
          return e && e.env && e.env.editor instanceof a ? e.env.editor : (n = "", e && /input|textarea/i.test(e.tagName) ? (n = (i = e).value, e = s.createElement("pre"), i.parentNode.replaceChild(e, i)) : e && (n = e.textContent, e.innerHTML = ""), n = r.createEditSession(n), e = new a(new l(e), n, t), o = {
            document: n,
            editor: e,
            onResize: e.resize.bind(e, null)
          }, i && (o.textarea = i), e.on("destroy", function () {
            o.editor.container.env = null;
          }), e.container.env = e.env = o, e);
        }, r.createEditSession = function (e, t) {
          e = new i(e, t);
          return e.setUndoManager(new o()), e;
        }, r.Range = n, r.Editor = a, r.EditSession = i, r.UndoManager = o, r.VirtualRenderer = l, r.version = r.config.version;
      }), ace.require(["ace/ace"], function (e) {
        for (var t in e && (e.config.init(!0), e.define = ace.define), window.ace || (window.ace = e), e) e.hasOwnProperty(t) && (window.ace[t] = e[t]);
        window.ace.default = window.ace, n && (n.exports = window.ace);
      });
    },
    4317: function (t, e, n) {
      t = n.nmd(t), ace.define("ace/snippets", ["require", "exports", "module", "ace/lib/dom", "ace/lib/oop", "ace/lib/event_emitter", "ace/lib/lang", "ace/range", "ace/range_list", "ace/keyboard/hash_handler", "ace/tokenizer", "ace/clipboard", "ace/editor"], function (e, s, t) {
        "use strict";

        var n = e("./lib/dom"),
          i = e("./lib/oop"),
          o = e("./lib/event_emitter").EventEmitter,
          c = e("./lib/lang"),
          h = e("./range").Range,
          d = e("./range_list").RangeList,
          r = e("./keyboard/hash_handler").HashHandler,
          a = e("./tokenizer").Tokenizer,
          l = e("./clipboard"),
          u = {
            CURRENT_WORD: function (e) {
              return e.session.getTextRange(e.session.getWordRange());
            },
            SELECTION: function (e, t, n) {
              e = e.session.getTextRange();
              return n ? e.replace(/\n\r?([ \t]*\S)/g, "\n" + n + "$1") : e;
            },
            CURRENT_LINE: function (e) {
              return e.session.getLine(e.getCursorPosition().row);
            },
            PREV_LINE: function (e) {
              return e.session.getLine(e.getCursorPosition().row - 1);
            },
            LINE_INDEX: function (e) {
              return e.getCursorPosition().row;
            },
            LINE_NUMBER: function (e) {
              return e.getCursorPosition().row + 1;
            },
            SOFT_TABS: function (e) {
              return e.session.getUseSoftTabs() ? "YES" : "NO";
            },
            TAB_SIZE: function (e) {
              return e.session.getTabSize();
            },
            CLIPBOARD: function (e) {
              return l.getText && l.getText();
            },
            FILENAME: function (e) {
              return /[^/\\]*$/.exec(this.FILEPATH(e))[0];
            },
            FILENAME_BASE: function (e) {
              return /[^/\\]*$/.exec(this.FILEPATH(e))[0].replace(/\.[^.]*$/, "");
            },
            DIRECTORY: function (e) {
              return this.FILEPATH(e).replace(/[^/\\]*$/, "");
            },
            FILEPATH: function (e) {
              return "/not implemented.txt";
            },
            WORKSPACE_NAME: function () {
              return "Unknown";
            },
            FULLNAME: function () {
              return "Unknown";
            },
            BLOCK_COMMENT_START: function (e) {
              e = e.session.$mode || {};
              return e.blockComment && e.blockComment.start || "";
            },
            BLOCK_COMMENT_END: function (e) {
              e = e.session.$mode || {};
              return e.blockComment && e.blockComment.end || "";
            },
            LINE_COMMENT: function (e) {
              return (e.session.$mode || {}).lineCommentStart || "";
            },
            CURRENT_YEAR: g.bind(null, {
              year: "numeric"
            }),
            CURRENT_YEAR_SHORT: g.bind(null, {
              year: "2-digit"
            }),
            CURRENT_MONTH: g.bind(null, {
              month: "numeric"
            }),
            CURRENT_MONTH_NAME: g.bind(null, {
              month: "long"
            }),
            CURRENT_MONTH_NAME_SHORT: g.bind(null, {
              month: "short"
            }),
            CURRENT_DATE: g.bind(null, {
              day: "2-digit"
            }),
            CURRENT_DAY_NAME: g.bind(null, {
              weekday: "long"
            }),
            CURRENT_DAY_NAME_SHORT: g.bind(null, {
              weekday: "short"
            }),
            CURRENT_HOUR: g.bind(null, {
              hour: "2-digit",
              hour12: !1
            }),
            CURRENT_MINUTE: g.bind(null, {
              minute: "2-digit"
            }),
            CURRENT_SECOND: g.bind(null, {
              second: "2-digit"
            })
          };
        function g(e) {
          e = new Date().toLocaleString("en-us", e);
          return 1 == e.length ? "0" + e : e;
        }
        u.SELECTED_TEXT = u.SELECTION;
        function p() {
          (this || _global).snippetMap = {}, (this || _global).snippetNameMap = {};
        }
        !function () {
          i.implement(this || _global, o), (this || _global).getTokenizer = function () {
            return p.$tokenizer || this.createTokenizer();
          }, (this || _global).createTokenizer = function () {
            function i(e) {
              return e = e.substr(1), /^\d+$/.test(e) ? [{
                tabstopId: parseInt(e, 10)
              }] : [{
                text: e
              }];
            }
            function e(e) {
              return "(?:[^\\\\" + e + "]|\\\\.)";
            }
            var t = {
              regex: "/(" + e("/") + "+)/",
              onMatch: function (e, t, n) {
                n = n[0];
                return n.fmtString = !0, n.guard = e.slice(1, -1), n.flag = "";
              },
              next: "formatString"
            };
            return p.$tokenizer = new a({
              start: [{
                regex: /\\./,
                onMatch: function (e, t, n) {
                  var i = e[1];
                  return [e = "}" == i && n.length || -1 != "`$\\".indexOf(i) ? i : e];
                }
              }, {
                regex: /}/,
                onMatch: function (e, t, n) {
                  return [n.length ? n.shift() : e];
                }
              }, {
                regex: /\$(?:\d+|\w+)/,
                onMatch: i
              }, {
                regex: /\$\{[\dA-Z_a-z]+/,
                onMatch: function (e, t, n) {
                  e = i(e.substr(1));
                  return n.unshift(e[0]), e;
                },
                next: "snippetVar"
              }, {
                regex: /\n/,
                token: "newline",
                merge: !1
              }],
              snippetVar: [{
                regex: "\\|" + e("\\|") + "*\\|",
                onMatch: function (e, t, n) {
                  e = e.slice(1, -1).replace(/\\[,|\\]|,/g, function (e) {
                    return 2 == e.length ? e[1] : "\0";
                  }).split("\0").map(function (e) {
                    return {
                      value: e
                    };
                  });
                  return [(n[0].choices = e)[0]];
                },
                next: "start"
              }, t, {
                regex: "([^:}\\\\]|\\\\.)*:?",
                token: "",
                next: "start"
              }],
              formatString: [{
                regex: /:/,
                onMatch: function (e, t, n) {
                  return n.length && n[0].expectElse ? (n[0].expectElse = !1, n[0].ifEnd = {
                    elseEnd: n[0]
                  }, [n[0].ifEnd]) : ":";
                }
              }, {
                regex: /\\./,
                onMatch: function (e, t, n) {
                  var i = e[1];
                  return "}" == i && n.length || -1 != "`$\\".indexOf(i) ? e = i : "n" == i ? e = "\n" : "t" == i ? e = "\t" : -1 != "ulULE".indexOf(i) && (e = {
                    changeCase: i,
                    local: "a" < i
                  }), [e];
                }
              }, {
                regex: "/\\w*}",
                onMatch: function (e, t, n) {
                  n = n.shift();
                  return n && (n.flag = e.slice(1, -1)), (this || _global).next = n && n.tabstopId ? "start" : "", [n || e];
                },
                next: "start"
              }, {
                regex: /\$(?:\d+|\w+)/,
                onMatch: function (e, t, n) {
                  return [{
                    text: e.slice(1)
                  }];
                }
              }, {
                regex: /\${\w+/,
                onMatch: function (e, t, n) {
                  e = {
                    text: e.slice(2)
                  };
                  return n.unshift(e), [e];
                },
                next: "formatStringVar"
              }, {
                regex: /\n/,
                token: "newline",
                merge: !1
              }, {
                regex: /}/,
                onMatch: function (e, t, n) {
                  n = n.shift();
                  return (this || _global).next = n && n.tabstopId ? "start" : "", [n || e];
                },
                next: "start"
              }],
              formatStringVar: [{
                regex: /:\/\w+}/,
                onMatch: function (e, t, n) {
                  return n[0].formatFunction = e.slice(2, -1), [n.shift()];
                },
                next: "formatString"
              }, t, {
                regex: /:[\?\-+]?/,
                onMatch: function (e, t, n) {
                  "+" == e[1] && (n[0].ifEnd = n[0]), "?" == e[1] && (n[0].expectElse = !0);
                },
                next: "formatString"
              }, {
                regex: "([^:}\\\\]|\\\\.)*:?",
                token: "",
                next: "formatString"
              }]
            });
          }, (this || _global).tokenizeTmSnippet = function (e, t) {
            return this.getTokenizer().getLineTokens(e, t).tokens.map(function (e) {
              return e.value || e;
            });
          }, (this || _global).getVariableValue = function (e, t, n) {
            var i;
            return /^\d+$/.test(t) ? ((this || _global).variables.__ || {})[t] || "" : /^[A-Z]\d+$/.test(t) ? ((this || _global).variables[t[0] + "__"] || {})[t.substr(1)] || "" : (t = t.replace(/^TM_/, ""), !(this || _global).variables.hasOwnProperty(t) || null == (i = "function" == typeof (i = (this || _global).variables[t]) ? (this || _global).variables[t](e, t, n) : i) ? "" : i);
          }, (this || _global).variables = u, (this || _global).tmStrFormat = function (e, t, s) {
            var n, i, a, l;
            return t.fmt ? (n = t.flag || "", i = t.guard, i = new RegExp(i, n.replace(/[^gim]/g, "")), a = "string" == typeof t.fmt ? this.tokenizeTmSnippet(t.fmt, "formatString") : t.fmt, l = this || _global, e.replace(i, function () {
              for (var e = l.variables.__, t = (l.variables.__ = [].slice.call(arguments), l.resolveVariables(a, s)), n = "E", i = 0; i < t.length; i++) {
                var o,
                  r = t[i];
                "object" == typeof r ? (t[i] = "", r.changeCase && r.local ? (o = t[i + 1]) && "string" == typeof o && ("u" == r.changeCase ? t[i] = o[0].toUpperCase() : t[i] = o[0].toLowerCase(), t[i + 1] = o.substr(1)) : r.changeCase && (n = r.changeCase)) : "U" == n ? t[i] = r.toUpperCase() : "L" == n && (t[i] = r.toLowerCase());
              }
              return l.variables.__ = e, t.join("");
            })) : e;
          }, (this || _global).tmFormatFunction = function (e, t, n) {
            return "upcase" == t.formatFunction ? e.toUpperCase() : "downcase" == t.formatFunction ? e.toLowerCase() : e;
          }, (this || _global).resolveVariables = function (t, e) {
            for (var n = [], i = "", o = !0, r = 0; r < t.length; r++) {
              var s,
                a = t[r];
              "string" == typeof a ? (n.push(a), "\n" == a ? (o = !0, i = "") : o && (i = /^\t*/.exec(a)[0], o = /\S/.test(a))) : a && (o = !1, a.fmtString && (-1 == (s = t.indexOf(a, r + 1)) && (s = t.length), a.fmt = t.slice(r + 1, s), r = s), a.text ? (s = this.getVariableValue(e, a.text, i) + "", a.fmtString && (s = this.tmStrFormat(s, a, e)), (s = a.formatFunction ? this.tmFormatFunction(s, a, e) : s) && !a.ifEnd ? (n.push(s), l(a)) : !s && a.ifEnd && l(a.ifEnd)) : a.elseEnd ? l(a.elseEnd) : null == a.tabstopId && null == a.changeCase || n.push(a));
            }
            function l(e) {
              e = t.indexOf(e, r + 1);
              -1 != e && (r = e);
            }
            return n;
          };
          function r(e, t, n) {
            void 0 === n && (n = {});
            for (var i = e.getCursorPosition(), o = e.session.getLine(i.row), r = e.session.getTabString(), s = o.match(/^\s*/)[0], a = (i.column < s.length && (s = s.slice(0, i.column)), t = t.replace(/\r/g, ""), this.tokenizeTmSnippet(t)), l = (a = (a = this.resolveVariables(a, e)).map(function (e) {
                return "\n" != e || n.excludeExtraIndent ? "string" == typeof e ? e.replace(/\t/g, r) : e : e + s;
              }), []), c = (a.forEach(function (e, t) {
                var n, i, o;
                "object" == typeof e && (o = e.tabstopId, (n = l[o]) || ((n = l[o] = []).index = o, n.value = "", n.parents = {}), -1 === n.indexOf(e)) && (e.choices && !n.choices && (n.choices = e.choices), n.push(e), -1 !== (i = a.indexOf(e, t + 1))) && ((o = a.slice(t + 1, i)).some(function (e) {
                  return "object" == typeof e;
                }) && !n.value ? n.value = o : !o.length || n.value && "string" == typeof n.value || (n.value = o.join("")));
              }), l.forEach(function (e) {
                e.length = 0;
              }), {}), h = 0; h < a.length; h++) {
              var d,
                u,
                g,
                p = a[h];
              "object" == typeof p && (g = p.tabstopId, d = l[g], u = a.indexOf(p, h + 1), c[g] ? c[g] === p && (delete c[g], Object.keys(c).forEach(function (e) {
                d.parents[e] = !0;
              })) : (c[g] = p, "string" != typeof (g = d.value) ? g = function (e) {
                for (var t = [], n = 0; n < e.length; n++) {
                  if ("object" == typeof (i = e[n])) {
                    if (c[i.tabstopId]) continue;
                    var i = t[e.lastIndexOf(i, n - 1)] || {
                      tabstopId: i.tabstopId
                    };
                  }
                  t[n] = i;
                }
                return t;
              }(g) : p.fmt && (g = this.tmStrFormat(g, p, e)), a.splice.apply(a, [h + 1, Math.max(0, u - h)].concat(g, p)), -1 === d.indexOf(p) && d.push(p)));
            }
            var m = 0,
              f = 0,
              C = "";
            return a.forEach(function (e) {
              var t;
              "string" == typeof e ? (1 < (t = e.split("\n")).length ? (f = t[t.length - 1].length, m += t.length - 1) : f += e.length, C += e) : e && (e.start ? e.end = {
                row: m,
                column: f
              } : e.start = {
                row: m,
                column: f
              });
            }), {
              text: C,
              tabstops: l,
              tokens: a
            };
          }
          (this || _global).getDisplayTextForSnippet = function (e, t) {
            return r.call(this || _global, e, t).text;
          }, (this || _global).insertSnippetForSelection = function (e, t, n) {
            var t = r.call(this || _global, e, t, n = void 0 === n ? {} : n),
              i = e.getSelectionRange(),
              n = (n.range && 0 === n.range.compareRange(i) && (i = n.range), e.session.replace(i, t.text)),
              o = new m(e),
              e = e.inVirtualSelectionMode && e.selection.index;
            o.addTabstops(t.tabstops, i.start, n, e);
          }, (this || _global).insertSnippet = function (e, t, n) {
            var i = this || _global;
            if (!(n = void 0 === n ? {} : n).range || n.range instanceof h || (n.range = h.fromPoints(n.range.start, n.range.end)), e.inVirtualSelectionMode) return i.insertSnippetForSelection(e, t, n);
            e.forEachSelection(function () {
              i.insertSnippetForSelection(e, t, n);
            }, null, {
              keepOrder: !0
            }), e.tabstopManager && e.tabstopManager.tabNext();
          }, (this || _global).$getScope = function (e) {
            var t,
              n = e.session.$mode.$id || "";
            return "html" !== (n = n.split("/").pop()) && "php" !== n || ("php" !== n || e.session.$mode.inlinePhp || (n = "html"), t = e.getCursorPosition(), (e = "object" == typeof (e = e.session.getState(t.row)) ? e[0] : e).substring && ("js-" == e.substring(0, 3) ? n = "javascript" : "css-" == e.substring(0, 4) ? n = "css" : "php-" == e.substring(0, 4) && (n = "php"))), n;
          }, (this || _global).getActiveScopes = function (e) {
            var e = this.$getScope(e),
              t = [e],
              n = (this || _global).snippetMap;
            return n[e] && n[e].includeScopes && t.push.apply(t, n[e].includeScopes), t.push("_"), t;
          }, (this || _global).expandWithTab = function (e, t) {
            var n = this || _global,
              i = e.forEachSelection(function () {
                return n.expandSnippetForSelection(e, t);
              }, null, {
                keepOrder: !0
              });
            return i && e.tabstopManager && e.tabstopManager.tabNext(), i;
          }, (this || _global).expandSnippetForSelection = function (e, t) {
            var n,
              i = e.getCursorPosition(),
              o = e.session.getLine(i.row),
              r = o.substring(0, i.column),
              s = o.substr(i.column),
              a = (this || _global).snippetMap;
            return this.getActiveScopes(e).some(function (e) {
              e = a[e];
              return !!(n = e ? this.findMatchingSnippet(e, r, s) : n);
            }, this || _global), !!n && (t && t.dryRun || (e.session.doc.removeInLine(i.row, i.column - n.replaceBefore.length, i.column + n.replaceAfter.length), (this || _global).variables.M__ = n.matchBefore, (this || _global).variables.T__ = n.matchAfter, this.insertSnippetForSelection(e, n.content), (this || _global).variables.M__ = (this || _global).variables.T__ = null), !0);
          }, (this || _global).findMatchingSnippet = function (e, t, n) {
            for (var i = e.length; i--;) {
              var o = e[i];
              if ((!o.startRe || o.startRe.test(t)) && (!o.endRe || o.endRe.test(n)) && (o.startRe || o.endRe)) return o.matchBefore = o.startRe ? o.startRe.exec(t) : [""], o.matchAfter = o.endRe ? o.endRe.exec(n) : [""], o.replaceBefore = o.triggerRe ? o.triggerRe.exec(t)[0] : "", o.replaceAfter = o.endTriggerRe ? o.endTriggerRe.exec(n)[0] : "", o;
            }
          }, (this || _global).snippetMap = {}, (this || _global).snippetNameMap = {}, (this || _global).register = function (t, i) {
            var o = (this || _global).snippetMap,
              r = (this || _global).snippetNameMap,
              s = this || _global;
            function a(e) {
              return (e = e && !/^\^?\(.*\)\$?$|^\\b$/.test(e) ? "(?:" + e + ")" : e) || "";
            }
            function l(e, t, n) {
              return e = a(e), t = a(t), n ? (e = t + e) && "$" != e[e.length - 1] && (e += "$") : (e += t) && "^" != e[0] && (e = "^" + e), new RegExp(e);
            }
            function n(e) {
              e.scope || (e.scope = i || "_"), i = e.scope, o[i] || (o[i] = [], r[i] = {});
              var t,
                n = r[i];
              e.name && ((t = n[e.name]) && s.unregister(t), n[e.name] = e), o[i].push(e), e.prefix && (e.tabTrigger = e.prefix), !e.content && e.body && (e.content = Array.isArray(e.body) ? e.body.join("\n") : e.body), e.tabTrigger && !e.trigger && (!e.guard && /^\w/.test(e.tabTrigger) && (e.guard = "\\b"), e.trigger = c.escapeRegExp(e.tabTrigger)), (e.trigger || e.guard || e.endTrigger || e.endGuard) && (e.startRe = l(e.trigger, e.guard, !0), e.triggerRe = new RegExp(e.trigger), e.endRe = l(e.endTrigger, e.endGuard, !0), e.endTriggerRe = new RegExp(e.endTrigger));
            }
            t = t || [], Array.isArray(t) ? t.forEach(n) : Object.keys(t).forEach(function (e) {
              n(t[e]);
            }), this._signal("registerSnippets", {
              scope: i
            });
          }, (this || _global).unregister = function (e, n) {
            var i = (this || _global).snippetMap,
              o = (this || _global).snippetNameMap;
            function t(e) {
              var t = o[e.scope || n];
              t && t[e.name] && (delete t[e.name], 0 <= (e = (t = i[e.scope || n]) && t.indexOf(e))) && t.splice(e, 1);
            }
            e.content ? t(e) : Array.isArray(e) && e.forEach(t);
          }, (this || _global).parseSnippetFile = function (e) {
            e = e.replace(/\r/g, "");
            for (var t, n, i, o = [], r = {}, s = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm; n = s.exec(e);) {
              if (n[1]) try {
                r = JSON.parse(n[1]), o.push(r);
              } catch (e) {}
              n[4] ? (r.content = n[4].replace(/^\t/gm, ""), o.push(r), r = {}) : (t = n[2], n = n[3], "regex" == t ? (r.guard = (i = /\/((?:[^\/\\]|\\.)*)|$/g).exec(n)[1], r.trigger = i.exec(n)[1], r.endTrigger = i.exec(n)[1], r.endGuard = i.exec(n)[1]) : "snippet" == t ? (r.tabTrigger = n.match(/^\S*/)[0], r.name || (r.name = n)) : t && (r[t] = n));
            }
            return o;
          }, (this || _global).getSnippetByName = function (t, e) {
            var n,
              i = (this || _global).snippetNameMap;
            return this.getActiveScopes(e).some(function (e) {
              e = i[e];
              return !!(n = e ? e[t] : n);
            }, this || _global), n;
          };
        }.call(p.prototype);
        var m = function (e) {
            if (e.tabstopManager) return e.tabstopManager;
            (e.tabstopManager = this || _global).$onChange = (this || _global).onChange.bind(this || _global), (this || _global).$onChangeSelection = c.delayedCall((this || _global).onChangeSelection.bind(this || _global)).schedule, (this || _global).$onChangeSession = (this || _global).onChangeSession.bind(this || _global), (this || _global).$onAfterExec = (this || _global).onAfterExec.bind(this || _global), this.attach(e);
          },
          f = (!function () {
            (this || _global).attach = function (e) {
              (this || _global).index = 0, (this || _global).ranges = [], (this || _global).tabstops = [], (this || _global).$openTabstops = null, (this || _global).selectedTabstop = null, (this || _global).editor = e, (this || _global).editor.on("change", (this || _global).$onChange), (this || _global).editor.on("changeSelection", (this || _global).$onChangeSelection), (this || _global).editor.on("changeSession", (this || _global).$onChangeSession), (this || _global).editor.commands.on("afterExec", (this || _global).$onAfterExec), (this || _global).editor.keyBinding.addKeyboardHandler((this || _global).keyboardHandler);
            }, (this || _global).detach = function () {
              (this || _global).tabstops.forEach((this || _global).removeTabstopMarkers, this || _global), (this || _global).ranges = null, (this || _global).tabstops = null, (this || _global).selectedTabstop = null, (this || _global).editor.removeListener("change", (this || _global).$onChange), (this || _global).editor.removeListener("changeSelection", (this || _global).$onChangeSelection), (this || _global).editor.removeListener("changeSession", (this || _global).$onChangeSession), (this || _global).editor.commands.removeListener("afterExec", (this || _global).$onAfterExec), (this || _global).editor.keyBinding.removeKeyboardHandler((this || _global).keyboardHandler), (this || _global).editor.tabstopManager = null, (this || _global).editor = null;
            }, (this || _global).onChange = function (e) {
              for (var t = "r" == e.action[0], n = (this || _global).selectedTabstop || {}, i = n.parents || {}, o = ((this || _global).tabstops || []).slice(), r = 0; r < o.length; r++) {
                var s = o[r],
                  a = s == n || i[s.index];
                if (s.rangeList.$bias = a ? 0 : 1, "remove" == e.action && s !== n) for (var a = s.parents && s.parents[n.index], l = (l = s.rangeList.pointIndex(e.start, a)) < 0 ? -l - 1 : l + 1, a = s.rangeList.pointIndex(e.end, a), c = s.rangeList.ranges.slice(l, a < 0 ? -a - 1 : a - 1), h = 0; h < c.length; h++) this.removeRange(c[h]);
                s.rangeList.$onChange(e);
              }
              var d = (this || _global).editor.session;
              (this || _global).$inChange || !t || 1 != d.getLength() || d.getValue() || this.detach();
            }, (this || _global).updateLinkedFields = function () {
              var e = (this || _global).selectedTabstop;
              if (e && e.hasLinkedRanges && e.firstNonLinked) {
                (this || _global).$inChange = !0;
                for (var t = (this || _global).editor.session, n = t.getTextRange(e.firstNonLinked), i = 0; i < e.length; i++) {
                  var o,
                    r = e[i];
                  r.linked && (o = r.original, o = s.snippetManager.tmStrFormat(n, o, (this || _global).editor), t.replace(r, o));
                }
                (this || _global).$inChange = !1;
              }
            }, (this || _global).onAfterExec = function (e) {
              e.command && !e.command.readOnly && this.updateLinkedFields();
            }, (this || _global).onChangeSelection = function () {
              if ((this || _global).editor) {
                for (var e = (this || _global).editor.selection.lead, t = (this || _global).editor.selection.anchor, n = (this || _global).editor.selection.isEmpty(), i = 0; i < (this || _global).ranges.length; i++) if (!(this || _global).ranges[i].linked) {
                  var o = (this || _global).ranges[i].contains(e.row, e.column),
                    r = n || (this || _global).ranges[i].contains(t.row, t.column);
                  if (o && r) return;
                }
                this.detach();
              }
            }, (this || _global).onChangeSession = function () {
              this.detach();
            }, (this || _global).tabNext = function (e) {
              var t = (this || _global).tabstops.length,
                e = (this || _global).index + (e || 1),
                e = Math.min(Math.max(e, 1), t);
              this.selectTabstop(e = e == t ? 0 : e), 0 === e && this.detach();
            }, (this || _global).selectTabstop = function (e) {
              (this || _global).$openTabstops = null;
              var t = (this || _global).tabstops[(this || _global).index];
              if (t && this.addTabstopMarkers(t), (this || _global).index = e, (t = (this || _global).tabstops[(this || _global).index]) && t.length) {
                e = ((this || _global).selectedTabstop = t).firstNonLinked || t;
                if (t.choices && (e.cursor = e.start), (this || _global).editor.inVirtualSelectionMode) (this || _global).editor.selection.fromOrientedRange(e);else {
                  var n = (this || _global).editor.multiSelect;
                  n.toSingleRange(e);
                  for (var i = 0; i < t.length; i++) t.hasLinkedRanges && t[i].linked || n.addRange(t[i].clone(), !0);
                }
                (this || _global).editor.keyBinding.addKeyboardHandler((this || _global).keyboardHandler), (this || _global).selectedTabstop && (this || _global).selectedTabstop.choices && (this || _global).editor.execCommand("startAutocomplete", {
                  matches: (this || _global).selectedTabstop.choices
                });
              }
            }, (this || _global).addTabstops = function (e, s, t) {
              var a = (this || _global).useLink || !(this || _global).editor.getOption("enableMultiselect");
              (this || _global).$openTabstops || ((this || _global).$openTabstops = []), e[0] || (t = h.fromPoints(t, t), C(t.start, s), C(t.end, s), e[0] = [t], e[0].index = 0);
              var l = [(this || _global).index + 1, 0],
                c = (this || _global).ranges;
              e.forEach(function (e, t) {
                for (var n = (this || _global).$openTabstops[t] || e, i = 0; i < e.length; i++) {
                  var o = e[i],
                    r = h.fromPoints(o.start, o.end || o.start);
                  f(r.start, s), f(r.end, s), r.original = o, r.tabstop = n, c.push(r), n != e ? n.unshift(r) : n[i] = r, o.fmtString || n.firstNonLinked && a ? (r.linked = !0, n.hasLinkedRanges = !0) : n.firstNonLinked || (n.firstNonLinked = r);
                }
                n.firstNonLinked || (n.hasLinkedRanges = !1), n === e && (l.push(n), (this || _global).$openTabstops[t] = n), this.addTabstopMarkers(n), n.rangeList = n.rangeList || new d(), n.rangeList.$bias = 0, n.rangeList.addList(n);
              }, this || _global), 2 < l.length && ((this || _global).tabstops.length && l.push(l.splice(2, 1)[0]), (this || _global).tabstops.splice.apply((this || _global).tabstops, l));
            }, (this || _global).addTabstopMarkers = function (e) {
              var t = (this || _global).editor.session;
              e.forEach(function (e) {
                e.markerId || (e.markerId = t.addMarker(e, "ace_snippet-marker", "text"));
              });
            }, (this || _global).removeTabstopMarkers = function (e) {
              var t = (this || _global).editor.session;
              e.forEach(function (e) {
                t.removeMarker(e.markerId), e.markerId = null;
              });
            }, (this || _global).removeRange = function (e) {
              var t = e.tabstop.indexOf(e);
              -1 != t && e.tabstop.splice(t, 1), -1 != (t = (this || _global).ranges.indexOf(e)) && (this || _global).ranges.splice(t, 1), -1 != (t = e.tabstop.rangeList.ranges.indexOf(e)) && e.tabstop.splice(t, 1), (this || _global).editor.session.removeMarker(e.markerId), e.tabstop.length || (-1 != (t = (this || _global).tabstops.indexOf(e.tabstop)) && (this || _global).tabstops.splice(t, 1), (this || _global).tabstops.length) || this.detach();
            }, (this || _global).keyboardHandler = new r(), (this || _global).keyboardHandler.bindKeys({
              Tab: function (e) {
                s.snippetManager && s.snippetManager.expandWithTab(e) || (e.tabstopManager.tabNext(1), e.renderer.scrollCursorIntoView());
              },
              "Shift-Tab": function (e) {
                e.tabstopManager.tabNext(-1), e.renderer.scrollCursorIntoView();
              },
              Esc: function (e) {
                e.tabstopManager.detach();
              }
            });
          }.call(m.prototype), function (e, t) {
            0 == e.row && (e.column += t.column), e.row += t.row;
          }),
          C = function (e, t) {
            e.row == t.row && (e.column -= t.column), e.row -= t.row;
          },
          n = (n.importCssString("\n.ace_snippet-marker {\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    background: rgba(194, 193, 208, 0.09);\n    border: 1px dotted rgba(211, 208, 235, 0.62);\n    position: absolute;\n}", "snippets.css", !1), s.snippetManager = new p(), e("./editor").Editor);
        !function () {
          (this || _global).insertSnippet = function (e, t) {
            return s.snippetManager.insertSnippet(this || _global, e, t);
          }, (this || _global).expandSnippet = function (e) {
            return s.snippetManager.expandWithTab(this || _global, e);
          };
        }.call(n.prototype);
      }), ace.define("ace/autocomplete/popup", ["require", "exports", "module", "ace/virtual_renderer", "ace/editor", "ace/range", "ace/lib/event", "ace/lib/lang", "ace/lib/dom", "ace/config"], function (e, t, n) {
        "use strict";

        function a(e) {
          return "suggest-aria-id:".concat(e);
        }
        function l(e) {
          return (e = new o(e)).$maxLines = 4, (e = new r(e)).setHighlightActiveLine(!1), e.setShowPrintMargin(!1), e.renderer.setShowGutter(!1), e.renderer.setHighlightGutterLine(!1), e.$mouseHandler.$focusTimeout = 0, e.$highlightTagPending = !0, e;
        }
        function i(e) {
          function t() {}
          function n() {
            s(-1);
          }
          var u,
            i = p.createElement("div"),
            g = new l(i),
            o = (e && e.appendChild(i), i.style.display = "none", g.renderer.content.style.cursor = "default", g.renderer.setStyle("ace_autocomplete"), g.renderer.container.setAttribute("role", "listbox"), g.renderer.container.setAttribute("aria-label", m("Autocomplete suggestions")), g.setOption("displayIndentGuides", !1), g.setOption("dragDelay", 150), g.focus = t, g.$isFocused = !0, g.renderer.$cursorLayer.restartTimer = t, g.renderer.$cursorLayer.element.style.opacity = 0, g.renderer.$maxLines = 8, g.renderer.$keepTextAreaAtCursor = !1, g.setHighlightActiveLine(!1), g.session.highlight(""), g.session.$searchHighlight.clazz = "ace_highlight-marker", g.on("mousedown", function (e) {
              var t = e.getDocumentPosition();
              g.selection.moveToPosition(t), r.start.row = r.end.row = t.row, e.stop();
            }), new c(-1, 0, -1, 1 / 0)),
            r = new c(-1, 0, -1, 1 / 0),
            s = (r.id = g.session.addMarker(r, "ace_active-line", "fullLine"), g.setSelectOnHover = function (e) {
              e ? o.id && (g.session.removeMarker(o.id), o.id = null) : o.id = g.session.addMarker(o, "ace_line-hover", "fullLine");
            }, g.setSelectOnHover(!1), g.on("mousemove", function (e) {
              var t;
              u ? u.x == e.x && u.y == e.y || ((u = e).scrollTop = g.renderer.scrollTop, t = u.getDocumentPosition().row, o.start.row != t && (o.id || g.setRow(t), s(t))) : u = e;
            }), g.renderer.on("beforeRender", function () {
              var e;
              u && -1 != o.start.row && (u.$pos = null, e = u.getDocumentPosition().row, o.id || g.setRow(e), s(e, !0));
            }), g.renderer.on("afterRender", function () {
              var e = g.getRow(),
                t = g.renderer.$textLayer,
                n = t.element.childNodes[e - t.config.firstRow],
                i = document.activeElement;
              n !== t.selectedNode && t.selectedNode && (p.removeCssClass(t.selectedNode, "ace_selected"), i.removeAttribute("aria-activedescendant"), t.selectedNode.removeAttribute("id")), (t.selectedNode = n) && (p.addCssClass(n, "ace_selected"), t = a(e), n.id = t, g.renderer.container.setAttribute("aria-activedescendant", t), i.setAttribute("aria-activedescendant", t), n.setAttribute("role", "option"), n.setAttribute("aria-label", g.getData(e).value), n.setAttribute("aria-setsize", g.data.length), n.setAttribute("aria-posinset", e));
            }), function (e, t) {
              e !== o.start.row && (o.start.row = o.end.row = e, t || g.session._emit("changeBackMarker"), g._emit("changeHoverMarker"));
            });
          return g.getHoveredRow = function () {
            return o.start.row;
          }, h.addListener(g.container, "mouseout", n), g.on("hide", n), g.on("changeSelection", n), g.session.doc.getLength = function () {
            return g.data.length;
          }, g.session.doc.getLine = function (e) {
            e = g.data[e];
            return "string" == typeof e ? e : e && e.value || "";
          }, (e = g.session.bgTokenizer).$tokenizeRow = function (e) {
            var n = g.data[e],
              i = [];
            if (n) {
              for (var t, o, r = (n = "string" == typeof n ? {
                  value: n
                } : n).caption || n.value || n.name, s = r.toLowerCase(), a = (g.filterText || "").toLowerCase(), l = 0, c = 0, h = 0; h <= a.length; h++) h != c && (n.matchMask & 1 << h || h == a.length) && (t = a.slice(c, h), c = h, -1 != (o = s.indexOf(t, l))) && (d(r.slice(l, o), ""), l = o + t.length, d(r.slice(o, l), "completion-highlight"));
              d(r.slice(l, r.length), ""), n.meta && i.push({
                type: "completion-meta",
                value: n.meta
              }), n.message && i.push({
                type: "completion-message",
                value: n.message
              });
            }
            return i;
            function d(e, t) {
              e && i.push({
                type: (n.className || "") + (t || ""),
                value: e
              });
            }
          }, e.$updateOnChange = t, e.start = t, g.session.$computeWidth = function () {
            return (this || _global).screenWidth = 0;
          }, g.isOpen = !1, g.isTopdown = !1, g.autoSelect = !0, g.filterText = "", g.data = [], g.setData = function (e, t) {
            g.filterText = t || "", g.setValue(d.stringRepeat("\n", e.length), -1), g.data = e || [], g.setRow(0);
          }, g.getData = function (e) {
            return g.data[e];
          }, g.getRow = function () {
            return r.start.row;
          }, g.setRow = function (e) {
            e = Math.max((this || _global).autoSelect ? 0 : -1, Math.min((this || _global).data.length, e)), r.start.row != e && (g.selection.clearSelection(), r.start.row = r.end.row = e || 0, g.session._emit("changeBackMarker"), g.moveCursorTo(e || 0, 0), g.isOpen) && g._signal("select");
          }, g.on("changeSelection", function () {
            g.isOpen && g.setRow(g.selection.lead.row), g.renderer.scrollCursorIntoView();
          }), g.hide = function () {
            (this || _global).container.style.display = "none", g.anchorPos = null, g.anchor = null, g.isOpen && (g.isOpen = !1, this._signal("hide"));
          }, g.tryShow = function (e, t, n, i) {
            if (i || !g.isOpen || !g.anchorPos || !g.anchor || g.anchorPos.top !== e.top || g.anchorPos.left !== e.left || g.anchor !== n) {
              var o = (this || _global).container,
                r = window.innerHeight,
                s = window.innerWidth,
                a = (this || _global).renderer,
                l = a.$maxLines * t * 1.4,
                c = {
                  top: 0,
                  bottom: 0,
                  left: 0
                },
                h = r - e.top - 3 * (this || _global).$borderSize - t,
                d = e.top - 3 * (this || _global).$borderSize,
                t = ("top" === (n = n || (d <= h || l <= h ? "bottom" : "top")) ? (c.bottom = e.top - (this || _global).$borderSize, c.top = c.bottom - l) : "bottom" === n && (c.top = e.top + t + (this || _global).$borderSize, c.bottom = c.top + l), 0 <= c.top && c.bottom <= r);
              if (!i && !t) return !1;
              a.$maxPixelHeight = t ? null : "top" === n ? d : h, "top" === n ? (o.style.top = "", o.style.bottom = r - c.bottom + "px", g.isTopdown = !1) : (o.style.top = c.top + "px", o.style.bottom = "", g.isTopdown = !0), o.style.display = "";
              l = e.left;
              l + o.offsetWidth > s && (l = s - o.offsetWidth), o.style.left = l + "px", o.style.right = "", g.isOpen || (g.isOpen = !0, this._signal("show"), u = null), g.anchorPos = e, g.anchor = n;
            }
            return !0;
          }, g.show = function (e, t, n) {
            this.tryShow(e, t, n ? "bottom" : void 0, !0);
          }, g.goTo = function (e) {
            var t = this.getRow(),
              n = (this || _global).session.getLength() - 1;
            switch (e) {
              case "up":
                t = t <= 0 ? n : t - 1;
                break;
              case "down":
                t = n <= t ? -1 : t + 1;
                break;
              case "start":
                t = 0;
                break;
              case "end":
                t = n;
            }
            this.setRow(t);
          }, g.getTextLeftOffset = function () {
            return (this || _global).$borderSize + (this || _global).renderer.$padding + (this || _global).$imageSize;
          }, g.$imageSize = 0, g.$borderSize = 1, g;
        }
        var o = e("../virtual_renderer").VirtualRenderer,
          r = e("../editor").Editor,
          c = e("../range").Range,
          h = e("../lib/event"),
          d = e("../lib/lang"),
          p = e("../lib/dom"),
          m = e("../config").nls;
        p.importCssString("\n.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\n    background-color: #CAD6FA;\n    z-index: 1;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\n    background-color: #3a674e;\n}\n.ace_editor.ace_autocomplete .ace_line-hover {\n    border: 1px solid #abbffe;\n    margin-top: -1px;\n    background: rgba(233,233,253,0.4);\n    position: absolute;\n    z-index: 2;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_line-hover {\n    border: 1px solid rgba(109, 150, 13, 0.8);\n    background: rgba(58, 103, 78, 0.62);\n}\n.ace_completion-meta {\n    opacity: 0.5;\n    margin: 0 0.9em;\n}\n.ace_completion-message {\n    color: blue;\n}\n.ace_editor.ace_autocomplete .ace_completion-highlight{\n    color: #2d69c7;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_completion-highlight{\n    color: #93ca12;\n}\n.ace_editor.ace_autocomplete {\n    width: 300px;\n    z-index: 200000;\n    border: 1px lightgray solid;\n    position: fixed;\n    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\n    line-height: 1.4;\n    background: #fefefe;\n    color: #111;\n}\n.ace_dark.ace_editor.ace_autocomplete {\n    border: 1px #484747 solid;\n    box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.51);\n    line-height: 1.4;\n    background: #25282c;\n    color: #c1c1c1;\n}\n.ace_autocomplete_right .ace_text-layer  {\n    width: calc(100% - 8px);\n}\n.ace_autocomplete_right .ace_line {\n    display: flex;\n}\n.ace_autocomplete_right .ace_completion-meta {\n    flex: 1;\n    text-align: right;\n}\n", "autocompletion.css", !1), t.AcePopup = i, t.$singleLineEditor = l, t.getAriaId = a;
      }), ace.define("ace/autocomplete/inline", ["require", "exports", "module", "ace/snippets"], function (e, t, n) {
        "use strict";

        var i = e("../snippets").snippetManager;
        function o() {
          (this || _global).editor = null;
        }
        o.prototype.show = function (e, t, n) {
          return n = n || "", e && (this || _global).editor && (this || _global).editor !== e && (this.hide(), (this || _global).editor = null), !(!e || !t || !(t = t.snippet ? i.getDisplayTextForSnippet(e, t.snippet) : t.value) || !t.startsWith(n) || ((this || _global).editor = e, "" === (t = t.slice(n.length)) ? e.removeGhostText() : e.setGhostText(t), 0));
        }, o.prototype.isOpen = function () {
          return !!(this || _global).editor && !!(this || _global).editor.renderer.$ghostText;
        }, o.prototype.hide = function () {
          return !!(this || _global).editor && ((this || _global).editor.removeGhostText(), !0);
        }, o.prototype.destroy = function () {
          this.hide(), (this || _global).editor = null;
        }, t.AceInline = o;
      }), ace.define("ace/autocomplete/util", ["require", "exports", "module"], function (e, t, n) {
        "use strict";

        t.parForEach = function (e, t, n) {
          var i = 0,
            o = e.length;
          0 === o && n();
          for (var r = 0; r < o; r++) t(e[r], function (e, t) {
            ++i === o && n(e, t);
          });
        };
        var r = /[a-zA-Z_0-9\$\-\u00A2-\u2000\u2070-\uFFFF]/;
        t.retrievePrecedingIdentifier = function (e, t, n) {
          n = n || r;
          for (var i = [], o = t - 1; 0 <= o && n.test(e[o]); o--) i.push(e[o]);
          return i.reverse().join("");
        }, t.retrieveFollowingIdentifier = function (e, t, n) {
          n = n || r;
          for (var i = [], o = t; o < e.length && n.test(e[o]); o++) i.push(e[o]);
          return i;
        }, t.getCompletionPrefix = function (e) {
          var t,
            n = e.getCursorPosition(),
            i = e.session.getLine(n.row);
          return e.completers.forEach(function (e) {
            e.identifierRegexps && e.identifierRegexps.forEach(function (e) {
              !t && e && (t = this.retrievePrecedingIdentifier(i, n.column, e));
            }.bind(this || _global));
          }.bind(this || _global)), t || this.retrievePrecedingIdentifier(i, n.column);
        };
      }), ace.define("ace/autocomplete", ["require", "exports", "module", "ace/keyboard/hash_handler", "ace/autocomplete/popup", "ace/autocomplete/inline", "ace/autocomplete/popup", "ace/autocomplete/util", "ace/lib/lang", "ace/lib/dom", "ace/snippets", "ace/config"], function (e, t, n) {
        "use strict";

        function i(e, t) {
          t.completer && t.completer.destroy();
        }
        var o = e("./keyboard/hash_handler").HashHandler,
          r = e("./autocomplete/popup").AcePopup,
          s = e("./autocomplete/inline").AceInline,
          a = e("./autocomplete/popup").getAriaId,
          c = e("./autocomplete/util"),
          l = e("./lib/lang"),
          h = e("./lib/dom"),
          d = e("./snippets").snippetManager,
          u = e("./config"),
          g = (p.prototype.$init = function () {
            return (this || _global).popup = new r(document.body || document.documentElement), (this || _global).popup.on("click", function (e) {
              this.insertMatch(), e.stop();
            }.bind(this || _global)), (this || _global).popup.focus = (this || _global).editor.focus.bind((this || _global).editor), (this || _global).popup.on("show", (this || _global).$onPopupChange.bind(this || _global)), (this || _global).popup.on("hide", (this || _global).$onHidePopup.bind(this || _global)), (this || _global).popup.on("select", (this || _global).$onPopupChange.bind(this || _global)), (this || _global).popup.on("changeHoverMarker", (this || _global).tooltipTimer.bind(null, null)), (this || _global).popup;
          }, p.prototype.$initInline = function () {
            if ((this || _global).inlineEnabled && !(this || _global).inlineRenderer) return (this || _global).inlineRenderer = new s(), (this || _global).inlineRenderer;
          }, p.prototype.getPopup = function () {
            return (this || _global).popup || this.$init();
          }, p.prototype.$onHidePopup = function () {
            (this || _global).inlineRenderer && (this || _global).inlineRenderer.hide(), this.hideDocTooltip();
          }, p.prototype.$onPopupChange = function (e) {
            var t;
            (this || _global).inlineRenderer && (this || _global).inlineEnabled && (e = e ? null : (this || _global).popup.getData((this || _global).popup.getRow()), t = c.getCompletionPrefix((this || _global).editor), (this || _global).inlineRenderer.show((this || _global).editor, e, t) || (this || _global).inlineRenderer.hide(), this.$updatePopupPosition()), (this || _global).tooltipTimer.call(null, null);
          }, p.prototype.$updatePopupPosition = function () {
            var e = (this || _global).editor,
              t = e.renderer,
              n = t.layerConfig.lineHeight,
              i = t.$cursorLayer.getPixelPosition((this || _global).base, !0),
              o = (i.left -= (this || _global).popup.getTextLeftOffset(), e.container.getBoundingClientRect()),
              o = (i.top += o.top - t.layerConfig.offset, i.left += o.left - e.renderer.scrollLeft, i.left += t.gutterWidth, {
                top: i.top,
                left: i.left
              });
            t.$ghostText && t.$ghostTextWidget && (this || _global).base.row === t.$ghostText.position.row && (o.top += t.$ghostTextWidget.el.offsetHeight), (this || _global).popup.tryShow(o, n, "bottom") || (this || _global).popup.tryShow(i, n, "top") || (this || _global).popup.show(i, n);
          }, p.prototype.openPopup = function (e, t, n) {
            (this || _global).popup || this.$init(), (this || _global).inlineEnabled && !(this || _global).inlineRenderer && this.$initInline(), (this || _global).popup.autoSelect = (this || _global).autoSelect, (this || _global).popup.setData((this || _global).completions.filtered, (this || _global).completions.filterText), (this || _global).editor.textInput.setAriaOptions && (this || _global).editor.textInput.setAriaOptions({
              activeDescendant: a((this || _global).popup.getRow()),
              inline: (this || _global).inlineEnabled
            }), e.keyBinding.addKeyboardHandler((this || _global).keyboardHandler), (this || _global).popup.setRow((this || _global).autoSelect ? 0 : -1), n ? t || this.detach() : ((this || _global).popup.setTheme(e.getTheme()), (this || _global).popup.setFontSize(e.getFontSize()), this.$updatePopupPosition(), (this || _global).tooltipNode && this.updateDocTooltip()), (this || _global).changeTimer.cancel();
          }, p.prototype.detach = function () {
            (this || _global).editor && ((this || _global).editor.keyBinding.removeKeyboardHandler((this || _global).keyboardHandler), (this || _global).editor.off("changeSelection", (this || _global).changeListener), (this || _global).editor.off("blur", (this || _global).blurListener), (this || _global).editor.off("mousedown", (this || _global).mousedownListener), (this || _global).editor.off("mousewheel", (this || _global).mousewheelListener)), (this || _global).changeTimer.cancel(), this.hideDocTooltip(), (this || _global).completionProvider && (this || _global).completionProvider.detach(), (this || _global).popup && (this || _global).popup.isOpen && (this || _global).popup.hide(), (this || _global).base && (this || _global).base.detach(), (this || _global).activated = !1, (this || _global).completionProvider = (this || _global).completions = (this || _global).base = null;
          }, p.prototype.changeListener = function (e) {
            var t = (this || _global).editor.selection.lead;
            (t.row != (this || _global).base.row || t.column < (this || _global).base.column) && this.detach(), (this || _global).activated ? (this || _global).changeTimer.schedule() : this.detach();
          }, p.prototype.blurListener = function (e) {
            var t = document.activeElement,
              n = (this || _global).editor.textInput.getElement(),
              i = e.relatedTarget && (this || _global).tooltipNode && (this || _global).tooltipNode.contains(e.relatedTarget),
              o = (this || _global).popup && (this || _global).popup.container;
            t == n || t.parentNode == o || i || t == (this || _global).tooltipNode || e.relatedTarget == n || this.detach();
          }, p.prototype.mousedownListener = function (e) {
            this.detach();
          }, p.prototype.mousewheelListener = function (e) {
            this.detach();
          }, p.prototype.goTo = function (e) {
            (this || _global).popup.goTo(e);
          }, p.prototype.insertMatch = function (e, t) {
            var n;
            return !!(e = e || (this || _global).popup.getData((this || _global).popup.getRow())) && (n = (this || _global).completions, e = this.getCompletionProvider().insertMatch((this || _global).editor, e, n.filterText, t), (this || _global).completions == n && this.detach(), e);
          }, p.prototype.showPopup = function (e, t) {
            (this || _global).editor && this.detach(), (this || _global).activated = !0, ((this || _global).editor = e).completer != (this || _global) && (e.completer && e.completer.detach(), e.completer = this || _global), e.on("changeSelection", (this || _global).changeListener), e.on("blur", (this || _global).blurListener), e.on("mousedown", (this || _global).mousedownListener), e.on("mousewheel", (this || _global).mousewheelListener), this.updateCompletions(!1, t);
          }, p.prototype.getCompletionProvider = function () {
            return (this || _global).completionProvider || ((this || _global).completionProvider = new m()), (this || _global).completionProvider;
          }, p.prototype.gatherCompletions = function (e, t) {
            return this.getCompletionProvider().gatherCompletions(e, t);
          }, p.prototype.updateCompletions = function (r, e) {
            var t, n;
            return r && (this || _global).base && (this || _global).completions ? (t = (this || _global).editor.getCursorPosition(), (n = (this || _global).editor.session.getTextRange({
              start: (this || _global).base,
              end: t
            })) == (this || _global).completions.filterText ? void 0 : ((this || _global).completions.setFilter(n), (this || _global).completions.filtered.length && (1 != (this || _global).completions.filtered.length || (this || _global).completions.filtered[0].value != n || (this || _global).completions.filtered[0].snippet) ? void this.openPopup((this || _global).editor, n, r) : this.detach())) : e && e.matches ? (t = (this || _global).editor.getSelectionRange().start, (this || _global).base = (this || _global).editor.session.doc.createAnchor(t.row, t.column), (this || _global).base.$insertRight = !0, (this || _global).completions = new C(e.matches), this.openPopup((this || _global).editor, "", r)) : (e = (this || _global).editor.getSession(), t = (this || _global).editor.getCursorPosition(), n = c.getCompletionPrefix((this || _global).editor), (this || _global).base = e.doc.createAnchor(t.row, t.column - n.length), (this || _global).base.$insertRight = !0, e = {
              exactMatch: (this || _global).exactMatch
            }, void this.getCompletionProvider().provideCompletions((this || _global).editor, e, function (e, t, n) {
              var i = t.filtered,
                o = c.getCompletionPrefix((this || _global).editor);
              if (n) {
                if (!i.length) return this.detach();
                if (1 == i.length && i[0].value == o && !i[0].snippet) return this.detach();
                if ((this || _global).autoInsert && 1 == i.length) return this.insertMatch(i[0]);
              }
              (this || _global).completions = t, this.openPopup((this || _global).editor, o, r);
            }.bind(this || _global)));
          }, p.prototype.cancelContextMenu = function () {
            (this || _global).editor.$mouseHandler.cancelContextMenu();
          }, p.prototype.updateDocTooltip = function () {
            var e = (this || _global).popup,
              t = e.data,
              n = t && (t[e.getHoveredRow()] || t[e.getRow()]),
              i = null;
            if (!n || !(this || _global).editor || !(this || _global).popup.isOpen) return this.hideDocTooltip();
            for (var o = (this || _global).editor.completers.length, r = 0; r < o; r++) {
              var s = (this || _global).editor.completers[r];
              if (s.getDocTooltip && n.completerId === s.id) {
                i = s.getDocTooltip(n);
                break;
              }
            }
            if (!(i = "string" == typeof (i = i || "string" == typeof n ? i : n) ? {
              docText: i
            } : i) || !i.docHTML && !i.docText) return this.hideDocTooltip();
            this.showDocTooltip(i);
          }, p.prototype.showDocTooltip = function (e) {
            (this || _global).tooltipNode || ((this || _global).tooltipNode = h.createElement("div"), (this || _global).tooltipNode.style.margin = 0, (this || _global).tooltipNode.style.pointerEvents = "auto", (this || _global).tooltipNode.tabIndex = -1, (this || _global).tooltipNode.onblur = (this || _global).blurListener.bind(this || _global), (this || _global).tooltipNode.onclick = (this || _global).onTooltipClick.bind(this || _global));
            var t = (this || _global).editor.renderer.theme,
              t = ((this || _global).tooltipNode.className = "ace_tooltip ace_doc-tooltip " + (t.isDark ? "ace_dark " : "") + (t.cssClass || ""), (this || _global).tooltipNode),
              e = (e.docHTML ? t.innerHTML = e.docHTML : e.docText && (t.textContent = e.docText), t.parentNode || document.body.appendChild(t), (this || _global).popup),
              n = e.container.getBoundingClientRect();
            t.style.top = e.container.style.top, t.style.bottom = e.container.style.bottom, t.style.display = "block", window.innerWidth - n.right < 320 ? n.left < 320 ? (e.isTopdown ? t.style.top = n.bottom + "px" : t.style.top = e.container.offsetTop - t.offsetHeight + "px", t.style.left = n.left + "px", t.style.right = "", t.style.bottom = "") : (t.style.right = window.innerWidth - n.left + "px", t.style.left = "") : (t.style.left = n.right + 1 + "px", t.style.right = "");
          }, p.prototype.hideDocTooltip = function () {
            var e;
            (this || _global).tooltipTimer.cancel(), (this || _global).tooltipNode && (e = (this || _global).tooltipNode, (this || _global).editor.isFocused() || document.activeElement != e || (this || _global).editor.focus(), (this || _global).tooltipNode = null, e.parentNode) && e.parentNode.removeChild(e);
          }, p.prototype.onTooltipClick = function (e) {
            for (var t = e.target; t && t != (this || _global).tooltipNode;) {
              if ("A" == t.nodeName && t.href) {
                t.rel = "noreferrer", t.target = "_blank";
                break;
              }
              t = t.parentNode;
            }
          }, p.prototype.destroy = function () {
            var e;
            this.detach(), (this || _global).popup && ((this || _global).popup.destroy(), e = (this || _global).popup.container) && e.parentNode && e.parentNode.removeChild(e), (this || _global).editor && (this || _global).editor.completer == (this || _global) && ((this || _global).editor.off("destroy", i), (this || _global).editor.completer = null), (this || _global).inlineRenderer = (this || _global).popup = (this || _global).editor = null;
          }, p);
        function p() {
          (this || _global).autoInsert = !1, (this || _global).autoSelect = !0, (this || _global).exactMatch = !1, (this || _global).inlineEnabled = !1, (this || _global).keyboardHandler = new o(), (this || _global).keyboardHandler.bindKeys((this || _global).commands), (this || _global).blurListener = (this || _global).blurListener.bind(this || _global), (this || _global).changeListener = (this || _global).changeListener.bind(this || _global), (this || _global).mousedownListener = (this || _global).mousedownListener.bind(this || _global), (this || _global).mousewheelListener = (this || _global).mousewheelListener.bind(this || _global), (this || _global).changeTimer = l.delayedCall(function () {
            this.updateCompletions(!0);
          }.bind(this || _global)), (this || _global).tooltipTimer = l.delayedCall((this || _global).updateDocTooltip.bind(this || _global), 50);
        }
        g.prototype.commands = {
          Up: function (e) {
            e.completer.goTo("up");
          },
          Down: function (e) {
            e.completer.goTo("down");
          },
          "Ctrl-Up|Ctrl-Home": function (e) {
            e.completer.goTo("start");
          },
          "Ctrl-Down|Ctrl-End": function (e) {
            e.completer.goTo("end");
          },
          Esc: function (e) {
            e.completer.detach();
          },
          Return: function (e) {
            return e.completer.insertMatch();
          },
          "Shift-Return": function (e) {
            e.completer.insertMatch(null, {
              deleteSuffix: !0
            });
          },
          Tab: function (e) {
            var t = e.completer.insertMatch();
            if (t || e.tabstopManager) return t;
            e.completer.goTo("down");
          },
          PageUp: function (e) {
            e.completer.popup.gotoPageUp();
          },
          PageDown: function (e) {
            e.completer.popup.gotoPageDown();
          }
        }, g.for = function (e) {
          return e.completer instanceof g || (e.completer && (e.completer.destroy(), e.completer = null), u.get("sharedPopups") ? (g.$sharedInstance || (g.$sharedInstance = new g()), e.completer = g.$sharedInstance) : (e.completer = new g(), e.once("destroy", i))), e.completer;
        }, g.startCommand = {
          name: "startAutocomplete",
          exec: function (e, t) {
            var n = g.for(e);
            n.autoInsert = !1, n.autoSelect = !0, n.showPopup(e, t), n.cancelContextMenu();
          },
          bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
        };
        f.prototype.insertByIndex = function (e, t, n) {
          return !(!(this || _global).completions || !(this || _global).completions.filtered) && this.insertMatch(e, (this || _global).completions.filtered[t], n);
        }, f.prototype.insertMatch = function (e, t, n) {
          if (!t) return !1;
          if (e.startOperation({
            command: {
              name: "insertMatch"
            }
          }), t.completer && t.completer.insertMatch) t.completer.insertMatch(e, t);else {
            if (!(this || _global).completions) return !1;
            if ((this || _global).completions.filterText) for (var i, o = e.selection.getAllRanges ? e.selection.getAllRanges() : [e.getSelectionRange()], r = 0; i = o[r]; r++) i.start.column -= (this || _global).completions.filterText.length, e.session.remove(i);
            t.snippet ? d.insertSnippet(e, t.snippet, {
              range: t.range
            }) : this.$insertString(e, t), t.command && "startAutocomplete" === t.command && e.execCommand(t.command);
          }
          return e.endOperation(), !0;
        }, f.prototype.$insertString = function (t, n) {
          var i = n.value || n;
          if (n.range) {
            if (t.inVirtualSelectionMode) return t.session.replace(n.range, i);
            t.forEachSelection(function () {
              var e = t.getSelectionRange();
              0 === n.range.compareRange(e) ? t.session.replace(n.range, i) : t.insert(i);
            }, null, {
              keepOrder: !0
            });
          } else t.execCommand("insertstring", i);
        }, f.prototype.gatherCompletions = function (n, i) {
          var o = n.getSession(),
            r = n.getCursorPosition(),
            s = c.getCompletionPrefix(n),
            a = [],
            l = n.completers.length;
          return n.completers.forEach(function (e, t) {
            e.getCompletions(n, o, r, s, function (e, t) {
              !e && t && (a = a.concat(t)), i(null, {
                prefix: c.getCompletionPrefix(n),
                matches: a,
                finished: 0 == --l
              });
            });
          }), !0;
        }, f.prototype.provideCompletions = function (e, i, o) {
          var n = function (e) {
              var t = e.prefix,
                n = e.matches;
              (this || _global).completions = new C(n), i.exactMatch && ((this || _global).completions.exactMatch = !0), i.ignoreCaption && ((this || _global).completions.ignoreCaption = !0), (this || _global).completions.setFilter(t), (e.finished || (this || _global).completions.filtered.length) && o(null, (this || _global).completions, e.finished);
            }.bind(this || _global),
            r = !0,
            s = null;
          this.gatherCompletions(e, function (e, t) {
            (this || _global).active && (e && (o(e, [], !0), this.detach()), 0 === t.prefix.indexOf(t.prefix)) && (r ? s = t : n(t));
          }.bind(this || _global)), r = !1, s && (e = s, s = null, n(e));
        }, f.prototype.detach = function () {
          (this || _global).active = !1;
        };
        var m = f;
        function f() {
          (this || _global).active = !0;
        }
        y.prototype.setFilter = function (e) {
          t = e.length > (this || _global).filterText && 0 === e.lastIndexOf((this || _global).filterText, 0) ? (this || _global).filtered : (this || _global).all, (this || _global).filterText = e, t = (t = this.filterCompletions(t, (this || _global).filterText)).sort(function (e, t) {
            return t.exactMatch - e.exactMatch || t.$score - e.$score || (e.caption || e.value).localeCompare(t.caption || t.value);
          });
          var t,
            n = null;
          t = t.filter(function (e) {
            e = e.snippet || e.caption || e.value;
            return e !== n && (n = e, !0);
          }), (this || _global).filtered = t;
        }, y.prototype.filterCompletions = function (e, t) {
          var n = [],
            i = t.toUpperCase(),
            o = t.toLowerCase();
          e: for (var r, s = 0; r = e[s]; s++) {
            var a = !(this || _global).ignoreCaption && r.caption || r.value || r.snippet;
            if (a) {
              var l = -1,
                c = 0,
                h = 0;
              if ((this || _global).exactMatch) {
                if (t !== a.substr(0, t.length)) continue;
              } else {
                var d = a.toLowerCase().indexOf(o);
                if (-1 < d) h = d;else for (var u = 0; u < t.length; u++) {
                  var g = a.indexOf(o[u], l + 1),
                    p = a.indexOf(i[u], l + 1);
                  if ((g = 0 <= g && (p < 0 || g < p) ? g : p) < 0) continue e;
                  0 < (p = g - l - 1) && (-1 === l && (h += 10), h += p, c |= 1 << u), l = g;
                }
              }
              r.matchMask = c, r.exactMatch = h ? 0 : 1, r.$score = (r.score || 0) - h, n.push(r);
            }
          }
          return n;
        };
        var C = y;
        function y(e, t) {
          (this || _global).all = e, (this || _global).filtered = e, (this || _global).filterText = t || "", (this || _global).exactMatch = !1, (this || _global).ignoreCaption = !1;
        }
        t.Autocomplete = g, t.CompletionProvider = m, t.FilteredList = C;
      }), ace.define("ace/autocomplete/text_completer", ["require", "exports", "module", "ace/range"], function (e, t, n) {
        var s = e("../range").Range,
          a = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;
        function l(e, t) {
          var n = e.getTextRange(s.fromPoints({
              row: 0,
              column: 0
            }, t)).split(a).length - 1,
            i = e.getValue().split(a),
            o = Object.create(null),
            r = i[n];
          return i.forEach(function (e, t) {
            e && e !== r && (t = Math.abs(n - t), t = i.length - t, o[e] ? o[e] = Math.max(t, o[e]) : o[e] = t);
          }), o;
        }
        t.getCompletions = function (e, t, n, i, o) {
          var r = l(t, n);
          o(null, Object.keys(r).map(function (e) {
            return {
              caption: e,
              value: e,
              score: r[e],
              meta: "local"
            };
          }));
        };
      }), ace.define("ace/ext/language_tools", ["require", "exports", "module", "ace/snippets", "ace/autocomplete", "ace/config", "ace/lib/lang", "ace/autocomplete/util", "ace/autocomplete/text_completer", "ace/editor", "ace/config"], function (e, t, n) {
        "use strict";

        function i(e, t) {
          m(t.session.$mode);
        }
        function o(e) {
          var t = e.editor,
            n = t.completer && t.completer.activated;
          "backspace" === e.command.name ? n && !c.getCompletionPrefix(t) && t.completer.detach() : "insertstring" === e.command.name && c.getCompletionPrefix(t) && !n && ((e = r.for(t)).autoInsert = !1, e.showPopup(t));
        }
        var l = e("../snippets").snippetManager,
          r = e("../autocomplete").Autocomplete,
          s = e("../config"),
          a = e("../lib/lang"),
          c = e("../autocomplete/util"),
          h = e("../autocomplete/text_completer"),
          d = {
            getCompletions: function (e, t, n, i, o) {
              if (t.$mode.completer) return t.$mode.completer.getCompletions(e, t, n, i, o);
              e = e.session.getState(n.row);
              o(null, t.$mode.getCompletions(e, t, n, i).map(function (e) {
                return e.completerId = d.id, e;
              }));
            },
            id: "keywordCompleter"
          },
          u = {
            getCompletions: function (e, t, n, i, o) {
              var r = [],
                t = t.getTokenAt(n.row, n.column),
                s = (t && t.type.match(/(tag-name|tag-open|tag-whitespace|attribute-name|attribute-value)\.xml$/) ? r.push("html-tag") : r = l.getActiveScopes(e), l.snippetMap),
                a = [];
              r.forEach(function (e) {
                for (var t = s[e] || [], n = t.length; n--;) {
                  var i = t[n],
                    o = i.name || i.tabTrigger;
                  o && a.push({
                    caption: o,
                    snippet: i.content,
                    meta: i.tabTrigger && !i.name ? i.tabTrigger + "\u21E5 " : "snippet",
                    completerId: u.id
                  });
                }
              }, this || _global), o(null, a);
            },
            getDocTooltip: function (e) {
              var o;
              e.snippet && !e.docHTML && (e.docHTML = ["<b>", a.escapeHTML(e.caption), "</b>", "<hr></hr>", a.escapeHTML((e = e.snippet, o = {}, e.replace(/\${(\d+)(:(.*?))?}/g, function (e, t, n, i) {
                return o[t] = i || "";
              }).replace(/\$(\d+?)/g, function (e, t) {
                return o[t];
              })))].join(""));
            },
            id: "snippetCompleter"
          },
          g = [u, h, d],
          p = (t.setCompleters = function (e) {
            g.length = 0, e && g.push.apply(g, e);
          }, t.addCompleter = function (e) {
            g.push(e);
          }, t.textCompleter = h, t.keyWordCompleter = d, t.snippetCompleter = u, {
            name: "expandSnippet",
            exec: function (e) {
              return l.expandWithTab(e);
            },
            bindKey: "Tab"
          }),
          m = function (e) {
            (e = "string" == typeof e ? s.$modes[e] : e) && (l.files || (l.files = {}), f(e.$id, e.snippetFileId), e.modes) && e.modes.forEach(m);
          },
          f = function (t, e) {
            e && t && !l.files[t] && (l.files[t] = {}, s.loadModule(e, function (e) {
              e && (!(l.files[t] = e).snippets && e.snippetText && (e.snippets = l.parseSnippetFile(e.snippetText)), l.register(e.snippets || [], e.scope), e.includeScopes) && (l.snippetMap[e.scope].includeScopes = e.includeScopes, e.includeScopes.forEach(function (e) {
                m("ace/mode/" + e);
              }));
            }));
          },
          h = e("../editor").Editor;
        e("../config").defineOptions(h.prototype, "editor", {
          enableBasicAutocompletion: {
            set: function (e) {
              e ? ((this || _global).completers || ((this || _global).completers = Array.isArray(e) ? e : g), (this || _global).commands.addCommand(r.startCommand)) : (this || _global).commands.removeCommand(r.startCommand);
            },
            value: !1
          },
          enableLiveAutocompletion: {
            set: function (e) {
              e ? ((this || _global).completers || ((this || _global).completers = Array.isArray(e) ? e : g), (this || _global).commands.on("afterExec", o)) : (this || _global).commands.removeListener("afterExec", o);
            },
            value: !1
          },
          enableSnippets: {
            set: function (e) {
              e ? ((this || _global).commands.addCommand(p), this.on("changeMode", i), i(0, this || _global)) : ((this || _global).commands.removeCommand(p), this.off("changeMode", i));
            },
            value: !1
          }
        });
      }), ace.require(["ace/ext/language_tools"], function (e) {
        t && (t.exports = e);
      });
    },
    3330: function (t, e, n) {
      t = n.nmd(t), ace.define("ace/ext/searchbox.css", ["require", "exports", "module"], function (e, t, n) {
        n.exports = "\n\n/* ------------------------------------------------------------------------------------------\n * Editor Search Form\n * --------------------------------------------------------------------------------------- */\n.ace_search {\n    background-color: #ddd;\n    color: #666;\n    border: 1px solid #cbcbcb;\n    border-top: 0 none;\n    overflow: hidden;\n    margin: 0;\n    padding: 4px 6px 0 4px;\n    position: absolute;\n    top: 0;\n    z-index: 99;\n    white-space: normal;\n}\n.ace_search.left {\n    border-left: 0 none;\n    border-radius: 0px 0px 5px 0px;\n    left: 0;\n}\n.ace_search.right {\n    border-radius: 0px 0px 0px 5px;\n    border-right: 0 none;\n    right: 0;\n}\n\n.ace_search_form, .ace_replace_form {\n    margin: 0 20px 4px 0;\n    overflow: hidden;\n    line-height: 1.9;\n}\n.ace_replace_form {\n    margin-right: 0;\n}\n.ace_search_form.ace_nomatch {\n    outline: 1px solid red;\n}\n\n.ace_search_field {\n    border-radius: 3px 0 0 3px;\n    background-color: white;\n    color: black;\n    border: 1px solid #cbcbcb;\n    border-right: 0 none;\n    outline: 0;\n    padding: 0;\n    font-size: inherit;\n    margin: 0;\n    line-height: inherit;\n    padding: 0 6px;\n    min-width: 17em;\n    vertical-align: top;\n    min-height: 1.8em;\n    box-sizing: content-box;\n}\n.ace_searchbtn {\n    border: 1px solid #cbcbcb;\n    line-height: inherit;\n    display: inline-block;\n    padding: 0 6px;\n    background: #fff;\n    border-right: 0 none;\n    border-left: 1px solid #dcdcdc;\n    cursor: pointer;\n    margin: 0;\n    position: relative;\n    color: #666;\n}\n.ace_searchbtn:last-child {\n    border-radius: 0 3px 3px 0;\n    border-right: 1px solid #cbcbcb;\n}\n.ace_searchbtn:disabled {\n    background: none;\n    cursor: default;\n}\n.ace_searchbtn:hover {\n    background-color: #eef1f6;\n}\n.ace_searchbtn.prev, .ace_searchbtn.next {\n     padding: 0px 0.7em\n}\n.ace_searchbtn.prev:after, .ace_searchbtn.next:after {\n     content: \"\";\n     border: solid 2px #888;\n     width: 0.5em;\n     height: 0.5em;\n     border-width:  2px 0 0 2px;\n     display:inline-block;\n     transform: rotate(-45deg);\n}\n.ace_searchbtn.next:after {\n     border-width: 0 2px 2px 0 ;\n}\n.ace_searchbtn_close {\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAAZ0lEQVR42u2SUQrAMAhDvazn8OjZBilCkYVVxiis8H4CT0VrAJb4WHT3C5xU2a2IQZXJjiQIRMdkEoJ5Q2yMqpfDIo+XY4k6h+YXOyKqTIj5REaxloNAd0xiKmAtsTHqW8sR2W5f7gCu5nWFUpVjZwAAAABJRU5ErkJggg==) no-repeat 50% 0;\n    border-radius: 50%;\n    border: 0 none;\n    color: #656565;\n    cursor: pointer;\n    font: 16px/16px Arial;\n    padding: 0;\n    height: 14px;\n    width: 14px;\n    top: 9px;\n    right: 7px;\n    position: absolute;\n}\n.ace_searchbtn_close:hover {\n    background-color: #656565;\n    background-position: 50% 100%;\n    color: white;\n}\n\n.ace_button {\n    margin-left: 2px;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    overflow: hidden;\n    opacity: 0.7;\n    border: 1px solid rgba(100,100,100,0.23);\n    padding: 1px;\n    box-sizing:    border-box!important;\n    color: black;\n}\n\n.ace_button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_button:active {\n    background-color: #ddd;\n}\n\n.ace_button.checked {\n    border-color: #3399ff;\n    opacity:1;\n}\n\n.ace_search_options{\n    margin-bottom: 3px;\n    text-align: right;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    clear: both;\n}\n\n.ace_search_counter {\n    float: left;\n    font-family: arial;\n    padding: 0 8px;\n}";
      }), ace.define("ace/ext/searchbox", ["require", "exports", "module", "ace/lib/dom", "ace/lib/lang", "ace/lib/event", "ace/ext/searchbox.css", "ace/keyboard/hash_handler", "ace/lib/keys", "ace/config"], function (e, t, n) {
        "use strict";

        var o = e("../lib/dom"),
          r = e("../lib/lang"),
          s = e("../lib/event"),
          a = e("./searchbox.css"),
          i = e("../keyboard/hash_handler").HashHandler,
          l = e("../lib/keys"),
          c = e("../config").nls,
          h = (o.importCssString(a, "ace_searchbox", !1), d.prototype.setEditor = function (e) {
            e.searchBox = this || _global, e.renderer.scroller.appendChild((this || _global).element), (this || _global).editor = e;
          }, d.prototype.setSession = function (e) {
            (this || _global).searchRange = null, this.$syncOptions(!0);
          }, d.prototype.$initElements = function (e) {
            (this || _global).searchBox = e.querySelector(".ace_search_form"), (this || _global).replaceBox = e.querySelector(".ace_replace_form"), (this || _global).searchOption = e.querySelector("[action=searchInSelection]"), (this || _global).replaceOption = e.querySelector("[action=toggleReplace]"), (this || _global).regExpOption = e.querySelector("[action=toggleRegexpMode]"), (this || _global).caseSensitiveOption = e.querySelector("[action=toggleCaseSensitive]"), (this || _global).wholeWordOption = e.querySelector("[action=toggleWholeWords]"), (this || _global).searchInput = (this || _global).searchBox.querySelector(".ace_search_field"), (this || _global).replaceInput = (this || _global).replaceBox.querySelector(".ace_search_field"), (this || _global).searchCounter = e.querySelector(".ace_search_counter");
          }, d.prototype.$init = function () {
            var e = (this || _global).element,
              i = (this.$initElements(e), this || _global);
            s.addListener(e, "mousedown", function (e) {
              setTimeout(function () {
                i.activeInput.focus();
              }, 0), s.stopPropagation(e);
            }), s.addListener(e, "click", function (e) {
              var t = (e.target || e.srcElement).getAttribute("action");
              t && i[t] ? i[t]() : i.$searchBarKb.commands[t] && i.$searchBarKb.commands[t].exec(i), s.stopPropagation(e);
            }), s.addCommandKeyListener(e, function (e, t, n) {
              n = l.keyCodeToString(n), t = i.$searchBarKb.findKeyCommand(t, n);
              t && t.exec && (t.exec(i), s.stopEvent(e));
            }), (this || _global).$onChange = r.delayedCall(function () {
              i.find(!1, !1);
            }), s.addListener((this || _global).searchInput, "input", function () {
              i.$onChange.schedule(20);
            }), s.addListener((this || _global).searchInput, "focus", function () {
              i.activeInput = i.searchInput, i.searchInput.value && i.highlight();
            }), s.addListener((this || _global).replaceInput, "focus", function () {
              i.activeInput = i.replaceInput, i.searchInput.value && i.highlight();
            });
          }, d.prototype.setSearchRange = function (e) {
            ((this || _global).searchRange = e) ? (this || _global).searchRangeMarker = (this || _global).editor.session.addMarker(e, "ace_active-line") : (this || _global).searchRangeMarker && ((this || _global).editor.session.removeMarker((this || _global).searchRangeMarker), (this || _global).searchRangeMarker = null);
          }, d.prototype.$syncOptions = function (e) {
            o.setCssClass((this || _global).replaceOption, "checked", (this || _global).searchRange), o.setCssClass((this || _global).searchOption, "checked", (this || _global).searchOption.checked), (this || _global).replaceOption.textContent = (this || _global).replaceOption.checked ? "-" : "+", o.setCssClass((this || _global).regExpOption, "checked", (this || _global).regExpOption.checked), o.setCssClass((this || _global).wholeWordOption, "checked", (this || _global).wholeWordOption.checked), o.setCssClass((this || _global).caseSensitiveOption, "checked", (this || _global).caseSensitiveOption.checked);
            var t = (this || _global).editor.getReadOnly();
            (this || _global).replaceOption.style.display = t ? "none" : "", (this || _global).replaceBox.style.display = (this || _global).replaceOption.checked && !t ? "" : "none", this.find(!1, !1, e);
          }, d.prototype.highlight = function (e) {
            (this || _global).editor.session.highlight(e || (this || _global).editor.$search.$options.re), (this || _global).editor.renderer.updateBackMarkers();
          }, d.prototype.find = function (e, t, n) {
            e = !(this || _global).editor.find((this || _global).searchInput.value, {
              skipCurrent: e,
              backwards: t,
              wrap: !0,
              regExp: (this || _global).regExpOption.checked,
              caseSensitive: (this || _global).caseSensitiveOption.checked,
              wholeWord: (this || _global).wholeWordOption.checked,
              preventScroll: n,
              range: (this || _global).searchRange
            }) && (this || _global).searchInput.value;
            o.setCssClass((this || _global).searchBox, "ace_nomatch", e), (this || _global).editor._emit("findSearchBox", {
              match: !e
            }), this.highlight(), this.updateCounter();
          }, d.prototype.updateCounter = function () {
            var e = (this || _global).editor,
              t = e.$search.$options.re,
              n = 0,
              i = 0;
            if (t) {
              var o,
                r,
                s = (this || _global).searchRange ? e.session.getTextRange((this || _global).searchRange) : e.getValue(),
                a = e.session.doc.positionToIndex(e.selection.anchor);
              for ((this || _global).searchRange && (a -= e.session.doc.positionToIndex((this || _global).searchRange.start)), t.lastIndex = 0; (r = t.exec(s)) && ((o = r.index) <= a && i++, !(999 < ++n)) && (r[0] || (t.lastIndex = o += 1, !(o >= s.length))););
            }
            (this || _global).searchCounter.textContent = c("$0 of $1", [i, 999 < n ? "999+" : n]);
          }, d.prototype.findNext = function () {
            this.find(!0, !1);
          }, d.prototype.findPrev = function () {
            this.find(!0, !0);
          }, d.prototype.findAll = function () {
            var e = !(this || _global).editor.findAll((this || _global).searchInput.value, {
              regExp: (this || _global).regExpOption.checked,
              caseSensitive: (this || _global).caseSensitiveOption.checked,
              wholeWord: (this || _global).wholeWordOption.checked
            }) && (this || _global).searchInput.value;
            o.setCssClass((this || _global).searchBox, "ace_nomatch", e), (this || _global).editor._emit("findSearchBox", {
              match: !e
            }), this.highlight(), this.hide();
          }, d.prototype.replace = function () {
            (this || _global).editor.getReadOnly() || (this || _global).editor.replace((this || _global).replaceInput.value);
          }, d.prototype.replaceAndFindNext = function () {
            (this || _global).editor.getReadOnly() || ((this || _global).editor.replace((this || _global).replaceInput.value), this.findNext());
          }, d.prototype.replaceAll = function () {
            (this || _global).editor.getReadOnly() || (this || _global).editor.replaceAll((this || _global).replaceInput.value);
          }, d.prototype.hide = function () {
            (this || _global).active = !1, this.setSearchRange(null), (this || _global).editor.off("changeSession", (this || _global).setSession), (this || _global).element.style.display = "none", (this || _global).editor.keyBinding.removeKeyboardHandler((this || _global).$closeSearchBarKb), (this || _global).editor.focus();
          }, d.prototype.show = function (e, t) {
            (this || _global).active = !0, (this || _global).editor.on("changeSession", (this || _global).setSession), (this || _global).element.style.display = "", (this || _global).replaceOption.checked = t, e && ((this || _global).searchInput.value = e), (this || _global).searchInput.focus(), (this || _global).searchInput.select(), (this || _global).editor.keyBinding.addKeyboardHandler((this || _global).$closeSearchBarKb), this.$syncOptions(!0);
          }, d.prototype.isFocused = function () {
            var e = document.activeElement;
            return e == (this || _global).searchInput || e == (this || _global).replaceInput;
          }, d);
        function d(e, t, n) {
          var i = o.createElement("div");
          o.buildDom(["div", {
            class: "ace_search right"
          }, ["span", {
            action: "hide",
            class: "ace_searchbtn_close"
          }], ["div", {
            class: "ace_search_form"
          }, ["input", {
            class: "ace_search_field",
            placeholder: c("Search for"),
            spellcheck: "false"
          }], ["span", {
            action: "findPrev",
            class: "ace_searchbtn prev"
          }, "\u200B"], ["span", {
            action: "findNext",
            class: "ace_searchbtn next"
          }, "\u200B"], ["span", {
            action: "findAll",
            class: "ace_searchbtn",
            title: "Alt-Enter"
          }, c("All")]], ["div", {
            class: "ace_replace_form"
          }, ["input", {
            class: "ace_search_field",
            placeholder: c("Replace with"),
            spellcheck: "false"
          }], ["span", {
            action: "replaceAndFindNext",
            class: "ace_searchbtn"
          }, c("Replace")], ["span", {
            action: "replaceAll",
            class: "ace_searchbtn"
          }, c("All")]], ["div", {
            class: "ace_search_options"
          }, ["span", {
            action: "toggleReplace",
            class: "ace_button",
            title: c("Toggle Replace mode"),
            style: "float:left;margin-top:-2px;padding:0 5px;"
          }, "+"], ["span", {
            class: "ace_search_counter"
          }], ["span", {
            action: "toggleRegexpMode",
            class: "ace_button",
            title: c("RegExp Search")
          }, ".*"], ["span", {
            action: "toggleCaseSensitive",
            class: "ace_button",
            title: c("CaseSensitive Search")
          }, "Aa"], ["span", {
            action: "toggleWholeWords",
            class: "ace_button",
            title: c("Whole Word Search")
          }, "\\b"], ["span", {
            action: "searchInSelection",
            class: "ace_button",
            title: c("Search In Selection")
          }, "S"]]], i), (this || _global).element = i.firstChild, (this || _global).setSession = (this || _global).setSession.bind(this || _global), this.$init(), this.setEditor(e), o.importCssString(a, "ace_searchbox", e.container);
        }
        e = new i(), e.bindKeys({
          "Ctrl-f|Command-f": function (e) {
            var t = e.isReplace = !e.isReplace;
            e.replaceBox.style.display = t ? "" : "none", e.replaceOption.checked = !1, e.$syncOptions(), e.searchInput.focus();
          },
          "Ctrl-H|Command-Option-F": function (e) {
            e.editor.getReadOnly() || (e.replaceOption.checked = !0, e.$syncOptions(), e.replaceInput.focus());
          },
          "Ctrl-G|Command-G": function (e) {
            e.findNext();
          },
          "Ctrl-Shift-G|Command-Shift-G": function (e) {
            e.findPrev();
          },
          esc: function (e) {
            setTimeout(function () {
              e.hide();
            });
          },
          Return: function (e) {
            e.activeInput == e.replaceInput && e.replace(), e.findNext();
          },
          "Shift-Return": function (e) {
            e.activeInput == e.replaceInput && e.replace(), e.findPrev();
          },
          "Alt-Return": function (e) {
            e.activeInput == e.replaceInput && e.replaceAll(), e.findAll();
          },
          Tab: function (e) {
            (e.activeInput == e.replaceInput ? e.searchInput : e.replaceInput).focus();
          }
        }), e.addCommands([{
          name: "toggleRegexpMode",
          bindKey: {
            win: "Alt-R|Alt-/",
            mac: "Ctrl-Alt-R|Ctrl-Alt-/"
          },
          exec: function (e) {
            e.regExpOption.checked = !e.regExpOption.checked, e.$syncOptions();
          }
        }, {
          name: "toggleCaseSensitive",
          bindKey: {
            win: "Alt-C|Alt-I",
            mac: "Ctrl-Alt-R|Ctrl-Alt-I"
          },
          exec: function (e) {
            e.caseSensitiveOption.checked = !e.caseSensitiveOption.checked, e.$syncOptions();
          }
        }, {
          name: "toggleWholeWords",
          bindKey: {
            win: "Alt-B|Alt-W",
            mac: "Ctrl-Alt-B|Ctrl-Alt-W"
          },
          exec: function (e) {
            e.wholeWordOption.checked = !e.wholeWordOption.checked, e.$syncOptions();
          }
        }, {
          name: "toggleReplace",
          exec: function (e) {
            e.replaceOption.checked = !e.replaceOption.checked, e.$syncOptions();
          }
        }, {
          name: "searchInSelection",
          exec: function (e) {
            e.searchOption.checked = !e.searchRange, e.setSearchRange(e.searchOption.checked && e.editor.getSelectionRange()), e.$syncOptions();
          }
        }]), i = new i([{
          bindKey: "Esc",
          name: "closeSearchBar",
          exec: function (e) {
            e.searchBox.hide();
          }
        }]);
        h.prototype.$searchBarKb = e, h.prototype.$closeSearchBarKb = i, t.SearchBox = h, t.Search = function (e, t) {
          (e.searchBox || new h(e)).show(e.session.getTextRange(), t);
        };
      }), ace.require(["ace/ext/searchbox"], function (e) {
        t && (t.exports = e);
      });
    },
    4091: function (t, e, n) {
      t = n.nmd(t), ace.define("ace/mode/json_highlight_rules", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text_highlight_rules"], function (e, t, n) {
        "use strict";

        function i() {
          (this || _global).$rules = {
            start: [{
              token: "variable",
              regex: "[\"](?:(?:\\\\.)|(?:[^\"\\\\]))*?[\"]\\s*(?=:)"
            }, {
              token: "string",
              regex: "\"",
              next: "string"
            }, {
              token: "constant.numeric",
              regex: "0[xX][0-9a-fA-F]+\\b"
            }, {
              token: "constant.numeric",
              regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
            }, {
              token: "constant.language.boolean",
              regex: "(?:true|false)\\b"
            }, {
              token: "text",
              regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
            }, {
              token: "comment",
              regex: "\\/\\/.*$"
            }, {
              token: "comment.start",
              regex: "\\/\\*",
              next: "comment"
            }, {
              token: "paren.lparen",
              regex: "[[({]"
            }, {
              token: "paren.rparen",
              regex: "[\\])}]"
            }, {
              token: "punctuation.operator",
              regex: /[,]/
            }, {
              token: "text",
              regex: "\\s+"
            }],
            string: [{
              token: "constant.language.escape",
              regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
            }, {
              token: "string",
              regex: "\"|$",
              next: "start"
            }, {
              defaultToken: "string"
            }],
            comment: [{
              token: "comment.end",
              regex: "\\*\\/",
              next: "start"
            }, {
              defaultToken: "comment"
            }]
          };
        }
        var o = e("../lib/oop"),
          e = e("./text_highlight_rules").TextHighlightRules;
        o.inherits(i, e), t.JsonHighlightRules = i;
      }), ace.define("ace/mode/matching_brace_outdent", ["require", "exports", "module", "ace/range"], function (e, t, n) {
        "use strict";

        function i() {}
        var o = e("../range").Range;
        !function () {
          (this || _global).checkOutdent = function (e, t) {
            return !!/^\s+$/.test(e) && /^\s*\}/.test(t);
          }, (this || _global).autoOutdent = function (e, t) {
            var n,
              i = e.getLine(t).match(/^(\s*\})/);
            return i && (i = i[1].length, n = e.findMatchingBracket({
              row: t,
              column: i
            })) && n.row != t ? (n = this.$getIndent(e.getLine(n.row)), void e.replace(new o(t, 0, t, i - 1), n)) : 0;
          }, (this || _global).$getIndent = function (e) {
            return e.match(/^\s*/)[0];
          };
        }.call(i.prototype), t.MatchingBraceOutdent = i;
      }), ace.define("ace/mode/folding/cstyle", ["require", "exports", "module", "ace/lib/oop", "ace/range", "ace/mode/folding/fold_mode"], function (e, t, n) {
        "use strict";

        var i = e("../../lib/oop"),
          h = e("../../range").Range,
          e = e("./fold_mode").FoldMode,
          t = t.FoldMode = function (e) {
            e && ((this || _global).foldingStartMarker = new RegExp((this || _global).foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + e.start)), (this || _global).foldingStopMarker = new RegExp((this || _global).foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + e.end)));
          };
        i.inherits(t, e), function () {
          (this || _global).foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/, (this || _global).foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/, (this || _global).singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/, (this || _global).tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/, (this || _global).startRegionRe = /^\s*(\/\*|\/\/)#?region\b/, (this || _global)._getFoldWidgetBase = (this || _global).getFoldWidget, (this || _global).getFoldWidget = function (e, t, n) {
            var i = e.getLine(n);
            return !(this || _global).singleLineBlockCommentRe.test(i) || (this || _global).startRegionRe.test(i) || (this || _global).tripleStarBlockCommentRe.test(i) ? !(e = this._getFoldWidgetBase(e, t, n)) && (this || _global).startRegionRe.test(i) ? "start" : e : "";
          }, (this || _global).getFoldWidgetRange = function (e, t, n, i) {
            var o,
              r,
              s,
              a = e.getLine(n);
            return (this || _global).startRegionRe.test(a) ? this.getCommentRegionBlock(e, a, n) : (r = a.match((this || _global).foldingStartMarker)) ? (s = r.index, r[1] ? this.openingBracketBlock(e, r[1], n, s) : ((o = e.getCommentFoldRange(n, s + r[0].length, 1)) && !o.isMultiLine() && (i ? o = this.getSectionRange(e, n) : "all" != t && (o = null)), o)) : "markbegin" !== t && (r = a.match((this || _global).foldingStopMarker)) ? (s = r.index + r[0].length, r[1] ? this.closingBracketBlock(e, r[1], n, s) : e.getCommentFoldRange(n, s, -1)) : void 0;
          }, (this || _global).getSectionRange = function (e, t) {
            for (var n = (a = e.getLine(t)).search(/\S/), i = t, o = a.length, r = t += 1, s = e.getLength(); ++t < s;) {
              var a,
                l = (a = e.getLine(t)).search(/\S/);
              if (-1 !== l) {
                if (l < n) break;
                var c = this.getFoldWidgetRange(e, "all", t);
                if (c) {
                  if (c.start.row <= i) break;
                  if (c.isMultiLine()) t = c.end.row;else if (n == l) break;
                }
                r = t;
              }
            }
            return new h(i, o, r, e.getLine(r).length);
          }, (this || _global).getCommentRegionBlock = function (e, t, n) {
            for (var i = t.search(/\s*$/), o = e.getLength(), r = n, s = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/, a = 1; ++n < o;) {
              t = e.getLine(n);
              var l = s.exec(t);
              if (l && (l[1] ? a-- : a++, !a)) break;
            }
            if (r < n) return new h(r, i, n, t.length);
          };
        }.call(t.prototype);
      }), ace.define("ace/mode/json", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text", "ace/mode/json_highlight_rules", "ace/mode/matching_brace_outdent", "ace/mode/behaviour/cstyle", "ace/mode/folding/cstyle", "ace/worker/worker_client"], function (e, t, n) {
        "use strict";

        function i() {
          (this || _global).HighlightRules = s, (this || _global).$outdent = new a(), (this || _global).$behaviour = new l(), (this || _global).foldingRules = new c();
        }
        var o = e("../lib/oop"),
          r = e("./text").Mode,
          s = e("./json_highlight_rules").JsonHighlightRules,
          a = e("./matching_brace_outdent").MatchingBraceOutdent,
          l = e("./behaviour/cstyle").CstyleBehaviour,
          c = e("./folding/cstyle").FoldMode,
          h = e("../worker/worker_client").WorkerClient;
        o.inherits(i, r), function () {
          (this || _global).lineCommentStart = "//", (this || _global).blockComment = {
            start: "/*",
            end: "*/"
          }, (this || _global).getNextLineIndent = function (e, t, n) {
            var i = this.$getIndent(t);
            return "start" == e && t.match(/^.*[\{\(\[]\s*$/) && (i += n), i;
          }, (this || _global).checkOutdent = function (e, t, n) {
            return (this || _global).$outdent.checkOutdent(t, n);
          }, (this || _global).autoOutdent = function (e, t, n) {
            (this || _global).$outdent.autoOutdent(t, n);
          }, (this || _global).createWorker = function (t) {
            var e = new h(["ace"], "ace/mode/json_worker", "JsonWorker");
            return e.attachToDocument(t.getDocument()), e.on("annotate", function (e) {
              t.setAnnotations(e.data);
            }), e.on("terminate", function () {
              t.clearAnnotations();
            }), e;
          }, (this || _global).$id = "ace/mode/json";
        }.call(i.prototype), t.Mode = i;
      }), ace.require(["ace/mode/json"], function (e) {
        t && (t.exports = e);
      });
    },
    8903: function (e, t, g) {
      "use strict";

      var s = g(5689),
        l = g(3969),
        p = g(5255),
        c = g(4293),
        m = g(3508),
        f = g(3368),
        C = g(742),
        y = g(9394),
        v = g(3724),
        e = ((e.exports = w).prototype.validate = function (e, t) {
          var n;
          if ("string" == typeof e) {
            if (!(n = this.getSchema(e))) throw new Error("no schema with key or ref \"" + e + "\"");
          } else {
            e = this._addSchema(e);
            n = e.validate || this._compile(e);
          }
          e = n(t);
          !0 !== n.$async && ((this || _global).errors = n.errors);
          return e;
        }, w.prototype.compile = function (e, t) {
          e = this._addSchema(e, void 0, t);
          return e.validate || this._compile(e);
        }, w.prototype.addSchema = function (e, t, n, i) {
          if (Array.isArray(e)) for (var o = 0; o < e.length; o++) this.addSchema(e[o], void 0, n, i);else {
            var r = this._getId(e);
            if (void 0 !== r && "string" != typeof r) throw new Error("schema id must be string");
            h(this || _global, t = l.normalizeId(t || r)), (this || _global)._schemas[t] = this._addSchema(e, n, i, !0);
          }
          return this || _global;
        }, w.prototype.addMetaSchema = function (e, t, n) {
          return this.addSchema(e, t, n, !0), this || _global;
        }, w.prototype.validateSchema = function (e, t) {
          var n = e.$schema;
          if (void 0 !== n && "string" != typeof n) throw new Error("$schema must be a string");
          if (!(n = n || (this || _global)._opts.defaultMeta || function (e) {
            var t = e._opts.meta;
            return e._opts.defaultMeta = "object" == typeof t ? e._getId(t) || t : e.getSchema(I) ? I : void 0, e._opts.defaultMeta;
          }(this || _global))) return (this || _global).logger.warn("meta-schema not available"), !((this || _global).errors = null);
          n = this.validate(n, e);
          if (!n && t) {
            e = "schema is invalid: " + this.errorsText();
            if ("log" != (this || _global)._opts.validateSchema) throw new Error(e);
            (this || _global).logger.error(e);
          }
          return n;
        }, w.prototype.getSchema = function (e) {
          var t = n(this || _global, e);
          switch (typeof t) {
            case "object":
              return t.validate || this._compile(t);
            case "string":
              return this.getSchema(t);
            case "undefined":
              return function (e, t) {
                var n = l.schema.call(e, {
                  schema: {}
                }, t);
                {
                  var i, o, r;
                  if (n) return i = n.schema, o = n.root, n = n.baseId, r = s.call(e, i, o, void 0, n), e._fragments[t] = new c({
                    ref: t,
                    fragment: !0,
                    schema: i,
                    root: o,
                    baseId: n,
                    validate: r
                  }), r;
                }
              }(this || _global, e);
          }
        }, w.prototype.removeSchema = function (e) {
          if (e instanceof RegExp) i(this || _global, (this || _global)._schemas, e), i(this || _global, (this || _global)._refs, e);else switch (typeof e) {
            case "undefined":
              return i(this || _global, (this || _global)._schemas), i(this || _global, (this || _global)._refs), (this || _global)._cache.clear(), this || _global;
            case "string":
              var t = n(this || _global, e);
              return t && (this || _global)._cache.del(t.cacheKey), delete (this || _global)._schemas[e], delete (this || _global)._refs[e], this || _global;
            case "object":
              t = (this || _global)._opts.serialize, t = t ? t(e) : e, t = ((this || _global)._cache.del(t), this._getId(e));
              t && (t = l.normalizeId(t), delete (this || _global)._schemas[t], delete (this || _global)._refs[t]);
          }
          return this || _global;
        }, w.prototype.addFormat = function (e, t) {
          "string" == typeof t && (t = new RegExp(t));
          return (this || _global)._formats[e] = t, this || _global;
        }, w.prototype.errorsText = function (e, t) {
          if (!(e = e || (this || _global).errors)) return "No errors";
          for (var n = void 0 === (t = t || {}).separator ? ", " : t.separator, i = void 0 === t.dataVar ? "data" : t.dataVar, o = "", r = 0; r < e.length; r++) {
            var s = e[r];
            s && (o += i + s.dataPath + " " + s.message + n);
          }
          return o.slice(0, -n.length);
        }, w.prototype._addSchema = function (e, t, n, i) {
          if ("object" != typeof e && "boolean" != typeof e) throw new Error("schema should be object or boolean");
          var o = (this || _global)._opts.serialize,
            o = o ? o(e) : e,
            r = (this || _global)._cache.get(o);
          if (r) return r;
          i = i || !1 !== (this || _global)._opts.addUsedSchema;
          r = l.normalizeId(this._getId(e));
          r && i && h(this || _global, r);
          var s,
            t = !1 !== (this || _global)._opts.validateSchema && !t;
          t && !(s = r && r == l.normalizeId(e.$schema)) && this.validateSchema(e, !0);
          var a = l.ids.call(this || _global, e),
            a = new c({
              id: r,
              schema: e,
              localRefs: a,
              cacheKey: o,
              meta: n
            });
          "#" != r[0] && i && ((this || _global)._refs[r] = a);
          (this || _global)._cache.put(o, a), t && s && this.validateSchema(e, !0);
          return a;
        }, w.prototype._compile = function (n, e) {
          if (n.compiling) return (n.validate = o).schema = n.schema, o.errors = null, o.root = e || o, !0 === n.schema.$async && (o.$async = !0), o;
          var t, i;
          n.compiling = !0, n.meta && (t = (this || _global)._opts, (this || _global)._opts = (this || _global)._metaOpts);
          try {
            i = s.call(this || _global, n.schema, e, n.localRefs);
          } catch (e) {
            throw delete n.validate, e;
          } finally {
            n.compiling = !1, n.meta && ((this || _global)._opts = t);
          }
          return n.validate = i, n.refs = i.refs, n.refVal = i.refVal, n.root = i.root, i;
          function o() {
            var e = n.validate,
              t = e.apply(this || _global, arguments);
            return o.errors = e.errors, t;
          }
        }, w.prototype.compileAsync = g(9677), g(7931)),
        e = (w.prototype.addKeyword = e.add, w.prototype.getKeyword = e.get, w.prototype.removeKeyword = e.remove, w.prototype.validateKeyword = e.validate, g(5359)),
        I = (w.ValidationError = e.Validation, w.MissingRefError = e.MissingRef, w.$dataMetaSchema = y, "http://json-schema.org/draft-07/schema"),
        b = ["removeAdditional", "useDefaults", "coerceTypes", "strictDefaults"],
        A = ["/properties"];
      function w(e) {
        if (!((this || _global) instanceof w)) return new w(e);
        e = (this || _global)._opts = v.copy(e) || {};
        var t = this || _global,
          n = t._opts.logger;
        if (!1 === n) t.logger = {
          log: E,
          warn: E,
          error: E
        };else {
          if (!("object" == typeof (n = void 0 === n ? console : n) && n.log && n.warn && n.error)) throw new Error("logger must implement log, warn and error methods");
          t.logger = n;
        }
        if ((this || _global)._schemas = {}, (this || _global)._refs = {}, (this || _global)._fragments = {}, (this || _global)._formats = f(e.format), (this || _global)._cache = e.cache || new p(), (this || _global)._loadingSchemas = {}, (this || _global)._compilations = [], (this || _global).RULES = C(), (this || _global)._getId = function (e) {
          switch (e.schemaId) {
            case "auto":
              return k;
            case "id":
              return S;
            default:
              return x;
          }
        }(e), e.loopRequired = e.loopRequired || 1 / 0, "property" == e.errorDataPath && (e._errorDataPathProperty = !0), void 0 === e.serialize && (e.serialize = m), (this || _global)._metaOpts = function (e) {
          for (var t = v.copy(e._opts), n = 0; n < b.length; n++) delete t[b[n]];
          return t;
        }(this || _global), e.formats) {
          var i,
            o = this || _global;
          for (i in o._opts.formats) {
            var r = o._opts.formats[i];
            o.addFormat(i, r);
          }
        }
        if (e.keywords) {
          var s,
            a = this || _global;
          for (s in a._opts.keywords) {
            var l = a._opts.keywords[s];
            a.addKeyword(s, l);
          }
        }
        var c,
          t = this || _global,
          h = (t._opts.$data && (c = g(894), t.addMetaSchema(c, c.$id, !0)), !1 !== t._opts.meta && (c = g(6680), t._opts.$data && (c = y(c, A)), t.addMetaSchema(c, I, !0), t._refs["http://json-schema.org/schema"] = I), "object" == typeof e.meta && this.addMetaSchema(e.meta), e.nullable && this.addKeyword("nullable", {
            metaSchema: {
              type: "boolean"
            }
          }), this || _global),
          d = h._opts.schemas;
        if (d) if (Array.isArray(d)) h.addSchema(d);else for (var u in d) h.addSchema(d[u], u);
      }
      function n(e, t) {
        return t = l.normalizeId(t), e._schemas[t] || e._refs[t] || e._fragments[t];
      }
      function i(e, t, n) {
        for (i in t) {
          var o = t[i];
          o.meta || n && !n.test(i) || (e._cache.del(o.cacheKey), delete t[i]);
        }
      }
      function S(e) {
        return e.$id && (this || _global).logger.warn("schema $id ignored", e.$id), e.id;
      }
      function x(e) {
        return e.id && (this || _global).logger.warn("schema id ignored", e.id), e.$id;
      }
      function k(e) {
        if (e.$id && e.id && e.$id != e.id) throw new Error("schema $id is different from id");
        return e.$id || e.id;
      }
      function h(e, t) {
        if (e._schemas[t] || e._refs[t]) throw new Error("schema with key or id \"" + t + "\" already exists");
      }
      function E() {}
    },
    5255: function (e) {
      "use strict";

      e = e.exports = function () {
        (this || _global)._cache = {};
      };
      e.prototype.put = function (e, t) {
        (this || _global)._cache[e] = t;
      }, e.prototype.get = function (e) {
        return (this || _global)._cache[e];
      }, e.prototype.del = function (e) {
        delete (this || _global)._cache[e];
      }, e.prototype.clear = function () {
        (this || _global)._cache = {};
      };
    },
    9677: function (e, t, n) {
      "use strict";

      var i = n(5359).MissingRef;
      function o(t, s, n) {
        var a = this || _global;
        if ("function" != typeof (this || _global)._opts.loadSchema) throw new Error("options.loadSchema should be a function");
        "function" == typeof s && (n = s, s = void 0);
        var e = l(t).then(function () {
          var e = a._addSchema(t, void 0, s);
          return e.validate || function o(r) {
            try {
              return a._compile(r);
            } catch (e) {
              if (e instanceof i) return t(e);
              throw e;
            }
            function t(e) {
              var t = e.missingSchema;
              if (i(t)) throw new Error("Schema " + t + " is loaded but " + e.missingRef + " cannot be resolved");
              e = a._loadingSchemas[t];
              return e || (e = a._loadingSchemas[t] = a._opts.loadSchema(t)).then(n, n), e.then(function (e) {
                if (!i(t)) return l(e).then(function () {
                  i(t) || a.addSchema(e, t, void 0, s);
                });
              }).then(function () {
                return o(r);
              });
              function n() {
                delete a._loadingSchemas[t];
              }
              function i(e) {
                return a._refs[e] || a._schemas[e];
              }
            }
          }(e);
        });
        return n && e.then(function (e) {
          n(null, e);
        }, n), e;
        function l(e) {
          e = e.$schema;
          return e && !a.getSchema(e) ? o.call(a, {
            $ref: e
          }, !0) : Promise.resolve();
        }
      }
      e.exports = o;
    },
    5359: function (e, t, n) {
      "use strict";

      var i = n(3969);
      function o(e, t, n) {
        (this || _global).message = n || o.message(e, t), (this || _global).missingRef = i.url(e, t), (this || _global).missingSchema = i.normalizeId(i.fullPath((this || _global).missingRef));
      }
      function r(e) {
        return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e;
      }
      e.exports = {
        Validation: r(function (e) {
          (this || _global).message = "validation failed", (this || _global).errors = e, (this || _global).ajv = (this || _global).validation = !0;
        }),
        MissingRef: r(o)
      }, o.message = function (e, t) {
        return "can't resolve reference " + t + " from id " + e;
      };
    },
    3368: function (e, t, n) {
      "use strict";

      var i = n(3724),
        o = /^(\d\d\d\d)-(\d\d)-(\d\d)$/,
        r = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        s = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i,
        n = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
        a = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
        l = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
        c = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i,
        h = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
        d = /^(?:\/(?:[^~/]|~0|~1)*)*$/,
        u = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
        g = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
      function p(e) {
        return i.copy(p[e = "full" == e ? "full" : "fast"]);
      }
      function m(e) {
        var t,
          n,
          e = e.match(o);
        return !!e && (t = +e[1], n = +e[2], e = +e[3], 1 <= n) && n <= 12 && 1 <= e && e <= (2 != n || (e = t) % 4 != 0 || e % 100 == 0 && e % 400 != 0 ? r[n] : 29);
      }
      function f(e, t) {
        var n,
          i,
          o,
          e = e.match(s);
        return !!e && (n = e[1], i = e[2], o = e[3], e = e[5], n <= 23 && i <= 59 && o <= 59 || 23 == n && 59 == i && 60 == o) && (!t || e);
      }
      (e.exports = p).fast = {
        date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
        time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
        "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
        uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
        "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
        "uri-template": l,
        url: c,
        email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
        hostname: n,
        ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
        ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
        regex: I,
        uuid: h,
        "json-pointer": d,
        "json-pointer-uri-fragment": u,
        "relative-json-pointer": g
      }, p.full = {
        date: m,
        time: f,
        "date-time": function (e) {
          e = e.split(C);
          return 2 == e.length && m(e[0]) && f(e[1], !0);
        },
        uri: function (e) {
          return y.test(e) && a.test(e);
        },
        "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
        "uri-template": l,
        url: c,
        email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
        hostname: n,
        ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
        ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
        regex: I,
        uuid: h,
        "json-pointer": d,
        "json-pointer-uri-fragment": u,
        "relative-json-pointer": g
      };
      var C = /t|\s/i;
      var y = /\/|:/;
      var v = /[^\\]\\Z/;
      function I(e) {
        if (v.test(e)) return !1;
        try {
          return new RegExp(e), !0;
        } catch (e) {
          return !1;
        }
      }
    },
    5689: function (e, t, n) {
      "use strict";

      var E = n(3969),
        T = n(3724),
        R = n(5359),
        _ = n(3508),
        $ = n(1869),
        L = T.ucs2length,
        N = n(2303),
        B = R.Validation;
      function M(e, s, a, t) {
        var l = this || _global,
          c = (this || _global)._opts,
          h = [void 0],
          d = {},
          u = [],
          n = {},
          g = [],
          i = {},
          p = [],
          o = (s = s || {
            schema: e,
            refVal: h,
            refs: d
          }, function (e, t, n) {
            var i = W.call(this || _global, e, t, n);
            return 0 <= i ? {
              index: i,
              compiling: !0
            } : (i = (this || _global)._compilations.length, (this || _global)._compilations[i] = {
              schema: e,
              root: t,
              baseId: n
            }, {
              index: i,
              compiling: !1
            });
          }.call(this || _global, e, s, t)),
          r = (this || _global)._compilations[o.index];
        if (o.compiling) return r.callValidate = v;
        var m = (this || _global)._formats,
          f = (this || _global).RULES;
        try {
          var C = I(e, s, a, t),
            y = (r.validate = C, r.callValidate);
          return y && (y.schema = C.schema, y.errors = null, y.refs = C.refs, y.refVal = C.refVal, y.root = C.root, y.$async = C.$async, c.sourceCode) && (y.source = C.source), C;
        } finally {
          !function (e, t, n) {
            e = W.call(this || _global, e, t, n);
            0 <= e && (this || _global)._compilations.splice(e, 1);
          }.call(this || _global, e, s, t);
        }
        function v() {
          var e = r.validate,
            t = e.apply(this || _global, arguments);
          return v.errors = e.errors, t;
        }
        function I(e, t, n, i) {
          var o = !t || t.schema == e;
          if (t.schema != s.schema) return M.call(l, e, t, n, i);
          n = !0 === e.$async, i = $({
            isTop: !0,
            schema: e,
            isRoot: o,
            baseId: i,
            root: t,
            schemaPath: "",
            errSchemaPath: "#",
            errorPath: "\"\"",
            MissingRefError: R.MissingRef,
            RULES: f,
            validate: $,
            util: T,
            resolve: E,
            resolveRef: b,
            usePattern: S,
            useDefault: x,
            useCustomRule: k,
            opts: c,
            formats: m,
            logger: l.logger,
            self: l
          }), i = V(h, P) + V(u, H) + V(g, G) + V(p, F) + i;
          c.processCode && (i = c.processCode(i, e));
          try {
            var r = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", i)(l, f, m, s, h, g, p, N, L, B);
            h[0] = r;
          } catch (e) {
            throw l.logger.error("Error compiling schema, function code:", i), e;
          }
          return r.schema = e, r.errors = null, r.refs = d, r.refVal = h, r.root = o ? r : t, n && (r.$async = !0), !0 === c.sourceCode && (r.source = {
            code: i,
            patterns: u,
            defaults: g
          }), r;
        }
        function b(e, t, n) {
          t = E.url(e, t);
          var i = d[t];
          if (void 0 !== i) return w(o = h[i], r = "refVal[" + i + "]");
          if (!n && s.refs) {
            i = s.refs[t];
            if (void 0 !== i) return w(o = s.refVal[i], r = A(t, o));
          }
          var o,
            r = A(t),
            n = E.call(l, I, s, t);
          if (void 0 !== (n = void 0 === n && (i = a && a[t]) ? E.inlineRef(i, c.inlineRefs) ? i : M.call(l, i, s, a, e) : n)) return o = n, i = d[i = t], h[i] = o, w(n, r);
          delete d[t];
        }
        function A(e, t) {
          var n = h.length;
          return h[n] = t, "refVal" + (d[e] = n);
        }
        function w(e, t) {
          return "object" == typeof e || "boolean" == typeof e ? {
            code: t,
            schema: e,
            inline: !0
          } : {
            code: t,
            $async: e && !!e.$async
          };
        }
        function S(e) {
          var t = n[e];
          return void 0 === t && (t = n[e] = u.length, u[t] = e), "pattern" + t;
        }
        function x(e) {
          switch (typeof e) {
            case "boolean":
            case "number":
              return "" + e;
            case "string":
              return T.toQuotedString(e);
            case "object":
              var t, n;
              return null === e ? "null" : (t = _(e), void 0 === (n = i[t]) && (n = i[t] = g.length, g[n] = e), "default" + n);
          }
        }
        function k(e, t, n, i) {
          if (!1 !== l._opts.validateSchema) {
            var o = e.definition.dependencies;
            if (o && !o.every(function (e) {
              return Object.prototype.hasOwnProperty.call(n, e);
            })) throw new Error("parent schema must have all required keywords: " + o.join(","));
            o = e.definition.validateSchema;
            if (o) if (!o(t)) {
              o = "keyword schema is invalid: " + l.errorsText(o.errors);
              if ("log" != l._opts.validateSchema) throw new Error(o);
              l.logger.error(o);
            }
          }
          var r,
            o = e.definition.compile,
            s = e.definition.inline,
            a = e.definition.macro;
          if (o) r = o.call(l, t, n, i);else if (a) r = a.call(l, t, n, i), !1 !== c.validateSchema && l.validateSchema(r, !0);else if (s) r = s.call(l, i, e.keyword, t, n);else if (!(r = e.definition.validate)) return;
          if (void 0 === r) throw new Error("custom keyword \"" + e.keyword + "\"failed to compile");
          o = p.length;
          return {
            code: "customRule" + o,
            validate: p[o] = r
          };
        }
      }
      function W(e, t, n) {
        for (var i = 0; i < (this || _global)._compilations.length; i++) {
          var o = (this || _global)._compilations[i];
          if (o.schema == e && o.root == t && o.baseId == n) return i;
        }
        return -1;
      }
      function H(e, t) {
        return "var pattern" + e + " = new RegExp(" + T.toQuotedString(t[e]) + ");";
      }
      function G(e) {
        return "var default" + e + " = defaults[" + e + "];";
      }
      function P(e, t) {
        return void 0 === t[e] ? "" : "var refVal" + e + " = refVal[" + e + "];";
      }
      function F(e) {
        return "var customRule" + e + " = customRules[" + e + "];";
      }
      function V(e, t) {
        if (!e.length) return "";
        for (var n = "", i = 0; i < e.length; i++) n += t(i, e);
        return n;
      }
      e.exports = M;
    },
    3969: function (e, t, n) {
      "use strict";

      var g = n(7533),
        p = n(2303),
        m = n(3724),
        a = n(4293),
        i = n(500);
      function l(e, t, n) {
        var i,
          o,
          r,
          s = (this || _global)._refs[n];
        if ("string" == typeof s) {
          if (!(this || _global)._refs[s]) return l.call(this || _global, e, t, s);
          s = (this || _global)._refs[s];
        }
        return (s = s || (this || _global)._schemas[n]) instanceof a ? u(s.schema, (this || _global)._opts.inlineRefs) ? s.schema : s.validate || this._compile(s) : ((s = c.call(this || _global, t, n)) && (i = s.schema, t = s.root, r = s.baseId), i instanceof a ? o = i.validate || e.call(this || _global, i.schema, t, void 0, r) : void 0 !== i && (o = u(i, (this || _global)._opts.inlineRefs) ? i : e.call(this || _global, i, t, void 0, r)), o);
      }
      function c(e, t) {
        var n = g.parse(t),
          i = C(n),
          o = f(this._getId(e.schema));
        if (0 === Object.keys(e.schema).length || i !== o) {
          var i = y(i),
            r = (this || _global)._refs[i];
          if ("string" == typeof r) return function (e, t, n) {
            t = c.call(this || _global, e, t);
            {
              var i, o;
              if (t) return i = t.schema, o = t.baseId, e = t.root, (t = this._getId(i)) && (o = v(o, t)), s.call(this || _global, n, o, i, e);
            }
          }.call(this || _global, e, r, n);
          if (r instanceof a) r.validate || this._compile(r);else {
            if (!((r = (this || _global)._schemas[i]) instanceof a)) return;
            if (r.validate || this._compile(r), i == y(t)) return {
              schema: r,
              root: e,
              baseId: o
            };
          }
          if (!(e = r).schema) return;
          o = f(this._getId(e.schema));
        }
        return s.call(this || _global, n, o, e.schema, e);
      }
      (e.exports = l).normalizeId = y, l.fullPath = f, l.url = v, l.ids = function (e) {
        var t = y(this._getId(e)),
          c = {
            "": t
          },
          h = {
            "": f(t, !1)
          },
          d = {},
          u = this || _global;
        return i(e, {
          allKeys: !0
        }, function (e, t, n, i, o, r, s) {
          if ("" !== t) {
            var a = u._getId(e),
              l = c[i],
              i = h[i] + "/" + o;
            if (void 0 !== s && (i += "/" + ("number" == typeof s ? s : m.escapeFragment(s))), "string" == typeof a) {
              a = l = y(l ? g.resolve(l, a) : a), o = u._refs[a];
              if ((o = "string" == typeof o ? u._refs[o] : o) && o.schema) {
                if (!p(e, o.schema)) throw new Error("id \"" + a + "\" resolves to more than one schema");
              } else if (a != y(i)) if ("#" == a[0]) {
                if (d[a] && !p(e, d[a])) throw new Error("id \"" + a + "\" resolves to more than one schema");
                d[a] = e;
              } else u._refs[a] = i;
            }
            c[t] = l, h[t] = i;
          }
        }), d;
      }, l.inlineRef = u, l.schema = c;
      var h = m.toHash(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
      function s(e, t, n, i) {
        if (e.fragment = e.fragment || "", "/" == e.fragment.slice(0, 1)) {
          for (var o = e.fragment.split("/"), r = 1; r < o.length; r++) {
            s = o[r];
            if (s) {
              if (void 0 === (n = n[s = m.unescapeFragment(s)])) break;
              h[s] || ((s = this._getId(n)) && (t = v(t, s)), n.$ref && (s = v(t, n.$ref), s = c.call(this || _global, i, s)) && (n = s.schema, i = s.root, t = s.baseId));
            }
          }
          return void 0 !== n && n !== i.schema ? {
            schema: n,
            root: i,
            baseId: t
          } : void 0;
        }
      }
      var d = m.toHash(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum"]);
      function u(e, t) {
        return !1 !== t && (void 0 === t || !0 === t ? function e(t) {
          var n;
          if (Array.isArray(t)) {
            for (var i = 0; i < t.length; i++) if ("object" == typeof (n = t[i]) && !e(n)) return !1;
          } else for (var o in t) {
            if ("$ref" == o) return !1;
            if ("object" == typeof (n = t[o]) && !e(n)) return !1;
          }
          return !0;
        }(e) : t ? function e(t) {
          var n,
            i = 0;
          if (Array.isArray(t)) {
            for (var o = 0; o < t.length; o++) if ("object" == typeof (n = t[o]) && (i += e(n)), i == 1 / 0) return 1 / 0;
          } else for (var r in t) {
            if ("$ref" == r) return 1 / 0;
            if (d[r]) i++;else if ("object" == typeof (n = t[r]) && (i += e(n) + 1), i == 1 / 0) return 1 / 0;
          }
          return i;
        }(e) <= t : void 0);
      }
      function f(e, t) {
        return !1 !== t && (e = y(e)), C(g.parse(e));
      }
      function C(e) {
        return g.serialize(e).split("#")[0] + "#";
      }
      var o = /#\/?$/;
      function y(e) {
        return e ? e.replace(o, "") : "";
      }
      function v(e, t) {
        return t = y(t), g.resolve(e, t);
      }
    },
    742: function (e, t, n) {
      "use strict";

      var r = n(9646),
        s = n(3724).toHash;
      e.exports = function () {
        var i = [{
            type: "number",
            rules: [{
              maximum: ["exclusiveMaximum"]
            }, {
              minimum: ["exclusiveMinimum"]
            }, "multipleOf", "format"]
          }, {
            type: "string",
            rules: ["maxLength", "minLength", "pattern", "format"]
          }, {
            type: "array",
            rules: ["maxItems", "minItems", "items", "contains", "uniqueItems"]
          }, {
            type: "object",
            rules: ["maxProperties", "minProperties", "required", "dependencies", "propertyNames", {
              properties: ["additionalProperties", "patternProperties"]
            }]
          }, {
            rules: ["$ref", "const", "enum", "not", "anyOf", "oneOf", "allOf", "if"]
          }],
          o = ["type", "$comment"];
        return i.all = s(o), i.types = s(["number", "integer", "string", "array", "object", "boolean", "null"]), i.forEach(function (e) {
          e.rules = e.rules.map(function (e) {
            var t, n;
            return "object" == typeof e && (n = e[t = Object.keys(e)[0]], e = t, n.forEach(function (e) {
              o.push(e), i.all[e] = !0;
            })), o.push(e), i.all[e] = {
              keyword: e,
              code: r[e],
              implements: n
            };
          }), i.all.$comment = {
            keyword: "$comment",
            code: r.$comment
          }, e.type && (i.types[e.type] = e);
        }), i.keywords = s(o.concat(["$schema", "$id", "id", "$data", "$async", "title", "description", "default", "definitions", "examples", "readOnly", "writeOnly", "contentMediaType", "contentEncoding", "additionalItems", "then", "else"])), i.custom = {}, i;
      };
    },
    4293: function (e, t, n) {
      "use strict";

      var i = n(3724);
      e.exports = function (e) {
        i.copy(e, this || _global);
      };
    },
    6887: function (e) {
      "use strict";

      e.exports = function (e) {
        for (var t, n = 0, i = e.length, o = 0; o < i;) n++, 55296 <= (t = e.charCodeAt(o++)) && t <= 56319 && o < i && 56320 == (64512 & e.charCodeAt(o)) && o++;
        return n;
      };
    },
    3724: function (e, t, n) {
      "use strict";

      function r(e, t, n, i) {
        var o = i ? " !== " : " === ",
          r = i ? " || " : " && ",
          s = i ? "!" : "",
          a = i ? "" : "!";
        switch (e) {
          case "null":
            return t + o + "null";
          case "array":
            return s + "Array.isArray(" + t + ")";
          case "object":
            return "(" + s + t + r + "typeof " + t + o + "\"object\"" + r + a + "Array.isArray(" + t + "))";
          case "integer":
            return "(typeof " + t + o + "\"number\"" + r + a + "(" + t + " % 1)" + r + t + o + t + (n ? r + s + "isFinite(" + t + ")" : "") + ")";
          case "number":
            return "(typeof " + t + o + "\"" + e + "\"" + (n ? r + s + "isFinite(" + t + ")" : "") + ")";
          default:
            return "typeof " + t + o + "\"" + e + "\"";
        }
      }
      e.exports = {
        copy: function (e, t) {
          for (var n in t = t || {}, e) t[n] = e[n];
          return t;
        },
        checkDataType: r,
        checkDataTypes: function (e, t, n) {
          {
            if (1 === e.length) return r(e[0], t, n, !0);
            var i,
              o = "",
              e = a(e);
            for (i in e.array && e.object && (o = e.null ? "(" : "(!" + t + " || ", o += "typeof " + t + " !== \"object\")", delete e.null, delete e.array, delete e.object), e.number && delete e.integer, e) o += (o ? " && " : "") + r(i, t, n, !0);
            return o;
          }
        },
        coerceToTypes: function (e, t) {
          {
            if (!Array.isArray(t)) return s[t] ? [t] : "array" === e && "array" === t ? ["array"] : void 0;
            for (var n = [], i = 0; i < t.length; i++) {
              var o = t[i];
              (s[o] || "array" === e && "array" === o) && (n[n.length] = o);
            }
            return n.length ? n : void 0;
          }
        },
        toHash: a,
        getProperty: h,
        escapeQuotes: l,
        equal: n(2303),
        ucs2length: n(6887),
        varOccurences: function (e, t) {
          t += "[^0-9]";
          e = e.match(new RegExp(t, "g"));
          return e ? e.length : 0;
        },
        varReplace: function (e, t, n) {
          return t += "([^0-9])", n = n.replace(/\$/g, "$$$$"), e.replace(new RegExp(t, "g"), n + "$1");
        },
        schemaHasRules: function (e, t) {
          if ("boolean" == typeof e) return !e;
          for (var n in e) if (t[n]) return !0;
        },
        schemaHasRulesExcept: function (e, t, n) {
          if ("boolean" == typeof e) return !e && "not" != n;
          for (var i in e) if (i != n && t[i]) return !0;
        },
        schemaUnknownRules: function (e, t) {
          if ("boolean" != typeof e) for (var n in e) if (!t[n]) return n;
        },
        toQuotedString: c,
        getPathExpr: function (e, t, n, i) {
          return g(e, n ? "'/' + " + t + (i ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : i ? "'[' + " + t + " + ']'" : "'[\\'' + " + t + " + '\\']'");
        },
        getPath: function (e, t, n) {
          n = c(n ? "/" + p(t) : h(t));
          return g(e, n);
        },
        getData: function (e, t, n) {
          var i, o, r;
          if ("" === e) return "rootData";
          if ("/" == e[0]) {
            if (!d.test(e)) throw new Error("Invalid JSON-pointer: " + e);
            i = e, o = "rootData";
          } else {
            if (!(r = e.match(u))) throw new Error("Invalid JSON-pointer: " + e);
            if (e = +r[1], "#" == (i = r[2])) {
              if (t <= e) throw new Error("Cannot access property/index " + e + " levels up, current level is " + t);
              return n[t - e];
            }
            if (t < e) throw new Error("Cannot access data " + e + " levels up, current level is " + t);
            if (o = "data" + (t - e || ""), !i) return o;
          }
          for (var s = o, a = i.split("/"), l = 0; l < a.length; l++) {
            var c = a[l];
            c && (o += h(m(c)), s += " && " + o);
          }
          return s;
        },
        unescapeFragment: function (e) {
          return m(decodeURIComponent(e));
        },
        unescapeJsonPointer: m,
        escapeFragment: function (e) {
          return encodeURIComponent(p(e));
        },
        escapeJsonPointer: p
      };
      var s = a(["string", "number", "integer", "boolean", "null"]);
      function a(e) {
        for (var t = {}, n = 0; n < e.length; n++) t[e[n]] = !0;
        return t;
      }
      var i = /^[a-z$_][a-z$_0-9]*$/i,
        o = /'|\\/g;
      function h(e) {
        return "number" == typeof e ? "[" + e + "]" : i.test(e) ? "." + e : "['" + l(e) + "']";
      }
      function l(e) {
        return e.replace(o, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
      }
      function c(e) {
        return "'" + l(e) + "'";
      }
      var d = /^\/(?:[^~]|~0|~1)*$/,
        u = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
      function g(e, t) {
        return "\"\"" == e ? t : (e + " + " + t).replace(/([^\\])' \+ '/g, "$1");
      }
      function p(e) {
        return e.replace(/~/g, "~0").replace(/\//g, "~1");
      }
      function m(e) {
        return e.replace(/~1/g, "/").replace(/~0/g, "~");
      }
    },
    9394: function (e) {
      "use strict";

      var l = ["multipleOf", "maximum", "exclusiveMaximum", "minimum", "exclusiveMinimum", "maxLength", "minLength", "pattern", "additionalItems", "maxItems", "minItems", "uniqueItems", "maxProperties", "minProperties", "required", "additionalProperties", "enum", "format", "const"];
      e.exports = function (e, t) {
        for (var n = 0; n < t.length; n++) {
          e = JSON.parse(JSON.stringify(e));
          for (var i = t[n].split("/"), o = e, r = 1; r < i.length; r++) o = o[i[r]];
          for (r = 0; r < l.length; r++) {
            var s = l[r],
              a = o[s];
            a && (o[s] = {
              anyOf: [a, {
                $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
              }]
            });
          }
        }
        return e;
      };
    },
    5868: function (e, t, n) {
      "use strict";

      n = n(6680);
      e.exports = {
        $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
        definitions: {
          simpleTypes: n.definitions.simpleTypes
        },
        type: "object",
        dependencies: {
          schema: ["validate"],
          $data: ["validate"],
          statements: ["inline"],
          valid: {
            not: {
              required: ["macro"]
            }
          }
        },
        properties: {
          type: n.properties.type,
          schema: {
            type: "boolean"
          },
          statements: {
            type: "boolean"
          },
          dependencies: {
            type: "array",
            items: {
              type: "string"
            }
          },
          metaSchema: {
            type: "object"
          },
          modifying: {
            type: "boolean"
          },
          valid: {
            type: "boolean"
          },
          $data: {
            type: "boolean"
          },
          async: {
            type: "boolean"
          },
          errors: {
            anyOf: [{
              type: "boolean"
            }, {
              const: "full"
            }]
          }
        }
      };
    },
    1796: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o,
          r,
          s,
          a,
          l = " ",
          c = e.level,
          h = e.dataLevel,
          d = e.schema[t],
          u = e.schemaPath + e.util.getProperty(t),
          g = e.errSchemaPath + "/" + t,
          p = !e.opts.allErrors,
          m = "data" + (h || ""),
          f = e.opts.$data && d && d.$data,
          C = f ? (l += " var schema" + c + " = " + e.util.getData(d.$data, h, e.dataPathArr) + "; ", "schema" + c) : d,
          y = "maximum" == t,
          v = y ? "exclusiveMaximum" : "exclusiveMinimum",
          I = e.schema[v],
          b = e.opts.$data && I && I.$data,
          A = y ? "<" : ">",
          w = y ? ">" : "<",
          S = void 0;
        if (!f && "number" != typeof d && void 0 !== d) throw new Error(t + " must be number");
        if (!b && void 0 !== I && "number" != typeof I && "boolean" != typeof I) throw new Error(v + " must be number or boolean");
        b ? (h = e.util.getData(I.$data, h, e.dataPathArr), r = "exclIsNumber" + c, s = "' + " + (a = "op" + c) + " + '", S = v, (x = x || []).push(l = l + (" var schemaExcl" + c + " = " + h + "; ") + (" var " + (i = "exclusive" + c) + "; var " + (o = "exclType" + c) + " = typeof " + (h = "schemaExcl" + c) + "; if (" + o + " != 'boolean' && " + o + " != 'undefined' && " + o + " != 'number') { ")), l = "", !1 !== e.createErrors ? (l += " { keyword: '" + (S || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(g) + " , params: {} ", !1 !== e.opts.messages && (l += " , message: '" + v + " should be boolean' "), e.opts.verbose && (l += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), l += " } ") : l += " {} ", k = l, l = x.pop(), !e.compositeRule && p ? e.async ? l += " throw new ValidationError([" + k + "]); " : l += " validate.errors = [" + k + "]; return false; " : l += " var err = " + k + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l += " } else if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " " + o + " == 'number' ? ( (" + i + " = " + C + " === undefined || " + h + " " + A + "= " + C + ") ? " + m + " " + w + "= " + h + " : " + m + " " + w + " " + C + " ) : ( (" + i + " = " + h + " === true) ? " + m + " " + w + "= " + C + " : " + m + " " + w + " " + C + " ) || " + m + " !== " + m + ") { var op" + c + " = " + i + " ? '" + A + "' : '" + A + "='; ", void 0 === d && (g = e.errSchemaPath + "/" + (S = v), C = h, f = b)) : (s = A, (r = "number" == typeof I) && f ? (a = "'" + s + "'", l += " if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " ( " + C + " === undefined || " + I + " " + A + "= " + C + " ? " + m + " " + w + "= " + I + " : " + m + " " + w + " " + C + " ) || " + m + " !== " + m + ") { ") : (r && void 0 === d ? (i = !0, g = e.errSchemaPath + "/" + (S = v), C = I, w += "=") : (r && (C = Math[y ? "min" : "max"](I, d)), I === (!r || C) ? (i = !0, g = e.errSchemaPath + "/" + (S = v), w += "=") : (i = !1, s += "=")), a = "'" + s + "'", l += " if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " " + m + " " + w + " " + C + " || " + m + " !== " + m + ") { ")), S = S || t;
        (x = x || []).push(l), l = "", !1 !== e.createErrors ? (l += " { keyword: '" + (S || "_limit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(g) + " , params: { comparison: " + a + ", limit: " + C + ", exclusive: " + i + " } ", !1 !== e.opts.messages && (l = l + " , message: 'should be " + s + " " + (f ? "' + " + C : C + "'")), e.opts.verbose && (l = (l += " , schema:  ") + (f ? "validate.schema" + u : "" + d) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), l += " } ") : l += " {} ";
        var x,
          k = l;
        return l = x.pop(), !e.compositeRule && p ? e.async ? l += " throw new ValidationError([" + k + "]); " : l += " validate.errors = [" + k + "]; return false; " : l += " var err = " + k + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l += " } ", p && (l += " else { "), l;
      };
    },
    2407: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o = " ",
          r = e.level,
          s = e.dataLevel,
          a = e.schema[t],
          l = e.schemaPath + e.util.getProperty(t),
          c = e.errSchemaPath + "/" + t,
          h = !e.opts.allErrors,
          d = "data" + (s || ""),
          u = e.opts.$data && a && a.$data,
          s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
        if (u || "number" == typeof a) return o += "if ( ", u && (o += " (" + s + " !== undefined && typeof " + s + " != 'number') || "), (r = []).push(o += " " + d + ".length " + ("maxItems" == (i = t) ? ">" : "<") + " " + s + ") { "), o = "", !1 !== e.createErrors ? (o += " { keyword: '" + (i || "_limitItems") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + s + " } ", !1 !== e.opts.messages && (o = (o = (o += " , message: 'should NOT have ") + ("maxItems" == t ? "more" : "fewer") + " than ") + (u ? "' + " + s + " + '" : "" + a) + " items' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", i = o, o = r.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + i + "]); " : o += " validate.errors = [" + i + "]; return false; " : o += " var err = " + i + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += "} ", h && (o += " else { "), o;
        throw new Error(t + " must be number");
      };
    },
    1250: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o = " ",
          r = e.level,
          s = e.dataLevel,
          a = e.schema[t],
          l = e.schemaPath + e.util.getProperty(t),
          c = e.errSchemaPath + "/" + t,
          h = !e.opts.allErrors,
          d = "data" + (s || ""),
          u = e.opts.$data && a && a.$data,
          s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
        if (u || "number" == typeof a) return o += "if ( ", u && (o += " (" + s + " !== undefined && typeof " + s + " != 'number') || "), !1 === e.opts.unicode ? o += " " + d + ".length " : o += " ucs2length(" + d + ") ", (r = []).push(o += " " + ("maxLength" == (i = t) ? ">" : "<") + " " + s + ") { "), o = "", !1 !== e.createErrors ? (o += " { keyword: '" + (i || "_limitLength") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + s + " } ", !1 !== e.opts.messages && (o = (o = (o += " , message: 'should NOT be ") + ("maxLength" == t ? "longer" : "shorter") + " than ") + (u ? "' + " + s + " + '" : "" + a) + " characters' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", i = o, o = r.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + i + "]); " : o += " validate.errors = [" + i + "]; return false; " : o += " var err = " + i + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += "} ", h && (o += " else { "), o;
        throw new Error(t + " must be number");
      };
    },
    2596: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o = " ",
          r = e.level,
          s = e.dataLevel,
          a = e.schema[t],
          l = e.schemaPath + e.util.getProperty(t),
          c = e.errSchemaPath + "/" + t,
          h = !e.opts.allErrors,
          d = "data" + (s || ""),
          u = e.opts.$data && a && a.$data,
          s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
        if (u || "number" == typeof a) return o += "if ( ", u && (o += " (" + s + " !== undefined && typeof " + s + " != 'number') || "), (r = []).push(o += " Object.keys(" + d + ").length " + ("maxProperties" == (i = t) ? ">" : "<") + " " + s + ") { "), o = "", !1 !== e.createErrors ? (o += " { keyword: '" + (i || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + s + " } ", !1 !== e.opts.messages && (o = (o = (o += " , message: 'should NOT have ") + ("maxProperties" == t ? "more" : "fewer") + " than ") + (u ? "' + " + s + " + '" : "" + a) + " properties' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", i = o, o = r.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + i + "]); " : o += " validate.errors = [" + i + "]; return false; " : o += " var err = " + i + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += "} ", h && (o += " else { "), o;
        throw new Error(t + " must be number");
      };
    },
    9486: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.schema[t],
          r = e.schemaPath + e.util.getProperty(t),
          s = e.errSchemaPath + "/" + t,
          a = !e.opts.allErrors,
          l = e.util.copy(e),
          c = "",
          h = (l.level++, "valid" + l.level),
          d = l.baseId,
          u = !0,
          g = o;
        if (g) for (var p, m = -1, f = g.length - 1; m < f;) p = g[m += 1], (e.opts.strictKeywords ? "object" == typeof p && 0 < Object.keys(p).length || !1 === p : e.util.schemaHasRules(p, e.RULES.all)) && (u = !1, l.schema = p, l.schemaPath = r + "[" + m + "]", l.errSchemaPath = s + "/" + m, i += "  " + e.validate(l) + " ", l.baseId = d, a) && (i += " if (" + h + ") { ", c += "}");
        return a && (i += u ? " if (true) { " : " " + c.slice(0, -1) + " "), i;
      };
    },
    5347: function (e) {
      "use strict";

      e.exports = function (t, e, n) {
        var i = " ",
          o = t.level,
          r = t.dataLevel,
          s = t.schema[e],
          a = t.schemaPath + t.util.getProperty(e),
          l = t.errSchemaPath + "/" + e,
          e = !t.opts.allErrors,
          r = "data" + (r || ""),
          c = "valid" + o,
          o = "errs__" + o,
          h = t.util.copy(t),
          d = "",
          u = (h.level++, "valid" + h.level);
        if (s.every(function (e) {
          return t.opts.strictKeywords ? "object" == typeof e && 0 < Object.keys(e).length || !1 === e : t.util.schemaHasRules(e, t.RULES.all);
        })) {
          var g = h.baseId,
            p = (i += " var " + o + " = errors; var " + c + " = false;  ", t.compositeRule),
            m = (t.compositeRule = h.compositeRule = !0, s);
          if (m) for (var f, C = -1, y = m.length - 1; C < y;) f = m[C += 1], h.schema = f, h.schemaPath = a + "[" + C + "]", h.errSchemaPath = l + "/" + C, i += "  " + t.validate(h) + " ", h.baseId = g, i += " " + c + " = " + c + " || " + u + "; if (!" + c + ") { ", d += "}";
          t.compositeRule = h.compositeRule = p, i += " " + d + " if (!" + c + ") {   var err =   ", !1 !== t.createErrors ? (i += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(l) + " , params: {} ", !1 !== t.opts.messages && (i += " , message: 'should match some schema in anyOf' "), t.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + r + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !t.compositeRule && e && (t.async ? i += " throw new ValidationError(vErrors); " : i += " validate.errors = vErrors; return false; "), i += " } else {  errors = " + o + "; if (vErrors !== null) { if (" + o + ") vErrors.length = " + o + "; else vErrors = null; } ", t.opts.allErrors && (i += " } ");
        } else e && (i += " if (true) { ");
        return i;
      };
    },
    923: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.schema[t],
          t = e.errSchemaPath + "/" + t,
          o = (e.opts.allErrors, e.util.toQuotedString(o));
        return !0 === e.opts.$comment ? i += " console.log(" + o + ");" : "function" == typeof e.opts.$comment && (i += " self._opts.$comment(" + o + ", " + e.util.toQuotedString(t) + ", validate.root.schema);"), i;
      };
    },
    2617: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.level,
          r = e.dataLevel,
          s = e.schema[t],
          a = e.schemaPath + e.util.getProperty(t),
          t = e.errSchemaPath + "/" + t,
          l = !e.opts.allErrors,
          c = "data" + (r || ""),
          h = "valid" + o,
          d = e.opts.$data && s && s.$data,
          s = (d && (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; "), d || (i += " var schema" + o + " = validate.schema" + a + ";"), []),
          r = (s.push(i += "var " + h + " = equal(" + c + ", schema" + o + "); if (!" + h + ") {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'const' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { allowedValue: schema" + o + " } ", !1 !== e.opts.messages && (i += " , message: 'should be equal to constant' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i),
          i = s.pop();
        return !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + r + "]); " : i += " validate.errors = [" + r + "]; return false; " : i += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " }", l && (i += " else { "), i;
      };
    },
    2119: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.level,
          r = e.dataLevel,
          s = e.schema[t],
          a = e.schemaPath + e.util.getProperty(t),
          t = e.errSchemaPath + "/" + t,
          l = !e.opts.allErrors,
          r = "data" + (r || ""),
          c = "valid" + o,
          h = "errs__" + o,
          d = e.util.copy(e),
          u = (d.level++, "valid" + d.level),
          o = "i" + o,
          g = d.dataLevel = e.dataLevel + 1,
          p = "data" + g,
          m = e.baseId,
          f = e.opts.strictKeywords ? "object" == typeof s && 0 < Object.keys(s).length || !1 === s : e.util.schemaHasRules(s, e.RULES.all),
          o = (i += "var " + h + " = errors;var " + c + ";", f ? (c = e.compositeRule, e.compositeRule = d.compositeRule = !0, d.schema = s, d.schemaPath = a, d.errSchemaPath = t, i += " var " + u + " = false; for (var " + o + " = 0; " + o + " < " + r + ".length; " + o + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, o, e.opts.jsonPointers, !0), s = r + "[" + o + "]", d.dataPathArr[g] = o, g = e.validate(d), d.baseId = m, e.util.varOccurences(g, p) < 2 ? i += " " + e.util.varReplace(g, p, s) + " " : i += " var " + p + " = " + s + "; " + g + " ", i += " if (" + u + ") break; }  ", e.compositeRule = d.compositeRule = c, i += "  if (!" + u + ") {") : i += " if (" + r + ".length == 0) {", []),
          m = (o.push(i), i = "", !1 !== e.createErrors ? (i += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (i += " , message: 'should contain a valid item' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + r + " "), i += " } ") : i += " {} ", i),
          i = o.pop();
        return !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + m + "]); " : i += " validate.errors = [" + m + "]; return false; " : i += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } else { ", f && (i += "  errors = " + h + "; if (vErrors !== null) { if (" + h + ") vErrors.length = " + h + "; else vErrors = null; } "), e.opts.allErrors && (i += " } "), i;
      };
    },
    1793: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o,
          r,
          s = " ",
          a = e.level,
          l = e.dataLevel,
          c = e.schema[t],
          h = e.schemaPath + e.util.getProperty(t),
          d = e.errSchemaPath + "/" + t,
          u = !e.opts.allErrors,
          g = "data" + (l || ""),
          p = "valid" + a,
          m = "errs__" + a,
          f = e.opts.$data && c && c.$data,
          C = f ? (s += " var schema" + a + " = " + e.util.getData(c.$data, l, e.dataPathArr) + "; ", "schema" + a) : c,
          y = "definition" + a,
          v = (this || _global).definition,
          I = "";
        if (f && v.$data) {
          var b = "keywordValidate" + a,
            A = v.validateSchema;
          s += " var " + y + " = RULES.custom['" + t + "'].definition; var " + b + " = " + y + ".validate;";
        } else {
          if (!(k = e.useCustomRule(this || _global, c, e.schema, e))) return;
          C = "validate.schema" + h, b = k.code, i = v.compile, o = v.inline, r = v.macro;
        }
        var w,
          S,
          x,
          k,
          E,
          t = b + ".errors",
          c = "i" + a,
          T = "ruleErr" + a,
          R = v.async;
        if (R && !e.async) throw new Error("async keyword in sync schema");
        return o || r || (s += t + " = null;"), s += "var " + m + " = errors;var " + p + ";", f && v.$data && (I += "}", s += " if (" + C + " === undefined) { " + p + " = true; } else { ", A) && (I += "}", s += " " + p + " = " + y + ".validateSchema(" + C + "); if (" + p + ") { "), o ? v.statements ? s += " " + k.validate + " " : s += " " + p + " = " + k.validate + "; " : r ? (I = "", (f = e.util.copy(e)).level++, w = "valid" + f.level, f.schema = k.validate, f.schemaPath = "", A = e.compositeRule, e.compositeRule = f.compositeRule = !0, y = e.validate(f).replace(/validate\.schema/g, b), e.compositeRule = f.compositeRule = A, s += " " + y) : ((E = E || []).push(s), s = "", s += "  " + b + ".call( ", e.opts.passContext ? s += "this" : s += "self", i || !1 === v.schema ? s += " , " + g + " " : s += " , " + C + " , " + g + " , validate.schema" + e.schemaPath + " ", s += " , (dataPath || '')", "\"\"" != e.errorPath && (s += " + " + e.errorPath), k = s += " , " + (S = l ? "data" + (l - 1 || "") : "parentData") + " , " + (x = l ? e.dataPathArr[l] : "parentDataProperty") + " , rootData )  ", s = E.pop(), !1 === v.errors ? (s += " " + p + " = ", R && (s += "await "), s += k + "; ") : s += R ? " var " + (t = "customErrors" + a) + " = null; try { " + p + " = await " + k + "; } catch (e) { " + p + " = false; if (e instanceof ValidationError) " + t + " = e.errors; else throw e; } " : " " + t + " = null; " + p + " = " + k + "; "), v.modifying && (s += " if (" + S + ") " + g + " = " + S + "[" + x + "];"), s += "" + I, v.valid ? u && (s += " if (true) { ") : (s += " if ( ", void 0 === v.valid ? s = s + " !" + (r ? "" + w : p) : s += " " + !v.valid + " ", f = (this || _global).keyword, (E = E || []).push(s += ") { "), (E = E || []).push(s = ""), s = "", !1 !== e.createErrors ? (s += " { keyword: '" + (f || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { keyword: '" + (this || _global).keyword + "' } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"" + (this || _global).keyword + "\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), s += " } ") : s += " {} ", A = s, s = E.pop(), !e.compositeRule && u ? e.async ? s += " throw new ValidationError([" + A + "]); " : s += " validate.errors = [" + A + "]; return false; " : s += " var err = " + A + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", y = s, s = E.pop(), o ? v.errors ? "full" != v.errors && (s += "  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + T + " = vErrors[" + c + "]; if (" + T + ".dataPath === undefined) " + T + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + T + ".schemaPath === undefined) { " + T + ".schemaPath = \"" + d + "\"; } ", e.opts.verbose && (s += " " + T + ".schema = " + C + "; " + T + ".data = " + g + "; "), s += " } ") : !1 === v.errors ? s += " " + y + " " : (s += " if (" + m + " == errors) { " + y + " } else {  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + T + " = vErrors[" + c + "]; if (" + T + ".dataPath === undefined) " + T + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + T + ".schemaPath === undefined) { " + T + ".schemaPath = \"" + d + "\"; } ", e.opts.verbose && (s += " " + T + ".schema = " + C + "; " + T + ".data = " + g + "; "), s += " } } ") : r ? (s += "   var err =   ", !1 !== e.createErrors ? (s += " { keyword: '" + (f || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { keyword: '" + (this || _global).keyword + "' } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"" + (this || _global).keyword + "\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), s += " } ") : s += " {} ", s += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && u && (e.async ? s += " throw new ValidationError(vErrors); " : s += " validate.errors = vErrors; return false; ")) : !1 === v.errors ? s += " " + y + " " : (s += " if (Array.isArray(" + t + ")) { if (vErrors === null) vErrors = " + t + "; else vErrors = vErrors.concat(" + t + "); errors = vErrors.length;  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + T + " = vErrors[" + c + "]; if (" + T + ".dataPath === undefined) " + T + ".dataPath = (dataPath || '') + " + e.errorPath + ";  " + T + ".schemaPath = \"" + d + "\";  ", e.opts.verbose && (s += " " + T + ".schema = " + C + "; " + T + ".data = " + g + "; "), s += " } } else { " + y + " } "), s += " } ", u && (s += " else { ")), s;
      };
    },
    9115: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o = " ",
          r = e.level,
          s = e.dataLevel,
          a = e.schema[t],
          l = e.schemaPath + e.util.getProperty(t),
          c = e.errSchemaPath + "/" + t,
          h = !e.opts.allErrors,
          d = "data" + (s || ""),
          t = "errs__" + r,
          u = e.util.copy(e),
          g = "",
          p = (u.level++, "valid" + u.level),
          m = {},
          f = {},
          C = e.opts.ownProperties;
        for ($ in a) "__proto__" != $ && (N = a[$], (i = Array.isArray(N) ? f : m)[$] = N);
        var y = e.errorPath;
        for ($ in o = o + ("var " + t + " = errors;") + ("var missing" + r + ";"), f) if ((i = f[$]).length) {
          if (o += " if ( " + d + e.util.getProperty($) + " !== undefined ", C && (o += " && Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes($) + "') "), h) {
            o += " && ( ";
            var v = i;
            if (v) for (var I = -1, b = v.length - 1; I < b;) k = v[I += 1], I && (o += " || "), o += " ( ( " + (_ = d + (R = e.util.getProperty(k))) + " === undefined ", C && (o += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(k) + "') "), o += ") && (missing" + r + " = " + e.util.toQuotedString(e.opts.jsonPointers ? k : R) + ") ) ";
            o += ")) {  ";
            var A = "missing" + r,
              w = "' + " + A + " + '",
              S = (e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(y, A, !0) : y + " + " + A), S || []),
              A = (S.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes($) + "', missingProperty: '" + w + "', depsCount: " + i.length + ", deps: '" + e.util.escapeQuotes(1 == i.length ? i[0] : i.join(", ")) + "' } ", !1 !== e.opts.messages && (o += " , message: 'should have ", 1 == i.length ? o += "property " + e.util.escapeQuotes(i[0]) : o += "properties " + e.util.escapeQuotes(i.join(", ")), o += " when property " + e.util.escapeQuotes($) + " is present' "), e.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", o),
              o = S.pop();
            !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + A + "]); " : o += " validate.errors = [" + A + "]; return false; " : o += " var err = " + A + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
          } else {
            o += " ) { ";
            var x = i;
            if (x) for (var k, E = -1, T = x.length - 1; E < T;) {
              k = x[E += 1];
              var R = e.util.getProperty(k),
                w = e.util.escapeQuotes(k),
                _ = d + R;
              e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(y, k, e.opts.jsonPointers)), o += " if ( " + _ + " === undefined ", C && (o += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(k) + "') "), o += ") {  var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes($) + "', missingProperty: '" + w + "', depsCount: " + i.length + ", deps: '" + e.util.escapeQuotes(1 == i.length ? i[0] : i.join(", ")) + "' } ", !1 !== e.opts.messages && (o += " , message: 'should have ", 1 == i.length ? o += "property " + e.util.escapeQuotes(i[0]) : o += "properties " + e.util.escapeQuotes(i.join(", ")), o += " when property " + e.util.escapeQuotes($) + " is present' "), e.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
            }
          }
          o += " }   ", h && (g += "}", o += " else { ");
        }
        e.errorPath = y;
        var $,
          L = u.baseId;
        for ($ in m) {
          var N = m[$];
          (e.opts.strictKeywords ? "object" == typeof N && 0 < Object.keys(N).length || !1 === N : e.util.schemaHasRules(N, e.RULES.all)) && (o += " " + p + " = true; if ( " + d + e.util.getProperty($) + " !== undefined ", C && (o += " && Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes($) + "') "), o += ") { ", u.schema = N, u.schemaPath = l + e.util.getProperty($), u.errSchemaPath = c + "/" + e.util.escapeFragment($), o += "  " + e.validate(u) + " ", u.baseId = L, o += " }  ", h) && (o += " if (" + p + ") { ", g += "}");
        }
        return h && (o += "   " + g + " if (" + t + " == errors) {"), o;
      };
    },
    9317: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.level,
          r = e.dataLevel,
          s = e.schema[t],
          a = e.schemaPath + e.util.getProperty(t),
          t = e.errSchemaPath + "/" + t,
          l = !e.opts.allErrors,
          c = "data" + (r || ""),
          h = "valid" + o,
          d = e.opts.$data && s && s.$data,
          s = (d && (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; "), "i" + o),
          r = "schema" + o,
          r = (d || (i += " var " + r + " = validate.schema" + a + ";"), i += "var " + h + ";", d && (i += " if (schema" + o + " === undefined) " + h + " = true; else if (!Array.isArray(schema" + o + ")) " + h + " = false; else {"), i += h + " = false;for (var " + s + "=0; " + s + "<" + r + ".length; " + s + "++) if (equal(" + c + ", " + r + "[" + s + "])) { " + h + " = true; break; }", d && (i += "  }  "), []),
          s = (r.push(i += " if (!" + h + ") {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { allowedValues: schema" + o + " } ", !1 !== e.opts.messages && (i += " , message: 'should be equal to one of the allowed values' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i),
          i = r.pop();
        return !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + s + "]); " : i += " validate.errors = [" + s + "]; return false; " : i += " var err = " + s + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " }", l && (i += " else { "), i;
      };
    },
    8327: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.level,
          r = e.dataLevel,
          s = e.schema[t],
          a = e.schemaPath + e.util.getProperty(t),
          t = e.errSchemaPath + "/" + t,
          l = !e.opts.allErrors,
          c = "data" + (r || "");
        if (!1 === e.opts.format) l && (i += " if (true) { ");else {
          var h,
            d = e.opts.$data && s && s.$data,
            r = d ? (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; ", "schema" + o) : s,
            u = e.opts.unknownFormats,
            g = Array.isArray(u);
          if (d) i += " var " + (h = "format" + o) + " = formats[" + r + "]; var " + (p = "isObject" + o) + " = typeof " + h + " == 'object' && !(" + h + " instanceof RegExp) && " + h + ".validate; var " + (f = "formatType" + o) + " = " + p + " && " + h + ".type || 'string'; if (" + p + ") { ", e.async && (i += " var async" + o + " = " + h + ".async; "), i += " " + h + " = " + h + ".validate; } if (  ", d && (i += " (" + r + " !== undefined && typeof " + r + " != 'string') || "), i += " (", "ignore" != u && (i += " (" + r + " && !" + h + " ", g && (i += " && self._opts.unknownFormats.indexOf(" + r + ") == -1 "), i += ") || "), i += " (" + h + " && " + f + " == '" + n + "' && !(typeof " + h + " == 'function' ? ", e.async ? i += " (async" + o + " ? await " + h + "(" + c + ") : " + h + "(" + c + ")) " : i += " " + h + "(" + c + ") ", i += " : " + h + ".test(" + c + "))))) {";else {
            if (!(h = e.formats[s])) {
              if ("ignore" == u) return e.logger.warn("unknown format \"" + s + "\" ignored in schema at path \"" + e.errSchemaPath + "\""), l && (i += " if (true) { "), i;
              if (g && 0 <= u.indexOf(s)) return l && (i += " if (true) { "), i;
              throw new Error("unknown format \"" + s + "\" is used in schema at path \"" + e.errSchemaPath + "\"");
            }
            var p,
              m,
              f = (p = "object" == typeof h && !(h instanceof RegExp) && h.validate) && h.type || "string";
            if (p && (m = !0 === h.async, h = h.validate), f != n) return l && (i += " if (true) { "), i;
            if (m) {
              if (!e.async) throw new Error("async format in sync schema");
              i += " if (!(await " + (C = "formats" + e.util.getProperty(s) + ".validate") + "(" + c + "))) { ";
            } else {
              i += " if (! ";
              var C = "formats" + e.util.getProperty(s);
              p && (C += ".validate"), i = i + ("function" == typeof h ? " " + C + "(" + c + ") " : " " + C + ".test(" + c + ") ") + ") { ";
            }
          }
          o = [], g = (o.push(i), i = "", !1 !== e.createErrors ? (i = (i += " { keyword: 'format' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { format:  ") + (d ? "" + r : "" + e.util.toQuotedString(s)) + "  } ", !1 !== e.opts.messages && (i = (i += " , message: 'should match format \"") + (d ? "' + " + r + " + '" : "" + e.util.escapeQuotes(s)) + "\"' "), e.opts.verbose && (i = (i = (i += " , schema:  ") + (d ? "validate.schema" + a : "" + e.util.toQuotedString(s))) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i), i = o.pop();
          !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + g + "]); " : i += " validate.errors = [" + g + "]; return false; " : i += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } ", l && (i += " else { ");
        }
        return i;
      };
    },
    5926: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o = " ",
          r = e.level,
          s = e.dataLevel,
          a = e.schema[t],
          l = e.schemaPath + e.util.getProperty(t),
          t = e.errSchemaPath + "/" + t,
          c = !e.opts.allErrors,
          s = "data" + (s || ""),
          h = "valid" + r,
          d = "errs__" + r,
          u = e.util.copy(e),
          g = (u.level++, "valid" + u.level),
          p = e.schema.then,
          m = e.schema.else,
          p = void 0 !== p && (e.opts.strictKeywords ? "object" == typeof p && 0 < Object.keys(p).length || !1 === p : e.util.schemaHasRules(p, e.RULES.all)),
          m = void 0 !== m && (e.opts.strictKeywords ? "object" == typeof m && 0 < Object.keys(m).length || !1 === m : e.util.schemaHasRules(m, e.RULES.all)),
          f = u.baseId;
        return p || m ? (u.createErrors = !1, u.schema = a, u.schemaPath = l, u.errSchemaPath = t, o += " var " + d + " = errors; var " + h + " = true;  ", a = e.compositeRule, e.compositeRule = u.compositeRule = !0, o += "  " + e.validate(u) + " ", u.baseId = f, u.createErrors = !0, o += "  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; }  ", e.compositeRule = u.compositeRule = a, p ? (o += " if (" + g + ") {  ", u.schema = e.schema.then, u.schemaPath = e.schemaPath + ".then", u.errSchemaPath = e.errSchemaPath + "/then", o += "  " + e.validate(u) + " ", u.baseId = f, o += " " + h + " = " + g + "; ", p && m ? o += " var " + (i = "ifClause" + r) + " = 'then'; " : i = "'then'", o += " } ", m && (o += " else { ")) : o += " if (!" + g + ") { ", m && (u.schema = e.schema.else, u.schemaPath = e.schemaPath + ".else", u.errSchemaPath = e.errSchemaPath + "/else", o += "  " + e.validate(u) + " ", u.baseId = f, o += " " + h + " = " + g + "; ", p && m ? o += " var " + (i = "ifClause" + r) + " = 'else'; " : i = "'else'", o += " } "), o += " if (!" + h + ") {   var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'if' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { failingKeyword: " + i + " } ", !1 !== e.opts.messages && (o += " , message: 'should match \"' + " + i + " + '\" schema' "), e.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + s + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && c && (e.async ? o += " throw new ValidationError(vErrors); " : o += " validate.errors = vErrors; return false; "), o += " }   ", c && (o += " else { ")) : c && (o += " if (true) { "), o;
      };
    },
    9646: function (e, t, n) {
      "use strict";

      e.exports = {
        $ref: n(2331),
        allOf: n(9486),
        anyOf: n(5347),
        $comment: n(923),
        const: n(2617),
        contains: n(2119),
        dependencies: n(9115),
        enum: n(9317),
        format: n(8327),
        if: n(5926),
        items: n(392),
        maximum: n(1796),
        minimum: n(1796),
        maxItems: n(2407),
        minItems: n(2407),
        maxLength: n(1250),
        minLength: n(1250),
        maxProperties: n(2596),
        minProperties: n(2596),
        multipleOf: n(6039),
        not: n(7946),
        oneOf: n(9344),
        pattern: n(9737),
        properties: n(2537),
        propertyNames: n(2127),
        required: n(1204),
        uniqueItems: n(1985),
        validate: n(1869)
      };
    },
    392: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.level,
          r = e.dataLevel,
          s = e.schema[t],
          a = e.schemaPath + e.util.getProperty(t),
          l = e.errSchemaPath + "/" + t,
          c = !e.opts.allErrors,
          h = "data" + (r || ""),
          t = "valid" + o,
          r = "errs__" + o,
          d = e.util.copy(e),
          u = "",
          g = (d.level++, "valid" + d.level),
          o = "i" + o,
          p = d.dataLevel = e.dataLevel + 1,
          m = "data" + p,
          f = e.baseId;
        if (i += "var " + r + " = errors;var " + t + ";", Array.isArray(s)) {
          var C,
            y,
            v = e.schema.additionalItems,
            I = (!1 === v && (i += " " + t + " = " + h + ".length <= " + s.length + "; ", C = l, l = e.errSchemaPath + "/additionalItems", (y = y || []).push(i += "  if (!" + t + ") {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + s.length + " } ", !1 !== e.opts.messages && (i += " , message: 'should NOT have more than " + s.length + " items' "), e.opts.verbose && (i += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), i += " } ") : i += " {} ", t = i, i = y.pop(), !e.compositeRule && c ? e.async ? i += " throw new ValidationError([" + t + "]); " : i += " validate.errors = [" + t + "]; return false; " : i += " var err = " + t + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } ", l = C, c) && (u += "}", i += " else { "), s);
          if (I) for (var b = -1, A = I.length - 1; b < A;) {
            var w,
              S,
              x = I[b += 1];
            (e.opts.strictKeywords ? "object" == typeof x && 0 < Object.keys(x).length || !1 === x : e.util.schemaHasRules(x, e.RULES.all)) && (i += " " + g + " = true; if (" + h + ".length > " + b + ") { ", w = h + "[" + b + "]", d.schema = x, d.schemaPath = a + "[" + b + "]", d.errSchemaPath = l + "/" + b, d.errorPath = e.util.getPathExpr(e.errorPath, b, e.opts.jsonPointers, !0), d.dataPathArr[p] = b, S = e.validate(d), d.baseId = f, e.util.varOccurences(S, m) < 2 ? i += " " + e.util.varReplace(S, m, w) + " " : i += " var " + m + " = " + w + "; " + S + " ", i += " }  ", c) && (i += " if (" + g + ") { ", u += "}");
          }
          "object" == typeof v && (e.opts.strictKeywords ? "object" == typeof v && 0 < Object.keys(v).length || !1 === v : e.util.schemaHasRules(v, e.RULES.all)) && (d.schema = v, d.schemaPath = e.schemaPath + ".additionalItems", d.errSchemaPath = e.errSchemaPath + "/additionalItems", i += " " + g + " = true; if (" + h + ".length > " + s.length + ") {  for (var " + o + " = " + s.length + "; " + o + " < " + h + ".length; " + o + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, o, e.opts.jsonPointers, !0), w = h + "[" + o + "]", d.dataPathArr[p] = o, S = e.validate(d), d.baseId = f, e.util.varOccurences(S, m) < 2 ? i += " " + e.util.varReplace(S, m, w) + " " : i += " var " + m + " = " + w + "; " + S + " ", c && (i += " if (!" + g + ") break; "), i += " } }  ", c) && (i += " if (" + g + ") { ", u += "}");
        } else (e.opts.strictKeywords ? "object" == typeof s && 0 < Object.keys(s).length || !1 === s : e.util.schemaHasRules(s, e.RULES.all)) && (d.schema = s, d.schemaPath = a, d.errSchemaPath = l, i += "  for (var " + o + " = 0; " + o + " < " + h + ".length; " + o + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, o, e.opts.jsonPointers, !0), w = h + "[" + o + "]", d.dataPathArr[p] = o, S = e.validate(d), d.baseId = f, e.util.varOccurences(S, m) < 2 ? i += " " + e.util.varReplace(S, m, w) + " " : i += " var " + m + " = " + w + "; " + S + " ", c && (i += " if (!" + g + ") break; "), i += " }");
        return c && (i += " " + u + " if (" + r + " == errors) {"), i;
      };
    },
    6039: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.level,
          r = e.dataLevel,
          s = e.schema[t],
          a = e.schemaPath + e.util.getProperty(t),
          l = e.errSchemaPath + "/" + t,
          c = !e.opts.allErrors,
          h = "data" + (r || ""),
          d = e.opts.$data && s && s.$data,
          r = d ? (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; ", "schema" + o) : s;
        if (!d && "number" != typeof s) throw new Error(t + " must be number");
        i += "var division" + o + ";if (", d && (i += " " + r + " !== undefined && ( typeof " + r + " != 'number' || "), i += " (division" + o + " = " + h + " / " + r + ", ", e.opts.multipleOfPrecision ? i += " Math.abs(Math.round(division" + o + ") - division" + o + ") > 1e-" + e.opts.multipleOfPrecision + " " : i += " division" + o + " !== parseInt(division" + o + ") ", i += " ) ", d && (i += "  )  ");
        t = [], t.push(i += " ) {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { multipleOf: " + r + " } ", !1 !== e.opts.messages && (i = i + " , message: 'should be multiple of " + (d ? "' + " + r : r + "'")), e.opts.verbose && (i = (i += " , schema:  ") + (d ? "validate.schema" + a : "" + s) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), i += " } ") : i += " {} ", o = i, i = t.pop();
        return !e.compositeRule && c ? e.async ? i += " throw new ValidationError([" + o + "]); " : i += " validate.errors = [" + o + "]; return false; " : i += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", c && (i += " else { "), i;
      };
    },
    7946: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o,
          r = " ",
          s = e.level,
          a = e.dataLevel,
          l = e.schema[t],
          c = e.schemaPath + e.util.getProperty(t),
          t = e.errSchemaPath + "/" + t,
          h = !e.opts.allErrors,
          a = "data" + (a || ""),
          s = "errs__" + s,
          d = e.util.copy(e),
          u = (d.level++, "valid" + d.level);
        return (e.opts.strictKeywords ? "object" == typeof l && 0 < Object.keys(l).length || !1 === l : e.util.schemaHasRules(l, e.RULES.all)) ? (d.schema = l, d.schemaPath = c, d.errSchemaPath = t, r += " var " + s + " = errors;  ", l = e.compositeRule, e.compositeRule = d.compositeRule = !0, d.createErrors = !1, d.opts.allErrors && (o = d.opts.allErrors, d.opts.allErrors = !1), r += " " + e.validate(d) + " ", d.createErrors = !0, o && (d.opts.allErrors = o), e.compositeRule = d.compositeRule = l, (i = i || []).push(r += " if (" + u + ") {   "), r = "", !1 !== e.createErrors ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + a + " "), r += " } ") : r += " {} ", o = r, r = i.pop(), !e.compositeRule && h ? e.async ? r += " throw new ValidationError([" + o + "]); " : r += " validate.errors = [" + o + "]; return false; " : r += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else {  errors = " + s + "; if (vErrors !== null) { if (" + s + ") vErrors.length = " + s + "; else vErrors = null; } ", e.opts.allErrors && (r += " } ")) : (r += "  var err =   ", !1 !== e.createErrors ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + a + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", h && (r += " if (false) { ")), r;
      };
    },
    9344: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.level,
          r = e.dataLevel,
          s = e.schema[t],
          a = e.schemaPath + e.util.getProperty(t),
          l = e.errSchemaPath + "/" + t,
          t = !e.opts.allErrors,
          r = "data" + (r || ""),
          c = "valid" + o,
          h = "errs__" + o,
          d = e.util.copy(e),
          u = "",
          g = (d.level++, "valid" + d.level),
          p = d.baseId,
          m = "prevValid" + o,
          f = "passingSchemas" + o,
          o = (i += "var " + h + " = errors , " + m + " = false , " + c + " = false , " + f + " = null; ", e.compositeRule),
          C = (e.compositeRule = d.compositeRule = !0, s);
        if (C) for (var y, v = -1, I = C.length - 1; v < I;) y = C[v += 1], (e.opts.strictKeywords ? "object" == typeof y && 0 < Object.keys(y).length || !1 === y : e.util.schemaHasRules(y, e.RULES.all)) ? (d.schema = y, d.schemaPath = a + "[" + v + "]", d.errSchemaPath = l + "/" + v, i += "  " + e.validate(d) + " ", d.baseId = p) : i += " var " + g + " = true; ", v && (i += " if (" + g + " && " + m + ") { " + c + " = false; " + f + " = [" + f + ", " + v + "]; } else { ", u += "}"), i += " if (" + g + ") { " + c + " = " + m + " = true; " + f + " = " + v + "; }";
        return e.compositeRule = d.compositeRule = o, i += u + "if (!" + c + ") {   var err =   ", !1 !== e.createErrors ? (i += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { passingSchemas: " + f + " } ", !1 !== e.opts.messages && (i += " , message: 'should match exactly one schema in oneOf' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + r + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && t && (e.async ? i += " throw new ValidationError(vErrors); " : i += " validate.errors = vErrors; return false; "), i += "} else {  errors = " + h + "; if (vErrors !== null) { if (" + h + ") vErrors.length = " + h + "; else vErrors = null; }", e.opts.allErrors && (i += " } "), i;
      };
    },
    9737: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.level,
          r = e.dataLevel,
          s = e.schema[t],
          a = e.schemaPath + e.util.getProperty(t),
          t = e.errSchemaPath + "/" + t,
          l = !e.opts.allErrors,
          c = "data" + (r || ""),
          h = e.opts.$data && s && s.$data,
          r = h ? (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; ", "schema" + o) : s,
          o = h ? "(new RegExp(" + r + "))" : e.usePattern(s),
          d = (i += "if ( ", h && (i += " (" + r + " !== undefined && typeof " + r + " != 'string') || "), []),
          o = (d.push(i += " !" + o + ".test(" + c + ") ) {   "), i = "", !1 !== e.createErrors ? (i = (i += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { pattern:  ") + (h ? "" + r : "" + e.util.toQuotedString(s)) + "  } ", !1 !== e.opts.messages && (i = (i += " , message: 'should match pattern \"") + (h ? "' + " + r + " + '" : "" + e.util.escapeQuotes(s)) + "\"' "), e.opts.verbose && (i = (i = (i += " , schema:  ") + (h ? "validate.schema" + a : "" + e.util.toQuotedString(s))) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i),
          i = d.pop();
        return !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + o + "]); " : i += " validate.errors = [" + o + "]; return false; " : i += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", l && (i += " else { "), i;
      };
    },
    2537: function (e) {
      "use strict";

      e.exports = function (e, t, W) {
        var n,
          i = " ",
          o = e.level,
          r = e.dataLevel,
          H = e.schema[t],
          s = e.schemaPath + e.util.getProperty(t),
          a = e.errSchemaPath + "/" + t,
          l = !e.opts.allErrors,
          c = "data" + (r || ""),
          t = "errs__" + o,
          h = e.util.copy(e),
          d = "",
          u = (h.level++, "valid" + h.level),
          g = "key" + o,
          p = "idx" + o,
          m = h.dataLevel = e.dataLevel + 1,
          f = "data" + m,
          C = "dataProperties" + o,
          r = Object.keys(H || {}).filter(Z),
          G = e.schema.patternProperties || {},
          y = Object.keys(G).filter(Z),
          v = e.schema.additionalProperties,
          P = r.length || y.length,
          F = !1 === v,
          V = "object" == typeof v && Object.keys(v).length,
          I = e.opts.removeAdditional,
          b = F || V || I,
          A = e.opts.ownProperties,
          w = e.baseId,
          S = e.schema.required;
        function Z(e) {
          return "__proto__" !== e;
        }
        if (S && (!e.opts.$data || !S.$data) && S.length < e.opts.loopRequired && (n = e.util.toHash(S)), i += "var " + t + " = errors;var " + u + " = true;", A && (i += " var " + C + " = undefined;"), b) {
          if (i += A ? " " + C + " = " + C + " || Object.keys(" + c + "); for (var " + p + "=0; " + p + "<" + C + ".length; " + p + "++) { var " + g + " = " + C + "[" + p + "]; " : " for (var " + g + " in " + c + ") { ", P) {
            if (i += " var isAdditional" + o + " = !(false ", r.length) if (8 < r.length) i += " || validate.schema" + s + ".hasOwnProperty(" + g + ") ";else {
              var O = r;
              if (O) for (var D = -1, K = O.length - 1; D < K;) x = O[D += 1], i += " || " + g + " == " + e.util.toQuotedString(x) + " ";
            }
            if (y.length) {
              var j = y;
              if (j) for (var z = -1, X = j.length - 1; z < X;) N = j[z += 1], i += " || " + e.usePattern(N) + ".test(" + g + ") ";
            }
            i += " ); if (isAdditional" + o + ") { ";
          }
          "all" == I ? i += " delete " + c + "[" + g + "]; " : (E = e.errorPath, S = "' + " + g + " + '", e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers)), F ? I ? i += " delete " + c + "[" + g + "]; " : (T = a, a = e.errSchemaPath + "/additionalProperties", (_ = _ || []).push(i += " " + u + " = false; "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(a) + " , params: { additionalProperty: '" + S + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is an invalid additional property" : i += "should NOT have additional properties", i += "' "), e.opts.verbose && (i += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", $ = i, i = _.pop(), !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + $ + "]); " : i += " validate.errors = [" + $ + "]; return false; " : i += " var err = " + $ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", a = T, l && (i += " break; ")) : V && ("failing" == I ? (i += " var " + t + " = errors;  ", b = e.compositeRule, e.compositeRule = h.compositeRule = !0, h.schema = v, h.schemaPath = e.schemaPath + ".additionalProperties", h.errSchemaPath = e.errSchemaPath + "/additionalProperties", h.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), B = c + "[" + g + "]", h.dataPathArr[m] = g, M = e.validate(h), h.baseId = w, e.util.varOccurences(M, f) < 2 ? i += " " + e.util.varReplace(M, f, B) + " " : i += " var " + f + " = " + B + "; " + M + " ", i += " if (!" + u + ") { errors = " + t + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + c + "[" + g + "]; }  ", e.compositeRule = h.compositeRule = b) : (h.schema = v, h.schemaPath = e.schemaPath + ".additionalProperties", h.errSchemaPath = e.errSchemaPath + "/additionalProperties", h.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), B = c + "[" + g + "]", h.dataPathArr[m] = g, M = e.validate(h), h.baseId = w, e.util.varOccurences(M, f) < 2 ? i += " " + e.util.varReplace(M, f, B) + " " : i += " var " + f + " = " + B + "; " + M + " ", l && (i += " if (!" + u + ") break; "))), e.errorPath = E), P && (i += " } "), i += " }  ", l && (i += " if (" + u + ") { ", d += "}");
        }
        var Y = e.opts.useDefaults && !e.compositeRule;
        if (r.length) {
          var J = r;
          if (J) for (var x, U = -1, Q = J.length - 1; U < Q;) {
            var q,
              k,
              E,
              T,
              R,
              _,
              $,
              L = H[x = J[U += 1]];
            (e.opts.strictKeywords ? "object" == typeof L && 0 < Object.keys(L).length || !1 === L : e.util.schemaHasRules(L, e.RULES.all)) && (B = c + (R = e.util.getProperty(x)), q = Y && void 0 !== L.default, h.schema = L, h.schemaPath = s + R, h.errSchemaPath = a + "/" + e.util.escapeFragment(x), h.errorPath = e.util.getPath(e.errorPath, x, e.opts.jsonPointers), h.dataPathArr[m] = e.util.toQuotedString(x), M = e.validate(h), h.baseId = w, e.util.varOccurences(M, f) < 2 ? (M = e.util.varReplace(M, f, B), k = B) : i += " var " + (k = f) + " = " + B + "; ", q ? i += " " + M + " " : (n && n[x] ? (i += " if ( " + k + " === undefined ", A && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(x) + "') "), i += ") { " + u + " = false; ", E = e.errorPath, T = a, R = e.util.escapeQuotes(x), e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(E, x, e.opts.jsonPointers)), a = e.errSchemaPath + "/required", (_ = _ || []).push(i), i = "", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(a) + " , params: { missingProperty: '" + R + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + R + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", $ = i, i = _.pop(), !e.compositeRule && l ? e.async ? i += " throw new ValidationError([" + $ + "]); " : i += " validate.errors = [" + $ + "]; return false; " : i += " var err = " + $ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", a = T, e.errorPath = E, i += " } else { ") : l ? (i += " if ( " + k + " === undefined ", A && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(x) + "') "), i += ") { " + u + " = true; } else { ") : (i += " if (" + k + " !== undefined ", A && (i += " &&   Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(x) + "') "), i += " ) { "), i += " " + M + " } ")), l && (i += " if (" + u + ") { ", d += "}");
          }
        }
        if (y.length) {
          var ee = y;
          if (ee) for (var N, te = -1, ne = ee.length - 1; te < ne;) {
            var B,
              M,
              L = G[N = ee[te += 1]];
            (e.opts.strictKeywords ? "object" == typeof L && 0 < Object.keys(L).length || !1 === L : e.util.schemaHasRules(L, e.RULES.all)) && (h.schema = L, h.schemaPath = e.schemaPath + ".patternProperties" + e.util.getProperty(N), h.errSchemaPath = e.errSchemaPath + "/patternProperties/" + e.util.escapeFragment(N), i = (i += A ? " " + C + " = " + C + " || Object.keys(" + c + "); for (var " + p + "=0; " + p + "<" + C + ".length; " + p + "++) { var " + g + " = " + C + "[" + p + "]; " : " for (var " + g + " in " + c + ") { ") + " if (" + e.usePattern(N) + ".test(" + g + ")) { ", h.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), B = c + "[" + g + "]", h.dataPathArr[m] = g, M = e.validate(h), h.baseId = w, e.util.varOccurences(M, f) < 2 ? i += " " + e.util.varReplace(M, f, B) + " " : i += " var " + f + " = " + B + "; " + M + " ", l && (i += " if (!" + u + ") break; "), i += " } ", l && (i += " else " + u + " = true; "), i += " }  ", l) && (i += " if (" + u + ") { ", d += "}");
          }
        }
        return l && (i += " " + d + " if (" + t + " == errors) {"), i;
      };
    },
    2127: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o,
          r,
          s,
          a,
          l,
          c,
          h = " ",
          d = e.level,
          u = e.dataLevel,
          g = e.schema[t],
          p = e.schemaPath + e.util.getProperty(t),
          t = e.errSchemaPath + "/" + t,
          m = !e.opts.allErrors,
          u = "data" + (u || ""),
          f = "errs__" + d,
          C = e.util.copy(e),
          y = (C.level++, "valid" + C.level);
        return h += "var " + f + " = errors;", (e.opts.strictKeywords ? "object" == typeof g && 0 < Object.keys(g).length || !1 === g : e.util.schemaHasRules(g, e.RULES.all)) && (C.schema = g, C.schemaPath = p, C.errSchemaPath = t, g = "idx" + d, o = "i" + d, r = "' + " + (i = "key" + d) + " + '", s = "data" + (C.dataLevel = e.dataLevel + 1), c = "dataProperties" + d, l = e.opts.ownProperties, a = e.baseId, l && (h += " var " + c + " = undefined; "), h = h + (l ? " " + c + " = " + c + " || Object.keys(" + u + "); for (var " + g + "=0; " + g + "<" + c + ".length; " + g + "++) { var " + i + " = " + c + "[" + g + "]; " : " for (var " + i + " in " + u + ") { ") + " var startErrs" + d + " = errors; ", l = i, c = e.compositeRule, e.compositeRule = C.compositeRule = !0, g = e.validate(C), C.baseId = a, e.util.varOccurences(g, s) < 2 ? h += " " + e.util.varReplace(g, s, l) + " " : h += " var " + s + " = " + l + "; " + g + " ", e.compositeRule = C.compositeRule = c, h += " if (!" + y + ") { for (var " + o + "=startErrs" + d + "; " + o + "<errors; " + o + "++) { vErrors[" + o + "].propertyName = " + i + "; }   var err =   ", !1 !== e.createErrors ? (h += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { propertyName: '" + r + "' } ", !1 !== e.opts.messages && (h += " , message: 'property name \\'" + r + "\\' is invalid' "), e.opts.verbose && (h += " , schema: validate.schema" + p + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), h += " } ") : h += " {} ", h += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && m && (e.async ? h += " throw new ValidationError(vErrors); " : h += " validate.errors = vErrors; return false; "), m && (h += " break; "), h += " } }"), m && (h += "  if (" + f + " == errors) {"), h;
      };
    },
    2331: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o,
          r = " ",
          s = e.level,
          a = e.dataLevel,
          l = e.schema[t],
          t = e.errSchemaPath + "/" + t,
          c = !e.opts.allErrors,
          h = "data" + (a || ""),
          s = "valid" + s;
        if ("#" == l || "#/" == l) o = e.isRoot ? (i = e.async, "validate") : (i = !0 === e.root.schema.$async, "root.refVal[0]");else {
          var d = e.resolveRef(e.baseId, l, e.isRoot);
          if (void 0 === d) {
            var u = e.MissingRefError.message(e.baseId, l);
            if ("fail" == e.opts.missingRefs) {
              e.logger.error(u);
              (g = g || []).push(r), r = "", !1 !== e.createErrors ? (r += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { ref: '" + e.util.escapeQuotes(l) + "' } ", !1 !== e.opts.messages && (r += " , message: 'can\\'t resolve reference " + e.util.escapeQuotes(l) + "' "), e.opts.verbose && (r += " , schema: " + e.util.toQuotedString(l) + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), r += " } ") : r += " {} ";
              t = r, r = g.pop();
              !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + t + "]); " : r += " validate.errors = [" + t + "]; return false; " : r += " var err = " + t + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c && (r += " if (false) { ");
            } else {
              if ("ignore" != e.opts.missingRefs) throw new e.MissingRefError(e.baseId, l, u);
              e.logger.warn(u), c && (r += " if (true) { ");
            }
          } else d.inline ? ((t = e.util.copy(e)).level++, u = "valid" + t.level, t.schema = d.schema, t.schemaPath = "", t.errSchemaPath = l, r += " " + e.validate(t).replace(/validate\.schema/g, d.code) + " ", c && (r += " if (" + u + ") { ")) : (i = !0 === d.$async || e.async && !1 !== d.$async, o = d.code);
        }
        if (o) {
          (g = g || []).push(r), r = "", e.opts.passContext ? r += " " + o + ".call(this, " : r += " " + o + "( ", r += " " + h + ", (dataPath || '')", "\"\"" != e.errorPath && (r += " + " + e.errorPath);
          var g,
            l = a ? "data" + (a - 1 || "") : "parentData",
            t = r += " , " + l + " , " + (a ? e.dataPathArr[a] : "parentDataProperty") + ", rootData)  ";
          if (r = g.pop(), i) {
            if (!e.async) throw new Error("async schema referenced by sync schema");
            c && (r += " var " + s + "; "), r += " try { await " + t + "; ", c && (r += " " + s + " = true; "), r += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", c && (r += " " + s + " = false; "), r += " } ", c && (r += " if (" + s + ") { ");
          } else r += " if (!" + t + ") { if (vErrors === null) vErrors = " + o + ".errors; else vErrors = vErrors.concat(" + o + ".errors); errors = vErrors.length; } ", c && (r += " else { ");
        }
        return r;
      };
    },
    1204: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i = " ",
          o = e.level,
          r = e.dataLevel,
          s = e.schema[t],
          a = e.schemaPath + e.util.getProperty(t),
          l = e.errSchemaPath + "/" + t,
          t = !e.opts.allErrors,
          c = "data" + (r || ""),
          h = "valid" + o,
          d = e.opts.$data && s && s.$data,
          r = (d && (i += " var schema" + o + " = " + e.util.getData(s.$data, r, e.dataPathArr) + "; "), "schema" + o);
        if (!d) if (s.length < e.opts.loopRequired && e.schema.properties && Object.keys(e.schema.properties).length) {
          var u = [],
            g = s;
          if (g) for (var p = -1, m = g.length - 1; p < m;) {
            var f = g[p += 1],
              C = e.schema.properties[f];
            C && (e.opts.strictKeywords ? "object" == typeof C && 0 < Object.keys(C).length || !1 === C : e.util.schemaHasRules(C, e.RULES.all)) || (u[u.length] = f);
          }
        } else u = s;
        if (d || u.length) {
          var y = e.errorPath,
            s = d || u.length >= e.opts.loopRequired,
            v = e.opts.ownProperties;
          if (t) {
            if (i += " var missing" + o + "; ", s) {
              d || (i += " var " + r + " = validate.schema" + a + "; ");
              var I = "' + " + (k = "schema" + o + "[" + (w = "i" + o) + "]") + " + '";
              e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(y, k, e.opts.jsonPointers)), i += " var " + h + " = true; ", d && (i += " if (schema" + o + " === undefined) " + h + " = true; else if (!Array.isArray(schema" + o + ")) " + h + " = false; else {"), i += " for (var " + w + " = 0; " + w + " < " + r + ".length; " + w + "++) { " + h + " = " + c + "[" + r + "[" + w + "]] !== undefined ", v && (i += " &&   Object.prototype.hasOwnProperty.call(" + c + ", " + r + "[" + w + "]) "), i += "; if (!" + h + ") break; } ", d && (i += "  }  ");
              (x = x || []).push(i += "  if (!" + h + ") {   "), i = "", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ";
              var b = i,
                i = x.pop();
            } else {
              i += " if ( ";
              var A = u;
              if (A) for (var w = -1, S = A.length - 1; w < S;) T = A[w += 1], w && (i += " || "), i += " ( ( " + (L = c + ($ = e.util.getProperty(T))) + " === undefined ", v && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(T) + "') "), i += ") && (missing" + o + " = " + e.util.toQuotedString(e.opts.jsonPointers ? T : $) + ") ) ";
              i += ") {  ";
              I = "' + " + (k = "missing" + o) + " + '";
              e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(y, k, !0) : y + " + " + k);
              (x = x || []).push(i), i = "", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ";
              var x,
                b = i;
              i = x.pop();
            }
            !e.compositeRule && t ? e.async ? i += " throw new ValidationError([" + b + "]); " : i += " validate.errors = [" + b + "]; return false; " : i += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } else { ";
          } else if (s) {
            d || (i += " var " + r + " = validate.schema" + a + "; ");
            var k,
              I = "' + " + (k = "schema" + o + "[" + (w = "i" + o) + "]") + " + '";
            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(y, k, e.opts.jsonPointers)), d && (i += " if (" + r + " && !Array.isArray(" + r + ")) {  var err =   ", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + r + " !== undefined) { "), i += " for (var " + w + " = 0; " + w + " < " + r + ".length; " + w + "++) { if (" + c + "[" + r + "[" + w + "]] === undefined ", v && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", " + r + "[" + w + "]) "), i += ") {  var err =   ", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", d && (i += "  }  ");
          } else {
            var E = u;
            if (E) for (var T, R = -1, _ = E.length - 1; R < _;) {
              T = E[R += 1];
              var $ = e.util.getProperty(T),
                I = e.util.escapeQuotes(T),
                L = c + $;
              e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(y, T, e.opts.jsonPointers)), i += " if ( " + L + " === undefined ", v && (i += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(T) + "') "), i += ") {  var err =   ", !1 !== e.createErrors ? (i += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + I + "' } ", !1 !== e.opts.messages && (i += " , message: '", e.opts._errorDataPathProperty ? i += "is a required property" : i += "should have required property \\'" + I + "\\'", i += "' "), e.opts.verbose && (i += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), i += " } ") : i += " {} ", i += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
            }
          }
          e.errorPath = y;
        } else t && (i += " if (true) {");
        return i;
      };
    },
    1985: function (e) {
      "use strict";

      e.exports = function (e, t, n) {
        var i,
          o = " ",
          r = e.level,
          s = e.dataLevel,
          a = e.schema[t],
          l = e.schemaPath + e.util.getProperty(t),
          t = e.errSchemaPath + "/" + t,
          c = !e.opts.allErrors,
          h = "data" + (s || ""),
          d = "valid" + r,
          u = e.opts.$data && a && a.$data,
          s = u ? (o += " var schema" + r + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + r) : a;
        return (a || u) && !1 !== e.opts.uniqueItems ? (u && (o += " var " + d + "; if (" + s + " === false || " + s + " === undefined) " + d + " = true; else if (typeof " + s + " != 'boolean') " + d + " = false; else { "), o += " var i = " + h + ".length , " + d + " = true , j; if (i > 1) { ", r = e.schema.items && e.schema.items.type, s = Array.isArray(r), !r || "object" == r || "array" == r || s && (0 <= r.indexOf("object") || 0 <= r.indexOf("array")) ? o += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + h + "[i], " + h + "[j])) { " + d + " = false; break outer; } } } " : (o = (o += " var itemIndices = {}, item; for (;i--;) { var item = " + h + "[i]; ") + " if (" + e.util["checkDataType" + (s ? "s" : "")](r, "item", e.opts.strictNumbers, !0) + ") continue; ", s && (o += " if (typeof item == 'string') item = '\"' + item; "), o += " if (typeof itemIndices[item] == 'number') { " + d + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } "), o += " } ", u && (o += "  }  "), (i = i || []).push(o += " if (!" + d + ") {   "), o = "", !1 !== e.createErrors ? (o += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { i: i, j: j } ", !1 !== e.opts.messages && (o += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e.opts.verbose && (o = (o += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), o += " } ") : o += " {} ", r = o, o = i.pop(), !e.compositeRule && c ? e.async ? o += " throw new ValidationError([" + r + "]); " : o += " validate.errors = [" + r + "]; return false; " : o += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } ", c && (o += " else { ")) : c && (o += " if (true) { "), o;
      };
    },
    1869: function (e) {
      "use strict";

      e.exports = function (i, e, W) {
        var t = "",
          n = !0 === i.schema.$async,
          o = i.util.schemaHasRulesExcept(i.schema, i.RULES.all, "$ref"),
          r = i.self._getId(i.schema);
        if (i.opts.strictKeywords) {
          var s = i.util.schemaUnknownRules(i.schema, i.RULES.keywords);
          if (s) {
            s = "unknown keyword: " + s;
            if ("log" !== i.opts.strictKeywords) throw new Error(s);
            i.logger.warn(s);
          }
        }
        if (i.isTop && (t += " var validate = ", n && (i.async = !0, t += "async "), t += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", r) && (i.opts.sourceCode || i.opts.processCode) && (t += " /*# sourceURL=" + r + " */ "), "boolean" == typeof i.schema || !o && !i.schema.$ref) l = i.level, c = i.dataLevel, R = i.schema[e = "false schema"], I = i.schemaPath + i.util.getProperty(e), b = i.errSchemaPath + "/" + e, g = !i.opts.allErrors, h = "data" + (c || ""), u = "valid" + l, !1 === i.schema ? (i.isTop ? g = !0 : t += " var " + u + " = false; ", (B = B || []).push(t), t = "", !1 !== i.createErrors ? (t += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + i.errorPath + " , schemaPath: " + i.util.toQuotedString(b) + " , params: {} ", !1 !== i.opts.messages && (t += " , message: 'boolean schema is false' "), i.opts.verbose && (t += " , schema: false , parentSchema: validate.schema" + i.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", E = t, t = B.pop(), !i.compositeRule && g ? i.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ") : i.isTop ? t += n ? " return data; " : " validate.errors = null; return true; " : t += " var " + u + " = true; ", i.isTop && (t += " }; return validate; ");else {
          if (i.isTop) {
            var a = i.isTop,
              l = i.level = 0,
              c = i.dataLevel = 0,
              h = "data";
            if (i.rootId = i.resolve.fullPath(i.self._getId(i.root.schema)), i.baseId = i.baseId || i.rootId, delete i.isTop, i.dataPathArr = [""], void 0 !== i.schema.default && i.opts.useDefaults && i.opts.strictDefaults) {
              var d = "default is ignored in the schema root";
              if ("log" !== i.opts.strictDefaults) throw new Error(d);
              i.logger.warn(d);
            }
            t = (t += " var vErrors = null; ") + " var errors = 0;     " + " if (rootData === undefined) rootData = data; ";
          } else {
            l = i.level, h = "data" + ((c = i.dataLevel) || "");
            if (r && (i.baseId = i.resolve.url(i.baseId, r)), n && !i.async) throw new Error("async schema in sync schema");
            t += " var errs_" + l + " = errors;";
          }
          var u = "valid" + l,
            g = !i.opts.allErrors,
            p = "",
            m = "",
            f = i.schema.type,
            C = Array.isArray(f);
          if (f && i.opts.nullable && !0 === i.schema.nullable && (C ? -1 == f.indexOf("null") && (f = f.concat("null")) : "null" != f && (f = [f, "null"], C = !0)), C && 1 == f.length && (f = f[0], C = !1), i.schema.$ref && o) {
            if ("fail" == i.opts.extendRefs) throw new Error("$ref: validation keywords used in schema at path \"" + i.errSchemaPath + "\" (see option extendRefs)");
            !0 !== i.opts.extendRefs && (o = !1, i.logger.warn("$ref: keywords ignored in schema at path \"" + i.errSchemaPath + "\""));
          }
          if (i.schema.$comment && i.opts.$comment && (t += " " + i.RULES.all.$comment.code(i, "$comment")), f) {
            i.opts.coerceTypes && (y = i.util.coerceToTypes(i.opts.coerceTypes, f));
            var y,
              v = i.RULES.types[f];
            if (y || C || !0 === v || v && !z(v)) {
              var I = i.schemaPath + ".type",
                b = i.errSchemaPath + "/type",
                I = i.schemaPath + ".type",
                b = i.errSchemaPath + "/type";
              if (t += " if (" + i.util[C ? "checkDataTypes" : "checkDataType"](f, h, i.opts.strictNumbers, !0) + ") { ", y) {
                var A = "dataType" + l,
                  w = "coerced" + l,
                  S = (t += " var " + A + " = typeof " + h + "; var " + w + " = undefined; ", "array" == i.opts.coerceTypes && (t += " if (" + A + " == 'object' && Array.isArray(" + h + ") && " + h + ".length == 1) { " + h + " = " + h + "[0]; " + A + " = typeof " + h + "; if (" + i.util.checkDataType(i.schema.type, h, i.opts.strictNumbers) + ") " + w + " = " + h + "; } "), t += " if (" + w + " !== undefined) ; ", y);
                if (S) for (var x, k = -1, H = S.length - 1; k < H;) "string" == (x = S[k += 1]) ? t += " else if (" + A + " == 'number' || " + A + " == 'boolean') " + w + " = '' + " + h + "; else if (" + h + " === null) " + w + " = ''; " : "number" == x || "integer" == x ? (t += " else if (" + A + " == 'boolean' || " + h + " === null || (" + A + " == 'string' && " + h + " && " + h + " == +" + h + " ", "integer" == x && (t += " && !(" + h + " % 1)"), t += ")) " + w + " = +" + h + "; ") : "boolean" == x ? t += " else if (" + h + " === 'false' || " + h + " === 0 || " + h + " === null) " + w + " = false; else if (" + h + " === 'true' || " + h + " === 1) " + w + " = true; " : "null" == x ? t += " else if (" + h + " === '' || " + h + " === 0 || " + h + " === false) " + w + " = null; " : "array" == i.opts.coerceTypes && "array" == x && (t += " else if (" + A + " == 'string' || " + A + " == 'number' || " + A + " == 'boolean' || " + h + " == null) " + w + " = [" + h + "]; ");
                (B = B || []).push(t += " else {   "), t = "", !1 !== i.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + i.errorPath + " , schemaPath: " + i.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== i.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), i.opts.verbose && (t += " , schema: validate.schema" + I + " , parentSchema: validate.schema" + i.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ";
                var E = t,
                  s = (t = B.pop(), !i.compositeRule && g ? i.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c ? "data" + (c - 1 || "") : "parentData");
                t = t + (" } if (" + w + " !== undefined) {  ") + (" " + h + " = " + w + "; "), c || (t += "if (" + s + " !== undefined)"), t += " " + s + "[" + (c ? i.dataPathArr[c] : "parentDataProperty") + "] = " + w + "; } ";
              } else {
                E = ((B = B || []).push(t), t = "", !1 !== i.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + i.errorPath + " , schemaPath: " + i.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== i.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), i.opts.verbose && (t += " , schema: validate.schema" + I + " , parentSchema: validate.schema" + i.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", t);
                t = B.pop(), !i.compositeRule && g ? i.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
              }
              t += " } ";
            }
          }
          if (i.schema.$ref && !o) t += " " + i.RULES.all.$ref.code(i, "$ref") + " ", g && (t = (t += " } if (errors === ") + (a ? "0" : "errs_" + l) + ") { ", m += "}");else {
            var T = i.RULES;
            if (T) for (var G = -1, P = T.length - 1; G < P;) if (z(v = T[G += 1])) {
              if (v.type && (t += " if (" + i.util.checkDataType(v.type, h, i.opts.strictNumbers) + ") { "), i.opts.useDefaults) if ("object" == v.type && i.schema.properties) {
                var R = i.schema.properties,
                  _ = Object.keys(R);
                if (_) for (var F, V = -1, Z = _.length - 1; V < Z;) if (void 0 !== (N = R[F = _[V += 1]]).default) {
                  var $ = h + i.util.getProperty(F);
                  if (i.compositeRule) {
                    if (i.opts.strictDefaults) {
                      d = "default is ignored for: " + $;
                      if ("log" !== i.opts.strictDefaults) throw new Error(d);
                      i.logger.warn(d);
                    }
                  } else t += " if (" + $ + " === undefined ", "empty" == i.opts.useDefaults && (t += " || " + $ + " === null || " + $ + " === '' "), t += " ) " + $ + " = ", "shared" == i.opts.useDefaults ? t += " " + i.useDefault(N.default) + " " : t += " " + JSON.stringify(N.default) + " ", t += "; ";
                }
              } else if ("array" == v.type && Array.isArray(i.schema.items)) {
                var L = i.schema.items;
                if (L) for (var N, k = -1, O = L.length - 1; k < O;) if (void 0 !== (N = L[k += 1]).default) {
                  $ = h + "[" + k + "]";
                  if (i.compositeRule) {
                    if (i.opts.strictDefaults) {
                      d = "default is ignored for: " + $;
                      if ("log" !== i.opts.strictDefaults) throw new Error(d);
                      i.logger.warn(d);
                    }
                  } else t += " if (" + $ + " === undefined ", "empty" == i.opts.useDefaults && (t += " || " + $ + " === null || " + $ + " === '' "), t += " ) " + $ + " = ", "shared" == i.opts.useDefaults ? t += " " + i.useDefault(N.default) + " " : t += " " + JSON.stringify(N.default) + " ", t += "; ";
                }
              }
              var B,
                D = v.rules;
              if (D) for (var M, K = -1, j = D.length - 1; K < j;) X(M = D[K += 1]) && (M = M.code(i, M.keyword, v.type)) && (t += " " + M + " ", g) && (p += "}");
              g && (t += " " + p + " ", p = ""), v.type && (t += " } ", f) && f === v.type && !y && (t += " else { ", I = i.schemaPath + ".type", b = i.errSchemaPath + "/type", (B = B || []).push(t), t = "", !1 !== i.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + i.errorPath + " , schemaPath: " + i.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== i.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), i.opts.verbose && (t += " , schema: validate.schema" + I + " , parentSchema: validate.schema" + i.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", E = t, t = B.pop(), !i.compositeRule && g ? i.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } "), g && (t = (t += " if (errors === ") + (a ? "0" : "errs_" + l) + ") { ", m += "}");
            }
          }
          g && (t += " " + m + " "), a ? t = t + (n ? " if (errors === 0) return data;            else throw new ValidationError(vErrors); " : " validate.errors = vErrors;  return errors === 0;       ") + " }; return validate;" : t += " var " + u + " = errors === errs_" + l + ";";
        }
        return t;
        function z(e) {
          for (var t = e.rules, n = 0; n < t.length; n++) if (X(t[n])) return 1;
        }
        function X(e) {
          return void 0 !== i.schema[e.keyword] || e.implements && function (e) {
            for (var t = e.implements, n = 0; n < t.length; n++) if (void 0 !== i.schema[t[n]]) return 1;
          }(e);
        }
      };
    },
    7931: function (e, t, n) {
      "use strict";

      var a = /^[a-z_$][a-z0-9_$-]*$/i,
        l = n(1793),
        i = n(5868);
      function o(e, t) {
        o.errors = null;
        var n = (this || _global)._validateKeyword = (this || _global)._validateKeyword || this.compile(i, !0);
        if (n(e)) return !0;
        if (o.errors = n.errors, t) throw new Error("custom keyword definition is invalid: " + this.errorsText(n.errors));
        return !1;
      }
      e.exports = {
        add: function (e, t) {
          var s = (this || _global).RULES;
          if (s.keywords[e]) throw new Error("Keyword " + e + " is already defined");
          if (!a.test(e)) throw new Error("Keyword " + e + " is not a valid identifier");
          if (t) {
            this.validateKeyword(t, !0);
            var n = t.type;
            if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r(e, n[i], t);else r(e, n, t);
            var o = t.metaSchema;
            o && (t.$data && (this || _global)._opts.$data && (o = {
              anyOf: [o, {
                $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
              }]
            }), t.validateSchema = this.compile(o, !0));
          }
          function r(e, t, n) {
            for (var i, o = 0; o < s.length; o++) {
              r = s[o];
              if (r.type == t) {
                i = r;
                break;
              }
            }
            i || s.push(i = {
              type: t,
              rules: []
            });
            n = {
              keyword: e,
              definition: n,
              custom: !0,
              code: l,
              implements: n.implements
            };
            i.rules.push(n), s.custom[e] = n;
          }
          return s.keywords[e] = s.all[e] = !0, this || _global;
        },
        get: function (e) {
          var t = (this || _global).RULES.custom[e];
          return t ? t.definition : (this || _global).RULES.keywords[e] || !1;
        },
        remove: function (e) {
          var t = (this || _global).RULES;
          delete t.keywords[e], delete t.all[e], delete t.custom[e];
          for (var n = 0; n < t.length; n++) for (var i = t[n].rules, o = 0; o < i.length; o++) if (i[o].keyword == e) {
            i.splice(o, 1);
            break;
          }
          return this || _global;
        },
        validate: o
      };
    },
    2303: function (e) {
      "use strict";

      e.exports = function e(t, n) {
        if (t === n) return !0;
        if (t && n && "object" == typeof t && "object" == typeof n) {
          if (t.constructor !== n.constructor) return !1;
          var i, o, r;
          if (Array.isArray(t)) {
            if ((i = t.length) != n.length) return !1;
            for (o = i; 0 != o--;) if (!e(t[o], n[o])) return !1;
          } else {
            if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
            if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
            if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
            if ((i = (r = Object.keys(t)).length) !== Object.keys(n).length) return !1;
            for (o = i; 0 != o--;) if (!Object.prototype.hasOwnProperty.call(n, r[o])) return !1;
            for (o = i; 0 != o--;) {
              var s = r[o];
              if (!e(t[s], n[s])) return !1;
            }
          }
          return !0;
        }
        return t != t && n != n;
      };
    },
    3508: function (e) {
      "use strict";

      e.exports = function (e, t) {
        var i,
          l = "boolean" == typeof (t = "function" == typeof (t = t || {}) ? {
            cmp: t
          } : t).cycles && t.cycles,
          c = t.cmp && (i = t.cmp, function (n) {
            return function (e, t) {
              e = {
                key: e,
                value: n[e]
              }, t = {
                key: t,
                value: n[t]
              };
              return i(e, t);
            };
          }),
          h = [];
        return function e(t) {
          if (void 0 !== (t = t && t.toJSON && "function" == typeof t.toJSON ? t.toJSON() : t)) {
            if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
            if ("object" != typeof t) return JSON.stringify(t);
            if (Array.isArray(t)) {
              for (o = "[", r = 0; r < t.length; r++) r && (o += ","), o += e(t[r]) || "null";
              return o + "]";
            }
            if (null === t) return "null";
            if (-1 !== h.indexOf(t)) {
              if (l) return JSON.stringify("__cycle__");
              throw new TypeError("Converting circular structure to JSON");
            }
            for (var n = h.push(t) - 1, i = Object.keys(t).sort(c && c(t)), o = "", r = 0; r < i.length; r++) {
              var s = i[r],
                a = e(t[s]);
              a && (o && (o += ","), o += JSON.stringify(s) + ":" + a);
            }
            return h.splice(n, 1), "{" + o + "}";
          }
        }(e);
      };
    },
    233: function (e) {
      e.exports = function t(e, n) {
        "use strict";

        function i(e) {
          return t.insensitive && ("" + e).toLowerCase() || "" + e;
        }
        var o,
          r,
          s = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
          a = /(^[ ]*|[ ]*$)/g,
          l = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
          c = /^0x[0-9a-f]+$/i,
          h = /^0/,
          e = i(e).replace(a, "") || "",
          n = i(n).replace(a, "") || "",
          d = e.replace(s, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"),
          u = n.replace(s, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"),
          a = parseInt(e.match(c), 16) || 1 !== d.length && e.match(l) && Date.parse(e),
          s = parseInt(n.match(c), 16) || a && n.match(l) && Date.parse(n) || null;
        if (s) {
          if (a < s) return -1;
          if (s < a) return 1;
        }
        for (var g = 0, p = Math.max(d.length, u.length); g < p; g++) {
          if (o = !(d[g] || "").match(h) && parseFloat(d[g]) || d[g] || 0, r = !(u[g] || "").match(h) && parseFloat(u[g]) || u[g] || 0, isNaN(o) !== isNaN(r)) return isNaN(o) ? 1 : -1;
          if (typeof o != typeof r && (o += "", r += ""), o < r) return -1;
          if (r < o) return 1;
        }
        return 0;
      };
    },
    5156: function (e, t) {
      !function (e) {
        "use strict";

        function w(e) {
          return null !== e && "[object Array]" === Object.prototype.toString.call(e);
        }
        function S(e) {
          return null !== e && "[object Object]" === Object.prototype.toString.call(e);
        }
        function x(e, t) {
          if (e !== t) {
            if (Object.prototype.toString.call(e) !== Object.prototype.toString.call(t)) return !1;
            if (!0 === w(e)) {
              if (e.length !== t.length) return !1;
              for (var n = 0; n < e.length; n++) if (!1 === x(e[n], t[n])) return !1;
            } else {
              if (!0 !== S(e)) return !1;
              var i,
                o,
                r = {};
              for (i in e) if (hasOwnProperty.call(e, i)) {
                if (!1 === x(e[i], t[i])) return !1;
                r[i] = !0;
              }
              for (o in t) if (hasOwnProperty.call(t, o) && !0 !== r[o]) return !1;
            }
          }
          return !0;
        }
        function k(e) {
          if ("" === e || !1 === e || null === e) return !0;
          if (w(e) && 0 === e.length) return !0;
          if (S(e)) {
            for (var t in e) if (e.hasOwnProperty(t)) return !1;
            return !0;
          }
          return !1;
        }
        var o = "function" == typeof String.prototype.trimLeft ? function (e) {
            return e.trimLeft();
          } : function (e) {
            return e.match(/^\s*(.*)/)[1];
          },
          h = {
            0: "number",
            1: "any",
            2: "string",
            3: "array",
            4: "object",
            5: "boolean",
            6: "expression",
            7: "null",
            8: "Array<number>",
            9: "Array<string>"
          },
          s = "UnquotedIdentifier",
          a = "QuotedIdentifier",
          l = "Rbracket",
          c = "Rparen",
          d = "Comma",
          u = "Colon",
          r = "Rbrace",
          g = "Number",
          E = "Current",
          T = "Expref",
          R = "Pipe",
          _ = "Flatten",
          p = "Star",
          m = "Filter",
          f = "Lbrace",
          C = "Lbracket",
          y = "Lparen",
          v = "Literal",
          I = {
            ".": "Dot",
            "*": p,
            ",": d,
            ":": u,
            "{": f,
            "}": r,
            "]": l,
            "(": y,
            ")": c,
            "@": E
          },
          b = {
            "<": !0,
            ">": !0,
            "=": !0,
            "!": !0
          },
          A = {
            " ": !0,
            "\t": !0,
            "\n": !0
          };
        function $(e) {
          return "0" <= e && e <= "9" || "-" === e;
        }
        function n() {}
        n.prototype = {
          tokenize: function (e) {
            var t,
              n,
              i = [];
            for ((this || _global)._current = 0; (this || _global)._current < e.length;) if ("a" <= (r = e[(this || _global)._current]) && r <= "z" || "A" <= r && r <= "Z" || "_" === r) o = (this || _global)._current, t = this._consumeUnquotedIdentifier(e), i.push({
              type: s,
              value: t,
              start: o
            });else if (void 0 !== I[e[(this || _global)._current]]) i.push({
              type: I[e[(this || _global)._current]],
              value: e[(this || _global)._current],
              start: (this || _global)._current
            }), (this || _global)._current++;else if ($(e[(this || _global)._current])) n = this._consumeNumber(e), i.push(n);else if ("[" === e[(this || _global)._current]) n = this._consumeLBracket(e), i.push(n);else if ("\"" === e[(this || _global)._current]) o = (this || _global)._current, t = this._consumeQuotedIdentifier(e), i.push({
              type: a,
              value: t,
              start: o
            });else if ("'" === e[(this || _global)._current]) o = (this || _global)._current, t = this._consumeRawStringLiteral(e), i.push({
              type: v,
              value: t,
              start: o
            });else if ("`" === e[(this || _global)._current]) {
              var o = (this || _global)._current,
                r = this._consumeLiteral(e);
              i.push({
                type: v,
                value: r,
                start: o
              });
            } else if (void 0 !== b[e[(this || _global)._current]]) i.push(this._consumeOperator(e));else if (void 0 !== A[e[(this || _global)._current]]) (this || _global)._current++;else if ("&" === e[(this || _global)._current]) o = (this || _global)._current, (this || _global)._current++, "&" === e[(this || _global)._current] ? ((this || _global)._current++, i.push({
              type: "And",
              value: "&&",
              start: o
            })) : i.push({
              type: T,
              value: "&",
              start: o
            });else {
              if ("|" !== e[(this || _global)._current]) throw (r = new Error("Unknown character:" + e[(this || _global)._current])).name = "LexerError", r;
              o = (this || _global)._current, (this || _global)._current++, "|" === e[(this || _global)._current] ? ((this || _global)._current++, i.push({
                type: "Or",
                value: "||",
                start: o
              })) : i.push({
                type: R,
                value: "|",
                start: o
              });
            }
            return i;
          },
          _consumeUnquotedIdentifier: function (e) {
            var t,
              n = (this || _global)._current;
            for ((this || _global)._current++; (this || _global)._current < e.length && ("a" <= (t = e[(this || _global)._current]) && t <= "z" || "A" <= t && t <= "Z" || "0" <= t && t <= "9" || "_" === t);) (this || _global)._current++;
            return e.slice(n, (this || _global)._current);
          },
          _consumeQuotedIdentifier: function (e) {
            for (var t = (this || _global)._current, n = ((this || _global)._current++, e.length); "\"" !== e[(this || _global)._current] && (this || _global)._current < n;) {
              var i = (this || _global)._current;
              "\\" !== e[i] || "\\" !== e[i + 1] && "\"" !== e[i + 1] ? i++ : i += 2, (this || _global)._current = i;
            }
            return (this || _global)._current++, JSON.parse(e.slice(t, (this || _global)._current));
          },
          _consumeRawStringLiteral: function (e) {
            for (var t = (this || _global)._current, n = ((this || _global)._current++, e.length); "'" !== e[(this || _global)._current] && (this || _global)._current < n;) {
              var i = (this || _global)._current;
              "\\" !== e[i] || "\\" !== e[i + 1] && "'" !== e[i + 1] ? i++ : i += 2, (this || _global)._current = i;
            }
            return (this || _global)._current++, e.slice(t + 1, (this || _global)._current - 1).replace("\\'", "'");
          },
          _consumeNumber: function (e) {
            for (var t = (this || _global)._current, n = ((this || _global)._current++, e.length); $(e[(this || _global)._current]) && (this || _global)._current < n;) (this || _global)._current++;
            var i = parseInt(e.slice(t, (this || _global)._current));
            return {
              type: g,
              value: i,
              start: t
            };
          },
          _consumeLBracket: function (e) {
            var t = (this || _global)._current;
            return (this || _global)._current++, "?" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: m,
              value: "[?",
              start: t
            }) : "]" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: _,
              value: "[]",
              start: t
            }) : {
              type: C,
              value: "[",
              start: t
            };
          },
          _consumeOperator: function (e) {
            var t = (this || _global)._current,
              n = e[t];
            return (this || _global)._current++, "!" === n ? "=" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: "NE",
              value: "!=",
              start: t
            }) : {
              type: "Not",
              value: "!",
              start: t
            } : "<" === n ? "=" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: "LTE",
              value: "<=",
              start: t
            }) : {
              type: "LT",
              value: "<",
              start: t
            } : ">" === n ? "=" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: "GTE",
              value: ">=",
              start: t
            }) : {
              type: "GT",
              value: ">",
              start: t
            } : "=" === n && "=" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: "EQ",
              value: "==",
              start: t
            }) : void 0;
          },
          _consumeLiteral: function (e) {
            (this || _global)._current++;
            for (var t = (this || _global)._current, n = e.length; "`" !== e[(this || _global)._current] && (this || _global)._current < n;) {
              var i = (this || _global)._current;
              "\\" !== e[i] || "\\" !== e[i + 1] && "`" !== e[i + 1] ? i++ : i += 2, (this || _global)._current = i;
            }
            t = (t = o(e.slice(t, (this || _global)._current))).replace("\\`", "`"), t = this._looksLikeJSON(t) ? JSON.parse(t) : JSON.parse("\"" + t + "\"");
            return (this || _global)._current++, t;
          },
          _looksLikeJSON: function (e) {
            if ("" === e) return !1;
            if (0 <= "[{\"".indexOf(e[0])) return !0;
            if (0 <= ["true", "false", "null"].indexOf(e)) return !0;
            if (!(0 <= "-0123456789".indexOf(e[0]))) return !1;
            try {
              return JSON.parse(e), !0;
            } catch (e) {
              return !1;
            }
          }
        };
        var L = {};
        function N() {}
        function B(e) {
          (this || _global).runtime = e;
        }
        function M(e) {
          (this || _global)._interpreter = e, (this || _global).functionTable = {
            abs: {
              _func: (this || _global)._functionAbs,
              _signature: [{
                types: [0]
              }]
            },
            avg: {
              _func: (this || _global)._functionAvg,
              _signature: [{
                types: [8]
              }]
            },
            ceil: {
              _func: (this || _global)._functionCeil,
              _signature: [{
                types: [0]
              }]
            },
            contains: {
              _func: (this || _global)._functionContains,
              _signature: [{
                types: [2, 3]
              }, {
                types: [1]
              }]
            },
            ends_with: {
              _func: (this || _global)._functionEndsWith,
              _signature: [{
                types: [2]
              }, {
                types: [2]
              }]
            },
            floor: {
              _func: (this || _global)._functionFloor,
              _signature: [{
                types: [0]
              }]
            },
            length: {
              _func: (this || _global)._functionLength,
              _signature: [{
                types: [2, 3, 4]
              }]
            },
            map: {
              _func: (this || _global)._functionMap,
              _signature: [{
                types: [6]
              }, {
                types: [3]
              }]
            },
            max: {
              _func: (this || _global)._functionMax,
              _signature: [{
                types: [8, 9]
              }]
            },
            merge: {
              _func: (this || _global)._functionMerge,
              _signature: [{
                types: [4],
                variadic: !0
              }]
            },
            max_by: {
              _func: (this || _global)._functionMaxBy,
              _signature: [{
                types: [3]
              }, {
                types: [6]
              }]
            },
            sum: {
              _func: (this || _global)._functionSum,
              _signature: [{
                types: [8]
              }]
            },
            starts_with: {
              _func: (this || _global)._functionStartsWith,
              _signature: [{
                types: [2]
              }, {
                types: [2]
              }]
            },
            min: {
              _func: (this || _global)._functionMin,
              _signature: [{
                types: [8, 9]
              }]
            },
            min_by: {
              _func: (this || _global)._functionMinBy,
              _signature: [{
                types: [3]
              }, {
                types: [6]
              }]
            },
            type: {
              _func: (this || _global)._functionType,
              _signature: [{
                types: [1]
              }]
            },
            keys: {
              _func: (this || _global)._functionKeys,
              _signature: [{
                types: [4]
              }]
            },
            values: {
              _func: (this || _global)._functionValues,
              _signature: [{
                types: [4]
              }]
            },
            sort: {
              _func: (this || _global)._functionSort,
              _signature: [{
                types: [9, 8]
              }]
            },
            sort_by: {
              _func: (this || _global)._functionSortBy,
              _signature: [{
                types: [3]
              }, {
                types: [6]
              }]
            },
            join: {
              _func: (this || _global)._functionJoin,
              _signature: [{
                types: [2]
              }, {
                types: [9]
              }]
            },
            reverse: {
              _func: (this || _global)._functionReverse,
              _signature: [{
                types: [2, 3]
              }]
            },
            to_array: {
              _func: (this || _global)._functionToArray,
              _signature: [{
                types: [1]
              }]
            },
            to_string: {
              _func: (this || _global)._functionToString,
              _signature: [{
                types: [1]
              }]
            },
            to_number: {
              _func: (this || _global)._functionToNumber,
              _signature: [{
                types: [1]
              }]
            },
            not_null: {
              _func: (this || _global)._functionNotNull,
              _signature: [{
                types: [1],
                variadic: !0
              }]
            }
          };
        }
        L.EOF = 0, L[s] = 0, L[a] = 0, L[l] = 0, L[c] = 0, L[d] = 0, L[r] = 0, L[g] = 0, L[E] = 0, L[T] = 0, L.Pipe = 1, L.Or = 2, L.And = 3, L.EQ = 5, L.GT = 5, L.LT = 5, L.GTE = 5, L.LTE = 5, L.NE = 5, L[_] = 9, L.Star = 20, L[m] = 21, L.Dot = 40, L.Not = 45, L[f] = 50, L[C] = 55, L[y] = 60, N.prototype = {
          parse: function (e) {
            this._loadTokens(e), (this || _global).index = 0;
            var t,
              e = this.expression(0);
            if ("EOF" !== this._lookahead(0)) throw t = this._lookaheadToken(0), (t = new Error("Unexpected token type: " + t.type + ", value: " + t.value)).name = "ParserError", t;
            return e;
          },
          _loadTokens: function (e) {
            var t = new n().tokenize(e);
            t.push({
              type: "EOF",
              value: "",
              start: e.length
            }), (this || _global).tokens = t;
          },
          expression: function (e) {
            for (var t = this._lookaheadToken(0), n = (this._advance(), this.nud(t)), i = this._lookahead(0); e < L[i];) this._advance(), n = this.led(i, n), i = this._lookahead(0);
            return n;
          },
          _lookahead: function (e) {
            return (this || _global).tokens[(this || _global).index + e].type;
          },
          _lookaheadToken: function (e) {
            return (this || _global).tokens[(this || _global).index + e];
          },
          _advance: function () {
            (this || _global).index++;
          },
          nud: function (e) {
            var t, n;
            switch (e.type) {
              case v:
                return {
                  type: "Literal",
                  value: e.value
                };
              case s:
                return {
                  type: "Field",
                  name: e.value
                };
              case a:
                var i = {
                  type: "Field",
                  name: e.value
                };
                if (this._lookahead(0) === y) throw new Error("Quoted identifier not allowed for function names.");
                return i;
              case "Not":
                return {
                  type: "NotExpression",
                  children: [t = this.expression(L.Not)]
                };
              case p:
                return t = null, {
                  type: "ValueProjection",
                  children: [{
                    type: "Identity"
                  }, t = this._lookahead(0) === l ? {
                    type: "Identity"
                  } : this._parseProjectionRHS(L.Star)]
                };
              case m:
                return this.led(e.type, {
                  type: "Identity"
                });
              case f:
                return this._parseMultiselectHash();
              case _:
                return {
                  type: "Projection",
                  children: [{
                    type: _,
                    children: [{
                      type: "Identity"
                    }]
                  }, t = this._parseProjectionRHS(L.Flatten)]
                };
              case C:
                return this._lookahead(0) === g || this._lookahead(0) === u ? (t = this._parseIndexExpression(), this._projectIfSlice({
                  type: "Identity"
                }, t)) : this._lookahead(0) === p && this._lookahead(1) === l ? (this._advance(), this._advance(), {
                  type: "Projection",
                  children: [{
                    type: "Identity"
                  }, t = this._parseProjectionRHS(L.Star)]
                }) : this._parseMultiselectList();
              case E:
                return {
                  type: E
                };
              case T:
                return {
                  type: "ExpressionReference",
                  children: [n = this.expression(L.Expref)]
                };
              case y:
                for (var o = []; this._lookahead(0) !== c;) this._lookahead(0) === E ? (n = {
                  type: E
                }, this._advance()) : n = this.expression(0), o.push(n);
                return this._match(c), o[0];
              default:
                this._errorToken(e);
            }
          },
          led: function (e, t) {
            var n;
            switch (e) {
              case "Dot":
                var i = L.Dot;
                return this._lookahead(0) !== p ? {
                  type: "Subexpression",
                  children: [t, n = this._parseDotRHS(i)]
                } : (this._advance(), {
                  type: "ValueProjection",
                  children: [t, n = this._parseProjectionRHS(i)]
                });
              case R:
                return n = this.expression(L.Pipe), {
                  type: R,
                  children: [t, n]
                };
              case "Or":
                return {
                  type: "OrExpression",
                  children: [t, n = this.expression(L.Or)]
                };
              case "And":
                return {
                  type: "AndExpression",
                  children: [t, n = this.expression(L.And)]
                };
              case y:
                for (var o, i = t.name, r = []; this._lookahead(0) !== c;) this._lookahead(0) === E ? (o = {
                  type: E
                }, this._advance()) : o = this.expression(0), this._lookahead(0) === d && this._match(d), r.push(o);
                return this._match(c), {
                  type: "Function",
                  name: i,
                  children: r
                };
              case m:
                i = this.expression(0);
                return this._match(l), {
                  type: "FilterProjection",
                  children: [t, n = this._lookahead(0) === _ ? {
                    type: "Identity"
                  } : this._parseProjectionRHS(L.Filter), i]
                };
              case _:
                return {
                  type: "Projection",
                  children: [{
                    type: _,
                    children: [t]
                  }, this._parseProjectionRHS(L.Flatten)]
                };
              case "EQ":
              case "NE":
              case "GT":
              case "GTE":
              case "LT":
              case "LTE":
                return this._parseComparator(t, e);
              case C:
                i = this._lookaheadToken(0);
                return i.type === g || i.type === u ? (n = this._parseIndexExpression(), this._projectIfSlice(t, n)) : (this._match(p), this._match(l), {
                  type: "Projection",
                  children: [t, n = this._parseProjectionRHS(L.Star)]
                });
              default:
                this._errorToken(this._lookaheadToken(0));
            }
          },
          _match: function (e) {
            var t;
            if (this._lookahead(0) !== e) throw t = this._lookaheadToken(0), (e = new Error("Expected " + e + ", got: " + t.type)).name = "ParserError", e;
            this._advance();
          },
          _errorToken: function (e) {
            e = new Error("Invalid token (" + e.type + "): \"" + e.value + "\"");
            throw e.name = "ParserError", e;
          },
          _parseIndexExpression: function () {
            var e;
            return this._lookahead(0) === u || this._lookahead(1) === u ? this._parseSliceExpression() : (e = {
              type: "Index",
              value: this._lookaheadToken(0).value
            }, this._advance(), this._match(l), e);
          },
          _projectIfSlice: function (e, t) {
            e = {
              type: "IndexExpression",
              children: [e, t]
            };
            return "Slice" === t.type ? {
              type: "Projection",
              children: [e, this._parseProjectionRHS(L.Star)]
            } : e;
          },
          _parseSliceExpression: function () {
            for (var e, t = [null, null, null], n = 0, i = this._lookahead(0); i !== l && n < 3;) {
              if (i === u) n++;else {
                if (i !== g) throw e = this._lookahead(0), (e = new Error("Syntax error, unexpected token: " + e.value + "(" + e.type + ")")).name = "Parsererror", e;
                t[n] = this._lookaheadToken(0).value;
              }
              this._advance(), i = this._lookahead(0);
            }
            return this._match(l), {
              type: "Slice",
              children: t
            };
          },
          _parseComparator: function (e, t) {
            return {
              type: "Comparator",
              name: t,
              children: [e, this.expression(L[t])]
            };
          },
          _parseDotRHS: function (e) {
            var t = this._lookahead(0);
            return 0 <= [s, a, p].indexOf(t) ? this.expression(e) : t === C ? (this._match(C), this._parseMultiselectList()) : t === f ? (this._match(f), this._parseMultiselectHash()) : void 0;
          },
          _parseProjectionRHS: function (e) {
            var t, n;
            if (L[this._lookahead(0)] < 10) t = {
              type: "Identity"
            };else if (this._lookahead(0) === C) t = this.expression(e);else if (this._lookahead(0) === m) t = this.expression(e);else {
              if ("Dot" !== this._lookahead(0)) throw n = this._lookaheadToken(0), (n = new Error("Sytanx error, unexpected token: " + n.value + "(" + n.type + ")")).name = "ParserError", n;
              this._match("Dot"), t = this._parseDotRHS(e);
            }
            return t;
          },
          _parseMultiselectList: function () {
            for (var e = []; this._lookahead(0) !== l;) {
              var t = this.expression(0);
              if (e.push(t), this._lookahead(0) === d && (this._match(d), this._lookahead(0) === l)) throw new Error("Unexpected token Rbracket");
            }
            return this._match(l), {
              type: "MultiSelectList",
              children: e
            };
          },
          _parseMultiselectHash: function () {
            for (var e, t, n = [], i = [s, a];;) {
              if (e = this._lookaheadToken(0), i.indexOf(e.type) < 0) throw new Error("Expecting an identifier token, got: " + e.type);
              if (e = e.value, this._advance(), this._match(u), t = this.expression(0), n.push({
                type: "KeyValuePair",
                name: e,
                value: t
              }), this._lookahead(0) === d) this._match(d);else if (this._lookahead(0) === r) {
                this._match(r);
                break;
              }
            }
            return {
              type: "MultiSelectHash",
              children: n
            };
          }
        }, B.prototype = {
          search: function (e, t) {
            return this.visit(e, t);
          },
          visit: function (e, t) {
            var n, i, o, r, s, a;
            switch (e.type) {
              case "Field":
                return null !== t && S(t) ? void 0 === (l = t[e.name]) ? null : l : null;
              case "Subexpression":
                for (u = this.visit(e.children[0], t), f = 1; f < e.children.length; f++) if (null === (u = this.visit(e.children[1], u))) return null;
                return u;
              case "IndexExpression":
                return s = this.visit(e.children[0], t), this.visit(e.children[1], s);
              case "Index":
                return w(t) ? void 0 === (u = t[l = (l = e.value) < 0 ? t.length + l : l]) ? null : u : null;
              case "Slice":
                if (!w(t)) return null;
                var l = e.children.slice(0),
                  l = this.computeSliceParams(t.length, l),
                  c = l[0],
                  h = l[1],
                  d = l[2],
                  u = [];
                if (0 < d) for (f = c; f < h; f += d) u.push(t[f]);else for (f = c; h < f; f += d) u.push(t[f]);
                return u;
              case "Projection":
                var g = this.visit(e.children[0], t);
                if (!w(g)) return null;
                for (p = [], f = 0; f < g.length; f++) null !== (i = this.visit(e.children[1], g[f])) && p.push(i);
                return p;
              case "ValueProjection":
                if (!S(g = this.visit(e.children[0], t))) return null;
                for (var p = [], m = function (e) {
                    for (var t = Object.keys(e), n = [], i = 0; i < t.length; i++) n.push(e[t[i]]);
                    return n;
                  }(g), f = 0; f < m.length; f++) null !== (i = this.visit(e.children[1], m[f])) && p.push(i);
                return p;
              case "FilterProjection":
                if (!w(g = this.visit(e.children[0], t))) return null;
                var C = [],
                  y = [];
                for (f = 0; f < g.length; f++) k(n = this.visit(e.children[2], g[f])) || C.push(g[f]);
                for (var v = 0; v < C.length; v++) null !== (i = this.visit(e.children[1], C[v])) && y.push(i);
                return y;
              case "Comparator":
                switch (o = this.visit(e.children[0], t), r = this.visit(e.children[1], t), e.name) {
                  case "EQ":
                    u = x(o, r);
                    break;
                  case "NE":
                    u = !x(o, r);
                    break;
                  case "GT":
                    u = r < o;
                    break;
                  case "GTE":
                    u = r <= o;
                    break;
                  case "LT":
                    u = o < r;
                    break;
                  case "LTE":
                    u = o <= r;
                    break;
                  default:
                    throw new Error("Unknown comparator: " + e.name);
                }
                return u;
              case _:
                var I = this.visit(e.children[0], t);
                if (!w(I)) return null;
                var b = [];
                for (f = 0; f < I.length; f++) w(i = I[f]) ? b.push.apply(b, i) : b.push(i);
                return b;
              case "Identity":
                return t;
              case "MultiSelectList":
                if (null === t) return null;
                for (p = [], f = 0; f < e.children.length; f++) p.push(this.visit(e.children[f], t));
                return p;
              case "MultiSelectHash":
                if (null === t) return null;
                for (p = {}, f = 0; f < e.children.length; f++) p[(a = e.children[f]).name] = this.visit(a.value, t);
                return p;
              case "OrExpression":
                return n = k(n = this.visit(e.children[0], t)) ? this.visit(e.children[1], t) : n;
              case "AndExpression":
                return !0 === k(o = this.visit(e.children[0], t)) ? o : this.visit(e.children[1], t);
              case "NotExpression":
                return k(o = this.visit(e.children[0], t));
              case "Literal":
                return e.value;
              case R:
                return s = this.visit(e.children[0], t), this.visit(e.children[1], s);
              case E:
                return t;
              case "Function":
                var A = [];
                for (f = 0; f < e.children.length; f++) A.push(this.visit(e.children[f], t));
                return (this || _global).runtime.callFunction(e.name, A);
              case "ExpressionReference":
                l = e.children[0];
                return l.jmespathType = T, l;
              default:
                throw new Error("Unknown node type: " + e.type);
            }
          },
          computeSliceParams: function (e, t) {
            var n = t[0],
              i = t[1],
              t = t[2],
              o = [null, null, null];
            if (null === t) t = 1;else if (0 === t) throw (r = new Error("Invalid slice, step cannot be 0")).name = "RuntimeError", r;
            var r = t < 0,
              n = null === n ? r ? e - 1 : 0 : this.capSliceRange(e, n, t),
              i = null === i ? r ? -1 : e : this.capSliceRange(e, i, t);
            return o[0] = n, o[1] = i, o[2] = t, o;
          },
          capSliceRange: function (e, t, n) {
            return t < 0 ? (t += e) < 0 && (t = n < 0 ? -1 : 0) : e <= t && (t = n < 0 ? e - 1 : e), t;
          }
        }, M.prototype = {
          callFunction: function (e, t) {
            var n = (this || _global).functionTable[e];
            if (void 0 === n) throw new Error("Unknown function: " + e + "()");
            return this._validateArgs(e, t, n._signature), n._func.call(this || _global, t);
          },
          _validateArgs: function (e, t, n) {
            var i;
            if (n[n.length - 1].variadic) {
              if (t.length < n.length) throw i = 1 === n.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes at least" + n.length + i + " but received " + t.length);
            } else if (t.length !== n.length) throw i = 1 === n.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes " + n.length + i + " but received " + t.length);
            for (var o = 0; o < n.length; o++) {
              for (var r, s = !1, a = n[o].types, l = this._getTypeName(t[o]), c = 0; c < a.length; c++) if (this._typeMatches(l, a[c], t[o])) {
                s = !0;
                break;
              }
              if (!s) throw r = a.map(function (e) {
                return h[e];
              }).join(","), new Error("TypeError: " + e + "() expected argument " + (o + 1) + " to be type " + r + " but received type " + h[l] + " instead.");
            }
          },
          _typeMatches: function (e, t, n) {
            if (1 === t) return !0;
            if (9 !== t && 8 !== t && 3 !== t) return e === t;
            if (3 === t) return 3 === e;
            if (3 === e) {
              var i;
              8 === t ? i = 0 : 9 === t && (i = 2);
              for (var o = 0; o < n.length; o++) if (!this._typeMatches(this._getTypeName(n[o]), i, n[o])) return !1;
              return !0;
            }
          },
          _getTypeName: function (e) {
            switch (Object.prototype.toString.call(e)) {
              case "[object String]":
                return 2;
              case "[object Number]":
                return 0;
              case "[object Array]":
                return 3;
              case "[object Boolean]":
                return 5;
              case "[object Null]":
                return 7;
              case "[object Object]":
                return e.jmespathType === T ? 6 : 4;
            }
          },
          _functionStartsWith: function (e) {
            return 0 === e[0].lastIndexOf(e[1]);
          },
          _functionEndsWith: function (e) {
            var t = e[0],
              e = e[1];
            return -1 !== t.indexOf(e, t.length - e.length);
          },
          _functionReverse: function (e) {
            var t;
            if (2 !== this._getTypeName(e[0])) return (t = e[0].slice(0)).reverse(), t;
            for (var n = e[0], i = "", o = n.length - 1; 0 <= o; o--) i += n[o];
            return i;
          },
          _functionAbs: function (e) {
            return Math.abs(e[0]);
          },
          _functionCeil: function (e) {
            return Math.ceil(e[0]);
          },
          _functionAvg: function (e) {
            for (var t = 0, n = e[0], i = 0; i < n.length; i++) t += n[i];
            return t / n.length;
          },
          _functionContains: function (e) {
            return 0 <= e[0].indexOf(e[1]);
          },
          _functionFloor: function (e) {
            return Math.floor(e[0]);
          },
          _functionLength: function (e) {
            return (S(e[0]) ? Object.keys(e[0]) : e[0]).length;
          },
          _functionMap: function (e) {
            for (var t = [], n = (this || _global)._interpreter, i = e[0], o = e[1], r = 0; r < o.length; r++) t.push(n.visit(i, o[r]));
            return t;
          },
          _functionMerge: function (e) {
            for (var t = {}, n = 0; n < e.length; n++) {
              var i,
                o = e[n];
              for (i in o) t[i] = o[i];
            }
            return t;
          },
          _functionMax: function (e) {
            if (0 < e[0].length) {
              if (0 === this._getTypeName(e[0][0])) return Math.max.apply(Math, e[0]);
              for (var t = e[0], n = t[0], i = 1; i < t.length; i++) n.localeCompare(t[i]) < 0 && (n = t[i]);
              return n;
            }
            return null;
          },
          _functionMin: function (e) {
            if (0 < e[0].length) {
              if (0 === this._getTypeName(e[0][0])) return Math.min.apply(Math, e[0]);
              for (var t = e[0], n = t[0], i = 1; i < t.length; i++) t[i].localeCompare(n) < 0 && (n = t[i]);
              return n;
            }
            return null;
          },
          _functionSum: function (e) {
            for (var t = 0, n = e[0], i = 0; i < n.length; i++) t += n[i];
            return t;
          },
          _functionType: function (e) {
            switch (this._getTypeName(e[0])) {
              case 0:
                return "number";
              case 2:
                return "string";
              case 3:
                return "array";
              case 4:
                return "object";
              case 5:
                return "boolean";
              case 6:
                return "expref";
              case 7:
                return "null";
            }
          },
          _functionKeys: function (e) {
            return Object.keys(e[0]);
          },
          _functionValues: function (e) {
            for (var t = e[0], n = Object.keys(t), i = [], o = 0; o < n.length; o++) i.push(t[n[o]]);
            return i;
          },
          _functionJoin: function (e) {
            var t = e[0];
            return e[1].join(t);
          },
          _functionToArray: function (e) {
            return 3 === this._getTypeName(e[0]) ? e[0] : [e[0]];
          },
          _functionToString: function (e) {
            return 2 === this._getTypeName(e[0]) ? e[0] : JSON.stringify(e[0]);
          },
          _functionToNumber: function (e) {
            var t = this._getTypeName(e[0]);
            return 0 === t ? e[0] : 2 !== t || (t = +e[0], isNaN(t)) ? null : t;
          },
          _functionNotNull: function (e) {
            for (var t = 0; t < e.length; t++) if (7 !== this._getTypeName(e[t])) return e[t];
            return null;
          },
          _functionSort: function (e) {
            e = e[0].slice(0);
            return e.sort(), e;
          },
          _functionSortBy: function (e) {
            var t = e[0].slice(0);
            if (0 !== t.length) {
              var o = (this || _global)._interpreter,
                r = e[1],
                s = this._getTypeName(o.visit(r, t[0]));
              if ([0, 2].indexOf(s) < 0) throw new Error("TypeError");
              for (var a = this || _global, n = [], i = 0; i < t.length; i++) n.push([i, t[i]]);
              n.sort(function (e, t) {
                var n = o.visit(r, e[1]),
                  i = o.visit(r, t[1]);
                if (a._getTypeName(n) !== s) throw new Error("TypeError: expected " + s + ", received " + a._getTypeName(n));
                if (a._getTypeName(i) !== s) throw new Error("TypeError: expected " + s + ", received " + a._getTypeName(i));
                return i < n ? 1 : n < i ? -1 : e[0] - t[0];
              });
              for (var l = 0; l < n.length; l++) t[l] = n[l][1];
            }
            return t;
          },
          _functionMaxBy: function (e) {
            for (var t, n, i = e[1], o = e[0], r = this.createKeyFunction(i, [0, 2]), s = -1 / 0, a = 0; a < o.length; a++) s < (n = r(o[a])) && (s = n, t = o[a]);
            return t;
          },
          _functionMinBy: function (e) {
            for (var t, n, i = e[1], o = e[0], r = this.createKeyFunction(i, [0, 2]), s = 1 / 0, a = 0; a < o.length; a++) (n = r(o[a])) < s && (s = n, t = o[a]);
            return t;
          },
          createKeyFunction: function (n, i) {
            var o = this || _global,
              r = (this || _global)._interpreter;
            return function (e) {
              var t,
                e = r.visit(n, e);
              if (i.indexOf(o._getTypeName(e)) < 0) throw t = "TypeError: expected one of " + i + ", received " + o._getTypeName(e), new Error(t);
              return e;
            };
          }
        }, e.tokenize = function (e) {
          return new n().tokenize(e);
        }, e.compile = function (e) {
          return new N().parse(e);
        }, e.search = function (e, t) {
          var n = new N(),
            i = new B(o = new M()),
            o = (o._interpreter = i, n.parse(t));
          return i.search(o, e);
        }, e.strictDeepEqual = x;
      }(t);
    },
    500: function (e) {
      "use strict";

      var m = e.exports = function (e, t, n) {
        "function" == typeof t && (n = t, t = {}), function e(t, n, i, o, r, s, a, l, c, h) {
          if (o && "object" == typeof o && !Array.isArray(o)) {
            for (var d in n(o, r, s, a, l, c, h), o) {
              var u = o[d];
              if (Array.isArray(u)) {
                if (d in m.arrayKeywords) for (var g = 0; g < u.length; g++) e(t, n, i, u[g], r + "/" + d + "/" + g, s, r, d, o, g);
              } else if (d in m.propsKeywords) {
                if (u && "object" == typeof u) for (var p in u) e(t, n, i, u[p], r + "/" + d + "/" + f(p), s, r, d, o, p);
              } else (d in m.keywords || t.allKeys && !(d in m.skipKeywords)) && e(t, n, i, u, r + "/" + d, s, r, d, o);
            }
            i(o, r, s, a, l, c, h);
          }
        }(t, "function" == typeof (n = t.cb || n) ? n : n.pre || function () {}, n.post || function () {}, e, "", e);
      };
      function f(e) {
        return e.replace(/~/g, "~0").replace(/\//g, "~1");
      }
      m.keywords = {
        additionalItems: !0,
        items: !0,
        contains: !0,
        additionalProperties: !0,
        propertyNames: !0,
        not: !0
      }, m.arrayKeywords = {
        items: !0,
        allOf: !0,
        anyOf: !0,
        oneOf: !0
      }, m.propsKeywords = {
        definitions: !0,
        properties: !0,
        patternProperties: !0,
        dependencies: !0
      }, m.skipKeywords = {
        default: !0,
        enum: !0,
        const: !0,
        required: !0,
        maximum: !0,
        minimum: !0,
        exclusiveMaximum: !0,
        exclusiveMinimum: !0,
        multipleOf: !0,
        maxLength: !0,
        minLength: !0,
        pattern: !0,
        format: !0,
        maxItems: !0,
        minItems: !0,
        uniqueItems: !0,
        maxProperties: !0,
        minProperties: !0
      };
    },
    7026: function (e, t) {
      "use strict";

      var b = {
          b: "\b",
          f: "\f",
          n: "\n",
          r: "\r",
          t: "\t",
          "\"": "\"",
          "/": "/",
          "\\": "\\"
        },
        A = "a".charCodeAt(),
        n = (t.parse = function (o, e, t) {
          var i = {},
            n = 0,
            r = 0,
            s = 0,
            a = t && t.bigint && "undefined" != typeof BigInt;
          return {
            data: l("", !0),
            pointers: i
          };
          function l(e, t) {
            c(), m(e, "value");
            var n,
              i = u();
            switch (i) {
              case "t":
                d("rue"), n = !0;
                break;
              case "f":
                d("alse"), n = !1;
                break;
              case "n":
                d("ull"), n = null;
                break;
              case "\"":
                n = h();
                break;
              case "[":
                n = function (e) {
                  c();
                  var t = [],
                    n = 0;
                  if ("]" != u()) for (g();;) {
                    t.push(l(e + "/" + n)), c();
                    var i = u();
                    if ("]" == i) break;
                    "," != i && v(), c(), n++;
                  }
                  return t;
                }(e);
                break;
              case "{":
                n = function (e) {
                  c();
                  var t = {};
                  if ("}" != u()) for (g();;) {
                    var n = C(),
                      i = ("\"" != u() && v(), h()),
                      o = e + "/" + w(i),
                      n = (f(o, "key", n), m(o, "keyEnd"), c(), ":" != u() && v(), c(), t[i] = l(o), c(), u());
                    if ("}" == n) break;
                    "," != n && v(), c();
                  }
                  return t;
                }(e);
                break;
              default:
                g(), 0 <= "-0123456789".indexOf(i) ? n = function () {
                  var e = "",
                    t = !0;
                  "-" == o[s] && (e += u());
                  e += ("0" == o[s] ? u : p)(), "." == o[s] && (e += u() + p(), t = !1);
                  "e" != o[s] && "E" != o[s] || (e += u(), "+" != o[s] && "-" != o[s] || (e += u()), e += p(), t = !1);
                  var n = +e;
                  return a && t && (n > Number.MAX_SAFE_INTEGER || n < Number.MIN_SAFE_INTEGER) ? BigInt(e) : n;
                }() : y();
            }
            return m(e, "valueEnd"), c(), t && s < o.length && y(), n;
          }
          function c() {
            e: for (; s < o.length;) {
              switch (o[s]) {
                case " ":
                  r++;
                  break;
                case "\t":
                  r += 4;
                  break;
                case "\r":
                  r = 0;
                  break;
                case "\n":
                  r = 0, n++;
                  break;
                default:
                  break e;
              }
              s++;
            }
          }
          function h() {
            for (var e, t = ""; "\"" != (e = u());) "\\" == e ? (e = u()) in b ? t += b[e] : "u" == e ? t += function () {
              var e = 4,
                t = 0;
              for (; e--;) {
                t <<= 4;
                var n = u().toLowerCase();
                "a" <= n && n <= "f" ? t += n.charCodeAt() - A + 10 : "0" <= n && n <= "9" ? t += +n : v();
              }
              return String.fromCharCode(t);
            }() : v() : t += e;
            return t;
          }
          function d(e) {
            for (var t = 0; t < e.length; t++) u() !== e[t] && v();
          }
          function u() {
            I();
            var e = o[s];
            return s++, r++, e;
          }
          function g() {
            s--, r--;
          }
          function p() {
            for (var e = ""; "0" <= o[s] && o[s] <= "9";) e += u();
            if (e.length) return e;
            I(), y();
          }
          function m(e, t) {
            f(e, t, C());
          }
          function f(e, t, n) {
            i[e] = i[e] || {}, i[e][t] = n;
          }
          function C() {
            return {
              line: n,
              column: r,
              pos: s
            };
          }
          function y() {
            throw new SyntaxError("Unexpected token " + o[s] + " in JSON at position " + s);
          }
          function v() {
            g(), y();
          }
          function I() {
            if (s >= o.length) throw new SyntaxError("Unexpected end of JSON input");
          }
        }, t.stringify = function (e, t, n) {
          if (v(e)) {
            var i = 0;
            switch (typeof (u = "object" == typeof n ? n.space : n)) {
              case "number":
                var o = 10 < u ? 10 : u < 0 ? 0 : Math.floor(u),
                  u = o && y(o, " "),
                  r = o,
                  s = o;
                break;
              case "string":
                u = u.slice(0, 10);
                for (var a = s = r = 0; a < u.length; a++) {
                  switch (u[a]) {
                    case " ":
                      s++;
                      break;
                    case "\t":
                      s += 4;
                      break;
                    case "\r":
                      s = 0;
                      break;
                    case "\n":
                      s = 0, i++;
                      break;
                    default:
                      throw new Error("whitespace characters not allowed in JSON");
                  }
                  r++;
                }
                break;
              default:
                u = void 0;
            }
            var l = "",
              c = {},
              h = 0,
              d = 0,
              g = 0,
              p = n && n.es6 && "function" == typeof Map;
            return function l(c, h, d) {
              C(d, "value");
              switch (typeof c) {
                case "number":
                case "bigint":
                case "boolean":
                  m("" + c);
                  break;
                case "string":
                  m(I(c));
                  break;
                case "object":
                  null === c ? m("null") : "function" == typeof c.toJSON ? m(I(c.toJSON())) : Array.isArray(c) ? e() : p ? c.constructor.BYTES_PER_ELEMENT ? e() : c instanceof Map ? n() : c instanceof Set ? n(!0) : t() : t();
              }
              C(d, "valueEnd");
              function e() {
                if (c.length) {
                  m("[");
                  for (var e = h + 1, t = 0; t < c.length; t++) {
                    t && m(","), f(e);
                    var n = v(c[t]) ? c[t] : null,
                      i = d + "/" + t;
                    l(n, e, i);
                  }
                  f(h), m("]");
                } else m("[]");
              }
              function t() {
                var e = Object.keys(c);
                if (e.length) {
                  m("{");
                  for (var t = h + 1, n = 0; n < e.length; n++) {
                    var i,
                      o = e[n],
                      r = c[o];
                    v(r) && (n && m(","), i = d + "/" + w(o), f(t), C(i, "key"), m(I(o)), C(i, "keyEnd"), m(":"), u && m(" "), l(r, t, i));
                  }
                  f(h), m("}");
                } else m("{}");
              }
              function n(e) {
                if (c.size) {
                  m("{");
                  for (var t = h + 1, n = !0, i = c.entries(), o = i.next(); !o.done;) {
                    var r,
                      s = o.value,
                      a = s[0],
                      s = !!e || s[1];
                    v(s) && (n || m(","), n = !1, r = d + "/" + w(a), f(t), C(r, "key"), m(I(a)), C(r, "keyEnd"), m(":"), u && m(" "), l(s, t, r)), o = i.next();
                  }
                  f(h), m("}");
                } else m("{}");
              }
            }(e, 0, ""), {
              json: l,
              pointers: c
            };
          }
          function m(e) {
            d += e.length, g += e.length, l += e;
          }
          function f(e) {
            if (u) {
              for (l += "\n" + y(e, u), h++, d = 0; e--;) i ? (h += i, d = s) : d += s, g += r;
              g += 1;
            }
          }
          function C(e, t) {
            c[e] = c[e] || {}, c[e][t] = {
              line: h,
              column: d,
              pos: g
            };
          }
          function y(e, t) {
            return Array(e + 1).join(t);
          }
        }, ["number", "bigint", "boolean", "string", "object"]);
      function v(e) {
        return 0 <= n.indexOf(typeof e);
      }
      var i = /"|\\/g,
        o = /[\b]/g,
        r = /\f/g,
        s = /\n/g,
        a = /\r/g,
        l = /\t/g;
      function I(e) {
        return "\"" + (e = e.replace(i, "\\$&").replace(r, "\\f").replace(o, "\\b").replace(s, "\\n").replace(a, "\\r").replace(l, "\\t")) + "\"";
      }
      var c = /~/g,
        h = /\//g;
      function w(e) {
        return e.replace(c, "~0").replace(h, "~1");
      }
    },
    483: function (e, t) {
      var n, i;
      !function () {
        "use strict";

        i = [], void 0 !== (i = "function" == typeof (n = function () {
          "use strict";

          function C(e) {
            if (typeof Node === "object") return e instanceof Node;else return e && typeof e === "object" && typeof e.nodeType === "number";
          }
          function y(e) {
            return typeof e === "string";
          }
          function v() {
            var r = [];
            return {
              watch: r.push.bind(r),
              trigger: function (e, t) {
                var n = true;
                var i = {
                  detail: t,
                  preventDefault: function e() {
                    n = false;
                  }
                };
                for (var o = 0; o < r.length; o++) r[o](e, i);
                return n;
              }
            };
          }
          function o(e) {
            return window.getComputedStyle(e).display === "none";
          }
          function r(e) {
            (this || _global).elem = e;
          }
          function I(e, t) {
            return r.make(e("parent")).clazz("pico-overlay").clazz(e("overlayClass", "")).stylize({
              display: "none",
              position: "fixed",
              top: "0px",
              left: "0px",
              height: "100%",
              width: "100%",
              zIndex: 10000
            }).stylize(e("overlayStyles", {
              opacity: 0.5,
              background: "#000"
            })).onClick(function () {
              if (e("overlayClose", true)) t();
            });
          }
          r.make = function (e, t) {
            if (typeof e === "string") e = document.querySelector(e);
            var n = document.createElement(t || "div");
            (e || document.body).appendChild(n);
            return new r(n);
          }, r.prototype = {
            child: function (e) {
              return r.make((this || _global).elem, e);
            },
            stylize: function (e) {
              e = e || {};
              if (typeof e.opacity !== "undefined") e.filter = "alpha(opacity=" + e.opacity * 100 + ")";
              for (var t in e) if (e.hasOwnProperty(t)) (this || _global).elem.style[t] = e[t];
              return this || _global;
            },
            clazz: function (e) {
              (this || _global).elem.className += " " + e;
              return this || _global;
            },
            html: function (e) {
              if (C(e)) (this || _global).elem.appendChild(e);else (this || _global).elem.innerHTML = e;
              return this || _global;
            },
            onClick: function (e) {
              (this || _global).elem.addEventListener("click", e);
              return this || _global;
            },
            destroy: function () {
              (this || _global).elem.parentNode.removeChild((this || _global).elem);
            },
            hide: function () {
              (this || _global).elem.style.display = "none";
            },
            show: function () {
              (this || _global).elem.style.display = "block";
            },
            attr: function (e, t) {
              if (t !== undefined) (this || _global).elem.setAttribute(e, t);
              return this || _global;
            },
            anyAncestor: function (e) {
              var t = (this || _global).elem;
              while (t) if (e(new r(t))) return true;else t = t.parentNode;
              return false;
            },
            isVisible: function () {
              return !o((this || _global).elem);
            }
          };
          var s = 1;
          function b(e, n) {
            var t = e("width", "auto");
            if (typeof t === "number") t = "" + t + "px";
            var i = e("modalId", "pico-" + s++);
            var o = r.make(e("parent")).clazz("pico-content").clazz(e("modalClass", "")).stylize({
              display: "none",
              position: "fixed",
              zIndex: 10001,
              left: "50%",
              top: "38.1966%",
              maxHeight: "90%",
              boxSizing: "border-box",
              width: t,
              "-ms-transform": "translate(-50%,-38.1966%)",
              "-moz-transform": "translate(-50%,-38.1966%)",
              "-webkit-transform": "translate(-50%,-38.1966%)",
              "-o-transform": "translate(-50%,-38.1966%)",
              transform: "translate(-50%,-38.1966%)"
            }).stylize(e("modalStyles", {
              overflow: "auto",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "5px"
            })).html(e("content")).attr("id", i).attr("role", "dialog").attr("aria-labelledby", e("ariaLabelledBy")).attr("aria-describedby", e("ariaDescribedBy", i)).onClick(function (e) {
              var t = new r(e.target).anyAncestor(function (e) {
                return /\bpico-close\b/.test(e.elem.className);
              });
              if (t) n();
            });
            return o;
          }
          function A(e, t) {
            if (t("closeButton", true)) return e.child("button").html(t("closeHtml", "&#xD7;")).clazz("pico-close").clazz(t("closeClass", "")).stylize(t("closeStyles", {
              borderRadius: "2px",
              border: 0,
              padding: 0,
              cursor: "pointer",
              height: "15px",
              width: "15px",
              position: "absolute",
              top: "5px",
              right: "5px",
              fontSize: "16px",
              textAlign: "center",
              lineHeight: "15px",
              background: "#CCC"
            })).attr("aria-label", t("close-label", "Close"));
          }
          function w(e) {
            return function () {
              return e().elem;
            };
          }
          var S = v(),
            c = v();
          function x(r, s) {
            function t(e, t) {
              var n = e.msMatchesSelector || e.webkitMatchesSelector || e.matches;
              return n.call(e, t);
            }
            function i(e) {
              if (o(e) || t(e, ":disabled") || e.hasAttribute("contenteditable")) return false;else return e.hasAttribute("tabindex") || t(e, "input,select,textarea,button,a[href],area[href],iframe");
            }
            function a(e) {
              var t = e.getElementsByTagName("*");
              for (var n = 0; n < t.length; n++) if (i(t[n])) return t[n];
            }
            function l(e) {
              var t = e.getElementsByTagName("*");
              for (var n = t.length; n--;) if (i(t[n])) return t[n];
            }
            var n;
            r.beforeShow(function e() {
              n = document.activeElement;
            });
            r.afterShow(function e() {
              if (s()) {
                var t = a(r.modalElem());
                if (t) t.focus();
              }
            });
            r.afterClose(function e() {
              if (s() && n) n.focus();
              n = null;
            });
            c.watch(function e(t) {
              if (s() && r.isVisible()) {
                var n = a(r.modalElem());
                var i = l(r.modalElem());
                var o = t.shiftKey ? n : i;
                if (o === document.activeElement) {
                  (t.shiftKey ? i : n).focus();
                  t.preventDefault();
                }
              }
            });
          }
          function k(e, t) {
            var n;
            var i = new r(document.body);
            e.beforeShow(function () {
              n = i.elem.style.overflow;
              if (t()) i.stylize({
                overflow: "hidden"
              });
            });
            e.afterClose(function () {
              i.stylize({
                overflow: n
              });
            });
          }
          return document.documentElement.addEventListener("keydown", function e(t) {
            var n = t.which || t.keyCode;
            if (n === 27) S.trigger();else if (n === 9) c.trigger(t);
          }), function e(i) {
            if (y(i) || C(i)) i = {
              content: i
            };
            var o = v();
            var t = v();
            var n = v();
            var r = v();
            var s = v();
            function a(e, t) {
              var n = i[e];
              if (typeof n === "function") n = n(t);
              return n === undefined ? t : n;
            }
            var l = f.bind(window, "modal");
            var c = f.bind(window, "overlay");
            var h = f.bind(window, "close");
            var d;
            function u(e) {
              c().hide();
              l().hide();
              s.trigger(d, e);
            }
            function g(e) {
              if (r.trigger(d, e)) u(e);
            }
            function p(e) {
              return function () {
                e.apply(this || _global, arguments);
                return d;
              };
            }
            var m;
            function f(e, t) {
              if (!m) {
                var n = b(a, g);
                m = {
                  modal: n,
                  overlay: I(a, g),
                  close: A(n, a)
                };
                o.trigger(d, t);
              }
              return m[e];
            }
            d = {
              modalElem: w(l),
              closeElem: w(h),
              overlayElem: w(c),
              buildDom: p(f.bind(null, null)),
              isVisible: function () {
                return !!(m && l && l().isVisible());
              },
              show: function (e) {
                if (t.trigger(d, e)) {
                  c().show();
                  h();
                  l().show();
                  n.trigger(d, e);
                }
                return this || _global;
              },
              close: p(g),
              forceClose: p(u),
              destroy: function () {
                l().destroy();
                c().destroy();
                c = l = h = undefined;
              },
              options: function (t) {
                Object.keys(t).map(function (e) {
                  i[e] = t[e];
                });
              },
              afterCreate: p(o.watch),
              beforeShow: p(t.watch),
              afterShow: p(n.watch),
              beforeClose: p(r.watch),
              afterClose: p(s.watch)
            };
            x(d, a.bind(null, "focus", true));
            k(d, a.bind(null, "bodyOverflow", true));
            S.watch(function e() {
              if (a("escCloses", true) && d.isVisible()) d.close();
            });
            return d;
          };
        }) ? n.apply(t, i) : n) && (e.exports = i);
      }();
    },
    7533: function (e, t) {
      /** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
      !function (e) {
        "use strict";

        function he() {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          if (t.length > 1) {
            t[0] = t[0].slice(0, -1);
            var i = t.length - 1;
            for (var o = 1; o < i; ++o) t[o] = t[o].slice(1, -1);
            t[i] = t[i].slice(1);
            return t.join("");
          } else return t[0];
        }
        function de(e) {
          return "(?:" + e + ")";
        }
        function i(e) {
          return e === undefined ? "undefined" : e === null ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
        }
        function p(e) {
          return e.toUpperCase();
        }
        function b(e) {
          return e !== undefined && e !== null ? e instanceof Array ? e : typeof e.length !== "number" || e.split || e.setInterval || e.call ? [e] : Array.prototype.slice.call(e) : [];
        }
        function x(e, t) {
          var n = e;
          if (t) for (var i in t) n[i] = t[i];
          return n;
        }
        function t(e) {
          var t = "[A-Za-z]",
            W = "[\\x0D]",
            n = "[0-9]",
            H = "[\\x22]",
            i = he(n, "[A-Fa-f]"),
            G = "[\\x0A]",
            P = "[\\x20]",
            o = de(de("%[EFef]" + i + "%" + i + i + "%" + i + i) + "|" + de("%[89A-Fa-f]" + i + "%" + i + i) + "|" + de("%" + i + i)),
            r = "[\\:\\/\\?\\#\\[\\]\\@]",
            s = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
            a = he(r, s),
            l = e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]",
            c = e ? "[\\uE000-\\uF8FF]" : "[]",
            h = he(t, n, "[\\-\\.\\_\\~]", l),
            d = de(t + he(t, n, "[\\+\\-\\.]") + "*"),
            u = de(de(o + "|" + he(h, s, "[\\:]")) + "*"),
            F = de(de("25[0-5]") + "|" + de("2[0-4]" + n) + "|" + de("1" + n + n) + "|" + de("[1-9]" + n) + "|" + n),
            g = de(de("25[0-5]") + "|" + de("2[0-4]" + n) + "|" + de("1" + n + n) + "|" + de("0?[1-9]" + n) + "|0?0?" + n),
            p = de(g + "\\." + g + "\\." + g + "\\." + g),
            m = de(i + "{1,4}"),
            f = de(de(m + "\\:" + m) + "|" + p),
            C = de(de(m + "\\:") + "{6}" + f),
            y = de("\\:\\:" + de(m + "\\:") + "{5}" + f),
            v = de(de(m) + "?\\:\\:" + de(m + "\\:") + "{4}" + f),
            V = de(de(de(m + "\\:") + "{0,1}" + m) + "?\\:\\:" + de(m + "\\:") + "{3}" + f),
            Z = de(de(de(m + "\\:") + "{0,2}" + m) + "?\\:\\:" + de(m + "\\:") + "{2}" + f),
            O = de(de(de(m + "\\:") + "{0,3}" + m) + "?\\:\\:" + m + "\\:" + f),
            D = de(de(de(m + "\\:") + "{0,4}" + m) + "?\\:\\:" + f),
            K = de(de(de(m + "\\:") + "{0,5}" + m) + "?\\:\\:" + m),
            j = de(de(de(m + "\\:") + "{0,6}" + m) + "?\\:\\:"),
            I = de([C, y, v, V, Z, O, D, K, j].join("|")),
            b = de(de(h + "|" + o) + "+"),
            z = de(I + "\\%25" + b),
            X = de(I + de("\\%25|\\%(?!" + i + "{2})") + b),
            Y = de("[vV]" + i + "+\\." + he(h, s, "[\\:]") + "+"),
            J = de("\\[" + de(X + "|" + I + "|" + Y) + "\\]"),
            A = de(de(o + "|" + he(h, s)) + "*"),
            w = de(J + "|" + p + "(?!" + A + ")" + "|" + A),
            S = de(n + "*"),
            x = de(de(u + "@") + "?" + w + de("\\:" + S) + "?"),
            k = de(o + "|" + he(h, s, "[\\:\\@]")),
            U = de(k + "*"),
            E = de(k + "+"),
            Q = de(de(o + "|" + he(h, s, "[\\@]")) + "+"),
            T = de(de("\\/" + U) + "*"),
            R = de("\\/" + de(E + T) + "?"),
            _ = de(Q + T),
            $ = de(E + T),
            L = "(?!" + k + ")",
            q = de(T + "|" + R + "|" + _ + "|" + $ + "|" + L),
            N = de(de(k + "|" + he("[\\/\\?]", c)) + "*"),
            B = de(de(k + "|[\\/\\?]") + "*"),
            M = de(de("\\/\\/" + x + T) + "|" + R + "|" + $ + "|" + L),
            ee = de(d + "\\:" + M + de("\\?" + N) + "?" + de("\\#" + B) + "?"),
            te = de(de("\\/\\/" + x + T) + "|" + R + "|" + _ + "|" + L),
            ne = de(te + de("\\?" + N) + "?" + de("\\#" + B) + "?"),
            ie = de(ee + "|" + ne),
            oe = de(d + "\\:" + M + de("\\?" + N) + "?"),
            re = "^(" + d + ")\\:" + de(de("\\/\\/(" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?)") + "?(" + T + "|" + R + "|" + $ + "|" + L + ")") + de("\\?(" + N + ")") + "?" + de("\\#(" + B + ")") + "?$",
            se = "^(){0}" + de(de("\\/\\/(" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?)") + "?(" + T + "|" + R + "|" + _ + "|" + L + ")") + de("\\?(" + N + ")") + "?" + de("\\#(" + B + ")") + "?$",
            ae = "^(" + d + ")\\:" + de(de("\\/\\/(" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?)") + "?(" + T + "|" + R + "|" + $ + "|" + L + ")") + de("\\?(" + N + ")") + "?$",
            le = "^" + de("\\#(" + B + ")") + "?$",
            ce = "^" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?$";
          return {
            NOT_SCHEME: new RegExp(he("[^]", t, n, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(he("[^\\%\\:]", h, s), "g"),
            NOT_HOST: new RegExp(he("[^\\%\\[\\]\\:]", h, s), "g"),
            NOT_PATH: new RegExp(he("[^\\%\\/\\:\\@]", h, s), "g"),
            NOT_PATH_NOSCHEME: new RegExp(he("[^\\%\\/\\@]", h, s), "g"),
            NOT_QUERY: new RegExp(he("[^\\%]", h, s, "[\\:\\@\\/\\?]", c), "g"),
            NOT_FRAGMENT: new RegExp(he("[^\\%]", h, s, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(he("[^]", h, s), "g"),
            UNRESERVED: new RegExp(h, "g"),
            OTHER_CHARS: new RegExp(he("[^\\%]", h, a), "g"),
            PCT_ENCODED: new RegExp(o, "g"),
            IPV4ADDRESS: new RegExp("^(" + p + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + I + ")" + de(de("\\%25|\\%(?!" + i + "{2})") + "(" + b + ")") + "?\\]?$")
          };
        }
        var a = t(false),
          l = t(true),
          A = function () {
            function n(e, t) {
              var n = [];
              var i = true;
              var o = false;
              var r = undefined;
              try {
                for (var s = e[Symbol.iterator](), a; !(i = (a = s.next()).done); i = true) {
                  n.push(a.value);
                  if (t && n.length === t) break;
                }
              } catch (e) {
                o = true;
                r = e;
              } finally {
                try {
                  if (!i && s["return"]) s["return"]();
                } finally {
                  if (o) throw r;
                }
              }
              return n;
            }
            return function (e, t) {
              if (Array.isArray(e)) return e;else if (Symbol.iterator in Object(e)) return n(e, t);else throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(),
          k = function (e) {
            if (Array.isArray(e)) {
              for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
              return n;
            } else return Array.from(e);
          },
          B = 2147483647,
          M = 36,
          W = 1,
          H = 26,
          E = 38,
          T = 700,
          G = 72,
          P = 128,
          F = "-",
          R = /^xn--/,
          _ = /[^\0-\x7E]/,
          $ = /[\x2E\u3002\uFF0E\uFF61]/g,
          L = {
            overflow: "Overflow: input needs wider integers to process",
            "not-basic": "Illegal input >= 0x80 (not a basic code point)",
            "invalid-input": "Invalid input"
          },
          r = M - W,
          V = Math.floor,
          Z = String.fromCharCode;
        function O(e) {
          throw new RangeError(L[e]);
        }
        function N(e, t) {
          var n = [];
          var i = e.length;
          while (i--) n[i] = t(e[i]);
          return n;
        }
        function D(e, t) {
          var n = e.split("@");
          var i = "";
          if (n.length > 1) {
            i = n[0] + "@";
            e = n[1];
          }
          e = e.replace($, ".");
          var o = e.split(".");
          var r = N(o, t).join(".");
          return i + r;
        }
        function K(e) {
          var t = [];
          var n = 0;
          var i = e.length;
          while (n < i) {
            var o = e.charCodeAt(n++);
            if (o >= 55296 && o <= 56319 && n < i) {
              var r = e.charCodeAt(n++);
              if ((r & 64512) == 56320) t.push(((o & 1023) << 10) + (r & 1023) + 65536);else {
                t.push(o);
                n--;
              }
            } else t.push(o);
          }
          return t;
        }
        var j,
          z = function e(t) {
            if (t - 48 < 10) return t - 22;
            if (t - 65 < 26) return t - 65;
            if (t - 97 < 26) return t - 97;
            return M;
          },
          X = function e(t, n) {
            return t + 22 + 75 * (t < 26) - ((n != 0) << 5);
          },
          Y = function e(t, n, i) {
            var o = 0;
            t = i ? V(t / T) : t >> 1;
            t += V(t / n);
            for (; t > r * H >> 1; o += M) t = V(t / r);
            return V(o + (r + 1) * t / (t + E));
          },
          J = function e(t) {
            var n = [];
            var i = t.length;
            var o = 0;
            var r = P;
            var s = G;
            var a = t.lastIndexOf(F);
            if (a < 0) a = 0;
            for (var l = 0; l < a; ++l) {
              if (t.charCodeAt(l) >= 128) O("not-basic");
              n.push(t.charCodeAt(l));
            }
            for (var c = a > 0 ? a + 1 : 0; c < i;) {
              var h = o;
              for (var d = 1, u = M;; u += M) {
                if (c >= i) O("invalid-input");
                var g = z(t.charCodeAt(c++));
                if (g >= M || g > V((B - o) / d)) O("overflow");
                o += g * d;
                var p = u <= s ? W : u >= s + H ? H : u - s;
                if (g < p) break;
                var m = M - p;
                if (d > V(B / m)) O("overflow");
                d *= m;
              }
              var f = n.length + 1;
              s = Y(o - h, f, h == 0);
              if (V(o / f) > B - r) O("overflow");
              r += V(o / f);
              o %= f;
              n.splice(o++, 0, r);
            }
            return String.fromCodePoint.apply(String, n);
          },
          U = function e(t) {
            var n = [];
            t = K(t);
            var i = t.length;
            var o = P;
            var r = 0;
            var s = G;
            var a = true;
            var l = false;
            var c = undefined;
            try {
              for (var h = t[Symbol.iterator](), d; !(a = (d = h.next()).done); a = true) {
                var u = d.value;
                if (u < 128) n.push(Z(u));
              }
            } catch (e) {
              l = true;
              c = e;
            } finally {
              try {
                if (!a && h.return) h.return();
              } finally {
                if (l) throw c;
              }
            }
            var g = n.length;
            var p = g;
            if (g) n.push(F);
            while (p < i) {
              var m = B;
              var f = true;
              var C = false;
              var y = undefined;
              try {
                for (var v = t[Symbol.iterator](), I; !(f = (I = v.next()).done); f = true) {
                  var b = I.value;
                  if (b >= o && b < m) m = b;
                }
              } catch (e) {
                C = true;
                y = e;
              } finally {
                try {
                  if (!f && v.return) v.return();
                } finally {
                  if (C) throw y;
                }
              }
              var A = p + 1;
              if (m - o > V((B - r) / A)) O("overflow");
              r += (m - o) * A;
              o = m;
              var w = true;
              var S = false;
              var x = undefined;
              try {
                for (var k = t[Symbol.iterator](), E; !(w = (E = k.next()).done); w = true) {
                  var T = E.value;
                  if (T < o && ++r > B) O("overflow");
                  if (T == o) {
                    var R = r;
                    for (var _ = M;; _ += M) {
                      var $ = _ <= s ? W : _ >= s + H ? H : _ - s;
                      if (R < $) break;
                      var L = R - $;
                      var N = M - $;
                      n.push(Z(X($ + L % N, 0)));
                      R = V(L / N);
                    }
                    n.push(Z(X(R, 0)));
                    s = Y(r, A, p == g);
                    r = 0;
                    ++p;
                  }
                }
              } catch (e) {
                S = true;
                x = e;
              } finally {
                try {
                  if (!w && k.return) k.return();
                } finally {
                  if (S) throw x;
                }
              }
              ++r;
              ++o;
            }
            return n.join("");
          },
          Q,
          q,
          C = {
            version: "2.1.0",
            ucs2: {
              decode: K,
              encode: function e(t) {
                return String.fromCodePoint.apply(String, k(t));
              }
            },
            decode: J,
            encode: U,
            toASCII: function e(t) {
              return D(t, function (e) {
                return _.test(e) ? "xn--" + U(e) : e;
              });
            },
            toUnicode: function e(t) {
              return D(t, function (e) {
                return R.test(e) ? J(e.slice(4).toLowerCase()) : e;
              });
            }
          },
          h = {};
        function m(e) {
          var t = e.charCodeAt(0);
          var n = void 0;
          if (t < 16) n = "%0" + t.toString(16).toUpperCase();else if (t < 128) n = "%" + t.toString(16).toUpperCase();else if (t < 2048) n = "%" + (t >> 6 | 192).toString(16).toUpperCase() + "%" + (t & 63 | 128).toString(16).toUpperCase();else n = "%" + (t >> 12 | 224).toString(16).toUpperCase() + "%" + (t >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (t & 63 | 128).toString(16).toUpperCase();
          return n;
        }
        function c(e) {
          var t = "";
          var n = 0;
          var i = e.length;
          while (n < i) {
            var o = parseInt(e.substr(n + 1, 2), 16);
            if (o < 128) {
              t += String.fromCharCode(o);
              n += 3;
            } else if (o >= 194 && o < 224) {
              if (i - n >= 6) {
                var r = parseInt(e.substr(n + 4, 2), 16);
                t += String.fromCharCode((o & 31) << 6 | r & 63);
              } else t += e.substr(n, 6);
              n += 6;
            } else if (o >= 224) {
              if (i - n >= 9) {
                var s = parseInt(e.substr(n + 4, 2), 16);
                var a = parseInt(e.substr(n + 7, 2), 16);
                t += String.fromCharCode((o & 15) << 12 | (s & 63) << 6 | a & 63);
              } else t += e.substr(n, 9);
              n += 9;
            } else {
              t += e.substr(n, 3);
              n += 3;
            }
          }
          return t;
        }
        function d(e, n) {
          function t(e) {
            var t = c(e);
            return !t.match(n.UNRESERVED) ? e : t;
          }
          if (e.scheme) e.scheme = String(e.scheme).replace(n.PCT_ENCODED, t).toLowerCase().replace(n.NOT_SCHEME, "");
          if (e.userinfo !== undefined) e.userinfo = String(e.userinfo).replace(n.PCT_ENCODED, t).replace(n.NOT_USERINFO, m).replace(n.PCT_ENCODED, p);
          if (e.host !== undefined) e.host = String(e.host).replace(n.PCT_ENCODED, t).toLowerCase().replace(n.NOT_HOST, m).replace(n.PCT_ENCODED, p);
          if (e.path !== undefined) e.path = String(e.path).replace(n.PCT_ENCODED, t).replace(e.scheme ? n.NOT_PATH : n.NOT_PATH_NOSCHEME, m).replace(n.PCT_ENCODED, p);
          if (e.query !== undefined) e.query = String(e.query).replace(n.PCT_ENCODED, t).replace(n.NOT_QUERY, m).replace(n.PCT_ENCODED, p);
          if (e.fragment !== undefined) e.fragment = String(e.fragment).replace(n.PCT_ENCODED, t).replace(n.NOT_FRAGMENT, m).replace(n.PCT_ENCODED, p);
          return e;
        }
        function w(e) {
          return e.replace(/^0*(.*)/, "$1") || "0";
        }
        function S(e, t) {
          var n = e.match(t.IPV4ADDRESS) || [];
          var i = A(n, 2),
            o = i[1];
          if (o) return o.split(".").map(w).join(".");else return e;
        }
        function ee(e, t) {
          var n = e.match(t.IPV6ADDRESS) || [];
          var i = A(n, 3),
            o = i[1],
            r = i[2];
          if (o) {
            var s = o.toLowerCase().split("::").reverse(),
              a = A(s, 2),
              l = a[0],
              c = a[1];
            var h = c ? c.split(":").map(w) : [];
            var d = l.split(":").map(w);
            var u = t.IPV4ADDRESS.test(d[d.length - 1]);
            var g = u ? 7 : 8;
            var p = d.length - g;
            var m = Array(g);
            for (var f = 0; f < g; ++f) m[f] = h[f] || d[p + f] || "";
            if (u) m[g - 1] = S(m[g - 1], t);
            var C = m.reduce(function (e, t, n) {
              if (!t || t === "0") {
                var i = e[e.length - 1];
                if (i && i.index + i.length === n) i.length++;else e.push({
                  index: n,
                  length: 1
                });
              }
              return e;
            }, []);
            var y = C.sort(function (e, t) {
              return t.length - e.length;
            })[0];
            var v = void 0;
            if (y && y.length > 1) {
              var I = m.slice(0, y.index);
              var b = m.slice(y.index + y.length);
              v = I.join(":") + "::" + b.join(":");
            } else v = m.join(":");
            if (r) v += "%" + r;
            return v;
          } else return e;
        }
        var te = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i,
          ne = "".match(/(){0}/)[1] === undefined;
        function s(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = {};
          var i = t.iri !== false ? l : a;
          if (t.reference === "suffix") e = (t.scheme ? t.scheme + ":" : "") + "//" + e;
          var o = e.match(te);
          if (o) {
            if (ne) {
              n.scheme = o[1];
              n.userinfo = o[3];
              n.host = o[4];
              n.port = parseInt(o[5], 10);
              n.path = o[6] || "";
              n.query = o[7];
              n.fragment = o[8];
              if (isNaN(n.port)) n.port = o[5];
            } else {
              n.scheme = o[1] || undefined;
              n.userinfo = e.indexOf("@") !== -1 ? o[3] : undefined;
              n.host = e.indexOf("//") !== -1 ? o[4] : undefined;
              n.port = parseInt(o[5], 10);
              n.path = o[6] || "";
              n.query = e.indexOf("?") !== -1 ? o[7] : undefined;
              n.fragment = e.indexOf("#") !== -1 ? o[8] : undefined;
              if (isNaN(n.port)) n.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? o[4] : undefined;
            }
            if (n.host) n.host = ee(S(n.host, i), i);
            if (n.scheme === undefined && n.userinfo === undefined && n.host === undefined && n.port === undefined && !n.path && n.query === undefined) n.reference = "same-document";else if (n.scheme === undefined) n.reference = "relative";else if (n.fragment === undefined) n.reference = "absolute";else n.reference = "uri";
            if (t.reference && t.reference !== "suffix" && t.reference !== n.reference) n.error = n.error || "URI is not a " + t.reference + " reference.";
            var r = h[(t.scheme || n.scheme || "").toLowerCase()];
            if (!t.unicodeSupport && (!r || !r.unicodeSupport)) {
              if (n.host && (t.domainHost || r && r.domainHost)) try {
                n.host = C.toASCII(n.host.replace(i.PCT_ENCODED, c).toLowerCase());
              } catch (e) {
                n.error = n.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
              }
              d(n, a);
            } else d(n, i);
            if (r && r.parse) r.parse(n, t);
          } else n.error = n.error || "URI can not be parsed.";
          return n;
        }
        function ie(e, t) {
          var n = t.iri !== false ? l : a;
          var i = [];
          if (e.userinfo !== undefined) {
            i.push(e.userinfo);
            i.push("@");
          }
          if (e.host !== undefined) i.push(ee(S(String(e.host), n), n).replace(n.IPV6ADDRESS, function (e, t, n) {
            return "[" + t + (n ? "%25" + n : "") + "]";
          }));
          if (typeof e.port === "number" || typeof e.port === "string") {
            i.push(":");
            i.push(String(e.port));
          }
          return i.length ? i.join("") : undefined;
        }
        var oe = /^\.\.?\//,
          re = /^\/\.(\/|$)/,
          se = /^\/\.\.(\/|$)/,
          ae = /^\/?(?:.|\n)*?(?=\/|$)/;
        function u(e) {
          var t = [];
          while (e.length) if (e.match(oe)) e = e.replace(oe, "");else if (e.match(re)) e = e.replace(re, "/");else if (e.match(se)) {
            e = e.replace(se, "/");
            t.pop();
          } else if (e === "." || e === "..") e = "";else {
            var n = e.match(ae);
            if (n) {
              var i = n[0];
              e = e.slice(i.length);
              t.push(i);
            } else throw new Error("Unexpected dot segment condition");
          }
          return t.join("");
        }
        function g(t) {
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var e = n.iri ? l : a;
          var i = [];
          var o = h[(n.scheme || t.scheme || "").toLowerCase()];
          if (o && o.serialize) o.serialize(t, n);
          if (t.host) if (e.IPV6ADDRESS.test(t.host)) ;else if (n.domainHost || o && o.domainHost) try {
            t.host = !n.iri ? C.toASCII(t.host.replace(e.PCT_ENCODED, c).toLowerCase()) : C.toUnicode(t.host);
          } catch (e) {
            t.error = t.error || "Host's domain name can not be converted to " + (!n.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
          }
          d(t, e);
          if (n.reference !== "suffix" && t.scheme) {
            i.push(t.scheme);
            i.push(":");
          }
          var r = ie(t, n);
          if (r !== undefined) {
            if (n.reference !== "suffix") i.push("//");
            i.push(r);
            if (t.path && t.path.charAt(0) !== "/") i.push("/");
          }
          if (t.path !== undefined) {
            var s = t.path;
            if (!n.absolutePath && (!o || !o.absolutePath)) s = u(s);
            if (r === undefined) s = s.replace(/^\/\//, "/%2F");
            i.push(s);
          }
          if (t.query !== undefined) {
            i.push("?");
            i.push(t.query);
          }
          if (t.fragment !== undefined) {
            i.push("#");
            i.push(t.fragment);
          }
          return i.join("");
        }
        function le(e, t) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var i = arguments[3];
          var o = {};
          if (!i) {
            e = s(g(e, n), n);
            t = s(g(t, n), n);
          }
          n = n || {};
          if (!n.tolerant && t.scheme) {
            o.scheme = t.scheme;
            o.userinfo = t.userinfo;
            o.host = t.host;
            o.port = t.port;
            o.path = u(t.path || "");
            o.query = t.query;
          } else {
            if (t.userinfo !== undefined || t.host !== undefined || t.port !== undefined) {
              o.userinfo = t.userinfo;
              o.host = t.host;
              o.port = t.port;
              o.path = u(t.path || "");
              o.query = t.query;
            } else {
              if (!t.path) {
                o.path = e.path;
                if (t.query !== undefined) o.query = t.query;else o.query = e.query;
              } else {
                if (t.path.charAt(0) === "/") o.path = u(t.path);else {
                  if ((e.userinfo !== undefined || e.host !== undefined || e.port !== undefined) && !e.path) o.path = "/" + t.path;else if (!e.path) o.path = t.path;else o.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path;
                  o.path = u(o.path);
                }
                o.query = t.query;
              }
              o.userinfo = e.userinfo;
              o.host = e.host;
              o.port = e.port;
            }
            o.scheme = e.scheme;
          }
          o.fragment = t.fragment;
          return o;
        }
        function ce(e, t, n) {
          var i = x({
            scheme: "null"
          }, n);
          return g(le(s(e, i), s(t, i), i, true), i);
        }
        function ue(e, t) {
          if (typeof e === "string") e = g(s(e, t), t);else if (i(e) === "object") e = s(g(e, t), t);
          return e;
        }
        function ge(e, t, n) {
          if (typeof e === "string") e = g(s(e, n), n);else if (i(e) === "object") e = g(e, n);
          if (typeof t === "string") t = g(s(t, n), n);else if (i(t) === "object") t = g(t, n);
          return e === t;
        }
        function pe(e, t) {
          return e && e.toString().replace(!t || !t.iri ? a.ESCAPE : l.ESCAPE, m);
        }
        function y(e, t) {
          return e && e.toString().replace(!t || !t.iri ? a.PCT_ENCODED : l.PCT_ENCODED, c);
        }
        var n = {
            scheme: "http",
            domainHost: true,
            parse: function e(t, n) {
              if (!t.host) t.error = t.error || "HTTP URIs must have a host.";
              return t;
            },
            serialize: function e(t, n) {
              var i = String(t.scheme).toLowerCase() === "https";
              if (t.port === (i ? 443 : 80) || t.port === "") t.port = undefined;
              if (!t.path) t.path = "/";
              return t;
            }
          },
          me = {
            scheme: "https",
            domainHost: n.domainHost,
            parse: n.parse,
            serialize: n.serialize
          };
        function fe(e) {
          return typeof e.secure === "boolean" ? e.secure : String(e.scheme).toLowerCase() === "wss";
        }
        var o = {
            scheme: "ws",
            domainHost: true,
            parse: function e(t, n) {
              var i = t;
              i.secure = fe(i);
              i.resourceName = (i.path || "/") + (i.query ? "?" + i.query : "");
              i.path = undefined;
              i.query = undefined;
              return i;
            },
            serialize: function e(t, n) {
              if (t.port === (fe(t) ? 443 : 80) || t.port === "") t.port = undefined;
              if (typeof t.secure === "boolean") {
                t.scheme = t.secure ? "wss" : "ws";
                t.secure = undefined;
              }
              if (t.resourceName) {
                var i = t.resourceName.split("?"),
                  o = A(i, 2),
                  r = o[0],
                  s = o[1];
                t.path = r && r !== "/" ? r : undefined;
                t.query = s;
                t.resourceName = undefined;
              }
              t.fragment = undefined;
              return t;
            }
          },
          Ce = {
            scheme: "wss",
            domainHost: o.domainHost,
            parse: o.parse,
            serialize: o.serialize
          },
          ye = {},
          ve,
          Ie = "[A-Za-z0-9\\-\\.\\_\\~" + (true ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]",
          f = "[0-9A-Fa-f]",
          be = de(de("%[EFef]" + f + "%" + f + f + "%" + f + f) + "|" + de("%[89A-Fa-f]" + f + "%" + f + f) + "|" + de("%" + f + f)),
          Ae = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]",
          we,
          Se = he("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", "[\\\"\\\\]"),
          xe = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]",
          ke = new RegExp(Ie, "g"),
          v = new RegExp(be, "g"),
          Ee = new RegExp(he("[^]", Ae, "[\\.]", "[\\\"]", Se), "g"),
          Te = new RegExp(he("[^]", Ie, xe), "g"),
          Re = Te;
        function I(e) {
          var t = c(e);
          return !t.match(ke) ? e : t;
        }
        var _e = {
            scheme: "mailto",
            parse: function e(t, n) {
              var i = t;
              var o = i.to = i.path ? i.path.split(",") : [];
              i.path = undefined;
              if (i.query) {
                var r = false;
                var s = {};
                var a = i.query.split("&");
                for (var l = 0, c = a.length; l < c; ++l) {
                  var h = a[l].split("=");
                  switch (h[0]) {
                    case "to":
                      var d = h[1].split(",");
                      for (var u = 0, g = d.length; u < g; ++u) o.push(d[u]);
                      break;
                    case "subject":
                      i.subject = y(h[1], n);
                      break;
                    case "body":
                      i.body = y(h[1], n);
                      break;
                    default:
                      r = true;
                      s[y(h[0], n)] = y(h[1], n);
                      break;
                  }
                }
                if (r) i.headers = s;
              }
              i.query = undefined;
              for (var p = 0, m = o.length; p < m; ++p) {
                var f = o[p].split("@");
                f[0] = y(f[0]);
                if (!n.unicodeSupport) try {
                  f[1] = C.toASCII(y(f[1], n).toLowerCase());
                } catch (e) {
                  i.error = i.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                } else f[1] = y(f[1], n).toLowerCase();
                o[p] = f.join("@");
              }
              return i;
            },
            serialize: function e(t, n) {
              var i = t;
              var o = b(t.to);
              if (o) {
                for (var r = 0, s = o.length; r < s; ++r) {
                  var a = String(o[r]);
                  var l = a.lastIndexOf("@");
                  var c = a.slice(0, l).replace(v, I).replace(v, p).replace(Ee, m);
                  var h = a.slice(l + 1);
                  try {
                    h = !n.iri ? C.toASCII(y(h, n).toLowerCase()) : C.toUnicode(h);
                  } catch (e) {
                    i.error = i.error || "Email address's domain name can not be converted to " + (!n.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                  }
                  o[r] = c + "@" + h;
                }
                i.path = o.join(",");
              }
              var d = t.headers = t.headers || {};
              if (t.subject) d["subject"] = t.subject;
              if (t.body) d["body"] = t.body;
              var u = [];
              for (var g in d) if (d[g] !== ye[g]) u.push(g.replace(v, I).replace(v, p).replace(Te, m) + "=" + d[g].replace(v, I).replace(v, p).replace(Re, m));
              if (u.length) i.query = u.join("&");
              return i;
            }
          },
          $e = /^([^\:]+)\:(.*)/,
          Le = {
            scheme: "urn",
            parse: function e(t, n) {
              var i = t.path && t.path.match($e);
              var o = t;
              if (i) {
                var r = n.scheme || o.scheme || "urn";
                var s = i[1].toLowerCase();
                var a = i[2];
                var l = r + ":" + (n.nid || s);
                var c = h[l];
                o.nid = s;
                o.nss = a;
                o.path = undefined;
                if (c) o = c.parse(o, n);
              } else o.error = o.error || "URN can not be parsed.";
              return o;
            },
            serialize: function e(t, n) {
              var i = n.scheme || t.scheme || "urn";
              var o = t.nid;
              var r = i + ":" + (n.nid || o);
              var s = h[r];
              if (s) t = s.serialize(t, n);
              var a = t;
              var l = t.nss;
              a.path = (o || n.nid) + ":" + l;
              return a;
            }
          },
          Ne = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/,
          Be = {
            scheme: "urn:uuid",
            parse: function e(t, n) {
              var i = t;
              i.uuid = i.nss;
              i.nss = undefined;
              if (!n.tolerant && (!i.uuid || !i.uuid.match(Ne))) i.error = i.error || "UUID is not valid.";
              return i;
            },
            serialize: function e(t, n) {
              var i = t;
              i.nss = (t.uuid || "").toLowerCase();
              return i;
            }
          };
        h[n.scheme] = n, h[me.scheme] = me, h[o.scheme] = o, h[Ce.scheme] = Ce, h[_e.scheme] = _e, h[Le.scheme] = Le, h[Be.scheme] = Be, e.SCHEMES = h, e.pctEncChar = m, e.pctDecChars = c, e.parse = s, e.removeDotSegments = u, e.serialize = g, e.resolveComponents = le, e.resolve = ce, e.normalize = ue, e.equal = ge, e.escapeComponent = pe, e.unescapeComponent = y, Object.defineProperty(e, "__esModule", {
          value: true
        });
      }(t);
    },
    4049: function (e) {
      e.exports = function () {
        "use strict";

        var s = function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          },
          e = function () {
            function i(e, t) {
              for (var n = 0; n < t.length; n++) {
                i = t[n];
                i.enumerable = i.enumerable || false;
                i.configurable = true;
                if ("value" in i) i.writable = true;
                Object.defineProperty(e, i.key, i);
              }
            }
            return function (e, t, n) {
              if (t) i(e.prototype, t);
              if (n) i(e, n);
              return e;
            };
          }(),
          m = function () {
            function n(e, t) {
              var n = [];
              var i = true;
              var o = false;
              var r = undefined;
              try {
                for (var s = e[Symbol.iterator](), a; !(i = (a = s.next()).done); i = true) {
                  n.push(a.value);
                  if (t && n.length === t) break;
                }
              } catch (e) {
                o = true;
                r = e;
              } finally {
                try {
                  if (!i && s["return"]) s["return"]();
                } finally {
                  if (o) throw r;
                }
              }
              return n;
            }
            return function (e, t) {
              if (Array.isArray(e)) return e;else if (Symbol.iterator in Object(e)) return n(e, t);else throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(),
          o = (String.prototype.startsWith = String.prototype.startsWith || function (e) {
            return this.indexOf(e) === 0;
          }, String.prototype.padStart = String.prototype.padStart || function (e, t) {
            var n = this || _global;
            while (n.length < e) n = t + n;
            return n;
          }, {
            cb: "0f8ff",
            tqw: "aebd7",
            q: "-ffff",
            qmrn: "7fffd4",
            zr: "0ffff",
            bg: "5f5dc",
            bsq: "e4c4",
            bck: "---",
            nch: "ebcd",
            b: "--ff",
            bvt: "8a2be2",
            brwn: "a52a2a",
            brw: "deb887",
            ctb: "5f9ea0",
            hrt: "7fff-",
            chcT: "d2691e",
            cr: "7f50",
            rnw: "6495ed",
            crns: "8dc",
            crms: "dc143c",
            cn: "-ffff",
            Db: "--8b",
            Dcn: "-8b8b",
            Dgnr: "b8860b",
            Dgr: "a9a9a9",
            Dgrn: "-64-",
            Dkhk: "bdb76b",
            Dmgn: "8b-8b",
            Dvgr: "556b2f",
            Drng: "8c-",
            Drch: "9932cc",
            Dr: "8b--",
            Dsmn: "e9967a",
            Dsgr: "8fbc8f",
            DsTb: "483d8b",
            DsTg: "2f4f4f",
            Dtrq: "-ced1",
            Dvt: "94-d3",
            ppnk: "1493",
            pskb: "-bfff",
            mgr: "696969",
            grb: "1e90ff",
            rbrc: "b22222",
            rwht: "af0",
            stg: "228b22",
            chs: "-ff",
            gnsb: "dcdcdc",
            st: "8f8ff",
            g: "d7-",
            gnr: "daa520",
            gr: "808080",
            grn: "-8-0",
            grnw: "adff2f",
            hnw: "0fff0",
            htpn: "69b4",
            nnr: "cd5c5c",
            ng: "4b-82",
            vr: "0",
            khk: "0e68c",
            vnr: "e6e6fa",
            nrb: "0f5",
            wngr: "7cfc-",
            mnch: "acd",
            Lb: "add8e6",
            Lcr: "08080",
            Lcn: "e0ffff",
            Lgnr: "afad2",
            Lgr: "d3d3d3",
            Lgrn: "90ee90",
            Lpnk: "b6c1",
            Lsmn: "a07a",
            Lsgr: "20b2aa",
            Lskb: "87cefa",
            LsTg: "778899",
            Lstb: "b0c4de",
            Lw: "e0",
            m: "-ff-",
            mgrn: "32cd32",
            nn: "af0e6",
            mgnt: "-ff",
            mrn: "8--0",
            mqm: "66cdaa",
            mmb: "--cd",
            mmrc: "ba55d3",
            mmpr: "9370db",
            msg: "3cb371",
            mmsT: "7b68ee",
            "": "-fa9a",
            mtr: "48d1cc",
            mmvt: "c71585",
            mnLb: "191970",
            ntc: "5fffa",
            mstr: "e4e1",
            mccs: "e4b5",
            vjw: "dead",
            nv: "--80",
            c: "df5e6",
            v: "808-0",
            vrb: "6b8e23",
            rng: "a5-",
            rngr: "45-",
            rch: "da70d6",
            pgnr: "eee8aa",
            pgrn: "98fb98",
            ptrq: "afeeee",
            pvtr: "db7093",
            ppwh: "efd5",
            pchp: "dab9",
            pr: "cd853f",
            pnk: "c0cb",
            pm: "dda0dd",
            pwrb: "b0e0e6",
            prp: "8-080",
            cc: "663399",
            r: "--",
            sbr: "bc8f8f",
            rb: "4169e1",
            sbrw: "8b4513",
            smn: "a8072",
            nbr: "4a460",
            sgrn: "2e8b57",
            ssh: "5ee",
            snn: "a0522d",
            svr: "c0c0c0",
            skb: "87ceeb",
            sTb: "6a5acd",
            sTgr: "708090",
            snw: "afa",
            n: "-ff7f",
            stb: "4682b4",
            tn: "d2b48c",
            t: "-8080",
            thst: "d8bfd8",
            tmT: "6347",
            trqs: "40e0d0",
            vt: "ee82ee",
            whT: "5deb3",
            wht: "",
            hts: "5f5f5",
            w: "-",
            wgrn: "9acd32"
          });
        function a(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          var n = t > 0 ? e.toFixed(t).replace(/0+$/, "").replace(/\.$/, "") : e.toString();
          return n || "0";
        }
        var r = function () {
            function p(e, t, n, i) {
              s(this || _global, p);
              var g = this || _global;
              function o(e) {
                if (e.startsWith("hsl")) {
                  var t = e.match(/([\-\d\.e]+)/g).map(Number),
                    n = m(t, 4),
                    i = n[0],
                    o = n[1],
                    r = n[2],
                    s = n[3];
                  if (s === undefined) s = 1;
                  i /= 360;
                  o /= 100;
                  r /= 100;
                  g.hsla = [i, o, r, s];
                } else if (e.startsWith("rgb")) {
                  var a = e.match(/([\-\d\.e]+)/g).map(Number),
                    l = m(a, 4),
                    c = l[0],
                    h = l[1],
                    d = l[2],
                    u = l[3];
                  if (u === undefined) u = 1;
                  g.rgba = [c, h, d, u];
                } else if (e.startsWith("#")) g.rgba = p.hexToRgb(e);else g.rgba = p.nameToRgb(e) || p.hexToRgb(e);
              }
              if (e === undefined) ;else if (Array.isArray(e)) (this || _global).rgba = e;else if (n === undefined) {
                var r = e && "" + e;
                if (r) o(r.toLowerCase());
              } else (this || _global).rgba = [e, t, n, i === undefined ? 1 : i];
            }
            e(p, [{
              key: "printRGB",
              value: function e(t) {
                var n = t ? (this || _global).rgba : (this || _global).rgba.slice(0, 3),
                  i = n.map(function (e, t) {
                    return a(e, t === 3 ? 3 : 0);
                  });
                return t ? "rgba(" + i + ")" : "rgb(" + i + ")";
              }
            }, {
              key: "printHSL",
              value: function e(t) {
                var n = [360, 100, 100, 1],
                  i = ["", "%", "%", ""];
                var o = t ? (this || _global).hsla : (this || _global).hsla.slice(0, 3),
                  r = o.map(function (e, t) {
                    return a(e * n[t], t === 3 ? 3 : 1) + i[t];
                  });
                return t ? "hsla(" + r + ")" : "hsl(" + r + ")";
              }
            }, {
              key: "printHex",
              value: function e(t) {
                var n = (this || _global).hex;
                return t ? n : n.substring(0, 7);
              }
            }, {
              key: "rgba",
              get: function e() {
                if ((this || _global)._rgba) return (this || _global)._rgba;
                if (!(this || _global)._hsla) throw new Error("No color is set");
                return (this || _global)._rgba = p.hslToRgb((this || _global)._hsla);
              },
              set: function e(t) {
                if (t.length === 3) t[3] = 1;
                (this || _global)._rgba = t;
                (this || _global)._hsla = null;
              }
            }, {
              key: "rgbString",
              get: function e() {
                return this.printRGB();
              }
            }, {
              key: "rgbaString",
              get: function e() {
                return this.printRGB(true);
              }
            }, {
              key: "hsla",
              get: function e() {
                if ((this || _global)._hsla) return (this || _global)._hsla;
                if (!(this || _global)._rgba) throw new Error("No color is set");
                return (this || _global)._hsla = p.rgbToHsl((this || _global)._rgba);
              },
              set: function e(t) {
                if (t.length === 3) t[3] = 1;
                (this || _global)._hsla = t;
                (this || _global)._rgba = null;
              }
            }, {
              key: "hslString",
              get: function e() {
                return this.printHSL();
              }
            }, {
              key: "hslaString",
              get: function e() {
                return this.printHSL(true);
              }
            }, {
              key: "hex",
              get: function e() {
                var t = (this || _global).rgba,
                  n = t.map(function (e, t) {
                    return t < 3 ? e.toString(16) : Math.round(e * 255).toString(16);
                  });
                return "#" + n.map(function (e) {
                  return e.padStart(2, "0");
                }).join("");
              },
              set: function e(t) {
                (this || _global).rgba = p.hexToRgb(t);
              }
            }], [{
              key: "hexToRgb",
              value: function e(t) {
                var n = (t.startsWith("#") ? t.slice(1) : t).replace(/^(\w{3})$/, "$1F").replace(/^(\w)(\w)(\w)(\w)$/, "$1$1$2$2$3$3$4$4").replace(/^(\w{6})$/, "$1FF");
                if (!n.match(/^([0-9a-fA-F]{8})$/)) throw new Error("Unknown hex color; " + t);
                var i = n.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function (e) {
                  return parseInt(e, 16);
                });
                i[3] = i[3] / 255;
                return i;
              }
            }, {
              key: "nameToRgb",
              value: function e(t) {
                var n = t.toLowerCase().replace("at", "T").replace(/[aeiouyldf]/g, "").replace("ght", "L").replace("rk", "D").slice(-5, 4),
                  i = o[n];
                return i === undefined ? i : p.hexToRgb(i.replace(/\-/g, "00").padStart(6, "f"));
              }
            }, {
              key: "rgbToHsl",
              value: function e(t) {
                var n = m(t, 4),
                  i = n[0],
                  o = n[1],
                  r = n[2],
                  s = n[3];
                i /= 255;
                o /= 255;
                r /= 255;
                var a = Math.max(i, o, r),
                  l = Math.min(i, o, r);
                var c = void 0,
                  h = void 0,
                  d = (a + l) / 2;
                if (a === l) c = h = 0;else {
                  var u = a - l;
                  h = d > 0.5 ? u / (2 - a - l) : u / (a + l);
                  switch (a) {
                    case i:
                      c = (o - r) / u + (o < r ? 6 : 0);
                      break;
                    case o:
                      c = (r - i) / u + 2;
                      break;
                    case r:
                      c = (i - o) / u + 4;
                      break;
                  }
                  c /= 6;
                }
                return [c, h, d, s];
              }
            }, {
              key: "hslToRgb",
              value: function e(t) {
                var n = m(t, 4),
                  i = n[0],
                  o = n[1],
                  r = n[2],
                  s = n[3];
                var a = void 0,
                  l = void 0,
                  c = void 0;
                if (o === 0) a = l = c = r;else {
                  var h = function e(t, n, i) {
                    if (i < 0) i += 1;
                    if (i > 1) i -= 1;
                    if (i < 1 / 6) return t + (n - t) * 6 * i;
                    if (i < 1 / 2) return n;
                    if (i < 2 / 3) return t + (n - t) * (2 / 3 - i) * 6;
                    return t;
                  };
                  var d = r < 0.5 ? r * (1 + o) : r + o - r * o,
                    u = 2 * r - d;
                  a = h(u, d, i + 1 / 3);
                  l = h(u, d, i);
                  c = h(u, d, i - 1 / 3);
                }
                var g = [a * 255, l * 255, c * 255].map(Math.round);
                g[3] = s;
                return g;
              }
            }]);
            return p;
          }(),
          n = function () {
            function r() {
              s(this || _global, r);
              (this || _global)._events = [];
            }
            e(r, [{
              key: "add",
              value: function e(t, n, i) {
                t.addEventListener(n, i, false);
                (this || _global)._events.push({
                  target: t,
                  type: n,
                  handler: i
                });
              }
            }, {
              key: "remove",
              value: function e(n, i, o) {
                (this || _global)._events = (this || _global)._events.filter(function (e) {
                  var t = true;
                  if (n && n !== e.target) t = false;
                  if (i && i !== e.type) t = false;
                  if (o && o !== e.handler) t = false;
                  if (t) r._doRemove(e.target, e.type, e.handler);
                  return !t;
                });
              }
            }, {
              key: "destroy",
              value: function e() {
                (this || _global)._events.forEach(function (e) {
                  return r._doRemove(e.target, e.type, e.handler);
                });
                (this || _global)._events = [];
              }
            }], [{
              key: "_doRemove",
              value: function e(t, n, i) {
                t.removeEventListener(n, i, false);
              }
            }]);
            return r;
          }();
        function l(e) {
          var t = document.createElement("div");
          t.innerHTML = e;
          return t.firstElementChild;
        }
        function c(e, h, d) {
          var u = false;
          function g(e, t, n) {
            return Math.max(t, Math.min(e, n));
          }
          function i(e, t, n) {
            if (n) u = true;
            if (!u) return;
            e.preventDefault();
            var i = h.getBoundingClientRect(),
              o = i.width,
              r = i.height,
              s = t.clientX,
              a = t.clientY;
            var l = g(s - i.left, 0, o),
              c = g(a - i.top, 0, r);
            d(l / o, c / r);
          }
          function t(e, t) {
            var n = e.buttons === undefined ? e.which : e.buttons;
            if (n === 1) i(e, e, t);else u = false;
          }
          function n(e, t) {
            if (e.touches.length === 1) i(e, e.touches[0], t);else u = false;
          }
          e.add(h, "mousedown", function (e) {
            t(e, true);
          });
          e.add(h, "touchstart", function (e) {
            n(e, true);
          });
          e.add(window, "mousemove", t);
          e.add(h, "touchmove", n);
          e.add(window, "mouseup", function (e) {
            u = false;
          });
          e.add(h, "touchend", function (e) {
            u = false;
          });
          e.add(h, "touchcancel", function (e) {
            u = false;
          });
        }
        var b = "linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0 / 2em 2em,\n                   linear-gradient(45deg, lightgrey 25%,       white 25%,       white 75%, lightgrey 75%) 1em 1em / 2em 2em",
          A = 360,
          h = "keydown",
          d = "mousedown",
          u = "focusin";
        function w(e, t) {
          return (t || document).querySelector(e);
        }
        function g(e) {
          e.preventDefault();
          e.stopPropagation();
        }
        function p(e, t, n, i, o) {
          e.add(t, h, function (e) {
            if (n.indexOf(e.key) >= 0) {
              if (o) g(e);
              i(e);
            }
          });
        }
        var t = function () {
            function t(e) {
              s(this || _global, t);
              (this || _global).settings = {
                popup: "right",
                layout: "default",
                alpha: true,
                editor: true,
                editorFormat: "hex",
                cancelButton: false,
                defaultColor: "#0cf"
              };
              (this || _global)._events = new n();
              (this || _global).onChange = null;
              (this || _global).onDone = null;
              (this || _global).onOpen = null;
              (this || _global).onClose = null;
              this.setOptions(e);
            }
            e(t, [{
              key: "setOptions",
              value: function e(t) {
                var n = this || _global;
                if (!t) return;
                var i = (this || _global).settings;
                function o(e, t, n) {
                  for (var i in e) {
                    if (n && n.indexOf(i) >= 0) continue;
                    t[i] = e[i];
                  }
                }
                if (t instanceof HTMLElement) i.parent = t;else {
                  if (i.parent && t.parent && i.parent !== t.parent) {
                    (this || _global)._events.remove(i.parent);
                    (this || _global)._popupInited = false;
                  }
                  o(t, i);
                  if (t.onChange) (this || _global).onChange = t.onChange;
                  if (t.onDone) (this || _global).onDone = t.onDone;
                  if (t.onOpen) (this || _global).onOpen = t.onOpen;
                  if (t.onClose) (this || _global).onClose = t.onClose;
                  var r = t.color || t.colour;
                  if (r) this._setColor(r);
                }
                var s = i.parent;
                if (s && i.popup && !(this || _global)._popupInited) {
                  var a = function e(t) {
                    return n.openHandler(t);
                  };
                  (this || _global)._events.add(s, "click", a);
                  p((this || _global)._events, s, [" ", "Spacebar", "Enter"], a);
                  (this || _global)._popupInited = true;
                } else if (t.parent && !i.popup) this.show();
              }
            }, {
              key: "openHandler",
              value: function e(t) {
                if (this.show()) {
                  t && t.preventDefault();
                  (this || _global).settings.parent.style.pointerEvents = "none";
                  var n = t && t.type === h ? (this || _global)._domEdit : (this || _global).domElement;
                  setTimeout(function () {
                    return n.focus();
                  }, 100);
                  if ((this || _global).onOpen) this.onOpen((this || _global).colour);
                }
              }
            }, {
              key: "closeHandler",
              value: function e(t) {
                var n = t && t.type;
                var i = false;
                if (!t) i = true;else if (n === d || n === u) {
                  var o = ((this || _global).__containedEvent || 0) + 100;
                  if (t.timeStamp > o) i = true;
                } else {
                  g(t);
                  i = true;
                }
                if (i && this.hide()) {
                  (this || _global).settings.parent.style.pointerEvents = "";
                  if (n !== d) (this || _global).settings.parent.focus();
                  if ((this || _global).onClose) this.onClose((this || _global).colour);
                }
              }
            }, {
              key: "movePopup",
              value: function e(t, n) {
                this.closeHandler();
                this.setOptions(t);
                if (n) this.openHandler();
              }
            }, {
              key: "setColor",
              value: function e(t, n) {
                this._setColor(t, {
                  silent: n
                });
              }
            }, {
              key: "_setColor",
              value: function e(t, n) {
                if (typeof t === "string") t = t.trim();
                if (!t) return;
                n = n || {};
                var i = void 0;
                try {
                  i = new r(t);
                } catch (e) {
                  if (n.failSilently) return;
                  throw e;
                }
                if (!(this || _global).settings.alpha) {
                  var o = i.hsla;
                  o[3] = 1;
                  i.hsla = o;
                }
                (this || _global).colour = (this || _global).color = i;
                this._setHSLA(null, null, null, null, n);
              }
            }, {
              key: "setColour",
              value: function e(t, n) {
                this.setColor(t, n);
              }
            }, {
              key: "show",
              value: function e() {
                var t = (this || _global).settings.parent;
                if (!t) return false;
                if ((this || _global).domElement) {
                  var n = this._toggleDOM(true);
                  this._setPosition();
                  return n;
                }
                var i = (this || _global).settings.template || "<div class=\"picker_wrapper\" tabindex=\"-1\"><div class=\"picker_arrow\"></div><div class=\"picker_hue picker_slider\"><div class=\"picker_selector\"></div></div><div class=\"picker_sl\"><div class=\"picker_selector\"></div></div><div class=\"picker_alpha picker_slider\"><div class=\"picker_selector\"></div></div><div class=\"picker_editor\"><input aria-label=\"Type a color name or hex value\"/></div><div class=\"picker_sample\"></div><div class=\"picker_done\"><button>Ok</button></div><div class=\"picker_cancel\"><button>Cancel</button></div></div>";
                var o = l(i);
                (this || _global).domElement = o;
                (this || _global)._domH = w(".picker_hue", o);
                (this || _global)._domSL = w(".picker_sl", o);
                (this || _global)._domA = w(".picker_alpha", o);
                (this || _global)._domEdit = w(".picker_editor input", o);
                (this || _global)._domSample = w(".picker_sample", o);
                (this || _global)._domOkay = w(".picker_done button", o);
                (this || _global)._domCancel = w(".picker_cancel button", o);
                o.classList.add("layout_" + (this || _global).settings.layout);
                if (!(this || _global).settings.alpha) o.classList.add("no_alpha");
                if (!(this || _global).settings.editor) o.classList.add("no_editor");
                if (!(this || _global).settings.cancelButton) o.classList.add("no_cancel");
                this._ifPopup(function () {
                  return o.classList.add("popup");
                });
                this._setPosition();
                if ((this || _global).colour) this._updateUI();else this._setColor((this || _global).settings.defaultColor);
                this._bindEvents();
                return true;
              }
            }, {
              key: "hide",
              value: function e() {
                return this._toggleDOM(false);
              }
            }, {
              key: "destroy",
              value: function e() {
                (this || _global)._events.destroy();
                if ((this || _global).domElement) (this || _global).settings.parent.removeChild((this || _global).domElement);
              }
            }, {
              key: "_bindEvents",
              value: function e() {
                var n = this || _global;
                var i = this || _global,
                  o = (this || _global).domElement,
                  r = (this || _global)._events;
                function s(e, t, n) {
                  r.add(e, t, n);
                }
                s(o, "click", function (e) {
                  return e.preventDefault();
                });
                c(r, (this || _global)._domH, function (e, t) {
                  return i._setHSLA(e);
                });
                c(r, (this || _global)._domSL, function (e, t) {
                  return i._setHSLA(null, e, 1 - t);
                });
                if ((this || _global).settings.alpha) c(r, (this || _global)._domA, function (e, t) {
                  return i._setHSLA(null, null, null, 1 - t);
                });
                var t = (this || _global)._domEdit;
                {
                  s(t, "input", function (e) {
                    i._setColor((this || _global).value, {
                      fromEditor: true,
                      failSilently: true
                    });
                  });
                  s(t, "focus", function (e) {
                    var t = this || _global;
                    if (t.selectionStart === t.selectionEnd) t.select();
                  });
                }
                this._ifPopup(function () {
                  var e = function e(t) {
                    return n.closeHandler(t);
                  };
                  s(window, d, e);
                  s(window, u, e);
                  p(r, o, ["Esc", "Escape"], e);
                  var t = function e(t) {
                    n.__containedEvent = t.timeStamp;
                  };
                  s(o, d, t);
                  s(o, u, t);
                  s(n._domCancel, "click", e);
                });
                var a = function e(t) {
                  n._ifPopup(function () {
                    return n.closeHandler(t);
                  });
                  if (n.onDone) n.onDone(n.colour);
                };
                s((this || _global)._domOkay, "click", a);
                p(r, o, ["Enter"], a);
              }
            }, {
              key: "_setPosition",
              value: function e() {
                var n = (this || _global).settings.parent,
                  i = (this || _global).domElement;
                if (n !== i.parentNode) n.appendChild(i);
                this._ifPopup(function (e) {
                  if (getComputedStyle(n).position === "static") n.style.position = "relative";
                  var t = e === true ? "popup_right" : "popup_" + e;
                  ["popup_top", "popup_bottom", "popup_left", "popup_right"].forEach(function (e) {
                    if (e === t) i.classList.add(e);else i.classList.remove(e);
                  });
                  i.classList.add(t);
                });
              }
            }, {
              key: "_setHSLA",
              value: function e(t, n, i, o, r) {
                r = r || {};
                var s = (this || _global).colour,
                  a = s.hsla;
                [t, n, i, o].forEach(function (e, t) {
                  if (e || e === 0) a[t] = e;
                });
                s.hsla = a;
                this._updateUI(r);
                if ((this || _global).onChange && !r.silent) this.onChange(s);
              }
            }, {
              key: "_updateUI",
              value: function e(t) {
                if (!(this || _global).domElement) return;
                t = t || {};
                var n = (this || _global).colour,
                  i = n.hsla,
                  o = "hsl(" + i[0] * A + ", 100%, 50%)",
                  r = n.hslString,
                  s = n.hslaString;
                var a = (this || _global)._domH,
                  l = (this || _global)._domSL,
                  c = (this || _global)._domA,
                  h = w(".picker_selector", a),
                  d = w(".picker_selector", l),
                  u = w(".picker_selector", c);
                function g(e, t, n) {
                  t.style.left = n * 100 + "%";
                }
                function p(e, t, n) {
                  t.style.top = n * 100 + "%";
                }
                g(a, h, i[0]);
                (this || _global)._domSL.style.backgroundColor = (this || _global)._domH.style.color = o;
                g(l, d, i[1]);
                p(l, d, 1 - i[2]);
                l.style.color = r;
                p(c, u, 1 - i[3]);
                var m = r,
                  f = m.replace("hsl", "hsla").replace(")", ", 0)"),
                  C = "linear-gradient(" + [m, f] + ")";
                (this || _global)._domA.style.background = C + ", " + b;
                if (!t.fromEditor) {
                  var y = (this || _global).settings.editorFormat,
                    v = (this || _global).settings.alpha;
                  var I = void 0;
                  switch (y) {
                    case "rgb":
                      I = n.printRGB(v);
                      break;
                    case "hsl":
                      I = n.printHSL(v);
                      break;
                    default:
                      I = n.printHex(v);
                  }
                  (this || _global)._domEdit.value = I;
                }
                (this || _global)._domSample.style.color = s;
              }
            }, {
              key: "_ifPopup",
              value: function e(t, n) {
                if ((this || _global).settings.parent && (this || _global).settings.popup) t && t((this || _global).settings.popup);else n && n();
              }
            }, {
              key: "_toggleDOM",
              value: function e(t) {
                var n = (this || _global).domElement;
                if (!n) return false;
                var i = t ? "" : "none",
                  o = n.style.display !== i;
                if (o) n.style.display = i;
                return o;
              }
            }]);
            return t;
          }(),
          i = document.createElement("style");
        return i.textContent = ".picker_wrapper.no_alpha .picker_alpha{display:none}.picker_wrapper.no_editor .picker_editor{position:absolute;z-index:-1;opacity:0}.picker_wrapper.no_cancel .picker_cancel{display:none}.layout_default.picker_wrapper{display:flex;flex-flow:row wrap;justify-content:space-between;align-items:stretch;font-size:10px;width:25em;padding:.5em}.layout_default.picker_wrapper input,.layout_default.picker_wrapper button{font-size:1rem}.layout_default.picker_wrapper>*{margin:.5em}.layout_default.picker_wrapper::before{content:\"\";display:block;width:100%;height:0;order:1}.layout_default .picker_slider,.layout_default .picker_selector{padding:1em}.layout_default .picker_hue{width:100%}.layout_default .picker_sl{flex:1 1 auto}.layout_default .picker_sl::before{content:\"\";display:block;padding-bottom:100%}.layout_default .picker_editor{order:1;width:6.5rem}.layout_default .picker_editor input{width:100%;height:100%}.layout_default .picker_sample{order:1;flex:1 1 auto}.layout_default .picker_done,.layout_default .picker_cancel{order:1}.picker_wrapper{box-sizing:border-box;background:#f2f2f2;box-shadow:0 0 0 1px silver;cursor:default;font-family:sans-serif;color:#444;pointer-events:auto}.picker_wrapper:focus{outline:none}.picker_wrapper button,.picker_wrapper input{box-sizing:border-box;border:none;box-shadow:0 0 0 1px silver;outline:none}.picker_wrapper button:focus,.picker_wrapper button:active,.picker_wrapper input:focus,.picker_wrapper input:active{box-shadow:0 0 2px 1px #1e90ff}.picker_wrapper button{padding:.4em .6em;cursor:pointer;background-color:#f5f5f5;background-image:linear-gradient(0deg, gainsboro, transparent)}.picker_wrapper button:active{background-image:linear-gradient(0deg, transparent, gainsboro)}.picker_wrapper button:hover{background-color:#fff}.picker_selector{position:absolute;z-index:1;display:block;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);border:2px solid #fff;border-radius:100%;box-shadow:0 0 3px 1px #67b9ff;background:currentColor;cursor:pointer}.picker_slider .picker_selector{border-radius:2px}.picker_hue{position:relative;background-image:linear-gradient(90deg, red, yellow, lime, cyan, blue, magenta, red);box-shadow:0 0 0 1px silver}.picker_sl{position:relative;box-shadow:0 0 0 1px silver;background-image:linear-gradient(180deg, white, rgba(255, 255, 255, 0) 50%),linear-gradient(0deg, black, rgba(0, 0, 0, 0) 50%),linear-gradient(90deg, #808080, rgba(128, 128, 128, 0))}.picker_alpha,.picker_sample{position:relative;background:linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0/2em 2em,linear-gradient(45deg, lightgrey 25%, white 25%, white 75%, lightgrey 75%) 1em 1em/2em 2em;box-shadow:0 0 0 1px silver}.picker_alpha .picker_selector,.picker_sample .picker_selector{background:none}.picker_editor input{font-family:monospace;padding:.2em .4em}.picker_sample::before{content:\"\";position:absolute;display:block;width:100%;height:100%;background:currentColor}.picker_arrow{position:absolute;z-index:-1}.picker_wrapper.popup{position:absolute;z-index:2;margin:1.5em}.picker_wrapper.popup,.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{background:#f2f2f2;box-shadow:0 0 10px 1px rgba(0,0,0,.4)}.picker_wrapper.popup .picker_arrow{width:3em;height:3em;margin:0}.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{content:\"\";display:block;position:absolute;top:0;left:0;z-index:-99}.picker_wrapper.popup .picker_arrow::before{width:100%;height:100%;-webkit-transform:skew(45deg);transform:skew(45deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}.picker_wrapper.popup .picker_arrow::after{width:150%;height:150%;box-shadow:none}.popup.popup_top{bottom:100%;left:0}.popup.popup_top .picker_arrow{bottom:0;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.popup.popup_bottom{top:100%;left:0}.popup.popup_bottom .picker_arrow{top:0;left:0;-webkit-transform:rotate(90deg) scale(1, -1);transform:rotate(90deg) scale(1, -1)}.popup.popup_left{top:0;right:100%}.popup.popup_left .picker_arrow{top:0;right:0;-webkit-transform:scale(-1, 1);transform:scale(-1, 1)}.popup.popup_right{top:0;left:100%}.popup.popup_right .picker_arrow{top:0;left:0}", document.documentElement.firstElementChild.appendChild(i), t.StyleElement = i, t;
      }();
    },
    1262: function (h, e, t) {
      "use strict";

      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function s(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, function (e) {
            e = function (e, t) {
              if ("object" !== o(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 === n) return ("string" === t ? String : Number)(e);
              n = n.call(e, t || "default");
              if ("object" !== o(n)) return n;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(e, "string");
            return "symbol" === o(e) ? e : String(e);
          }(i.key), i);
        }
      }
      function a(n) {
        var i = r();
        return function () {
          var e,
            t = c(n),
            t = (e = i ? (e = c(this || _global).constructor, Reflect.construct(t, arguments, e)) : t.apply(this || _global, arguments), this || _global);
          if (e && ("object" === o(e) || "function" == typeof e)) return e;
          if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
          if (void 0 !== t) return t;
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        };
      }
      function n(e) {
        var n = "function" == typeof Map ? new Map() : void 0;
        return function (e) {
          if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
          if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
          if (void 0 !== n) {
            if (n.has(e)) return n.get(e);
            n.set(e, t);
          }
          function t() {
            return i(e, arguments, c(this || _global).constructor);
          }
          return t.prototype = Object.create(e.prototype, {
            constructor: {
              value: t,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), l(t, e);
        }(e);
      }
      function i(e, t, n) {
        return (i = r() ? Reflect.construct.bind() : function (e, t, n) {
          var i = [null];
          i.push.apply(i, t);
          t = new (Function.bind.apply(e, i))();
          return n && l(t, n.prototype), t;
        }).apply(null, arguments);
      }
      function r() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      function l(e, t) {
        return (l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function c(e) {
        return (c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      t.d(e, {
        K: function () {
          return fe;
        }
      });
      var C = function (e) {
          var t = r;
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && l(t, e);
          var n,
            i,
            o = a(r);
          function r(e, t) {
            if ((this || _global) instanceof r) return (e = o.call(this || _global, e + " at position " + t)).position = t, e;
            throw new TypeError("Cannot call a class as a function");
          }
          return t = r, n && s(t.prototype, n), i && s(t, i), Object.defineProperty(t, "prototype", {
            writable: !1
          }), t;
        }(n(Error)),
        y = 92,
        v = 47,
        O = 42,
        I = 123,
        b = 125,
        A = 91,
        w = 93,
        D = 40,
        K = 41,
        d = 32,
        S = 10,
        x = 9,
        k = 13,
        j = 8,
        z = 12,
        E = 34,
        T = 43,
        R = 45,
        u = 39,
        _ = 48,
        X = 49,
        $ = 57,
        L = 44,
        Y = 46,
        J = 58,
        U = 59,
        g = 65,
        p = 97,
        Q = 69,
        q = 101,
        m = 70,
        f = 102,
        ee = 160,
        te = 8192,
        ne = 8202,
        ie = 8239,
        oe = 8287,
        re = 12288,
        se = 8220,
        ae = 8221,
        le = 8216,
        ce = 8217,
        he = 96,
        de = 180;
      function N(e) {
        return _ <= e && e <= $ || g <= e && e <= m || p <= e && e <= f;
      }
      function B(e) {
        return _ <= e && e <= $;
      }
      var ue = /^[,:[\]{}()\n]$/;
      function M(e) {
        return ge.test(e) || e && H(e.charCodeAt(0));
      }
      var ge = /^[[{\w-]$/;
      function W(e) {
        return e === d || e === S || e === x || e === k;
      }
      function H(e) {
        return G(e) || F(e);
      }
      function G(e) {
        return e === E || e === se || e === ae;
      }
      function P(e) {
        return e === E;
      }
      function F(e) {
        return e === u || e === le || e === ce || e === he || e === de;
      }
      function V(e, t, n) {
        n = 2 < arguments.length && void 0 !== n && n, t = e.lastIndexOf(t);
        return -1 !== t ? e.substring(0, t) + (n ? "" : e.substring(t + 1)) : e;
      }
      function Z(e, t) {
        var n = e.length;
        if (!W(e.charCodeAt(n - 1))) return e + t;
        for (; W(e.charCodeAt(n - 1));) n--;
        return e.substring(0, n) + t + e.substring(n);
      }
      var pe = {
          "\b": "\\b",
          "\f": "\\f",
          "\n": "\\n",
          "\r": "\\r",
          "\t": "\\t"
        },
        me = {
          "\"": "\"",
          "\\": "\\",
          "/": "/",
          b: "\b",
          f: "\f",
          n: "\n",
          r: "\r",
          t: "\t"
        };
      function fe(a) {
        var l = 0,
          c = "";
        if (!i()) throw new C("Unexpected end of json string", a.length);
        var e = r(L);
        if (e && h(), M(a[l]) && /[,\n][ \t\r]*$/.test(c)) {
          e || (c = Z(c, ","));
          for (var t = !0, n = !0; n;) t ? t = !1 : r(L) || (c = Z(c, ",")), n = i();
          n || (c = V(c, ",")), c = "[\n".concat(c, "\n]");
        } else e && (c = V(c, ","));
        if (l >= a.length) return c;
        throw new C("Unexpected character " + JSON.stringify(a[l]), l);
        function i() {
          h();
          var e = function () {
            if (a.charCodeAt(l) !== I) return !1;
            c += "{", l++, h();
            var e = !0;
            for (; l < a.length && a.charCodeAt(l) !== b;) {
              if (e ? e = !!0 : (r(L) || (c = Z(c, ",")), h()), !(u() || g())) {
                a.charCodeAt(l) === b || a.charCodeAt(l) === I || a.charCodeAt(l) === w || a.charCodeAt(l) === A || void 0 === a[l] ? c = V(c, ",") : function () {
                  throw new C("Object key expected", l);
                }();
                break;
              }
              h();
              var t = r(J);
              t || (M(a[l]) ? c = Z(c, ":") : f()), i() || (t ? function () {
                throw new C("Object value expected", l);
              } : f)();
            }
            a.charCodeAt(l) === b ? (c += "}", l++) : c = Z(c, "}");
            return !0;
          }() || function () {
            if (a.charCodeAt(l) !== A) return !1;
            c += "[", l++, h();
            var e = !0;
            for (; l < a.length && a.charCodeAt(l) !== w;) if (e ? e = !1 : r(L) || (c = Z(c, ",")), !i()) {
              c = V(c, ",");
              break;
            }
            a.charCodeAt(l) === w ? (c += "]", l++) : c = Z(c, "]");
            return !0;
          }() || u() || function () {
            var e = l;
            if (a.charCodeAt(l) === R && (l++, m(e))) return !0;
            if (a.charCodeAt(l) === _) l++;else if (function (e) {
              return X <= e && e <= $;
            }(a.charCodeAt(l))) for (l++; B(a.charCodeAt(l));) l++;
            if (a.charCodeAt(l) === Y) {
              if (l++, m(e)) return !0;
              for (; B(a.charCodeAt(l));) l++;
            }
            if (a.charCodeAt(l) === q || a.charCodeAt(l) === Q) {
              if (l++, a.charCodeAt(l) !== R && a.charCodeAt(l) !== T || l++, m(e)) return !0;
              for (; B(a.charCodeAt(l));) l++;
            }
            if (e < l) return c += a.slice(e, l), !0;
            return !1;
          }() || s("true", "true") || s("false", "false") || s("null", "null") || s("True", "true") || s("False", "false") || s("None", "null") || g();
          return h(), e;
        }
        function h() {
          for (o(); function () {
            if (a.charCodeAt(l) === v && a.charCodeAt(l + 1) === O) {
              for (; l < a.length && !function (e, t) {
                return "*" === e[t] && "/" === e[t + 1];
              }(a, l);) l++;
              l += 2;
            } else {
              if (a.charCodeAt(l) !== v || a.charCodeAt(l + 1) !== v) return !1;
              for (; l < a.length && a.charCodeAt(l) !== S;) l++;
            }
            return !0;
          }() && o(););
        }
        function o() {
          for (var e, t, n = ""; (e = W(a.charCodeAt(l))) || (t = a.charCodeAt(l)) === ee || te <= t && t <= ne || t === ie || t === oe || t === re;) n += e ? a[l] : " ", l++;
          return 0 < n.length && (c += n, !0);
        }
        function r(e) {
          return a.charCodeAt(l) === e && (c += a[l], l++, !0);
        }
        function d() {
          return e = y, a.charCodeAt(l) === e && (l++, !0);
          var e;
        }
        function u() {
          var e,
            t = a.charCodeAt(l) === y;
          if (t && (l++, t = !0), H(a.charCodeAt(l))) {
            var n = F(a.charCodeAt(l)) ? F : P(a.charCodeAt(l)) ? P : G;
            for (c += "\"", l++; l < a.length && !n(a.charCodeAt(l));) {
              if (a.charCodeAt(l) === y) {
                var i = a[l + 1];
                if (void 0 !== me[i]) c += a.slice(l, l + 2), l += 2;else if ("u" === i) {
                  if (!(N(a.charCodeAt(l + 2)) && N(a.charCodeAt(l + 3)) && N(a.charCodeAt(l + 4)) && N(a.charCodeAt(l + 5)))) {
                    r = o = void 0;
                    for (var o = l, r = o + 2; /\w/.test(a[r]);) r++;
                    throw o = a.slice(o, r), new C("Invalid unicode character \"".concat(o, "\""), l);
                  }
                  c += a.slice(l, l + 6), l += 6;
                } else c += i, l += 2;
              } else {
                o = a[l], i = a.charCodeAt(l);
                if (i === E && a.charCodeAt(l - 1) !== y) c += "\\" + o;else if ((e = i) === S || e === k || e === x || e === j || e === z) c += pe[o];else {
                  if (!(32 <= (e = i) && e <= 1114111)) throw new C("Invalid character " + JSON.stringify(o), l);
                  c += o;
                }
                l++;
              }
              t && d();
            }
            H(a.charCodeAt(l)) ? (a.charCodeAt(l), c += "\"", l++) : c += "\"";
            for (h(); a.charCodeAt(l) === T;) {
              l++, h();
              var s = (c = V(c, "\"", !0)).length;
              u(), c = function (e, t, n) {
                return e.substring(0, t) + e.substring(t + n);
              }(c, s, 1);
            }
            return !0;
          }
          return !1;
        }
        function s(e, t) {
          return a.slice(l, l + e.length) === e && (c += t, l += e.length, !0);
        }
        function g() {
          for (var e, t = l; l < a.length && (e = a[l], !(ue.test(e) || e && H(e.charCodeAt(0))));) l++;
          if (t < l) {
            if (a.charCodeAt(l) === D) l++, i(), a.charCodeAt(l) === K && (l++, a.charCodeAt(l) === U) && l++;else {
              for (; W(a.charCodeAt(l - 1)) && 0 < l;) l--;
              t = a.slice(t, l);
              c += JSON.stringify(t);
            }
            return !0;
          }
        }
        function p(e) {
          if (!B(a.charCodeAt(l))) throw e = a.slice(e, l), new C("Invalid number '".concat(e, "', expecting a digit ").concat(a[l] ? "but got '".concat(a[l], "'") : "but reached end of input"), 2);
        }
        function m(e) {
          if (l >= a.length) return c += a.slice(e, l) + "0", 1;
          p(e);
        }
        function f() {
          throw new C("Colon expected", l);
        }
      }
    },
    894: function (e) {
      "use strict";

      e.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON Schema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");
    },
    7171: function (e) {
      "use strict";

      e.exports = JSON.parse("{\"id\":\"http://json-schema.org/draft-04/schema#\",\"$schema\":\"http://json-schema.org/draft-04/schema#\",\"description\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"positiveInteger\":{\"type\":\"integer\",\"minimum\":0},\"positiveIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/positiveInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"minItems\":1,\"uniqueItems\":true}},\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"$schema\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":{},\"multipleOf\":{\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"boolean\",\"default\":false},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"boolean\",\"default\":false},\"maxLength\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minLength\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#\"}],\"default\":{}},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":{}},\"maxItems\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minItems\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"maxProperties\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#\"}],\"default\":{}},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"enum\":{\"type\":\"array\",\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"dependencies\":{\"exclusiveMaximum\":[\"maximum\"],\"exclusiveMinimum\":[\"minimum\"]},\"default\":{}}");
    },
    6273: function (e) {
      "use strict";

      e.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-06/schema#\",\"$id\":\"http://json-schema.org/draft-06/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":{},\"examples\":{\"type\":\"array\",\"items\":{}},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":{}},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":{},\"enum\":{\"type\":\"array\",\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":{}}");
    },
    6680: function (e) {
      "use strict";

      e.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");
    }
  }, o = {}, i.amdD = function () {
    throw new Error("define cannot be used indirect");
  }, i.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return i.d(t, {
      a: t
    }), t;
  }, i.d = function (e, t) {
    for (var n in t) i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, i.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, i.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, i.nmd = function (e) {
    return e.paths = [], e.children || (e.children = []), e;
  }, i(3161);
  function i(e) {
    var t = o[e];
    return void 0 !== t || (t = o[e] = {
      id: e,
      loaded: !1,
      exports: {}
    }, n[e].call(t.exports, t, t.exports, i), t.loaded = !0), t.exports;
  }
  var n, o;
});
//# sourceMappingURL=jsoneditor.map
export default exports;
export const JSONEditor = exports.JSONEditor;